
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("iUdxh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "GlobalIssueNavigatorSPAEntryPoint", () => $5fa05719bb5ae605$export$abb5d7ade4119ba5);
$parcel$export(module.exports, "default", () => $5fa05719bb5ae605$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("2Geeh");

var $ajpes = parcelRequire("ajpes");

var $4f8Oj = parcelRequire("4f8Oj");

var $ebyGx = parcelRequire("ebyGx");

var $eTXmK = parcelRequire("eTXmK");

var $dGrdR = parcelRequire("dGrdR");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $9Nvh7 = parcelRequire("9Nvh7");

var $fasDq = parcelRequire("fasDq");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $g5X3G = parcelRequire("g5X3G");

var $l8ruj = parcelRequire("l8ruj");

var $5y0F0 = parcelRequire("5y0F0");
var $jDDFr = parcelRequire("jDDFr");

var $hayxm = parcelRequire("hayxm");
const $5fa05719bb5ae605$var$BROWSER_METRICS_INTERACTION_APP_KEY = 'jira.global-issue-navigator';
const $5fa05719bb5ae605$var$initInteractions = ()=>({
        pagination: {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$5fa05719bb5ae605$var$BROWSER_METRICS_INTERACTION_APP_KEY}.pagination.start-end.diff`
            }),
            properties: {}
        },
        refinement: {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$5fa05719bb5ae605$var$BROWSER_METRICS_INTERACTION_APP_KEY}.refinement.start-end.diff`
            }),
            properties: {}
        },
        filter: {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$5fa05719bb5ae605$var$BROWSER_METRICS_INTERACTION_APP_KEY}.filter.start-end.diff`
            }),
            properties: {}
        },
        'list-view': {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$5fa05719bb5ae605$var$BROWSER_METRICS_INTERACTION_APP_KEY}.list-view.start-end.diff`
            }),
            properties: {}
        },
        'split-view': {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$5fa05719bb5ae605$var$BROWSER_METRICS_INTERACTION_APP_KEY}.split-view.start-end.diff`
            }),
            properties: {}
        },
        'column-configuration': {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$5fa05719bb5ae605$var$BROWSER_METRICS_INTERACTION_APP_KEY}.column-configuration.start-end.diff`
            }),
            properties: {}
        }
    });
// eslint-disable-next-line jira/react/no-class-components
class $5fa05719bb5ae605$var$GlobalIssueNavigatorSPAWrapper extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), /**
   * Update the currently selected issue in the URL.
   *
   * @param issueKey Issue key to update in the URL
   * @param isSelectedByUserInteraction True if this issue was selected by a user interaction, e.g. clicking an issue
   * in the list. This will be false if an issue was automatically selected by the app, e.g. automatically selecting
   * the first issue once the issue list has loaded.
   * @param viewActivity True to indicate the issue app should scroll to the activity feed section after opening.
   */ this.onChangeIssue = (issueKey, isSelectedByUserInteraction, viewActivity)=>{
            // Replace the history entry when an issue is auto selected by the app so we're not pushing redundant entries to
            // the history stack
            this.push({
                issueKey: issueKey,
                ...(0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? {
                    viewActivity: viewActivity
                } : {}
            }, !isSelectedByUserInteraction);
        }, this.onChangePage = ()=>{
            this.startInteraction('pagination', {
                view: this.view
            });
            (0, $4R6GH.fg)('add_nin_press_interactions') && (0, $eTXmK.default)(`issue-navigator.pagination.${this.view}`);
        }, this.onSetView = (newView, issueKey)=>{
            this.startInteraction((0, $eJ0Zs.convertToView)(newView));
            (0, $4R6GH.fg)('add_nin_press_interactions') && (0, $eTXmK.default)(`issue-navigator.${(0, $eJ0Zs.convertToView)(newView)}`);
            this.view = newView;
            if (issueKey !== undefined) this.push({
                issueKey: issueKey
            }, true);
        }, this.onRefinement = ()=>{
            this.startInteraction('refinement');
            (0, $4R6GH.fg)('add_nin_press_interactions') && (0, $eTXmK.default)('issue-navigator.refinement');
        }, /**
   * Callback function called when internal changes are made to PIN's state which generates new JQL.
   *
   * @param jql string The new JQL string
   * @param clearFilter boolean When true we clear the filter from url params
   */ this.onChangeJql = (jql, clearFilter = false)=>{
            this.push({
                ...clearFilter ? {
                    filter: undefined
                } : {},
                jql: jql,
                // Clear issue key from URL whenever JQL changes
                issueKey: (0, $g5X3G.toIssueKey)('')
            });
        }, this.onPageDataLoad = (selectedView)=>{
            if (selectedView !== undefined) this.view = selectedView;
            if (!this.state.initialised) this.setState({
                initialised: true
            });
            this.endInteractions();
        }, this.onStartFilterChangeInteractionIfAny = (filter)=>{
            if (this.lastFilter !== filter) {
                this.lastFilter = filter;
                if (filter != null && (0, $9Nvh7.isFilterId)(filter)) {
                    this.startInteraction('filter', {
                        filterId: filter
                    });
                    (0, $4R6GH.fg)('add_nin_press_interactions') && (0, $eTXmK.default)('issue-navigator.filter');
                }
            }
        }, this.onChangeColumnConfiguration = ()=>{
            this.startInteraction('column-configuration');
            (0, $4R6GH.fg)('add_nin_press_interactions') && (0, $eTXmK.default)('issue-navigator.column-configuration');
        }, this.onChangeFilter = (filter)=>{
            this.push({
                ...filter ? {
                    filter: filter,
                    jql: undefined
                } : {
                    jql: undefined
                }
            }, true);
        }, this.startInteraction = (key, properties)=>{
            if (!this.activeInteractions.includes(key)) this.activeInteractions.push(key);
            const interaction = this.interactions[key];
            if (interaction) {
                interaction.properties = properties || {};
                interaction.metrics.start();
            }
        }, this.endInteractions = ()=>{
            this.activeInteractions.forEach((key)=>{
                this.interactions[key]?.metrics.stop({
                    customData: this.interactions[key]?.properties
                });
            });
            this.activeInteractions = [];
        }, this.getQueryStringParams = ()=>{
            const { location: location } = this.props;
            const { filter: filter, jql: jql } = (0, $ebyGx.parse)(location.search, {
                // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
                arrayFormat: 'comma'
            });
            return {
                filter: filter,
                jql: jql
            };
        };
        const { location: location } = props;
        this.locationSearchStr = location.search;
        this.activeInteractions = [];
        this.view = (0, $6UAdF.DEFAULT_VIEW_ID);
        this.interactions = $5fa05719bb5ae605$var$initInteractions();
        if ((0, $4R6GH.fg)('add_nin_press_interactions')) {
            // Ensure filter change event does not fire on initial loads & transitions because it
            // will cause the page load interaction to be aborted
            const { filter: filter } = this.getQueryStringParams();
            this.lastFilter = filter;
        }
        this.state = {
            initialised: false,
            issueKey: (0, $4R6GH.fg)('slv-4_migrate_nin_selected_issue_route') ? props.match?.query.selectedIssue ?? '' : props.match?.params.issueKey ?? ''
        };
    }
    componentDidUpdate(prevProps) {
        const prevIssueKey = (0, $4R6GH.fg)('slv-4_migrate_nin_selected_issue_route') ? prevProps.match?.query.selectedIssue ?? '' : prevProps.match?.params.issueKey ?? '';
        const issueKey = (0, $4R6GH.fg)('slv-4_migrate_nin_selected_issue_route') ? this.props.match?.query.selectedIssue ?? '' : this.props.match?.params.issueKey ?? '';
        // If issue key has changed from the router and does not match our internal key then update our state
        if (issueKey !== prevIssueKey && issueKey !== this.state.issueKey) this.setState({
            issueKey: issueKey
        });
    }
    push(newParams, shouldReplace = false) {
        const { push: push, location: location, replace: replace } = this.props;
        const historyAction = shouldReplace ? replace : push;
        const oldIssueKey = this.state.issueKey;
        const { issueKey: issueKey = oldIssueKey ?? '', ...params } = newParams;
        const issueKeyChanged = newParams.issueKey !== oldIssueKey;
        // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
        const query = (0, $ebyGx.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const queryParamsChanged = Object.keys(params).length !== 0 && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))((0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(params, (param)=>param), query);
        if (issueKeyChanged || queryParamsChanged) {
            if ((0, $4R6GH.fg)('slv-4_migrate_nin_selected_issue_route')) {
                const queryParams = {
                    ...query,
                    ...params,
                    selectedIssue: issueKey
                };
                if (issueKey === '') delete queryParams.selectedIssue;
                // @ts-expect-error - React-resource-router's external type interface claims push/replace only accept "string", however the underlying code works with the `Location` object we're using
                historyAction({
                    pathname: '/issues/',
                    // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
                    search: (0, $ebyGx.stringify)(queryParams, {
                        arrayFormat: 'comma'
                    })
                });
            } else // @ts-expect-error - React-resource-router's external type interface claims push/replace only accept "string", however the underlying code works with the `Location` object we're using
            historyAction({
                pathname: `/issues/${issueKey ?? ''}`,
                // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
                search: (0, $ebyGx.stringify)({
                    ...query,
                    ...params
                }, {
                    arrayFormat: 'comma'
                })
            });
        }
        if (issueKeyChanged) // We explicitly set this into state instead of being purely prop driven as browser history actions are not
        // re-rendered synchronously. Setting into state makes our render order more reliable.
        this.setState({
            issueKey: issueKey ?? ''
        });
        return true;
    }
    render() {
        const { filter: filter, jql: jql } = this.getQueryStringParams();
        this.onStartFilterChangeInteractionIfAny(filter);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hayxm.default), {
            issueKey: (0, $g5X3G.toIssueKey)(this.state.issueKey),
            jql: jql,
            onChangeIssue: this.onChangeIssue,
            onChangePage: this.onChangePage,
            onPageDataLoad: this.onPageDataLoad,
            onChangeColumnConfiguration: this.onChangeColumnConfiguration,
            onChangeJql: this.onChangeJql,
            onChangeFilter: this.onChangeFilter,
            initialised: this.state.initialised,
            onRefinement: this.onRefinement,
            onSetView: this.onSetView,
            view: (0, $eJ0Zs.convertToView)(this.view),
            filter: filter,
            preloadedEntryPoints: this.props.preloadedEntryPoints
        }), this.state.initialised && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "smartQueryDetectedFlag",
            packageName: "jiraSpaAppsGlobalIssueNavigator",
            teamName: "empanada",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fasDq.SmartQueryDetectedFlag), {
            jql: jql
        })));
    }
}
/**
 * @deprecated delete when jira_list_gin_entrypoint is cleaned up
 */ const $5fa05719bb5ae605$var$GlobalIssueNavigatorSPAWrapperRouterConsumer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "global-issue-navigator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ push: push, replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDDFr.RouterSubscriber), null, ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5fa05719bb5ae605$var$GlobalIssueNavigatorSPAWrapper, {
                push: push,
                location: location,
                match: match,
                replace: replace
            }))));
const $5fa05719bb5ae605$export$abb5d7ade4119ba5 = /*#__PURE__*/ (0, $5uXOq.memo)(({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "global-issue-navigator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ push: push, replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDDFr.RouterSubscriber), null, ({ location: location, match: match })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5fa05719bb5ae605$var$GlobalIssueNavigatorSPAWrapper, {
                push: push,
                location: location,
                match: match,
                replace: replace,
                preloadedEntryPoints: (0, $4R6GH.fg)('jira_list_gin_entrypoint') ? props.preloadedEntryPoints : undefined
            })))));
var $5fa05719bb5ae605$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($5fa05719bb5ae605$var$GlobalIssueNavigatorSPAWrapperRouterConsumer);

});
parcelRegister("fasDq", function(module, exports) {

$parcel$export(module.exports, "SmartQueryDetectedFlag", () => $adf6e9334467a02d$export$8b388d8aa2182f84);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $cgL5K = parcelRequire("cgL5K");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $g9eN3 = parcelRequire("g9eN3");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $doZTA = parcelRequire("doZTA");

var $4n4Cr = parcelRequire("4n4Cr");

var $k9xB3 = parcelRequire("k9xB3");


var $84gH2 = parcelRequire("84gH2");
const $adf6e9334467a02d$var$flagId = (0, $7HGHK.toFlagId)((0, $e5db7e3c291ae89c$export$aead6163e23d2a49));
const $adf6e9334467a02d$export$48ea269755562084 = (props)=>{
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onDismissed = ()=>{
        dismissFlag($adf6e9334467a02d$var$flagId);
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'smartQueryDetectedFlag dismissed');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g9eN3.default), {
        ...props,
        onDismissed: onDismissed,
        messageId: "issue-navigator-flags.ui.smart-query-detected-flag.info-flag",
        messageType: "transactional"
    });
};
function $adf6e9334467a02d$var$useDontShowAgainAction() {
    const { update: updateSmartQueryDontShowPreference } = (0, $4n4Cr.useBooleanPreferenceSet)('user.smart.query.flag.dont.show');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return {
        dontShowAgainAction: (0, $5uXOq.useMemo)(()=>({
                content: formatMessage((0, $84gH2.default).flagDontShowAgainAction),
                onClick: ()=>{
                    updateSmartQueryDontShowPreference();
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'smartQueryDetectedFlagDontShowAgain clicked');
                    dismissFlag($adf6e9334467a02d$var$flagId);
                }
            }), [
            formatMessage,
            updateSmartQueryDontShowPreference,
            createAnalyticsEvent,
            dismissFlag
        ])
    };
}
const $adf6e9334467a02d$export$a9400f40005bf958 = ()=>{
    const { showFlag: showFlag, hasFlag: hasFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dontShowAgainAction: dontShowAgainAction } = $adf6e9334467a02d$var$useDontShowAgainAction();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const flagActions = (0, $5uXOq.useMemo)(()=>[
            dontShowAgainAction
        ], [
        dontShowAgainAction
    ]);
    const displayFlag = (0, $5uXOq.useCallback)(()=>{
        if (!hasFlag?.($adf6e9334467a02d$var$flagId)) {
            showFlag({
                id: $adf6e9334467a02d$var$flagId,
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($adf6e9334467a02d$export$48ea269755562084, {
                        ...props,
                        id: $adf6e9334467a02d$var$flagId,
                        key: $adf6e9334467a02d$var$flagId,
                        title: formatMessage((0, $84gH2.default).flagTitle),
                        description: formatMessage((0, $84gH2.default).flagDescription, {
                            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                                    as: "strong"
                                }, chunks)
                        }),
                        actions: flagActions,
                        testId: "issue-navigator-flags.ui.smart-query-detected-flag.smart-query-detected-flag",
                        messageId: "issue-navigator-flags.ui.smart-query-detected-flag.flag",
                        messageType: "transactional"
                    })
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'smartQueryDetectedFlag shown');
        }
    }, [
        hasFlag,
        showFlag,
        formatMessage,
        flagActions,
        createAnalyticsEvent
    ]);
    return {
        displayFlag: displayFlag
    };
};
const $adf6e9334467a02d$export$8b388d8aa2182f84 = ({ jql: jql })=>{
    const { displayFlag: displayFlag } = $adf6e9334467a02d$export$a9400f40005bf958();
    const [route, { replace: replace }] = (0, $doZTA.useRouter)();
    const params = (0, $5uXOq.useMemo)(()=>(0, $ebyGx.parse)(route.location.search), [
        route.location.search
    ]);
    const wildcardAddedBool = params.wildcardAdded === 'true';
    const smartQueryDisabledBool = params.smartQueryDisabled === 'true';
    const { isSmartQuery: isSmartQuery, data: data } = (0, $k9xB3.useSmartQueryCheck)({
        jql: smartQueryDisabledBool ? jql : undefined,
        wildcardAdded: wildcardAddedBool
    });
    (0, $5uXOq.useEffect)(()=>{
        if (isSmartQuery) displayFlag();
    }, [
        isSmartQuery,
        displayFlag
    ]);
    // detection check should will remove smartQueryDisabled and wildcardAdded from the search params, making sure we don't show the flag again
    (0, $5uXOq.useEffect)(()=>{
        // if smart query is not disabled, still need to get rid of wildcardAdded param
        if (data || !smartQueryDisabledBool && wildcardAddedBool) {
            // remove smartQueryDisabled and wildcardAdded from the search params, including any & at the start
            // using fromQueryString here so that it encodes the JQL in the same format everything else does
            const newSearch = {
                ...params
            };
            if (newSearch.smartQueryDisabled) delete newSearch.smartQueryDisabled;
            if (newSearch.wildcardAdded) delete newSearch.wildcardAdded;
            // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
            const newSearchString = `?${(0, $ebyGx.stringify)(newSearch, {
                arrayFormat: 'comma'
            })}`;
            // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
            const oldSearchString = `?${(0, $ebyGx.stringify)(params, {
                arrayFormat: 'comma'
            })}`;
            if (newSearchString !== oldSearchString) replace({
                ...route.location,
                search: newSearchString
            });
        }
    }, [
        data,
        route,
        replace,
        smartQueryDisabledBool,
        wildcardAddedBool,
        params
    ]);
    return null;
};
var $adf6e9334467a02d$export$2e2bcd8739ae039 = $adf6e9334467a02d$export$8b388d8aa2182f84;

});
parcelRegister("4n4Cr", function(module, exports) {

$parcel$export(module.exports, "useBooleanPreferenceSet", () => $aca83aa66389e1ff$export$2e9a7ecf87efb1e6);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
const $aca83aa66389e1ff$export$2e9a7ecf87efb1e6 = (key)=>{
    const setPreferenceToTrue = (0, $5uXOq.useCallback)(()=>(0, $eusud.performPutRequest)(`/rest/api/3/mypreferences?key=${key}`, {
            body: 'true'
        }), [
        key
    ]);
    // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
    const { loading: loading, error: error, fetch: update } = (0, $ld2hZ.useService)(setPreferenceToTrue);
    (0, $5uXOq.useEffect)(()=>{
        if (error) (0, $jcw0u.default)({
            meta: {
                id: 'useBooleanPreferenceSet',
                packageName: 'jiraIssueNavigatorFlags',
                teamName: 'empanada'
            },
            error: error,
            attributes: {
                key: key
            }
        });
    }, [
        error,
        key
    ]);
    return {
        loading: loading,
        error: error,
        update: update
    };
};
var $aca83aa66389e1ff$export$2e2bcd8739ae039 = $aca83aa66389e1ff$export$2e9a7ecf87efb1e6;

});

parcelRegister("k9xB3", function(module, exports) {

$parcel$export(module.exports, "useSmartQueryCheck", () => $1db75f3e8ec45b3c$export$26a66faebe7f7b65);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $ld2hZ = parcelRequire("ld2hZ");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $9OXo1 = parcelRequire("9OXo1");
const $1db75f3e8ec45b3c$var$JQL_REGEX = /(?:textfields ~ )(.*?)(?= AND .*| OR .*| ORDER BY .*|$)/i;
const $1db75f3e8ec45b3c$export$26a66faebe7f7b65 = ({ jql: jql, wildcardAdded: wildcardAdded })=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $9OXo1.useTenantContext)();
    const request = (0, $5uXOq.useCallback)(async ()=>{
        if (!atlassianAccountId || !jql) return undefined;
        let searchString = ($1db75f3e8ec45b3c$var$JQL_REGEX.exec(jql)?.[1] || '').replaceAll('"', '');
        if (wildcardAdded) // remove the wildcard from the search string
        searchString = searchString.slice(0, -1);
        const queryStr = (0, $ebyGx.stringify)({
            searchString: searchString,
            ignorePreference: true
        });
        return (0, $7f4tk.default)(`/rest/navigation/4/quicksearch?${queryStr}`);
    }, [
        atlassianAccountId,
        jql,
        wildcardAdded
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(request);
    (0, $5uXOq.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    const isSmartQuery = (0, $5uXOq.useMemo)(()=>{
        const quicksearchUrl = data?.url;
        if (quicksearchUrl) {
            // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
            const query = (0, $ebyGx.parse)(quicksearchUrl, {
                arrayFormat: 'comma'
            });
            if (query.quickSearchQuery !== undefined) return true;
        }
        return false;
    }, [
        data
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) (0, $jcw0u.default)({
            meta: {
                id: 'quicksearchSmartQueryDisabledFetch',
                packageName: 'jiraIssueNavigatorFlags',
                teamName: 'empanada'
            },
            error: error
        });
    }, [
        error
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        fetch: fetch,
        isSmartQuery: isSmartQuery
    };
};
var $1db75f3e8ec45b3c$export$2e2bcd8739ae039 = $1db75f3e8ec45b3c$export$26a66faebe7f7b65;

});

const $e5db7e3c291ae89c$export$aead6163e23d2a49 = 'SMART_QUERY_DETECTED_FLAG_ID';

parcelRegister("84gH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8833b1899639508$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e8833b1899639508$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-flags.smart-query-detected-flag.flag-title",
        "defaultMessage": "Trying to search using a smart query?"
    },
    flagDescription: {
        "id": "issue-navigator-flags.smart-query-detected-flag.flag-description",
        "defaultMessage": "Smart queries are turned off by default. You can enable them in your <strong>personal settings</strong>."
    },
    flagDontShowAgainAction: {
        "id": "issue-navigator-flags.smart-query-detected-flag.flag-dont-show-again-action",
        "defaultMessage": "Don\u2019t show me this again"
    }
});

});


parcelRegister("eJ0Zs", function(module, exports) {

$parcel$export(module.exports, "createRememoizeSelector", () => $945e9d040796364e$export$982d75deeca693ef);
$parcel$export(module.exports, "isNormalClick", () => $945e9d040796364e$export$729f3684d5c2b9b9);
$parcel$export(module.exports, "isNonNullish", () => $945e9d040796364e$export$70573498ee17fe1d);
$parcel$export(module.exports, "parseIssueNavigatorViewIdOrDefault", () => $945e9d040796364e$export$ad0c80ba9128e83a);
$parcel$export(module.exports, "isFilterViewId", () => $945e9d040796364e$export$194f1a1e890054c9);
$parcel$export(module.exports, "convertToIssueNavigatorId", () => $945e9d040796364e$export$6ce707b3eccb341d);
$parcel$export(module.exports, "convertToView", () => $945e9d040796364e$export$95ef66082092aa68);
$parcel$export(module.exports, "convertFilterIdToIssueNavigatorId", () => $945e9d040796364e$export$ec4f6e9ea23bb55d);
$parcel$export(module.exports, "exclusiveGroupResultsOrIssueResultsFragment", () => $945e9d040796364e$export$1dde85fc919cd8db);

var $dGvGJ = parcelRequire("dGvGJ");

var $6UAdF = parcelRequire("6UAdF");
const $945e9d040796364e$export$982d75deeca693ef = (0, $dGvGJ.createSelectorCreator)((0, $dGvGJ.defaultMemoize), // @ts-expect-error - TS2339 - Property '_rememoize' does not exist on type 'T'. | TS2339 - Property '_rememoize' does not exist on type 'T'.
(a, b)=>a._rememoize === b._rememoize);
const $945e9d040796364e$export$729f3684d5c2b9b9 = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
function $945e9d040796364e$var$isPossibleValueEntry(entry) {
    return typeof entry[1] === 'string' || typeof entry[1] === 'number' || Array.isArray(entry[1]) && entry[1].length > 0;
}
const $945e9d040796364e$export$20fba0bc14771b28 = (state)=>{
    const definedEntries = Object.entries(state).filter($945e9d040796364e$var$isPossibleValueEntry);
    return definedEntries.map((entry)=>({
            key: entry[0],
            value: Array.isArray(entry[1]) ? entry[1].map((values)=>values.value) : entry[1]
        }));
};
const $945e9d040796364e$export$6256478a5735e738 = (state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(state).reduce((acc, key)=>{
        const value = state[key];
        if (key === 'search') {
            if (typeof value !== 'string') throw new Error('Unexpected non-string literal for search.');
            acc[key] = value;
        } else if (Array.isArray(value)) acc[key] = value.map((values)=>values.value);
        else if (typeof value === 'string' || typeof value === 'undefined') acc[key] = value || [];
        else acc[key] = value;
        return acc;
    }, {});
const $945e9d040796364e$export$28dade55d1b3964b = (viewId)=>viewId === 'detail' ? (0, $6UAdF.views).detail : (0, $6UAdF.views).list;
const $945e9d040796364e$export$587f73d78d2a7579 = (viewMode)=>viewMode === (0, $6UAdF.views).detail ? 'detail' : 'list_default';
const $945e9d040796364e$export$5786a571e562003d = (viewMode)=>viewMode === (0, $6UAdF.views).detail ? 'DETAIL' : 'LIST';
function $945e9d040796364e$export$70573498ee17fe1d(value) {
    return value != null;
}
const $945e9d040796364e$export$ad0c80ba9128e83a = (viewId, defaultValue = 'list_default')=>{
    if (!viewId) return defaultValue;
    switch(viewId){
        case 'list_default':
            return 'list_default';
        case 'list_system':
            return 'list_system';
        case 'detail':
            return 'detail';
        default:
            if ($945e9d040796364e$export$194f1a1e890054c9(viewId)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return viewId;
            return defaultValue;
    }
};
const $945e9d040796364e$export$194f1a1e890054c9 = (viewId)=>/^list_filter_\d+$/.test(viewId);
const $945e9d040796364e$export$6ce707b3eccb341d = (view)=>view === (0, $6UAdF.views).detail ? 'detail' : 'list_default';
const $945e9d040796364e$export$95ef66082092aa68 = (issueNavigatorViewId)=>issueNavigatorViewId === 'detail' ? (0, $6UAdF.views).detail : (0, $6UAdF.views).list;
const $945e9d040796364e$export$ec4f6e9ea23bb55d = (filterId)=>{
    if (typeof filterId === 'number') return `list_filter_${filterId}`;
    const filterIdInt = Number(filterId);
    if (Number.isNaN(filterIdInt)) throw new Error('filterId is invalid');
    return `list_filter_${filterIdInt}`;
};
function $945e9d040796364e$export$1dde85fc919cd8db({ groupResults: groupResults, issueResults: issueResults }) {
    if (issueResults) return {
        groupResults: null,
        issueResults: issueResults
    };
    if (groupResults) return {
        groupResults: groupResults,
        issueResults: null
    };
    return null;
}

});

parcelRegister("hayxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd5a1b49151ba2ac$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gcl1l = parcelRequire("gcl1l");

var $7iJwP = parcelRequire("7iJwP");

var $cxmtN = parcelRequire("cxmtN");

var $9Nvh7 = parcelRequire("9Nvh7");

var $5Czte = parcelRequire("5Czte");

var $a8lIB = parcelRequire("a8lIB");

var $ay8sY = parcelRequire("ay8sY");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");

var $8PRuf = parcelRequire("8PRuf");

var $5rqex = parcelRequire("5rqex");

var $ao2h1 = parcelRequire("ao2h1");

var $aBKbA = parcelRequire("aBKbA");

var $89kiv = parcelRequire("89kiv");

var $4R6GH = parcelRequire("4R6GH");

var $1gXMV = parcelRequire("1gXMV");

var $9dbF6 = parcelRequire("9dbF6");

var $dZw8H = parcelRequire("dZw8H");
const $fd5a1b49151ba2ac$var$AsyncGlobalIssueNavigatorWrapper = ({ filter: filter, jql: jqlParam, initialised: initialised, view: view, ...props })=>{
    const onMutateJqlParam = (0, $ay8sY.useUpdateUrlQueryParamCallback)('jql');
    const defaultJql = (0, $aBKbA.getDefaultJqlGin)();
    const jql = (0, $ay8sY.getJqlFromParamValues)(defaultJql, jqlParam, filter, undefined, onMutateJqlParam);
    const searchInput = (0, $5uXOq.useMemo)(()=>(0, $ay8sY.getSearchInput)(jql, filter), [
        jql,
        filter
    ]);
    const filterForAnalytics = filter && (0, $9Nvh7.isFilterId)(filter) ? filter : 'default';
    const attributes = {
        navigatorScope: 'global',
        viewLayout: view || '',
        // jql='' is a valid jql parameter, so we track empty jql
        jql: jqlParam !== undefined,
        filter: filterForAnalytics
    };
    const extraInfo = {
        scope: 'global',
        filterId: filterForAnalytics,
        isJqlParamPresent: !!jqlParam,
        ...attributes
    };
    const response = (0, $ao2h1.useRelayResource)((0, $89kiv.issueNavigatorRelayResource));
    const { queryReference: queryReference } = response;
    const filterResponse = (0, $ao2h1.useRelayResource)((0, $89kiv.issueNavigatorFilterRelayResource));
    const filterQueryReference = filterResponse.queryReference;
    const hydrationResponse = (0, $ao2h1.useRelayResource)((0, $89kiv.issueNavigatorHydrationRelayResource));
    const hydrationQueryReference = hydrationResponse.queryReference;
    const issueTableProps = (0, $5uXOq.useMemo)(()=>(0, $4R6GH.fg)('jira_list_gin_entrypoint') ? {
            preloadedEntryPoints: props.preloadedEntryPoints
        } : undefined, [
        props.preloadedEntryPoints
    ]);
    // During SSR our issueNavigatorRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (queryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1gXMV.GlobalIssueNavigatorSkeleton), null);
    // During SSR our issueNavigatorFilterRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (filterQueryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1gXMV.GlobalIssueNavigatorSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes,
        ...filter !== null && filter !== undefined && (0, $9Nvh7.isFilterId)(filter) && {
            containers: {
                issueFilter: {
                    id: filter
                }
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "unhandled",
        packageName: "jiraSpaAppsGlobalIssueNavigator",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "global-issue-navigator-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1gXMV.GlobalIssueNavigatorSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Czte.EnableNinChangeboardingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cxmtN.default), {
        ...props,
        searchInput: searchInput,
        defaultJql: defaultJql,
        queryReference: queryReference || undefined,
        filterQueryReference: filterQueryReference || undefined,
        jqlBuilderProps: {
            maybeHydrationQueryReference: hydrationQueryReference || undefined
        },
        issueTableProps: issueTableProps
    })))), initialised && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: "global-issue-navigator",
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $8PRuf.appBundleReadyMark),
            (0, $8PRuf.prefetchApiReadyMark)
        ],
        ttrSlo: 3000,
        ttiSlo: 4000,
        extra: extraInfo,
        metric: (0, $a8lIB.NINPageLoad),
        emitOnAnimationFrame: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "platform"
    }));
};
var $fd5a1b49151ba2ac$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($fd5a1b49151ba2ac$var$AsyncGlobalIssueNavigatorWrapper);

});
parcelRegister("cxmtN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d906565302a52a0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4m2yJ = parcelRequire("4m2yJ");

var $lNtuJ = parcelRequire("lNtuJ");

var $kfUal = parcelRequire("kfUal");
const $4d906565302a52a0$var$GlobalIssueNavigator = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4m2yJ.default), {
        CustomHeader: (0, $kfUal.default),
        HeaderSkeletonImage: (0, $lNtuJ.GlobalIssueNavigatorHeaderSkeleton),
        ...props
    });
var $4d906565302a52a0$export$2e2bcd8739ae039 = $4d906565302a52a0$var$GlobalIssueNavigator;

});
parcelRegister("4m2yJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $36b09ac9b73a27e7$export$2e2bcd8739ae039);

var $7u5Tm = parcelRequire("7u5Tm");

var $1nibn = parcelRequire("1nibn");

var $7uwEc = parcelRequire("7uwEc");

var $31TiE = parcelRequire("31TiE");

var $4hr2P = parcelRequire("4hr2P");

var $9hXMi = parcelRequire("9hXMi");

var $ai5n6 = parcelRequire("ai5n6");

var $4LFGS = parcelRequire("4LFGS");

var $ln32M = parcelRequire("ln32M");

var $l5FbD = parcelRequire("l5FbD");

var $hTvlq = parcelRequire("hTvlq");

var $kvekU = parcelRequire("kvekU");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $2CtcG = parcelRequire("2CtcG");

var $1TiUe = parcelRequire("1TiUe");

var $f98ZZ = parcelRequire("f98ZZ");

var $cSD7y = parcelRequire("cSD7y");

var $6UAdF = parcelRequire("6UAdF");

var $a8lIB = parcelRequire("a8lIB");

var $1z7Yr = parcelRequire("1z7Yr");

var $gtUFk = parcelRequire("gtUFk");

var $gwtSG = parcelRequire("gwtSG");

var $cKK2E = parcelRequire("cKK2E");

var $isIOR = parcelRequire("isIOR");

var $a5eZM = parcelRequire("a5eZM");

var $en3WN = parcelRequire("en3WN");

var $9BgIv = parcelRequire("9BgIv");

var $k4pU6 = parcelRequire("k4pU6");

var $kj1di = parcelRequire("kj1di");

var $gM6H8 = parcelRequire("gM6H8");
const $36b09ac9b73a27e7$var$SidebarContainer = (0, $cSD7y.componentWithFG)('jira_nin_sidebar_layout', (0, $f98ZZ.SidebarContainer), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
const $36b09ac9b73a27e7$export$e111e6466962b82b = (0, $kvekU.default);
// We memo as an optimisation to reduce forced re-renders when the immediate parent renders. In this case it's
// AppContextualAnalytics which will re-render when interacting with the JQL builder, e.g. opening picker.
const $36b09ac9b73a27e7$var$FilterAndJqlProvider = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, jql: jql, refetch: refetch, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKK2E.FilterQueryProvider), {
        query: $36b09ac9b73a27e7$export$e111e6466962b82b,
        refetch: refetch,
        filterId: filterId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gwtSG.ActiveJqlProvider), {
        filterId: filterId,
        filterJql: filterJql,
        jql: jql,
        isFilterEditable: isFilterEditable
    }, children)));
const $36b09ac9b73a27e7$var$getFilter = (searchParam)=>{
    if (searchParam?.type === (0, $6UAdF.SearchInputTypes).JQL) return undefined;
    return searchParam.type === (0, $6UAdF.SearchInputTypes).FILTER_AND_JQL ? searchParam.filter : searchParam;
};
const $36b09ac9b73a27e7$var$MaybeIssueSearch = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false), (0, $a5eZM.IssueSearch), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
const $36b09ac9b73a27e7$var$MaybeIssueSearchQueryProvider = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children), (0, $isIOR.IssueSearchQueryProvider));
const $36b09ac9b73a27e7$var$SelectedIssue = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false), ({ children: children, issues: issues, onChange: onChange, selectedIssueKey: selectedIssueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9BgIv.SelectedIssue), {
        issues: issues,
        onChange: onChange,
        selectedIssueKey: selectedIssueKey
    }, children), ({ children: children, issuesOld: issuesOld, onChange: onChange, selectedIssueKey: selectedIssueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gtUFk.SelectedIssueContainer), {
        issueResults: issuesOld,
        onChange: onChange,
        selectedIssueKey: selectedIssueKey
    }, children));
const $36b09ac9b73a27e7$var$IssueNavigator = ({ issueKey: issueKey, queryReference: queryReference, filterQueryReference: filterQueryReference, CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, onRefinement: onRefinement, onChangePage: onChangePage, onPageDataLoad: onPageDataLoad, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onSetView: onSetView, defaultJql: defaultJql, searchInput: searchInput, jqlBuilderProps: jqlBuilderProps, issueTableProps: issueTableProps, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_NAVIGATOR_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_NAVIGATOR_END);
    }, []);
    const filterInput = searchInput ? $36b09ac9b73a27e7$var$getFilter(searchInput) : undefined;
    const issueQuery = (0, $8Uumt.usePreloadedQuery)((0, $hTvlq.default), queryReference);
    const issueDataCondition = (0, $8Uumt.useFragment)((0, $l5FbD.default), issueQuery);
    const refetchQueryOld = (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? null : issueDataCondition;
    const refetchQueryNew = (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? issueDataCondition : null;
    /* eslint-disable @atlassian/relay/unused-fields */ const [issueNavigatorRefetchDataOld, issueNavigatorRefetchOld] = (0, $8Uumt.useRefetchableFragment)((0, $ln32M.default), refetchQueryOld);
    /* eslint-enable @atlassian/relay/unused-fields */ const [issueNavigatorRefetchDataNew, issueNavigatorRefetchNew] = (0, $8Uumt.useRefetchableFragment)((0, $4LFGS.default), refetchQueryNew);
    const jiraViewData = issueNavigatorRefetchDataNew?.jira?.jiraIssueSearchView ?? null;
    /* eslint-disable @atlassian/relay/unused-fields */ const issueSearchPaginationFragment = (0, $8Uumt.usePaginationFragment)((0, $ai5n6.default), issueNavigatorRefetchDataNew ?? null);
    /* eslint-enable @atlassian/relay/unused-fields */ const detailedViewPaginationFragment = (0, $8Uumt.usePaginationFragment)((0, $9hXMi.default), jiraViewData?.__typename === 'JiraDetailedView' ? jiraViewData : null);
    const groupedListViewPaginationFragment = (0, $8Uumt.usePaginationFragment)((0, $4hr2P.default), jiraViewData?.__typename === 'JiraGroupedListView' ? jiraViewData : null);
    const listViewPaginationFragment = (0, $8Uumt.usePaginationFragment)((0, $31TiE.default), jiraViewData?.__typename === 'JiraListView' ? jiraViewData : null);
    const userPreferencesData = (0, $8Uumt.useFragment)((0, $7uwEc.default), issueQuery.jira?.userPreferences ?? null);
    const jqlBuilderWithAiData = (0, $8Uumt.useFragment)((0, $1nibn.default), // @ts-expect-error - No overload matches this call.
    issueQuery.jira);
    const issueResultsDataOld = issueNavigatorRefetchDataOld?.jira?.issueSearchStable ?? null;
    const viewResultDataOld = issueNavigatorRefetchDataOld?.jira?.issueSearchViewResult ?? null;
    const issueSearchViewDataOld = viewResultDataOld?.__typename === 'JiraIssueSearchView' ? viewResultDataOld : null;
    let issueResultsDataNew = issueSearchPaginationFragment.data?.jira?.issueSearch ?? null;
    const viewResultDataNew = issueNavigatorRefetchDataNew?.jira?.issueSearchViewResult ?? null;
    const issueSearchViewDataNew = viewResultDataNew?.__typename === 'JiraIssueSearchView' ? viewResultDataNew : null;
    let issueResultsData;
    let viewResultData;
    let issueSearchViewData;
    let activePaginationFragment = issueSearchPaginationFragment;
    let groupResultsData = null;
    if ((0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) {
        issueResultsDataNew = null;
        if (detailedViewPaginationFragment.data) {
            activePaginationFragment = detailedViewPaginationFragment;
            issueResultsDataNew = detailedViewPaginationFragment?.data?.issues ?? null;
        } else if (groupedListViewPaginationFragment.data) {
            activePaginationFragment = groupedListViewPaginationFragment;
            groupResultsData = groupedListViewPaginationFragment?.data?.groups ?? null;
        } else if (listViewPaginationFragment.data) {
            activePaginationFragment = listViewPaginationFragment;
            issueResultsDataNew = listViewPaginationFragment?.data?.issues ?? null;
        }
    }
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        issueResultsData = issueResultsDataNew;
        viewResultData = viewResultDataNew;
        issueSearchViewData = issueSearchViewDataNew;
    } else {
        issueResultsData = issueResultsDataOld;
        viewResultData = viewResultDataOld;
        issueSearchViewData = issueSearchViewDataOld;
    }
    const filterQuery = (0, $8Uumt.usePreloadedQuery)($36b09ac9b73a27e7$export$e111e6466962b82b, filterQueryReference);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const [filterData, refetchFilter] = (0, $8Uumt.useRefetchableFragment)((0, $7u5Tm.default), filterQuery);
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ /**
   * initialQueryAsJql remembers the initial query on mount
   */ const [initialQueryAsJql] = (0, $5uXOq.useState)(()=>{
        if (!(0, $4R6GH.fg)('jracloud_85520_hydration_ref_only_on_page_load')) return undefined;
        // Use base input for plain JQL input OR
        // If both filter and JQL are present, JQL takes precedence
        if (searchInput.type === (0, $6UAdF.SearchInputTypes).JQL || searchInput.type === (0, $6UAdF.SearchInputTypes).FILTER_AND_JQL) return searchInput.jql;
        // Use filter JQL for manually-mapped filters like we use in Project Scope
        if (filterInput?.type === (0, $6UAdF.FilterTypes).JQL) return filterInput.value;
        // Otherwise, use the saved filter JQL as returned by the backend
        return filterData?.jira?.filter?.jql;
    });
    let setFlatListIssues = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ setFlatListIssues: setFlatListIssues } = (0, $gM6H8.useFlatListIssuesActions)());
    const handleIssueFlatListUpdated = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') && (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((newFlatKeyList)=>{
        setFlatListIssues(newFlatKeyList);
    }, [
        setFlatListIssues
    ]) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1z7Yr.AppContextualAnalytics), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36b09ac9b73a27e7$var$SidebarContainer, {
        scope: (0, $6UAdF.NIN_SIDEBAR_SCOPE),
        sidebarId: (0, $6UAdF.ISSUE_NAVIGATOR_SIDEBAR_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36b09ac9b73a27e7$var$FilterAndJqlProvider, {
        refetch: refetchFilter,
        filterId: filterInput?.type === (0, $6UAdF.FilterTypes).ID ? filterInput?.value : undefined,
        filterJql: filterInput?.type === (0, $6UAdF.FilterTypes).JQL ? filterInput?.value : filterData?.jira?.filter?.jql,
        isFilterEditable: filterData.jira?.filter?.isEditable !== null ? filterData.jira?.filter?.isEditable : undefined,
        jql: searchInput?.type === (0, $6UAdF.SearchInputTypes).FILTER_AND_JQL || searchInput?.type === (0, $6UAdF.SearchInputTypes).JQL ? searchInput?.jql : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36b09ac9b73a27e7$var$MaybeIssueSearchQueryProvider, {
        refetch: issueNavigatorRefetchOld,
        issueResults: issueResultsDataOld,
        view: issueSearchViewDataOld,
        query: (0, $2CtcG.default),
        onPageDataLoad: onPageDataLoad,
        onChangePage: onChangePage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36b09ac9b73a27e7$var$MaybeIssueSearch, {
        onPageDataLoad: onPageDataLoad,
        view: issueSearchViewDataNew,
        jiraView: jiraViewData,
        refetch: issueNavigatorRefetchNew,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        ...((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') || (0, $4R6GH.fg)('jira_list_group_shadow_requests') || (0, $4R6GH.fg)('jira_list_hierarchy_shadow_requests')) && {
            issueTableProps: issueTableProps
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kj1di.InfiniteScrollProvider), {
        onLoadNext: activePaginationFragment.loadNext,
        onLoadPrevious: activePaginationFragment.loadPrevious,
        isLoadingNext: activePaginationFragment.isLoadingNext,
        isLoadingPrevious: activePaginationFragment.isLoadingPrevious,
        hasNext: activePaginationFragment.hasNext,
        hasPrevious: activePaginationFragment.hasPrevious
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4pU6.SelectedViewContainer), {
        onSetView: onSetView,
        issueSearchView: issueSearchViewData,
        jiraView: jiraViewData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36b09ac9b73a27e7$var$SelectedIssue, {
        selectedIssueKey: issueKey,
        onChange: onChangeIssue,
        issuesOld: issueResultsDataOld,
        issues: issueResultsDataNew
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $en3WN.default), {
        CustomHeader: CustomHeader,
        ActionMenu: ActionMenu,
        HeaderSkeletonImage: HeaderSkeletonImage,
        filter: filterData?.jira?.filter ?? null,
        onChangeIssue: onChangeIssue,
        onChangeFilter: onChangeFilter,
        onPageDataLoad: onPageDataLoad,
        onChangeColumnConfiguration: onChangeColumnConfiguration,
        onChangeJql: onChangeJql,
        onRefinement: onRefinement,
        defaultJql: defaultJql,
        issueResults: issueResultsData,
        groupResults: groupResultsData,
        viewResult: viewResultData,
        project: issueQuery.jira?.jiraProjectByKey ?? null,
        userPreferences: userPreferencesData,
        jqlBuilderProps: jqlBuilderProps,
        jqlBuilderWithAiKey: jqlBuilderWithAiData,
        issueTableProps: issueTableProps,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        jiraView: jiraViewData,
        onIssueFlatListUpdatedOld: setFlatListIssues,
        onIssueFlatListUpdated: handleIssueFlatListUpdated,
        initialQueryAsJql: initialQueryAsJql
    })))))))));
};
const $36b09ac9b73a27e7$var$WithFlatListIssuesContainer = (Component)=>{
    const IssueNavigatorWithFlatListIssuesContainer = (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gM6H8.FlatListIssuesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
    };
    return IssueNavigatorWithFlatListIssuesContainer;
};
const $36b09ac9b73a27e7$var$ConditionalIssueNavigator = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes'), $36b09ac9b73a27e7$var$WithFlatListIssuesContainer($36b09ac9b73a27e7$var$IssueNavigator), $36b09ac9b73a27e7$var$IssueNavigator);
var $36b09ac9b73a27e7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($36b09ac9b73a27e7$var$ConditionalIssueNavigator);

});
parcelRegister("7u5Tm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9610eaebf63e0bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<50c8e9868b3e511de3ea4f420144c717>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $2JKPT = parcelRequire("2JKPT");
const $f9610eaebf63e0bf$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "filterAri"
        },
        {
            "kind": "RootArgument",
            "name": "includeFilter"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $2JKPT.default)
        }
    },
    "name": "main_issueNavigator_IssueNavigator_filterQuery",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "includeFilter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "filterAri"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jql"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditable"
                                        }
                                    ],
                                    "type": "JiraCustomFilter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_Header_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "topBar_issueNavigator_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_ListView_filter"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$f9610eaebf63e0bf$var$node.hash = "26da718314f181d4824f62928229af2b";
var $f9610eaebf63e0bf$export$2e2bcd8739ae039 = $f9610eaebf63e0bf$var$node;

});
parcelRegister("2JKPT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4685b2a0e7385ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0913b38543a4ac835cf7eeb194420fa3>>
 * @relayHash d4259e050915cf8816f8c8a4884d4afb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa55db43feb181a2ea2d08440aa1fca705fd8ddbbea5388f6c28457a3933a61e
const $a4685b2a0e7385ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fa55db43feb181a2ea2d08440aa1fca705fd8ddbbea5388f6c28457a3933a61e",
            "metadata": {},
            "name": "FilterRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a4685b2a0e7385ab$var$node.hash = "26da718314f181d4824f62928229af2b";
var $a4685b2a0e7385ab$export$2e2bcd8739ae039 = $a4685b2a0e7385ab$var$node;

});


parcelRegister("1nibn", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d0842de2b1cb5f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9b849f64e4a61be907eaec3accbf05bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $81d0842de2b1cb5f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_jira",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey"
        }
    ],
    "type": "JiraQuery"
};
$81d0842de2b1cb5f$var$node.hash = "e871bd0eb341a6573bd1df76ea8e5df1";
var $81d0842de2b1cb5f$export$2e2bcd8739ae039 = $81d0842de2b1cb5f$var$node;

});

parcelRegister("7uwEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4652f62216686f4e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1ecec124bc87c6002f2c45127804b4c1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4652f62216686f4e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_userPreferences"
        }
    ],
    "type": "JiraUserPreferences"
};
$4652f62216686f4e$var$node.hash = "1143e00ad7112d3bc319370b0e0a4b27";
var $4652f62216686f4e$export$2e2bcd8739ae039 = $4652f62216686f4e$var$node;

});

parcelRegister("31TiE", function(module, exports) {

$parcel$export(module.exports, "default", () => $baad11fc9e4ceaea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e54099876df2af6e18ab3cef3fd16503>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $at7Ef = parcelRequire("at7Ef");
const $baad11fc9e4ceaea$var$node = function() {
    var v0 = [
        "issues"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $at7Ef.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_listViewData",
        "selections": [
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorListViewPagination__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "selectedIssue_issueNavigator"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Variable",
                                "name": "shouldQueryHasChildren",
                                "variableName": "shouldQueryHasChildren"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraListView"
    };
}();
$baad11fc9e4ceaea$var$node.hash = "6fd17d4b441f85305e759e82f963bd19";
var $baad11fc9e4ceaea$export$2e2bcd8739ae039 = $baad11fc9e4ceaea$var$node;

});
parcelRegister("at7Ef", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7dcbb616d0e1e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f6edc961664cd35adf275d70f21f5040>>
 * @relayHash 2e7fdaa2b0b1d6587c650de750375a61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e069eb014b3022f75e3201a02c643b8ed4b0930078bd34a91b3cddd89618f666

var $bqIzm = parcelRequire("bqIzm");

var $5oQtH = parcelRequire("5oQtH");

var $k3PJZ = parcelRequire("k3PJZ");

var $5qm7M = parcelRequire("5qm7M");

var $dttgK = parcelRequire("dttgK");

var $hBvdF = parcelRequire("hBvdF");
const $da7dcbb616d0e1e8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v20 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v21 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v22 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v23 = {
        "kind": "ScalarField",
        "name": "id"
    }, v24 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "key"
    }, v27 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v30 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            v28 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v32 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v34 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v35 = [
        {
            "kind": "Variable",
            "name": "context",
            "variableName": "fieldSetsContext"
        },
        {
            "kind": "Variable",
            "name": "filterId",
            "variableName": "filterId"
        },
        v34 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v36 = {
        "kind": "ScalarField",
        "name": "text"
    }, v37 = {
        "kind": "ScalarField",
        "name": "name"
    }, v38 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v39 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v40 = {
        "kind": "ScalarField",
        "name": "type"
    }, v41 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v42 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v37 /*: any*/ ,
                                    v23 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v44 = {
        "kind": "ScalarField",
        "name": "value"
    }, v45 = [
        v44 /*: any*/ ,
        v23 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v46 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v47 = {
        "kind": "ClientExtension",
        "selections": [
            v46 /*: any*/ 
        ]
    }, v48 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v45 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v45 /*: any*/ 
                    }
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraCascadingSelectField"
    }, v49 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v50 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v51 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v50 /*: any*/ ,
                                    v51 /*: any*/ ,
                                    v23 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            v47 /*: any*/ 
        ],
        "type": "JiraComponentsField"
    }, v53 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            v53 /*: any*/ ,
            v37 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v55 = {
        "kind": "InlineFragment",
        "selections": [
            v36 /*: any*/ ,
            v37 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v56 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCommentSummary",
                "kind": "LinkedField",
                "name": "commentSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canAddComment"
                    },
                    v56 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCommentSummaryField"
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "uri"
            },
            v47 /*: any*/ 
        ],
        "type": "JiraUrlField"
    }, v59 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v23 /*: any*/ 
        ]
    }, v60 = [
        v59 /*: any*/ 
    ], v61 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    v56 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v44 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v60 /*: any*/ 
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v60 /*: any*/ 
                    },
                    v23 /*: any*/ ,
                    v61 /*: any*/ 
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraSingleSelectField"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v23 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v61 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraMultipleSelectField"
    }, v64 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v44 /*: any*/ 
        ]
    }, v65 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            v64 /*: any*/ 
                        ]
                    }
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraCheckboxesField"
    }, v66 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v67 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v22 /*: any*/ ,
                                    v66 /*: any*/ ,
                                    v37 /*: any*/ ,
                                    v38 /*: any*/ ,
                                    v23 /*: any*/ ,
                                    v67 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v69 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    }
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraTeamViewField"
    }, v70 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraTimeTrackingField",
                        "kind": "LinkedField",
                        "name": "timeTrackingField",
                        "plural": false,
                        "selections": [
                            v23 /*: any*/ ,
                            {
                                "concreteType": "JiraEstimate",
                                "kind": "LinkedField",
                                "name": "originalEstimate",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "timeInSeconds"
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraTimeTrackingSettings",
                                "kind": "LinkedField",
                                "name": "timeTrackingSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingHoursPerDay"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingDaysPerWeek"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultFormat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultUnit"
                                    }
                                ]
                            },
                            v28 /*: any*/ ,
                            v37 /*: any*/ ,
                            v40 /*: any*/ ,
                            v47 /*: any*/ 
                        ]
                    },
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraOriginalTimeEstimateField"
    }, v71 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": [
                    {
                        "alias": "label",
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    v23 /*: any*/ ,
                    v50 /*: any*/ 
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraRadioSelectField"
    }, v72 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v23 /*: any*/ ,
                                    v37 /*: any*/ ,
                                    v50 /*: any*/ ,
                                    v51 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            },
            v47 /*: any*/ 
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v73 = {
        "kind": "ClientExtension",
        "selections": [
            v33 /*: any*/ 
        ]
    }, v74 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    v23 /*: any*/ 
                ]
            },
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v23 /*: any*/ ,
                                    v26 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v73 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    v33 /*: any*/ ,
                    v46 /*: any*/ 
                ]
            }
        ],
        "type": "JiraGoalsField"
    }, v75 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v23 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "href"
                                    }
                                ]
                            }
                        ]
                    },
                    v56 /*: any*/ 
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            },
            v47 /*: any*/ 
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    }, v76 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v48 /*: any*/ ,
            v52 /*: any*/ ,
            v54 /*: any*/ ,
            v55 /*: any*/ ,
            v57 /*: any*/ ,
            v58 /*: any*/ ,
            v62 /*: any*/ ,
            v63 /*: any*/ ,
            v65 /*: any*/ ,
            v68 /*: any*/ ,
            v69 /*: any*/ ,
            v70 /*: any*/ ,
            v71 /*: any*/ ,
            v72 /*: any*/ ,
            v74 /*: any*/ ,
            v75 /*: any*/ 
        ]
    }, v77 = {
        "kind": "ScalarField",
        "name": "message"
    }, v78 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v77 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v79 = [
        v37 /*: any*/ ,
        v23 /*: any*/ 
    ], v80 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "componentsOld",
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v79 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v81 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            v80 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v36 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v82 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v83 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v37 /*: any*/ ,
            v82 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v84 = {
        "kind": "InlineFragment",
        "selections": [
            v53 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v85 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v86 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    v85 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v87 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v88 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    v29 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v89 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v30 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v90 = [
        v37 /*: any*/ 
    ], v91 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v90 /*: any*/ 
                            }
                        ]
                    },
                    v56 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v37 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v92 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v39 /*: any*/ ,
                    v37 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v93 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v36 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v94 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v59 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v95 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v96 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v95 /*: any*/ ,
                    v37 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            },
            v23 /*: any*/ 
        ]
    }, v97 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v98 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    v93 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v26 /*: any*/ ,
                            v94 /*: any*/ ,
                            v96 /*: any*/ ,
                            v93 /*: any*/ ,
                            v23 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v26 /*: any*/ ,
                            v94 /*: any*/ ,
                            v96 /*: any*/ ,
                            v93 /*: any*/ ,
                            v23 /*: any*/ ,
                            v27 /*: any*/ ,
                            v97 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v22 /*: any*/ ,
                                                    v23 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v28 /*: any*/ ,
                                                            v36 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v28 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v37 /*: any*/ ,
                                                                    v95 /*: any*/ ,
                                                                    v32 /*: any*/ ,
                                                                    v23 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v31 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v37 /*: any*/ ,
                    v47 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v99 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v23 /*: any*/ 
                ]
            },
            v37 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v100 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    v26 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v101 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v79 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v102 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v23 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v37 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v37 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v103 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v22 /*: any*/ ,
                    v66 /*: any*/ ,
                    v38 /*: any*/ ,
                    v37 /*: any*/ ,
                    v23 /*: any*/ ,
                    v67 /*: any*/ 
                ]
            },
            v37 /*: any*/ ,
            v82 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v104 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v79 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v105 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    v95 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v107 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v97 /*: any*/ ,
                                            v26 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v22 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v30 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v23 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v23 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v23 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v108 = {
        "kind": "ScalarField",
        "name": "number"
    }, v109 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v108 /*: any*/ ,
            v37 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v108 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v108 /*: any*/ ,
                    v37 /*: any*/ ,
                    v47 /*: any*/ 
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v110 = {
        "kind": "InlineFragment",
        "selections": [
            v40 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v111 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v112 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v113 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v114 = [
        v112 /*: any*/ ,
        v25 /*: any*/ ,
        v113 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorListViewPaginationQuery",
            "selections": [
                {
                    "args": v20 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "shouldQueryHasChildren",
                                    "variableName": "shouldQueryHasChildren"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_listViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorListViewPaginationQuery",
            "selections": [
                {
                    "args": v20 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v24 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isResolved"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v22 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v23 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v32 /*: any*/ ,
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                },
                                                                v23 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isHighlightedIssueRow"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": v35 /*: any*/ ,
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fields",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v36 /*: any*/ ,
                                                                                                                        v37 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v22 /*: any*/ ,
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v23 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                v39 /*: any*/ ,
                                                                                                                                v23 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v30 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v23 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldQueryFieldSetsById",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "fieldSetIds",
                                                                                    "variableName": "fieldSetIds"
                                                                                },
                                                                                v34 /*: any*/ 
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSet",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v40 /*: any*/ ,
                                                                                                v41 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fields",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v23 /*: any*/ ,
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        v76 /*: any*/ ,
                                                                                                                        v78 /*: any*/ ,
                                                                                                                        v81 /*: any*/ ,
                                                                                                                        v83 /*: any*/ ,
                                                                                                                        v84 /*: any*/ ,
                                                                                                                        v86 /*: any*/ ,
                                                                                                                        v87 /*: any*/ ,
                                                                                                                        v55 /*: any*/ ,
                                                                                                                        v88 /*: any*/ ,
                                                                                                                        v89 /*: any*/ ,
                                                                                                                        v91 /*: any*/ ,
                                                                                                                        v92 /*: any*/ ,
                                                                                                                        v98 /*: any*/ ,
                                                                                                                        v99 /*: any*/ ,
                                                                                                                        v100 /*: any*/ ,
                                                                                                                        v101 /*: any*/ ,
                                                                                                                        v102 /*: any*/ ,
                                                                                                                        v103 /*: any*/ ,
                                                                                                                        v104 /*: any*/ ,
                                                                                                                        v105 /*: any*/ ,
                                                                                                                        v106 /*: any*/ ,
                                                                                                                        v107 /*: any*/ ,
                                                                                                                        v109 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldQueryFieldSetsById",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": v35 /*: any*/ ,
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetsForIssueSearchView",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSet",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v40 /*: any*/ ,
                                                                                                v41 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fields",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v48 /*: any*/ ,
                                                                                                                                v52 /*: any*/ ,
                                                                                                                                v54 /*: any*/ ,
                                                                                                                                v110 /*: any*/ ,
                                                                                                                                v57 /*: any*/ ,
                                                                                                                                v58 /*: any*/ ,
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v63 /*: any*/ ,
                                                                                                                                v65 /*: any*/ ,
                                                                                                                                v68 /*: any*/ ,
                                                                                                                                v69 /*: any*/ ,
                                                                                                                                v70 /*: any*/ ,
                                                                                                                                v71 /*: any*/ ,
                                                                                                                                v72 /*: any*/ ,
                                                                                                                                v74 /*: any*/ ,
                                                                                                                                v75 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v78 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": false,
                                                                                                                            "selections": [
                                                                                                                                v80 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v83 /*: any*/ ,
                                                                                                                        v84 /*: any*/ ,
                                                                                                                        v86 /*: any*/ ,
                                                                                                                        v87 /*: any*/ ,
                                                                                                                        v110 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v90 /*: any*/ 
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                        },
                                                                                                                        v89 /*: any*/ ,
                                                                                                                        v91 /*: any*/ ,
                                                                                                                        v98 /*: any*/ ,
                                                                                                                        v99 /*: any*/ ,
                                                                                                                        v100 /*: any*/ ,
                                                                                                                        v101 /*: any*/ ,
                                                                                                                        v102 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v40 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "user",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v66 /*: any*/ ,
                                                                                                                                        v67 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v82 /*: any*/ ,
                                                                                                                                v47 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                                                        },
                                                                                                                        v104 /*: any*/ ,
                                                                                                                        v105 /*: any*/ ,
                                                                                                                        v106 /*: any*/ ,
                                                                                                                        v107 /*: any*/ ,
                                                                                                                        v109 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v85 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v39 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v22 /*: any*/ ,
                                                {
                                                    "condition": "shouldQueryHasChildren",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "filterByProjectKeys",
                                                                    "variableName": "projectKeys"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "hasChildren"
                                                        },
                                                        {
                                                            "args": [
                                                                v21 /*: any*/ 
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "canHaveChildIssues"
                                                        }
                                                    ]
                                                },
                                                v73 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v111 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v40 /*: any*/ ,
                                                                                v41 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        v42 /*: any*/ ,
                                                                                                        v23 /*: any*/ ,
                                                                                                        v43 /*: any*/ ,
                                                                                                        v76 /*: any*/ ,
                                                                                                        v78 /*: any*/ ,
                                                                                                        v81 /*: any*/ ,
                                                                                                        v83 /*: any*/ ,
                                                                                                        v84 /*: any*/ ,
                                                                                                        v86 /*: any*/ ,
                                                                                                        v87 /*: any*/ ,
                                                                                                        v55 /*: any*/ ,
                                                                                                        v88 /*: any*/ ,
                                                                                                        v89 /*: any*/ ,
                                                                                                        v91 /*: any*/ ,
                                                                                                        v92 /*: any*/ ,
                                                                                                        v98 /*: any*/ ,
                                                                                                        v99 /*: any*/ ,
                                                                                                        v100 /*: any*/ ,
                                                                                                        v101 /*: any*/ ,
                                                                                                        v102 /*: any*/ ,
                                                                                                        v103 /*: any*/ ,
                                                                                                        v104 /*: any*/ ,
                                                                                                        v105 /*: any*/ ,
                                                                                                        v106 /*: any*/ ,
                                                                                                        v107 /*: any*/ ,
                                                                                                        v109 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                v64 /*: any*/ ,
                                                                                                                                v73 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraCheckboxesField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v61 /*: any*/ ,
                                                                                                                        v23 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        v73 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldSets(first:500)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v114 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v114 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v112 /*: any*/ ,
                                                        v113 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v77 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidSyntaxError"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        v73 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "args": v111 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v22 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        v23 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldSets(first:500)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v24 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorListViewPagination__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                }
                            ],
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e069eb014b3022f75e3201a02c643b8ed4b0930078bd34a91b3cddd89618f666",
            "metadata": {},
            "name": "IssueNavigatorListViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$da7dcbb616d0e1e8$var$node.hash = "6fd17d4b441f85305e759e82f963bd19";
var $da7dcbb616d0e1e8$export$2e2bcd8739ae039 = $da7dcbb616d0e1e8$var$node;

});


parcelRegister("4hr2P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3be423d0774ab04$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<038d52b681a72d58f8f533420cf580f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $h5DJ3 = parcelRequire("h5DJ3");
const $e3be423d0774ab04$var$node = function() {
    var v0 = [
        "groups"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "isPaginating"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $h5DJ3.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_groupedListViewData",
        "selections": [
            {
                "alias": "groups",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraSpreadsheetGroupConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorGroupedListViewPagination__groups_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_groupResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraGroupedListView"
    };
}();
$e3be423d0774ab04$var$node.hash = "899edbd4ab306cc11af57fd78c9fef95";
var $e3be423d0774ab04$export$2e2bcd8739ae039 = $e3be423d0774ab04$var$node;

});
parcelRegister("h5DJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d572787bd96388ee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c2597615788cad86d014ca86ae02a5d7>>
 * @relayHash 0ef868a289a76b3338e006d996ae2ff7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e36118fdef3d2b9d851c91db3e4d2d056270eef9e0e296dc349ee214192b60b3

var $bqIzm = parcelRequire("bqIzm");

var $5oQtH = parcelRequire("5oQtH");

var $5qm7M = parcelRequire("5qm7M");

var $dttgK = parcelRequire("dttgK");

var $hBvdF = parcelRequire("hBvdF");
const $d572787bd96388ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v19 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v21 = {
        "kind": "ScalarField",
        "name": "id"
    }, v22 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "groupBy",
            "variableName": "groupBy"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v24 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v27 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v28 = {
        "kind": "ScalarField",
        "name": "name"
    }, v29 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v30 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v31 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v32 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v33 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v32 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "number"
    }, v35 = [
        v34 /*: any*/ 
    ], v36 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v37 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v21 /*: any*/ 
        ]
    }, v38 = {
        "kind": "ScalarField",
        "name": "value"
    }, v39 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v40 = {
        "kind": "ScalarField",
        "name": "state"
    }, v41 = {
        "kind": "ScalarField",
        "name": "endDate"
    }, v42 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "priorityId"
                            },
                            v21 /*: any*/ ,
                            v27 /*: any*/ ,
                            v28 /*: any*/ 
                        ]
                    },
                    v29 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v20 /*: any*/ ,
                            v30 /*: any*/ ,
                            v21 /*: any*/ ,
                            v31 /*: any*/ ,
                            v28 /*: any*/ 
                        ]
                    },
                    v29 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v21 /*: any*/ ,
                            v28 /*: any*/ ,
                            {
                                "concreteType": "JiraStatusCategory",
                                "kind": "LinkedField",
                                "name": "statusCategory",
                                "plural": false,
                                "selections": [
                                    v21 /*: any*/ ,
                                    v32 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v29 /*: any*/ ,
                    v33 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": v35 /*: any*/ ,
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v36 /*: any*/ ,
                            v21 /*: any*/ ,
                            v37 /*: any*/ ,
                            v38 /*: any*/ 
                        ]
                    },
                    v29 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": [
                            v39 /*: any*/ ,
                            v21 /*: any*/ ,
                            v40 /*: any*/ ,
                            v28 /*: any*/ ,
                            v41 /*: any*/ 
                        ]
                    },
                    v29 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v21 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            }
                        ]
                    },
                    v29 /*: any*/ 
                ],
                "type": "JiraJqlGoalsFieldValue"
            }
        ]
    }, v43 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v44 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v45 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v46 = {
        "kind": "ScalarField",
        "name": "message"
    }, v47 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v48 = {
        "kind": "ScalarField",
        "name": "key"
    }, v49 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v50 = {
        "kind": "InlineFragment",
        "selections": [
            v25 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v33 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v51 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v53 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v54 = {
        "kind": "ScalarField",
        "name": "type"
    }, v55 = [
        v38 /*: any*/ ,
        v21 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v56 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v57 = {
        "kind": "ClientExtension",
        "selections": [
            v56 /*: any*/ 
        ]
    }, v58 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v59 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v60 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v61 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v62 = {
        "kind": "ScalarField",
        "name": "text"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            v62 /*: any*/ ,
            v28 /*: any*/ ,
            v57 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v64 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v65 = [
        v37 /*: any*/ 
    ], v66 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v67 = {
        "kind": "ClientExtension",
        "selections": [
            v52 /*: any*/ 
        ]
    }, v68 = [
        v28 /*: any*/ ,
        v21 /*: any*/ 
    ], v69 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v70 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v62 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v71 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v72 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v73 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v72 /*: any*/ ,
                    v28 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            },
            v21 /*: any*/ 
        ]
    }, v74 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v75 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v54 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "fieldSetId"
                        },
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v54 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraIssueField"
                                                },
                                                v21 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAffectedServiceConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedAffectedServicesConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAffectedService",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "serviceId"
                                                                                },
                                                                                v28 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAffectedServicesField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraCascadingOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "cascadingOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "parentOptionValue",
                                                                            "plural": false,
                                                                            "selections": v55 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "childOptionValue",
                                                                            "plural": false,
                                                                            "selections": v55 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraCascadingSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "args": v58 /*: any*/ ,
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v59 /*: any*/ ,
                                                                                        v60 /*: any*/ ,
                                                                                        v21 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                },
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v61 /*: any*/ ,
                                                                v28 /*: any*/ ,
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraDateTimePickerField"
                                                        },
                                                        v63 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCommentSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "commentSummary",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canAddComment"
                                                                        },
                                                                        v64 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraCommentSummaryField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "uri"
                                                                },
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraUrlField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v64 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v65 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v65 /*: any*/ 
                                                                        },
                                                                        v21 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v38 /*: any*/ ,
                                                                                        v36 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v38 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraUserConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedUsersConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraUserEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v20 /*: any*/ ,
                                                                                        v30 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        v31 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        v66 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "email"
                                                                                                }
                                                                                            ],
                                                                                            "type": "AtlassianAccountUser"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraTeamView",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedTeam",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedName"
                                                                        }
                                                                    ]
                                                                },
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraTeamViewField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraTimeTrackingField",
                                                                            "kind": "LinkedField",
                                                                            "name": "timeTrackingField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraEstimate",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "originalEstimate",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "timeInSeconds"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "timeTrackingSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingHoursPerDay"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingDaysPerWeek"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultFormat"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultUnit"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v25 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v54 /*: any*/ ,
                                                                                v57 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraOriginalTimeEstimateField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": "label",
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        v21 /*: any*/ ,
                                                                        v59 /*: any*/ 
                                                                    ]
                                                                },
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "args": v58 /*: any*/ ,
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersion",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v28 /*: any*/ ,
                                                                                        v59 /*: any*/ ,
                                                                                        v60 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "versionId"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                },
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": v58 /*: any*/ ,
                                                                    "concreteType": "JiraGoalConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedGoals",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGoalEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraGoal",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v67 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                },
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v52 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraGoalsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "args": v58 /*: any*/ ,
                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "confluenceRemoteIssueLinks",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "href"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v64 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                },
                                                                v57 /*: any*/ 
                                                            ],
                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbObjectConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedCmdbObjectsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraCmdbObject",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "objectId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "label"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "mediaClientConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "clientId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fileId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaBaseUrl"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaJwtToken"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "url48"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "QueryError",
                                                                    "kind": "LinkedField",
                                                                    "name": "errors",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v46 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraCMDBField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": "componentsOld",
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v68 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v62 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "date"
                                                        },
                                                        v28 /*: any*/ ,
                                                        v69 /*: any*/ ,
                                                        v57 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v61 /*: any*/ 
                                                    ],
                                                    "type": "JiraDateTimePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraEpic",
                                                            "kind": "LinkedField",
                                                            "name": "epic",
                                                            "plural": false,
                                                            "selections": [
                                                                v48 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "color"
                                                                },
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraEpicLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "renderedFieldHtml"
                                                        }
                                                    ],
                                                    "type": "JiraFallbackField"
                                                },
                                                v63 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategory",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v32 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusCategoryField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusId"
                                                                },
                                                                v33 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v58 /*: any*/ ,
                                                            "concreteType": "JiraLabelConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedLabelsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v28 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v64 /*: any*/ 
                                                            ],
                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                        },
                                                        v28 /*: any*/ ,
                                                        v57 /*: any*/ 
                                                    ],
                                                    "type": "JiraLabelsField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                v28 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraIssueTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssue",
                                                            "plural": false,
                                                            "selections": [
                                                                v48 /*: any*/ ,
                                                                v70 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v48 /*: any*/ ,
                                                                        v71 /*: any*/ ,
                                                                        v73 /*: any*/ ,
                                                                        v70 /*: any*/ ,
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v48 /*: any*/ ,
                                                                        v71 /*: any*/ ,
                                                                        v73 /*: any*/ ,
                                                                        v70 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v74 /*: any*/ ,
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "summary",
                                                                                        "issuetype",
                                                                                        "status"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v62 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "issueTypeId"
                                                                                                                },
                                                                                                                v28 /*: any*/ ,
                                                                                                                v72 /*: any*/ ,
                                                                                                                v51 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                v50 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                        }
                                                                    ]
                                                                },
                                                                v28 /*: any*/ ,
                                                                v57 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraParentIssueField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        v28 /*: any*/ ,
                                                        v57 /*: any*/ 
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v48 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "large"
                                                                        }
                                                                    ]
                                                                },
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraProjectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraResolution",
                                                            "kind": "LinkedField",
                                                            "name": "resolution",
                                                            "plural": false,
                                                            "selections": v68 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraResolutionField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v39 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v40 /*: any*/ ,
                                                                                v41 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v28 /*: any*/ ,
                                                        v57 /*: any*/ 
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v31 /*: any*/ ,
                                                                v28 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                v66 /*: any*/ 
                                                            ]
                                                        },
                                                        v28 /*: any*/ ,
                                                        v69 /*: any*/ ,
                                                        v57 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        {
                                                            "args": v58 /*: any*/ ,
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v68 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraRichText",
                                                            "kind": "LinkedField",
                                                            "name": "richText",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraADF",
                                                                    "kind": "LinkedField",
                                                                    "name": "adfValue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                            "kind": "LinkedField",
                                                                            "name": "convertedPlainText",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "plainText"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraRichTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraServiceManagementRequestType",
                                                            "kind": "LinkedField",
                                                            "name": "requestType",
                                                            "plural": false,
                                                            "selections": [
                                                                v28 /*: any*/ ,
                                                                v72 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementRequestTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 1
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinkConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                v64 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v74 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "ids",
                                                                                                    "value": [
                                                                                                        "statusCategory"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldsById",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v20 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v33 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                        },
                                                                                        v21 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "relationName"
                                                                                },
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinkConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraIssueLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isStoryPointField"
                                                        },
                                                        v34 /*: any*/ ,
                                                        v28 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": v35 /*: any*/ 
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v34 /*: any*/ ,
                                                                v28 /*: any*/ ,
                                                                v57 /*: any*/ 
                                                            ]
                                                        },
                                                        v57 /*: any*/ 
                                                    ],
                                                    "type": "JiraNumberField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v76 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "selections": [
                {
                    "args": v19 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKey",
                                    "variableName": "projectKey"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_groupedListViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "selections": [
                {
                    "args": v19 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v20 /*: any*/ ,
                        v21 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v22 /*: any*/ ,
                                    "concreteType": "JiraSpreadsheetGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "groups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraSpreadsheetGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v43 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v44 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                v45 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "groupByField"
                                        },
                                        v24 /*: any*/ ,
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        }
                                                    ]
                                                },
                                                v46 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "isPaginating",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroup",
                                                    "kind": "LinkedField",
                                                    "name": "firstGroup",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        {
                                                            "args": v47 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v48 /*: any*/ ,
                                                                                v49 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isResolved"
                                                                                },
                                                                                {
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "ids",
                                                                                            "value": [
                                                                                                "status"
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsById",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v50 /*: any*/ ,
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueTypeField",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v51 /*: any*/ ,
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v21 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        v52 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isHighlightedIssueRow"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "condition": "shouldQueryFieldSetsById",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "fieldSetIds",
                                                                                                            "variableName": "fieldSetIds"
                                                                                                        },
                                                                                                        v53 /*: any*/ 
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldSetsById",
                                                                                                    "plural": false,
                                                                                                    "selections": v75 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "shouldQueryFieldSetsById",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "context",
                                                                                                            "variableName": "fieldSetsContext"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "filterId",
                                                                                                            "variableName": "filterId"
                                                                                                        },
                                                                                                        v53 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "namespace",
                                                                                                            "variableName": "namespace"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "viewId",
                                                                                                            "variableName": "viewId"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldSetsForIssueSearchView",
                                                                                                    "plural": false,
                                                                                                    "selections": v75 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v67 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "args": v76 /*: any*/ ,
                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldSets",
                                                                                    "plural": false,
                                                                                    "selections": v75 /*: any*/ ,
                                                                                    "storageKey": "fieldSets(first:500)"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalIssueSearchResultCount"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isCappingIssueSearchResult"
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v44 /*: any*/ ,
                                                                        v45 /*: any*/ 
                                                                    ]
                                                                },
                                                                v67 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "args": v76 /*: any*/ ,
                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldSets",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fields",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v25 /*: any*/ ,
                                                                                                                                v20 /*: any*/ ,
                                                                                                                                v54 /*: any*/ ,
                                                                                                                                v21 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "fieldSets(first:500)"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "args": v47 /*: any*/ ,
                                                            "filters": [
                                                                "fieldSetsInput"
                                                            ],
                                                            "handle": "connection",
                                                            "key": "firstGroupSection_nativeIssueTable__issues",
                                                            "kind": "LinkedHandle",
                                                            "name": "issues"
                                                        },
                                                        v25 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v67 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v22 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorGroupedListViewPagination__groups",
                                    "kind": "LinkedHandle",
                                    "name": "groups"
                                }
                            ],
                            "type": "JiraGroupedListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e36118fdef3d2b9d851c91db3e4d2d056270eef9e0e296dc349ee214192b60b3",
            "metadata": {},
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$d572787bd96388ee$var$node.hash = "899edbd4ab306cc11af57fd78c9fef95";
var $d572787bd96388ee$export$2e2bcd8739ae039 = $d572787bd96388ee$var$node;

});


parcelRegister("9hXMi", function(module, exports) {

$parcel$export(module.exports, "default", () => $544fce572f6eb084$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af35b869f8ae49feedd50c4b0116f492>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $4wBJE = parcelRequire("4wBJE");
const $544fce572f6eb084$var$node = function() {
    var v0 = [
        "issues"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $4wBJE.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_detailedViewData",
        "selections": [
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorDetailedViewPagination__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "selectedIssue_issueNavigator"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Literal",
                                "name": "shouldQueryHasChildren",
                                "value": false
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraDetailedView"
    };
}();
$544fce572f6eb084$var$node.hash = "b55231f2326f70fb819ca3062e0201a6";
var $544fce572f6eb084$export$2e2bcd8739ae039 = $544fce572f6eb084$var$node;

});
parcelRegister("4wBJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71ac203dea02c63$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<317423a3410263e826e7e59335d96e07>>
 * @relayHash c0744e09e6e58110446fa531f1e11e38
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b6c282561564ec3bfeeea403f083b68ee19ca9150943bbc5e495ef67e3d20500

var $bqIzm = parcelRequire("bqIzm");

var $5oQtH = parcelRequire("5oQtH");

var $k3PJZ = parcelRequire("k3PJZ");

var $5qm7M = parcelRequire("5qm7M");

var $dttgK = parcelRequire("dttgK");

var $hBvdF = parcelRequire("hBvdF");
const $a71ac203dea02c63$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v18 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        }
    ], v22 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v27 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            v25 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v27 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v29 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v31 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v32 = [
        {
            "kind": "Variable",
            "name": "context",
            "variableName": "fieldSetsContext"
        },
        {
            "kind": "Variable",
            "name": "filterId",
            "variableName": "filterId"
        },
        v31 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "text"
    }, v34 = {
        "kind": "ScalarField",
        "name": "name"
    }, v35 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v36 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "type"
    }, v38 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v39 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v40 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v34 /*: any*/ ,
                                    v20 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v41 = {
        "kind": "ScalarField",
        "name": "value"
    }, v42 = [
        v41 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v43 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v44 = {
        "kind": "ClientExtension",
        "selections": [
            v43 /*: any*/ 
        ]
    }, v45 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v42 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v42 /*: any*/ 
                    }
                ]
            },
            v44 /*: any*/ 
        ],
        "type": "JiraCascadingSelectField"
    }, v46 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v47 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v48 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v49 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "args": v46 /*: any*/ ,
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v47 /*: any*/ ,
                                    v48 /*: any*/ ,
                                    v20 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            v44 /*: any*/ 
        ],
        "type": "JiraComponentsField"
    }, v50 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v51 = {
        "kind": "InlineFragment",
        "selections": [
            v50 /*: any*/ ,
            v34 /*: any*/ ,
            v44 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            v33 /*: any*/ ,
            v34 /*: any*/ ,
            v44 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v53 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCommentSummary",
                "kind": "LinkedField",
                "name": "commentSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canAddComment"
                    },
                    v53 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCommentSummaryField"
    }, v55 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "uri"
            },
            v44 /*: any*/ 
        ],
        "type": "JiraUrlField"
    }, v56 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v20 /*: any*/ 
        ]
    }, v57 = [
        v56 /*: any*/ 
    ], v58 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v59 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    v53 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v41 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v57 /*: any*/ 
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v57 /*: any*/ 
                    },
                    v20 /*: any*/ ,
                    v58 /*: any*/ 
                ]
            },
            v44 /*: any*/ 
        ],
        "type": "JiraSingleSelectField"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    v41 /*: any*/ ,
                                    v58 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v44 /*: any*/ 
        ],
        "type": "JiraMultipleSelectField"
    }, v61 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v41 /*: any*/ 
        ]
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            v61 /*: any*/ 
                        ]
                    }
                ]
            },
            v44 /*: any*/ 
        ],
        "type": "JiraCheckboxesField"
    }, v63 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v64 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v65 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v19 /*: any*/ ,
                                    v63 /*: any*/ ,
                                    v34 /*: any*/ ,
                                    v35 /*: any*/ ,
                                    v20 /*: any*/ ,
                                    v64 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v44 /*: any*/ 
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v66 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    }
                ]
            },
            v44 /*: any*/ 
        ],
        "type": "JiraTeamViewField"
    }, v67 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraTimeTrackingField",
                        "kind": "LinkedField",
                        "name": "timeTrackingField",
                        "plural": false,
                        "selections": [
                            v20 /*: any*/ ,
                            {
                                "concreteType": "JiraEstimate",
                                "kind": "LinkedField",
                                "name": "originalEstimate",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "timeInSeconds"
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraTimeTrackingSettings",
                                "kind": "LinkedField",
                                "name": "timeTrackingSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingHoursPerDay"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingDaysPerWeek"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultFormat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultUnit"
                                    }
                                ]
                            },
                            v25 /*: any*/ ,
                            v34 /*: any*/ ,
                            v37 /*: any*/ ,
                            v44 /*: any*/ 
                        ]
                    },
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraOriginalTimeEstimateField"
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": [
                    {
                        "alias": "label",
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    v20 /*: any*/ ,
                    v47 /*: any*/ 
                ]
            },
            v44 /*: any*/ 
        ],
        "type": "JiraRadioSelectField"
    }, v69 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "args": v46 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    v34 /*: any*/ ,
                                    v47 /*: any*/ ,
                                    v48 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            },
            v44 /*: any*/ 
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v70 = {
        "kind": "ClientExtension",
        "selections": [
            v30 /*: any*/ 
        ]
    }, v71 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    v20 /*: any*/ 
                ]
            },
            {
                "args": v46 /*: any*/ ,
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    v23 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v70 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    v30 /*: any*/ ,
                    v43 /*: any*/ 
                ]
            }
        ],
        "type": "JiraGoalsField"
    }, v72 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "args": v46 /*: any*/ ,
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "href"
                                    }
                                ]
                            }
                        ]
                    },
                    v53 /*: any*/ 
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            },
            v44 /*: any*/ 
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    }, v73 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v45 /*: any*/ ,
            v49 /*: any*/ ,
            v51 /*: any*/ ,
            v52 /*: any*/ ,
            v54 /*: any*/ ,
            v55 /*: any*/ ,
            v59 /*: any*/ ,
            v60 /*: any*/ ,
            v62 /*: any*/ ,
            v65 /*: any*/ ,
            v66 /*: any*/ ,
            v67 /*: any*/ ,
            v68 /*: any*/ ,
            v69 /*: any*/ ,
            v71 /*: any*/ ,
            v72 /*: any*/ 
        ]
    }, v74 = {
        "kind": "ScalarField",
        "name": "message"
    }, v75 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v74 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v76 = [
        v34 /*: any*/ ,
        v20 /*: any*/ 
    ], v77 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "componentsOld",
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v76 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v78 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            v77 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v79 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v80 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v34 /*: any*/ ,
            v79 /*: any*/ ,
            v44 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v81 = {
        "kind": "InlineFragment",
        "selections": [
            v50 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v82 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v83 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v82 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v84 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v85 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v34 /*: any*/ ,
                    v26 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v86 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v34 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v27 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v87 = [
        v34 /*: any*/ 
    ], v88 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v46 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v87 /*: any*/ 
                            }
                        ]
                    },
                    v53 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v34 /*: any*/ ,
            v44 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v89 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v36 /*: any*/ ,
                    v34 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v90 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v91 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v56 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v92 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v93 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v92 /*: any*/ ,
                    v34 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            },
            v20 /*: any*/ 
        ]
    }, v94 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v95 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v90 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v23 /*: any*/ ,
                            v91 /*: any*/ ,
                            v93 /*: any*/ ,
                            v90 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v23 /*: any*/ ,
                            v91 /*: any*/ ,
                            v93 /*: any*/ ,
                            v90 /*: any*/ ,
                            v20 /*: any*/ ,
                            v24 /*: any*/ ,
                            v94 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v19 /*: any*/ ,
                                                    v20 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v25 /*: any*/ ,
                                                            v33 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v25 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v34 /*: any*/ ,
                                                                    v92 /*: any*/ ,
                                                                    v29 /*: any*/ ,
                                                                    v20 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v28 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v34 /*: any*/ ,
                    v44 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v96 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v34 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v20 /*: any*/ 
                ]
            },
            v34 /*: any*/ ,
            v44 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v97 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v34 /*: any*/ ,
                    v23 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v98 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v76 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v99 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v34 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v34 /*: any*/ ,
            v44 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v100 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    v63 /*: any*/ ,
                    v35 /*: any*/ ,
                    v34 /*: any*/ ,
                    v20 /*: any*/ ,
                    v64 /*: any*/ 
                ]
            },
            v34 /*: any*/ ,
            v79 /*: any*/ ,
            v44 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v101 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            {
                "args": v46 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v76 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v102 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v103 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v34 /*: any*/ ,
                    v92 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v104 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v53 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v94 /*: any*/ ,
                                            v23 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v19 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v27 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v20 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v20 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v20 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v105 = {
        "kind": "ScalarField",
        "name": "number"
    }, v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v105 /*: any*/ ,
            v34 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v105 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v105 /*: any*/ ,
                    v34 /*: any*/ ,
                    v44 /*: any*/ 
                ]
            },
            v44 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v107 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            v44 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v108 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v109 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v110 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v111 = [
        v109 /*: any*/ ,
        v22 /*: any*/ ,
        v110 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "selections": [
                {
                    "args": v18 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKey",
                                    "variableName": "projectKey"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_detailedViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "selections": [
                {
                    "args": v18 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v21 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isResolved"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v29 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isHighlightedIssueRow"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": v32 /*: any*/ ,
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fields",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v33 /*: any*/ ,
                                                                                                                        v34 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v34 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v19 /*: any*/ ,
                                                                                                                                v34 /*: any*/ ,
                                                                                                                                v35 /*: any*/ ,
                                                                                                                                v20 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v34 /*: any*/ ,
                                                                                                                                v36 /*: any*/ ,
                                                                                                                                v20 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v27 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldQueryFieldSetsById",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "fieldSetIds",
                                                                                    "variableName": "fieldSetIds"
                                                                                },
                                                                                v31 /*: any*/ 
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSet",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fields",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v19 /*: any*/ ,
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v39 /*: any*/ ,
                                                                                                                        v20 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v73 /*: any*/ ,
                                                                                                                        v75 /*: any*/ ,
                                                                                                                        v78 /*: any*/ ,
                                                                                                                        v80 /*: any*/ ,
                                                                                                                        v81 /*: any*/ ,
                                                                                                                        v83 /*: any*/ ,
                                                                                                                        v84 /*: any*/ ,
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v85 /*: any*/ ,
                                                                                                                        v86 /*: any*/ ,
                                                                                                                        v88 /*: any*/ ,
                                                                                                                        v89 /*: any*/ ,
                                                                                                                        v95 /*: any*/ ,
                                                                                                                        v96 /*: any*/ ,
                                                                                                                        v97 /*: any*/ ,
                                                                                                                        v98 /*: any*/ ,
                                                                                                                        v99 /*: any*/ ,
                                                                                                                        v100 /*: any*/ ,
                                                                                                                        v101 /*: any*/ ,
                                                                                                                        v102 /*: any*/ ,
                                                                                                                        v103 /*: any*/ ,
                                                                                                                        v104 /*: any*/ ,
                                                                                                                        v106 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldQueryFieldSetsById",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": v32 /*: any*/ ,
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetsForIssueSearchView",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSet",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fields",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v39 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v45 /*: any*/ ,
                                                                                                                                v49 /*: any*/ ,
                                                                                                                                v51 /*: any*/ ,
                                                                                                                                v107 /*: any*/ ,
                                                                                                                                v54 /*: any*/ ,
                                                                                                                                v55 /*: any*/ ,
                                                                                                                                v59 /*: any*/ ,
                                                                                                                                v60 /*: any*/ ,
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v65 /*: any*/ ,
                                                                                                                                v66 /*: any*/ ,
                                                                                                                                v67 /*: any*/ ,
                                                                                                                                v68 /*: any*/ ,
                                                                                                                                v69 /*: any*/ ,
                                                                                                                                v71 /*: any*/ ,
                                                                                                                                v72 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v75 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": false,
                                                                                                                            "selections": [
                                                                                                                                v77 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v80 /*: any*/ ,
                                                                                                                        v81 /*: any*/ ,
                                                                                                                        v83 /*: any*/ ,
                                                                                                                        v84 /*: any*/ ,
                                                                                                                        v107 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v87 /*: any*/ 
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                        },
                                                                                                                        v86 /*: any*/ ,
                                                                                                                        v88 /*: any*/ ,
                                                                                                                        v95 /*: any*/ ,
                                                                                                                        v96 /*: any*/ ,
                                                                                                                        v97 /*: any*/ ,
                                                                                                                        v98 /*: any*/ ,
                                                                                                                        v99 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "user",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v63 /*: any*/ ,
                                                                                                                                        v64 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v79 /*: any*/ ,
                                                                                                                                v44 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                                                        },
                                                                                                                        v101 /*: any*/ ,
                                                                                                                        v102 /*: any*/ ,
                                                                                                                        v103 /*: any*/ ,
                                                                                                                        v104 /*: any*/ ,
                                                                                                                        v106 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v82 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v36 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v19 /*: any*/ ,
                                                v70 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v108 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v37 /*: any*/ ,
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ ,
                                                                                                        v25 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v39 /*: any*/ ,
                                                                                                        v20 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        v73 /*: any*/ ,
                                                                                                        v75 /*: any*/ ,
                                                                                                        v78 /*: any*/ ,
                                                                                                        v80 /*: any*/ ,
                                                                                                        v81 /*: any*/ ,
                                                                                                        v83 /*: any*/ ,
                                                                                                        v84 /*: any*/ ,
                                                                                                        v52 /*: any*/ ,
                                                                                                        v85 /*: any*/ ,
                                                                                                        v86 /*: any*/ ,
                                                                                                        v88 /*: any*/ ,
                                                                                                        v89 /*: any*/ ,
                                                                                                        v95 /*: any*/ ,
                                                                                                        v96 /*: any*/ ,
                                                                                                        v97 /*: any*/ ,
                                                                                                        v98 /*: any*/ ,
                                                                                                        v99 /*: any*/ ,
                                                                                                        v100 /*: any*/ ,
                                                                                                        v101 /*: any*/ ,
                                                                                                        v102 /*: any*/ ,
                                                                                                        v103 /*: any*/ ,
                                                                                                        v104 /*: any*/ ,
                                                                                                        v106 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                v61 /*: any*/ ,
                                                                                                                                v70 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraCheckboxesField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v58 /*: any*/ ,
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        v70 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldSets(first:500)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v111 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v111 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v109 /*: any*/ ,
                                                        v110 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v74 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidSyntaxError"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        v70 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "args": v108 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldSets(first:500)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v21 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorDetailedViewPagination__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                }
                            ],
                            "type": "JiraDetailedView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b6c282561564ec3bfeeea403f083b68ee19ca9150943bbc5e495ef67e3d20500",
            "metadata": {},
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$a71ac203dea02c63$var$node.hash = "b55231f2326f70fb819ca3062e0201a6";
var $a71ac203dea02c63$export$2e2bcd8739ae039 = $a71ac203dea02c63$var$node;

});


parcelRegister("ai5n6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d5526f1028c0833$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea561c81d2a9ee87a588c604cb3879c2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $5iW7l = parcelRequire("5iW7l");
const $8d5526f1028c0833$var$node = function() {
    var v0 = [
        "jira",
        "issueSearch"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $5iW7l.default)
            }
        },
        "name": "main_issueNavigator_IssueNavigator_issueSearchData",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "alias": "issueSearch",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "issueSearchInput",
                                        "variableName": "issueSearchInput"
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "__IssueNavigatorIssueSearchPagination__issueSearch_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            },
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "startCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasPreviousPage"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "selectedIssue_issueNavigator"
                                    },
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "projectKey",
                                                "variableName": "projectKey"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "projectKeys",
                                                "variableName": "projectKeys"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "shouldQueryHasChildren",
                                                "variableName": "shouldQueryHasChildren"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$8d5526f1028c0833$var$node.hash = "2effd46440f8aee61775fe79bc8cc67a";
var $8d5526f1028c0833$export$2e2bcd8739ae039 = $8d5526f1028c0833$var$node;

});
parcelRegister("5iW7l", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c3d59a7ab62dfe5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<634d41b0138059e17a87b7fb07113fb2>>
 * @relayHash f764c93df967481ead4bcbc33ce1723a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3e403ae059dc2bead019ff5ce7e9fae6bec473420265cbcf6119401aa0b2ef7

var $bqIzm = parcelRequire("bqIzm");

var $5oQtH = parcelRequire("5oQtH");

var $1q6lK = parcelRequire("1q6lK");

var $k3PJZ = parcelRequire("k3PJZ");

var $5qm7M = parcelRequire("5qm7M");

var $dttgK = parcelRequire("dttgK");

var $hBvdF = parcelRequire("hBvdF");
const $9c3d59a7ab62dfe5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRefactorNinToViewSchemaEnabled"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v21 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v22 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "kind": "ScalarField",
        "name": "id"
    }, v26 = {
        "kind": "ScalarField",
        "name": "key"
    }, v27 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v30 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            v28 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v32 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v34 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v35 = [
        {
            "kind": "Variable",
            "name": "context",
            "variableName": "fieldSetsContext"
        },
        {
            "kind": "Variable",
            "name": "filterId",
            "variableName": "filterId"
        },
        v34 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v36 = {
        "kind": "ScalarField",
        "name": "text"
    }, v37 = {
        "kind": "ScalarField",
        "name": "name"
    }, v38 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v39 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v40 = {
        "kind": "ScalarField",
        "name": "type"
    }, v41 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v42 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v37 /*: any*/ ,
                                    v25 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v44 = {
        "kind": "ScalarField",
        "name": "value"
    }, v45 = [
        v44 /*: any*/ ,
        v25 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v46 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v47 = {
        "kind": "ClientExtension",
        "selections": [
            v46 /*: any*/ 
        ]
    }, v48 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v45 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v45 /*: any*/ 
                    }
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraCascadingSelectField"
    }, v49 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v50 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v51 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v50 /*: any*/ ,
                                    v51 /*: any*/ ,
                                    v25 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            v47 /*: any*/ 
        ],
        "type": "JiraComponentsField"
    }, v53 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            v53 /*: any*/ ,
            v37 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v55 = {
        "kind": "InlineFragment",
        "selections": [
            v36 /*: any*/ ,
            v37 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v56 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCommentSummary",
                "kind": "LinkedField",
                "name": "commentSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canAddComment"
                    },
                    v56 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCommentSummaryField"
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "uri"
            },
            v47 /*: any*/ 
        ],
        "type": "JiraUrlField"
    }, v59 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v25 /*: any*/ 
        ]
    }, v60 = [
        v59 /*: any*/ 
    ], v61 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    v56 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v44 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v60 /*: any*/ 
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v60 /*: any*/ 
                    },
                    v25 /*: any*/ ,
                    v61 /*: any*/ 
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraSingleSelectField"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v25 /*: any*/ ,
                                    v44 /*: any*/ ,
                                    v61 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraMultipleSelectField"
    }, v64 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v44 /*: any*/ 
        ]
    }, v65 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            v64 /*: any*/ 
                        ]
                    }
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraCheckboxesField"
    }, v66 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v67 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v24 /*: any*/ ,
                                    v66 /*: any*/ ,
                                    v37 /*: any*/ ,
                                    v38 /*: any*/ ,
                                    v25 /*: any*/ ,
                                    v67 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v69 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    }
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraTeamViewField"
    }, v70 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraTimeTrackingField",
                        "kind": "LinkedField",
                        "name": "timeTrackingField",
                        "plural": false,
                        "selections": [
                            v25 /*: any*/ ,
                            {
                                "concreteType": "JiraEstimate",
                                "kind": "LinkedField",
                                "name": "originalEstimate",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "timeInSeconds"
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraTimeTrackingSettings",
                                "kind": "LinkedField",
                                "name": "timeTrackingSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingHoursPerDay"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingDaysPerWeek"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultFormat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultUnit"
                                    }
                                ]
                            },
                            v28 /*: any*/ ,
                            v37 /*: any*/ ,
                            v40 /*: any*/ ,
                            v47 /*: any*/ 
                        ]
                    },
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "JiraOriginalTimeEstimateField"
    }, v71 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": [
                    {
                        "alias": "label",
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    v25 /*: any*/ ,
                    v50 /*: any*/ 
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraRadioSelectField"
    }, v72 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v25 /*: any*/ ,
                                    v37 /*: any*/ ,
                                    v50 /*: any*/ ,
                                    v51 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            },
            v47 /*: any*/ 
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v73 = {
        "kind": "ClientExtension",
        "selections": [
            v33 /*: any*/ 
        ]
    }, v74 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    v25 /*: any*/ 
                ]
            },
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v25 /*: any*/ ,
                                    v26 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v73 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    v33 /*: any*/ ,
                    v46 /*: any*/ 
                ]
            }
        ],
        "type": "JiraGoalsField"
    }, v75 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v25 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "href"
                                    }
                                ]
                            }
                        ]
                    },
                    v56 /*: any*/ 
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            },
            v47 /*: any*/ 
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    }, v76 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v48 /*: any*/ ,
            v52 /*: any*/ ,
            v54 /*: any*/ ,
            v55 /*: any*/ ,
            v57 /*: any*/ ,
            v58 /*: any*/ ,
            v62 /*: any*/ ,
            v63 /*: any*/ ,
            v65 /*: any*/ ,
            v68 /*: any*/ ,
            v69 /*: any*/ ,
            v70 /*: any*/ ,
            v71 /*: any*/ ,
            v72 /*: any*/ ,
            v74 /*: any*/ ,
            v75 /*: any*/ 
        ]
    }, v77 = {
        "kind": "ScalarField",
        "name": "message"
    }, v78 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v77 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v79 = [
        v37 /*: any*/ ,
        v25 /*: any*/ 
    ], v80 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "componentsOld",
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v79 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v81 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            v80 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v36 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v82 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v83 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v37 /*: any*/ ,
            v82 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v84 = {
        "kind": "InlineFragment",
        "selections": [
            v53 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v85 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v86 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    v85 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v87 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v88 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    v29 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v89 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v30 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v90 = [
        v37 /*: any*/ 
    ], v91 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v90 /*: any*/ 
                            }
                        ]
                    },
                    v56 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v37 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v92 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v39 /*: any*/ ,
                    v37 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v93 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v36 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v94 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v59 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v95 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v96 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v95 /*: any*/ ,
                    v37 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            },
            v25 /*: any*/ 
        ]
    }, v97 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v98 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    v93 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v26 /*: any*/ ,
                            v94 /*: any*/ ,
                            v96 /*: any*/ ,
                            v93 /*: any*/ ,
                            v25 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v26 /*: any*/ ,
                            v94 /*: any*/ ,
                            v96 /*: any*/ ,
                            v93 /*: any*/ ,
                            v25 /*: any*/ ,
                            v27 /*: any*/ ,
                            v97 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v24 /*: any*/ ,
                                                    v25 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v28 /*: any*/ ,
                                                            v36 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v28 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v37 /*: any*/ ,
                                                                    v95 /*: any*/ ,
                                                                    v32 /*: any*/ ,
                                                                    v25 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v31 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v37 /*: any*/ ,
                    v47 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v99 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v25 /*: any*/ 
                ]
            },
            v37 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v100 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    v26 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v101 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v79 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v102 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v25 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v37 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v37 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v103 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    v66 /*: any*/ ,
                    v38 /*: any*/ ,
                    v37 /*: any*/ ,
                    v25 /*: any*/ ,
                    v67 /*: any*/ 
                ]
            },
            v37 /*: any*/ ,
            v82 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v104 = {
        "kind": "InlineFragment",
        "selections": [
            v37 /*: any*/ ,
            {
                "args": v49 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v79 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v105 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    v95 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v107 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v56 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v97 /*: any*/ ,
                                            v26 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v24 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v30 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v25 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v25 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v25 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v108 = {
        "kind": "ScalarField",
        "name": "number"
    }, v109 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v108 /*: any*/ ,
            v37 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v108 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v108 /*: any*/ ,
                    v37 /*: any*/ ,
                    v47 /*: any*/ 
                ]
            },
            v47 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v110 = {
        "kind": "InlineFragment",
        "selections": [
            v40 /*: any*/ ,
            v47 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v111 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v112 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v113 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v114 = [
        v112 /*: any*/ ,
        v23 /*: any*/ ,
        v113 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorIssueSearchPaginationQuery",
            "selections": [
                {
                    "args": [
                        v21 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        },
                        {
                            "kind": "Variable",
                            "name": "shouldQueryHasChildren",
                            "variableName": "shouldQueryHasChildren"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_issueSearchData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorIssueSearchPaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v22 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isResolved"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v24 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v25 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v32 /*: any*/ ,
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                },
                                                                v25 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isHighlightedIssueRow"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": v35 /*: any*/ ,
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fields",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v24 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v36 /*: any*/ ,
                                                                                                                        v37 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v24 /*: any*/ ,
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                v38 /*: any*/ ,
                                                                                                                                v25 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "issueType",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v37 /*: any*/ ,
                                                                                                                                v39 /*: any*/ ,
                                                                                                                                v25 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v30 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v25 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldQueryFieldSetsById",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "fieldSetIds",
                                                                                    "variableName": "fieldSetIds"
                                                                                },
                                                                                v34 /*: any*/ 
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSet",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v40 /*: any*/ ,
                                                                                                v41 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fields",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v24 /*: any*/ ,
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v25 /*: any*/ ,
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        v76 /*: any*/ ,
                                                                                                                        v78 /*: any*/ ,
                                                                                                                        v81 /*: any*/ ,
                                                                                                                        v83 /*: any*/ ,
                                                                                                                        v84 /*: any*/ ,
                                                                                                                        v86 /*: any*/ ,
                                                                                                                        v87 /*: any*/ ,
                                                                                                                        v55 /*: any*/ ,
                                                                                                                        v88 /*: any*/ ,
                                                                                                                        v89 /*: any*/ ,
                                                                                                                        v91 /*: any*/ ,
                                                                                                                        v92 /*: any*/ ,
                                                                                                                        v98 /*: any*/ ,
                                                                                                                        v99 /*: any*/ ,
                                                                                                                        v100 /*: any*/ ,
                                                                                                                        v101 /*: any*/ ,
                                                                                                                        v102 /*: any*/ ,
                                                                                                                        v103 /*: any*/ ,
                                                                                                                        v104 /*: any*/ ,
                                                                                                                        v105 /*: any*/ ,
                                                                                                                        v106 /*: any*/ ,
                                                                                                                        v107 /*: any*/ ,
                                                                                                                        v109 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldQueryFieldSetsById",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": v35 /*: any*/ ,
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetsForIssueSearchView",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldSet",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v40 /*: any*/ ,
                                                                                                v41 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fields",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "edges",
                                                                                                            "plural": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "node",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v28 /*: any*/ ,
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        v42 /*: any*/ ,
                                                                                                                        v43 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": [
                                                                                                                                v48 /*: any*/ ,
                                                                                                                                v52 /*: any*/ ,
                                                                                                                                v54 /*: any*/ ,
                                                                                                                                v110 /*: any*/ ,
                                                                                                                                v57 /*: any*/ ,
                                                                                                                                v58 /*: any*/ ,
                                                                                                                                v62 /*: any*/ ,
                                                                                                                                v63 /*: any*/ ,
                                                                                                                                v65 /*: any*/ ,
                                                                                                                                v68 /*: any*/ ,
                                                                                                                                v69 /*: any*/ ,
                                                                                                                                v70 /*: any*/ ,
                                                                                                                                v71 /*: any*/ ,
                                                                                                                                v72 /*: any*/ ,
                                                                                                                                v74 /*: any*/ ,
                                                                                                                                v75 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v78 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": false,
                                                                                                                            "selections": [
                                                                                                                                v80 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v83 /*: any*/ ,
                                                                                                                        v84 /*: any*/ ,
                                                                                                                        v86 /*: any*/ ,
                                                                                                                        v87 /*: any*/ ,
                                                                                                                        v110 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "statusCategory",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v90 /*: any*/ 
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                                        },
                                                                                                                        v89 /*: any*/ ,
                                                                                                                        v91 /*: any*/ ,
                                                                                                                        v98 /*: any*/ ,
                                                                                                                        v99 /*: any*/ ,
                                                                                                                        v100 /*: any*/ ,
                                                                                                                        v101 /*: any*/ ,
                                                                                                                        v102 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "InlineFragment",
                                                                                                                            "selections": [
                                                                                                                                v40 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "user",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v66 /*: any*/ ,
                                                                                                                                        v67 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v82 /*: any*/ ,
                                                                                                                                v47 /*: any*/ 
                                                                                                                            ],
                                                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                                                        },
                                                                                                                        v104 /*: any*/ ,
                                                                                                                        v105 /*: any*/ ,
                                                                                                                        v106 /*: any*/ ,
                                                                                                                        v107 /*: any*/ ,
                                                                                                                        v109 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v85 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v39 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v24 /*: any*/ ,
                                                {
                                                    "condition": "shouldQueryHasChildren",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "filterByProjectKeys",
                                                                    "variableName": "projectKeys"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "hasChildren"
                                                        },
                                                        {
                                                            "args": [
                                                                v21 /*: any*/ 
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "canHaveChildIssues"
                                                        }
                                                    ]
                                                },
                                                v73 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v111 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v40 /*: any*/ ,
                                                                                v41 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v24 /*: any*/ ,
                                                                                                        v28 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        v42 /*: any*/ ,
                                                                                                        v25 /*: any*/ ,
                                                                                                        v43 /*: any*/ ,
                                                                                                        v76 /*: any*/ ,
                                                                                                        v78 /*: any*/ ,
                                                                                                        v81 /*: any*/ ,
                                                                                                        v83 /*: any*/ ,
                                                                                                        v84 /*: any*/ ,
                                                                                                        v86 /*: any*/ ,
                                                                                                        v87 /*: any*/ ,
                                                                                                        v55 /*: any*/ ,
                                                                                                        v88 /*: any*/ ,
                                                                                                        v89 /*: any*/ ,
                                                                                                        v91 /*: any*/ ,
                                                                                                        v92 /*: any*/ ,
                                                                                                        v98 /*: any*/ ,
                                                                                                        v99 /*: any*/ ,
                                                                                                        v100 /*: any*/ ,
                                                                                                        v101 /*: any*/ ,
                                                                                                        v102 /*: any*/ ,
                                                                                                        v103 /*: any*/ ,
                                                                                                        v104 /*: any*/ ,
                                                                                                        v105 /*: any*/ ,
                                                                                                        v106 /*: any*/ ,
                                                                                                        v107 /*: any*/ ,
                                                                                                        v109 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                v64 /*: any*/ ,
                                                                                                                                v73 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraCheckboxesField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v61 /*: any*/ ,
                                                                                                                        v25 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        v73 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldSets(first:500)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v114 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v114 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v112 /*: any*/ ,
                                                        v113 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v24 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v77 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidSyntaxError"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        v73 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "args": v111 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v28 /*: any*/ ,
                                                                                                        v24 /*: any*/ ,
                                                                                                        v40 /*: any*/ ,
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldSets(first:500)"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v22 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                                    "kind": "LinkedHandle",
                                    "name": "issueSearch"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b3e403ae059dc2bead019ff5ce7e9fae6bec473420265cbcf6119401aa0b2ef7",
            "metadata": {},
            "name": "IssueNavigatorIssueSearchPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isRefactorNinToViewSchemaEnabled": (0, $1q6lK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider": (0, $1q6lK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$9c3d59a7ab62dfe5$var$node.hash = "2effd46440f8aee61775fe79bc8cc67a";
var $9c3d59a7ab62dfe5$export$2e2bcd8739ae039 = $9c3d59a7ab62dfe5$var$node;

});


parcelRegister("4LFGS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e58808b90d1423b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b289a3048054d02874f9e275fd35b15e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $kF1V3 = parcelRequire("kF1V3");
const $7e58808b90d1423b$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v1 = {
        "kind": "Variable",
        "name": "projectKeys",
        "variableName": "projectKeys"
    }, v2 = [
        v0 /*: any*/ ,
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "shouldQueryHasChildren",
            "variableName": "shouldQueryHasChildren"
        }
    ], v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "kind": "Variable",
        "name": "filterId",
        "variableName": "filterId"
    }, v5 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v6 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v7 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = [
        v0 /*: any*/ ,
        v1 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "isPaginating"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "staticViewInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $kF1V3.default)
            }
        },
        "name": "main_issueNavigator_IssueNavigator_refetchQueryNew",
        "selections": [
            {
                "args": v2 /*: any*/ ,
                "kind": "FragmentSpread",
                "name": "main_issueNavigator_IssueNavigator_issueSearchData"
            },
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "viewConfigInput",
                                        "variableName": "staticViewInput"
                                    },
                                    v7 /*: any*/ 
                                ],
                                "kind": "LinkedField",
                                "name": "jiraIssueSearchView",
                                "plural": false,
                                "selections": [
                                    v8 /*: any*/ ,
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issueSearch_issueNavigatorGrouping"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigatorUI_jiraView"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "selectedView_issueNavigator_SelectedViewContainer_jiraView"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": v9 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "main_issueNavigator_IssueNavigator_detailedViewData"
                                            }
                                        ],
                                        "type": "JiraDetailedView"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": v9 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "main_issueNavigator_IssueNavigator_groupedListViewData"
                                            }
                                        ],
                                        "type": "JiraGroupedListView"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": v2 /*: any*/ ,
                                                "kind": "FragmentSpread",
                                                "name": "main_issueNavigator_IssueNavigator_listViewData"
                                            }
                                        ],
                                        "type": "JiraListView"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": [
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ 
                                ],
                                "kind": "LinkedField",
                                "name": "issueSearchViewResult",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v8 /*: any*/ ,
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "issueSearch_issueNavigator"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "selectedView_issueNavigator_SelectedViewContainer_issueSearchView"
                                            }
                                        ],
                                        "type": "JiraIssueSearchView"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigatorUI_viewResult"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$7e58808b90d1423b$var$node.hash = "df75ebbabf681ee8b6dc5d51605996ca";
var $7e58808b90d1423b$export$2e2bcd8739ae039 = $7e58808b90d1423b$var$node;

});
parcelRegister("kF1V3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2b7fdc33d59789a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6feaef03708212a23da1f24677bcfaf9>>
 * @relayHash be2fa6578edc7674494b3b15352c2da5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c87dc483b646067310ffb71a20f2a44bc95f5eac4ea747c3f0a2c40f77ba4dfd

var $bqIzm = parcelRequire("bqIzm");

var $5oQtH = parcelRequire("5oQtH");

var $1q6lK = parcelRequire("1q6lK");

var $k3PJZ = parcelRequire("k3PJZ");

var $5qm7M = parcelRequire("5qm7M");

var $dttgK = parcelRequire("dttgK");

var $hBvdF = parcelRequire("hBvdF");
const $a2b7fdc33d59789a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isRefactorNinToViewSchemaEnabled"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v24 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v25 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v26 = {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
    }, v27 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v28 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v29 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v30 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v31 = {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
    }, v32 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v33 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v34 = {
        "kind": "Variable",
        "name": "viewConfigInput",
        "variableName": "viewConfigInput"
    }, v35 = [
        v25 /*: any*/ ,
        v26 /*: any*/ ,
        v27 /*: any*/ ,
        v28 /*: any*/ ,
        v29 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ ,
        v33 /*: any*/ ,
        v34 /*: any*/ 
    ], v36 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v37 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v38 = {
        "kind": "ScalarField",
        "name": "id"
    }, v39 = {
        "kind": "ScalarField",
        "name": "key"
    }, v40 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v41 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v42 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v43 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v44 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v43 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v45 = {
        "kind": "InlineFragment",
        "selections": [
            v42 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v44 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v46 = {
        "args": [
            {
                "kind": "Literal",
                "name": "ids",
                "value": [
                    "status"
                ]
            }
        ],
        "concreteType": "JiraIssueFieldConnection",
        "kind": "LinkedField",
        "name": "fieldsById",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v37 /*: any*/ ,
                            v45 /*: any*/ ,
                            v38 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldsById(ids:[\"status\"])"
    }, v47 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v48 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v47 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            },
            v38 /*: any*/ 
        ]
    }, v49 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v50 = {
        "kind": "ClientExtension",
        "selections": [
            v49 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v51 = {
        "kind": "Variable",
        "name": "filterId",
        "variableName": "filterId"
    }, v52 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v53 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v54 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v55 = [
        {
            "kind": "Variable",
            "name": "context",
            "variableName": "fieldSetsContext"
        },
        v51 /*: any*/ ,
        v52 /*: any*/ ,
        v53 /*: any*/ ,
        v54 /*: any*/ 
    ], v56 = {
        "kind": "ScalarField",
        "name": "text"
    }, v57 = {
        "kind": "ScalarField",
        "name": "name"
    }, v58 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v59 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v60 = {
        "kind": "ScalarField",
        "name": "type"
    }, v61 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v62 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v57 /*: any*/ ,
                                    v38 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v64 = {
        "kind": "ScalarField",
        "name": "value"
    }, v65 = [
        v64 /*: any*/ ,
        v38 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v66 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v67 = {
        "kind": "ClientExtension",
        "selections": [
            v66 /*: any*/ 
        ]
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v65 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v65 /*: any*/ 
                    }
                ]
            },
            v67 /*: any*/ 
        ],
        "type": "JiraCascadingSelectField"
    }, v69 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v70 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v71 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v72 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "args": v69 /*: any*/ ,
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v70 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    v38 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            v67 /*: any*/ 
        ],
        "type": "JiraComponentsField"
    }, v73 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v74 = {
        "kind": "InlineFragment",
        "selections": [
            v73 /*: any*/ ,
            v57 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v75 = {
        "kind": "InlineFragment",
        "selections": [
            v56 /*: any*/ ,
            v57 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v76 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v77 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCommentSummary",
                "kind": "LinkedField",
                "name": "commentSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canAddComment"
                    },
                    v76 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCommentSummaryField"
    }, v78 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "uri"
            },
            v67 /*: any*/ 
        ],
        "type": "JiraUrlField"
    }, v79 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v38 /*: any*/ 
        ]
    }, v80 = [
        v79 /*: any*/ 
    ], v81 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v82 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    v76 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v64 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v80 /*: any*/ 
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v80 /*: any*/ 
                    },
                    v38 /*: any*/ ,
                    v81 /*: any*/ 
                ]
            },
            v67 /*: any*/ 
        ],
        "type": "JiraSingleSelectField"
    }, v83 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    v64 /*: any*/ ,
                                    v81 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v67 /*: any*/ 
        ],
        "type": "JiraMultipleSelectField"
    }, v84 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v38 /*: any*/ ,
            v64 /*: any*/ 
        ]
    }, v85 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            v84 /*: any*/ 
                        ]
                    }
                ]
            },
            v67 /*: any*/ 
        ],
        "type": "JiraCheckboxesField"
    }, v86 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v87 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v88 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v37 /*: any*/ ,
                                    v86 /*: any*/ ,
                                    v57 /*: any*/ ,
                                    v58 /*: any*/ ,
                                    v38 /*: any*/ ,
                                    v87 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v67 /*: any*/ 
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v89 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    }
                ]
            },
            v67 /*: any*/ 
        ],
        "type": "JiraTeamViewField"
    }, v90 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraTimeTrackingField",
                        "kind": "LinkedField",
                        "name": "timeTrackingField",
                        "plural": false,
                        "selections": [
                            v38 /*: any*/ ,
                            {
                                "concreteType": "JiraEstimate",
                                "kind": "LinkedField",
                                "name": "originalEstimate",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "timeInSeconds"
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraTimeTrackingSettings",
                                "kind": "LinkedField",
                                "name": "timeTrackingSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingHoursPerDay"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingDaysPerWeek"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultFormat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultUnit"
                                    }
                                ]
                            },
                            v42 /*: any*/ ,
                            v57 /*: any*/ ,
                            v60 /*: any*/ ,
                            v67 /*: any*/ 
                        ]
                    },
                    v38 /*: any*/ 
                ]
            }
        ],
        "type": "JiraOriginalTimeEstimateField"
    }, v91 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": [
                    {
                        "alias": "label",
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    v38 /*: any*/ ,
                    v70 /*: any*/ 
                ]
            },
            v67 /*: any*/ 
        ],
        "type": "JiraRadioSelectField"
    }, v92 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "args": v69 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    v57 /*: any*/ ,
                                    v70 /*: any*/ ,
                                    v71 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            },
            v67 /*: any*/ 
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v93 = [
        v38 /*: any*/ 
    ], v94 = {
        "kind": "ClientExtension",
        "selections": [
            v49 /*: any*/ 
        ]
    }, v95 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": v93 /*: any*/ 
            },
            {
                "args": v69 /*: any*/ ,
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    v39 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v94 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    v49 /*: any*/ ,
                    v66 /*: any*/ 
                ]
            }
        ],
        "type": "JiraGoalsField"
    }, v96 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "args": v69 /*: any*/ ,
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "href"
                                    }
                                ]
                            }
                        ]
                    },
                    v76 /*: any*/ 
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            },
            v67 /*: any*/ 
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    }, v97 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v68 /*: any*/ ,
            v72 /*: any*/ ,
            v74 /*: any*/ ,
            v75 /*: any*/ ,
            v77 /*: any*/ ,
            v78 /*: any*/ ,
            v82 /*: any*/ ,
            v83 /*: any*/ ,
            v85 /*: any*/ ,
            v88 /*: any*/ ,
            v89 /*: any*/ ,
            v90 /*: any*/ ,
            v91 /*: any*/ ,
            v92 /*: any*/ ,
            v95 /*: any*/ ,
            v96 /*: any*/ 
        ]
    }, v98 = {
        "kind": "ScalarField",
        "name": "message"
    }, v99 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v98 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v100 = [
        v57 /*: any*/ ,
        v38 /*: any*/ 
    ], v101 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "componentsOld",
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v100 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v102 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            v101 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v56 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v103 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v104 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v57 /*: any*/ ,
            v103 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v105 = {
        "kind": "InlineFragment",
        "selections": [
            v73 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v106 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v107 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v39 /*: any*/ ,
                    v106 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v38 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v108 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v109 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    v43 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v110 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v44 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v111 = [
        v57 /*: any*/ 
    ], v112 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v69 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v111 /*: any*/ 
                            }
                        ]
                    },
                    v76 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v57 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v113 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v59 /*: any*/ ,
                    v57 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v114 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v56 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v115 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v79 /*: any*/ ,
            v38 /*: any*/ 
        ]
    }, v116 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v117 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v116 /*: any*/ ,
                    v57 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            },
            v38 /*: any*/ 
        ]
    }, v118 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v119 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v39 /*: any*/ ,
                    v114 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v39 /*: any*/ ,
                            v115 /*: any*/ ,
                            v117 /*: any*/ ,
                            v114 /*: any*/ ,
                            v38 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v39 /*: any*/ ,
                            v115 /*: any*/ ,
                            v117 /*: any*/ ,
                            v114 /*: any*/ ,
                            v38 /*: any*/ ,
                            v40 /*: any*/ ,
                            v118 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v37 /*: any*/ ,
                                                    v38 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v42 /*: any*/ ,
                                                            v56 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v42 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v57 /*: any*/ ,
                                                                    v116 /*: any*/ ,
                                                                    v47 /*: any*/ ,
                                                                    v38 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v45 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v57 /*: any*/ ,
                    v67 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v120 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v121 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    v120 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            },
            v57 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v122 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    v39 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v38 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v123 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v100 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v124 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v125 = {
        "kind": "ScalarField",
        "name": "state"
    }, v126 = {
        "kind": "ScalarField",
        "name": "endDate"
    }, v127 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    v124 /*: any*/ ,
                                    v57 /*: any*/ ,
                                    v125 /*: any*/ ,
                                    v126 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v57 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v128 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    v86 /*: any*/ ,
                    v58 /*: any*/ ,
                    v57 /*: any*/ ,
                    v38 /*: any*/ ,
                    v87 /*: any*/ 
                ]
            },
            v57 /*: any*/ ,
            v103 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v129 = {
        "kind": "InlineFragment",
        "selections": [
            v57 /*: any*/ ,
            {
                "args": v69 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v100 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v130 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v131 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v57 /*: any*/ ,
                    v116 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v132 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v76 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v118 /*: any*/ ,
                                            v39 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v37 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v44 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v38 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v38 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v38 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v133 = {
        "kind": "ScalarField",
        "name": "number"
    }, v134 = [
        v133 /*: any*/ 
    ], v135 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v133 /*: any*/ ,
            v57 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": v134 /*: any*/ 
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v133 /*: any*/ ,
                    v57 /*: any*/ ,
                    v67 /*: any*/ 
                ]
            },
            v67 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v136 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v60 /*: any*/ ,
                        v61 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v37 /*: any*/ ,
                                                v42 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                v62 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v63 /*: any*/ ,
                                                v97 /*: any*/ ,
                                                v99 /*: any*/ ,
                                                v102 /*: any*/ ,
                                                v104 /*: any*/ ,
                                                v105 /*: any*/ ,
                                                v107 /*: any*/ ,
                                                v108 /*: any*/ ,
                                                v75 /*: any*/ ,
                                                v109 /*: any*/ ,
                                                v110 /*: any*/ ,
                                                v112 /*: any*/ ,
                                                v113 /*: any*/ ,
                                                v119 /*: any*/ ,
                                                v121 /*: any*/ ,
                                                v122 /*: any*/ ,
                                                v123 /*: any*/ ,
                                                v127 /*: any*/ ,
                                                v128 /*: any*/ ,
                                                v129 /*: any*/ ,
                                                v130 /*: any*/ ,
                                                v131 /*: any*/ ,
                                                v132 /*: any*/ ,
                                                v135 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v137 = {
        "condition": "shouldQueryFieldSetsById",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "fieldSetIds",
                        "variableName": "fieldSetIds"
                    },
                    v52 /*: any*/ 
                ],
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsById",
                "plural": false,
                "selections": v136 /*: any*/ 
            }
        ]
    }, v138 = {
        "kind": "InlineFragment",
        "selections": [
            v60 /*: any*/ ,
            v67 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v139 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            v38 /*: any*/ ,
            v39 /*: any*/ ,
            v40 /*: any*/ ,
            v41 /*: any*/ ,
            v46 /*: any*/ ,
            v48 /*: any*/ ,
            v50 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "args": v55 /*: any*/ ,
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSetsForIssueSearchView",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldSet",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fields",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v37 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v42 /*: any*/ ,
                                                                            v56 /*: any*/ ,
                                                                            v57 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraSingleLineTextField"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v42 /*: any*/ ,
                                                                            v57 /*: any*/ ,
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "user",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v37 /*: any*/ ,
                                                                                    v57 /*: any*/ ,
                                                                                    v58 /*: any*/ ,
                                                                                    v38 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v42 /*: any*/ ,
                                                                            {
                                                                                "concreteType": "JiraIssueType",
                                                                                "kind": "LinkedField",
                                                                                "name": "issueType",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v57 /*: any*/ ,
                                                                                    v59 /*: any*/ ,
                                                                                    v38 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ],
                                                                        "type": "JiraIssueTypeField"
                                                                    },
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v42 /*: any*/ ,
                                                                            v44 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v38 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v137 /*: any*/ ,
                    {
                        "condition": "shouldQueryFieldSetsById",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": v55 /*: any*/ ,
                                "concreteType": "JiraIssueFieldSetConnection",
                                "kind": "LinkedField",
                                "name": "fieldSetsForIssueSearchView",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldSetEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldSet",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v60 /*: any*/ ,
                                                    v61 /*: any*/ ,
                                                    {
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fields",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v42 /*: any*/ ,
                                                                            v60 /*: any*/ ,
                                                                            v62 /*: any*/ ,
                                                                            v63 /*: any*/ ,
                                                                            {
                                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    v68 /*: any*/ ,
                                                                                    v72 /*: any*/ ,
                                                                                    v74 /*: any*/ ,
                                                                                    v138 /*: any*/ ,
                                                                                    v77 /*: any*/ ,
                                                                                    v78 /*: any*/ ,
                                                                                    v82 /*: any*/ ,
                                                                                    v83 /*: any*/ ,
                                                                                    v85 /*: any*/ ,
                                                                                    v88 /*: any*/ ,
                                                                                    v89 /*: any*/ ,
                                                                                    v90 /*: any*/ ,
                                                                                    v91 /*: any*/ ,
                                                                                    v92 /*: any*/ ,
                                                                                    v95 /*: any*/ ,
                                                                                    v96 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v99 /*: any*/ ,
                                                                            {
                                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                "kind": "Condition",
                                                                                "passingValue": false,
                                                                                "selections": [
                                                                                    v101 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v104 /*: any*/ ,
                                                                            v105 /*: any*/ ,
                                                                            v107 /*: any*/ ,
                                                                            v108 /*: any*/ ,
                                                                            v138 /*: any*/ ,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraStatusCategory",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "statusCategory",
                                                                                        "plural": false,
                                                                                        "selections": v111 /*: any*/ 
                                                                                    }
                                                                                ],
                                                                                "type": "JiraStatusCategoryField"
                                                                            },
                                                                            v110 /*: any*/ ,
                                                                            v112 /*: any*/ ,
                                                                            v119 /*: any*/ ,
                                                                            v121 /*: any*/ ,
                                                                            v122 /*: any*/ ,
                                                                            v123 /*: any*/ ,
                                                                            v127 /*: any*/ ,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v60 /*: any*/ ,
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "user",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v86 /*: any*/ ,
                                                                                            v87 /*: any*/ 
                                                                                        ]
                                                                                    },
                                                                                    v103 /*: any*/ ,
                                                                                    v67 /*: any*/ 
                                                                                ],
                                                                                "type": "JiraSingleSelectUserPickerField"
                                                                            },
                                                                            v129 /*: any*/ ,
                                                                            v130 /*: any*/ ,
                                                                            v131 /*: any*/ ,
                                                                            v132 /*: any*/ ,
                                                                            v135 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v106 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v59 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v140 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v141 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": v140 /*: any*/ ,
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v60 /*: any*/ ,
                                    v61 /*: any*/ ,
                                    {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v37 /*: any*/ ,
                                                            v42 /*: any*/ ,
                                                            v60 /*: any*/ ,
                                                            v62 /*: any*/ ,
                                                            v38 /*: any*/ ,
                                                            v63 /*: any*/ ,
                                                            v97 /*: any*/ ,
                                                            v99 /*: any*/ ,
                                                            v102 /*: any*/ ,
                                                            v104 /*: any*/ ,
                                                            v105 /*: any*/ ,
                                                            v107 /*: any*/ ,
                                                            v108 /*: any*/ ,
                                                            v75 /*: any*/ ,
                                                            v109 /*: any*/ ,
                                                            v110 /*: any*/ ,
                                                            v112 /*: any*/ ,
                                                            v113 /*: any*/ ,
                                                            v119 /*: any*/ ,
                                                            v121 /*: any*/ ,
                                                            v122 /*: any*/ ,
                                                            v123 /*: any*/ ,
                                                            v127 /*: any*/ ,
                                                            v128 /*: any*/ ,
                                                            v129 /*: any*/ ,
                                                            v130 /*: any*/ ,
                                                            v131 /*: any*/ ,
                                                            v132 /*: any*/ ,
                                                            v135 /*: any*/ ,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOptionConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "selectedOptions",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraOptionEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v84 /*: any*/ ,
                                                                                    v94 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraCheckboxesField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOption",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v81 /*: any*/ ,
                                                                            v38 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraSingleSelectField"
                                                            },
                                                            v94 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "fieldSets(first:500)"
            }
        ]
    }, v142 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v143 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v144 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v142 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            v143 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            }
        ]
    }, v145 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "firstIssuePosition"
            },
            {
                "kind": "ScalarField",
                "name": "lastIssuePosition"
            }
        ]
    }, v146 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v147 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v148 = [
        v146 /*: any*/ ,
        v36 /*: any*/ ,
        v147 /*: any*/ 
    ], v149 = {
        "args": [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ],
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v148 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v148 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": [
                    v36 /*: any*/ ,
                    v146 /*: any*/ ,
                    v147 /*: any*/ 
                ]
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v150 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v151 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v98 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ],
                "type": "JiraInvalidSyntaxError"
            }
        ]
    }, v152 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v153 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v154 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "args": v140 /*: any*/ ,
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSets",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldSet",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fields",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v42 /*: any*/ ,
                                                                    v37 /*: any*/ ,
                                                                    v60 /*: any*/ ,
                                                                    v38 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "fieldSets(first:500)"
                    }
                ]
            }
        ]
    }, v155 = [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                v36 /*: any*/ ,
                v139 /*: any*/ ,
                v37 /*: any*/ ,
                {
                    "condition": "shouldQueryHasChildren",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "filterByProjectKeys",
                                    "variableName": "projectKeys"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "hasChildren"
                        },
                        {
                            "args": [
                                v24 /*: any*/ 
                            ],
                            "kind": "ScalarField",
                            "name": "canHaveChildIssues"
                        }
                    ]
                },
                v94 /*: any*/ ,
                v141 /*: any*/ 
            ]
        },
        v144 /*: any*/ ,
        v145 /*: any*/ ,
        v149 /*: any*/ ,
        v150 /*: any*/ ,
        v151 /*: any*/ ,
        v152 /*: any*/ ,
        v153 /*: any*/ ,
        v94 /*: any*/ ,
        v154 /*: any*/ 
    ], v156 = [
        "issueSearchInput"
    ], v157 = {
        "kind": "ScalarField",
        "name": "viewId"
    }, v158 = {
        "kind": "Variable",
        "name": "staticViewInput",
        "variableName": "staticViewInput"
    }, v159 = [
        v158 /*: any*/ 
    ], v160 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v161 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v162 = {
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v163 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        v52 /*: any*/ 
    ], v164 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v165 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v166 = {
        "kind": "ScalarField",
        "name": "isSortable"
    }, v167 = {
        "concreteType": "JiraFieldSetPreferences",
        "kind": "LinkedField",
        "name": "fieldSetPreferences",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    }, v168 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isPlaceHolderField"
            }
        ]
    }, v169 = {
        "concreteType": "JiraFieldType",
        "kind": "LinkedField",
        "name": "fieldType",
        "plural": false,
        "selections": [
            v164 /*: any*/ 
        ]
    }, v170 = {
        "args": v159 /*: any*/ ,
        "concreteType": "JiraIssueSearchViewConfigSettings",
        "kind": "LinkedField",
        "name": "viewConfigSettings",
        "plural": false,
        "selections": [
            v161 /*: any*/ 
        ]
    }, v171 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v172 = {
        "kind": "Variable",
        "name": "groupBy",
        "variableName": "groupBy"
    }, v173 = [
        v172 /*: any*/ ,
        v30 /*: any*/ ,
        v158 /*: any*/ 
    ], v174 = {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraField",
                "kind": "LinkedField",
                "name": "groupByField",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    v38 /*: any*/ 
                ]
            }
        ]
    }, v175 = {
        "kind": "ScalarField",
        "name": "isGroupingEnabled"
    }, v176 = {
        "kind": "ScalarField",
        "name": "canEnableGrouping"
    }, v177 = [
        v160 /*: any*/ ,
        v171 /*: any*/ ,
        v175 /*: any*/ ,
        v176 /*: any*/ 
    ], v178 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v173 /*: any*/ ,
                "concreteType": "JiraIssueSearchViewConfigSettings",
                "kind": "LinkedField",
                "name": "viewSettings",
                "plural": false,
                "selections": v177 /*: any*/ 
            }
        ],
        "type": "JiraSpreadsheetView",
        "abstractKey": "__isJiraSpreadsheetView"
    }, v179 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v37 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ]
    }, v180 = [
        v179 /*: any*/ ,
        v98 /*: any*/ 
    ], v181 = [
        v25 /*: any*/ ,
        v26 /*: any*/ ,
        v28 /*: any*/ ,
        v29 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ ,
        v33 /*: any*/ 
    ], v182 = [
        v25 /*: any*/ ,
        v26 /*: any*/ ,
        v29 /*: any*/ ,
        v172 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        v33 /*: any*/ 
    ], v183 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v184 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v37 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "priorityId"
                            },
                            v38 /*: any*/ ,
                            v120 /*: any*/ ,
                            v57 /*: any*/ 
                        ]
                    },
                    v164 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v37 /*: any*/ ,
                            v86 /*: any*/ ,
                            v38 /*: any*/ ,
                            v58 /*: any*/ ,
                            v57 /*: any*/ 
                        ]
                    },
                    v164 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v38 /*: any*/ ,
                            v57 /*: any*/ ,
                            {
                                "concreteType": "JiraStatusCategory",
                                "kind": "LinkedField",
                                "name": "statusCategory",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    v43 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v164 /*: any*/ ,
                    v44 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": v134 /*: any*/ ,
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v81 /*: any*/ ,
                            v38 /*: any*/ ,
                            v79 /*: any*/ ,
                            v64 /*: any*/ 
                        ]
                    },
                    v164 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": [
                            v124 /*: any*/ ,
                            v38 /*: any*/ ,
                            v125 /*: any*/ ,
                            v57 /*: any*/ ,
                            v126 /*: any*/ 
                        ]
                    },
                    v164 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v38 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            }
                        ]
                    },
                    v164 /*: any*/ 
                ],
                "type": "JiraJqlGoalsFieldValue"
            }
        ]
    }, v185 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v186 = [
        v28 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v187 = [
        v25 /*: any*/ ,
        v26 /*: any*/ ,
        v28 /*: any*/ ,
        v29 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ ,
        v33 /*: any*/ ,
        v34 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v24 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_refetchQueryNew"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v35 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issueSearch",
                                    "plural": false,
                                    "selections": v155 /*: any*/ 
                                },
                                {
                                    "args": v35 /*: any*/ ,
                                    "filters": v156 /*: any*/ ,
                                    "handle": "connection",
                                    "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                                    "kind": "LinkedHandle",
                                    "name": "issueSearch"
                                },
                                {
                                    "args": [
                                        v27 /*: any*/ ,
                                        v51 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v53 /*: any*/ ,
                                        v54 /*: any*/ 
                                    ],
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewResult",
                                    "plural": false,
                                    "selections": [
                                        v37 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraIssueSearchViewResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v157 /*: any*/ ,
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": v159 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewConfigSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v160 /*: any*/ ,
                                                                v161 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        v162 /*: any*/ ,
                                                        {
                                                            "args": v163 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                v76 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v61 /*: any*/ ,
                                                                                v60 /*: any*/ ,
                                                                                v164 /*: any*/ ,
                                                                                v165 /*: any*/ ,
                                                                                v166 /*: any*/ ,
                                                                                v167 /*: any*/ ,
                                                                                v168 /*: any*/ ,
                                                                                v169 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v94 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v170 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "args": v159 /*: any*/ ,
                                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "viewConfigSettings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v171 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssueSearchView"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v173 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v171 /*: any*/ ,
                                                                        v174 /*: any*/ ,
                                                                        v160 /*: any*/ ,
                                                                        v161 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSpreadsheetView",
                                                            "abstractKey": "__isJiraSpreadsheetView"
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                                },
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": v159 /*: any*/ ,
                                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "viewConfigSettings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v171 /*: any*/ ,
                                                                                v175 /*: any*/ ,
                                                                                v176 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JiraIssueSearchView"
                                                                },
                                                                v178 /*: any*/ 
                                                            ]
                                                        },
                                                        v94 /*: any*/ 
                                                    ],
                                                    "type": "JiraIssueSearchViewMetadata",
                                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                }
                                            ],
                                            "type": "JiraIssueSearchView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v98 /*: any*/ ,
                                                v179 /*: any*/ 
                                            ],
                                            "type": "QueryError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v93 /*: any*/ ,
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        v27 /*: any*/ ,
                                        v51 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v53 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "viewConfigInput",
                                            "variableName": "staticViewInput"
                                        },
                                        v54 /*: any*/ 
                                    ],
                                    "kind": "LinkedField",
                                    "name": "jiraIssueSearchView",
                                    "plural": false,
                                    "selections": [
                                        v37 /*: any*/ ,
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraView"
                                        },
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "error",
                                            "plural": false,
                                            "selections": v180 /*: any*/ 
                                        },
                                        v38 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v157 /*: any*/ ,
                                                {
                                                    "args": v163 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v61 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraIssueSearchViewMetadata",
                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v173 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                    "kind": "LinkedField",
                                                    "name": "viewSettings",
                                                    "plural": false,
                                                    "selections": [
                                                        v175 /*: any*/ ,
                                                        v176 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroupByConfig",
                                                            "kind": "LinkedField",
                                                            "name": "groupByConfig",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraField",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v42 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v57 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "typeKey"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v160 /*: any*/ ,
                                                        v161 /*: any*/ 
                                                    ]
                                                },
                                                v152 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v162 /*: any*/ ,
                                                        {
                                                            "args": v163 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSets",
                                                            "plural": false,
                                                            "selections": [
                                                                v76 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v60 /*: any*/ ,
                                                                                v164 /*: any*/ ,
                                                                                v165 /*: any*/ ,
                                                                                v166 /*: any*/ ,
                                                                                v167 /*: any*/ ,
                                                                                v169 /*: any*/ ,
                                                                                v168 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v94 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "args": v159 /*: any*/ ,
                                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "viewConfigSettings",
                                                                            "plural": false,
                                                                            "selections": v177 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "JiraIssueSearchView"
                                                                },
                                                                v178 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v170 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "args": v159 /*: any*/ ,
                                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                            "kind": "LinkedField",
                                                                            "name": "viewConfigSettings",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v160 /*: any*/ ,
                                                                                v171 /*: any*/ ,
                                                                                v161 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssueSearchView"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v173 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v161 /*: any*/ ,
                                                                        v171 /*: any*/ ,
                                                                        v174 /*: any*/ ,
                                                                        v160 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSpreadsheetView",
                                                            "abstractKey": "__isJiraSpreadsheetView"
                                                        },
                                                        v94 /*: any*/ 
                                                    ],
                                                    "type": "JiraIssueSearchViewMetadata",
                                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                }
                                            ],
                                            "type": "JiraSpreadsheetView",
                                            "abstractKey": "__isJiraSpreadsheetView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v181 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v139 /*: any*/ ,
                                                                v37 /*: any*/ ,
                                                                v94 /*: any*/ ,
                                                                v141 /*: any*/ 
                                                            ]
                                                        },
                                                        v144 /*: any*/ ,
                                                        v145 /*: any*/ ,
                                                        v149 /*: any*/ ,
                                                        v150 /*: any*/ ,
                                                        v151 /*: any*/ ,
                                                        v152 /*: any*/ ,
                                                        v153 /*: any*/ ,
                                                        v94 /*: any*/ ,
                                                        v154 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": v181 /*: any*/ ,
                                                    "filters": v156 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorDetailedViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ],
                                            "type": "JiraDetailedView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v182 /*: any*/ ,
                                                    "concreteType": "JiraSpreadsheetGroupConnection",
                                                    "kind": "LinkedField",
                                                    "name": "groups",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroupEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v37 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v152 /*: any*/ ,
                                                                        v42 /*: any*/ ,
                                                                        v183 /*: any*/ ,
                                                                        v184 /*: any*/ ,
                                                                        v185 /*: any*/ 
                                                                    ]
                                                                },
                                                                v37 /*: any*/ 
                                                            ]
                                                        },
                                                        v144 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "groupByField"
                                                        },
                                                        v152 /*: any*/ ,
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": v180 /*: any*/ 
                                                        },
                                                        {
                                                            "condition": "isPaginating",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroup",
                                                                    "kind": "LinkedField",
                                                                    "name": "firstGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        v152 /*: any*/ ,
                                                                        v184 /*: any*/ ,
                                                                        v183 /*: any*/ ,
                                                                        v185 /*: any*/ ,
                                                                        {
                                                                            "args": v186 /*: any*/ ,
                                                                            "concreteType": "JiraIssueConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "issues",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v37 /*: any*/ ,
                                                                                        v36 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssue",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                v39 /*: any*/ ,
                                                                                                v40 /*: any*/ ,
                                                                                                v41 /*: any*/ ,
                                                                                                v46 /*: any*/ ,
                                                                                                v48 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        v137 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "shouldQueryFieldSetsById",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "args": v55 /*: any*/ ,
                                                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldSetsForIssueSearchView",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v136 /*: any*/ 
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v94 /*: any*/ ,
                                                                                        {
                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v140 /*: any*/ ,
                                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldSets",
                                                                                                    "plural": false,
                                                                                                    "selections": v136 /*: any*/ ,
                                                                                                    "storageKey": "fieldSets(first:500)"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v150 /*: any*/ ,
                                                                                v153 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "PageInfo",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "pageInfo",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v142 /*: any*/ ,
                                                                                        v143 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v94 /*: any*/ ,
                                                                                v154 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": v186 /*: any*/ ,
                                                                            "filters": [
                                                                                "fieldSetsInput"
                                                                            ],
                                                                            "handle": "connection",
                                                                            "key": "firstGroupSection_nativeIssueTable__issues",
                                                                            "kind": "LinkedHandle",
                                                                            "name": "issues"
                                                                        },
                                                                        v42 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v94 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": v182 /*: any*/ ,
                                                    "filters": v156 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorGroupedListViewPagination__groups",
                                                    "kind": "LinkedHandle",
                                                    "name": "groups"
                                                }
                                            ],
                                            "type": "JiraGroupedListView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v187 /*: any*/ ,
                                                    "concreteType": "JiraIssueConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issues",
                                                    "plural": false,
                                                    "selections": v155 /*: any*/ 
                                                },
                                                {
                                                    "args": v187 /*: any*/ ,
                                                    "filters": v156 /*: any*/ ,
                                                    "handle": "connection",
                                                    "key": "IssueNavigatorListViewPagination__issues",
                                                    "kind": "LinkedHandle",
                                                    "name": "issues"
                                                }
                                            ],
                                            "type": "JiraListView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c87dc483b646067310ffb71a20f2a44bc95f5eac4ea747c3f0a2c40f77ba4dfd",
            "metadata": {},
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "isRefactorNinToViewSchemaEnabled": (0, $1q6lK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider": (0, $1q6lK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$a2b7fdc33d59789a$var$node.hash = "df75ebbabf681ee8b6dc5d51605996ca";
var $a2b7fdc33d59789a$export$2e2bcd8739ae039 = $a2b7fdc33d59789a$var$node;

});


parcelRegister("ln32M", function(module, exports) {

$parcel$export(module.exports, "default", () => $361a37bcf594286c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<84a204d4b1511bfb09017e0595935430>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $2CtcG = parcelRequire("2CtcG");
const $361a37bcf594286c$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "staticViewInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $2CtcG.default)
            }
        },
        "name": "main_issueNavigator_IssueNavigator_refetchQueryOld",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "after",
                                "variableName": "after"
                            },
                            {
                                "kind": "Variable",
                                "name": "before",
                                "variableName": "before"
                            },
                            v0 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "fieldSetsInput",
                                "variableName": "fieldSetsInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "first",
                                "variableName": "first"
                            },
                            v1 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "last",
                                "variableName": "last"
                            },
                            {
                                "kind": "Variable",
                                "name": "options",
                                "variableName": "options"
                            }
                        ],
                        "concreteType": "JiraIssueConnection",
                        "kind": "LinkedField",
                        "name": "issueSearchStable",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_issueResults"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "selectedIssueStateOld_issueNavigator_SelectedIssueContainer"
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "shouldQueryHasChildren",
                                        "value": false
                                    }
                                ],
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                            }
                        ]
                    },
                    {
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "filterId",
                                "variableName": "filterId"
                            },
                            v1 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "namespace",
                                "variableName": "namespace"
                            },
                            {
                                "kind": "Variable",
                                "name": "viewId",
                                "variableName": "viewId"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "issueSearchViewResult",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_view"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "selectedView_issueNavigator_SelectedViewContainer_issueSearchView"
                                    }
                                ],
                                "type": "JiraIssueSearchView"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigatorUI_viewResult"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$361a37bcf594286c$var$node.hash = "6872de214f3b36a519a609d3c1bec106";
var $361a37bcf594286c$export$2e2bcd8739ae039 = $361a37bcf594286c$var$node;

});
parcelRegister("2CtcG", function(module, exports) {

$parcel$export(module.exports, "default", () => $894e01c189a8309f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c3a443fa84e5cb4d4cf60a899f06941>>
 * @relayHash 0a5cc0d49d6d5b2276e2f16b45ab58ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8721b64465460289d4a0dcc39018a0e89905bc357c6a331f9785ecbfdba3455d

var $bqIzm = parcelRequire("bqIzm");

var $5oQtH = parcelRequire("5oQtH");

var $k3PJZ = parcelRequire("k3PJZ");

var $5qm7M = parcelRequire("5qm7M");

var $dttgK = parcelRequire("dttgK");

var $hBvdF = parcelRequire("hBvdF");
const $894e01c189a8309f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v17 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v18 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v19 = {
        "kind": "ScalarField",
        "name": "key"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v22 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v23 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v24 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v25 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v23 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v25 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v27 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v29 = {
        "kind": "Variable",
        "name": "filterId",
        "variableName": "filterId"
    }, v30 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v31 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v32 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v33 = [
        {
            "kind": "Variable",
            "name": "context",
            "variableName": "fieldSetsContext"
        },
        v29 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        v32 /*: any*/ 
    ], v34 = {
        "kind": "ScalarField",
        "name": "text"
    }, v35 = {
        "kind": "ScalarField",
        "name": "name"
    }, v36 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v37 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v38 = {
        "kind": "ScalarField",
        "name": "type"
    }, v39 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v40 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v35 /*: any*/ ,
                                    v20 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v42 = {
        "kind": "ScalarField",
        "name": "value"
    }, v43 = [
        v42 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v45 = {
        "kind": "ClientExtension",
        "selections": [
            v44 /*: any*/ 
        ]
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "concreteType": "JiraCascadingOption",
                "kind": "LinkedField",
                "name": "cascadingOption",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "parentOptionValue",
                        "plural": false,
                        "selections": v43 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "childOptionValue",
                        "plural": false,
                        "selections": v43 /*: any*/ 
                    }
                ]
            },
            v45 /*: any*/ 
        ],
        "type": "JiraCascadingSelectField"
    }, v47 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v48 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v49 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v50 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "args": v47 /*: any*/ ,
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v48 /*: any*/ ,
                                    v49 /*: any*/ ,
                                    v20 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedComponentsConnection(first:1000)"
            },
            v45 /*: any*/ 
        ],
        "type": "JiraComponentsField"
    }, v51 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            v51 /*: any*/ ,
            v35 /*: any*/ ,
            v45 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v53 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ ,
            v35 /*: any*/ ,
            v45 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v54 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v55 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCommentSummary",
                "kind": "LinkedField",
                "name": "commentSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canAddComment"
                    },
                    v54 /*: any*/ 
                ]
            }
        ],
        "type": "JiraCommentSummaryField"
    }, v56 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "uri"
            },
            v45 /*: any*/ 
        ],
        "type": "JiraUrlField"
    }, v57 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v20 /*: any*/ 
        ]
    }, v58 = [
        v57 /*: any*/ 
    ], v59 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                    v54 /*: any*/ 
                ]
            },
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "fieldOption",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v58 /*: any*/ 
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v58 /*: any*/ 
                    },
                    v20 /*: any*/ ,
                    v59 /*: any*/ 
                ]
            },
            v45 /*: any*/ 
        ],
        "type": "JiraSingleSelectField"
    }, v61 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    v42 /*: any*/ ,
                                    v59 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            },
            v45 /*: any*/ 
        ],
        "type": "JiraMultipleSelectField"
    }, v62 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v42 /*: any*/ 
        ]
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "selectedOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            v62 /*: any*/ 
                        ]
                    }
                ]
            },
            v45 /*: any*/ 
        ],
        "type": "JiraCheckboxesField"
    }, v64 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v65 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v66 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "selectedUsersConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v22 /*: any*/ ,
                                    v64 /*: any*/ ,
                                    v35 /*: any*/ ,
                                    v36 /*: any*/ ,
                                    v20 /*: any*/ ,
                                    v65 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "email"
                                            }
                                        ],
                                        "type": "AtlassianAccountUser"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v45 /*: any*/ 
        ],
        "type": "JiraMultipleSelectUserPickerField"
    }, v67 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "concreteType": "JiraTeamView",
                "kind": "LinkedField",
                "name": "selectedTeam",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraSuppliedName"
                    }
                ]
            },
            v45 /*: any*/ 
        ],
        "type": "JiraTeamViewField"
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraTimeTrackingField",
                        "kind": "LinkedField",
                        "name": "timeTrackingField",
                        "plural": false,
                        "selections": [
                            v20 /*: any*/ ,
                            {
                                "concreteType": "JiraEstimate",
                                "kind": "LinkedField",
                                "name": "originalEstimate",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "timeInSeconds"
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraTimeTrackingSettings",
                                "kind": "LinkedField",
                                "name": "timeTrackingSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingHoursPerDay"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "workingDaysPerWeek"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultFormat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "defaultUnit"
                                    }
                                ]
                            },
                            v23 /*: any*/ ,
                            v35 /*: any*/ ,
                            v38 /*: any*/ ,
                            v45 /*: any*/ 
                        ]
                    },
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraOriginalTimeEstimateField"
    }, v69 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "concreteType": "JiraOption",
                "kind": "LinkedField",
                "name": "selectedOption",
                "plural": false,
                "selections": [
                    {
                        "alias": "label",
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    v20 /*: any*/ ,
                    v48 /*: any*/ 
                ]
            },
            v45 /*: any*/ 
        ],
        "type": "JiraRadioSelectField"
    }, v70 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "args": v47 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    v35 /*: any*/ ,
                                    v48 /*: any*/ ,
                                    v49 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "versionId"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            },
            v45 /*: any*/ 
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v71 = [
        v20 /*: any*/ 
    ], v72 = {
        "kind": "ClientExtension",
        "selections": [
            v28 /*: any*/ 
        ]
    }, v73 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": v71 /*: any*/ 
            },
            {
                "args": v47 /*: any*/ ,
                "concreteType": "JiraGoalConnection",
                "kind": "LinkedField",
                "name": "selectedGoals",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraGoal",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    v19 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v72 /*: any*/ 
                ],
                "storageKey": "selectedGoals(first:1000)"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    v28 /*: any*/ ,
                    v44 /*: any*/ 
                ]
            }
        ],
        "type": "JiraGoalsField"
    }, v74 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "args": v47 /*: any*/ ,
                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                "kind": "LinkedField",
                "name": "confluenceRemoteIssueLinks",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "href"
                                    }
                                ]
                            }
                        ]
                    },
                    v54 /*: any*/ 
                ],
                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
            },
            v45 /*: any*/ 
        ],
        "type": "JiraConfluenceRemoteIssueLinksField"
    }, v75 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v46 /*: any*/ ,
            v50 /*: any*/ ,
            v52 /*: any*/ ,
            v53 /*: any*/ ,
            v55 /*: any*/ ,
            v56 /*: any*/ ,
            v60 /*: any*/ ,
            v61 /*: any*/ ,
            v63 /*: any*/ ,
            v66 /*: any*/ ,
            v67 /*: any*/ ,
            v68 /*: any*/ ,
            v69 /*: any*/ ,
            v70 /*: any*/ ,
            v73 /*: any*/ ,
            v74 /*: any*/ 
        ]
    }, v76 = {
        "kind": "ScalarField",
        "name": "message"
    }, v77 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v76 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v78 = [
        v35 /*: any*/ ,
        v20 /*: any*/ 
    ], v79 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "componentsOld",
                "concreteType": "JiraComponentConnection",
                "kind": "LinkedField",
                "name": "selectedComponentsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraComponentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraComponent",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v78 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraComponentsField"
    }, v80 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            v79 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v34 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v81 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v82 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v35 /*: any*/ ,
            v81 /*: any*/ ,
            v45 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v83 = {
        "kind": "InlineFragment",
        "selections": [
            v51 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v84 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v85 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    v84 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v86 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v87 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v35 /*: any*/ ,
                    v24 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v88 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v35 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v25 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v89 = [
        v35 /*: any*/ 
    ], v90 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v47 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v89 /*: any*/ 
                            }
                        ]
                    },
                    v54 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v35 /*: any*/ ,
            v45 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v91 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    v35 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v92 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v93 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v57 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v94 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v95 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v94 /*: any*/ ,
                    v35 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            },
            v20 /*: any*/ 
        ]
    }, v96 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v97 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    v92 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v93 /*: any*/ ,
                            v95 /*: any*/ ,
                            v92 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v93 /*: any*/ ,
                            v95 /*: any*/ ,
                            v92 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v96 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v22 /*: any*/ ,
                                                    v20 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v23 /*: any*/ ,
                                                            v34 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v23 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v35 /*: any*/ ,
                                                                    v94 /*: any*/ ,
                                                                    v27 /*: any*/ ,
                                                                    v20 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v26 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v35 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v98 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v35 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v20 /*: any*/ 
                ]
            },
            v35 /*: any*/ ,
            v45 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v99 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v35 /*: any*/ ,
                    v19 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v100 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v78 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v101 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v35 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v35 /*: any*/ ,
            v45 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v102 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v22 /*: any*/ ,
                    v64 /*: any*/ ,
                    v36 /*: any*/ ,
                    v35 /*: any*/ ,
                    v20 /*: any*/ ,
                    v65 /*: any*/ 
                ]
            },
            v35 /*: any*/ ,
            v81 /*: any*/ ,
            v45 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v103 = {
        "kind": "InlineFragment",
        "selections": [
            v35 /*: any*/ ,
            {
                "args": v47 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v78 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v104 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v105 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v35 /*: any*/ ,
                    v94 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v54 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v96 /*: any*/ ,
                                            v19 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v22 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v25 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v20 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v20 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v20 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v107 = {
        "kind": "ScalarField",
        "name": "number"
    }, v108 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v107 /*: any*/ ,
            v35 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v107 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v107 /*: any*/ ,
                    v35 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            },
            v45 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v109 = {
        "kind": "InlineFragment",
        "selections": [
            v38 /*: any*/ ,
            v45 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v110 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v111 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v112 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v113 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v114 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        v30 /*: any*/ 
    ], v115 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v116 = {
        "kind": "Variable",
        "name": "staticViewInput",
        "variableName": "staticViewInput"
    }, v117 = [
        v116 /*: any*/ 
    ], v118 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v119 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v120 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v121 = [
        {
            "kind": "Variable",
            "name": "groupBy",
            "variableName": "groupBy"
        },
        v18 /*: any*/ ,
        v116 /*: any*/ 
    ], v122 = {
        "kind": "ScalarField",
        "name": "isGroupingEnabled"
    }, v123 = {
        "kind": "ScalarField",
        "name": "canEnableGrouping"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorResultsRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_refetchQueryOld"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorResultsRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "after",
                                    "variableName": "after"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "before",
                                    "variableName": "before"
                                },
                                v17 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                v18 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "options",
                                    "variableName": "options"
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isResolved"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "status"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                },
                                                {
                                                    "concreteType": "JiraIssueTypeField",
                                                    "kind": "LinkedField",
                                                    "name": "issueTypeField",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v20 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isHighlightedIssueRow"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "args": v33 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldSetsForIssueSearchView",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSet",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fields",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v22 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v34 /*: any*/ ,
                                                                                                                v35 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v35 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "user",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v36 /*: any*/ ,
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectUserPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueType",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issueType",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v20 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraIssueTypeField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v25 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraStatusCategoryField"
                                                                                                        },
                                                                                                        v20 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "fieldSetIds",
                                                                            "variableName": "fieldSetIds"
                                                                        },
                                                                        v30 /*: any*/ 
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v38 /*: any*/ ,
                                                                                        v39 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fields",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                v23 /*: any*/ ,
                                                                                                                v38 /*: any*/ ,
                                                                                                                v40 /*: any*/ ,
                                                                                                                v20 /*: any*/ ,
                                                                                                                v41 /*: any*/ ,
                                                                                                                v75 /*: any*/ ,
                                                                                                                v77 /*: any*/ ,
                                                                                                                v80 /*: any*/ ,
                                                                                                                v82 /*: any*/ ,
                                                                                                                v83 /*: any*/ ,
                                                                                                                v85 /*: any*/ ,
                                                                                                                v86 /*: any*/ ,
                                                                                                                v53 /*: any*/ ,
                                                                                                                v87 /*: any*/ ,
                                                                                                                v88 /*: any*/ ,
                                                                                                                v90 /*: any*/ ,
                                                                                                                v91 /*: any*/ ,
                                                                                                                v97 /*: any*/ ,
                                                                                                                v98 /*: any*/ ,
                                                                                                                v99 /*: any*/ ,
                                                                                                                v100 /*: any*/ ,
                                                                                                                v101 /*: any*/ ,
                                                                                                                v102 /*: any*/ ,
                                                                                                                v103 /*: any*/ ,
                                                                                                                v104 /*: any*/ ,
                                                                                                                v105 /*: any*/ ,
                                                                                                                v106 /*: any*/ ,
                                                                                                                v108 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "shouldQueryFieldSetsById",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "args": v33 /*: any*/ ,
                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldSetsForIssueSearchView",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldSet",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v38 /*: any*/ ,
                                                                                        v39 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fields",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v23 /*: any*/ ,
                                                                                                                v38 /*: any*/ ,
                                                                                                                v40 /*: any*/ ,
                                                                                                                v41 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": true,
                                                                                                                    "selections": [
                                                                                                                        v46 /*: any*/ ,
                                                                                                                        v50 /*: any*/ ,
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v109 /*: any*/ ,
                                                                                                                        v55 /*: any*/ ,
                                                                                                                        v56 /*: any*/ ,
                                                                                                                        v60 /*: any*/ ,
                                                                                                                        v61 /*: any*/ ,
                                                                                                                        v63 /*: any*/ ,
                                                                                                                        v66 /*: any*/ ,
                                                                                                                        v67 /*: any*/ ,
                                                                                                                        v68 /*: any*/ ,
                                                                                                                        v69 /*: any*/ ,
                                                                                                                        v70 /*: any*/ ,
                                                                                                                        v73 /*: any*/ ,
                                                                                                                        v74 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v77 /*: any*/ ,
                                                                                                                {
                                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                    "kind": "Condition",
                                                                                                                    "passingValue": false,
                                                                                                                    "selections": [
                                                                                                                        v79 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v82 /*: any*/ ,
                                                                                                                v83 /*: any*/ ,
                                                                                                                v85 /*: any*/ ,
                                                                                                                v86 /*: any*/ ,
                                                                                                                v109 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "statusCategory",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v89 /*: any*/ 
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v88 /*: any*/ ,
                                                                                                                v90 /*: any*/ ,
                                                                                                                v97 /*: any*/ ,
                                                                                                                v98 /*: any*/ ,
                                                                                                                v99 /*: any*/ ,
                                                                                                                v100 /*: any*/ ,
                                                                                                                v101 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "user",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v64 /*: any*/ ,
                                                                                                                                v65 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v81 /*: any*/ ,
                                                                                                                        v45 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                                },
                                                                                                                v103 /*: any*/ ,
                                                                                                                v104 /*: any*/ ,
                                                                                                                v105 /*: any*/ ,
                                                                                                                v106 /*: any*/ ,
                                                                                                                v108 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        v84 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v72 /*: any*/ ,
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "args": v110 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        v39 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                v40 /*: any*/ ,
                                                                                                v20 /*: any*/ ,
                                                                                                v41 /*: any*/ ,
                                                                                                v75 /*: any*/ ,
                                                                                                v77 /*: any*/ ,
                                                                                                v80 /*: any*/ ,
                                                                                                v82 /*: any*/ ,
                                                                                                v83 /*: any*/ ,
                                                                                                v85 /*: any*/ ,
                                                                                                v86 /*: any*/ ,
                                                                                                v53 /*: any*/ ,
                                                                                                v87 /*: any*/ ,
                                                                                                v88 /*: any*/ ,
                                                                                                v90 /*: any*/ ,
                                                                                                v91 /*: any*/ ,
                                                                                                v97 /*: any*/ ,
                                                                                                v98 /*: any*/ ,
                                                                                                v99 /*: any*/ ,
                                                                                                v100 /*: any*/ ,
                                                                                                v101 /*: any*/ ,
                                                                                                v102 /*: any*/ ,
                                                                                                v103 /*: any*/ ,
                                                                                                v104 /*: any*/ ,
                                                                                                v105 /*: any*/ ,
                                                                                                v106 /*: any*/ ,
                                                                                                v108 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v62 /*: any*/ ,
                                                                                                                        v72 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v59 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                v72 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalIssueSearchResultCount"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "maxCursors",
                                            "value": 7
                                        }
                                    ],
                                    "concreteType": "JiraPageCursors",
                                    "kind": "LinkedField",
                                    "name": "pageCursors",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "around",
                                            "plural": true,
                                            "selections": [
                                                v111 /*: any*/ ,
                                                v112 /*: any*/ ,
                                                v113 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "last",
                                            "plural": false,
                                            "selections": [
                                                v113 /*: any*/ ,
                                                v111 /*: any*/ ,
                                                v112 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraPageCursor",
                                            "kind": "LinkedField",
                                            "name": "first",
                                            "plural": false,
                                            "selections": [
                                                v111 /*: any*/ ,
                                                v113 /*: any*/ ,
                                                v112 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "pageCursors(maxCursors:7)"
                                },
                                {
                                    "concreteType": "JiraIssueNavigatorPageInfo",
                                    "kind": "LinkedField",
                                    "name": "issueNavigatorPageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssuePosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "firstIssueKeyFromNextPage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastIssueKeyFromPreviousPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "issueSearchError",
                                    "plural": false,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "messages"
                                                }
                                            ],
                                            "type": "JiraInvalidJqlError"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v76 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ],
                                            "type": "JiraInvalidSyntaxError"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "jql"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isCappingIssueSearchResult"
                                },
                                v72 /*: any*/ ,
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "args": v110 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v23 /*: any*/ ,
                                                                                                v22 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                v17 /*: any*/ ,
                                v29 /*: any*/ ,
                                v18 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "issueSearchViewResult",
                            "plural": false,
                            "selections": [
                                v22 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraIssueSearchViewResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "viewId"
                                        },
                                        {
                                            "args": v114 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v20 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasDefaultFieldSets"
                                                },
                                                {
                                                    "args": v114 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v54 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        v115 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jqlTerm"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v115 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v72 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v117 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewConfigSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v118 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": v117 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewConfigSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v119 /*: any*/ ,
                                                                        v120 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraIssueSearchView"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v121 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v120 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraField",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupByField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v23 /*: any*/ ,
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v119 /*: any*/ ,
                                                                v118 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v117 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewConfigSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v119 /*: any*/ ,
                                                                        v120 /*: any*/ ,
                                                                        v122 /*: any*/ ,
                                                                        v123 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssueSearchView"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v121 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v122 /*: any*/ ,
                                                                        v123 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSpreadsheetView",
                                                            "abstractKey": "__isJiraSpreadsheetView"
                                                        }
                                                    ]
                                                },
                                                v72 /*: any*/ 
                                            ],
                                            "type": "JiraIssueSearchViewMetadata",
                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                        }
                                    ],
                                    "type": "JiraIssueSearchView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v76 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": v71 /*: any*/ ,
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8721b64465460289d4a0dcc39018a0e89905bc357c6a331f9785ecbfdba3455d",
            "metadata": {},
            "name": "IssueNavigatorResultsRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$894e01c189a8309f$var$node.hash = "6872de214f3b36a519a609d3c1bec106";
var $894e01c189a8309f$export$2e2bcd8739ae039 = $894e01c189a8309f$var$node;

});


parcelRegister("l5FbD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c45b6cdf0660508$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7aa0785e47fc94a3e1a4af12f45faa84>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5c45b6cdf0660508$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_issueQuery",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_refetchQueryOld"
                }
            ]
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "projectKey",
                            "variableName": "projectKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_refetchQueryNew"
                }
            ]
        }
    ],
    "type": "Query"
};
$5c45b6cdf0660508$var$node.hash = "0b187435848f6b4a422a2b897dcb841c";
var $5c45b6cdf0660508$export$2e2bcd8739ae039 = $5c45b6cdf0660508$var$node;

});

parcelRegister("f98ZZ", function(module, exports) {

$parcel$export(module.exports, "SidebarContainer", () => $3536899865974e25$export$f39f3f768bc98e3d);
$parcel$export(module.exports, "useSidebar", () => $3536899865974e25$export$54c70f22f548bff8);
$parcel$export(module.exports, "useSidebarActions", () => $3536899865974e25$export$685a45ff9d61633f);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $2NMNM = parcelRequire("2NMNM");


var $bLhPU = parcelRequire("bLhPU");
const $3536899865974e25$export$dbc37fcbd226eb52 = (0, $gg7kZ.createContainer)();
const $3536899865974e25$export$f39f3f768bc98e3d = ({ children: children, scope: scope, sidebarId: sidebarId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3536899865974e25$export$dbc37fcbd226eb52, {
        scope: scope,
        sidebarId: sidebarId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $3536899865974e25$var$Store = (0, $iXqE5.createStore)({
    name: (0, $82deb0810ac24613$export$cd79d01fb3d2f506),
    containedBy: $3536899865974e25$export$dbc37fcbd226eb52,
    initialState: {
        id: null,
        content: null
    },
    actions: $bLhPU.actions
});
const $3536899865974e25$export$54c70f22f548bff8 = (0, $3sQ5x.createHook)($3536899865974e25$var$Store);
const $3536899865974e25$export$685a45ff9d61633f = (0, $3sQ5x.createActionsHook)($3536899865974e25$var$Store);

});
const $82deb0810ac24613$export$cd79d01fb3d2f506 = 'JiraPlatformSidebarStore';
const $82deb0810ac24613$export$b8b9d90f9e5bd72b = 'jiraPlatformSidebar';

parcelRegister("bLhPU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b5da470da8dd158d$export$e324594224ef24da);

var $8zOmE = parcelRequire("8zOmE");

var $2YZCu = parcelRequire("2YZCu");
const $b5da470da8dd158d$var$fireSidebarAnalytics = (experienceId, analyticsProps, eventType)=>{
    const { sidebarId: sidebarId, createAnalyticsEvent: createAnalyticsEvent } = analyticsProps;
    const sidebarLocationId = `jira${sidebarId}SidebarExperience`;
    try {
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${sidebarLocationId} ${eventType}`, {
            experienceId: experienceId
        });
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraPlatformSidebar', error instanceof Error ? error.message : `Error firing analytics event for sidebar with id ${sidebarId}`);
    }
};
const $b5da470da8dd158d$var$fireStartSidebarAnalytics = (experienceId, analyticsProps)=>{
    $b5da470da8dd158d$var$fireSidebarAnalytics(experienceId, analyticsProps, 'started');
};
const $b5da470da8dd158d$var$fireCloseSidebarAnalytics = (experienceId, analyticsProps)=>{
    $b5da470da8dd158d$var$fireSidebarAnalytics(experienceId, analyticsProps, 'ended');
};
const $b5da470da8dd158d$var$setExperienceId = (id)=>({ setState: setState, getState: getState }, analyticsProps)=>{
        const state = getState();
        const newState = {
            id: id,
            content: null
        };
        const newId = newState.id;
        const previousId = state.id;
        if (analyticsProps.sidebarId) {
            $b5da470da8dd158d$var$fireStartSidebarAnalytics(newId, analyticsProps);
            if (previousId != null) $b5da470da8dd158d$var$fireCloseSidebarAnalytics(previousId, analyticsProps);
        }
        setState({
            ...state,
            ...newState
        });
    };
const $b5da470da8dd158d$var$closeSidebar = ()=>({ setState: setState, getState: getState }, analyticsProps)=>{
        const state = getState();
        const newState = {
            id: null,
            content: null
        };
        if (analyticsProps.sidebarId && state.id) $b5da470da8dd158d$var$fireCloseSidebarAnalytics(state.id, analyticsProps);
        setState({
            ...state,
            ...newState
        });
    };
const $b5da470da8dd158d$var$setStaticSidebarContent = (id, content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content,
            id: id
        });
    };
const $b5da470da8dd158d$export$e324594224ef24da = {
    setExperienceId: $b5da470da8dd158d$var$setExperienceId,
    closeSidebar: $b5da470da8dd158d$var$closeSidebar,
    setStaticSidebarContent: $b5da470da8dd158d$var$setStaticSidebarContent
};

});


parcelRegister("a8lIB", function(module, exports) {

$parcel$export(module.exports, "marks", () => $9dd1b22816aa1595$export$3a8025f2f3e0c64);
$parcel$export(module.exports, "NINJqlBuilderAsyncLoad", () => $9dd1b22816aa1595$export$8ba5b9245ec3f6f9);
$parcel$export(module.exports, "NINPageLoad", () => $9dd1b22816aa1595$export$248c6c208e271182);
$parcel$export(module.exports, "markOnce", () => $9dd1b22816aa1595$export$243d158112bae094);

var $dGrdR = parcelRequire("dGrdR");

var $8vNru = parcelRequire("8vNru");
const $9dd1b22816aa1595$export$3a8025f2f3e0c64 = {
    ISSUE_NAVIGATOR_START: 'ISSUE_NAVIGATOR_START',
    ISSUE_NAVIGATOR_END: 'ISSUE_NAVIGATOR_END',
    ISSUE_NAVIGATOR_UI_START: 'ISSUE_NAVIGATOR_UI_START',
    ISSUE_NAVIGATOR_UI_END: 'ISSUE_NAVIGATOR_UI_END',
    PAGE_ACTIONS_START: 'PAGE_ACTIONS_START',
    PAGE_ACTIONS_END: 'PAGE_ACTIONS_END',
    PAGE_ACTIONS_VIEW_SWITCHER_START: 'PAGE_ACTIONS_VIEW_SWITCHER_START',
    PAGE_ACTIONS_VIEW_SWITCHER_END: 'PAGE_ACTIONS_VIEW_SWITCHER_END',
    REFINEMENT_START: 'REFINEMENT_START',
    REFINEMENT_END: 'REFINEMENT_END',
    ISSUE_RESULTS_START: 'ISSUE_RESULTS_START',
    ISSUE_RESULTS_END: 'ISSUE_RESULTS_END',
    ISSUE_RESULTS_DETAIL_VIEW_START: 'ISSUE_RESULTS_DETAIL_VIEW_START',
    ISSUE_RESULTS_DETAIL_VIEW_END: 'ISSUE_RESULTS_DETAIL_VIEW_END',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END',
    ISSUE_RESULTS_LIST_VIEW_START: 'ISSUE_RESULTS_LIST_VIEW_START',
    ISSUE_RESULTS_LIST_VIEW_END: 'ISSUE_RESULTS_LIST_VIEW_END',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_START: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_START',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_END: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_END',
    ISSUE_APP_START: 'ISSUE_APP_START',
    ISSUE_APP_END: 'ISSUE_APP_END',
    ...(0, $8vNru.JQL_BUILDER_PERFORMANCE_MARKS)
};
const $9dd1b22816aa1595$export$8ba5b9245ec3f6f9 = (0, $dGrdR.metrics).pageSegmentLoad({
    key: 'new-issue-navigator-jql-builder',
    timings: [
        {
            key: 'product/issue-navigator/ui/jql-builder',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/hydrate',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic/js',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced/js',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_END
        }
    ],
    histogram: {
        initial: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        },
        transition: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        }
    },
    featureFlags: []
});
const $9dd1b22816aa1595$export$248c6c208e271182 = (0, $dGrdR.metrics).pageLoad({
    key: 'new-issue-navigator',
    slo: {
        fmp: {
            initial: {
                threshold: 3000
            },
            transition: {
                threshold: 3000
            }
        },
        tti: {
            initial: {
                threshold: 4000
            },
            transition: {
                threshold: 4000
            }
        }
    },
    ssr: {
        doneAsFmp: true
    },
    timings: [
        {
            key: 'product/issue-navigator',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_END
        },
        {
            key: 'product/issue-navigator/ui',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_END
        },
        {
            key: 'product/issue-navigator/ui/page-actions',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.PAGE_ACTIONS_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.PAGE_ACTIONS_END
        },
        {
            key: 'product/issue-navigator/ui/page-actions/view-switcher',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_END
        },
        {
            key: 'product/issue-navigator/ui/refinement',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.REFINEMENT_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.REFINEMENT_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/detail-view',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/detail-view/card-list',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/list-view',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_END
        },
        {
            key: 'product/issue-navigator/ui/issue-results/list-view/footer',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_END
        },
        {
            key: 'product/issue-navigator/ui/issue-app',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_APP_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_APP_END
        }
    ],
    featureFlags: []
});
const $9dd1b22816aa1595$var$consumedMarks = [];
const $9dd1b22816aa1595$export$243d158112bae094 = (mark)=>{
    if (!$9dd1b22816aa1595$var$consumedMarks.includes(mark)) {
        $9dd1b22816aa1595$var$consumedMarks.push(mark);
        $9dd1b22816aa1595$export$248c6c208e271182.mark(mark);
        $9dd1b22816aa1595$export$8ba5b9245ec3f6f9.mark(mark);
    }
};

});

parcelRegister("1z7Yr", function(module, exports) {

$parcel$export(module.exports, "useAppContextualAnalyticsActions", () => $48ac6de4ef0bf23b$export$8aad1a4e4d637906);
$parcel$export(module.exports, "AppContextualAnalytics", () => $48ac6de4ef0bf23b$export$2942dddca20a92ac);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $iXVV6 = parcelRequire("iXVV6");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $48ac6de4ef0bf23b$var$Container = (0, $gg7kZ.createContainer)();
const $48ac6de4ef0bf23b$var$Store = (0, $iXqE5.createStore)({
    name: 'AppContextualAnalyticsStore',
    containedBy: $48ac6de4ef0bf23b$var$Container,
    initialState: {
        issueNavigatorSearchSessionId: undefined
    },
    actions: {
        onJourneyStart: ()=>({ setState: setState })=>{
                const issueNavigatorSearchSessionId = (0, $7Jxgt.v4)();
                setState({
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                });
                return {
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                };
            }
    }
});
const $48ac6de4ef0bf23b$export$e1e7a4797df1a656 = (0, $3sQ5x.createHook)($48ac6de4ef0bf23b$var$Store, {
    selector: (state)=>state.issueNavigatorSearchSessionId
});
const $48ac6de4ef0bf23b$export$8aad1a4e4d637906 = (0, $3sQ5x.createActionsHook)($48ac6de4ef0bf23b$var$Store);
const $48ac6de4ef0bf23b$var$AppContextualAnalyticsData = ({ children: children })=>{
    const [issueNavigatorSearchSessionId] = $48ac6de4ef0bf23b$export$e1e7a4797df1a656();
    const attributes = (0, $5uXOq.useMemo)(()=>({
            issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
        }), [
        issueNavigatorSearchSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "issueNavigator",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: attributes
    }, children);
};
const $48ac6de4ef0bf23b$export$2942dddca20a92ac = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48ac6de4ef0bf23b$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48ac6de4ef0bf23b$var$AppContextualAnalyticsData, null, children));

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("gtUFk", function(module, exports) {

$parcel$export(module.exports, "selectionState", () => $3b394fabc3b44251$export$a01d720722806cd3);
$parcel$export(module.exports, "SelectedIssueContainer", () => $3b394fabc3b44251$export$8b7bb55917259a5d);
$parcel$export(module.exports, "useSelectedIssueKey", () => $3b394fabc3b44251$export$7cedcbfb2da7e49d);
$parcel$export(module.exports, "useSelectedIssueIndex", () => $3b394fabc3b44251$export$a4b375f8f9b094ad);
$parcel$export(module.exports, "useFocusedIssueIndex", () => $3b394fabc3b44251$export$4399fa4a8958cb76);
$parcel$export(module.exports, "useSelectedIssueDebouncedState", () => $3b394fabc3b44251$export$ed5cb04ac9d88e95);
$parcel$export(module.exports, "useSelectedIssueStateOldActions", () => $3b394fabc3b44251$export$6f74178a4465fc7e);
$parcel$export(module.exports, "useIssueSelectionState", () => $3b394fabc3b44251$export$d703c03c23d04b26);
$parcel$export(module.exports, "useIsForcedSelectionOnReset", () => $3b394fabc3b44251$export$800a67a9f72a46a2);
$parcel$export(module.exports, "useIsFullPageIssueAppMode", () => $3b394fabc3b44251$export$988cbddd89e853c0);

var $iLtRV = parcelRequire("iLtRV");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $g5X3G = parcelRequire("g5X3G");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $isIOR = parcelRequire("isIOR");

var $ih9zY = parcelRequire("ih9zY");

var $1On4W = parcelRequire("1On4W");

const $3b394fabc3b44251$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        _rememoize: Date.now(),
        searchKey: '',
        selectedIssue: [
            null,
            (0, $g5X3G.toIssueKey)('')
        ],
        focusedIssue: null,
        nextResetStrategy: (0, $f455add29e1ec026$export$6953d2fd44491a2f),
        isFullPageIssueAppMode: false
    },
    actions: $1On4W.default,
    name: 'IssueNavigatorSelectedIssueState'
});
const $3b394fabc3b44251$export$a01d720722806cd3 = {
    ISSUE_SELECTED: 'ISSUE_SELECTED',
    BLANK_ISSUE_SELECTED: 'BLANK_ISSUE_SELECTED',
    NO_SELECTION: 'NO_SELECTION'
};
const $3b394fabc3b44251$var$getSelectedIndex = (issueKeys, selectedIssueKey)=>{
    const index = selectedIssueKey && issueKeys ? issueKeys.indexOf(selectedIssueKey) : null;
    if (index !== null && index >= 0) // If key exists in result set, set selected index to the corresponding position
    return index;
    // Otherwise, set selected index to null (i.e. no visual selection)
    return null;
};
const $3b394fabc3b44251$var$Container = (0, $gg7kZ.createContainer)($3b394fabc3b44251$var$Store, {
    onInit: ()=>({ dispatch: dispatch, setState: setState }, { selectedIssueKey: selectedIssueKey, issueKeys: issueKeys, searchKey: searchKey, view: view })=>{
            const isFullPageIssueAppMode = Boolean(selectedIssueKey) && view === (0, $6UAdF.views).list;
            const initialIssueKey = selectedIssueKey || dispatch((0, $1On4W.privateActions).getDefaultIssueKey()) || (0, $g5X3G.toIssueKey)('');
            const initialIndex = $3b394fabc3b44251$var$getSelectedIndex(issueKeys, initialIssueKey);
            setState({
                _rememoize: Date.now(),
                selectedIssue: [
                    initialIndex,
                    initialIssueKey
                ],
                searchKey: searchKey,
                isFullPageIssueAppMode: isFullPageIssueAppMode
            });
        },
    onUpdate: ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { selectedIssueKey: nextIssueKey, isFetching: isFetching, searchKey: searchKey, firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage })=>{
            if (isFetching) return;
            const state = getState();
            // Reset the selected issue whenever our search key has changed
            if (searchKey !== state.searchKey) {
                dispatch((0, $1On4W.privateActions).resetSelectedIssue(!!nextIssueKey));
                setState({
                    searchKey: searchKey
                });
            } else if (nextIssueKey) {
                // Call our set action to ensure the selected issue index is up to date.
                dispatch($3b394fabc3b44251$var$Store.actions.setSelectedIssueByKey(nextIssueKey, false, false, false));
                // If an issue key has been specified while in list view then enter full page issue app mode.
                if (dispatch((0, $1On4W.privateActions).isListViewWithoutIssueApp())) dispatch($3b394fabc3b44251$var$Store.actions.enterFullPageIssueAppMode());
                // If the issue key to select matches the first issue key from the next page then emit an event to go to
                // the next page.
                if (nextIssueKey === firstIssueKeyFromNextPage) dispatch($3b394fabc3b44251$var$Store.actions.selectFirstIssueOnNextPage());
                else if (nextIssueKey === lastIssueKeyFromPreviousPage) dispatch($3b394fabc3b44251$var$Store.actions.selectLastIssueOnPreviousPage());
            } else if (dispatch((0, $1On4W.privateActions).isListViewWithIssueAppAndKey())) dispatch($3b394fabc3b44251$var$Store.actions.exitFullPageIssueAppMode());
        }
});
const $3b394fabc3b44251$export$8b7bb55917259a5d = ({ selectedIssueKey: selectedIssueKey, issueResults: issueResults, ...props })=>{
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const { isFetching: isFetching, searchKey: searchKey, onIssueSearchForPage: onIssueSearchForPage, onIssueSearchForNextPage: onIssueSearchForNextPage, onIssueSearchForPreviousPage: onIssueSearchForPreviousPage } = (0, $isIOR.useIssueSearchQuery)();
    // eslint-disable-next-line @atlassian/relay/query-restriction
    const issueData = (0, $8Uumt.useFragment)((0, $iLtRV.default), issueResults);
    const { firstIssuePosition: firstIssuePosition, lastIssuePosition: lastIssuePosition, firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage } = issueData?.issueNavigatorPageInfo ?? {};
    const issueKeys = (0, $5uXOq.useMemo)(()=>issueData?.edges?.map((edge)=>(0, $g5X3G.toIssueKey)(edge?.node?.key ?? '')) ?? [], [
        issueData?.edges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b394fabc3b44251$var$Container, {
        isFetching: isFetching,
        searchKey: searchKey,
        selectedIssueKey: selectedIssueKey,
        issueKeys: issueKeys,
        view: (0, $eJ0Zs.convertToView)(view),
        onPageChange: onIssueSearchForPage,
        onNextPage: onIssueSearchForNextPage,
        onPreviousPage: onIssueSearchForPreviousPage,
        firstIssuePosition: firstIssuePosition ?? null,
        lastIssuePosition: lastIssuePosition ?? null,
        firstIssueKeyFromNextPage: firstIssueKeyFromNextPage ?? null,
        lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage ?? null,
        ...props
    });
};
const $3b394fabc3b44251$export$7cedcbfb2da7e49d = (0, $3sQ5x.createStateHook)($3b394fabc3b44251$var$Store, {
    selector: ({ selectedIssue: selectedIssue })=>selectedIssue[1]
});
const $3b394fabc3b44251$export$a4b375f8f9b094ad = (0, $3sQ5x.createStateHook)($3b394fabc3b44251$var$Store, {
    selector: ({ selectedIssue: selectedIssue })=>selectedIssue[0]
});
const $3b394fabc3b44251$export$4399fa4a8958cb76 = (0, $3sQ5x.createHook)($3b394fabc3b44251$var$Store, {
    selector: ({ focusedIssue: focusedIssue })=>focusedIssue
});
const $3b394fabc3b44251$export$ed5cb04ac9d88e95 = (0, $3sQ5x.createStateHook)($3b394fabc3b44251$var$Store, {
    selector: (0, $eJ0Zs.createRememoizeSelector)((state)=>state, ({ selectedIssue: selectedIssue })=>selectedIssue[1])
});
const $3b394fabc3b44251$export$6f74178a4465fc7e = (0, $3sQ5x.createActionsHook)($3b394fabc3b44251$var$Store);
const $3b394fabc3b44251$export$d703c03c23d04b26 = (0, $3sQ5x.createHook)($3b394fabc3b44251$var$Store, {
    selector: ({ selectedIssue: selectedIssue })=>{
        if (selectedIssue[0] !== null && selectedIssue[1].length > 0) return $3b394fabc3b44251$export$a01d720722806cd3.ISSUE_SELECTED;
        if (selectedIssue[0] !== null && selectedIssue[1].length === 0) return $3b394fabc3b44251$export$a01d720722806cd3.BLANK_ISSUE_SELECTED;
        return $3b394fabc3b44251$export$a01d720722806cd3.NO_SELECTION;
    }
});
const $3b394fabc3b44251$export$800a67a9f72a46a2 = (0, $3sQ5x.createStateHook)($3b394fabc3b44251$var$Store, {
    selector: ({ nextResetStrategy: nextResetStrategy })=>nextResetStrategy === (0, $f455add29e1ec026$export$7438b768c88f1c5b) || nextResetStrategy === (0, $f455add29e1ec026$export$9d24b8100c251252)
});
const $3b394fabc3b44251$export$988cbddd89e853c0 = (0, $3sQ5x.createStateHook)($3b394fabc3b44251$var$Store, {
    selector: ({ isFullPageIssueAppMode: isFullPageIssueAppMode })=>isFullPageIssueAppMode
});

});
parcelRegister("iLtRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $783350784ca64578$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<705c41b65f0364f33cc5d8ace96b3876>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $783350784ca64578$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedIssueStateOld_issueNavigator_SelectedIssueContainer",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "JiraIssueNavigatorPageInfo",
            "kind": "LinkedField",
            "name": "issueNavigatorPageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "firstIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssuePosition"
                },
                {
                    "kind": "ScalarField",
                    "name": "firstIssueKeyFromNextPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "lastIssueKeyFromPreviousPage"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$783350784ca64578$var$node.hash = "337a019a583c3a28f545e54926fd4e34";
var $783350784ca64578$export$2e2bcd8739ae039 = $783350784ca64578$var$node;

});

parcelRegister("isIOR", function(module, exports) {

$parcel$export(module.exports, "useIssueSearchQuery", () => $51670fcdef73f961$export$11659072884978f5);
$parcel$export(module.exports, "IssueSearchQueryProvider", () => $51670fcdef73f961$export$3f36a9df094c3109);

var $dh0OE = parcelRequire("dh0OE");

var $94MjA = parcelRequire("94MjA");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $5eRaS = parcelRequire("5eRaS");

var $4R6GH = parcelRequire("4R6GH");

var $9Nvh7 = parcelRequire("9Nvh7");

var $1XJ20 = parcelRequire("1XJ20");

var $6Z846 = parcelRequire("6Z846");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cZpsT = parcelRequire("cZpsT");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $gwtSG = parcelRequire("gwtSG");

var $1GlUV = parcelRequire("1GlUV");

var $lavGr = parcelRequire("lavGr");

var $foKFw = parcelRequire("foKFw");

var $aHzNA = parcelRequire("aHzNA");

var $fgjcR = parcelRequire("fgjcR");
// Maximum number of times we will attempt to backfill our page of issues, e.g. if the user refreshes on page 3 but
// there are only 100 issues then we refresh page 2.
const $51670fcdef73f961$var$MAX_BACKFILL_RETRIES = 1;
const $51670fcdef73f961$var$IssueSearchQueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isFetching: false,
    isRefreshing: false,
    hasViewIdChanged: false,
    isNetworkError: false,
    isStalePage: false,
    onDeleteIssue: ()=>'',
    onFetchUncappedTotalIssueCount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onIssueSearch: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onIssueSearchForPage: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onIssueSearchForCurrentPage: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onIssueSearchForNextPage: ()=>false,
    onIssueSearchForPreviousPage: ()=>false,
    onIssueSearchForView: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onIssueSearchRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onIssueByFieldsRefetch: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    searchKey: '',
    uncappedTotalIssueCount: {
        ...(0, $foKFw.uncappedTotalInitialState)
    }
});
$51670fcdef73f961$var$IssueSearchQueryContext.displayName = 'IssueSearchQueryContext';
const $51670fcdef73f961$export$11659072884978f5 = ()=>(0, $5uXOq.useContext)($51670fcdef73f961$var$IssueSearchQueryContext);
const $51670fcdef73f961$export$3f36a9df094c3109 = ({ refetch: refetch, issueResults: issueResults, view: view, query: query, onPageDataLoad: onPageDataLoad, onChangePage: onChangePage, children: children })=>{
    /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/query-restriction */ const issueResultsData = (0, $8Uumt.useFragment)((0, $94MjA.default), issueResults);
    const viewData = (0, $8Uumt.useFragment)((0, $dh0OE.default), view);
    /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/query-restriction */ const [isRefreshing, setIsRefreshing] = (0, $5uXOq.useState)(false);
    const { jql: jql, filterId: filterId } = (0, $gwtSG.useActiveJql)();
    // Track if a refetch action is about to be called due to changing issueSearchInput
    const willFetch = (0, $5uXOq.useRef)(false);
    // Track currently selected view as a ref which will be used as an argument for any issue search queries
    const selectedViewId = (0, $5uXOq.useRef)((0, $eJ0Zs.parseIssueNavigatorViewIdOrDefault)(viewData?.viewId, (0, $6UAdF.DEFAULT_VIEW_ID)));
    // Only a fixed set of input variables are recomputed for our refetch query.
    const issueSearchInput = (0, $5uXOq.useMemo)(()=>jql === undefined && (0, $9Nvh7.isFilterId)(filterId) ? {
            filterId: filterId
        } : {
            jql: jql
        }, [
        filterId,
        jql
    ]);
    const prevIssueSearchInput = (0, $1XJ20.usePreviousWithInitial)(issueSearchInput);
    const fieldSetIds = (0, $5uXOq.useMemo)(()=>viewData?.fieldSets?.edges.filter((0, $eJ0Zs.isNonNullish)).map(({ node: { fieldSetId: fieldSetId } })=>fieldSetId) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const isBifrost = (0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? !!(0, $5eRaS.ssr).getFeatureFlags()?.ssrViaBifrost : undefined;
    const { onIssueSearchFail: onIssueSearchFail } = (0, $1GlUV.useExperienceAnalytics)(onPageDataLoad, selectedViewId.current, {
        ...(0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? {
            isBifrost: isBifrost
        } : {}
    });
    const { isFetching: isFetching, hasViewIdChanged: hasViewIdChanged, isNetworkError: isNetworkError, onIssueSearchRefetch: onIssueSearchRefetch, onIssueByFieldsRefetch: onIssueByFieldsRefetch, searchKey: searchKey, uncappedTotalIssueCount: uncappedTotalIssueCount, onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount } = (0, $lavGr.useIssueSearchRefetch)(refetch, query, issueSearchInput, selectedViewId.current, issueResultsData?.__id, fieldSetIds, onIssueSearchFail);
    const onIssueSearch = (0, $5uXOq.useCallback)(()=>{
        // Execute a new search against the network with current JQL input arguments
        onIssueSearchRefetch({}, {
            fetchPolicy: 'network-only'
        });
    }, [
        onIssueSearchRefetch
    ]);
    const hasIssueSearchInputChanged = !(0, $6Z846.isShallowEqual)(issueSearchInput, prevIssueSearchInput);
    if (hasIssueSearchInputChanged) // We track this during render instead of waiting for useEffect to fire so there is no intermediary render for
    // downstream components where `jql` has changed but `isFetching` is still false.
    willFetch.current = true;
    (0, $5uXOq.useEffect)(()=>{
        if (hasIssueSearchInputChanged) {
            willFetch.current = false;
            const shouldLoadWithFilterViewId = selectedViewId.current !== 'detail' && issueSearchInput.filterId && (0, $9Nvh7.isCustomFilter)(issueSearchInput.filterId);
            const isCurrentViewIdInvalid = (0, $eJ0Zs.isFilterViewId)(selectedViewId.current) && selectedViewId.current !== `list_filter_${filterId}`;
            if (issueSearchInput.filterId && shouldLoadWithFilterViewId) {
                selectedViewId.current = (0, $eJ0Zs.convertFilterIdToIssueNavigatorId)(issueSearchInput.filterId);
                onIssueSearchRefetch({
                    viewId: selectedViewId.current
                }, {
                    fetchPolicy: 'network-only'
                });
            } else if (isCurrentViewIdInvalid) {
                selectedViewId.current = (0, $6UAdF.DEFAULT_VIEW_ID);
                onIssueSearchRefetch({
                    viewId: selectedViewId.current
                }, {
                    fetchPolicy: 'network-only'
                });
            } else onIssueSearch();
        }
    }, [
        filterId,
        hasIssueSearchInputChanged,
        issueSearchInput,
        onIssueSearch,
        onIssueSearchRefetch,
        prevIssueSearchInput
    ]);
    const cursors = issueResultsData?.pageCursors?.around;
    const currentPageIndex = (0, $5uXOq.useMemo)(()=>cursors?.findIndex((cursor)=>cursor?.isCurrent) ?? -1, [
        cursors
    ]);
    const currentPage = currentPageIndex > -1 ? cursors?.[currentPageIndex] : undefined;
    const currentPageCursor = currentPage?.cursor ?? null;
    const currentPageNumber = currentPage?.pageNumber ?? 1;
    // Ignoring linting errors for the conditional call as the FF does not change during runtime
    const onSelectedViewMutation = (0, $aHzNA.useSelectedViewMutation)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    /**
   * This will refetch issue and field configuration data for the provided view.
   */ const onIssueSearchForView = (0, $5uXOq.useCallback)((newViewId)=>{
        // Only allow non-anonymous users to invoke the mutation to update the user preference
        if (!isAnonymous && (0, $eJ0Zs.convertToView)(newViewId) !== (0, $eJ0Zs.convertToView)(selectedViewId.current)) onSelectedViewMutation(newViewId);
        // Update our viewId according to the selected view and refetch our issue data
        selectedViewId.current = newViewId;
        // If we have no currentPageCursor then we can assume our search has failed. In this case we need to force a
        // network call as otherwise Relay will serve null data from cache.
        const options = {
            isNewSearchKey: false,
            fetchPolicy: 'network-only'
        };
        onIssueSearchRefetch({
            after: currentPageCursor,
            viewId: selectedViewId.current
        }, options);
    }, [
        currentPageCursor,
        isAnonymous,
        onIssueSearchRefetch,
        onSelectedViewMutation
    ]);
    /**
   * Event emitted when an issue is deleted.
   */ const onDeleteIssue = (0, $fgjcR.useOnDeleteIssue)(issueResultsData);
    /**
   * This will refetch issue and field configuration data for the provided page cursor.
   */ const onIssueSearchForPage = (0, $5uXOq.useCallback)((after, options)=>{
        onIssueSearchRefetch({
            after: after
        }, options);
        onChangePage && onChangePage();
    }, [
        onChangePage,
        onIssueSearchRefetch
    ]);
    const onIssueSearchForNextPage = (0, $5uXOq.useCallback)((options)=>{
        if (currentPageIndex > -1) {
            const nextPage = cursors?.[currentPageIndex + 1];
            if (nextPage && nextPage.cursor != null) {
                onIssueSearchForPage(nextPage.cursor, options);
                return true;
            }
        }
        return false;
    }, [
        currentPageIndex,
        cursors,
        onIssueSearchForPage
    ]);
    const onIssueSearchForPreviousPage = (0, $5uXOq.useCallback)((options)=>{
        if (currentPageIndex > 0) {
            const previousPage = cursors?.[currentPageIndex - 1];
            if (previousPage && previousPage.cursor != null) {
                onIssueSearchForPage(previousPage.cursor, options);
                return true;
            }
        }
        return false;
    }, [
        currentPageIndex,
        cursors,
        onIssueSearchForPage
    ]);
    /**
   * This will refetch issue and field configuration data for the current page.
   */ const onIssueSearchForCurrentPage = (0, $5uXOq.useCallback)(()=>{
        onIssueSearchRefetch({
            after: currentPageCursor
        }, {
            fetchPolicy: 'network-only',
            isNewSearchKey: false
        });
    }, [
        currentPageCursor,
        onIssueSearchRefetch
    ]);
    /**
   * This will refresh issue and field configuration data for the provided page number (or current page if no page
   * number is given), triggering a new search using offset based pagination.
   */ const onIssueSearchRefresh = (0, $5uXOq.useCallback)((pageNumber = currentPageNumber)=>{
        setIsRefreshing(true);
        // Offset based request - API will run a new (i.e. non-stable) search for the given range
        onIssueSearchRefetch({
            first: pageNumber * (0, $6UAdF.MAX_ISSUES_PER_PAGE),
            last: (0, $6UAdF.MAX_ISSUES_PER_PAGE)
        }, {
            fetchPolicy: 'network-only',
            onComplete: ()=>{
                setIsRefreshing(false);
            },
            onError: ()=>{
                setIsRefreshing(false);
            },
            onUnsubscribe: ()=>{
                setIsRefreshing(false);
            }
        });
    }, [
        currentPageNumber,
        onIssueSearchRefetch
    ]);
    const backfillRetryCount = (0, $5uXOq.useRef)(0);
    const edges = issueResultsData?.edges ?? [];
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const isStalePage = total > 0 && edges.length === 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const prevIssueResultsData = (0, $1XJ20.usePrevious)(issueResultsData);
    /**
   * Handle the edge case where the user refreshes a page (e.g. page 3) and there are no issues present on the page.
   * In this scenario we automatically trigger a refresh request for the last available page with issues.
   */ (0, $5uXOq.useLayoutEffect)(()=>{
        if (issueResultsData !== prevIssueResultsData) {
            if (isStalePage && backfillRetryCount.current <= $51670fcdef73f961$var$MAX_BACKFILL_RETRIES) {
                const pageNumber = // If we've reached our limit then fallback to page 1
                backfillRetryCount.current === $51670fcdef73f961$var$MAX_BACKFILL_RETRIES ? 1 : Math.ceil(total / (0, $6UAdF.MAX_ISSUES_PER_PAGE));
                onIssueSearchRefresh(pageNumber);
                backfillRetryCount.current += 1;
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueSearchResults backfill');
                return;
            }
            backfillRetryCount.current = 0;
        }
    }, [
        createAnalyticsEvent,
        issueResultsData,
        prevIssueResultsData,
        isStalePage,
        onIssueSearchRefresh,
        total
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isFetching: isFetching || willFetch.current,
            isRefreshing: isRefreshing,
            hasViewIdChanged: hasViewIdChanged,
            isNetworkError: isNetworkError,
            isStalePage: isStalePage,
            searchKey: searchKey,
            onDeleteIssue: onDeleteIssue,
            onIssueSearch: onIssueSearch,
            onIssueSearchForPage: onIssueSearchForPage,
            onIssueSearchForCurrentPage: onIssueSearchForCurrentPage,
            onIssueSearchForNextPage: onIssueSearchForNextPage,
            onIssueSearchForPreviousPage: onIssueSearchForPreviousPage,
            onIssueSearchForView: onIssueSearchForView,
            onIssueSearchRefresh: onIssueSearchRefresh,
            onIssueByFieldsRefetch: onIssueByFieldsRefetch,
            onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount,
            uncappedTotalIssueCount: uncappedTotalIssueCount
        }), [
        isFetching,
        isRefreshing,
        hasViewIdChanged,
        isNetworkError,
        isStalePage,
        searchKey,
        onDeleteIssue,
        onIssueSearch,
        onIssueSearchForPage,
        onIssueSearchForCurrentPage,
        onIssueSearchForNextPage,
        onIssueSearchForPreviousPage,
        onIssueSearchForView,
        onIssueSearchRefresh,
        onIssueByFieldsRefetch,
        onFetchUncappedTotalIssueCount,
        uncappedTotalIssueCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            issuesLoaded: total
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51670fcdef73f961$var$IssueSearchQueryContext.Provider, {
        value: contextValue
    }, children));
};

});
parcelRegister("dh0OE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8573f724cfbdbde5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc976390fd8b29859278e8cbe5af37b2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8573f724cfbdbde5$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        }
    ],
    "kind": "Fragment",
    "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_view",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "viewId"
            },
            "action": "THROW",
            "path": "viewId"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                            "fieldSetSelectedState": "SELECTED"
                        }
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                    }
                ],
                "concreteType": "JiraIssueSearchFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraIssueSearchFieldSet",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "fieldSetId"
                                                },
                                                "action": "THROW",
                                                "path": "fieldSets.edges.node.fieldSetId"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "fieldSets.edges.node"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "fieldSets.edges"
                    }
                ]
            },
            "action": "THROW",
            "path": "fieldSets"
        }
    ],
    "type": "JiraIssueSearchView"
};
$8573f724cfbdbde5$var$node.hash = "73c821f489985ab33d96817dee8a6600";
var $8573f724cfbdbde5$export$2e2bcd8739ae039 = $8573f724cfbdbde5$var$node;

});

parcelRegister("94MjA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb136e3833a201c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f5558bea4509b675d4b93f377171ac71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3eb136e3833a201c$var$node = function() {
    var v0 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "issueSearchQuery_issueNavigator_IssueSearchQueryProvider_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            }
                        ]
                    },
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isCurrent"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "pageNumber"
                            }
                        ]
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            v0 /*: any*/ 
        ],
        "type": "JiraIssueConnection"
    };
}();
$3eb136e3833a201c$var$node.hash = "be5101b94f9ee67c52f693de30818ccb";
var $3eb136e3833a201c$export$2e2bcd8739ae039 = $3eb136e3833a201c$var$node;

});

parcelRegister("gwtSG", function(module, exports) {

$parcel$export(module.exports, "useActiveJql", () => $403641b131a496d8$export$caeaf867313163e4);
$parcel$export(module.exports, "ActiveJqlProvider", () => $403641b131a496d8$export$c69a9a3114157ae7);
$parcel$export(module.exports, "useResolvedJql", () => $403641b131a496d8$export$23e17984875d36b4);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $9Nvh7 = parcelRequire("9Nvh7");
const $403641b131a496d8$var$ActiveJqlContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    jql: ''
});
$403641b131a496d8$var$ActiveJqlContext.displayName = 'ActiveJqlContext';
const $403641b131a496d8$export$caeaf867313163e4 = ()=>(0, $5uXOq.useContext)($403641b131a496d8$var$ActiveJqlContext);
const $403641b131a496d8$export$c69a9a3114157ae7 = ({ jql: jql, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql, children: children })=>{
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            jql: jql,
            filterId: filterId,
            isFilterEditable: isFilterEditable,
            filterJql: filterJql
        }), [
        jql,
        filterId,
        isFilterEditable,
        filterJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($403641b131a496d8$var$ActiveJqlContext.Provider, {
        value: contextValue
    }, children);
};
const $403641b131a496d8$export$23e17984875d36b4 = ()=>{
    const { jql: jql, filterJql: filterJql } = $403641b131a496d8$export$caeaf867313163e4();
    const filter = filterJql !== undefined ? filterJql : '';
    return jql !== undefined ? jql : filter;
};
const $403641b131a496d8$export$5d3c8489d1ae8bee = ()=>{
    const { filterId: filterId, jql: jql } = $403641b131a496d8$export$caeaf867313163e4();
    return `/issues/?${(0, $ebyGx.stringify)({
        jql: jql,
        ...(0, $9Nvh7.isFilterId)(filterId) ? {
            filter: filterId
        } : {}
    })}`;
};

});

parcelRegister("1GlUV", function(module, exports) {

$parcel$export(module.exports, "useExperienceAnalytics", () => $5bd41227ba98547a$export$523b242362f30838);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $6s1PB = parcelRequire("6s1PB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6UAdF = parcelRequire("6UAdF");
/**
 * This debouncer is shared between both the success and fail calls so that the last one called in the current event
 * loop tick is the one that gets logged. This helps us overcome weaknesses in the Relay-based rendering where an error
 * being thrown taks an additional render cycle to reach the component managing the analytics.
 */ const $5bd41227ba98547a$var$sharedDebouncer = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((action)=>action(), 0);
const $5bd41227ba98547a$export$523b242362f30838 = (/**
	 * Event emitted when page data has loaded and the key experience is interactive.
	 */ onPageDataLoad, /**
	 * Currently selected view mode.
	 *
	 * @deprecated This argument is now passed in directly to the onIssueSearchSuccess on onIssueSearchFail callbacks.
	 * This makes it easier to correctly attribute failed refetch requests which have modified the viewId.
	 */ // TODO Remove this argument when cleaning up jira_spreadsheet_component_m1
viewOld, /**
	 * Analytics attributes to be emitted as part of success/fail experience events.
	 */ attributes)=>{
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $6UAdF.EXPERIENCE_NAME),
        experienceId: undefined,
        analyticsSource: (0, $6UAdF.ANALYTICS_SOURCE)
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $6UAdF.EXPERIENCE_NAME),
        attributes: attributes
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $6UAdF.EXPERIENCE_NAME),
        attributes: attributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onFireUIAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'screen'
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'issueSearchResults', attributes ?? {});
    }, [
        attributes,
        createAnalyticsEvent
    ]);
    const onIssueSearchSuccess = (0, $5uXOq.useCallback)((view)=>{
        $5bd41227ba98547a$var$sharedDebouncer(()=>{
            onExperienceStart();
            onExperienceSuccess();
            onFireUIAnalyticsEvent();
        });
        onPageDataLoad && onPageDataLoad((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? view : viewOld);
    }, [
        onExperienceStart,
        onExperienceSuccess,
        onFireUIAnalyticsEvent,
        onPageDataLoad,
        viewOld
    ]);
    const onIssueSearchFail = (0, $5uXOq.useCallback)((location, error, view)=>{
        $5bd41227ba98547a$var$sharedDebouncer(()=>{
            onExperienceStart();
            onExperienceFail(location, error);
        });
        onPageDataLoad && onPageDataLoad((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? view : viewOld);
    }, [
        onExperienceFail,
        onExperienceStart,
        onPageDataLoad,
        viewOld
    ]);
    return {
        onIssueSearchSuccess: onIssueSearchSuccess,
        onIssueSearchFail: onIssueSearchFail
    };
};

});

parcelRegister("lavGr", function(module, exports) {

$parcel$export(module.exports, "useIssueSearchRefetch", () => $aeb7b1acdf8f6e00$export$b550b6912621dc5d);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $ajpes = parcelRequire("ajpes");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $7Jxgt = parcelRequire("7Jxgt");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $1XJ20 = parcelRequire("1XJ20");

var $9OXo1 = parcelRequire("9OXo1");

var $6UAdF = parcelRequire("6UAdF");

var $foKFw = parcelRequire("foKFw");

var $6Hhfn = parcelRequire("6Hhfn");

var $4M3mV = parcelRequire("4M3mV");
const $aeb7b1acdf8f6e00$var$searchErrorFlagId = (0, $7HGHK.toFlagId)('ISSUE_NAVIGATOR_SEARCH_ERROR_FLAG');
const $aeb7b1acdf8f6e00$var$searchErrorFlag = {
    id: $aeb7b1acdf8f6e00$var$searchErrorFlagId,
    type: 'error',
    title: (0, $4M3mV.default).searchFailedTitle,
    description: (0, $4M3mV.default).searchFailedDescription,
    messageId: `issue-navigator.services.issue-search-refetch.searchErrorFlag.${$aeb7b1acdf8f6e00$var$searchErrorFlagId}`,
    messageType: 'transactional'
};
const $aeb7b1acdf8f6e00$export$b550b6912621dc5d = (refetch, query, issueSearchInput, viewId, connectionId, fieldSetIds, onIssueSearchFail)=>{
    // Used to track and force a network-only request when a failed search has been cached
    const lastVariables = (0, $5uXOq.useRef)();
    const networkOnlyVariables = (0, $5uXOq.useRef)(new Set());
    const connectionIds = (0, $5uXOq.useRef)(new Set());
    const disposableOperations = (0, $5uXOq.useRef)(new Set());
    const [searchKey, setSearchKey] = (0, $5uXOq.useState)((0, $7Jxgt.v4)());
    const [isFetching, setIsFetching] = (0, $5uXOq.useState)(false);
    const [isNetworkError, setNetworkError] = (0, $5uXOq.useState)(false);
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { uncappedTotalIssueCount: uncappedTotalIssueCount, resetTotalIssueCount: resetTotalIssueCount, onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount } = (0, $foKFw.useIssueSearchTotalCount)({
        cloudId: cloudId,
        issueSearchInput: issueSearchInput
    });
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const prevViewId = (0, $1XJ20.usePreviousWithInitial)(viewId);
    const prevFieldSetIds = (0, $1XJ20.usePreviousWithInitial)(fieldSetIds);
    const inFlightRequest = (0, $5uXOq.useRef)();
    // Release data for each fetchQuery operation allowing them to be garbage collected by Relay
    const onDisposeOperations = (0, $5uXOq.useCallback)(()=>{
        disposableOperations.current.forEach((disposable)=>disposable.dispose());
        disposableOperations.current.clear();
    }, []);
    // Dispose operations on unmount. This happens automatically for Relay query hooks, but we need to do it ourselves
    // when using fetchQuery.
    (0, $5uXOq.useEffect)(()=>onDisposeOperations, [
        onDisposeOperations
    ]);
    const onIssueByFieldsRefetch = (0, $6Hhfn.useIssueByFieldsRefetch)(fieldSetIds);
    /**
	 * Invalidate all tracked issue connections so any subsequent queries with a matching identifier will hit the
	 * network.
	 */ const onInvalidateIssueConnection = (0, $5uXOq.useCallback)(()=>{
        (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            connectionIds.current.forEach((id)=>{
                const connection = store.get(id);
                connection && connection.invalidateRecord();
            });
            connectionIds.current.clear();
        });
    }, [
        environment
    ]);
    const onInvalidateAndDisposeIssueConnection = (0, $5uXOq.useCallback)(()=>{
        onInvalidateIssueConnection();
        onDisposeOperations();
    }, [
        onDisposeOperations,
        onInvalidateIssueConnection
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // If our fieldSetIds have changed then we must invalidate our connections so we don't serve stale issue data
        // with mismatched field sets.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(fieldSetIds, prevFieldSetIds) && viewId === prevViewId) onInvalidateIssueConnection();
        if (connectionId !== undefined) // Track ids of our issue connections so they can be invalidated
        connectionIds.current.add(connectionId);
        else if (lastVariables.current) // If we do not receive a connection id then add the last used variables to our set of network-only
        // variables. This prevents us serving null responses from cache when there is no connection id to invalidate.
        networkOnlyVariables.current.add(lastVariables.current);
    });
    const onIssueSearchRefetch = (0, $5uXOq.useCallback)((variables, options)=>{
        // Some consumers may fire refetch queries before in-flight query
        // has been completed (e.g. while user is toggling columns on and off in
        // the column picker). In these situations, we always want to fetch latest
        // data from the API as column configuration may have changed for the user.
        // To do that, we disable Relay's automatic de-deduping of requests.
        inFlightRequest.current?.unsubscribe();
        const finalVariables = {
            cloudId: cloudId,
            issueSearchInput: issueSearchInput,
            first: (0, $6UAdF.MAX_ISSUES_PER_PAGE),
            after: null,
            namespace: 'ISSUE_NAVIGATOR',
            viewId: viewId,
            options: null,
            fieldSetIds: [],
            shouldQueryFieldSetsById: false,
            amountOfColumns: (0, $6UAdF.MAX_AMOUNT_OF_COLUMNS),
            filterId: null,
            ...variables
        };
        setIsFetching(true);
        setNetworkError(false);
        // Hide any search error flags currently visible
        dismissFlag($aeb7b1acdf8f6e00$var$searchErrorFlagId);
        let fetchPolicy = options?.fetchPolicy ?? 'store-or-network';
        // Check if our final variables match any of our network-only variables, and if so update the fetch policy.
        networkOnlyVariables.current.forEach((value)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(finalVariables, value)) {
                fetchPolicy = 'network-only';
                networkOnlyVariables.current.delete(value);
            }
        });
        if (fetchPolicy === 'network-only') onInvalidateAndDisposeIssueConnection();
        inFlightRequest.current = (0, $eiowN.fetchQuery)(environment, query, finalVariables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        }).subscribe({
            complete: ()=>{
                /*
					 * fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
					 * data will remain saved in the Relay store at any point after the request completes.
					 * We need to explicitly retain the operation to ensure it doesn't get deleted.
					 * See https://relay.dev/docs/api-reference/fetch-query/#behavior
					 */ const operation = (0, $eiowN.createOperationDescriptor)((0, $eiowN.getRequest)(query), finalVariables);
                disposableOperations.current.add(environment.retain(operation));
                lastVariables.current = finalVariables;
                let hasStoreRefetchCompleted = false;
                // We need to batch these updates as without it, Relay will cause multiple renders and invoke the
                // onComplete callback multiple times. This causes our success/fail analytics events to become
                // unreliable.
                // We introduced a similar fix for fetchQuery (see src/packages/platform/graphql/relay-scheduler/src/index.js)
                // and in React 18 will be able to remove this in favour of the startTransition/useTransition APIs.
                (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unstable_batchedUpdates(()=>{
                    refetch(finalVariables, {
                        fetchPolicy: 'store-only',
                        onComplete: ()=>{
                            // Relay will dispose the cached operation after a 5m timeout, in which case it will
                            // refetch the query from the store and retrigger the onComplete callback. We need to
                            // ensure this callback is invoked strictly once to prevent unexpected side effects,
                            // e.g. https://jira.atlassian.com/browse/JRACLOUD-84106.
                            if (hasStoreRefetchCompleted) return;
                            hasStoreRefetchCompleted = true;
                            setIsFetching(false);
                            options?.onComplete && options.onComplete();
                            if (options?.isNewSearchKey ?? true) {
                                setSearchKey((0, $7Jxgt.v4)());
                                if (/*
										 * Once a refetch has completed, go back and inspect
										 * the request variables for the existence of an `after` cursor.
										 * If an `after` cursor was provided to the query, this means that
										 * the query was triggered via user navigating to a different page of
										 * results for the current search (I.e. by clicking pagination controls).
										 * For such events, do not reset the total issue count. We want it to
										 * be preserved across pagination.
										 */ !finalVariables.after) resetTotalIssueCount();
                            }
                        }
                    });
                });
            },
            error: (error)=>{
                setIsFetching(false);
                setNetworkError(true);
                onIssueSearchFail(`${(0, $6UAdF.PACKAGE_NAME)}.issue-search-refetch`, error, viewId);
                showFlag($aeb7b1acdf8f6e00$var$searchErrorFlag);
                options?.onError && options.onError();
            },
            unsubscribe: ()=>{
                options?.onUnsubscribe && options.onUnsubscribe();
            }
        });
    }, [
        cloudId,
        issueSearchInput,
        viewId,
        dismissFlag,
        environment,
        query,
        onInvalidateAndDisposeIssueConnection,
        refetch,
        resetTotalIssueCount,
        onIssueSearchFail,
        showFlag
    ]);
    return {
        isFetching: isFetching,
        hasViewIdChanged: viewId !== prevViewId,
        isNetworkError: isNetworkError,
        onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount,
        onIssueSearchRefetch: onIssueSearchRefetch,
        onIssueByFieldsRefetch: onIssueByFieldsRefetch,
        searchKey: searchKey,
        uncappedTotalIssueCount: uncappedTotalIssueCount
    };
};

});
parcelRegister("foKFw", function(module, exports) {

$parcel$export(module.exports, "uncappedTotalInitialState", () => $b9c1ec4b15549a72$export$31250fb09166d65c);
$parcel$export(module.exports, "useIssueSearchTotalCount", () => $b9c1ec4b15549a72$export$409cb8d89f7323a6);

var $fE00s = parcelRequire("fE00s");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");
const $b9c1ec4b15549a72$export$31250fb09166d65c = {
    count: undefined,
    isFetching: false,
    isError: false
};
const $b9c1ec4b15549a72$export$409cb8d89f7323a6 = ({ cloudId: cloudId, issueSearchInput: issueSearchInput })=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const [uncappedTotalIssueCount, setUncappedTotalIssueCount] = (0, $5uXOq.useState)({
        ...$b9c1ec4b15549a72$export$31250fb09166d65c
    });
    const resetTotalIssueCount = (0, $5uXOq.useCallback)(()=>{
        setUncappedTotalIssueCount({
            ...$b9c1ec4b15549a72$export$31250fb09166d65c
        });
    }, []);
    const onFetchUncappedTotalIssueCount = (0, $5uXOq.useCallback)(()=>{
        setUncappedTotalIssueCount({
            count: undefined,
            isFetching: true,
            isError: false
        });
        (0, $8Uumt.fetchQuery)(environment, (0, $fE00s.default), {
            cloudId: cloudId,
            issueSearchInput: issueSearchInput
        }, {
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: {
                    META_SLOW_ENDPOINT: true
                }
            }
        }).toPromise().then((data)=>{
            const count = data ? data.jira?.issueSearchTotalCount : null;
            let isError = false;
            if (count === null || count === undefined) isError = true;
            setUncappedTotalIssueCount({
                count: count,
                isFetching: false,
                isError: isError
            });
        }).catch(()=>{
            setUncappedTotalIssueCount({
                count: null,
                isFetching: false,
                isError: true
            });
        });
    }, [
        cloudId,
        environment,
        issueSearchInput
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            uncappedTotalIssueCount: uncappedTotalIssueCount,
            resetTotalIssueCount: resetTotalIssueCount,
            onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount
        }), [
        uncappedTotalIssueCount,
        resetTotalIssueCount,
        onFetchUncappedTotalIssueCount
    ]);
};

});
parcelRegister("fE00s", function(module, exports) {

$parcel$export(module.exports, "default", () => $0436ddab441f1d11$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<17b5714c3546c414fbfe4379532efc21>>
 * @relayHash 929c7cfdabf85276ab021ca0aaf710c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3810891dc29174a6ad47903cc92470a66dff964fe69f524a8d29c29992b37a1
const $0436ddab441f1d11$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "issueSearchTotalCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a3810891dc29174a6ad47903cc92470a66dff964fe69f524a8d29c29992b37a1",
            "metadata": {},
            "name": "issueSearchTotalCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0436ddab441f1d11$var$node.hash = "37773194a6f16231c4993e21b36ed872";
var $0436ddab441f1d11$export$2e2bcd8739ae039 = $0436ddab441f1d11$var$node;

});


parcelRegister("6Hhfn", function(module, exports) {

$parcel$export(module.exports, "useIssueByFieldsRefetch", () => $49b7b4d37d56a65b$export$a3f7fddb3e08cea5);

var $8nnfc = parcelRequire("8nnfc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $9OXo1 = parcelRequire("9OXo1");

var $6UAdF = parcelRequire("6UAdF");
const $49b7b4d37d56a65b$export$a3f7fddb3e08cea5 = (fieldSets)=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)((issuekey)=>(0, $eiowN.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ (0, $8nnfc.default), /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ {
            cloudId: cloudId,
            issueSearchInput: {
                jql: `issueKey=${issuekey}`
            },
            fieldSetIds: fieldSets,
            amountOfColumns: (0, $6UAdF.MAX_AMOUNT_OF_COLUMNS)
        }, {
            fetchPolicy: 'network-only'
        }).toPromise(), [
        cloudId,
        environment,
        fieldSets
    ]);
};

});
parcelRegister("8nnfc", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ed14087c56651a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ef18951ac4e40111a764ded6a16e439>>
 * @relayHash 64a3a2b8ddc924497ea3c6fc393ce4f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ed618fe83491f4b5daee4d0b6fae6fd59a6b85a960623175390e6ab388d119a4

var $5qm7M = parcelRequire("5qm7M");

var $hBvdF = parcelRequire("hBvdF");
const $70ed14087c56651a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v4 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }
    ], v6 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "value"
    }, v13 = [
        v12 /*: any*/ ,
        v10 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v15 = {
        "kind": "ClientExtension",
        "selections": [
            v14 /*: any*/ 
        ]
    }, v16 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v17 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v20 = {
        "kind": "ScalarField",
        "name": "text"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            v20 /*: any*/ ,
            v11 /*: any*/ ,
            v15 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v22 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v23 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v10 /*: any*/ 
        ]
    }, v24 = [
        v23 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v28 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v29 = {
        "kind": "ScalarField",
        "name": "key"
    }, v30 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v31 = [
        v11 /*: any*/ ,
        v10 /*: any*/ 
    ], v32 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v34 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v35 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v37 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v38 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v37 /*: any*/ ,
                    v11 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            },
            v10 /*: any*/ 
        ]
    }, v39 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v40 = {
        "kind": "ScalarField",
        "name": "number"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isDensityFull",
                                                                    "value": false
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isInlineEditingEnabled",
                                                                    "value": true
                                                                }
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "main_issueNavigator_Card_fieldSets"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v8 /*: any*/ ,
                                                                                                v9 /*: any*/ ,
                                                                                                v7 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                v10 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v10 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "cascadingOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "parentOptionValue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v13 /*: any*/ 
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "childOptionValue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v13 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraCascadingSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v16 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        v10 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraDateTimePickerField"
                                                                                                        },
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "commentSummary",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "canAddComment"
                                                                                                                        },
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraCommentSummaryField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "uri"
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraUrlField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v12 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": v24 /*: any*/ 
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": v24 /*: any*/ 
                                                                                                                        },
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v25 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                        v25 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraCheckboxesField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedUsersConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v8 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ ,
                                                                                                                                        v11 /*: any*/ ,
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "email"
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraTeamView",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedTeam",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "jiraSuppliedId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "jiraSuppliedName"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraTeamViewField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v10 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraEstimate",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "originalEstimate",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "timeInSeconds"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "timeTrackingSettings",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "workingHoursPerDay"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "workingDaysPerWeek"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "defaultFormat"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "defaultUnit"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v9 /*: any*/ ,
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v7 /*: any*/ ,
                                                                                                                                v15 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "alias": "label",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "value"
                                                                                                                        },
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraRadioSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v16 /*: any*/ ,
                                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedVersionsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v11 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "versionId"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v16 /*: any*/ ,
                                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedGoals",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v29 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ClientExtension",
                                                                                                                            "selections": [
                                                                                                                                v30 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ClientExtension",
                                                                                                                    "selections": [
                                                                                                                        v30 /*: any*/ ,
                                                                                                                        v14 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraGoalsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v16 /*: any*/ ,
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "href"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "mediaClientConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "clientId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "fileId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "message"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "componentsOld",
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v31 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v20 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "date"
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v32 /*: any*/ ,
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v29 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "summary"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                v33 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v34 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v16 /*: any*/ ,
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v22 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "small"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v29 /*: any*/ ,
                                                                                                                v35 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v29 /*: any*/ ,
                                                                                                                        v36 /*: any*/ ,
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v29 /*: any*/ ,
                                                                                                                        v36 /*: any*/ ,
                                                                                                                        v38 /*: any*/ ,
                                                                                                                        v35 /*: any*/ ,
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "issueId"
                                                                                                                        },
                                                                                                                        v39 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "summary",
                                                                                                                                        "issuetype",
                                                                                                                                        "status"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v8 /*: any*/ ,
                                                                                                                                                v10 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                                        v20 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueType",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "issueTypeId"
                                                                                                                                                                },
                                                                                                                                                                v11 /*: any*/ ,
                                                                                                                                                                v37 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "hierarchy",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "level"
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                v10 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "status",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v34 /*: any*/ ,
                                                                                                                                                                v10 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ ,
                                                                                                                v15 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                v29 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": v31 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v10 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v8 /*: any*/ ,
                                                                                                                v26 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v10 /*: any*/ ,
                                                                                                                v28 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v32 /*: any*/ ,
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v11 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v16 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v31 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                v37 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                v4 /*: any*/ 
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v39 /*: any*/ ,
                                                                                                                                        v29 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v8 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v34 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v10 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        v10 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v10 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isStoryPointField"
                                                                                                        },
                                                                                                        v40 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                v40 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                v40 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v15 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraNumberField"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ed618fe83491f4b5daee4d0b6fae6fd59a6b85a960623175390e6ab388d119a4",
            "metadata": {},
            "name": "refetchIssue_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$70ed14087c56651a$var$node.hash = "c4758e8f0c69bf48cf3f00e006767f21";
var $70ed14087c56651a$export$2e2bcd8739ae039 = $70ed14087c56651a$var$node;

});


parcelRegister("4M3mV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b78ba074f422fa2b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b78ba074f422fa2b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchFailedTitle: {
        "id": "issue-navigator.services.issue-search-refetch.search-failed-title",
        "defaultMessage": "We couldn't load your search results"
    },
    searchFailedDescription: {
        "id": "issue-navigator.services.issue-search-refetch.search-failed-description",
        "defaultMessage": "Refresh and try again."
    }
});

});


parcelRegister("aHzNA", function(module, exports) {

$parcel$export(module.exports, "useSelectedViewMutation", () => $2944951b3352cd6b$export$765f658bb8bac50f);

var $aQlsP = parcelRequire("aQlsP");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $koeKL = parcelRequire("koeKL");

var $6UAdF = parcelRequire("6UAdF");
const $2944951b3352cd6b$export$5786a571e562003d = (view)=>view.startsWith('list_') ? 'LIST' : 'DETAIL';
const $2944951b3352cd6b$export$765f658bb8bac50f = ()=>{
    const userCloudId = (0, $koeKL.useCloudId)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $aQlsP.default));
    return (0, $5uXOq.useCallback)((view)=>{
        commitMutation({
            variables: {
                cloudId: userCloudId,
                searchLayout: $2944951b3352cd6b$export$5786a571e562003d(view)
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    sendToPrivacyUnsafeSplunk: true,
                    error: error,
                    meta: {
                        id: 'mainSelectedViewMutation',
                        packageName: (0, $6UAdF.PACKAGE_NAME),
                        teamName: (0, $6UAdF.TEAM_NAME)
                    }
                });
            },
            optimisticResponse: {
                jira: {
                    userPreferences: {
                        setIssueNavigatorSearchLayout: {
                            success: true,
                            errors: [],
                            issueNavigatorSearchLayout: $2944951b3352cd6b$export$5786a571e562003d(view)
                        }
                    }
                }
            }
        });
    }, [
        commitMutation,
        userCloudId
    ]);
};

});
parcelRegister("aQlsP", function(module, exports) {

$parcel$export(module.exports, "default", () => $92fa5e8811139c3f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<03678eaaa27509a9eaff05b3536ed7a3>>
 * @relayHash 411c1701f9d22f072c495ac536a98400
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f11f424abd082a8324c0f881b823fe5b84699dcb133b3f8c6933ee47e9907505
const $92fa5e8811139c3f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchLayout"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "searchLayout",
                                    "variableName": "searchLayout"
                                }
                            ],
                            "concreteType": "JiraIssueNavigatorSearchLayoutMutationPayload",
                            "kind": "LinkedField",
                            "name": "setIssueNavigatorSearchLayout",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueNavigatorSearchLayout"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "selectedView_updateUserViewModeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "selectedView_updateUserViewModeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "f11f424abd082a8324c0f881b823fe5b84699dcb133b3f8c6933ee47e9907505",
            "metadata": {},
            "name": "selectedView_updateUserViewModeMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$92fa5e8811139c3f$var$node.hash = "57781762cebd4351d1b1402acc6af4c4";
var $92fa5e8811139c3f$export$2e2bcd8739ae039 = $92fa5e8811139c3f$var$node;

});


parcelRegister("fgjcR", function(module, exports) {

$parcel$export(module.exports, "useOnDeleteIssue", () => $24b03457fbd48166$export$45e2b3c3de4980ed);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");
const $24b03457fbd48166$export$45e2b3c3de4980ed = (data)=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)((issueKeyToDelete)=>{
        const issueResultEdges = data?.edges ?? [];
        let previousIssueKey;
        let nextIssueKey;
        (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            let record;
            for(let i = 0; i < issueResultEdges.length; i++){
                const edge = issueResultEdges[i];
                const key = edge?.node?.key;
                // If we have not found the record holding the deleted issue
                if (!record) {
                    // Check if we've found the deleted issue
                    if (edge && key === issueKeyToDelete) record = store.get(edge.__id);
                    else if (key != null) previousIssueKey = key;
                } else if (key != null) {
                    nextIssueKey = key;
                    break;
                }
            }
            // Nullify the issue node which we'll handle in our UI as a deleted issue
            record?.setValue(null, 'node');
        });
        // Return the next issue key to select. If there is no next issue key then return the previous key.
        return nextIssueKey ?? previousIssueKey ?? '';
    }, [
        environment,
        data?.edges
    ]);
};

});


parcelRegister("ih9zY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $03e3ed82cee3c5c7$export$42a852a2b6b56249);
$parcel$export(module.exports, "useSelectedViewState", () => $03e3ed82cee3c5c7$export$b94206faaa871f9e);
$parcel$export(module.exports, "useSelectedView", () => $03e3ed82cee3c5c7$export$639584d6e9163827);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6UAdF = parcelRequire("6UAdF");
const $03e3ed82cee3c5c7$export$42a852a2b6b56249 = (0, $gg7kZ.createContainer)();
const $03e3ed82cee3c5c7$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        view: (0, $6UAdF.DEFAULT_VIEW_ID)
    },
    containedBy: $03e3ed82cee3c5c7$export$42a852a2b6b56249,
    actions: {
        setView: (view, issueKey)=>({ setState: setState }, { onSetView: onSetView, onIssueSearchForView: onIssueSearchForView })=>{
                setState({
                    view: view
                });
                onSetView(view, issueKey);
                onIssueSearchForView && onIssueSearchForView(view);
            }
    },
    handlers: {
        onInit: ()=>({ setState: setState }, { view: view })=>{
                setState({
                    view: view
                });
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (nextProps.view !== prevProps.view) setState({
                    view: nextProps.view
                });
            }
    },
    name: 'IssueNavigatorSelectedViewStateNew'
});
const $03e3ed82cee3c5c7$export$b94206faaa871f9e = (0, $3sQ5x.createHook)($03e3ed82cee3c5c7$var$Store);
const $03e3ed82cee3c5c7$export$639584d6e9163827 = (0, $3sQ5x.createStateHook)($03e3ed82cee3c5c7$var$Store, {
    selector: (state)=>state.view
});

});

parcelRegister("1On4W", function(module, exports) {

$parcel$export(module.exports, "privateActions", () => $16c8c1e1a5eb8155$export$3f1be494d407b77a);
$parcel$export(module.exports, "default", () => $16c8c1e1a5eb8155$export$2e2bcd8739ae039);

var $lFKmC = parcelRequire("lFKmC");

var $g5X3G = parcelRequire("g5X3G");

var $6UAdF = parcelRequire("6UAdF");

const $16c8c1e1a5eb8155$var$doSideEffectUpdate = ({ setState: setState, getState: getState, onChange: onChange, shouldNotifyOnChange: shouldNotifyOnChange, isSelectedByUserInteraction: isSelectedByUserInteraction })=>{
    const { selectedIssue: selectedIssue } = getState();
    setState({
        _rememoize: Date.now()
    });
    const key = selectedIssue[1];
    shouldNotifyOnChange && onChange && onChange(key, isSelectedByUserInteraction);
};
const $16c8c1e1a5eb8155$var$doDebouncedSideEffectUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))($16c8c1e1a5eb8155$var$doSideEffectUpdate, 600);
const $16c8c1e1a5eb8155$var$doSideEffectUpdates = (shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction)=>{
    if (shouldDebounce) $16c8c1e1a5eb8155$var$doDebouncedSideEffectUpdate({
        setState: setState,
        getState: getState,
        onChange: onChange,
        shouldNotifyOnChange: shouldNotifyOnChange,
        isSelectedByUserInteraction: isSelectedByUserInteraction
    });
    else $16c8c1e1a5eb8155$var$doSideEffectUpdate({
        setState: setState,
        getState: getState,
        onChange: onChange,
        shouldNotifyOnChange: shouldNotifyOnChange,
        isSelectedByUserInteraction: isSelectedByUserInteraction
    });
};
const $16c8c1e1a5eb8155$var$setSelectedIssueByKey = (issueKey, shouldDebounce = false, shouldNotifyOnChange = true, isSelectedByUserInteraction = true)=>({ setState: setState, getState: getState }, { onChange: onChange, issueKeys: issueKeys })=>{
        if (!issueKey.length) return;
        const index = issueKey.length ? issueKeys?.findIndex((key)=>key === issueKey) : -1;
        if (index !== -1) setState({
            selectedIssue: [
                index,
                issueKey
            ]
        });
        else setState({
            selectedIssue: [
                null,
                issueKey
            ]
        });
        $16c8c1e1a5eb8155$var$doSideEffectUpdates(shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction);
    };
const $16c8c1e1a5eb8155$var$setSelectedIssueByIndex = (issueIndex, shouldDebounce = false, shouldNotifyOnChange = true, isSelectedByUserInteraction = true)=>({ setState: setState, getState: getState }, { onChange: onChange, issueKeys: issueKeys })=>{
        if (issueIndex >= issueKeys.length) return;
        const key = issueKeys[issueIndex];
        setState({
            selectedIssue: [
                issueIndex,
                key
            ]
        });
        $16c8c1e1a5eb8155$var$doSideEffectUpdates(shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction);
    };
/**
 * Return the position of the currently selected issue in the search results or `null` if the selected issue could not
 * be found.
 */ const $16c8c1e1a5eb8155$var$getSelectedIssuePosition = ()=>({ getState: getState }, { firstIssuePosition: firstIssuePosition, lastIssuePosition: lastIssuePosition, firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage })=>{
        // Incomplete page info from our search results so don't compute the position
        if (firstIssuePosition === null || lastIssuePosition === null) return null;
        const { selectedIssue: selectedIssue, nextResetStrategy: nextResetStrategy } = getState();
        const [selectedIssueIndex, selectedIssueKey] = selectedIssue;
        // If the first issue key from next page is selected or if we are forcing selection of the first issue on
        // pagination then we optimistically compute the issue position.
        if (selectedIssueKey === firstIssueKeyFromNextPage || nextResetStrategy === (0, $f455add29e1ec026$export$7438b768c88f1c5b)) return lastIssuePosition + 1;
        // If the last issue key from previous page is selected or if we are forcing selection of the last issue on
        // pagination then we optimistically compute the issue position.
        if (selectedIssueKey === lastIssueKeyFromPreviousPage || nextResetStrategy === (0, $f455add29e1ec026$export$9d24b8100c251252)) return firstIssuePosition - 1;
        if (selectedIssueIndex !== null) return selectedIssueIndex + firstIssuePosition;
        return null;
    };
/**
 * Returns true if the currently selected issue is within the page of issues.
 */ const $16c8c1e1a5eb8155$var$isSelectedIssueOnPage = ()=>({ dispatch: dispatch }, { firstIssuePosition: firstIssuePosition, lastIssuePosition: lastIssuePosition })=>{
        const selectedIssuePosition = dispatch($16c8c1e1a5eb8155$var$getSelectedIssuePosition());
        return selectedIssuePosition !== null && firstIssuePosition !== null && lastIssuePosition !== null && selectedIssuePosition >= firstIssuePosition && selectedIssuePosition <= lastIssuePosition;
    };
/**
 * Returns true if the currently selected issue is the first issue on the page.
 */ const $16c8c1e1a5eb8155$var$isFirstIssueOnPage = ()=>({ dispatch: dispatch }, { firstIssuePosition: firstIssuePosition })=>{
        const selectedIssuePosition = dispatch($16c8c1e1a5eb8155$var$getSelectedIssuePosition());
        return selectedIssuePosition !== null && selectedIssuePosition === firstIssuePosition;
    };
/**
 * Returns true if the currently selected issue is the last issue on the page.
 */ const $16c8c1e1a5eb8155$var$isLastIssueOnPage = ()=>({ dispatch: dispatch }, { lastIssuePosition: lastIssuePosition })=>{
        const selectedIssuePosition = dispatch($16c8c1e1a5eb8155$var$getSelectedIssuePosition());
        return selectedIssuePosition !== null && selectedIssuePosition === lastIssuePosition;
    };
/**
 * Return the next issue in the search results from the currently selected issue. If the selected issue is the last item
 * in the page of search results then the first key from the next page is returned with a boolean indicating the issue
 * belongs to the next page.
 */ const $16c8c1e1a5eb8155$var$getNextIssue = ()=>({ getState: getState, dispatch: dispatch }, { firstIssueKeyFromNextPage: firstIssueKeyFromNextPage, issueKeys: issueKeys })=>{
        const { selectedIssue: selectedIssue } = getState();
        const [selectedIssueIndex] = selectedIssue;
        let nextIssueKey = '';
        let nextIssueIndex = null;
        let isOnNextPage = false;
        if (dispatch($16c8c1e1a5eb8155$var$isLastIssueOnPage())) {
            nextIssueKey = firstIssueKeyFromNextPage ?? '';
            isOnNextPage = true;
        } else if (selectedIssueIndex !== null && dispatch($16c8c1e1a5eb8155$var$isSelectedIssueOnPage())) {
            nextIssueIndex = selectedIssueIndex + 1;
            nextIssueKey = issueKeys[nextIssueIndex];
        }
        return {
            issueKey: nextIssueKey,
            issueIndex: nextIssueIndex,
            isOnNextPage: isOnNextPage
        };
    };
/**
 * Return the previous issue in the search results from the currently selected issue. If the selected issue is the first
 * item in the page of search results then the last key from the previous page is returned with a boolean indicating the
 * issue belongs to the previous page.
 */ const $16c8c1e1a5eb8155$var$getPreviousIssue = ()=>({ getState: getState, dispatch: dispatch }, { lastIssueKeyFromPreviousPage: lastIssueKeyFromPreviousPage, issueKeys: issueKeys })=>{
        const { selectedIssue: selectedIssue } = getState();
        const [selectedIssueIndex] = selectedIssue;
        let previousIssueKey = '';
        let previousIssueIndex = null;
        let isOnPreviousPage = false;
        const selectedIssuePosition = dispatch($16c8c1e1a5eb8155$var$getSelectedIssuePosition());
        // Ignore the first issue on the first page, which always has position '1'
        if (selectedIssuePosition === 1) return {
            issueKey: previousIssueKey,
            issueIndex: previousIssueIndex,
            isOnPreviousPage: isOnPreviousPage
        };
        if (dispatch($16c8c1e1a5eb8155$var$isFirstIssueOnPage())) {
            previousIssueKey = lastIssueKeyFromPreviousPage ?? '';
            isOnPreviousPage = true;
        } else if (selectedIssueIndex !== null && dispatch($16c8c1e1a5eb8155$var$isSelectedIssueOnPage())) {
            previousIssueIndex = selectedIssueIndex - 1;
            previousIssueKey = issueKeys[previousIssueIndex];
        }
        return {
            issueKey: previousIssueKey,
            issueIndex: previousIssueIndex,
            isOnPreviousPage: isOnPreviousPage
        };
    };
/**
 * Emit an event to fetch the next page of issues and force the first issue on the page (including null issues) to
 * be selected when the new connection of search results is loaded.
 */ const $16c8c1e1a5eb8155$var$selectFirstIssueOnNextPage = ()=>({ setState: setState }, { onNextPage: onNextPage })=>{
        setState({
            nextResetStrategy: (0, $f455add29e1ec026$export$7438b768c88f1c5b)
        });
        const revertStrategy = ()=>setState({
                nextResetStrategy: (0, $f455add29e1ec026$export$6953d2fd44491a2f)
            });
        // Revert the reset strategy if the pagination request was interrupted (e.g. toggling view) or failed.
        const handled = onNextPage({
            onError: revertStrategy,
            onUnsubscribe: revertStrategy
        });
        // Revert the reset strategy if the page was unchanged
        if (!handled) revertStrategy();
    };
/**
 * Emit an event to fetch the previous page of issues and force the last issue on the page (including null issues)
 * to be selected when the new connection of search results is loaded.
 */ const $16c8c1e1a5eb8155$var$selectLastIssueOnPreviousPage = ()=>({ setState: setState }, { onPreviousPage: onPreviousPage })=>{
        setState({
            nextResetStrategy: (0, $f455add29e1ec026$export$9d24b8100c251252)
        });
        const revertStrategy = ()=>setState({
                nextResetStrategy: (0, $f455add29e1ec026$export$6953d2fd44491a2f)
            });
        // Revert the reset strategy if the pagination request was interrupted (e.g. toggling view) or failed.
        const handled = onPreviousPage({
            onError: revertStrategy,
            onUnsubscribe: revertStrategy
        });
        // Revert the reset strategy if the page was unchanged
        if (!handled) revertStrategy();
    };
const $16c8c1e1a5eb8155$var$selectIssueOnPage = (after, shouldSelectLastIssue)=>({ setState: setState }, { onPageChange: onPageChange })=>{
        setState({
            nextResetStrategy: shouldSelectLastIssue ? (0, $f455add29e1ec026$export$9d24b8100c251252) : (0, $f455add29e1ec026$export$7438b768c88f1c5b)
        });
        const revertStrategy = ()=>setState({
                nextResetStrategy: (0, $f455add29e1ec026$export$6953d2fd44491a2f)
            });
        // Revert the reset strategy if the pagination request was interrupted (e.g. toggling view) or failed.
        onPageChange(after, {
            onError: revertStrategy,
            onUnsubscribe: revertStrategy
        });
    };
/**
 * Select the next issue in the search results (if there is a valid selection). Returns `true` if an issue was selected,
 * otherwise `false`.
 */ const $16c8c1e1a5eb8155$var$selectNextIssue = (shouldDebounce)=>({ dispatch: dispatch })=>{
        const { issueKey: issueKey, issueIndex: issueIndex, isOnNextPage: isOnNextPage } = dispatch($16c8c1e1a5eb8155$var$getNextIssue());
        if (issueIndex !== null) {
            dispatch($16c8c1e1a5eb8155$var$setSelectedIssueByIndex(issueIndex, shouldDebounce));
            return true;
        }
        if (issueKey !== '') {
            dispatch($16c8c1e1a5eb8155$var$setSelectedIssueByKey(issueKey, shouldDebounce));
            return true;
        }
        // If we do not have an issue key but our issue to select is on the next page (i.e. deleted issue) then we
        // dispatch an action to fetch the next page (rather than relying on the container update action).
        if (isOnNextPage) {
            dispatch($16c8c1e1a5eb8155$var$selectFirstIssueOnNextPage());
            return true;
        }
        return false;
    };
/**
 * Select the previous issue in the search results (if there is a valid selection). Returns `true` if an issue was
 * selected, otherwise `false`.
 */ const $16c8c1e1a5eb8155$var$selectPreviousIssue = (shouldDebounce)=>({ dispatch: dispatch })=>{
        const { issueKey: issueKey, issueIndex: issueIndex, isOnPreviousPage: isOnPreviousPage } = dispatch($16c8c1e1a5eb8155$var$getPreviousIssue());
        if (issueIndex !== null) {
            dispatch($16c8c1e1a5eb8155$var$setSelectedIssueByIndex(issueIndex, shouldDebounce));
            return true;
        }
        if (issueKey !== '') {
            dispatch($16c8c1e1a5eb8155$var$setSelectedIssueByKey(issueKey, shouldDebounce));
            return true;
        }
        // If we do not have an issue key but our issue to select is on the previous page (i.e. deleted issue) then we
        // dispatch an action to fetch the previous page (rather than relying on the container update action).
        if (isOnPreviousPage) {
            dispatch($16c8c1e1a5eb8155$var$selectLastIssueOnPreviousPage());
            return true;
        }
        return false;
    };
const $16c8c1e1a5eb8155$var$setFocusedIssueByIndex = (issueIndex)=>({ setState: setState })=>{
        setState({
            focusedIssue: issueIndex
        });
    };
const $16c8c1e1a5eb8155$var$resetFocusedIssue = ()=>({ setState: setState })=>{
        setState({
            focusedIssue: null
        });
    };
const $16c8c1e1a5eb8155$var$deselectIssue = (shouldDebounce = false, shouldNotifyOnChange = true, isSelectedByUserInteraction = true)=>({ setState: setState, getState: getState }, { onChange: onChange })=>{
        setState({
            selectedIssue: [
                null,
                (0, $g5X3G.toIssueKey)('')
            ]
        });
        $16c8c1e1a5eb8155$var$doSideEffectUpdates(shouldDebounce, setState, getState, onChange, shouldNotifyOnChange, isSelectedByUserInteraction);
    };
const $16c8c1e1a5eb8155$var$enterFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: true
        });
const $16c8c1e1a5eb8155$var$exitFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: false
        });
const $16c8c1e1a5eb8155$var$getDefaultIssueKey = ()=>(_, { issueKeys: issueKeys })=>issueKeys.find((nonEmptyKey)=>Boolean(nonEmptyKey));
/**
 * Return true if we're in default list view mode without the full page issue app visible.
 */ const $16c8c1e1a5eb8155$var$isListViewWithoutIssueApp = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode } = getState();
        return view === (0, $6UAdF.views).list && !isFullPageIssueAppMode;
    };
/**
 * Return true if we're in default list view mode with the full page issue app visible and a selected issue key.
 */ const $16c8c1e1a5eb8155$var$isListViewWithIssueAppAndKey = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode, selectedIssue: selectedIssue } = getState();
        return view === (0, $6UAdF.views).list && isFullPageIssueAppMode && !!selectedIssue[1];
    };
/**
 * Reset the selected issue based on the current reset strategy.
 *
 * @param hasNextIssueKey `true` if a selected issue key is specified in the URL
 */ const $16c8c1e1a5eb8155$var$resetSelectedIssue = (hasNextIssueKey)=>({ dispatch: dispatch, getState: getState, setState: setState }, { issueKeys: issueKeys })=>{
        const { nextResetStrategy: nextResetStrategy } = getState();
        // Update to default reset strategy
        setState({
            nextResetStrategy: (0, $f455add29e1ec026$export$6953d2fd44491a2f)
        });
        // We only want to update issue key in the URL if our view mode uses external issue key selection, i.e. detail
        // view or full page issue app in list view. For the default list view mode we want to keep the selected issue
        // state internal.
        const shouldNotifyOnChange = !dispatch($16c8c1e1a5eb8155$var$isListViewWithoutIssueApp());
        // If there is a selected issue specified in the URL, e.g. pagination, then `isSelectedByUserInteraction` should
        // be `true` to push a new entry in the browser history stack. Otherwise, if there is no selected issue in the
        // URL, e.g. new search, then `isSelectedByUserInteraction` should be false to replace the existing entry.
        const isSelectedByUserInteraction = hasNextIssueKey;
        // Index of the last issue on the issue list
        const lastIssueIndex = issueKeys.length - 1;
        switch(nextResetStrategy){
            case 0, $f455add29e1ec026$export$9d24b8100c251252:
                dispatch($16c8c1e1a5eb8155$var$setSelectedIssueByIndex(lastIssueIndex, false, shouldNotifyOnChange, isSelectedByUserInteraction));
                dispatch($16c8c1e1a5eb8155$var$setFocusedIssueByIndex(lastIssueIndex));
                break;
            case 0, $f455add29e1ec026$export$7438b768c88f1c5b:
                dispatch($16c8c1e1a5eb8155$var$setSelectedIssueByIndex(0, false, shouldNotifyOnChange, isSelectedByUserInteraction));
                dispatch($16c8c1e1a5eb8155$var$setFocusedIssueByIndex(0));
                break;
            case 0, $f455add29e1ec026$export$6953d2fd44491a2f:
            default:
                dispatch($16c8c1e1a5eb8155$var$setSelectedIssueByIndex(0, false, shouldNotifyOnChange, isSelectedByUserInteraction));
                break;
        }
    };
const $16c8c1e1a5eb8155$export$e324594224ef24da = {
    setSelectedIssueByKey: $16c8c1e1a5eb8155$var$setSelectedIssueByKey,
    setSelectedIssueByIndex: $16c8c1e1a5eb8155$var$setSelectedIssueByIndex,
    getSelectedIssuePosition: $16c8c1e1a5eb8155$var$getSelectedIssuePosition,
    getNextIssue: $16c8c1e1a5eb8155$var$getNextIssue,
    getPreviousIssue: $16c8c1e1a5eb8155$var$getPreviousIssue,
    selectNextIssue: $16c8c1e1a5eb8155$var$selectNextIssue,
    selectPreviousIssue: $16c8c1e1a5eb8155$var$selectPreviousIssue,
    setFocusedIssueByIndex: $16c8c1e1a5eb8155$var$setFocusedIssueByIndex,
    deselectIssue: $16c8c1e1a5eb8155$var$deselectIssue,
    selectFirstIssueOnNextPage: $16c8c1e1a5eb8155$var$selectFirstIssueOnNextPage,
    selectLastIssueOnPreviousPage: $16c8c1e1a5eb8155$var$selectLastIssueOnPreviousPage,
    selectIssueOnPage: $16c8c1e1a5eb8155$var$selectIssueOnPage,
    enterFullPageIssueAppMode: $16c8c1e1a5eb8155$var$enterFullPageIssueAppMode,
    exitFullPageIssueAppMode: $16c8c1e1a5eb8155$var$exitFullPageIssueAppMode,
    resetFocusedIssue: $16c8c1e1a5eb8155$var$resetFocusedIssue
};
const $16c8c1e1a5eb8155$export$3f1be494d407b77a = {
    getDefaultIssueKey: $16c8c1e1a5eb8155$var$getDefaultIssueKey,
    isListViewWithoutIssueApp: $16c8c1e1a5eb8155$var$isListViewWithoutIssueApp,
    isListViewWithIssueAppAndKey: $16c8c1e1a5eb8155$var$isListViewWithIssueAppAndKey,
    resetSelectedIssue: $16c8c1e1a5eb8155$var$resetSelectedIssue
};
var $16c8c1e1a5eb8155$export$2e2bcd8739ae039 = $16c8c1e1a5eb8155$export$e324594224ef24da;

});
const $f455add29e1ec026$export$6953d2fd44491a2f = 'DEFAULT_FIRST';
const $f455add29e1ec026$export$7438b768c88f1c5b = 'FORCE_FIRST';
const $f455add29e1ec026$export$9d24b8100c251252 = 'FORCE_LAST';



parcelRegister("cKK2E", function(module, exports) {

$parcel$export(module.exports, "useFilterQuery", () => $964d8c42bd13cd02$export$5576614cd48b552);
$parcel$export(module.exports, "FilterQueryProvider", () => $964d8c42bd13cd02$export$78b7af8c530bd7a4);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9Nvh7 = parcelRequire("9Nvh7");

var $qXt2q = parcelRequire("qXt2q");

var $dXq4S = parcelRequire("dXq4S");

var $2NMNM = parcelRequire("2NMNM");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");
const $964d8c42bd13cd02$var$FilterQueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    filterQueryIsFetching: false,
    filterQueryIsNetworkError: false
});
$964d8c42bd13cd02$var$FilterQueryContext.displayName = 'FilterQueryContext';
const $964d8c42bd13cd02$export$5576614cd48b552 = ()=>(0, $5uXOq.useContext)($964d8c42bd13cd02$var$FilterQueryContext);
const $964d8c42bd13cd02$export$78b7af8c530bd7a4 = ({ refetch: refetch, query: query, children: children, filterId: filterId })=>{
    const [filterQueryIsFetching, setFilterQueryIsFetching] = (0, $5uXOq.useState)(false);
    const [filterQueryIsNetworkError, setFilterQueryNetworkError] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const activationId = (0, $fY39E.useActivationId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const inFlightRequest = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (filterId !== undefined && (0, $9Nvh7.isFilterId)(filterId)) {
            // Prevent race condition from multiple requests in progress
            // (ex. if user clicks quickly on different filters)
            inFlightRequest.current?.unsubscribe();
            const variables = {
                filterAri: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                includeFilter: true
            };
            setFilterQueryIsFetching(true);
            setFilterQueryNetworkError(false);
            inFlightRequest.current = (0, $8Uumt.fetchQuery)(environment, query, variables, {
                fetchPolicy: 'store-or-network'
            }).subscribe({
                complete: ()=>{
                    refetch(variables, {
                        fetchPolicy: 'store-only'
                    });
                    setFilterQueryIsFetching(false);
                },
                error: ()=>{
                    setFilterQueryIsFetching(false);
                    setFilterQueryNetworkError(true);
                }
            });
        } else // Need to refetch when filter is undefined so it reset filterData to empty
        refetch({
            includeFilter: false,
            filterAri: ''
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        activationId,
        cloudId,
        environment,
        filterId,
        query,
        refetch,
        setFilterQueryIsFetching,
        setFilterQueryNetworkError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (filterId !== undefined && (0, $9Nvh7.isFilterId)(filterId)) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $qXt2q.addFilterToRecent)(filterId, analyticsEvent);
        }
    }, [
        filterId,
        createAnalyticsEvent
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            filterQueryIsFetching: filterQueryIsFetching,
            filterQueryIsNetworkError: filterQueryIsNetworkError
        }), [
        filterQueryIsFetching,
        filterQueryIsNetworkError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($964d8c42bd13cd02$var$FilterQueryContext.Provider, {
        value: contextValue
    }, children);
};

});
parcelRegister("qXt2q", function(module, exports) {

$parcel$export(module.exports, "addFilterToRecent", () => $d3ebef4b85856e17$export$1f166118234b128e);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $d3ebef4b85856e17$export$1f166118234b128e = async (filterId, analyticsEvent)=>{
    try {
        await (0, $eusud.performPostRequest)((0, $530a97584bf6c339$export$3fdeac1311ebf841) + filterId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            event: analyticsEvent,
            meta: {
                id: 'addFilterToRecent',
                packageName: 'jiraIssueNavigatorCustomFilters'
            }
        });
    }
};

});
const $530a97584bf6c339$export$3fdeac1311ebf841 = '/rest/issueNav/1/history/saveFilter/';



parcelRegister("a5eZM", function(module, exports) {

$parcel$export(module.exports, "IssueSearch", () => $b919584441152507$export$ce2913cefc6e57dc);

var $gaK4T = parcelRequire("gaK4T");

var $26JO5 = parcelRequire("26JO5");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $4R6GH = parcelRequire("4R6GH");

var $9Nvh7 = parcelRequire("9Nvh7");

var $koeKL = parcelRequire("koeKL");

var $1TiUe = parcelRequire("1TiUe");

var $5eRaS = parcelRequire("5eRaS");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $gwtSG = parcelRequire("gwtSG");

var $1GlUV = parcelRequire("1GlUV");

var $foucT = parcelRequire("foucT");

var $1PJ7c = parcelRequire("1PJ7c");

var $aHzNA = parcelRequire("aHzNA");

var $hkDYg = parcelRequire("hkDYg");
const $b919584441152507$var$searchErrorFlagId = (0, $7HGHK.toFlagId)('ISSUE_NAVIGATOR_SEARCH_ERROR_FLAG');
const $b919584441152507$var$searchErrorFlag = {
    id: $b919584441152507$var$searchErrorFlagId,
    type: 'error',
    title: (0, $hkDYg.default).searchFailedTitle,
    description: (0, $hkDYg.default).searchFailedDescription,
    messageId: `issue-navigator.ui.issue-search.searchErrorFlag.${$b919584441152507$var$searchErrorFlagId}`,
    messageType: 'transactional'
};
const $b919584441152507$export$ce2913cefc6e57dc = ({ children: children, onPageDataLoad: onPageDataLoad, view: view, refetch: refetch, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, jiraView: jiraView, issueTableProps: issueTableProps })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { jql: jql, filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const issueSearchInput = (0, $5uXOq.useMemo)(()=>jql === undefined && (0, $9Nvh7.isFilterId)(filterId) ? {
            filterId: filterId
        } : {
            jql: jql
        }, [
        filterId,
        jql
    ]);
    const onSelectedViewMutation = (0, $aHzNA.useSelectedViewMutation)();
    const issueSearchViewData = (0, $8Uumt.useFragment)((0, $26JO5.default), view);
    const jiraViewData = (0, $8Uumt.useFragment)((0, $gaK4T.default), jiraView);
    let groupedByField = null;
    let isGroupingEnabled;
    let isHierarchyEnabled;
    let isHideDoneEnabled;
    let maybeViewId;
    if ((0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) {
        groupedByField = jiraViewData?.viewSettings?.groupByConfig?.groupByField?.fieldId ?? null;
        isGroupingEnabled = Boolean(issueTableProps?.isGroupingSupported) && Boolean(jiraViewData?.viewSettings?.isGroupingEnabled) && Boolean(jiraViewData?.viewSettings?.canEnableGrouping);
        isHierarchyEnabled = Boolean(isIssueHierarchySupportEnabled && jiraViewData?.viewSettings?.isHierarchyEnabled);
        isHideDoneEnabled = Boolean(jiraViewData?.viewSettings?.hideDone);
        maybeViewId = jiraViewData?.viewId;
    } else {
        isGroupingEnabled = false;
        isHierarchyEnabled = Boolean(isIssueHierarchySupportEnabled && issueSearchViewData?.viewConfigSettings?.isHierarchyEnabled);
        isHideDoneEnabled = Boolean(issueSearchViewData?.viewConfigSettings?.hideDone);
        maybeViewId = issueSearchViewData?.viewId;
    }
    const onRefetchStart = (0, $5uXOq.useCallback)(()=>{
        // Hide any search error flags currently visible
        dismissFlag($b919584441152507$var$searchErrorFlagId);
    }, [
        dismissFlag
    ]);
    const viewId = (0, $eJ0Zs.parseIssueNavigatorViewIdOrDefault)(maybeViewId);
    const isBifrost = (0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? !!(0, $5eRaS.ssr).getFeatureFlags()?.ssrViaBifrost : undefined;
    const { onIssueSearchFail: onIssueSearchFail } = (0, $1GlUV.useExperienceAnalytics)(onPageDataLoad, viewId, {
        ...isGroupingEnabled ? {
            experienceId: (0, $6UAdF.GROUPED_LIST_EXPERIENCE_ID)
        } : {},
        ...(0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? {
            isBifrost: isBifrost
        } : {}
    });
    const onRefetchError = (0, $5uXOq.useCallback)((error, refetchView)=>{
        onIssueSearchFail(`${(0, $6UAdF.PACKAGE_NAME)}.issue-search-refetch`, error, refetchView);
        showFlag($b919584441152507$var$searchErrorFlag);
    }, [
        onIssueSearchFail,
        showFlag
    ]);
    const projectContext = issueTableProps?.projectContext;
    (0, $foucT.useMainIssueNavigatorQueryShadowRequest)({
        first: 50,
        amountOfColumns: 500,
        fieldSetIds: [],
        shouldQueryFieldSetsById: false,
        cloudId: cloudId,
        issueSearchInput: issueSearchInput,
        atlassianIntelligenceProductFeature: 'NATURAL_LANGUAGE_TO_JQL',
        projectKey: projectContext ?? '',
        shouldQueryProject: false,
        filterId: filterId ?? null,
        viewConfigInput: {
            viewInput: {
                namespace: 'ISSUE_NAVIGATOR'
            }
        },
        fieldSetsInput: {
            viewInput: {
                namespace: 'ISSUE_NAVIGATOR',
                filterId: filterId ?? null
            }
        },
        shouldQueryHasChildren: true
    }, viewId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PJ7c.IssueSearchServiceContainer), {
        cloudId: cloudId,
        environment: environment,
        issueSearchInput: issueSearchInput,
        viewId: viewId,
        filterId: filterId,
        onPageDataLoad: onPageDataLoad,
        onRefetchStart: onRefetchStart,
        onRefetchError: onRefetchError,
        onSelectedViewMutation: onSelectedViewMutation,
        refetch: refetch,
        projectContext: projectContext,
        isHierarchyEnabled: isHierarchyEnabled,
        isHideDoneEnabled: isHideDoneEnabled,
        groupedByField: groupedByField,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled
    }, children);
};

});
parcelRegister("gaK4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59cfac77de15fb0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea21710515089caa04ab2a009d3b4e54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f59cfac77de15fb0$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "issueSearch_issueNavigatorGrouping",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "viewId"
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        },
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$f59cfac77de15fb0$var$node.hash = "94322c7d4a10c641a16cca59cc5dc927";
var $f59cfac77de15fb0$export$2e2bcd8739ae039 = $f59cfac77de15fb0$var$node;

});

parcelRegister("26JO5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca6e5afb96fea766$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<febf24c46a5b7469fc6147163ebf19bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ca6e5afb96fea766$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "issueSearch_issueNavigator",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewConfigSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "viewId"
            },
            "action": "THROW",
            "path": "viewId"
        }
    ],
    "type": "JiraIssueSearchView"
};
$ca6e5afb96fea766$var$node.hash = "003cd3c768e45103680b4e1e40fe414d";
var $ca6e5afb96fea766$export$2e2bcd8739ae039 = $ca6e5afb96fea766$var$node;

});

parcelRegister("foucT", function(module, exports) {

$parcel$export(module.exports, "fetchIssueNavigatorIssueSearchRefetchQueryShadow", () => $137529bbca2f4f2b$export$460584db8358ab3e);
$parcel$export(module.exports, "useMainIssueNavigatorQueryShadowRequest", () => $137529bbca2f4f2b$export$d0a69cc9f9c06a41);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $6UAdF = parcelRequire("6UAdF");
const $137529bbca2f4f2b$export$a5981df6f2a66c20 = async (variables, query, operationName, isGrouping = false)=>{
    try {
        await (0, $7f4tk.default)('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'X-ExperimentalApi': 'JiraIssueSearch, JiraProject'
            },
            body: JSON.stringify({
                operationName: operationName,
                query: query,
                variables: {
                    ...variables,
                    namespace: 'ISSUE_NAVIGATOR',
                    amountOfColumns: 500,
                    scope: {
                        operationScope: (0, $6UAdF.NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE)
                    },
                    // we want to use the new view schema for grouping
                    isRefactorNinToViewSchemaEnabled: isGrouping,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider: (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false),
                    __relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider: true,
                    // we want to use the new view schema for grouping
                    __relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider: isGrouping,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider: 1,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiralistinlineeditingrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: true
                }
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            attributes: {
                message: `Shadow request for nin issue search ${operationName} failed`
            },
            meta: {
                id: 'shadow-request-for-nin-issue-search',
                packageName: 'jiraIssueNavigator',
                teamName: 'empanada'
            }
        });
    }
};

const $137529bbca2f4f2b$var$getIssueNavigatorIssueSearchRefetchQueryShadowOperation = (isGrouping = false)=>{
    const operation = (parcelRequire("9KD4w")).then((module)=>{
        const operationName = `IssueNavigatorIssueSearchRefetch${isGrouping ? 'Grouping' : ''}QueryShadow`;
        return {
            operationName: operationName,
            operation: module.operation.replace('IssueNavigatorIssueSearchRefetchQuery', operationName)
        };
    });
    return operation;
};

const $137529bbca2f4f2b$var$getMainIssueNavigatorQueryShadowOperation = (isGrouping = false)=>{
    const operation = (parcelRequire("9u4tg")).then((module)=>{
        const operationName = `main_IssueNavigator${isGrouping ? 'Grouping' : ''}QueryShadow`;
        return {
            operationName: operationName,
            operation: module.operation.replace('main_IssueNavigatorQuery', operationName)
        };
    });
    return operation;
};
const $137529bbca2f4f2b$var$catchedCallback = (cb)=>{
    return (...args)=>{
        try {
            cb(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                attributes: {
                    message: 'Queue shadow request for nin issue search failed'
                },
                meta: {
                    id: 'queue-shadow-request-for-nin-issue-search',
                    packageName: 'jiraIssueNavigator',
                    teamName: 'empanada'
                }
            });
        }
    };
};
const $137529bbca2f4f2b$var$catchedCallbackAsync = (cb)=>{
    return async (...args)=>{
        try {
            await cb(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                attributes: {
                    message: 'Queue shadow request for nin issue search failed'
                },
                meta: {
                    id: 'queue-shadow-request-for-nin-issue-search',
                    packageName: 'jiraIssueNavigator',
                    teamName: 'empanada'
                }
            });
        }
    };
};
const $137529bbca2f4f2b$export$8ca28e57c08b20c8 = $137529bbca2f4f2b$var$catchedCallback((getOperation, variables, isGrouping = false)=>{
    if (false) return;
    // requestIdleCallback is not supported in Safari, so we need a workaround.
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback !== 'undefined') window.requestIdleCallback($137529bbca2f4f2b$var$catchedCallback(()=>setTimeout($137529bbca2f4f2b$var$catchedCallback(()=>{
            window.requestIdleCallback($137529bbca2f4f2b$var$catchedCallbackAsync(async ()=>{
                const query = await getOperation();
                $137529bbca2f4f2b$export$a5981df6f2a66c20(variables, query.operation, query.operationName, isGrouping);
            }));
        }), 5000)));
});
const $137529bbca2f4f2b$export$460584db8358ab3e = (variables, isGrouping)=>{
    $137529bbca2f4f2b$export$8ca28e57c08b20c8(()=>$137529bbca2f4f2b$var$getIssueNavigatorIssueSearchRefetchQueryShadowOperation(isGrouping), variables, isGrouping);
};
const $137529bbca2f4f2b$export$d0a69cc9f9c06a41 = (variables, viewId)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (variables.projectKey && viewId !== 'detail') {
            if ((0, $4R6GH.fg)('jira_list_hierarchy_shadow_requests')) $137529bbca2f4f2b$export$8ca28e57c08b20c8($137529bbca2f4f2b$var$getMainIssueNavigatorQueryShadowOperation, variables, false);
            else if ((0, $4R6GH.fg)('jira_list_group_shadow_requests')) {
                const groupByFields = [
                    'status',
                    'assignee',
                    'priority',
                    'com.atlassian.jira.plugin.system.customfieldtypes:float',
                    'com.pyxis.greenhopper.jira:jsw-story-points',
                    'com.pyxis.greenhopper.jira:gh-sprint',
                    'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category'
                ];
                // Switch between the main query with refactor enabled and with group by overrides
                const variableOverrides = (0, $4R6GH.fg)('jira_list_main_shadow_query_group_overrides') ? {
                    staticViewInput: {
                        isHierarchyEnabled: false,
                        isGroupingEnabled: true
                    },
                    viewConfigInput: {
                        staticViewInput: {
                            isHierarchyEnabled: false,
                            isGroupingEnabled: true
                        }
                    },
                    // Randomly select a groupBy field to test the shadow request
                    groupBy: groupByFields[Math.floor(Math.random() * groupByFields.length)]
                } : {};
                $137529bbca2f4f2b$export$8ca28e57c08b20c8(()=>$137529bbca2f4f2b$var$getMainIssueNavigatorQueryShadowOperation(true), {
                    ...variables,
                    ...variableOverrides
                }, true);
            }
        }
    // We only want to fetch the main query once, so we don't need to add any dependencies here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("9KD4w", function(module, exports) {

let $7196b7c9055dcf91$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7196b7c9055dcf91$var$load("6vTNm").then(()=>parcelRequire('8Ip33'));

});

parcelRegister("9u4tg", function(module, exports) {

let $6e7a6240dc5f52c7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e7a6240dc5f52c7$var$load("7A8XO").then(()=>parcelRequire('hd4f0'));

});


parcelRegister("1PJ7c", function(module, exports) {

$parcel$export(module.exports, "IssueSearchServiceContainer", () => $4a9e937233ca8a4b$export$3744f0b7d0dd1936);
$parcel$export(module.exports, "Store", () => $4a9e937233ca8a4b$export$390f32400eaf98c9);

var $7Jxgt = parcelRequire("7Jxgt");

var $6Z846 = parcelRequire("6Z846");

var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $012Fv = parcelRequire("012Fv");
const $4a9e937233ca8a4b$var$initialState = {
    disposables: [],
    isFetching: false,
    isFetchingView: false,
    isRefreshing: false,
    isNetworkError: false,
    searchKey: '',
    totalIssueCount: null,
    totalIssueCountIsFetching: false,
    totalIssueCountIsError: false
};
const $4a9e937233ca8a4b$export$3744f0b7d0dd1936 = (0, $gg7kZ.createContainer)();
const $4a9e937233ca8a4b$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'IssueSearchServiceStore',
    initialState: $4a9e937233ca8a4b$var$initialState,
    actions: $012Fv.actions,
    containedBy: $4a9e937233ca8a4b$export$3744f0b7d0dd1936,
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    searchKey: (0, $7Jxgt.v4)()
                });
            },
        onContainerUpdate: (nextProps, prevProps)=>({ dispatch: dispatch })=>{
                if (!(0, $6Z846.isShallowEqual)(nextProps.issueSearchInput, prevProps.issueSearchInput)) dispatch((0, $012Fv.onSearchInputUpdate)());
            },
        onDestroy: ()=>({ getState: getState })=>{
                const { disposables: disposables } = getState();
                // Dispose of any manually retained operations when the container is unmounted
                disposables.forEach((disposable)=>disposable.dispose());
            }
    }
});

});
parcelRegister("012Fv", function(module, exports) {

$parcel$export(module.exports, "onSearchInputUpdate", () => $a4a2e9f3a0dcbb02$export$61bc3f1fa2f74c3c);
$parcel$export(module.exports, "actions", () => $a4a2e9f3a0dcbb02$export$e324594224ef24da);

var $eANr0 = parcelRequire("eANr0");

var $7nsd3 = parcelRequire("7nsd3");

var $eiowN = parcelRequire("eiowN");

var $7Jxgt = parcelRequire("7Jxgt");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $9Nvh7 = parcelRequire("9Nvh7");

var $kF1V3 = parcelRequire("kF1V3");

var $1TiUe = parcelRequire("1TiUe");

var $c1haS = parcelRequire("c1haS");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $foucT = parcelRequire("foucT");
const $a4a2e9f3a0dcbb02$export$61bc3f1fa2f74c3c = ()=>({ dispatch: dispatch }, { issueSearchInput: issueSearchInput, filterId: filterId, viewId: viewId })=>{
        const shouldLoadWithFilterViewId = viewId !== 'detail' && issueSearchInput.filterId && (0, $9Nvh7.isCustomFilter)(issueSearchInput.filterId);
        const isCurrentViewIdInvalid = (0, $eJ0Zs.isFilterViewId)(viewId) && viewId !== `list_filter_${filterId}`;
        let variables = {};
        if (issueSearchInput.filterId && shouldLoadWithFilterViewId) {
            const issueNavigatorViewId = (0, $eJ0Zs.convertFilterIdToIssueNavigatorId)(issueSearchInput.filterId);
            variables = {
                viewId: issueNavigatorViewId,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: issueNavigatorViewId
                    }
                }
            };
        } else if (isCurrentViewIdInvalid) variables = {
            viewId: (0, $6UAdF.DEFAULT_VIEW_ID),
            fieldSetsInput: {
                viewInput: {
                    namespace: 'ISSUE_NAVIGATOR',
                    viewId: (0, $6UAdF.DEFAULT_VIEW_ID)
                }
            }
        };
        dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch(variables));
    };
const $a4a2e9f3a0dcbb02$export$9eb6b63e55022ba0 = ()=>({ setState: setState })=>{
        setState({
            totalIssueCount: null,
            totalIssueCountIsFetching: false,
            totalIssueCountIsError: false
        });
    };
const $a4a2e9f3a0dcbb02$export$e324594224ef24da = {
    onChangeView: (viewId)=>({ dispatch: dispatch }, { onSelectedViewMutation: onSelectedViewMutation, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled })=>{
            onSelectedViewMutation(viewId);
            dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch({
                viewId: viewId,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: viewId
                    }
                },
                // eslint-disable-next-line jira/ff/no-preconditioning
                ...(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && isIssueHierarchySupportEnabled && {
                    viewConfigInput: {
                        viewInput: {
                            namespace: 'ISSUE_NAVIGATOR',
                            viewId: viewId
                        }
                    },
                    shouldQueryHasChildren: viewId !== 'detail',
                    staticViewInput: null
                }
            }));
        },
    onChangeHierarchy: (nextIsHierarchyEnabled)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled })=>{
            if (nextIsHierarchyEnabled !== isHierarchyEnabled) {
                const staticViewInput = {
                    isHierarchyEnabled: nextIsHierarchyEnabled,
                    isGroupingEnabled: !!groupedByField,
                    ...(0, $4R6GH.fg)('jsc_list_hide_done_items') ? {
                        isHideDoneEnabled: isHideDoneEnabled
                    } : {}
                };
                dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch({
                    staticViewInput: staticViewInput,
                    viewConfigInput: {
                        staticViewInput: staticViewInput
                    },
                    shouldQueryHasChildren: Boolean(nextIsHierarchyEnabled)
                }));
            }
        },
    onChangeGroupedByField: (nextGroupedByField)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled })=>{
            const staticViewInput = {
                isHierarchyEnabled: isHierarchyEnabled,
                isGroupingEnabled: !!nextGroupedByField,
                ...(0, $4R6GH.fg)('jsc_list_hide_done_items') ? {
                    isHideDoneEnabled: isHideDoneEnabled
                } : {}
            };
            dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch({
                groupBy: nextGroupedByField,
                staticViewInput: staticViewInput,
                viewConfigInput: {
                    staticViewInput: staticViewInput
                }
            }));
        },
    onChangeHideDone: (nextIsHideDoneEnabled)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled })=>{
            if (nextIsHideDoneEnabled !== isHideDoneEnabled) {
                const staticViewInput = {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: !!groupedByField,
                    isHideDoneEnabled: nextIsHideDoneEnabled
                };
                dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch({
                    staticViewInput: staticViewInput,
                    viewConfigInput: {
                        staticViewInput: staticViewInput
                    },
                    shouldQueryHasChildren: Boolean(isHierarchyEnabled)
                }));
            }
        },
    onRefetch: (variables = {}, options = {})=>({ dispatch: dispatch, getState: getState, setState: setState }, { cloudId: cloudId, environment: environment, issueSearchInput: issueSearchInput, onRefetchStart: onRefetchStart, onRefetchError: onRefetchError, refetch: refetch, viewId: viewId, isHierarchyEnabled: isHierarchyEnabled, projectContext: projectContext, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled })=>{
            let { inFlightRequest: inFlightRequest } = getState();
            // Some consumers may fire refetch queries before in-flight query
            // has been completed (e.g. while user is toggling columns on and off in
            // the column picker). In these situations, we always want to fetch latest
            // data from the API as column configuration may have changed for the user.
            // To do that, we disable Relay's automatic de-deduping of requests.
            inFlightRequest?.unsubscribe();
            const staticViewInput = {
                isHierarchyEnabled: isHierarchyEnabled,
                isGroupingEnabled: !!groupedByField,
                isHideDoneEnabled: isHideDoneEnabled
            };
            let operationScope;
            if (projectContext) operationScope = (0, $1TiUe.isRefactorNinToViewSchemaEnabled)() ? (0, $6UAdF.NIN_PROJECT_SCHEMA_REFACTOR_OPERATION_SCOPE) : (0, $6UAdF.NIN_PROJECT_OPERATION_SCOPE);
            else operationScope = (0, $1TiUe.isRefactorNinToViewSchemaEnabled)() ? (0, $6UAdF.NIN_GLOBAL_SCHEMA_REFACTOR_OPERATION_SCOPE) : (0, $6UAdF.NIN_GLOBAL_OPERATION_SCOPE);
            const finalVariables = {
                cloudId: cloudId,
                issueSearchInput: issueSearchInput,
                first: (0, $6UAdF.MAX_ISSUES_PER_PAGE),
                after: null,
                namespace: 'ISSUE_NAVIGATOR',
                viewId: viewId,
                options: null,
                fieldSetIds: [],
                shouldQueryFieldSetsById: false,
                shouldQueryHasChildren: isHierarchyEnabled || false,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: viewId
                    }
                },
                amountOfColumns: (0, $6UAdF.MAX_AMOUNT_OF_COLUMNS),
                ...(0, $4R6GH.fg)('jsc_nin_operation_scope_fe') && {
                    scope: {
                        operationScope: operationScope
                    }
                },
                filterId: null,
                isRefactorNinToViewSchemaEnabled: (0, $1TiUe.isRefactorNinToViewSchemaEnabled)(),
                staticViewInput: staticViewInput,
                viewConfigInput: {
                    staticViewInput: staticViewInput
                },
                groupBy: groupedByField,
                isPaginating: false,
                projectKeys: projectContext ? [
                    projectContext
                ] : null,
                projectKey: projectContext ?? null,
                ...variables
            };
            inFlightRequest = (0, $eiowN.fetchQuery)(environment, (0, $kF1V3.default), finalVariables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                complete: ()=>{
                    /**
         * fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
         * data will remain saved in the Relay store at any point after the request completes.
         * We need to explicitly retain the operation to ensure it doesn't get deleted.
         * See https://relay.dev/docs/api-reference/fetch-query/#behavior
         */ const operation = (0, $eiowN.createOperationDescriptor)((0, $eiowN.getRequest)((0, $kF1V3.default)), finalVariables);
                    const { disposables: disposables } = getState();
                    setState({
                        disposables: disposables.concat([
                            environment.retain(operation)
                        ])
                    });
                    let hasStoreRefetchCompleted = false;
                    const storeRefetch = ()=>{
                        refetch(finalVariables, {
                            fetchPolicy: 'store-only',
                            onComplete: ()=>{
                                /**
               * Relay will dispose the cached operation after a 5m timeout, in which case it will
               * refetch the query from the store and retrigger the onComplete callback. We need to
               * ensure this callback is invoked strictly once to prevent unexpected side effects,
               * e.g. https://jira.atlassian.com/browse/JRACLOUD-84106.
               */ if (hasStoreRefetchCompleted) return;
                                hasStoreRefetchCompleted = true;
                                /**
               * A very difficult to debug race condition emerges when setState is called in the same
               * update cycle as our refetch function. It appears to be related to useSyncExternalStore
               * (used internally by RSS) internal state becoming out of sync which prevents it from
               * correctly notifying listeners (i.e. hooks consumers) when an update is made. Scheduling
               * the update at the end of the event loop is the simplest way of mitigating the bug,
               * but we should revisit this once React concurrent rendering is enabled.
               *
               * Bug this fixes: When clicking "refresh" button multiple times, the shaded loading
               * state on the table will only appear the first time.
               */ queueMicrotask(()=>{
                                    setState({
                                        isFetching: false,
                                        isFetchingView: false,
                                        searchKey: (0, $7Jxgt.v4)()
                                    });
                                    dispatch($a4a2e9f3a0dcbb02$export$9eb6b63e55022ba0());
                                    options.onComplete?.();
                                });
                            }
                        });
                    };
                    if ((0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('empanada_nin_concurrent_mode_fixes_concurrent_reqd')) /**
           * Delaying the store refetch until the next tick in order to avoid a race condition that occurs
           * when react concurrent mode is enabled. In the future (once concurrent mode rollout is
           * complete), we should replace this suspenseless refetch pattern with transitions.
           *
           * Bug this fixes: Features that perform state updates shortly after the refetch (like toggling
           * hierarchy or grouping) can result in a flicker between old results an new results.
           */ setTimeout(storeRefetch, 0);
                    else /**
           * We need to batch these updates as without it, Relay will cause multiple renders and invoke the
           * onComplete callback multiple times. This causes our success/fail analytics events to become
           * unreliable.
           * We introduced a similar fix for fetchQuery (see src/packages/platform/graphql/relay-scheduler/src/index.js)
           * and in React 18 will be able to remove this in favour of the startTransition/useTransition APIs.
           */ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unstable_batchedUpdates(storeRefetch);
                    if (projectContext && viewId !== 'detail') {
                        if ((0, $4R6GH.fg)('jira_list_hierarchy_shadow_requests')) (0, $foucT.fetchIssueNavigatorIssueSearchRefetchQueryShadow)({
                            ...finalVariables,
                            staticViewInput: {
                                ...(0, $4R6GH.fg)('jsc_list_hide_done_items') ? finalVariables.staticViewInput : {},
                                isHierarchyEnabled: true
                            },
                            viewConfigInput: {
                                staticViewInput: {
                                    ...finalVariables.viewConfigInput && (0, $4R6GH.fg)('jsc_list_hide_done_items') ? finalVariables.viewConfigInput.staticViewInput : {},
                                    isHierarchyEnabled: true
                                }
                            },
                            shouldQueryHasChildren: true
                        }, false);
                        else if ((0, $4R6GH.fg)('jira_list_group_shadow_requests')) {
                            const groupByFields = (0, $4R6GH.fg)('jira_list_main_shadow_query_group_overrides') ? [
                                'status',
                                'assignee',
                                'priority',
                                'com.atlassian.jira.plugin.system.customfieldtypes:float',
                                'com.pyxis.greenhopper.jira:jsw-story-points',
                                'com.pyxis.greenhopper.jira:gh-sprint',
                                'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category'
                            ] : [
                                'status',
                                'assignee',
                                'priority'
                            ];
                            (0, $foucT.fetchIssueNavigatorIssueSearchRefetchQueryShadow)({
                                ...finalVariables,
                                staticViewInput: {
                                    ...(0, $4R6GH.fg)('jsc_list_hide_done_items') ? finalVariables.staticViewInput : {},
                                    isHierarchyEnabled: false,
                                    isGroupingEnabled: true
                                },
                                viewConfigInput: {
                                    staticViewInput: {
                                        ...finalVariables.viewConfigInput && (0, $4R6GH.fg)('jsc_list_hide_done_items') ? finalVariables.viewConfigInput.staticViewInput : {},
                                        isHierarchyEnabled: false,
                                        isGroupingEnabled: true
                                    }
                                },
                                // Randomly select a groupBy field to test the shadow request
                                groupBy: groupByFields[Math.floor(Math.random() * groupByFields.length)]
                            }, true);
                        }
                    }
                },
                error: (error)=>{
                    setState({
                        isFetching: false,
                        isFetchingView: false,
                        isNetworkError: true
                    });
                    options.onError?.();
                    onRefetchError?.(error, (0, $eJ0Zs.parseIssueNavigatorViewIdOrDefault)(finalVariables.viewId));
                },
                unsubscribe: ()=>{
                    options.onUnsubscribe?.();
                }
            });
            onRefetchStart?.();
            setState({
                inFlightRequest: inFlightRequest,
                isFetching: true,
                isFetchingView: viewId !== finalVariables.viewId,
                isNetworkError: false
            });
        },
    onRefresh: ()=>({ setState: setState, dispatch: dispatch })=>{
            setState({
                isRefreshing: true
            });
            const onFinish = ()=>{
                setState({
                    isRefreshing: false
                });
            };
            dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch({}, {
                onComplete: onFinish,
                onError: onFinish,
                onUnsubscribe: onFinish
            }));
        },
    onFetchTotalIssueCount: ()=>({ setState: setState }, { environment: environment, cloudId: cloudId, issueSearchInput: issueSearchInput, isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled })=>{
            setState({
                totalIssueCount: null,
                totalIssueCountIsFetching: true,
                totalIssueCountIsError: false
            });
            const viewConfigInput = // eslint-disable-next-line jira/ff/no-preconditioning
            (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && isIssueHierarchySupportEnabled || isHideDoneEnabled && (0, $4R6GH.fg)('jsc_list_hide_done_items') ? {
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isHideDoneEnabled: isHideDoneEnabled
                }
            } : null;
            (0, $eiowN.fetchQuery)(environment, (0, $eANr0.default), {
                cloudId: cloudId,
                issueSearchInput: issueSearchInput,
                viewConfigInput: viewConfigInput
            }, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                next: (data)=>{
                    const totalIssueCount = data?.jira?.issueSearchTotalCount ?? null;
                    const totalIssueCountIsError = totalIssueCount === null;
                    setState({
                        totalIssueCount: totalIssueCount,
                        totalIssueCountIsFetching: false,
                        totalIssueCountIsError: totalIssueCountIsError
                    });
                },
                error: ()=>{
                    setState({
                        totalIssueCount: null,
                        totalIssueCountIsFetching: false,
                        totalIssueCountIsError: true
                    });
                }
            });
        }
};

});
parcelRegister("eANr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bed1c47c19db2e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f49d250c4b8366e370da7204a234835>>
 * @relayHash de122fab1f76e33de979655b8a8c56c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9cc42e6580b3f106e3737ff40b96eca4407846844604fe1c42ce16bba8fc5d
const $6bed1c47c19db2e0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewConfigInput"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewConfigInput",
                            "variableName": "viewConfigInput"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "issueSearchTotalCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "actions_issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "actions_issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2f9cc42e6580b3f106e3737ff40b96eca4407846844604fe1c42ce16bba8fc5d",
            "metadata": {},
            "name": "actions_issueSearchTotalCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6bed1c47c19db2e0$var$node.hash = "82fd57c594d13d97ce59735d9e84149d";
var $6bed1c47c19db2e0$export$2e2bcd8739ae039 = $6bed1c47c19db2e0$var$node;

});



parcelRegister("hkDYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc996088b4c53457$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cc996088b4c53457$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchFailedTitle: {
        "id": "issue-navigator.issue-search.search-failed-title",
        "defaultMessage": "We couldn't load your search results"
    },
    searchFailedDescription: {
        "id": "issue-navigator.issue-search.search-failed-description",
        "defaultMessage": "Refresh and try again."
    }
});

});


parcelRegister("en3WN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0c308f64e79b7ea$export$2e2bcd8739ae039);

var $1lc8w = parcelRequire("1lc8w");

var $gYyDI = parcelRequire("gYyDI");

var $9wiT5 = parcelRequire("9wiT5");

var $dTj8L = parcelRequire("dTj8L");

var $hH7GY = parcelRequire("hH7GY");

var $gWLDR = parcelRequire("gWLDR");

var $lxams = parcelRequire("lxams");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $dG0IQ = parcelRequire("dG0IQ");

var $SpDot = parcelRequire("SpDot");

var $fraBZ = parcelRequire("fraBZ");

var $5eRaS = parcelRequire("5eRaS");

var $fvbIR = parcelRequire("fvbIR");

var $4mO32 = parcelRequire("4mO32");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $koVbs = parcelRequire("koVbs");

var $9Nvh7 = parcelRequire("9Nvh7");

var $5Czte = parcelRequire("5Czte");

var $ffdpA = parcelRequire("ffdpA");

var $48rMm = parcelRequire("48rMm");

var $f7PHy = parcelRequire("f7PHy");

var $bSg1p = parcelRequire("bSg1p");

var $1XJ20 = parcelRequire("1XJ20");

var $5oFIy = parcelRequire("5oFIy");

var $1TiUe = parcelRequire("1TiUe");

var $5d1oN = parcelRequire("5d1oN");

var $cSD7y = parcelRequire("cSD7y");

var $6UAdF = parcelRequire("6UAdF");

var $bbbXL = parcelRequire("bbbXL");

var $a8lIB = parcelRequire("a8lIB");

var $kMfdg = parcelRequire("kMfdg");

var $5NwJk = parcelRequire("5NwJk");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");

var $cKK2E = parcelRequire("cKK2E");

var $isIOR = parcelRequire("isIOR");

var $38r5c = parcelRequire("38r5c");

var $gM6H8 = parcelRequire("gM6H8");

var $jfQeI = parcelRequire("jfQeI");

var $7jipW = parcelRequire("7jipW");

var $jKHs3 = parcelRequire("jKHs3");

var $hWyif = parcelRequire("hWyif");

var $aTDVl = parcelRequire("aTDVl");

var $gOpmP = parcelRequire("gOpmP");

var $7Cqtr = parcelRequire("7Cqtr");

var $5RTlC = parcelRequire("5RTlC");

var $6tXCF = parcelRequire("6tXCF");

var $dqObP = parcelRequire("dqObP");

var $cWY4u = parcelRequire("cWY4u");

var $887Eo = parcelRequire("887Eo");
const $a0c308f64e79b7ea$var$SidebarLayout = (0, $cSD7y.componentWithFG)('jira_nin_sidebar_layout', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5d1oN.SidebarLayout), {
        defaultRatio: 0.3,
        minWidth: 360,
        maxRatio: 0.75,
        teamName: "empanada",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $887Eo.SidebarExperienceRegistryWithErrorBoundary), null)
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWY4u.SidebarCloserController), null)), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
const $a0c308f64e79b7ea$var$staticEntrypointParams = {
    cloudId: undefined,
    projectKey: undefined
};
const $a0c308f64e79b7ea$var$staticUseEntryPointFGOff = {
    entryPointActions: {
        load: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    entryPointReferenceSubject: undefined
};
const $a0c308f64e79b7ea$var$IssueFieldStatisticsEntrypointProvider = (props)=>{
    if ((0, $6s1PB.expVal)('helios_list_view_statistics_nin_migration', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $SpDot.IssueFieldStatisticsEntrypointProvider), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
};
const $a0c308f64e79b7ea$var$ConditionalIssueTableSelectedIssuesContainer = ({ children: children, onIssueSelected: onIssueSelected })=>{
    if (!(0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false)) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $48rMm.IssueTableSelectedIssuesContainer), {
        onIssueSelected: onIssueSelected
    }, children);
};
const $a0c308f64e79b7ea$export$397fa57fff06920f = ({ CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, filter: filter, onPageDataLoad: onPageDataLoad, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, defaultJql: defaultJql, onRefinement: onRefinement, onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld, onIssueFlatListUpdated: onIssueFlatListUpdated, issueResults: issueResults, groupResults: groupResults, viewResult: viewResult, project: project, userPreferences: userPreferences, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey, issueTableProps: issueTableProps, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, jiraView: jiraView, initialQueryAsJql: initialQueryAsJql })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_NAVIGATOR_UI_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_NAVIGATOR_UI_END);
    }, []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [caughtIssueSearchError, setCaughtIssueSearchError] = (0, $5uXOq.useState)();
    const { filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const resolvedJql = (0, $gwtSG.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cKK2E.useFilterQuery)();
    const handleReset = (0, $5uXOq.useCallback)((isResetToFilter = false)=>{
        if (isResetToFilter) onChangeFilter && onChangeFilter();
        else onChangeJql && onChangeJql(defaultJql, true);
    }, [
        onChangeFilter,
        onChangeJql,
        defaultJql
    ]);
    const onChange = (0, $5uXOq.useCallback)((jql)=>{
        onRefinement && onRefinement();
        onChangeJql && onChangeJql(jql, !filterQueryIsFetching && filter === null && (0, $9Nvh7.isFilterId)(filterId));
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        onChangeJql,
        onRefinement
    ]);
    let searchKey;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    searchKey = (0, $38r5c.useSearchKey)();
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    searchKey = (0, $isIOR.useIssueSearchQuery)().searchKey;
    const previousData = (0, $1XJ20.usePrevious)(searchKey);
    const hasSearchChanged = Boolean(searchKey && searchKey !== previousData);
    const [{ view: selectedView }] = (0, $ih9zY.useSelectedViewState)();
    const issueResultsData = (0, $8Uumt.useFragment)((0, $lxams.default), issueResults);
    const groupResultsData = (0, $8Uumt.useFragment)((0, $gWLDR.default), groupResults);
    const viewResultData = (0, $8Uumt.useFragment)((0, $hH7GY.default), viewResult);
    const jiraViewData = (0, $8Uumt.useFragment)((0, $dTj8L.default), jiraView);
    const viewResultError = (0, $5uXOq.useMemo)(()=>{
        if (jiraViewData && (0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) {
            const message = jiraViewData.error?.message ?? '';
            const statusCode = jiraViewData.error?.extensions?.[0].statusCode;
            if (typeof statusCode !== 'number') return;
            return new (0, $jJZqs.default)(statusCode, message);
        }
        return viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode !== undefined && viewResultData?.extensions?.[0]?.statusCode !== null ? new (0, $jJZqs.default)(viewResultData?.extensions?.[0]?.statusCode, viewResultData?.message ?? '') : undefined;
    }, [
        jiraViewData,
        viewResultData?.__typename,
        viewResultData?.extensions,
        viewResultData?.message
    ]);
    const userPreferencesData = (0, $8Uumt.useFragment)((0, $9wiT5.default), userPreferences);
    const jqlBuilderWithAiData = (0, $8Uumt.useFragment)((0, $gYyDI.default), jqlBuilderWithAiKey);
    const projectData = (0, $8Uumt.useFragment)((0, $1lc8w.default), project);
    const isGrouping = (0, $5uXOq.useMemo)(()=>issueTableProps?.isGroupingSupported && jiraViewData?.viewSettings?.isGroupingEnabled && jiraViewData?.viewSettings?.canEnableGrouping, [
        issueTableProps?.isGroupingSupported,
        jiraViewData?.viewSettings?.canEnableGrouping,
        jiraViewData?.viewSettings?.isGroupingEnabled
    ]);
    const shouldAnnounceInfo = (0, $5uXOq.useMemo)(()=>hasSearchChanged && (isGrouping ? groupResultsData !== null : issueResultsData !== null && typeof issueResultsData.totalIssueSearchResultCount === 'number'), [
        hasSearchChanged,
        isGrouping,
        groupResultsData,
        issueResultsData
    ]);
    const [isAiEnabled, setIsAiEnabled] = (0, $5uXOq.useState)(false);
    const onToggleAi = (0, $5uXOq.useCallback)((isEnabled)=>{
        setIsAiEnabled(isEnabled);
    }, []);
    let hasServerError = issueResultsData?.issueSearchError?.__typename === 'JiraServerError';
    if ((0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) hasServerError = hasServerError || (groupResultsData?.errors ?? []).some(({ extensions: extensions })=>!extensions?.some(({ statusCode: statusCode })=>typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500));
    const hasViewNotFoundError = (0, $1TiUe.isRefactorNinToViewSchemaEnabled)() ? !!viewResultError && viewResultError.statusCode === 404 : viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode === 404;
    const noFilterReason = (0, $5uXOq.useMemo)(()=>{
        if (!filterQueryIsFetching && filter === null && (0, $9Nvh7.isFilterId)(filterId)) return 'Filter query mismatch';
        if (hasViewNotFoundError) return 'Filter not found in view result';
        return undefined;
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        hasViewNotFoundError
    ]);
    const IssueNavigatorTopBar = (0, $5uXOq.useMemo)(()=>{
        const jqlBuilder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gOpmP.default), {
            onChangeJql: onChange,
            defaultJql: defaultJql,
            filter: filter,
            onReset: handleReset,
            onFilterSave: onChangeFilter,
            groupResults: groupResultsData,
            issueResults: issueResultsData,
            onToggleAi: onToggleAi,
            jqlBuilderWithAiKey: jqlBuilderWithAiData,
            jqlBuilderProps: jqlBuilderProps,
            initialQueryAsJql: initialQueryAsJql
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, ActionMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqObP.default), {
            ActionMenu: ActionMenu,
            isGroupingSupported: issueTableProps?.isGroupingSupported,
            filter: filter,
            issueResults: issueResultsData,
            HeaderSkeletonImage: HeaderSkeletonImage,
            jqlBuilder: jqlBuilder,
            viewResult: viewResultData?.__typename === 'JiraIssueSearchView' ? viewResultData : null,
            jiraViewResult: jiraViewData
        }), CustomHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWyif.default), {
            CustomHeader: CustomHeader,
            filter: filter,
            issueResults: issueResultsData,
            HeaderSkeletonImage: HeaderSkeletonImage,
            viewResult: viewResultData?.__typename === 'JiraIssueSearchView' ? viewResultData : null,
            jiraViewResult: jiraViewData,
            isGroupingSupported: issueTableProps?.isGroupingSupported
        }), jqlBuilder));
    }, [
        onChange,
        defaultJql,
        filter,
        handleReset,
        onChangeFilter,
        groupResultsData,
        issueResultsData,
        onToggleAi,
        jqlBuilderWithAiData,
        jqlBuilderProps,
        initialQueryAsJql,
        ActionMenu,
        issueTableProps?.isGroupingSupported,
        HeaderSkeletonImage,
        viewResultData,
        jiraViewData,
        CustomHeader
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4mO32.useEntryPoint)((0, $fvbIR.asyncBulkOpsCoreEntryPoint), $a0c308f64e79b7ea$var$staticEntrypointParams) : $a0c308f64e79b7ea$var$staticUseEntryPointFGOff;
    let setFlatListIssueIds = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') && (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ setFlatListIssueIds: setFlatListIssueIds } = (0, $gM6H8.useFlatListIssuesActions)());
    const handleIssueFlatListUpdated = (0, $5uXOq.useCallback)((newFlatKeyList, newFlatIdList)=>{
        setFlatListIssueIds(newFlatIdList);
        if (onIssueFlatListUpdated) onIssueFlatListUpdated(newFlatKeyList, newFlatIdList);
    }, [
        setFlatListIssueIds,
        onIssueFlatListUpdated
    ]);
    let IssueNavigatorContent = (0, $5uXOq.useMemo)(()=>{
        const getAnnouncerMessage = ()=>{
            if (isGrouping) return formatMessage((0, $7Cqtr.default).screenReaderGroupResultInfo);
            let message;
            if (issueResultsData?.isCappingIssueSearchResult) message = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7Cqtr.default).screenReaderSearchResultMoreInfoIssueTermRefresh : (0, $7Cqtr.default).screenReaderSearchResultMoreInfo;
            else message = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7Cqtr.default).screenReaderSearchResultInfoIssueTermRefresh : (0, $7Cqtr.default).screenReaderSearchResultInfo;
            return formatMessage(message, {
                total: issueResultsData?.totalIssueSearchResultCount
            });
        };
        const HierarchyOnboardingProvider = (0, $4R6GH.fg)('jira_list_hierarchy_extraction') ? (0, $f7PHy.HierarchyOnboardingProvider) : (0, $bSg1p.HierarchyOnboardingProvider);
        const HierarchyOnboardingProviderComponent = // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? HierarchyOnboardingProvider : (0, $5uXOq.Fragment);
        const HideDoneOnboardingProviderComponent = (0, $4R6GH.fg)('jsc_list_hide_done_items') ? (0, $dG0IQ.HideDoneOnboardingProvider) : (0, $5uXOq.Fragment);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0c308f64e79b7ea$var$ConditionalIssueTableSelectedIssuesContainer, {
            onIssueSelected: entryPointActions.load
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0c308f64e79b7ea$var$IssueFieldStatisticsEntrypointProvider, {
            jql: resolvedJql,
            view: selectedView
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0c308f64e79b7ea$var$SidebarLayout, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7jipW.BulkOperationsWrapper // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        ), {
            // @ts-ignore - error TS2322: - type mismatch
            bulkOpsCoreEntryPointReference: entryPointReferenceSubject,
            fragmentRef: issueResultsData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HierarchyOnboardingProviderComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jfQeI.InlineFieldConfigProviderComponent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0c308f64e79b7ea$var$IssueNavigatorContentContainer, {
            selectedView: selectedView,
            "data-vc": `issue-navigator-content${false ? '-ssr' : ''}`,
            ...false && (0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && {
                'data-ssr-placeholder': 'issue-navigator-content-placeholder'
            },
            ...!false && (0, $4R6GH.fg)('add_ssr_placeholder_replacements_to_nin_and_nav') && {
                'data-ssr-placeholder-replace': 'issue-navigator-content-placeholder'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HideDoneOnboardingProviderComponent, null, IssueNavigatorTopBar), (0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ffdpA.JQLDebuggerRenderSlot), null) : null, !filterQueryIsFetching && filter === null && (0, $9Nvh7.isFilterId)(filterId) || hasViewNotFoundError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbbXL.NoFilter), {
            reason: noFilterReason
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
            message: getAnnouncerMessage(),
            shouldAnnounce: shouldAnnounceInfo,
            testId: "issue-navigator.ui.search-announcer"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTDVl.default), {
            hasServerError: hasServerError,
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            onChangeJql: onChangeJql,
            onCaughtIssueSearchError: setCaughtIssueSearchError,
            issueResults: issueResultsData,
            viewResult: viewResultData,
            jiraView: jiraViewData,
            project: projectData,
            groupResults: groupResultsData,
            issueTableProps: issueTableProps,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld,
            onIssueFlatListUpdated: handleIssueFlatListUpdated,
            filter: filter
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6tXCF.default), {
            hasIssueResults: !!issueResultsData?.totalIssueSearchResultCount,
            userPreferences: userPreferencesData,
            isAiEnabled: isAiEnabled
        }))))))));
    }, [
        entryPointActions.load,
        resolvedJql,
        selectedView,
        entryPointReferenceSubject,
        issueResultsData,
        IssueNavigatorTopBar,
        filterQueryIsFetching,
        filter,
        filterId,
        hasViewNotFoundError,
        noFilterReason,
        shouldAnnounceInfo,
        hasServerError,
        onChangeColumnConfiguration,
        onChangeJql,
        viewResultData,
        jiraViewData,
        projectData,
        groupResultsData,
        issueTableProps,
        isIssueHierarchySupportEnabled,
        onIssueFlatListUpdatedOld,
        handleIssueFlatListUpdated,
        userPreferencesData,
        isAiEnabled,
        isGrouping,
        formatMessage
    ]);
    const isFullPageIssueAppMode = (0, $5NwJk.useIsFullPageIssueAppMode)();
    if (isFullPageIssueAppMode) {
        const view = jiraViewData && (0, $6UAdF.isJiraIssueSearchViewMetadata)(jiraViewData) ? jiraViewData : null;
        const oldView = viewResultData?.__typename === 'JiraIssueSearchView' ? viewResultData : null;
        IssueNavigatorContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKHs3.default), {
            onChangeIssue: onChangeIssue,
            issueResults: issueResultsData,
            view: (0, $1TiUe.isRefactorNinToViewSchemaEnabled)() ? view : oldView,
            ...(0, $4R6GH.fg)('add-attribute-required-for-colorful-labels-expe') ? {
                projectType: projectData?.projectType
            } : {}
        });
    }
    (0, $5Czte.useGlobalScopeOptInFlag)();
    const hasSearchError = hasServerError || !!caughtIssueSearchError;
    const hasViewResultData = !!viewResultData;
    const hasViewResultError = viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode !== 404;
    let hasSearchResults = !!issueResultsData;
    let isFailedIssueSearch = !hasSearchResults || hasSearchError || !hasViewResultData || hasViewResultError;
    if ((0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) {
        hasSearchResults = !!issueResultsData || !!groupResultsData;
        isFailedIssueSearch = !hasSearchResults || hasSearchError || !jiraViewData || !!viewResultError && viewResultError.statusCode !== 404;
    }
    const isBifrost = (0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? !!(0, $5eRaS.ssr).getFeatureFlags()?.ssrViaBifrost : undefined;
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, IssueNavigatorContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5RTlC.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), isFailedIssueSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kMfdg.IssueSearchFail), {
            location: `${(0, $6UAdF.PACKAGE_NAME)}.ui`,
            error: caughtIssueSearchError || viewResultError || new Error('There was an error searching for issues'),
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled,
                ...isGrouping ? {
                    experienceId: (0, $6UAdF.GROUPED_LIST_EXPERIENCE_ID)
                } : {},
                ...(0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? {
                    isBifrost: isBifrost
                } : {}
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kMfdg.IssueSearchSuccess), {
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled,
                ...isGrouping ? {
                    experienceId: (0, $6UAdF.GROUPED_LIST_EXPERIENCE_ID)
                } : {},
                ...(0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? {
                    isBifrost: isBifrost
                } : {}
            }
        })), [
        IssueNavigatorContent,
        isFailedIssueSearch,
        caughtIssueSearchError,
        viewResultError,
        onPageDataLoad,
        isAiEnabled,
        isGrouping,
        isBifrost
    ]);
};
// re-render regression detection
$a0c308f64e79b7ea$export$397fa57fff06920f.whyDidYouRender = true;
var $a0c308f64e79b7ea$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($a0c308f64e79b7ea$export$397fa57fff06920f);
const $a0c308f64e79b7ea$var$IssueNavigatorContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedView: selectedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq _19pkidpf _2hwxxy5q _otyridpf _18u0xy5q",
            __cmplp.selectedView !== 'detail' && "_n3tdv47k _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1lc8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d058da013b06c2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cbc71691841953de0d125b05443d9491>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7d058da013b06c2d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_project"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$7d058da013b06c2d$var$node.hash = "3dd510242e3d4890b157f1d082cc36fa";
var $7d058da013b06c2d$export$2e2bcd8739ae039 = $7d058da013b06c2d$var$node;

});

parcelRegister("gYyDI", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaeb5527acfb0176$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b028ab22d769af59e1b92eab949e2221>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aaeb5527acfb0176$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey"
        }
    ],
    "type": "JiraQuery"
};
$aaeb5527acfb0176$var$node.hash = "e9088c921273ca13e8f1d0f476e2f2fb";
var $aaeb5527acfb0176$export$2e2bcd8739ae039 = $aaeb5527acfb0176$var$node;

});

parcelRegister("9wiT5", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d194ce17a15e42$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1da52f0913815b9fe1e6847953ff7bea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $98d194ce17a15e42$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "spotlight_issueNavigator_IssueNavigatorSpotlight"
        }
    ],
    "type": "JiraUserPreferences"
};
$98d194ce17a15e42$var$node.hash = "aa84b2b1589fd8e695aa782c018fd60c";
var $98d194ce17a15e42$export$2e2bcd8739ae039 = $98d194ce17a15e42$var$node;

});

parcelRegister("dTj8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $196e83c66a3d5847$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ee084f452ff2b0b656c712f239d84c39>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $196e83c66a3d5847$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_jiraView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "error",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Header_jiraViewResult"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_jiraView"
        },
        {
            "kind": "FragmentSpread",
            "name": "topBar_issueNavigator_jiraViewResult"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_FullPageIssueApp_view"
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$196e83c66a3d5847$var$node.hash = "516c1a5874a4fcc568615f6d3afee330";
var $196e83c66a3d5847$export$2e2bcd8739ae039 = $196e83c66a3d5847$var$node;

});

parcelRegister("hH7GY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d27e1baab967744$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1e0bf02376aa3d2c09b47fc757e49dd2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9d27e1baab967744$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_viewResult",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_viewResult"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_FullPageIssueApp_view"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_Header_viewResult"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "topBar_issueNavigator_viewResult"
                }
            ],
            "type": "JiraIssueSearchView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                },
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                }
            ],
            "type": "QueryError"
        }
    ],
    "type": "JiraIssueSearchViewResult",
    "abstractKey": "__isJiraIssueSearchViewResult"
};
$9d27e1baab967744$var$node.hash = "734c65301c902c4873569a6d77b57db1";
var $9d27e1baab967744$export$2e2bcd8739ae039 = $9d27e1baab967744$var$node;

});

parcelRegister("gWLDR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe56e9af641ec4ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bccaea827099599c35efdd1a65270e81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fe56e9af641ec4ca$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_groupResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_groupResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults"
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$fe56e9af641ec4ca$var$node.hash = "5d6a696ce62196724f5906b5a505895e";
var $fe56e9af641ec4ca$export$2e2bcd8739ae039 = $fe56e9af641ec4ca$var$node;

});

parcelRegister("lxams", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d22552440100cae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<58f0caa04f54df88b02dd1066d15c43f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6d22552440100cae$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "topBar_issueNavigator_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Header_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_FullPageIssueApp_issueResults"
        },
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$6d22552440100cae$var$node.hash = "ac60e0f31f3a7da92f2e220df7713938";
var $6d22552440100cae$export$2e2bcd8739ae039 = $6d22552440100cae$var$node;

});

parcelRegister("dG0IQ", function(module, exports) {

$parcel$export(module.exports, "HideDoneOnboardingProvider", () => $afb4196e3ab0f9dd$export$a84c251717c39a3e);
$parcel$export(module.exports, "useHideDoneOnboarding", () => $afb4196e3ab0f9dd$export$df78f68a5cea98eb);
$parcel$export(module.exports, "HideDoneOnboarding", () => $afb4196e3ab0f9dd$export$48041c15f880aebf);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $kbqIt = parcelRequire("kbqIt");

var $2NMNM = parcelRequire("2NMNM");

var $ioD1B = parcelRequire("ioD1B");

var $8zOmE = parcelRequire("8zOmE");

var $eGLgs = parcelRequire("eGLgs");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");


var $hNjGG = parcelRequire("hNjGG");
const $afb4196e3ab0f9dd$export$a611c8ca1952c1b5 = 'jira-nin-hide-done-onboarding-stg';
const $afb4196e3ab0f9dd$export$3d8a20f97116832b = 'jira-nin-hide-done-onboarding';
const $afb4196e3ab0f9dd$var$ENV_STAGING = 'staging';
const $afb4196e3ab0f9dd$var$STARGATE_URL = '/gateway/api';
const $afb4196e3ab0f9dd$var$HideDoneOnboardingContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $afb4196e3ab0f9dd$export$a84c251717c39a3e = ({ children: children })=>{
    const [showHideDoneOnboarding, setShowHideDoneOnboarding] = (0, $5uXOq.useState)(false);
    const value = (0, $5uXOq.useMemo)(()=>({
            showHideDoneOnboarding: showHideDoneOnboarding,
            setShowHideDoneOnboarding: setShowHideDoneOnboarding
        }), [
        showHideDoneOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($afb4196e3ab0f9dd$var$HideDoneOnboardingContext.Provider, {
        value: value
    }, children);
};
const $afb4196e3ab0f9dd$export$51d637936c6abe6f = ()=>{
    const hierarchyContext = (0, $5uXOq.useContext)($afb4196e3ab0f9dd$var$HideDoneOnboardingContext);
    if (!hierarchyContext) {
        (0, $jcw0u.default)({
            meta: {
                id: 'issueTableHideDoneOnboarding',
                packageName: (0, $60ea362de9a3f71f$export$b8b9d90f9e5bd72b),
                teamName: (0, $60ea362de9a3f71f$export$d57b6b390e78d90f)
            },
            error: new Error('useHideDoneOnboardingContext must be used within a HideDoneOnboardingProvider'),
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            showHideDoneOnboarding: false,
            setShowHideDoneOnboarding: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    return hierarchyContext;
};
const $afb4196e3ab0f9dd$export$df78f68a5cea98eb = ({ isHideDoneSupportEnabled: isHideDoneSupportEnabled })=>{
    const { showHideDoneOnboarding: showHideDoneOnboarding, setShowHideDoneOnboarding: setShowHideDoneOnboarding } = $afb4196e3ab0f9dd$export$51d637936c6abe6f();
    const ONBOARDING_ENGAGEMENT_ID = (0, $2tT7R.useEnvironment)() === $afb4196e3ab0f9dd$var$ENV_STAGING ? $afb4196e3ab0f9dd$export$a611c8ca1952c1b5 : $afb4196e3ab0f9dd$export$3d8a20f97116832b;
    const cloudId = (0, $koeKL.useCloudId)();
    /*
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the HideDone_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, $afb4196e3ab0f9dd$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $kbqIt.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $5uXOq.useEffect)(()=>{
        if (isEnrolled && isHideDoneSupportEnabled) {
            stopEnrolment(false);
            setShowHideDoneOnboarding(true);
        }
    }, [
        isEnrolled,
        isHideDoneSupportEnabled,
        setShowHideDoneOnboarding,
        stopEnrolment
    ]);
    return {
        showHideDoneOnboarding: showHideDoneOnboarding,
        setShowHideDoneOnboarding: setShowHideDoneOnboarding
    };
};
const $afb4196e3ab0f9dd$export$48041c15f880aebf = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    const { showHideDoneOnboarding: showHideDoneOnboarding, setShowHideDoneOnboarding: setShowHideDoneOnboarding } = $afb4196e3ab0f9dd$export$51d637936c6abe6f();
    const onCloseSpotlight = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'hideDoneOnboardingButton');
        setIsSpotlightActive(false);
        setShowHideDoneOnboarding(false);
    }, [
        createAnalyticsEvent,
        setShowHideDoneOnboarding
    ]);
    if (!showHideDoneOnboarding || !isSpotlightActive) return;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        messageId: "issue-table-hide-done-toggle.ui.onboarding.jira-spotlight.nin-hide-done-toggle-spotlight",
        messageType: "engagement",
        dialogPlacement: "left top",
        actions: [
            {
                onClick: onCloseSpotlight,
                text: formatMessage((0, $hNjGG.default).ok)
            }
        ],
        dialogWidth: 270,
        heading: formatMessage((0, $hNjGG.default).onboardingHeading),
        target: "nin-hide-done-toggle-spotlight",
        key: "nin-hide-done-toggle-spotlight",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)"
    }, formatMessage((0, $hNjGG.default).onboardingDescription)));
};

});
const $60ea362de9a3f71f$export$b8b9d90f9e5bd72b = 'jiraIssueTableHideDoneToggle';
const $60ea362de9a3f71f$export$d57b6b390e78d90f = 'keystone';
const $60ea362de9a3f71f$export$6a7d6ab86cfdfcdc = 'hideDoneToggle';
const $60ea362de9a3f71f$export$f7109619a5e9e0d6 = 'jira-native-issue-table';

parcelRegister("hNjGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f1d92c562e73bfa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f1d92c562e73bfa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    onboardingHeading: {
        "id": "jira-issue-table-hide-done-toggle.onboarding.onboarding-heading",
        "defaultMessage": "Hide done work items"
    },
    onboardingDescription: {
        "id": "jira-issue-table-hide-done-toggle.onboarding.onboarding-description",
        "defaultMessage": "Quickly hide work that's done without adding a filter."
    },
    ok: {
        "id": "jira-issue-table-hide-done-toggle.onboarding.done",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("SpDot", function(module, exports) {

$parcel$export(module.exports, "IssueFieldStatisticsEntrypointProvider", () => $0f9a73f89502d9ff$export$2043a5b19c8c0e7f);
$parcel$export(module.exports, "useIssueFieldStatisticsEntryPoint", () => $0f9a73f89502d9ff$export$8e48443ccac1a85f);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $l37qh = parcelRequire("l37qh");

var $6gWfU = parcelRequire("6gWfU");

var $h8Scx = parcelRequire("h8Scx");
const $0f9a73f89502d9ff$var$IssueFieldStatisticsEntrypointContext = (0, $l37qh.createUseEntryPointContext)();
const $0f9a73f89502d9ff$export$2043a5b19c8c0e7f = ({ children: children, jql: jql, view: view })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            jql: jql,
            view: view,
            namespace: (0, $6gWfU.ISSUE_SEARCH_NAMESPACE)
        }), [
        cloudId,
        jql,
        view
    ]);
    const createObjectEntryPoint = (0, $4mO32.useEntryPoint)((0, $h8Scx.issueFieldStatisticsStatisticsSidebarEntryPoint), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f9a73f89502d9ff$var$IssueFieldStatisticsEntrypointContext.Provider, {
        value: createObjectEntryPoint
    }, children);
};
const $0f9a73f89502d9ff$export$8e48443ccac1a85f = ()=>(0, $5uXOq.useContext)($0f9a73f89502d9ff$var$IssueFieldStatisticsEntrypointContext);

});
parcelRegister("l37qh", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $6e7e19c2d291c94c$export$41bce2223126846b);

var $5uXOq = parcelRequire("5uXOq");
const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $5uXOq.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});

parcelRegister("6gWfU", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_EXPERIENCE_NAME", () => $73aec7ab50e32fac$export$716d68d214fad041);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $73aec7ab50e32fac$export$de2495608df10495);

var $e4eHl = parcelRequire("e4eHl");
const $73aec7ab50e32fac$export$716d68d214fad041 = 'issue-field-statistics';
const $73aec7ab50e32fac$export$6d9ce65a72493aac = 'statistics';
const $73aec7ab50e32fac$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $73aec7ab50e32fac$var$AUTO_OPEN_SIDEBAR_KEY = 'sidebar';
const $73aec7ab50e32fac$export$b229a6bf782d77e7 = 'statistics-field';
const $73aec7ab50e32fac$export$c4ec2849fcb32515 = 'statistics-chart';
const $73aec7ab50e32fac$export$70a91e824238865d = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))($73aec7ab50e32fac$export$b229a6bf782d77e7);
const $73aec7ab50e32fac$export$60179bff81db3578 = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))($73aec7ab50e32fac$export$c4ec2849fcb32515);
const $73aec7ab50e32fac$export$1816113812ed602d = Object.freeze({
    [$73aec7ab50e32fac$var$AUTO_OPEN_SIDEBAR_KEY]: undefined,
    [$73aec7ab50e32fac$export$70a91e824238865d]: undefined,
    [$73aec7ab50e32fac$export$60179bff81db3578]: undefined
});

});

parcelRegister("h8Scx", function(module, exports) {

$parcel$export(module.exports, "issueFieldStatisticsStatisticsSidebarEntryPoint", () => $f4920e5a5ac1e1fb$export$89d0b9a4111dd3ef);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $9MMMd = parcelRequire("9MMMd");

const $f4920e5a5ac1e1fb$export$89d0b9a4111dd3ef = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6HwW0")), {
        moduleId: "4940af1a"
    }),
    getPreloadProps: ({ cloudId: cloudId, jql: jql, view: view, namespace: namespace })=>({
            queries: {
                issueFieldStatistics: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $9MMMd.default,
                    variables: {
                        cloudId: cloudId,
                        jql: jql,
                        view: view,
                        namespace: namespace
                    }
                }
            }
        })
});

});
parcelRegister("9MMMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $59215f0e9ec7314d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8169ecad465e715815c2295aecc1f51a>>
 * @relayHash cef0af5f1ffb6c1746574c08900d7ecb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 64da94b349b17c84216ef81da914f33538077ebcf1438ac672fad245104ad62d
const $59215f0e9ec7314d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "64da94b349b17c84216ef81da914f33538077ebcf1438ac672fad245104ad62d",
        "metadata": {},
        "name": "ui_StatisticsSidebarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $59215f0e9ec7314d$export$2e2bcd8739ae039 = $59215f0e9ec7314d$var$node;

});

parcelRegister("6HwW0", function(module, exports) {

let $4e104e5a1d584ea5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4e104e5a1d584ea5$var$load("6L0rz").then(()=>parcelRequire('lyMZX'));

});



parcelRegister("fvbIR", function(module, exports) {

$parcel$export(module.exports, "asyncBulkOpsCoreEntryPoint", () => $187b82d9aad4ec6a$export$d90d57132636bb1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $187b82d9aad4ec6a$export$d90d57132636bb1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("cSkfh")), {
        moduleId: "f81933b6"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cSkfh", function(module, exports) {

let $95fa3b7b254cbf84$var$load = (parcelRequire("28QjX"))(4);
module.exports = $95fa3b7b254cbf84$var$load("hXddo").then(()=>parcelRequire('k9wdm'));

});


parcelRegister("ffdpA", function(module, exports) {

$parcel$export(module.exports, "JQLDebuggerRenderSlotAsync", () => $31ef2c0ef7cee43c$export$222c67ffe33f4fa4);
$parcel$export(module.exports, "JQLDebuggerRenderSlot", () => $31ef2c0ef7cee43c$export$a3144a6f75ce69fe);

var $5uXOq = parcelRequire("5uXOq");

var $kxZPA = parcelRequire("kxZPA");
var $7hSN4 = parcelRequire("7hSN4");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $512eM = parcelRequire("512eM");

var $6eDsT = parcelRequire("6eDsT");

var $6OxoL = parcelRequire("6OxoL");

const $31ef2c0ef7cee43c$export$222c67ffe33f4fa4 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("36p9g")), {
    moduleId: "./src/packages/jql-builder/jql-debugger/src/ui/index.tsx"
});
function $31ef2c0ef7cee43c$export$e8398d4933a4ab21() {
    const [debuggerState] = (0, $512eM.useDebuggerStatus)();
    const debuggerActions = (0, $512eM.useJqlDebuggerStoreActions)();
    const [isAiEnabled] = (0, $512eM.useIsAiEnabled)();
    // Don't render the render slot when AI is not enabled
    if (!isAiEnabled) return null;
    // Don't render the render slot when the feature is at initial state
    if (debuggerState === 'INIT') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: (0, $6eDsT.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $6eDsT.ERROR_BOUNDARY_IDS).FIX_WITH_AI_MODAL,
        teamName: (0, $6eDsT.TEAM_NAME),
        fallback: "unmount",
        onError: ()=>{
            // On error, set the feature state to be JS_ERROR, so that such scenarios can be handled without
            // interfering with the feature initial state nor with the AI event instrumentation
            debuggerActions.setStatus('JS_ERROR');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31ef2c0ef7cee43c$export$222c67ffe33f4fa4, null)));
}
const $31ef2c0ef7cee43c$export$a3144a6f75ce69fe = (0, $cSD7y.componentWithFG)('gravityai-2283-jql-debugger-rll-to-entrypoints', (0, $6OxoL.JQLPanelRenderSlotForIssueView), $31ef2c0ef7cee43c$export$e8398d4933a4ab21);

});
parcelRegister("36p9g", function(module, exports) {

let $242570927895144d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $242570927895144d$var$load("iaSjP").then(()=>parcelRequire('hKkvZ'));

});


parcelRegister("48rMm", function(module, exports) {

$parcel$export(module.exports, "IssueTableSelectedIssuesContainer", () => $c785af315de8dae0$export$b11112517798dbed);
$parcel$export(module.exports, "useIssueTableSelectedIssuesActions", () => $c785af315de8dae0$export$b4602482fdfd31ed);
$parcel$export(module.exports, "useIssueTableSelectedIssues", () => $c785af315de8dae0$export$ad5f97924b14314b);
$parcel$export(module.exports, "useIsIssueSelected", () => $c785af315de8dae0$export$cfefd69fc8a5ac52);
$parcel$export(module.exports, "useAreAllIssuesSelected", () => $c785af315de8dae0$export$949e47631f4a60a5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $es90k = parcelRequire("es90k");
const $c785af315de8dae0$export$b11112517798dbed = (0, $gg7kZ.createContainer)();
const $c785af315de8dae0$var$Store = (0, $iXqE5.createStore)({
    initialState: $es90k.initialState,
    actions: $es90k.actions,
    name: 'jira-native-issue-table-selected-issues-state',
    containedBy: $c785af315de8dae0$export$b11112517798dbed
});
const $c785af315de8dae0$export$b4602482fdfd31ed = (0, $3sQ5x.createActionsHook)($c785af315de8dae0$var$Store);
const $c785af315de8dae0$var$getSelectedIssueIdsSelector = (state)=>{
    return Array.from(state.selectedIssueIds);
};
const $c785af315de8dae0$export$ad5f97924b14314b = (0, $3sQ5x.createStateHook)($c785af315de8dae0$var$Store, {
    selector: $c785af315de8dae0$var$getSelectedIssueIdsSelector
});
const $c785af315de8dae0$var$getIsIssueIdSelectedSelector = (state, issueId)=>{
    return state.selectedIssueIds.has(issueId);
};
const $c785af315de8dae0$export$cfefd69fc8a5ac52 = (0, $3sQ5x.createStateHook)($c785af315de8dae0$var$Store, {
    selector: $c785af315de8dae0$var$getIsIssueIdSelectedSelector
});
const $c785af315de8dae0$var$getAreAllIssuesSelectedSelector = (state, issueIds)=>{
    const selectedIssueIds = $c785af315de8dae0$var$getSelectedIssueIdsSelector(state);
    return issueIds.length > 0 && issueIds.every((issueId)=>selectedIssueIds.includes(issueId));
};
const $c785af315de8dae0$export$949e47631f4a60a5 = (0, $3sQ5x.createStateHook)($c785af315de8dae0$var$Store, {
    selector: $c785af315de8dae0$var$getAreAllIssuesSelectedSelector
});

});
parcelRegister("es90k", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $75d6ff2ec2275c29$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $75d6ff2ec2275c29$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $75d6ff2ec2275c29$export$d4c72bab9d6cc13a = {
    selectedIssueIds: new Set([]),
    lastSelectedRowIndex: null
};
const $75d6ff2ec2275c29$export$e324594224ef24da = {
    insertSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            onIssueSelected?.(selectedIssueIds);
            setState({
                selectedIssueIds: new Set([
                    ...currentState.selectedIssueIds,
                    ...selectedIssueIds
                ])
            });
        },
    removeSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            selectedIssueIds.forEach((selectedIssueId)=>{
                updatedSelectedIssueIds.delete(selectedIssueId);
            });
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    insertSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.add(selectedIssueId);
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    removeSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.delete(selectedIssueId);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    selectedOnlyIssueId: (selectedIssueId)=>({ setState: setState }, { onIssueSelected: onIssueSelected })=>{
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: new Set([
                    selectedIssueId
                ])
            });
        },
    updateLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState })=>{
            setState({
                lastSelectedRowIndex: lastSelectedRowIndex
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState($75d6ff2ec2275c29$export$d4c72bab9d6cc13a);
        },
    checkIssueRow: (issueId, isChecked, isShiftPressed, flatList)=>({ dispatch: dispatch, getState: getState })=>{
            const selectedIssueIds = [
                issueId
            ];
            const currentState = getState();
            const currentCheckedIndex = flatList.findIndex((id)=>id === issueId);
            if (isShiftPressed && currentState.lastSelectedRowIndex !== null) {
                const start = Math.min(currentState.lastSelectedRowIndex, currentCheckedIndex);
                const end = Math.max(currentState.lastSelectedRowIndex, currentCheckedIndex);
                selectedIssueIds.push(...flatList.slice(start, end + 1).filter((id)=>id !== issueId));
            }
            dispatch($75d6ff2ec2275c29$export$e324594224ef24da.updateLastSelectedRowIndex(currentCheckedIndex));
            if (isChecked) dispatch($75d6ff2ec2275c29$export$e324594224ef24da.insertSelectedIssueIds(selectedIssueIds));
            else dispatch($75d6ff2ec2275c29$export$e324594224ef24da.removeSelectedIssueIds(selectedIssueIds));
        }
};

});


parcelRegister("f7PHy", function(module, exports) {

$parcel$export(module.exports, "HierarchyOnboardingProvider", () => $2c829909fdbc1ce5$export$61ea399940cf79d6);
$parcel$export(module.exports, "useHierarchyOnboardingContext", () => $2c829909fdbc1ce5$export$34916c588fba606d);
$parcel$export(module.exports, "HierarchyOnboarding", () => $2c829909fdbc1ce5$export$19eb9bdb0cf578f5);
$parcel$export(module.exports, "HierarchyToggleOnboarding", () => $2c829909fdbc1ce5$export$e350c43a524c2f15);

var $5uXOq = parcelRequire("5uXOq");

var $kbqIt = parcelRequire("kbqIt");

var $1QiBP = parcelRequire("1QiBP");

var $ioD1B = parcelRequire("ioD1B");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $6s1PB = parcelRequire("6s1PB");

var $jA4v5 = parcelRequire("jA4v5");
const $2c829909fdbc1ce5$export$2d29273a16589c02 = 'jira-nin-hierarchy-onboarding-stg';
const $2c829909fdbc1ce5$export$e7deeb52c7c3e7a9 = 'jira-list-nin-hierarchy-onboarding';
const $2c829909fdbc1ce5$var$ENV_STAGING = 'staging';
const $2c829909fdbc1ce5$var$STARGATE_URL = '/gateway/api';
const $2c829909fdbc1ce5$var$HierarchyOnboardingContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $2c829909fdbc1ce5$export$61ea399940cf79d6 = ({ children: children })=>{
    const [showToggleOnboarding, setShowToggleOnboarding] = (0, $5uXOq.useState)(false);
    const value = (0, $5uXOq.useMemo)(()=>({
            showToggleOnboarding: showToggleOnboarding,
            setShowToggleOnboarding: setShowToggleOnboarding
        }), [
        showToggleOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c829909fdbc1ce5$var$HierarchyOnboardingContext.Provider, {
        value: value
    }, children);
};
const $2c829909fdbc1ce5$export$34916c588fba606d = ()=>{
    const hierarchyContext = (0, $5uXOq.useContext)($2c829909fdbc1ce5$var$HierarchyOnboardingContext);
    if (!hierarchyContext) throw new Error('useHierarchyOnboardingContext must be used within a HierarchyOnboardingProvider');
    return hierarchyContext;
};
const $2c829909fdbc1ce5$export$19eb9bdb0cf578f5 = ()=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $2tT7R.useEnvironment)() === $2c829909fdbc1ce5$var$ENV_STAGING ? $2c829909fdbc1ce5$export$2d29273a16589c02 : $2c829909fdbc1ce5$export$e7deeb52c7c3e7a9;
    const { setShowToggleOnboarding: setShowToggleOnboarding } = $2c829909fdbc1ce5$export$34916c588fba606d();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    /**
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the HIERARCHY_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, $2c829909fdbc1ce5$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(false);
    const [isEnrolled, stopEnrolment] = (0, $kbqIt.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $5uXOq.useEffect)(()=>{
        if (isEnrolled) {
            stopEnrolment(false);
            setIsSpotlightActive(true);
        }
    }, [
        isEnrolled,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isEnrolled && isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.expand-column-header",
        messageType: "engagement",
        actionsBeforeElement: "1/2",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    setShowToggleOnboarding(true);
                },
                text: formatMessage((0, $jA4v5.default).next)
            },
            {
                appearance: 'subtle',
                onClick: ()=>setIsSpotlightActive(false),
                text: formatMessage((0, $jA4v5.default).dismiss)
            }
        ],
        dialogWidth: 320,
        heading: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jA4v5.default).onboardingHeadingIssueTermRefresh : (0, $jA4v5.default).onboardingHeading),
        target: "expand-column-header",
        key: "expand-column-header",
        targetRadius: 3
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jA4v5.default).onboardingDescriptionIssueTermRefresh : (0, $jA4v5.default).onboardingDescription))));
};
const $2c829909fdbc1ce5$export$e350c43a524c2f15 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showToggleOnboarding: showToggleOnboarding, setShowToggleOnboarding: setShowToggleOnboarding } = $2c829909fdbc1ce5$export$34916c588fba606d();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    if (!isSpotlightActive || !showToggleOnboarding) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.hierarchy-feature-toggle",
        messageType: "engagement",
        actionsBeforeElement: "2/2",
        actions: [
            {
                onClick: ()=>{
                    setShowToggleOnboarding(false);
                    setIsSpotlightActive(false);
                },
                text: formatMessage((0, $jA4v5.default).ok)
            }
        ],
        dialogWidth: 320,
        target: "hierarchy-feature-toggle",
        key: "hierarchy-feature-toggle",
        targetRadius: 3
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jA4v5.default).toggleOnboardingIssueTermRefresh : (0, $jA4v5.default).toggleOnboarding)));
};

});
parcelRegister("jA4v5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac913e97fbfbe408$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ac913e97fbfbe408$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    onboardingHeading: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading",
        "defaultMessage": "View issue hierarchy"
    },
    onboardingHeadingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading-issue-term-refresh",
        "defaultMessage": "View hierarchy"
    },
    onboardingDescription: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child issues."
    },
    onboardingDescriptionIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description-issue-term-refresh",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child work items."
    },
    next: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.next",
        "defaultMessage": "Next"
    },
    toggleOnboarding: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding",
        "defaultMessage": "Use the toggle to show or hide the issue hierarchy."
    },
    toggleOnboardingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding-issue-term-refresh",
        "defaultMessage": "Use the toggle to show or hide the hierarchy."
    },
    ok: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.done",
        "defaultMessage": "Ok"
    },
    dismiss: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("bSg1p", function(module, exports) {

$parcel$export(module.exports, "HierarchyOnboardingProvider", () => $4708ffe3b7f78317$export$61ea399940cf79d6);
$parcel$export(module.exports, "useHierarchyOnboardingContext", () => $4708ffe3b7f78317$export$34916c588fba606d);
$parcel$export(module.exports, "HierarchyOnboarding", () => $4708ffe3b7f78317$export$19eb9bdb0cf578f5);
$parcel$export(module.exports, "HierarchyToggleOnboarding", () => $4708ffe3b7f78317$export$e350c43a524c2f15);

var $5uXOq = parcelRequire("5uXOq");

var $kbqIt = parcelRequire("kbqIt");

var $1QiBP = parcelRequire("1QiBP");

var $ioD1B = parcelRequire("ioD1B");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $6s1PB = parcelRequire("6s1PB");

var $7fpPT = parcelRequire("7fpPT");
const $4708ffe3b7f78317$export$2d29273a16589c02 = 'jira-nin-hierarchy-onboarding-stg';
const $4708ffe3b7f78317$export$e7deeb52c7c3e7a9 = 'jira-list-nin-hierarchy-onboarding';
const $4708ffe3b7f78317$var$ENV_STAGING = 'staging';
const $4708ffe3b7f78317$var$STARGATE_URL = '/gateway/api';
const $4708ffe3b7f78317$var$HierarchyOnboardingContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $4708ffe3b7f78317$export$61ea399940cf79d6 = ({ children: children })=>{
    const [showToggleOnboarding, setShowToggleOnboarding] = (0, $5uXOq.useState)(false);
    const value = (0, $5uXOq.useMemo)(()=>({
            showToggleOnboarding: showToggleOnboarding,
            setShowToggleOnboarding: setShowToggleOnboarding
        }), [
        showToggleOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4708ffe3b7f78317$var$HierarchyOnboardingContext.Provider, {
        value: value
    }, children);
};
const $4708ffe3b7f78317$export$34916c588fba606d = ()=>{
    const hierarchyContext = (0, $5uXOq.useContext)($4708ffe3b7f78317$var$HierarchyOnboardingContext);
    if (!hierarchyContext) throw new Error('useHierarchyOnboardingContext must be used within a HierarchyOnboardingProvider');
    return hierarchyContext;
};
const $4708ffe3b7f78317$export$19eb9bdb0cf578f5 = ()=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $2tT7R.useEnvironment)() === $4708ffe3b7f78317$var$ENV_STAGING ? $4708ffe3b7f78317$export$2d29273a16589c02 : $4708ffe3b7f78317$export$e7deeb52c7c3e7a9;
    const { setShowToggleOnboarding: setShowToggleOnboarding } = $4708ffe3b7f78317$export$34916c588fba606d();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    /**
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the HIERARCHY_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, $4708ffe3b7f78317$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(false);
    const [isEnrolled, stopEnrolment] = (0, $kbqIt.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $5uXOq.useEffect)(()=>{
        if (isEnrolled) {
            stopEnrolment(false);
            setIsSpotlightActive(true);
        }
    }, [
        isEnrolled,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isEnrolled && isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        messageId: "native-issue-table.ui.hierarchy-onboarding.jira-spotlight.expand-column-header",
        messageType: "engagement",
        actionsBeforeElement: "1/2",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    setShowToggleOnboarding(true);
                },
                text: formatMessage((0, $7fpPT.default).next)
            },
            {
                appearance: 'subtle',
                onClick: ()=>setIsSpotlightActive(false),
                text: formatMessage((0, $7fpPT.default).dismiss)
            }
        ],
        dialogWidth: 320,
        heading: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7fpPT.default).onboardingHeadingIssueTermRefresh : (0, $7fpPT.default).onboardingHeading),
        target: "expand-column-header",
        key: "expand-column-header",
        targetRadius: 3
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7fpPT.default).onboardingDescriptionIssueTermRefresh : (0, $7fpPT.default).onboardingDescription))));
};
const $4708ffe3b7f78317$export$e350c43a524c2f15 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showToggleOnboarding: showToggleOnboarding, setShowToggleOnboarding: setShowToggleOnboarding } = $4708ffe3b7f78317$export$34916c588fba606d();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    if (!isSpotlightActive || !showToggleOnboarding) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        messageId: "native-issue-table.ui.hierarchy-onboarding.jira-spotlight.hierarchy-feature-toggle",
        messageType: "engagement",
        actionsBeforeElement: "2/2",
        actions: [
            {
                onClick: ()=>{
                    setShowToggleOnboarding(false);
                    setIsSpotlightActive(false);
                },
                text: formatMessage((0, $7fpPT.default).ok)
            }
        ],
        dialogWidth: 320,
        target: "hierarchy-feature-toggle",
        key: "hierarchy-feature-toggle",
        targetRadius: 3
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7fpPT.default).toggleOnboardingIssueTermRefresh : (0, $7fpPT.default).toggleOnboarding)));
};

});
parcelRegister("7fpPT", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c397747d610703a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6c397747d610703a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    onboardingHeading: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading",
        "defaultMessage": "View issue hierarchy"
    },
    onboardingHeadingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading-issue-term-refresh",
        "defaultMessage": "View hierarchy"
    },
    onboardingDescription: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child issues."
    },
    onboardingDescriptionIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description-issue-term-refresh",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child work items."
    },
    next: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.next",
        "defaultMessage": "Next"
    },
    toggleOnboarding: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding",
        "defaultMessage": "Use the toggle to show or hide the issue hierarchy."
    },
    toggleOnboardingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding-issue-term-refresh",
        "defaultMessage": "Use the toggle to show or hide the hierarchy."
    },
    ok: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.done",
        "defaultMessage": "Ok"
    },
    dismiss: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("5d1oN", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $f718399f9a5c6176$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");

var $evhhl = parcelRequire("evhhl");

var $7CMCs = parcelRequire("7CMCs");

var $f98ZZ = parcelRequire("f98ZZ");

const $f718399f9a5c6176$export$8295a33ab8a36876 = ({ children: children, content: content, teamName: teamName, defaultRatio: defaultRatio, minWidth: minWidth, minRatio: minRatio, maxRatio: maxRatio })=>{
    const [{ id: id }, { closeSidebar: closeSidebar }] = (0, $f98ZZ.useSidebar)();
    // reset sidebar content on view unmount
    (0, $5uXOq.useEffect)(()=>()=>{
            closeSidebar();
        }, [
        closeSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        testId: "platform-sidebar.ui.sidebar-layout",
        xcss: $f718399f9a5c6176$var$styles.wrapper,
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $f718399f9a5c6176$var$styles.childContentContainer
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "sidebarWrapper",
        packageName: (0, $82deb0810ac24613$export$b8b9d90f9e5bd72b),
        teamName: teamName,
        fallback: "flag",
        attributes: {
            sidebarExperienceId: id
        }
    }, id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $evhhl.default), {
        defaultRatio: defaultRatio,
        minWidth: minWidth,
        minRatio: minRatio,
        maxRatio: maxRatio
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ...props,
            className: (0, $bwpsq.default)([
                $f718399f9a5c6176$var$styles.sidebarContentContainer
            ])
        }, content)) : null));
};
const $f718399f9a5c6176$var$styles = {
    wrapper: "_4t3i1osq _18m91wug",
    sidebarContentContainer: "_16qs1cd0 _18u0xmi2",
    childContentContainer: "_16jlkb7n _1o9zkb7n _i0dlidpf _18m91wug"
};

});
parcelRegister("evhhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed706472ac6afb2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "resizerStyleOverrides", () => $fed706472ac6afb2$export$70af81d424c0709);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eygxC = parcelRequire("eygxC");

var $jgytl = parcelRequire("jgytl");

var $f65qx = parcelRequire("f65qx");
var $fed706472ac6afb2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { children: children, ...resizerProps } = props;
    const { minRatio: minRatio = 0, maxRatio: maxRatio = 1, minWidth: minWidth, maxWidth: maxWidth, initialRatio: initialRatio, defaultRatio: defaultRatio, extraWidth: extraWidth, position: position = 'left', resizeHandleAsOverlay: resizeHandleAsOverlay, collapsed: collapsed, additionalStyles: additionalStyles } = resizerProps;
    // Ensure the ratio which is initially set to the flex-basis style is bounded between the min/max ratios
    // The css properties handles max-width and min-width
    const ratio = (0, $5uXOq.useRef)((0, $jgytl.clampValue)({
        value: initialRatio ?? defaultRatio,
        minValue: minRatio,
        maxValue: maxRatio
    }));
    /** If resizer is expanded and the ratio is 0, set the ratio to the initial ratio.
   *  This logic would need to change if we allow users to "uncollapse" the resizer manually, because currently this code will reset the ratio to the initial ratio.
   */ if (!collapsed && ratio.current === 0) ratio.current = (0, $jgytl.clampValue)({
        value: initialRatio ?? defaultRatio,
        minValue: minRatio,
        maxValue: maxRatio
    });
    const container = (0, $5uXOq.useRef)(null);
    const renderHandle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f65qx.default), {
            additionalStyles: additionalStyles,
            ...resizerProps,
            ...initialRatio !== undefined ? {
                initialRatio: ratio.current,
                defaultRatio: (0, $jgytl.clampValue)({
                    value: defaultRatio,
                    minValue: minRatio,
                    maxValue: maxRatio
                })
            } : {
                defaultRatio: ratio.current
            },
            childrenContainerRef: container
        });
    const renderResizer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, position === 'left' && renderHandle(), typeof children === 'function' ? children({
            ref: (r)=>{
                container.current = r;
            },
            style: (0, $jgytl.getChildrenStyle)(ratio.current, minWidth, maxWidth, extraWidth, collapsed)
        }) : children, position === 'right' && renderHandle());
    return resizeHandleAsOverlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fed706472ac6afb2$export$c7990a6594835e51, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $jgytl.getChildrenStyle)(ratio.current, minWidth, maxWidth, extraWidth, collapsed),
        ref: container,
        "data-testid": "flex-resizer.ui.resize-wrapper"
    }, renderResizer()) : renderResizer();
});
const $fed706472ac6afb2$export$c7990a6594835e51 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _lcxv1wug _q0u0kb7n _2e98kb7n _12rof1ug",
            __cmplp.className
        ])
    });
});
const $fed706472ac6afb2$export$70af81d424c0709 = (0, $eygxC.resizerStyleOverrides);

});
parcelRegister("eygxC", function(module, exports) {

$parcel$export(module.exports, "resizerStyleOverrides", () => $361c03a737fc18e2$export$70af81d424c0709);
const $361c03a737fc18e2$export$70af81d424c0709 = {
    ISSUE_VIEW_MARGIN_OFFSET: 'issue-view-margin-offset'
};

});

parcelRegister("jgytl", function(module, exports) {

$parcel$export(module.exports, "RESIZE_HANDLE_WIDTH", () => $242c5845cb693839$export$45f504201feb6ea6);
$parcel$export(module.exports, "useAnimationFrameThrottle", () => $242c5845cb693839$export$9d3ed311e5db6a6f);
$parcel$export(module.exports, "useDoubleClick", () => $242c5845cb693839$export$b1d0a5c81935127f);
$parcel$export(module.exports, "clampValue", () => $242c5845cb693839$export$31ee16100cde6ce2);
$parcel$export(module.exports, "calculateNewRatio", () => $242c5845cb693839$export$58e1996e98bfba9e);
$parcel$export(module.exports, "getChildrenStyle", () => $242c5845cb693839$export$f2a5e228fabed40b);

var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");
const $242c5845cb693839$export$45f504201feb6ea6 = 3 * (0, $gwIPs.gridSize) + 2;
const $242c5845cb693839$export$9d3ed311e5db6a6f = (callback)=>{
    const token = (0, $5uXOq.useRef)(null);
    const lastArgs = (0, $5uXOq.useRef)(null);
    const hasTriggered = (0, $5uXOq.useRef)(false);
    const handleFrame = (0, $5uXOq.useCallback)(()=>{
        lastArgs.current = null;
        hasTriggered.current = false;
    }, []);
    const throttle = (0, $5uXOq.useCallback)((...args)=>{
        lastArgs.current = args;
        if (hasTriggered.current) return;
        callback(...args);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        token.current = window.requestAnimationFrame(handleFrame);
        hasTriggered.current = true;
    }, [
        handleFrame,
        callback
    ]);
    const cancel = (0, $5uXOq.useCallback)(()=>{
        if (token.current) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cancelAnimationFrame(token.current);
        if (!hasTriggered.current && lastArgs.current !== null) callback(...lastArgs.current);
        token.current = null;
        lastArgs.current = null;
        hasTriggered.current = false;
    }, [
        callback
    ]);
    (0, $5uXOq.useEffect)(()=>()=>cancel(), [
        callback,
        cancel
    ]);
    return [
        throttle,
        cancel
    ];
};
const $242c5845cb693839$export$b1d0a5c81935127f = (callback)=>{
    const lastClickTime = (0, $5uXOq.useRef)(0);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const now = Date.now();
        if (now - lastClickTime.current < 500) {
            lastClickTime.current = 0;
            callback();
            return true;
        }
        lastClickTime.current = now;
        return false;
    }, [
        callback
    ]);
    return handleClick;
};
const $242c5845cb693839$export$29ae71364f84a225 = (element)=>{
    const style = getComputedStyle(element);
    const paddingX = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    return paddingX;
};
const $242c5845cb693839$export$31ee16100cde6ce2 = ({ value: value, minValue: minValue, maxValue: maxValue })=>Math.min(Math.max(value, minValue), maxValue);
const $242c5845cb693839$export$58e1996e98bfba9e = ({ parentWidth: parentWidth, currentWidth: currentWidth, deltaX: deltaX, minWidth: minWidth, minRatio: minRatio, maxWidth: maxWidth, maxRatio: maxRatio, baseWidth: baseWidth, position: position })=>{
    const targetWidth = Math.min(Math.max(currentWidth - baseWidth + (position === 'left' ? deltaX : deltaX * -1), minWidth), maxWidth);
    return $242c5845cb693839$export$31ee16100cde6ce2({
        value: targetWidth / parentWidth,
        minValue: minRatio,
        maxValue: maxRatio
    });
};
const $242c5845cb693839$export$f2a5e228fabed40b = (ratio, minWidth, maxWidth, extraWidth = 0, collapsed = false)=>({
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: (()=>{
            if (collapsed) return '0%';
            return extraWidth > 0 ? `calc(${ratio * 100}% + ${extraWidth}px)` : `${ratio * 100}%`;
        })(),
        minWidth: (()=>{
            if (collapsed) return 0;
            return minWidth !== undefined ? minWidth : null;
        })(),
        maxWidth: (()=>{
            if (collapsed) return 0;
            return maxWidth !== undefined ? maxWidth : null;
        })()
    });

});

parcelRegister("f65qx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e21000af4826614$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $cay7e = parcelRequire("cay7e");

var $dOj0C = parcelRequire("dOj0C");
var $6e21000af4826614$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.issue.view.resizer",
        packageName: "async.issue.view.resizer",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeHandle), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cay7e.default), props)));

});
parcelRegister("cay7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e1b555b6155529f$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $22Gxp = parcelRequire("22Gxp");

var $3bDjY = parcelRequire("3bDjY");

var $3Qiip = parcelRequire("3Qiip");

var $hWZau = parcelRequire("hWZau");

var $jldZL = parcelRequire("jldZL");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $1XJ20 = parcelRequire("1XJ20");

var $jgytl = parcelRequire("jgytl");

var $gxE4O = parcelRequire("gxE4O");

var $aydCa = parcelRequire("aydCa");

var $2rgs5 = parcelRequire("2rgs5");

var $dOj0C = parcelRequire("dOj0C");
const $8e1b555b6155529f$var$RESIZE_ICON_TEST_ID = 'flex-resizer.ui.handle.resize-icon';
const $8e1b555b6155529f$var$RESIZE_CHEVRON_ICON = 'flex-resizer.ui.handle.chevron-';
const $8e1b555b6155529f$var$resizeCursorCollapsed = null;
const $8e1b555b6155529f$var$resizeCursor = null;
const $8e1b555b6155529f$var$grabAreaStyles = {
    root: "_1bsbo7ao _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _vp7g1p6i _30l31p6i _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h1p6i"
};
const $8e1b555b6155529f$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbyh40 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e02cy7w"
};
const $8e1b555b6155529f$var$TooltipWrapper = ({ toolTipContent: toolTipContent, children: children })=>{
    if (toolTipContent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: toolTipContent,
        hideTooltipOnClick: true
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $8e1b555b6155529f$var$Resizer = ({ childrenContainerRef: childrenContainerRef, initialRatio: initialRatio, defaultRatio: defaultRatio, minWidth: minWidth, minRatio: minRatio = 0, maxWidth: maxWidth, maxRatio: maxRatio = 1, extraWidth: extraWidth = 0, position: position = 'left', resizeHandleAsOverlay: resizeHandleAsOverlay, resizeHandleZIndex: resizeHandleZIndex, onRatioChange: onRatioChange, onRatioReset: onRatioReset, onResizeStart: onResizeStart, chevronDirection: chevronDirection, persistResizeIcon: persistResizeIcon, onResizeHandleClick: onResizeHandleClick, collapsed: collapsed, minWidthLeftContainer: minWidthLeftContainer, minWidthRightContainer: minWidthRightContainer, toolTipContent: toolTipContent, additionalStyles: additionalStyles })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startWidth = (0, $5uXOq.useRef)(0);
    const parentWidth = (0, $5uXOq.useRef)(0);
    const onResizeStartStableRef = (0, $5uXOq.useRef)(onResizeStart);
    const onResizeEndStableRef = (0, $5uXOq.useRef)(onRatioChange);
    const [rangeInputValue, setRangeInputValue] = (0, $5uXOq.useState)(maxRatio - (initialRatio ?? defaultRatio));
    const [inputRange, setInputRange] = (0, $5uXOq.useState)({
        min: 0,
        max: 1
    }); /*
           onRatioChange calls setFlexBasisProp from the parent component. Even if the slider value changes to 0 there are
        chances the line splitter can min go upto 0.2. If, user performs keyboard navigation the user will not see any movement
        if the value was 0 unless it reaches to 0.2 lets say
      	  To avoid this, lineSplitterRef.current.getBoundingClientRect -> returns width giving the exact position of the line and we
        can thus update the ratio which we are doing on handleSliderFocus
      */ 
    const lineSplitterRef = (0, $5uXOq.useRef)(null);
    const [keyboardResizeManager] = (0, $5uXOq.useState)(()=>(0, $2rgs5.createKeyboardResizeManager)({
            onResizeStart: ()=>onResizeStartStableRef.current?.(),
            onResizeEnd: (...args)=>{
                return onResizeEndStableRef.current?.(...args);
            }
        }));
    const prevChevronDirection = (0, $1XJ20.usePreviousWithInitial)(chevronDirection);
    const nextRatio = (0, $5uXOq.useRef)(initialRatio ?? defaultRatio);
    const styleElement = (0, $5uXOq.useRef)(null);
    const labelId = (0, $22Gxp.useUID)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        /*
    initialRatio is 0 means Panel splitter is completely closed
          When it is collapsed and initialRatio is 0, next time when we expand,
    range should take defaultRatio
           Else
           If initialRatio is > 0, when we collapse the panel and expand, range should take initialRatio.
          */ if (collapsed && (0, $4R6GH.fg)('jira_a11y_pannel_splitter_navigations')) setRangeInputValue(maxRatio - (initialRatio && initialRatio !== 0 ? initialRatio : defaultRatio));
    }, [
        collapsed,
        initialRatio,
        defaultRatio,
        maxRatio
    ]);
    const setFlexBasisProp = (0, $5uXOq.useCallback)((ratio, setNextRatio)=>{
        // This will force-fix any in consitencies in the ratio value if ratio is set from parent components
        if (setNextRatio !== undefined) nextRatio.current = setNextRatio;
        if (childrenContainerRef.current) childrenContainerRef.current.style.setProperty('flex-basis', extraWidth > 0 ? `calc(${ratio * 100}% + ${extraWidth}px)` : `${ratio * 100}%`);
    }, [
        childrenContainerRef,
        extraWidth
    ]);
    const resetDetector = (0, $jgytl.useDoubleClick)((0, $5uXOq.useCallback)(()=>{
        const targetRatio = (0, $jgytl.clampValue)({
            value: defaultRatio * parentWidth.current,
            minValue: Math.max(minWidth ?? 0, minRatio * parentWidth.current),
            maxValue: Math.min(maxWidth ?? Infinity, maxRatio * parentWidth.current)
        }) / parentWidth.current;
        nextRatio.current = targetRatio;
        setFlexBasisProp(targetRatio);
        onRatioReset?.(targetRatio);
    }, [
        defaultRatio,
        minWidth,
        minRatio,
        maxWidth,
        maxRatio,
        setFlexBasisProp,
        onRatioReset
    ]));
    const [onPointerMoveThrottled, cancelPointerMove] = (0, $jgytl.useAnimationFrameThrottle)((0, $5uXOq.useCallback)((e)=>{
        const r = (0, $jgytl.calculateNewRatio)({
            parentWidth: parentWidth.current,
            currentWidth: startWidth.current,
            deltaX: startX.current - e.pageX,
            minWidth: minWidth ?? 0,
            minRatio: minRatio,
            maxWidth: maxWidth ?? Infinity,
            maxRatio: maxRatio,
            baseWidth: extraWidth,
            position: position
        });
        nextRatio.current = r;
        setFlexBasisProp(r);
    }, [
        extraWidth,
        maxRatio,
        maxWidth,
        minRatio,
        minWidth,
        position,
        setFlexBasisProp
    ]));
    const onPointerMove = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        onPointerMoveThrottled(e);
    }, [
        onPointerMoveThrottled
    ]);
    const onPointerUp = (0, $5uXOq.useCallback)(()=>{
        const r = nextRatio.current;
        const resetTriggered = resetDetector();
        if (!resetTriggered) onRatioChange?.(r, nextRatio.current * parentWidth.current, setFlexBasisProp);
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('pointermove', onPointerMove, {
            capture: true
        }); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('pointerup', onPointerUp, {
            capture: true
        });
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            stylesheet.deleteRule(1);
            stylesheet.deleteRule(0);
        }
        cancelPointerMove();
        if ((0, $4R6GH.fg)('jira_a11y_pannel_splitter_navigations')) setRangeInputValue(maxRatio - r);
    }, [
        cancelPointerMove,
        onPointerMove,
        onRatioChange,
        resetDetector,
        setFlexBasisProp,
        maxRatio
    ]);
    const onPointerDown = (0, $5uXOq.useCallback)((e)=>{
        // Check if the chevron icon was clicked and prevent dragging
        if (onResizeHandleClick && e.target instanceof HTMLElement) {
            const target = (e.target.getAttribute('data-testid') || '').indexOf($8e1b555b6155529f$var$RESIZE_CHEVRON_ICON) > -1 ? 'chevron' : 'resizer';
            if (!onResizeHandleClick?.(target, setFlexBasisProp, e)) {
                e.preventDefault();
                return;
            }
        } // Prevent resize when the resizer is collapsed
        if (collapsed) return; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('pointermove', onPointerMove, {
            capture: true
        }); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('pointerup', onPointerUp, {
            capture: true
        });
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            // There is a chromium bug which forces all scrollbars to be visible when 'pointer-events: none' is added.
            // Chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=1280013&q=pointer-events%20scrollbar&can=2
            // The previously implemented workarounds for this issue didn't solve all use cases, i.e., horizontal scrollbars,
            // thus, 'user-select: none' is used to prevent text-highlighting but allows hover events, unlike 'pointer-events'.
            stylesheet.insertRule('body { user-select: none; }', 0); // Set the dragging cursor (higher than disabled pointer events)
            stylesheet.insertRule('#jira { cursor: ew-resize; }', 1);
        }
        const currentContainer = childrenContainerRef.current;
        const parentContainer = currentContainer?.parentElement;
        if (!currentContainer || !parentContainer) return;
        startWidth.current = currentContainer.getBoundingClientRect().width;
        parentWidth.current = parentContainer.getBoundingClientRect().width ?? 0;
        onResizeStart?.();
        startX.current = e.pageX; // This is preventing popups from closing when the resize handle is dragged
        if (!onResizeHandleClick) e.preventDefault();
    }, [
        onPointerMove,
        onPointerUp,
        childrenContainerRef,
        onResizeStart,
        onResizeHandleClick,
        collapsed,
        setFlexBasisProp
    ]);
    const handleSliderFocus = (0, $5uXOq.useCallback)(()=>{
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            // There is a chromium bug which forces all scrollbars to be visible when 'pointer-events: none' is added.
            // Chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=1280013&q=pointer-events%20scrollbar&can=2
            // The previously implemented workarounds for this issue didn't solve all use cases, i.e., horizontal scrollbars,
            // thus, 'user-select: none' is used to prevent text-highlighting but allows hover events, unlike 'pointer-events'.
            stylesheet.insertRule('body { user-select: none; }', 0); // Set the dragging cursor (higher than disabled pointer events)
            stylesheet.insertRule('#jira { cursor: ew-resize; }', 1);
        }
        const currentContainer = childrenContainerRef.current;
        const parentContainer = currentContainer?.parentElement;
        if (!currentContainer || !parentContainer) return;
        startWidth.current = currentContainer.getBoundingClientRect().width;
        parentWidth.current = parentContainer.getBoundingClientRect().width ?? 0; /*
                                                                                    calculate the range only when the user actually wants navigate via
                                                                                    keyboard and save the computation at initial render
                                                                                    */ 
        setInputRange((prev)=>({
                ...prev,
                min: minWidthLeftContainer ? minWidthLeftContainer / parentWidth.current : minRatio,
                max: minWidthRightContainer ? maxRatio - minWidthRightContainer / parentWidth.current : maxRatio
            }));
        onResizeStart?.();
    }, [
        onResizeStart,
        childrenContainerRef,
        maxRatio,
        minRatio,
        minWidthLeftContainer,
        minWidthRightContainer
    ]);
    const handleSliderInputChange = (0, $5uXOq.useCallback)((e)=>{
        const value = parseFloat(e.target.value);
        setRangeInputValue(value); // doing this maxRatio - value because current drag has left as 100% and right as 0% alternative to input range
        nextRatio.current = maxRatio - value;
        setFlexBasisProp(maxRatio - value);
        keyboardResizeManager.onResize({
            ratio: maxRatio - value,
            width: (maxRatio - value) * parentWidth.current,
            flexBasis: setFlexBasisProp
        });
    }, [
        setFlexBasisProp,
        maxRatio,
        keyboardResizeManager
    ]);
    const ariaValueText = (0, $5uXOq.useMemo)(()=>`${(0, $aydCa.getPercentageWithinPixelBounds)({
            currentWidth: collapsed ? maxRatio : rangeInputValue,
            minRatio: minRatio,
            maxRatio: maxRatio
        })}% width`, [
        rangeInputValue,
        minRatio,
        maxRatio,
        collapsed
    ]);
    const ResizeBar = (0, $5uXOq.useCallback)(()=>{
        const directionDidChange = chevronDirection !== prevChevronDirection;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeHandle), {
            tabIndex: 0,
            role: "separator",
            "aria-orientation": "vertical",
            "data-testid": "flex-resizer.ui.handle.resizer",
            onPointerDown: onPointerDown,
            position: position,
            resizeHandleZIndex: resizeHandleZIndex,
            resizeHandleAsOverlay: resizeHandleAsOverlay,
            "aria-valuenow": Math.floor(nextRatio.current * 100),
            collapsed: collapsed,
            customStyles: additionalStyles?.resizeHandleStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeBorder), {
            triggerAnimation: directionDidChange,
            collapsed: collapsed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e1b555b6155529f$var$TooltipWrapper, {
            toolTipContent: toolTipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeIcon), {
            triggerAnimation: directionDidChange,
            "data-testid": $8e1b555b6155529f$var$RESIZE_ICON_TEST_ID,
            persistResizeIcon: persistResizeIcon,
            onResizeHandleClick: onResizeHandleClick
        }, chevronDirection === 'LEFT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Qiip))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$8e1b555b6155529f$var$RESIZE_CHEVRON_ICON}left`
        }), chevronDirection === 'RIGHT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$8e1b555b6155529f$var$RESIZE_CHEVRON_ICON}right`
        })))));
    }, [
        onPointerDown,
        position,
        resizeHandleZIndex,
        resizeHandleAsOverlay,
        collapsed,
        chevronDirection,
        prevChevronDirection,
        persistResizeIcon,
        onResizeHandleClick,
        toolTipContent,
        additionalStyles
    ]);
    const renderKeyboardNavigation = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: lineSplitterRef,
            className: (0, $bwpsq.default)([
                $8e1b555b6155529f$var$grabAreaStyles.root,
                collapsed ? "_1gavfnf5" : "_d0aluf7j _1gavfnf5"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            id: labelId,
            type: "range",
            value: rangeInputValue,
            step: "0.01",
            min: inputRange.min,
            max: inputRange.max,
            "aria-valuetext": ariaValueText,
            onChange: handleSliderInputChange,
            onFocus: handleSliderFocus
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
            htmlFor: labelId
        }, formatMessage((0, $gxE4O.default).resizer))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, $bwpsq.default)([
                $8e1b555b6155529f$var$lineStyles.root
            ])
        }));
    }, [
        ariaValueText,
        formatMessage,
        handleSliderFocus,
        handleSliderInputChange,
        labelId,
        rangeInputValue,
        inputRange.max,
        inputRange.min,
        collapsed
    ]);
    const renderResizeBar = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeHandle), {
            "data-testid": "flex-resizer.ui.handle.resizer",
            onPointerDown: onPointerDown,
            position: position,
            resizeHandleZIndex: resizeHandleZIndex,
            resizeHandleAsOverlay: resizeHandleAsOverlay,
            collapsed: collapsed,
            customStyles: additionalStyles?.resizeHandleStyles
        }, renderKeyboardNavigation(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeBorder), {
            triggerAnimation: chevronDirection !== prevChevronDirection,
            collapsed: collapsed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e1b555b6155529f$var$TooltipWrapper, {
            toolTipContent: toolTipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeIcon), {
            triggerAnimation: chevronDirection !== prevChevronDirection,
            "data-testid": $8e1b555b6155529f$var$RESIZE_ICON_TEST_ID,
            persistResizeIcon: persistResizeIcon,
            onResizeHandleClick: onResizeHandleClick
        }, chevronDirection === 'LEFT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3Qiip))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$8e1b555b6155529f$var$RESIZE_CHEVRON_ICON}left`
        }), chevronDirection === 'RIGHT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$8e1b555b6155529f$var$RESIZE_CHEVRON_ICON}right`
        })))));
    }, [
        onPointerDown,
        position,
        resizeHandleZIndex,
        resizeHandleAsOverlay,
        persistResizeIcon,
        onResizeHandleClick,
        collapsed,
        renderKeyboardNavigation,
        chevronDirection,
        prevChevronDirection,
        toolTipContent,
        additionalStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('jira_a11y_pannel_splitter_navigations') ? renderResizeBar() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ResizeBar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        ref: styleElement
    }));
};
var $8e1b555b6155529f$export$2e2bcd8739ae039 = $8e1b555b6155529f$var$Resizer;

});
parcelRegister("3Qiip", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::50eb0536eed3191cdc1ef30e9478909d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cc46ba193f64324$var$_react = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2cc46ba193f64324$var$_chevronLeft = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("lRheX")));

var $2cc46ba193f64324$var$_chevronLeft2 = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("nHhrH")));
function $2cc46ba193f64324$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cc46ba193f64324$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $2cc46ba193f64324$var$_react.default.createElement($2cc46ba193f64324$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $2cc46ba193f64324$var$_chevronLeft2.default
    }, props));
$2cc46ba193f64324$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $2cc46ba193f64324$var$_default = module.exports.default = $2cc46ba193f64324$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("nHhrH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0473b8ae11c957a6$var$_react = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0473b8ae11c957a6$var$_chevronLeft = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $0473b8ae11c957a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0473b8ae11c957a6$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $0473b8ae11c957a6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $0473b8ae11c957a6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$0473b8ae11c957a6$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $0473b8ae11c957a6$var$_default = module.exports.default = $0473b8ae11c957a6$var$ChevronLeftIcon;

});


parcelRegister("gxE4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $f78ef77eaa788dc2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f78ef77eaa788dc2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resizer: {
        "id": "flex-resizer.handle.resizer",
        "defaultMessage": "Resize issue view side panel"
    }
});

});

parcelRegister("aydCa", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $b44a35b1fb9125cb$export$b5423678cdf09f5);
function $b44a35b1fb9125cb$export$b5423678cdf09f5({ currentWidth: currentWidth, minRatio: minRatio, maxRatio: maxRatio }) {
    const resizeRange = maxRatio - minRatio;
    const widthAsPercentage = (currentWidth - minRatio) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("2rgs5", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", () => $0375140776397e94$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $0375140776397e94$var$resizeCallbackDebounceTimeMs = 500;
function $0375140776397e94$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ ratio: ratio, width: width, flexBasis: flexBasis }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd?.(ratio, width, flexBasis);
            resizingState = {
                type: 'idle'
            };
        }, $0375140776397e94$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: width,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ ratio: ratio, width: width, flexBasis: flexBasis }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart();
            startResizeEndTimer({
                ratio: ratio,
                width: width,
                flexBasis: flexBasis
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                ratio: ratio,
                width: width,
                flexBasis: flexBasis
            });
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("dOj0C", function(module, exports) {

$parcel$export(module.exports, "ResizeHandle", () => $d209db24df180fbf$export$33f2411a0ad35be7);
$parcel$export(module.exports, "ResizeIcon", () => $d209db24df180fbf$export$8a1e762806b47a07);
$parcel$export(module.exports, "ResizeBorder", () => $d209db24df180fbf$export$a6c16750034505be);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $eygxC = parcelRequire("eygxC");
const $d209db24df180fbf$var$resizeHandleSelectorName = 'jira-issue-view-common-component-resize-handle';
const $d209db24df180fbf$export$3cd44ff7e3089142 = `[data-component-selector="${$d209db24df180fbf$var$resizeHandleSelectorName}"]`;
const $d209db24df180fbf$var$marginOffset = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d209db24df180fbf$var$ResizeHandleComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { collapsed: collapsed, resizeHandleZIndex: resizeHandleZIndex, position: position, resizeHandleAsOverlay: resizeHandleAsOverlay, customStyles: customStyles, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ravlqm": (0, $lD23V.default)(__cmplp.resizeHandleZIndex),
            "--_1o4cubd": (0, $lD23V.default)(__cmplp.position === 'left' ? 'translate3d(-50%, 0, 0)' : 'translate3d(50%, 0, 0)')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _1bsb1ejb _1wpz1fhb _1e0c1txw _1bah1h6o _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.collapsed ? "_80omtlke" : "_80omuf7j",
            __cmplp.resizeHandleZIndex && "_1pby7mzf",
            __cmplp.position === 'left' ? "_1ltvidpf" : "_1xi2idpf",
            __cmplp.resizeHandleAsOverlay && "_154iidpf _kqswstnw _4t3i1osq _t9ec1jw3",
            __cmplp.customStyles === (0, $eygxC.resizerStyleOverrides).ISSUE_VIEW_MARGIN_OFFSET && "_2hwx1ejb",
            __cmplp.className
        ])
    });
});
const $d209db24df180fbf$export$86f12edbaf8a60d3 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d209db24df180fbf$var$ResizeHandleComponent, {
        "data-component-selector": $d209db24df180fbf$var$resizeHandleSelectorName,
        ...props
    }));
const $d209db24df180fbf$export$be9da3111ad61150 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d209db24df180fbf$var$ResizeHandleComponent, {
        "data-component-selector": $d209db24df180fbf$var$resizeHandleSelectorName,
        ...props
    });
const $d209db24df180fbf$export$33f2411a0ad35be7 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('memo_resize_handle_in_issue_view_vc90_top_offender'), $d209db24df180fbf$export$86f12edbaf8a60d3, $d209db24df180fbf$export$be9da3111ad61150);
const $d209db24df180fbf$var$appearAnimationBorder = null;
const $d209db24df180fbf$var$appearAnimationIcon = null;
const $d209db24df180fbf$var$ResizeIconBaseStyles = null;
const $d209db24df180fbf$var$ResizeIconRefreshStyles = null;
const $d209db24df180fbf$var$PointerStyle = null;
const $d209db24df180fbf$var$OpacityStyle1 = null;
const $d209db24df180fbf$var$OpacityStyle0 = null;
const $d209db24df180fbf$var$AnimationDuration1S = null;
const $d209db24df180fbf$var$AnimationDuration0S = null;
const $d209db24df180fbf$var$ResizeIconCompiled = ({ isRefreshVariant: isRefreshVariant = false, triggerAnimation: triggerAnimation, persistResizeIcon: persistResizeIcon, children: children, onResizeHandleClick: onResizeHandleClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_2rko1ssb _kqswstnw _154ixy5q _4t3i1tcg _1bsb1tcg _1ltvxmi2 _16qs1cd0 _j7hq1s2f _1pgl1ytf _bfhkvuon _irr3108i",
            isRefreshVariant && "_1e0c1txw _4cvr1h6o _1bah1h6o",
            triggerAnimation && "_5sag9cwz",
            !triggerAnimation && "_5sagru3m",
            persistResizeIcon && "_tzy4kb7n",
            !persistResizeIcon && "_tzy4idpf",
            !!onResizeHandleClick && "_80omtlke"
        ])
    }, children);
};
const $d209db24df180fbf$export$8a1e762806b47a07 = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d209db24df180fbf$var$ResizeIconCompiled, {
        isRefreshVariant: true,
        ...props
    }), $d209db24df180fbf$var$ResizeIconCompiled);
const $d209db24df180fbf$export$a6c16750034505be = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { triggerAnimation: triggerAnimation, collapsed: collapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v56419xe _1bsbyh40 _1wpz1fhb _j7hq1f9b _1pgl1ytf _kqswh2mm _17cdkb7n _vhr0kb7n _1sankb7n _lew41p6i _1ld91p6i _18fi1p6i",
            __cmplp.triggerAnimation ? "_5sag9cwz" : "_5sagru3m",
            __cmplp.collapsed ? "_bfhkmuej" : "_bfhk1p6i",
            __cmplp.collapsed ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});





parcelRegister("bbbXL", function(module, exports) {

$parcel$export(module.exports, "NoFilter", () => $4564153678e1805d$export$fba2cdeecf4e314d);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $kjIEI = parcelRequire("kjIEI");

var $c7i3D = parcelRequire("c7i3D");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $6YP2a = parcelRequire("6YP2a");
const $4564153678e1805d$var$ANOTHER_FILTER_LINK = '/jira/filters';
const $4564153678e1805d$export$fba2cdeecf4e314d = ({ reason: reason })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "noFilter",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: reason ? {
            reason: reason
        } : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $6YP2a.default).weCouldntFindThisFilter),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6YP2a.default).filterNoExistOrNoPermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6YP2a.default).tryAnotherFilterIssueTermRefresh : (0, $6YP2a.default).tryAnotherFilter))),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            href: $4564153678e1805d$var$ANOTHER_FILTER_LINK
        }, formatMessage((0, $6YP2a.default).viewFilters)),
        primaryAction: // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            href: window.location.pathname
        }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6YP2a.default).searchIssuesIssueTermRefresh : (0, $6YP2a.default).searchIssues)),
        renderImage: ()=>(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $4564153678e1805d$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7i3D.default), {
                alt: ""
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $4564153678e1805d$var$ImageWrapperStylesOld
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjIEI.default), {
                alt: ""
            }))
    }));
};
var $4564153678e1805d$export$2e2bcd8739ae039 = $4564153678e1805d$export$fba2cdeecf4e314d;
const $4564153678e1805d$var$ImageWrapperStylesOld = (0, $8CUq3.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});
const $4564153678e1805d$var$ImageWrapperStyles = (0, $8CUq3.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("kjIEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b511ca53b54ba8ce$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("540HS")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $dCLgq = parcelRequire("dCLgq");

var $4aihJ = parcelRequire("4aihJ");

var $540HS = parcelRequire("540HS");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $b511ca53b54ba8ce$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($540HS)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4aihJ))
});
var $b511ca53b54ba8ce$export$2e2bcd8739ae039 = $b511ca53b54ba8ce$var$Illustration;
// for advanced use only
const $b511ca53b54ba8ce$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("4aihJ", function(module, exports) {
module.exports = new URL("search-no-results-old-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("540HS", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});


parcelRegister("c7i3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6eff2dc5f73fdbc$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $dCLgq = parcelRequire("dCLgq");

var $f3FKt = parcelRequire("f3FKt");

var $5BNLu = parcelRequire("5BNLu");
const $e6eff2dc5f73fdbc$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5BNLu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($f3FKt))
});
var $e6eff2dc5f73fdbc$export$2e2bcd8739ae039 = $e6eff2dc5f73fdbc$var$Illustration;
// for advanced use only
const $e6eff2dc5f73fdbc$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    184
];

});
parcelRegister("f3FKt", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.c66ae5fb.svg", import.meta.url).toString();

});

parcelRegister("5BNLu", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});


parcelRegister("6YP2a", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe733e75fd165d2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3fe733e75fd165d2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    weCouldntFindThisFilter: {
        "id": "issue-navigator.common.no-filter.we-couldnt-find-this-filter",
        "defaultMessage": "We couldn't find this filter"
    },
    filterNoExistOrNoPermissions: {
        "id": "issue-navigator.common.no-filter.filter-no-exist-or-no-permissions",
        "defaultMessage": "This filter may not exist, or you don\u2019t have permissions to view it."
    },
    tryAnotherFilter: {
        "id": "issue-navigator.common.no-filter.try-another-filter",
        "defaultMessage": "Try searching for another filter, or start a new issue search."
    },
    viewFilters: {
        "id": "issue-navigator.common.no-filter.view-filters",
        "defaultMessage": "View filters"
    },
    searchIssues: {
        "id": "issue-navigator.common.no-filter.search-issues",
        "defaultMessage": "Search issues"
    },
    tryAnotherFilterIssueTermRefresh: {
        "id": "issue-navigator.common.no-filter.try-another-filter-issue-term-refresh",
        "defaultMessage": "Try searching for another filter, or start a new search."
    },
    searchIssuesIssueTermRefresh: {
        "id": "issue-navigator.common.no-filter.search-issues-issue-term-refresh",
        "defaultMessage": "Search work items"
    }
});

});


parcelRegister("kMfdg", function(module, exports) {

$parcel$export(module.exports, "IssueSearchSuccess", () => $b2794e71f9164ec7$export$3ee6d2830e5ead03);
$parcel$export(module.exports, "IssueSearchFail", () => $b2794e71f9164ec7$export$91886a55521e4fad);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $1XJ20 = parcelRequire("1XJ20");

var $1GlUV = parcelRequire("1GlUV");

var $isIOR = parcelRequire("isIOR");

var $38r5c = parcelRequire("38r5c");

var $ih9zY = parcelRequire("ih9zY");
const $b2794e71f9164ec7$export$3ee6d2830e5ead03 = ({ attributes: attributes, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const { onIssueSearchSuccess: onIssueSearchSuccess } = (0, $1GlUV.useExperienceAnalytics)(onPageDataLoad, view, attributes);
    let isFetching;
    let isNetworkError;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isFetching = (0, $38r5c.useIsFetching)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isNetworkError = (0, $38r5c.useIsNetworkError)();
    } else // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ isFetching: isFetching, isNetworkError: isNetworkError } = (0, $isIOR.useIssueSearchQuery)());
    const prevIsFetching = (0, $1XJ20.usePrevious)(isFetching);
    (0, $5uXOq.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching && !isNetworkError) onIssueSearchSuccess(view);
    }, [
        isFetching,
        isNetworkError,
        onIssueSearchSuccess,
        prevIsFetching,
        view
    ]);
    return null;
};
const $b2794e71f9164ec7$export$91886a55521e4fad = ({ attributes: attributes, location: location, error: error, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const { onIssueSearchFail: onIssueSearchFail } = (0, $1GlUV.useExperienceAnalytics)(onPageDataLoad, view, attributes);
    let isFetching;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    isFetching = (0, $38r5c.useIsFetching)();
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ isFetching: isFetching } = (0, $isIOR.useIssueSearchQuery)());
    const prevIsFetching = (0, $1XJ20.usePrevious)(isFetching);
    (0, $5uXOq.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching) onIssueSearchFail(location, error, view);
    }, [
        error,
        isFetching,
        location,
        onIssueSearchFail,
        prevIsFetching,
        view
    ]);
    return null;
};

});
parcelRegister("38r5c", function(module, exports) {

$parcel$export(module.exports, "useSearchKey", () => $e1f660d76cb8d0f0$export$89b7d8d2a901e7f3);
$parcel$export(module.exports, "useIsFetching", () => $e1f660d76cb8d0f0$export$625b2ff71316bcd3);
$parcel$export(module.exports, "useIsFetchingView", () => $e1f660d76cb8d0f0$export$bb4d69b04e77d5fc);
$parcel$export(module.exports, "useIsNetworkError", () => $e1f660d76cb8d0f0$export$e42540e6c753cf0d);
$parcel$export(module.exports, "useIsRefreshing", () => $e1f660d76cb8d0f0$export$f0abaf46a1fbe05d);
$parcel$export(module.exports, "useTotalIssueCount", () => $e1f660d76cb8d0f0$export$2913c5459976c260);
$parcel$export(module.exports, "useTotalIssueCountIsFetching", () => $e1f660d76cb8d0f0$export$597fd4c2a21a6427);
$parcel$export(module.exports, "useTotalIssueCountIsError", () => $e1f660d76cb8d0f0$export$8ca94746675b8a5f);
$parcel$export(module.exports, "useIssueSearchActions", () => $e1f660d76cb8d0f0$export$77a801a298598c57);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $1PJ7c = parcelRequire("1PJ7c");
const $e1f660d76cb8d0f0$export$89b7d8d2a901e7f3 = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.searchKey
});
const $e1f660d76cb8d0f0$export$625b2ff71316bcd3 = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.isFetching
});
const $e1f660d76cb8d0f0$export$bb4d69b04e77d5fc = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.isFetchingView
});
const $e1f660d76cb8d0f0$export$e42540e6c753cf0d = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.isNetworkError
});
const $e1f660d76cb8d0f0$export$f0abaf46a1fbe05d = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.isRefreshing
});
const $e1f660d76cb8d0f0$export$2913c5459976c260 = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.totalIssueCount
});
const $e1f660d76cb8d0f0$export$597fd4c2a21a6427 = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.totalIssueCountIsFetching
});
const $e1f660d76cb8d0f0$export$8ca94746675b8a5f = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.totalIssueCountIsError
});
const $e1f660d76cb8d0f0$export$77a801a298598c57 = (0, $3sQ5x.createActionsHook)((0, $1PJ7c.Store));

});


parcelRegister("5NwJk", function(module, exports) {

$parcel$export(module.exports, "useSelectedIssueKey", () => $0bb54236b3bd8bd1$export$7cedcbfb2da7e49d);
$parcel$export(module.exports, "useSelectedIssueIndex", () => $0bb54236b3bd8bd1$export$a4b375f8f9b094ad);
$parcel$export(module.exports, "useSelectedIssueDebouncedState", () => $0bb54236b3bd8bd1$export$ed5cb04ac9d88e95);
$parcel$export(module.exports, "useIsFullPageIssueAppMode", () => $0bb54236b3bd8bd1$export$988cbddd89e853c0);

var $6s1PB = parcelRequire("6s1PB");

var $gtUFk = parcelRequire("gtUFk");

var $7OTah = parcelRequire("7OTah");
const $0bb54236b3bd8bd1$export$7cedcbfb2da7e49d = ()=>(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? (0, $7OTah.useSelectedIssueKey)() : (0, $gtUFk.useSelectedIssueKey)();
const $0bb54236b3bd8bd1$export$a4b375f8f9b094ad = ()=>(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? (0, $7OTah.useSelectedIssueIndex)() : (0, $gtUFk.useSelectedIssueIndex)();
const $0bb54236b3bd8bd1$export$ed5cb04ac9d88e95 = ()=>(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? (0, $7OTah.useSelectedIssueDebouncedState)() : (0, $gtUFk.useSelectedIssueDebouncedState)();
const $0bb54236b3bd8bd1$export$988cbddd89e853c0 = ()=>(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? (0, $7OTah.useIsFullPageIssueAppMode)() : (0, $gtUFk.useIsFullPageIssueAppMode)();

});
parcelRegister("7OTah", function(module, exports) {

$parcel$export(module.exports, "useSelectedIssueIndex", () => $45ced29c2f763b85$export$a4b375f8f9b094ad);
$parcel$export(module.exports, "useNextIssueKey", () => $45ced29c2f763b85$export$a357f91232534409);
$parcel$export(module.exports, "usePreviousIssueKey", () => $45ced29c2f763b85$export$ee05f65713c12ae3);
$parcel$export(module.exports, "useIssuesCount", () => $45ced29c2f763b85$export$b8578d9ea1fc9bc);
$parcel$export(module.exports, "useSelectedIssueKey", () => $45ced29c2f763b85$export$7cedcbfb2da7e49d);
$parcel$export(module.exports, "useIsSelectedIssue", () => $45ced29c2f763b85$export$ccd07516e284d793);
$parcel$export(module.exports, "useSelectedIssueDebouncedState", () => $45ced29c2f763b85$export$ed5cb04ac9d88e95);
$parcel$export(module.exports, "useIsFullPageIssueAppMode", () => $45ced29c2f763b85$export$988cbddd89e853c0);
$parcel$export(module.exports, "useSelectedIssueActions", () => $45ced29c2f763b85$export$d1c4608e18de4f02);

var $3sQ5x = parcelRequire("3sQ5x");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $hnJJ3 = parcelRequire("hnJJ3");

var $gz4II = parcelRequire("gz4II");
const $45ced29c2f763b85$export$a4b375f8f9b094ad = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: (0, $gz4II.getSelectedIssueIndex)
});
const $45ced29c2f763b85$export$a357f91232534409 = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: (0, $gz4II.getNextIssueKey)
});
const $45ced29c2f763b85$export$ee05f65713c12ae3 = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: (0, $gz4II.getPreviousIssueKey)
});
const $45ced29c2f763b85$export$b8578d9ea1fc9bc = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: (0, $gz4II.getIssuesCount)
});
const $45ced29c2f763b85$export$7cedcbfb2da7e49d = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: ({ selectedIssueKey: selectedIssueKey })=>selectedIssueKey
});
const $45ced29c2f763b85$export$ccd07516e284d793 = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: ({ selectedIssueKey: selectedIssueKey }, issueKey)=>selectedIssueKey === issueKey
});
const $45ced29c2f763b85$export$ed5cb04ac9d88e95 = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: (0, $eJ0Zs.createRememoizeSelector)((state)=>state, ({ selectedIssueKey: selectedIssueKey })=>selectedIssueKey)
});
const $45ced29c2f763b85$export$988cbddd89e853c0 = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: ({ isFullPageIssueAppMode: isFullPageIssueAppMode })=>isFullPageIssueAppMode
});
const $45ced29c2f763b85$export$d1c4608e18de4f02 = (0, $3sQ5x.createActionsHook)((0, $hnJJ3.Store));

});
parcelRegister("hnJJ3", function(module, exports) {

$parcel$export(module.exports, "SelectedIssueContainer", () => $2e98f8dbaf47ae14$export$8b7bb55917259a5d);
$parcel$export(module.exports, "Store", () => $2e98f8dbaf47ae14$export$390f32400eaf98c9);

var $g5X3G = parcelRequire("g5X3G");

var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $6UAdF = parcelRequire("6UAdF");

var $kyTMp = parcelRequire("kyTMp");
const $2e98f8dbaf47ae14$export$8b7bb55917259a5d = (0, $gg7kZ.createContainer)();
const $2e98f8dbaf47ae14$var$initialState = {
    _rememoize: Date.now(),
    selectedIssueKey: (0, $g5X3G.toIssueKey)(''),
    isFullPageIssueAppMode: false,
    issueKeys: []
};
const $2e98f8dbaf47ae14$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'SelectedIssueStore',
    containedBy: $2e98f8dbaf47ae14$export$8b7bb55917259a5d,
    initialState: $2e98f8dbaf47ae14$var$initialState,
    actions: $kyTMp.default,
    handlers: {
        onInit: ()=>({ setState: setState, dispatch: dispatch }, { selectedIssueKey: selectedIssueKey, view: view, issueKeys: issueKeys })=>{
                dispatch((0, $kyTMp.privateActions).onContainerUpdate());
                const isFullPageIssueAppMode = Boolean(selectedIssueKey) && view === (0, $6UAdF.views).list;
                const initialIssueKey = selectedIssueKey || issueKeys[0] || (0, $g5X3G.toIssueKey)('');
                setState({
                    _rememoize: Date.now(),
                    selectedIssueKey: initialIssueKey,
                    isFullPageIssueAppMode: isFullPageIssueAppMode
                });
            },
        onContainerUpdate: ({ searchKey: searchKey, selectedIssueKey: selectedIssueKey }, prevProps)=>({ dispatch: dispatch })=>{
                dispatch((0, $kyTMp.privateActions).onContainerUpdate());
                if (searchKey !== prevProps.searchKey) dispatch((0, $kyTMp.privateActions).resetSelectedIssue());
                else if (selectedIssueKey && selectedIssueKey !== prevProps.selectedIssueKey) {
                    dispatch($2e98f8dbaf47ae14$export$390f32400eaf98c9.actions.setSelectedIssueByKey(selectedIssueKey, {
                        shouldDebounce: false,
                        shouldNotifyOnChange: false,
                        isSelectedByUserInteraction: false
                    }));
                    // If an issue key has been specified while in list view then enter full page issue app mode.
                    if (dispatch((0, $kyTMp.privateActions).isListViewWithoutIssueApp())) dispatch($2e98f8dbaf47ae14$export$390f32400eaf98c9.actions.enterFullPageIssueAppMode());
                // TODO JSC-185 Fetch next/previous page when last/first issue is selected
                } else if (!selectedIssueKey && dispatch((0, $kyTMp.privateActions).isListViewWithIssueAppAndKey())) dispatch($2e98f8dbaf47ae14$export$390f32400eaf98c9.actions.exitFullPageIssueAppMode());
            }
    }
});

});
parcelRegister("kyTMp", function(module, exports) {

$parcel$export(module.exports, "privateActions", () => $ecb0ae8c94bab407$export$3f1be494d407b77a);
$parcel$export(module.exports, "default", () => $ecb0ae8c94bab407$export$2e2bcd8739ae039);

var $lFKmC = parcelRequire("lFKmC");

var $g5X3G = parcelRequire("g5X3G");

var $6UAdF = parcelRequire("6UAdF");

var $gz4II = parcelRequire("gz4II");
const $ecb0ae8c94bab407$var$doSideEffectUpdate = ({ getState: getState, setState: setState }, { onChange: onChange, shouldNotifyOnChange: shouldNotifyOnChange = true, isSelectedByUserInteraction: isSelectedByUserInteraction = true, viewActivity: viewActivity })=>{
    const { selectedIssueKey: selectedIssueKey } = getState();
    setState({
        _rememoize: Date.now()
    });
    shouldNotifyOnChange && onChange && onChange(selectedIssueKey, isSelectedByUserInteraction, viewActivity);
};
const $ecb0ae8c94bab407$var$doDebouncedSideEffectUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))($ecb0ae8c94bab407$var$doSideEffectUpdate, 600);
const $ecb0ae8c94bab407$var$doSideEffectUpdates = (actions, options)=>{
    options.shouldDebounce ? $ecb0ae8c94bab407$var$doDebouncedSideEffectUpdate(actions, options) : $ecb0ae8c94bab407$var$doSideEffectUpdate(actions, options);
};
const $ecb0ae8c94bab407$var$setSelectedIssueByKey = (selectedIssueKey, options = {})=>(actions, { onChange: onChange })=>{
        if (!selectedIssueKey.length) return false;
        actions.setState({
            selectedIssueKey: selectedIssueKey
        });
        $ecb0ae8c94bab407$var$doSideEffectUpdates(actions, {
            ...options,
            onChange: onChange
        });
        return true;
    };
const $ecb0ae8c94bab407$var$setSelectedIssueByIndex = (issueIndex, options)=>({ dispatch: dispatch }, { issueKeys: issueKeys })=>{
        return dispatch($ecb0ae8c94bab407$var$setSelectedIssueByKey(issueKeys[issueIndex] ?? (0, $g5X3G.toIssueKey)(''), options));
    };
/**
 * Select the next issue in the search results (if there is a valid selection). Returns `true` if an issue was selected,
 * otherwise `false`.
 */ const $ecb0ae8c94bab407$var$selectNextIssue = (shouldDebounce)=>({ dispatch: dispatch, getState: getState })=>{
        return dispatch($ecb0ae8c94bab407$var$setSelectedIssueByKey((0, $gz4II.getNextIssueKey)(getState()) ?? (0, $g5X3G.toIssueKey)(''), {
            shouldDebounce: shouldDebounce
        }));
    };
/**
 * Select the previous issue in the search results (if there is a valid selection). Returns `true` if an issue was
 * selected, otherwise `false`.
 */ const $ecb0ae8c94bab407$var$selectPreviousIssue = (shouldDebounce)=>({ dispatch: dispatch, getState: getState })=>{
        return dispatch($ecb0ae8c94bab407$var$setSelectedIssueByKey((0, $gz4II.getPreviousIssueKey)(getState()) ?? (0, $g5X3G.toIssueKey)(''), {
            shouldDebounce: shouldDebounce
        }));
    };
const $ecb0ae8c94bab407$var$deselectIssue = (options)=>(actions, { onChange: onChange })=>{
        actions.setState({
            selectedIssueKey: (0, $g5X3G.toIssueKey)('')
        });
        $ecb0ae8c94bab407$var$doSideEffectUpdates(actions, {
            ...options,
            onChange: onChange
        });
    };
const $ecb0ae8c94bab407$var$enterFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: true
        });
const $ecb0ae8c94bab407$var$exitFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: false
        });
/**
 * Return true if we're in default list view mode without the full page issue app visible.
 */ const $ecb0ae8c94bab407$var$isListViewWithoutIssueApp = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode } = getState();
        return view === (0, $6UAdF.views).list && !isFullPageIssueAppMode;
    };
/**
 * Return true if we're in default list view mode with the full page issue app visible and a selected issue key.
 */ const $ecb0ae8c94bab407$var$isListViewWithIssueAppAndKey = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode, selectedIssueKey: selectedIssueKey } = getState();
        return view === (0, $6UAdF.views).list && isFullPageIssueAppMode && !!selectedIssueKey;
    };
/**
 * Reset the selected issue to the first issue in the connection.
 */ const $ecb0ae8c94bab407$var$resetSelectedIssue = ()=>({ dispatch: dispatch })=>{
        // We only want to update issue key in the URL if our view mode uses external issue key selection, i.e. detail
        // view or full page issue app in list view. For the default list view mode we want to keep the selected issue
        // state internal.
        const shouldNotifyOnChange = !dispatch($ecb0ae8c94bab407$var$isListViewWithoutIssueApp());
        dispatch($ecb0ae8c94bab407$var$setSelectedIssueByIndex(0, {
            shouldDebounce: false,
            shouldNotifyOnChange: shouldNotifyOnChange,
            isSelectedByUserInteraction: false
        }));
    };
const $ecb0ae8c94bab407$export$ab8f0de40a3a2d2d = ()=>({ setState: setState }, { issueKeys: issueKeys })=>{
        setState({
            issueKeys: issueKeys
        });
    };
const $ecb0ae8c94bab407$export$e324594224ef24da = {
    setSelectedIssueByKey: $ecb0ae8c94bab407$var$setSelectedIssueByKey,
    setSelectedIssueByIndex: $ecb0ae8c94bab407$var$setSelectedIssueByIndex,
    selectNextIssue: $ecb0ae8c94bab407$var$selectNextIssue,
    selectPreviousIssue: $ecb0ae8c94bab407$var$selectPreviousIssue,
    deselectIssue: $ecb0ae8c94bab407$var$deselectIssue,
    enterFullPageIssueAppMode: $ecb0ae8c94bab407$var$enterFullPageIssueAppMode,
    exitFullPageIssueAppMode: $ecb0ae8c94bab407$var$exitFullPageIssueAppMode
};
const $ecb0ae8c94bab407$export$3f1be494d407b77a = {
    isListViewWithoutIssueApp: $ecb0ae8c94bab407$var$isListViewWithoutIssueApp,
    isListViewWithIssueAppAndKey: $ecb0ae8c94bab407$var$isListViewWithIssueAppAndKey,
    resetSelectedIssue: $ecb0ae8c94bab407$var$resetSelectedIssue,
    onContainerUpdate: $ecb0ae8c94bab407$export$ab8f0de40a3a2d2d
};
var $ecb0ae8c94bab407$export$2e2bcd8739ae039 = $ecb0ae8c94bab407$export$e324594224ef24da;

});
parcelRegister("gz4II", function(module, exports) {

$parcel$export(module.exports, "getSelectedIssueIndex", () => $a1a1b31f57e99fe6$export$b5bba5025e9754c0);
$parcel$export(module.exports, "getNextIssueKey", () => $a1a1b31f57e99fe6$export$2a413bfa3aeed781);
$parcel$export(module.exports, "getPreviousIssueKey", () => $a1a1b31f57e99fe6$export$5e257a264fce89f7);
$parcel$export(module.exports, "getIssuesCount", () => $a1a1b31f57e99fe6$export$af7642e9bc434b70);

var $6dDSs = parcelRequire("6dDSs");
const $a1a1b31f57e99fe6$export$b5bba5025e9754c0 = (0, $6dDSs.createSelector)((state)=>state.selectedIssueKey, (state)=>state.issueKeys, (selectedIssueKey, issueKeys)=>issueKeys.indexOf(selectedIssueKey));
const $a1a1b31f57e99fe6$export$2a413bfa3aeed781 = (state)=>{
    const index = $a1a1b31f57e99fe6$export$b5bba5025e9754c0(state);
    const { issueKeys: issueKeys } = state;
    return index > -1 && index < issueKeys.length - 1 ? issueKeys[index + 1] : null;
};
const $a1a1b31f57e99fe6$export$5e257a264fce89f7 = (state)=>{
    const index = $a1a1b31f57e99fe6$export$b5bba5025e9754c0(state);
    const { issueKeys: issueKeys } = state;
    return index > 0 ? issueKeys[index - 1] : null;
};
const $a1a1b31f57e99fe6$export$af7642e9bc434b70 = (state)=>{
    return state.issueKeys.length;
};

});





parcelRegister("gM6H8", function(module, exports) {

$parcel$export(module.exports, "FlatListIssuesContainer", () => $fe56567ca6bbd596$export$60cae405c8bdaa87);
$parcel$export(module.exports, "useFlatListIssuesActions", () => $fe56567ca6bbd596$export$14d48bac80618630);
$parcel$export(module.exports, "useFlatListIssues", () => $fe56567ca6bbd596$export$a53e6810bcedfe4d);
$parcel$export(module.exports, "useFlatListIssueIds", () => $fe56567ca6bbd596$export$440fc5b87687d980);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $fe56567ca6bbd596$export$60cae405c8bdaa87 = (0, $gg7kZ.createContainer)();
const $fe56567ca6bbd596$var$initialState = {
    flatListIssues: [],
    flatListIssueIds: []
};
const $fe56567ca6bbd596$var$actions = {
    setFlatListIssueIds: (flatListIssueIds)=>({ setState: setState })=>{
            setState({
                flatListIssueIds: flatListIssueIds
            });
        },
    setFlatListIssues: (flatListIssues)=>({ setState: setState })=>{
            setState({
                flatListIssues: flatListIssues
            });
        }
};
const $fe56567ca6bbd596$var$Store = (0, $iXqE5.createStore)({
    containedBy: $fe56567ca6bbd596$export$60cae405c8bdaa87,
    initialState: $fe56567ca6bbd596$var$initialState,
    actions: $fe56567ca6bbd596$var$actions,
    name: 'jira-native-issue-table-flat-list-issues-store'
});
const $fe56567ca6bbd596$export$14d48bac80618630 = (0, $3sQ5x.createActionsHook)($fe56567ca6bbd596$var$Store);
const $fe56567ca6bbd596$export$2868636f0c1a29ec = (0, $3sQ5x.createHook)($fe56567ca6bbd596$var$Store);
const $fe56567ca6bbd596$var$getFlatListIssuesSelector = (state)=>state.flatListIssues;
const $fe56567ca6bbd596$export$a53e6810bcedfe4d = (0, $3sQ5x.createStateHook)($fe56567ca6bbd596$var$Store, {
    selector: $fe56567ca6bbd596$var$getFlatListIssuesSelector
});
const $fe56567ca6bbd596$var$getFlatListIssueIdsSelector = (state)=>state.flatListIssueIds;
const $fe56567ca6bbd596$export$440fc5b87687d980 = (0, $3sQ5x.createStateHook)($fe56567ca6bbd596$var$Store, {
    selector: $fe56567ca6bbd596$var$getFlatListIssueIdsSelector
});

});

parcelRegister("jfQeI", function(module, exports) {

$parcel$export(module.exports, "useIFCEntryPointContext", () => $38798637f24a8af2$export$caffdf0d268fddd7);
$parcel$export(module.exports, "InlineFieldConfigProviderComponent", () => $38798637f24a8af2$export$7b6238f7c058bb58);

var $5uXOq = parcelRequire("5uXOq");

var $l37qh = parcelRequire("l37qh");

var $4mO32 = parcelRequire("4mO32");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $7iHfG = parcelRequire("7iHfG");
const $38798637f24a8af2$export$ed5ff4845085aae5 = (0, $l37qh.createUseEntryPointContext)();
const $38798637f24a8af2$var$entryPointParams = {};
const $38798637f24a8af2$export$b1528524caf51b8b = ({ children: children })=>{
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $7iHfG.ifcEntryPoint), $38798637f24a8af2$var$entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($38798637f24a8af2$export$ed5ff4845085aae5.Provider, {
        value: entryPointResult
    }, children);
};
const $38798637f24a8af2$export$caffdf0d268fddd7 = ()=>{
    return (0, $5uXOq.useContext)($38798637f24a8af2$export$ed5ff4845085aae5);
};
const $38798637f24a8af2$export$7b6238f7c058bb58 = (0, $7XYc4.componentWithCondition)(()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) && (0, $4R6GH.fg)('jira_nin_sidebar_layout') && (0, $4R6GH.fg)('jira_ifc_changes_for_pnin'), $38798637f24a8af2$export$b1528524caf51b8b, ({ children: children })=>children);

});
parcelRegister("7iHfG", function(module, exports) {

$parcel$export(module.exports, "ifcEntryPoint", () => $37e91c9742f05fff$export$26521842160defa7);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $37e91c9742f05fff$export$26521842160defa7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("hBWYA")), {
        moduleId: "6c18a40d"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hBWYA", function(module, exports) {

let $cd23a3cebfb1b422$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cd23a3cebfb1b422$var$load("hPzOn"),
    $cd23a3cebfb1b422$var$load("cM9em"),
    $cd23a3cebfb1b422$var$load("fr9NE"),
    $cd23a3cebfb1b422$var$load("h2MrD"),
    $cd23a3cebfb1b422$var$load("bYT2S"),
    $cd23a3cebfb1b422$var$load("4rnMf")
]).then(()=>parcelRequire('hjnsM'));

});



parcelRegister("7jipW", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsWrapper", () => $1689161e44158dbb$export$88a2a475d15f0a71);

var $hOOQf = parcelRequire("hOOQf");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $91LZJ = parcelRequire("91LZJ");

var $8RB1G = parcelRequire("8RB1G");

var $48rMm = parcelRequire("48rMm");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $1XJ20 = parcelRequire("1XJ20");

var $gM6H8 = parcelRequire("gM6H8");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");
const $1689161e44158dbb$var$EMPTY_ARRAY = [];
const $1689161e44158dbb$var$LoadBulkOpsCore = ({ bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, fragmentRef: fragmentRef })=>{
    const selectedIssues = (0, $48rMm.useIssueTableSelectedIssues)();
    const { reset: reset, insertSelectedIssueIds: insertSelectedIssueIds } = (0, $48rMm.useIssueTableSelectedIssuesActions)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const view = (0, $4R6GH.fg)('bulk_operations_in_nin_fast_follow') ? (0, $ih9zY.useSelectedView)() : undefined;
    if ((0, $4R6GH.fg)('bulk_operations_in_nin_fast_follow')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { jql: jql } = (0, $gwtSG.useActiveJql)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const previousJql = (0, $1XJ20.usePrevious)(jql);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useEffect)(()=>{
            if (jql !== previousJql && previousJql !== undefined) reset();
        }, [
            jql,
            previousJql,
            reset
        ]);
    }
    let issuesFlatListIds = $1689161e44158dbb$var$EMPTY_ARRAY;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    issuesFlatListIds = (0, $gM6H8.useFlatListIssueIds)();
    const data = (0, $8Uumt.useFragment)((0, $hOOQf.default), fragmentRef);
    // we don't need to read issueIds for grouping from the query because we already have them in the flat list
    const issueIds = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) return {
            strings: issuesFlatListIds,
            numbers: issuesFlatListIds.map((issueId)=>Number(issueId))
        };
        const strings = data?.edges?.map((edge)=>edge?.node?.issueId).filter(Boolean) ?? [];
        return {
            strings: strings,
            numbers: strings.map((issueId)=>Number(issueId))
        };
    }, [
        data?.edges,
        issuesFlatListIds
    ]);
    const onSelectAll = (0, $5uXOq.useCallback)(()=>{
        insertSelectedIssueIds(issueIds.strings);
    }, [
        issueIds.strings,
        insertSelectedIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8RB1G.AsyncBulkOpsCoreFull), {
        bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference,
        selectedIssueIds: selectedIssues.map((issue)=>Number(issue)),
        onClearAll: reset,
        onSelectAll: onSelectAll,
        selectableIssueIds: issueIds.numbers,
        onClearAllVisible: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        ...(0, $4R6GH.fg)('bulk_operations_in_nin_fast_follow') && {
            shouldHideToolbar: view === 'detail'
        }
    });
};
const $1689161e44158dbb$export$88a2a475d15f0a71 = ({ children: children, bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, fragmentRef: fragmentRef })=>{
    if (!(0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false)) return children;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isBulkOpsInProgress = (0, $91LZJ.useIsBulkOperationsInProgress)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $1689161e44158dbb$var$wrapperStyles,
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $1689161e44158dbb$var$childContainerStyles,
            isBulkOpsInProgress && $1689161e44158dbb$var$childContainerDisabledStyles
        ]
    }, children), (fragmentRef || (0, $4R6GH.fg)('jira_list_grouping_bulk_ops')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1689161e44158dbb$var$LoadBulkOpsCore, {
        fragmentRef: fragmentRef,
        bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference
    }));
};
const $1689161e44158dbb$var$wrapperStyles = (0, $8CUq3.xcss)({
    height: '100%',
    overflowY: 'auto'
});
const $1689161e44158dbb$var$childContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    overflowY: 'auto'
});
const $1689161e44158dbb$var$childContainerDisabledStyles = (0, $8CUq3.xcss)({
    opacity: 0.5,
    pointerEvents: 'none'
});

});
parcelRegister("hOOQf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dbfbc599ad06ce9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9447c66ceb43590970549d094be1fa98>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7dbfbc599ad06ce9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$7dbfbc599ad06ce9$var$node.hash = "3ef50a3a9b158093691740d555608365";
var $7dbfbc599ad06ce9$export$2e2bcd8739ae039 = $7dbfbc599ad06ce9$var$node;

});

parcelRegister("91LZJ", function(module, exports) {

$parcel$export(module.exports, "useBulkOperations", () => $655e95f3b81da53e$export$940587be18a93fc4);
$parcel$export(module.exports, "useBulkOperationsActions", () => $655e95f3b81da53e$export$355499dfde532d1a);
$parcel$export(module.exports, "useIsBulkOperationsInProgress", () => $655e95f3b81da53e$export$760458c2204457a1);
$parcel$export(module.exports, "useShouldRenderSpotlight", () => $655e95f3b81da53e$export$4a165cf2377f023a);
$parcel$export(module.exports, "useBulkTransitionsStage", () => $655e95f3b81da53e$export$b3afff39a0c663ad);
$parcel$export(module.exports, "useBulkOperationInForm", () => $655e95f3b81da53e$export$6794339387d6d562);
$parcel$export(module.exports, "useBulkOperationType", () => $655e95f3b81da53e$export$4289f82da677ffac);
$parcel$export(module.exports, "useCancelDialogTrigger", () => $655e95f3b81da53e$export$babceeeb2408337b);
$parcel$export(module.exports, "useCurrentView", () => $655e95f3b81da53e$export$8ce7af7b2f8c770);

var $8zOmE = parcelRequire("8zOmE");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5ltfA = parcelRequire("5ltfA");

var $liV8G = parcelRequire("liV8G");
const $655e95f3b81da53e$export$d4c72bab9d6cc13a = {
    operationType: null,
    isSidebarOpen: false,
    cancelDialogTrigger: undefined,
    currentView: 'edit',
    firstFieldId: undefined,
    operationStartTime: null
};
const $655e95f3b81da53e$var$actions = {
    setSummaryView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'summary'
            });
        },
    setFirstFieldId: (firstFieldId)=>({ setState: setState })=>{
            setState({
                firstFieldId: firstFieldId
            });
        },
    setEditView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'edit'
            });
        },
    setCancelDialogTrigger: (newTrigger = 'user-triggered')=>({ setState: setState, getState: getState })=>{
            const { cancelDialogTrigger: currentTrigger } = getState();
            /* Sometimes both events can be fired (route change & onclick) in one loop
					We need to prioritise route-change event  */ if (currentTrigger === 'route-change' && newTrigger === 'user-triggered') return;
            setState({
                cancelDialogTrigger: newTrigger
            });
        },
    clearDialogTrigger: ()=>({ setState: setState })=>{
            setState({
                cancelDialogTrigger: undefined
            });
        },
    startEdit: (args)=>({ setState: setState })=>{
            const { shouldRenderSpotlight: shouldRenderSpotlight } = args || {
                shouldRenderSpotlight: false
            };
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_EDIT
                },
                shouldRenderSpotlight: shouldRenderSpotlight,
                isSidebarOpen: true,
                operationStartTime: performance.now()
            });
        },
    loadTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).LOAD_BULK_TRANSITIONS
                },
                isSidebarOpen: false
            });
        },
    startQuickTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_QUICK_TRANSITIONS
                },
                isSidebarOpen: false,
                operationStartTime: performance.now()
            });
        },
    startSidebarTransition: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_SIDEBAR_TRANSITION
                },
                isSidebarOpen: true,
                operationStartTime: performance.now()
            });
        },
    startTransitionScreen: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_TRANSITION_SCREEN
                },
                isSidebarOpen: true
            });
        },
    dismissBulkOperation: ({ createAnalyticsEvent: createAnalyticsEvent, dismissType: dismissType })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const analyticsEvent = createAnalyticsEvent({});
            const operationEndTime = performance.now();
            const operationTimeTaken = currentState.operationStartTime ? operationEndTime - currentState.operationStartTime : null;
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'dismissed bulkOperations', {
                dismissType: dismissType,
                operationTimeTaken: operationTimeTaken
            });
            (0, $5ltfA.extraFormDataService).clear();
            setState($655e95f3b81da53e$export$d4c72bab9d6cc13a);
        }
};
const $655e95f3b81da53e$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $655e95f3b81da53e$export$d4c72bab9d6cc13a,
    actions: $655e95f3b81da53e$var$actions,
    name: 'bulk-operations-store'
});
const $655e95f3b81da53e$export$940587be18a93fc4 = (0, $3sQ5x.createHook)($655e95f3b81da53e$export$6f57813fe9f31bf9);
const $655e95f3b81da53e$export$355499dfde532d1a = (0, $3sQ5x.createActionsHook)($655e95f3b81da53e$export$6f57813fe9f31bf9);
const $655e95f3b81da53e$export$760458c2204457a1 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType !== null
});
const $655e95f3b81da53e$export$4a165cf2377f023a = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>!!state.shouldRenderSpotlight
});
const $655e95f3b81da53e$export$b3afff39a0c663ad = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        const { operationType: operationType } = state;
        if (operationType?.type === (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION) return operationType.stage;
        return null;
    }
});
const $655e95f3b81da53e$export$6794339387d6d562 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        if (state.isSidebarOpen && state.operationType) return state.operationType.type;
        return null;
    }
});
const $655e95f3b81da53e$export$4289f82da677ffac = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType
});
const $655e95f3b81da53e$export$babceeeb2408337b = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.cancelDialogTrigger
});
const $655e95f3b81da53e$export$8ce7af7b2f8c770 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.currentView
});

});
parcelRegister("5ltfA", function(module, exports) {

$parcel$export(module.exports, "extraFormDataService", () => $3546d70b36caa00c$export$3cd9d97d155e8e66);
class $3546d70b36caa00c$var$ExtraFormData {
    clear() {
        this.data = {};
    }
    addByKey(key, value) {
        this.data[key] = value;
    }
    getByKey(key) {
        return this.data[key];
    }
    getAll() {
        return this.data;
    }
    constructor(){
        this.data = {};
    }
}
const $3546d70b36caa00c$var$extraFormData = new $3546d70b36caa00c$var$ExtraFormData();
const $3546d70b36caa00c$var$addDataByKey = (key, value)=>{
    $3546d70b36caa00c$var$extraFormData.addByKey(key, value);
};
const $3546d70b36caa00c$var$clear = ()=>{
    $3546d70b36caa00c$var$extraFormData.clear();
};
const $3546d70b36caa00c$var$getDataByKey = (key)=>$3546d70b36caa00c$var$extraFormData.getByKey(key);
const $3546d70b36caa00c$var$getData = ()=>$3546d70b36caa00c$var$extraFormData.getAll();
const $3546d70b36caa00c$export$3cd9d97d155e8e66 = {
    addDataByKey: $3546d70b36caa00c$var$addDataByKey,
    getDataByKey: $3546d70b36caa00c$var$getDataByKey,
    clear: $3546d70b36caa00c$var$clear,
    getData: $3546d70b36caa00c$var$getData
};

});

parcelRegister("liV8G", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsTypes", () => $41c61f309c49c414$export$7ec2782f56bb6e02);
$parcel$export(module.exports, "BulkTransitionsStage", () => $41c61f309c49c414$export$a6f51fa6c8971716);
const $41c61f309c49c414$export$7ec2782f56bb6e02 = {
    BULK_EDIT: 'BULK_EDIT',
    BULK_TRANSITION: 'BULK_TRANSITION',
    BULK_DELETE: 'BULK_DELETE',
    BULK_WATCH: 'BULK_WATCH',
    BULK_UNWATCH: 'BULK_UNWATCH'
};
const $41c61f309c49c414$export$a6f51fa6c8971716 = {
    LOAD_BULK_TRANSITIONS: 'LOAD_BULK_TRANSITIONS',
    START_QUICK_TRANSITIONS: 'START_QUICK_TRANSITIONS',
    START_SIDEBAR_TRANSITION: 'START_SIDEBAR_TRANSITION',
    START_TRANSITION_SCREEN: 'START_TRANSITION_SCREEN'
};
const $41c61f309c49c414$export$1550a2cc6d56ae33 = {
    // ERRORS //
    ERROR_BULK_EDIT: 'ERROR_BULK_EDIT',
    ERROR_BULK_TRANSITION: 'ERROR_BULK_TRANSITION',
    ERROR_BULK_TRANSITION_SCREEN_MOUNT: 'ERROR_BULK_TRANSITION_SCREEN_MOUNT',
    // BULK EDIT //
    EDIT_FORM_PRISTINE_CANCEL: 'EDIT_FORM_PRISTINE_CANCEL',
    EDIT_FORM_DIRTY_CANCEL: 'EDIT_FORM_DIRTY_CANCEL',
    EDIT_FORM_SUMMARY_CANCEL: 'EDIT_FORM_SUMMARY_CANCEL',
    EDIT_ATTEMPT_SUBMIT: 'EDIT_ATTEMPT_SUBMIT',
    // TRANSITION DIALOG //
    TRANSITION_DIALOG_PRISTINE_CANCEL: 'TRANSITION_DIALOG_PRISTINE_CANCEL',
    TRANSITION_DIALOG_DIRTY_CANCEL: 'TRANSITION_DIALOG_DIRTY_CANCEL',
    TRANSITION_DIALOG_CANT_CONTINUE_WARNING: 'TRANSITION_DIALOG_CANT_CONTINUE_WARNING',
    TRANSITION_DIALOG_ATTEMPT_SUBMIT: 'TRANSITION_DIALOG_ATTEMPT_SUBMIT',
    // TRANSITION FORM //
    TRANSITION_FORM_PRISTINE_CANCEL: 'TRANSITION_FORM_PRISTINE_CANCEL',
    TRANSITION_FORM_DIRTY_CANCEL: 'TRANSITION_FORM_DIRTY_CANCEL',
    TRANSITION_FORM_ATTEMPT_SUBMIT: 'TRANSITION_FORM_ATTEMPT_SUBMIT',
    // TRANSITION WITH SCREEN //
    TRANSITION_WITH_SCREEN_LEGACY_LINK: 'TRANSITION_WITH_SCREEN_LEGACY_LINK',
    TRANSITION_WITH_SCREEN_SUMMARY_CANCEL: 'TRANSITION_WITH_SCREEN_SUMMARY_CANCEL',
    TRANSITION_WITH_SCREEN_CANCEL: 'TRANSITION_WITH_SCREEN_CANCEL',
    // BULK DELETE //
    DELETE_ATTEMPT_SUBMIT: 'DELETE_ATTEMPT_SUBMIT',
    DELETE_ATTEMPT_CANCEL: 'DELETE_CANCEL',
    // BULK WATCH //
    WATCH_ATTEMPT_SUBMIT: 'WATCH_ATTEMPT_SUBMIT',
    // BULK UNWATCH //
    UNWATCH_ATTEMPT_SUBMIT: 'UNWATCH_ATTEMPT_SUBMIT',
    // OTHER //
    NAVIGATION: 'NAVIGATION',
    DESELECT_ALL_ISSUES: 'DESELECT_ALL_ISSUES'
};

});


parcelRegister("8RB1G", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkOpsCoreFull", () => $0713926df1958104$export$5a522923c01d18f2);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $52qhI = parcelRequire("52qhI");
const $0713926df1958104$export$5a522923c01d18f2 = (props)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $52qhI.asyncBulkOpsCoreFullEntryPoint), entryPointParams);
    // This type conversion fixes the below CI build error
    // Type 'Omit<BulkOperationsCoreLoader<TEntryPoint>, "hasBulkEditPermission">' is not assignable to type 'Omit<BulkOperationsCoreLoader<AnyEntryPoint | undefined>, "hasBulkEditPermission">'
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fixedEntryPointReferenceSubject = entryPointReferenceSubject;
    // this is to reduce the load to NIN when adding bulk ops
    // we should revisit later to remove this and load bulk ops same as the way backlog loads
    // https://hello.jira.atlassian.cloud/browse/DEE-6353
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.backlog.bulk.operations.core.full",
        packageName: "jiraBulkOperationsCoreFull",
        entryPointReferenceSubject: fixedEntryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: props
    });
};

});
parcelRegister("52qhI", function(module, exports) {

$parcel$export(module.exports, "asyncBulkOpsCoreFullEntryPoint", () => $42e200e10d2ccac9$export$4586bee469e9f8fc);

var $61xJ7 = parcelRequire("61xJ7");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $42e200e10d2ccac9$export$4586bee469e9f8fc = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("h7GtL")), {
        moduleId: "46b63f73"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                permissionsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $61xJ7.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("61xJ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcabe91a5fb1367e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb430c501ccce22cd8ca816174850f68>>
 * @relayHash da2409ae2bc56c51b0f8898e8ba8c588
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f80926256dac19536f6b2057ab2e6fe8c357e6ab85002583f57fdbb921f12d7
const $dcabe91a5fb1367e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4f80926256dac19536f6b2057ab2e6fe8c357e6ab85002583f57fdbb921f12d7",
        "metadata": {},
        "name": "srcFullCoreQuery",
        "operationKind": "query",
        "text": null
    }
};
var $dcabe91a5fb1367e$export$2e2bcd8739ae039 = $dcabe91a5fb1367e$var$node;

});

parcelRegister("h7GtL", function(module, exports) {

let $c7740a93d809180b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c7740a93d809180b$var$load("3smSX").then(()=>parcelRequire('anh2a'));

});




parcelRegister("jKHs3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a32f27c74f4bd66c$export$2e2bcd8739ae039);

var $3mkkt = parcelRequire("3mkkt");

var $ragIq = parcelRequire("ragIq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $3Tty1 = parcelRequire("3Tty1");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $imS60 = parcelRequire("imS60");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $6UAdF = parcelRequire("6UAdF");

var $eojy4 = parcelRequire("eojy4");

var $gtUFk = parcelRequire("gtUFk");

var $5NwJk = parcelRequire("5NwJk");

var $7OTah = parcelRequire("7OTah");

var $kj1di = parcelRequire("kj1di");

var $isIOR = parcelRequire("isIOR");

var $38r5c = parcelRequire("38r5c");

var $5lE9L = parcelRequire("5lE9L");
const $a32f27c74f4bd66c$var$useAnalyticsAttributes = (type)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!type) return;
        const projectType = (0, $2vSU6.toProjectType)(type.toLowerCase());
        if (!projectType) return;
        const edition = (0, $ldyPw.getEditionForProject)(projectType, appEditions);
        if (!edition) return;
        return {
            edition: edition
        };
    }, [
        appEditions,
        type
    ]);
};
const $a32f27c74f4bd66c$var$FullPageIssueApp = ({ onChangeIssue: onChangeIssue, issueResults: issueResults, view: view, projectType: projectType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let isFetching;
    let isForcedSelectionOnReset;
    let exitFullPageIssueAppMode;
    let selectNextIssue;
    let selectPreviousIssue;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isFetching = (0, $38r5c.useIsFetching)();
        // TODO Remove this condition when cleaning up jira_spreadsheet_component_m1
        isForcedSelectionOnReset = false;
        ({ exitFullPageIssueAppMode: exitFullPageIssueAppMode, selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $7OTah.useSelectedIssueActions)());
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ isFetching: isFetching } = (0, $isIOR.useIssueSearchQuery)());
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isForcedSelectionOnReset = (0, $gtUFk.useIsForcedSelectionOnReset)();
        ({ exitFullPageIssueAppMode: exitFullPageIssueAppMode, selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $gtUFk.useSelectedIssueStateOldActions)());
    }
    const onBackToSearch = (0, $5uXOq.useCallback)(()=>{
        // Clear the selected issue key from the URL and return to normal view mode
        onChangeIssue((0, $g5X3G.toIssueKey)(''), true);
        exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        onChangeIssue
    ]);
    const onBackToSearchByButton = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent.clone(), 'returnToSearch');
        onBackToSearch();
    }, [
        onBackToSearch
    ]);
    const onBackToSearchByKeyboardShortcut = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'issue'
        }), 'returnToSearch', {
            keyPressed: 'z',
            keyboardShortcut: true
        });
        onBackToSearch();
    }, [
        onBackToSearch,
        createAnalyticsEvent
    ]);
    const onNextIssue = (0, $5uXOq.useCallback)(()=>{
        if (selectNextIssue()) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'nextIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectNextIssue
    ]);
    const onPreviousIssue = (0, $5uXOq.useCallback)(()=>{
        if (selectPreviousIssue()) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'previousIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectPreviousIssue
    ]);
    // If a new search is being run and we do not have forced issue selection (i.e. issue app pagination) then return to
    // normal view mode. This can happen when a filter is clicked in the sidebar or browser history navigation.
    (0, $5uXOq.useEffect)(()=>{
        if (isFetching && !isForcedSelectionOnReset) exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        isFetching,
        isForcedSelectionOnReset
    ]);
    const backToSearch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "issue-navigator.ui.full-page-issue-app.return-to-search",
        onClick: onBackToSearchByButton,
        interactionName: "issue-navigator-full-page-issue-app-return-to-search"
    }, formatMessage((0, $5lE9L.default).returnText));
    const issueResultsData = (0, $8Uumt.useFragment)((0, $ragIq.default), issueResults);
    const viewData = (0, $8Uumt.useFragment)((0, $3mkkt.default), view);
    let attributes;
    if ((0, $4R6GH.fg)('add-attribute-required-for-colorful-labels-expe')) // eslint-disable-next-line react-hooks/rules-of-hooks
    attributes = $a32f27c74f4bd66c$var$useAnalyticsAttributes(projectType);
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const fieldSetIds = (0, $5uXOq.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
            viewData?.fieldSets?.edges
        ]);
        const { hasPrevious: hasPrevious, isLoadingPrevious: isLoadingPrevious, onLoadPrevious: onLoadPrevious, hasNext: hasNext, isLoadingNext: isLoadingNext, onLoadNext: onLoadNext } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $kj1di.useInfiniteScroll)({
            fieldSetIds: fieldSetIds,
            view: null
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const selectedIssueKey = (0, $5NwJk.useSelectedIssueKey)();
        const edges = issueResultsData?.edges ?? [];
        const isFirstIssueSelected = edges[0]?.node?.key === selectedIssueKey;
        const isLastIssueSelected = edges[edges.length - 1]?.node?.key === selectedIssueKey;
        // Automatically fetch previous and next pages while navigating issues in full page mode
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useEffect)(()=>{
            if (isFirstIssueSelected && hasPrevious && !isLoadingPrevious) onLoadPrevious?.();
        }, [
            hasPrevious,
            isFirstIssueSelected,
            isLoadingPrevious,
            onLoadPrevious
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $5uXOq.useEffect)(()=>{
            if (isLastIssueSelected && hasNext && !isLoadingNext) onLoadNext?.();
        }, [
            hasNext,
            isLastIssueSelected,
            isLoadingNext,
            onLoadNext
        ]);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "full-page-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $6UAdF.ANALYTICS_LIST_VIEW_SOURCE_NAME),
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        ...attributes ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: {
            z: {
                callback: onBackToSearchByKeyboardShortcut
            },
            j: {
                callback: onNextIssue
            },
            k: {
                callback: onPreviousIssue
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eojy4.default), {
        isEmbedView: false,
        extraHeaderActions: backToSearch,
        issueResults: issueResultsData,
        view: viewData
    })));
};
var $a32f27c74f4bd66c$export$2e2bcd8739ae039 = $a32f27c74f4bd66c$var$FullPageIssueApp;

});
parcelRegister("3mkkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3361b148cbcd4cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1de1445498b44672cc6e64f801a2e3c6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d3361b148cbcd4cd$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_FullPageIssueApp_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_view"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$d3361b148cbcd4cd$var$node.hash = "9486a61169223702f49af2fa40c90f38";
var $d3361b148cbcd4cd$export$2e2bcd8739ae039 = $d3361b148cbcd4cd$var$node;

});

parcelRegister("ragIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e254396e0247514b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e191fe8f978a91a8364f661a75b25c8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e254396e0247514b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_FullPageIssueApp_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$e254396e0247514b$var$node.hash = "c76ea1c159a6e1be56c13b6262324ca3";
var $e254396e0247514b$export$2e2bcd8739ae039 = $e254396e0247514b$var$node;

});

parcelRegister("eojy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $757f42b291a6a665$export$2e2bcd8739ae039);

var $7loir = parcelRequire("7loir");

var $efKfR = parcelRequire("efKfR");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $cSD7y = parcelRequire("cSD7y");

var $6s1PB = parcelRequire("6s1PB");

var $7LYcV = parcelRequire("7LYcV");

var $b3DTW = parcelRequire("b3DTW");

var $FTaAj = parcelRequire("FTaAj");

var $7eqRV = parcelRequire("7eqRV");

var $5gJcp = parcelRequire("5gJcp");

var $iXVV6 = parcelRequire("iXVV6");

var $g5X3G = parcelRequire("g5X3G");

var $dZw8H = parcelRequire("dZw8H");

var $kxZPA = parcelRequire("kxZPA");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $2su1H = parcelRequire("2su1H");

var $gtUFk = parcelRequire("gtUFk");

var $5NwJk = parcelRequire("5NwJk");

var $7OTah = parcelRequire("7OTah");

var $isIOR = parcelRequire("isIOR");

var $cqgcE = parcelRequire("cqgcE");

var $6Hhfn = parcelRequire("6Hhfn");

var $6UAdF = parcelRequire("6UAdF");

var $a8lIB = parcelRequire("a8lIB");

var $9aomo = parcelRequire("9aomo");

var $ltUBN = parcelRequire("ltUBN");


const $757f42b291a6a665$var$AsyncIssueAppComponent = (0, $cSD7y.componentWithFG)('make_nins_issue_app_lazyforpaint', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>(parcelRequire("kFLe7")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
}), // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("kFLe7")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
}));
const $757f42b291a6a665$var$AsyncIssueAppUsingLoadingPhases = ({ isEmbedView: isEmbedView, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: "issue-navigator",
        isEmbedView: isEmbedView,
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b3DTW.UnknownErrorView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($757f42b291a6a665$var$AsyncIssueAppComponent, rest));
const $757f42b291a6a665$var$issueCardChangeExcludedEventTypes = [
    (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_REQUESTED,
    (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_FAILED,
    (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED,
    (0, $FTaAj.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED
];
const $757f42b291a6a665$var$useJSCM1CompatibleActions = (connectionId, fieldSetIds)=>{
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey // eslint-disable-next-line react-hooks/rules-of-hooks
         } = (0, $7OTah.useSelectedIssueActions)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        const onDeleteIssue = (0, $cqgcE.useOnDeleteIssue)(connectionId); // eslint-disable-next-line react-hooks/rules-of-hooks
        const onIssueByFieldsRefetch = (0, $6Hhfn.useIssueByFieldsRefetch)(fieldSetIds);
        return {
            deselectIssue: deselectIssue,
            exitFullPageIssueAppMode: exitFullPageIssueAppMode,
            setSelectedIssueByKey: setSelectedIssueByKey,
            onDeleteIssue: onDeleteIssue,
            onIssueByFieldsRefetch: onIssueByFieldsRefetch
        };
    }
    const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey } = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gtUFk.useSelectedIssueStateOldActions)();
    const { onDeleteIssue: onDeleteIssue, onIssueByFieldsRefetch: onIssueByFieldsRefetch } = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $isIOR.useIssueSearchQuery)();
    return {
        deselectIssue: deselectIssue,
        exitFullPageIssueAppMode: exitFullPageIssueAppMode,
        setSelectedIssueByKey: setSelectedIssueByKey,
        onDeleteIssue: onDeleteIssue,
        onIssueByFieldsRefetch: onIssueByFieldsRefetch
    };
};
const $757f42b291a6a665$var$IssueAppWithData = ({ IssueApp: IssueApp = $757f42b291a6a665$var$AsyncIssueAppUsingLoadingPhases, extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, issueResults: issueResults, view: view })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_APP_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_APP_END);
    }, []);
    const selectedIssueKey = (0, $5NwJk.useSelectedIssueDebouncedState)();
    const issueResultsData = (0, $8Uumt.useFragment)((0, $efKfR.default), issueResults);
    let fieldSetIds = [];
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const viewData = (0, $8Uumt.useFragment)((0, $7loir.default), view); // eslint-disable-next-line react-hooks/rules-of-hooks
        fieldSetIds = (0, $5uXOq.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
            viewData?.fieldSets?.edges
        ]);
    }
    const { onInteractive: onInteractive } = (0, $2su1H.useStartNinIssueAppAnalytics)(selectedIssueKey);
    const issueAppMetrics = (0, $5uXOq.useMemo)(()=>({
            onInteractive: onInteractive
        }), [
        onInteractive
    ]);
    const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey, onDeleteIssue: onDeleteIssue, onIssueByFieldsRefetch: onIssueByFieldsRefetch } = $757f42b291a6a665$var$useJSCM1CompatibleActions(issueResultsData?.__id, fieldSetIds);
    const refetchCallback = (0, $5uXOq.useRef)(onIssueByFieldsRefetch);
    refetchCallback.current = onIssueByFieldsRefetch;
    const onIssueDeleteSuccess = (0, $5uXOq.useCallback)(({ issueKey: deletedIssueKey })=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue(); // Return to list view if we were in full page mode
            exitFullPageIssueAppMode();
        } else setSelectedIssueByKey((0, $g5X3G.toIssueKey)(issueKeyToSelect));
    }, [
        deselectIssue,
        exitFullPageIssueAppMode,
        onDeleteIssue,
        setSelectedIssueByKey
    ]);
    const onIssueKeyChange = (0, $5uXOq.useCallback)((issueKeys)=>{
        setSelectedIssueByKey(issueKeys.toIssueKey);
    }, [
        setSelectedIssueByKey
    ]);
    const issueContainerMaxWidth = (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? (0, $5gJcp.getIssueContainerIncreasedMaxWidth)() : (0, $5gJcp.getIssueContainerDefaultMaxWidth)(); // When we're in non-embedded view (i.e. full page) we need to define a max width to ensure correct full page
    // styling within the issue app.
    const maxWidth = !isEmbedView ? issueContainerMaxWidth : undefined;
    let isFullPageIssueAppMode = false;
    if ((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6')) // eslint-disable-next-line react-hooks/rules-of-hooks
    isFullPageIssueAppMode = (0, $5NwJk.useIsFullPageIssueAppMode)();
    const shouldWrapMargin = !isFullPageIssueAppMode && (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6');
    if (!(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [issueSelection] = (0, $gtUFk.useIssueSelectionState)();
        if (issueSelection === (0, $gtUFk.selectionState).BLANK_ISSUE_SELECTED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($757f42b291a6a665$var$IssueAppContainer, {
            isEmbedView: isEmbedView,
            shouldWrapMargin: shouldWrapMargin
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9aomo.default), {
            issueResults: issueResultsData,
            extraHeaderActions: extraHeaderActions,
            isEmbedView: isEmbedView,
            maxWidth: maxWidth
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LYcV.PermissionErrorView), null));
    }
    if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $ltUBN.useScrollToActivityFeed)(selectedIssueKey);
    if (!selectedIssueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageErrorReady), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($757f42b291a6a665$var$IssueAppContainer, {
        isEmbedView: isEmbedView,
        shouldWrapMargin: shouldWrapMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9aomo.default), {
        issueResults: issueResultsData,
        extraHeaderActions: extraHeaderActions,
        isEmbedView: isEmbedView,
        maxWidth: maxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($757f42b291a6a665$var$IssueAppHeightAdjustment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "issueNavigatorEmbeddedIssueView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueApp, {
        metrics: issueAppMetrics,
        key: selectedIssueKey,
        isEmbedView: isEmbedView,
        analyticsSource: (0, $6UAdF.ANALYTICS_SOURCE),
        issueKey: (0, $g5X3G.toIssueKey)(selectedIssueKey),
        issueMaxWidth: maxWidth,
        onIssueKeyChange: onIssueKeyChange,
        onChange: (event)=>{
            if (event && !$757f42b291a6a665$var$issueCardChangeExcludedEventTypes.includes(event.type)) refetchCallback.current(String(selectedIssueKey));
        },
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        shouldSetInitialFocus: false
    }))));
};
var $757f42b291a6a665$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $757f42b291a6a665$var$IssueAppWithData;
const $757f42b291a6a665$var$IssueAppContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldWrapMargin: shouldWrapMargin, isEmbedView: isEmbedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _16jlkb7n _4t3i1osq _1ul9idpf _1e0c1txw _2lx21bp4 _vchhusvi",
            __cmplp.shouldWrapMargin && "_2hwx10v4",
            !__cmplp.isEmbedView && "_ca0qxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $757f42b291a6a665$var$IssueAppHeightAdjustment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1tkeidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7loir", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cec674991979ea9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3f03f0bd7e03dd7b5efb9130a123ed96>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5cec674991979ea9$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueAppWithData_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$5cec674991979ea9$var$node.hash = "17aabbd02b42b64821e748007bf69f7b";
var $5cec674991979ea9$export$2e2bcd8739ae039 = $5cec674991979ea9$var$node;

});

parcelRegister("efKfR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e62e5ab28765e44$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1eb167471fb64a02bbc7a0985243c9bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e62e5ab28765e44$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueAppWithData_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "headerActions_issueNavigator"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$3e62e5ab28765e44$var$node.hash = "267fadd3844f360bfc7e5d9f255f3ee7";
var $3e62e5ab28765e44$export$2e2bcd8739ae039 = $3e62e5ab28765e44$var$node;

});

parcelRegister("7LYcV", function(module, exports) {

$parcel$export(module.exports, "PermissionErrorView", () => $46330205bd9e339c$export$1bd3db7a0a8884d3);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $2JXc1 = parcelRequire("2JXc1");

var $koVbs = parcelRequire("koVbs");

var $iEg2R = parcelRequire("iEg2R");

var $5FlWj = parcelRequire("5FlWj");
const $46330205bd9e339c$var$ErrorImage = ()=>(0, $4R6GH.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $46330205bd9e339c$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JXc1.default), {
        width: 90,
        height: 130,
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2JXc1.default), {
        width: 90,
        height: 130,
        alt: ""
    });
const $46330205bd9e339c$export$1bd3db7a0a8884d3 = ()=>{
    const intl = (0, $koVbs.default)();
    return (0, $4R6GH.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "issue-view-errors.ui.permission-error-view.permission-error-view",
        header: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5FlWj.messages).permissionErrorHeaderIssueTermRefresh : (0, $5FlWj.messages).permissionErrorHeader),
        description: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5FlWj.messages).permissionErrorDescriptionIssueTermRefresh : (0, $5FlWj.messages).permissionErrorDescription),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46330205bd9e339c$var$ErrorImage, null)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iEg2R.ErrorDisplay), {
        header: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5FlWj.messages).permissionErrorHeaderIssueTermRefresh : (0, $5FlWj.messages).permissionErrorHeader),
        description: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5FlWj.messages).permissionErrorDescriptionIssueTermRefresh : (0, $5FlWj.messages).permissionErrorDescription),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46330205bd9e339c$var$ErrorImage, null)
    });
};
const $46330205bd9e339c$var$imageWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});
parcelRegister("2JXc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5d3fe7c3133ec07$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = mmwr66tqxzps49fhmn4694w
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/mmwr66tqxzps49fhmn4694w

var $dCLgq = parcelRequire("dCLgq");

var $cid60 = parcelRequire("cid60");

var $6y2Qu = parcelRequire("6y2Qu");
const $c5d3fe7c3133ec07$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6y2Qu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cid60))
});
var $c5d3fe7c3133ec07$export$2e2bcd8739ae039 = $c5d3fe7c3133ec07$var$Illustration;
// for advanced use only
const $c5d3fe7c3133ec07$export$a179c88182cb9d56 = [
    0,
    0,
    191,
    222
];

});
parcelRegister("cid60", function(module, exports) {
module.exports = new URL("lock-closed-darkmode.26d51607.svg", import.meta.url).toString();

});

parcelRegister("6y2Qu", function(module, exports) {
module.exports = new URL("lock-closed.22dbfd6e.svg", import.meta.url).toString();

});


parcelRegister("iEg2R", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $42c3be45cf82ac6a$export$d56b0569bceb92ae);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $42c3be45cf82ac6a$export$d56b0569bceb92ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42c3be45cf82ac6a$var$Container, {
        "data-testid": "issue-view-errors.common.ui.error-display.permission-error-display"
    }, props.image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42c3be45cf82ac6a$var$Heading, null, props.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42c3be45cf82ac6a$var$Description, null, props.description), props.children);
$42c3be45cf82ac6a$export$d56b0569bceb92ae.defaultProps = {
    description: undefined,
    children: null
};
/**
 * Duplicated from `src/packages/issue/issue-view/src/views/issue-details/issue-modal/styled.tsx`
 *
 * TODO: Derive properly on `src/packages/issue/issue-view/src/views/issue-details/error` cleanup
 */ const $42c3be45cf82ac6a$var$modalDialogContainerSelectorName = 'jira.issue-view.issue-details.modal-dialog-container';
const $42c3be45cf82ac6a$var$MODAL_DIALOG_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$42c3be45cf82ac6a$var$modalDialogContainerSelectorName}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $42c3be45cf82ac6a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _2lx21bp4 _syaz1fxt _1e0c1txw _1bah1h6o _4cvr1h6o _ca0qxncg _17ipxncg _1ksgidpf",
            __cmplp.className
        ])
    });
});
const $42c3be45cf82ac6a$var$Heading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8lodh _19pkutpp _otyrutpp _p12f1osq",
            __cmplp.className
        ])
    });
});
const $42c3be45cf82ac6a$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5FlWj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7e93cdae4f6f7e95$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7e93cdae4f6f7e95$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    permissionErrorHeader: {
        "id": "issue-view-errors.permission-error-view.permission-error-header",
        "defaultMessage": "You don't have access to this issue"
    },
    permissionErrorDescription: {
        "id": "issue-view-errors.permission-error-view.permission-error-description",
        "defaultMessage": "Make sure the issue exists in this project. If it does, ask a project admin for permission to see the project's issues."
    },
    permissionErrorHeaderIssueTermRefresh: {
        "id": "issue-view-errors.permission-error-view.permission-error-header-issue-term-refresh",
        "defaultMessage": "You don't have access to this work item"
    },
    permissionErrorDescriptionIssueTermRefresh: {
        "id": "issue-view-errors.permission-error-view.permission-error-description-issue-term-refresh",
        "defaultMessage": "Make sure the work item exists in this project. If it does, ask a project admin for permission to see work in this project."
    }
});

});


parcelRegister("b3DTW", function(module, exports) {

$parcel$export(module.exports, "UnknownErrorView", () => $37e65e4dbd5a0c18$export$f23f26771420affd);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $bH03R = parcelRequire("bH03R");

var $koVbs = parcelRequire("koVbs");

var $iEg2R = parcelRequire("iEg2R");

var $1HGxj = parcelRequire("1HGxj");
const $37e65e4dbd5a0c18$var$ErrorImage = ()=>{
    return (0, $4R6GH.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $37e65e4dbd5a0c18$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bH03R.default), {
        width: 90,
        height: 130,
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bH03R.default), {
        width: 90,
        height: 130,
        alt: ""
    });
};
const $37e65e4dbd5a0c18$export$f23f26771420affd = ()=>{
    const intl = (0, $koVbs.default)();
    return (0, $4R6GH.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "issue-view-errors.ui.unknown-error-view.unknown-error-view",
        header: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1HGxj.messages).unknownErrorHeaderIssueTermRefresh : (0, $1HGxj.messages).unknownErrorHeader),
        description: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1HGxj.messages).unknownErrorDescriptionIssueTermRefresh : (0, $1HGxj.messages).unknownErrorDescription),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37e65e4dbd5a0c18$var$ErrorImage, null)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iEg2R.ErrorDisplay), {
        header: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1HGxj.messages).unknownErrorHeaderIssueTermRefresh : (0, $1HGxj.messages).unknownErrorHeader),
        description: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1HGxj.messages).unknownErrorDescriptionIssueTermRefresh : (0, $1HGxj.messages).unknownErrorDescription),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37e65e4dbd5a0c18$var$ErrorImage, null)
    });
};
const $37e65e4dbd5a0c18$var$imageWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});
parcelRegister("bH03R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8185200722e377$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $6FRgI = parcelRequire("6FRgI");
const $2a8185200722e377$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6FRgI)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6FRgI))
});
var $2a8185200722e377$export$2e2bcd8739ae039 = $2a8185200722e377$var$Illustration;
// for advanced use only
const $2a8185200722e377$export$a179c88182cb9d56 = [
    0,
    0,
    104,
    140
];

});
parcelRegister("6FRgI", function(module, exports) {
module.exports = new URL("empty-search-error-colour.f0aa9e5e.svg", import.meta.url).toString();

});


parcelRegister("1HGxj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5157af2738c78f52$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5157af2738c78f52$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unknownErrorHeader: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header",
        "defaultMessage": "We couldn't connect to that issue"
    },
    unknownErrorDescription: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description",
        "defaultMessage": "Make sure that this issue actually exists in that project. If it does, try again in a few minutes. If you still can't link to the issue, contact your Jira admin."
    },
    unknownErrorHeaderIssueTermRefresh: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header-issue-term-refresh",
        "defaultMessage": "We couldn't connect to that work item."
    },
    unknownErrorDescriptionIssueTermRefresh: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description-issue-term-refresh",
        "defaultMessage": "Make sure that this work item actually exists in that project. If it does, try again in a few minutes. If you still can't link to the work item, contact your Jira admin."
    }
});

});


parcelRegister("FTaAj", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
    [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
    [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
    [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("7eqRV", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $e3c8771effba3477$export$fbf48ede0cf52b5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $lb0Dk = parcelRequire("lb0Dk");
const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("lb0Dk", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $bf9ca492e3d15685$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iMqhh = parcelRequire("iMqhh");

var $4R6GH = parcelRequire("4R6GH");

var $hCy6k = parcelRequire("hCy6k");

var $gERis = parcelRequire("gERis");
const $bf9ca492e3d15685$var$fullpageStyles = null;
const $bf9ca492e3d15685$var$modalStyles = null;
const $bf9ca492e3d15685$var$customSpacingStylesWithIncreasedWidth = null;
const $bf9ca492e3d15685$var$customSpacingStylesWithDefaultWidth = null;
const $bf9ca492e3d15685$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? $bf9ca492e3d15685$var$customSpacingStylesWithIncreasedWidth : $bf9ca492e3d15685$var$customSpacingStylesWithDefaultWidth,
        isEmbedView !== true && isModalView !== true ? $bf9ca492e3d15685$var$fullpageStyles : null,
        isModalView === true ? $bf9ca492e3d15685$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMqhh.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gERis))),
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi" : "_p12f1ypn _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("iMqhh", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $db79d17d45755de5$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $db79d17d45755de5$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $db79d17d45755de5$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $8kj45 = parcelRequire("8kj45");

var $doZTA = parcelRequire("doZTA");

var $k1L82 = parcelRequire("k1L82");

var $hhMVP = parcelRequire("hhMVP");
const $db79d17d45755de5$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
const $db79d17d45755de5$export$ddd398a95f85cd75 = 850;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$db79d17d45755de5$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $db79d17d45755de5$var$useRouteKey() {
    const [routeState] = (0, $doZTA.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $db79d17d45755de5$var$useRouteKey();
    (0, $hhMVP.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $hhMVP.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
        (0, $hhMVP.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInSidePanelExperiment: isInSidePanelExperiment } = (0, $k1L82.useIssueLayoutActivitySidePanel)();
    const query = isInSidePanelExperiment ? $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8kj45.ContainerQueryObserver), {
        query: query,
        onChange: (state)=>{
            (0, $hhMVP.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
        value: isCompact
    }, children));
};
const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db79d17d45755de5$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;

parcelRegister("8kj45", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $ed10e3c030ea0408$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $ed10e3c030ea0408$var$QueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
let $ed10e3c030ea0408$var$currentIdSeed = 0;
function $ed10e3c030ea0408$var$generateAttributeValue() {
    return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
}
function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $5uXOq.useState)(defaultState);
    const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $ed10e3c030ea0408$export$b66a67697973e01() {
    const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
    const spanRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed10e3c030ea0408$var$ContainerToBeQueried = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("k1L82", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainers", () => $725285d3420dc4d6$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $725285d3420dc4d6$export$5f49a43487b268);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $725285d3420dc4d6$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $725285d3420dc4d6$export$5962da0433486667);
$parcel$export(module.exports, "useIssueLayoutActivitySidePanel", () => $725285d3420dc4d6$export$8105ff1c0f6ac8a9);
$parcel$export(module.exports, "useIssueLayoutActions", () => $725285d3420dc4d6$export$1e5e9fc877a47cd9);

var $5uXOq = parcelRequire("5uXOq");

var $egBua = parcelRequire("egBua");

var $6s1PB = parcelRequire("6s1PB");

var $eNNkf = parcelRequire("eNNkf");

var $2gCtH = parcelRequire("2gCtH");


var $93Yeu = parcelRequire("93Yeu");

var $2vSU6 = parcelRequire("2vSU6");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $bCdIp = parcelRequire("bCdIp");

var $kI4MM = parcelRequire("kI4MM");

var $cNJ33 = parcelRequire("cNJ33");
const $725285d3420dc4d6$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $725285d3420dc4d6$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $egBua.useEnabledHiddenFields)();
    return [
        (0, $cNJ33.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
    ];
};
const $725285d3420dc4d6$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $kI4MM.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $725285d3420dc4d6$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $kI4MM.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $725285d3420dc4d6$export$8105ff1c0f6ac8a9 = ()=>{
    try {
        /* eslint-disable react-hooks/rules-of-hooks */ if (!(0, $4R6GH.fg)('issue-view-side-panel-activity-kill-switch')) return {
            isActivityInVerticalSidePanel: false,
            isInSidePanelExperiment: false,
            activityLayoutView: null
        };
        // Get required values
        const isFullIssueView = (0, $2gCtH.useIsFullPageIssueView)();
        const [activityLayoutView] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$2cf981c493d79a21));
        const issueKey = (0, $2gCtH.useIssueKey)();
        const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
        const projectType = (0, $93Yeu.useProjectType)(projectKey);
        const isMobile = (0, $bCdIp.default)();
        /* eslint-enable react-hooks/rules-of-hooks */ const isJiraIssue = projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT);
        // Determine if in experiment condition based on project type, view and inline experiment evaluation
        const isInSidePanelExperiment = !isMobile && isJiraIssue && isFullIssueView && (0, $6s1PB.expVal)('issue-view-side-panel-activity', 'isActivityInSidePanel', false);
        // Compute final values directly
        const isActivityInVerticalSidePanel = isInSidePanelExperiment && activityLayoutView === 'VERTICAL';
        // Return object with named properties
        return {
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            isInSidePanelExperiment: Boolean(isInSidePanelExperiment),
            activityLayoutView: activityLayoutView
        };
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useIssueLayoutActivitySidePanel : ${error}`);
        return {
            isActivityInVerticalSidePanel: false,
            isInSidePanelExperiment: false,
            activityLayoutView: null
        };
    }
};
const $725285d3420dc4d6$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $kI4MM.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $5uXOq.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $5uXOq.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $5uXOq.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};

});
parcelRegister("egBua", function(module, exports) {

$parcel$export(module.exports, "useEnabledHiddenFields", () => $ea65d07999c73532$export$bb6c2b9159c3f32b);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $jrwZp = parcelRequire("jrwZp");

var $eoznE = parcelRequire("eoznE");
const $ea65d07999c73532$export$bb6c2b9159c3f32b = ()=>{
    (0, $gKZoD.di)((0, $jrwZp.useAdjustmentsEnabled), (0, $eoznE.useHiddenFields));
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const hiddenFields = (0, $eoznE.useHiddenFields)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("jrwZp", function(module, exports) {

$parcel$export(module.exports, "store", () => $db4845f733e81d44$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $db4845f733e81d44$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $db4845f733e81d44$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $db4845f733e81d44$export$5eb9c167b683d125);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $db4845f733e81d44$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $db4845f733e81d44$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($db4845f733e81d44$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $db4845f733e81d44$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-adjustments-context',
    initialState: $db4845f733e81d44$var$initialState,
    actions: $db4845f733e81d44$export$e324594224ef24da
});
const $db4845f733e81d44$export$a12f82a132dee079 = (0, $3sQ5x.createHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$358ad850b2f6d6fe = (0, $3sQ5x.createStateHook)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $db4845f733e81d44$export$4f2729981f4b81d2 = (0, $3sQ5x.createActionsHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$5eb9c167b683d125 = (0, $gg7kZ.createContainer)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("eoznE", function(module, exports) {

$parcel$export(module.exports, "useHiddenFields", () => $8c7bafd209de1659$export$de6fdc67c945e596);

var $6dDSs = parcelRequire("6dDSs");
var $3sQ5x = parcelRequire("3sQ5x");

var $1YewZ = parcelRequire("1YewZ");
const $8c7bafd209de1659$var$selectHiddenFields = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8c7bafd209de1659$export$de6fdc67c945e596 = (0, $3sQ5x.createStateHook)((0, $1YewZ.store), {
    selector: $8c7bafd209de1659$var$selectHiddenFields
});

});
parcelRegister("1YewZ", function(module, exports) {

$parcel$export(module.exports, "store", () => $cf6a6312e4141eb7$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $cf6a6312e4141eb7$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $cf6a6312e4141eb7$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $cf6a6312e4141eb7$export$677b3e34bd14c681);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $3whHg = parcelRequire("3whHg");

var $hyCnL = parcelRequire("hyCnL");

var $boEP0 = parcelRequire("boEP0");

var $2NMWZ = parcelRequire("2NMWZ");

var $d30F5 = parcelRequire("d30F5");

var $8e24q = parcelRequire("8e24q");

var $cTj8m = parcelRequire("cTj8m");

var $i4uue = parcelRequire("i4uue");

var $3iUv8 = parcelRequire("3iUv8");

var $b8ZsE = parcelRequire("b8ZsE");

var $jDMtG = parcelRequire("jDMtG");

var $l0b2q = parcelRequire("l0b2q");

var $4MJXd = parcelRequire("4MJXd");

var $gHQFd = parcelRequire("gHQFd");

var $7JtDe = parcelRequire("7JtDe");
const $cf6a6312e4141eb7$var$name = 'issue-adjustments';
const $cf6a6312e4141eb7$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $cf6a6312e4141eb7$var$triggerFieldInitializationKey, viewType: $cf6a6312e4141eb7$var$scopedViewType, numberOfSupportedFields: $cf6a6312e4141eb7$var$numberOfSupportedFields, ...$cf6a6312e4141eb7$var$stateForResetAllFields } = $cf6a6312e4141eb7$export$d4c72bab9d6cc13a;
const $cf6a6312e4141eb7$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $b8ZsE.processChange,
    setFieldValue: $l0b2q.setFieldValue,
    initializeField: $8e24q.initializeField,
    initializeFields: $8e24q.initializeFields,
    startFieldsInitialisationTimeout: $d30F5.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $d30F5.successFieldsInitalisation,
    registerFields: $jDMtG.registerFields,
    unregisterFields: $jDMtG.unregisterFields,
    updateFields: $gHQFd.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($cf6a6312e4141eb7$var$stateForResetAllFields);
        },
    setError: $2NMWZ.setError,
    resetError: $2NMWZ.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $3whHg.setAppErrors,
    resetAppErrors: $3whHg.resetAppErrors,
    addAppsErrors: $3whHg.addAppsErrors,
    initializeNoScreenTab: $cTj8m.initializeNoScreenTab,
    initializeScreenTabs: $i4uue.initializeScreenTabs,
    updateScreenTabs: $7JtDe.updateScreenTabs,
    updateActiveScreenTab: $4MJXd.updateActiveScreenTab,
    detectAppliedChangesConflicts: $hyCnL.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $boEP0.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $boEP0.collectFieldsAppliedChangesHistory,
    setNotification: $3iUv8.setNotification,
    resetNotification: $3iUv8.resetNotification
};
const $cf6a6312e4141eb7$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: $cf6a6312e4141eb7$var$name,
    initialState: $cf6a6312e4141eb7$export$d4c72bab9d6cc13a,
    actions: $cf6a6312e4141eb7$export$e324594224ef24da
});
const $cf6a6312e4141eb7$export$37792a602e748c08 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe = {};
const $cf6a6312e4141eb7$export$c76e674a29843e21 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $cf6a6312e4141eb7$export$df4b0714e8177e0e = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe
});
const $cf6a6312e4141eb7$export$cb9a014ec14556d8 = (0, $3sQ5x.createActionsHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$export$677b3e34bd14c681 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("3whHg", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $87bccf3deeafaa75$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $87bccf3deeafaa75$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $87bccf3deeafaa75$export$24c821207687a907);
const $87bccf3deeafaa75$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $87bccf3deeafaa75$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $87bccf3deeafaa75$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("hyCnL", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $4c0b86f075c0ff6b$export$90d94f20d157e756);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $3whHg = parcelRequire("3whHg");

var $3iUv8 = parcelRequire("3iUv8");

var $lLAXK = parcelRequire("lLAXK");
const $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $4c0b86f075c0ff6b$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $19ec31e354320eb2$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $lLAXK.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $3whHg.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $3iUv8.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("2jyqu", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $9253211b05747618$export$a1fb57756f0de62b);

var $gB4mS = parcelRequire("gB4mS");


const $9253211b05747618$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $gB4mS.default)((0, $aded369bac156944$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $6e65040b988c460f$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

const $aded369bac156944$export$8280e5c6104c5b40 = 'ui-modifications';


const $19ec31e354320eb2$export$415cc1afa6445f90 = 'onInitChangeId';
const $19ec31e354320eb2$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("3iUv8", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $547ed651019edc98$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $547ed651019edc98$export$caafa3945f199bc7);
const $547ed651019edc98$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $547ed651019edc98$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("lLAXK", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $5d47c6c300e4a9ca$export$a06103ec99e4e394);

var $fr1K2 = parcelRequire("fr1K2");


var $bCvSM = parcelRequire("bCvSM");

const $5d47c6c300e4a9ca$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $5d47c6c300e4a9ca$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $78805f0b93715186$export$f674b7a3bbd94b5)) return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $bCvSM.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $5d47c6c300e4a9ca$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $5d47c6c300e4a9ca$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $ca611ff348f89182$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $ca611ff348f89182$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $ca611ff348f89182$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $ca611ff348f89182$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $ca611ff348f89182$export$e4ac32edd5da2ee7 = 'FIELD';
const $ca611ff348f89182$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("bCvSM", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $b1dea33557091402$export$e1cc7da28a1c4bb7);
const $b1dea33557091402$var$SET_NAME_METHOD = 'setName';
const $b1dea33557091402$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $b1dea33557091402$var$SET_VISIBLE_METHOD = 'setVisible';
const $b1dea33557091402$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $b1dea33557091402$var$SET_VALUE_METHOD = 'setValue';
const $b1dea33557091402$var$SET_REQUIRED_METHOD = 'setRequired';
const $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $b1dea33557091402$export$8325709d137b2606 = {
    fieldName: $b1dea33557091402$var$SET_NAME_METHOD,
    description: $b1dea33557091402$var$SET_DESCRIPTION_METHOD,
    isVisible: $b1dea33557091402$var$SET_VISIBLE_METHOD,
    isReadOnly: $b1dea33557091402$var$SET_READ_ONLY_METHOD,
    value: $b1dea33557091402$var$SET_VALUE_METHOD,
    isRequired: $b1dea33557091402$var$SET_REQUIRED_METHOD,
    optionsVisibility: $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $b1dea33557091402$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $b1dea33557091402$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $78805f0b93715186$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $78805f0b93715186$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("boEP0", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$7d0f534e5b16dcc9);


var $3vp6H = parcelRequire("3vp6H");
const $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $f5288ff27f25fb7e$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $78805f0b93715186$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $f5288ff27f25fb7e$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $3vp6H.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("3vp6H", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $23bcfa1804fc8fad$export$8a23b3e9a1749620);

const $23bcfa1804fc8fad$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $78805f0b93715186$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $23bcfa1804fc8fad$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $23bcfa1804fc8fad$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("2NMWZ", function(module, exports) {

$parcel$export(module.exports, "setError", () => $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $13e2b126ca97f7fe$export$7e5930c6217b1d4e);
const $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $13e2b126ca97f7fe$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("d30F5", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $e08f4de833312075$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $e08f4de833312075$export$cf768a695e83eefa);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");

var $1FDIy = parcelRequire("1FDIy");

var $2NMWZ = parcelRequire("2NMWZ");
const $e08f4de833312075$var$getTimeout = ()=>50000;
const $e08f4de833312075$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $e08f4de833312075$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $e08f4de833312075$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($e08f4de833312075$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $e08f4de833312075$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $e08f4de833312075$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status) || (0, $1FDIy.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $2NMWZ.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $e08f4de833312075$var$getTimeout(),
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $e08f4de833312075$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("1FDIy", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $9ea7c26aba3c4975$export$4cadeedb8c3f31f7);

var $6dDSs = parcelRequire("6dDSs");
const $9ea7c26aba3c4975$export$4cadeedb8c3f31f7 = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("8e24q", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $c1b779e01c06a231$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $c1b779e01c06a231$export$4a6b4707110b0552);

var $iLSUx = parcelRequire("iLSUx");
const $c1b779e01c06a231$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $c1b779e01c06a231$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("iLSUx", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $4854c3676fce92c1$export$50806045b617d116);

var $gKZoD = parcelRequire("gKZoD");

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $4854c3676fce92c1$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gKZoD.di)((0, $cmmj3.fireErrorAnalytics), (0, $gL80q.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $cmmj3.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("cmmj3", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $1359a69054531aa4$export$a27c21aa3ed8f0f1);

var $1nF7O = parcelRequire("1nF7O");

var $z11xo = parcelRequire("z11xo");
const $1359a69054531aa4$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $1359a69054531aa4$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $z11xo.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $1nF7O.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $1359a69054531aa4$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("z11xo", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $df5192e881ed2750$export$e19f9f08a6d79fd2);

var $3HlI9 = parcelRequire("3HlI9");
const $df5192e881ed2750$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $df5192e881ed2750$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $df5192e881ed2750$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $df5192e881ed2750$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $df5192e881ed2750$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $df5192e881ed2750$export$89a175d4190df42e = 'Invoke value functions failed:';
const $df5192e881ed2750$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $df5192e881ed2750$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $df5192e881ed2750$var$BAD_REQUEST = 400;
const $df5192e881ed2750$var$REQUEST_TIMEOUT = 408;
const $df5192e881ed2750$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $df5192e881ed2750$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $df5192e881ed2750$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($df5192e881ed2750$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $df5192e881ed2750$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($df5192e881ed2750$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($df5192e881ed2750$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($df5192e881ed2750$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $3HlI9.isClientFetchError)(error)) return $df5192e881ed2750$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("3HlI9", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cbf82ad04131c769$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cbf82ad04131c769$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cbf82ad04131c769$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cbf82ad04131c769$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cbf82ad04131c769$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cbf82ad04131c769$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.cause.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("gL80q", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $968cd36658e5c86e$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $968cd36658e5c86e$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $968cd36658e5c86e$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $968cd36658e5c86e$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $968cd36658e5c86e$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $968cd36658e5c86e$export$ef45e4471aa21b27);

var $cmmj3 = parcelRequire("cmmj3");

var $3OTqu = parcelRequire("3OTqu");
const $968cd36658e5c86e$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $968cd36658e5c86e$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $3OTqu.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $968cd36658e5c86e$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$968cd36658e5c86e$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $968cd36658e5c86e$export$e4330d77fd93d1de = (viewType)=>$968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $968cd36658e5c86e$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $968cd36658e5c86e$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $968cd36658e5c86e$export$20eabd2b3ada6bf3(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $968cd36658e5c86e$export$b768d6a95f7a930(context) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $968cd36658e5c86e$export$b0297573c90085aa(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $968cd36658e5c86e$export$c0728caa743a409e(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $968cd36658e5c86e$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $968cd36658e5c86e$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("3OTqu", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $b8beb3418915829f$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $b8beb3418915829f$export$f0022a21ccd1f6be);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
const $b8beb3418915829f$var$VIEW_CONFIGURATIONS = new Map();
const $b8beb3418915829f$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$b8beb3418915829f$var$VIEW_CONFIGURATIONS.has(viewType)) $b8beb3418915829f$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $b8beb3418915829f$export$176b6e68da08ffa2 = (viewType)=>$b8beb3418915829f$var$VIEW_CONFIGURATIONS.get(viewType);
const $b8beb3418915829f$export$e8091eff40c4f16e = ()=>{
    $b8beb3418915829f$var$VIEW_CONFIGURATIONS.clear();
};
const $b8beb3418915829f$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gKZoD.di)($b8beb3418915829f$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $5uXOq.useState)(()=>{
        $b8beb3418915829f$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("cTj8m", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $b87f070d69e40149$export$93459ad9bfd6c380);
const $b87f070d69e40149$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("i4uue", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $559bbe3e01414de7$export$7f7be235f64f029b);
const $559bbe3e01414de7$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("b8ZsE", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $926b03f8c2e312a1$export$352dfcce04d66748);

var $3ZT8o = parcelRequire("3ZT8o");

var $gKZoD = parcelRequire("gKZoD");

var $gL80q = parcelRequire("gL80q");

var $l6AQO = parcelRequire("l6AQO");
const $926b03f8c2e312a1$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("3ZT8o", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/** Used to generate unique IDs. */ var $2e91d6202798e8a1$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $2e91d6202798e8a1$var$uniqueId(prefix) {
    var id = ++$2e91d6202798e8a1$var$idCounter;
    return $jJVtR(prefix) + id;
}
module.exports = $2e91d6202798e8a1$var$uniqueId;

});

parcelRegister("l6AQO", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $2b658e9f553d1ad3$export$25441a03bb8f1cb0);

var $ajpes = parcelRequire("ajpes");

var $iLSUx = parcelRequire("iLSUx");
const $2b658e9f553d1ad3$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("jDMtG", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $5e78d8ed1ee13321$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $5e78d8ed1ee13321$export$1ca69a85bb7273de);

var $fr1K2 = parcelRequire("fr1K2");

var $kGsr8 = parcelRequire("kGsr8");
const $5e78d8ed1ee13321$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $5e78d8ed1ee13321$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("l0b2q", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $da1080104d423ca2$export$6556d46d2662453c);

var $l6AQO = parcelRequire("l6AQO");
const $da1080104d423ca2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("4MJXd", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $104b1b4dd763f6ee$export$21363496760d39cd);
const $104b1b4dd763f6ee$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("gHQFd", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $069ce0e12537855c$export$cceae62fd4d1ef0a);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $ajglJ = parcelRequire("ajglJ");

var $dA2NP = parcelRequire("dA2NP");

var $fKje4 = parcelRequire("fKje4");

var $dwG9p = parcelRequire("dwG9p");

var $dRfi6 = parcelRequire("dRfi6");

var $3whHg = parcelRequire("3whHg");

var $boEP0 = parcelRequire("boEP0");

var $hzAKL = parcelRequire("hzAKL");
const $069ce0e12537855c$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $boEP0.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $dA2NP.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $3whHg.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $80e7f3d73b333b84$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $80e7f3d73b333b84$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $80e7f3d73b333b84$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $hzAKL.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $dRfi6.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $fKje4.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, $ajglJ.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $dwG9p.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $boEP0.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $80e7f3d73b333b84$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $80e7f3d73b333b84$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $80e7f3d73b333b84$export$f5d5f6bb902f1027 = '-1';
const $80e7f3d73b333b84$export$106087dcfd4fb129 = 100;

parcelRegister("ajglJ", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $907938b0f57574ed$export$9e8b5e552e255163);

var $2jqAp = parcelRequire("2jqAp");
class $907938b0f57574ed$export$9e8b5e552e255163 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("2jqAp", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $b8ce6491bf34e535$export$6e8165c81a6a65df);
class $b8ce6491bf34e535$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("dA2NP", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b);
const $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("fKje4", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $620a721e65ec1dbe$export$460820f27643954e);

var $gL80q = parcelRequire("gL80q");
const $620a721e65ec1dbe$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("dwG9p", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $8d92968018d86237$export$e1fce51bc5be90b7);
const $8d92968018d86237$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("dRfi6", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $cc6b08557666e682$export$aa453854f74fab);

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $cc6b08557666e682$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("hzAKL", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $422557008e0dbc71$export$d14f85c01e334a1);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $7NDId = parcelRequire("7NDId");

var $gL80q = parcelRequire("gL80q");


var $bCvSM = parcelRequire("bCvSM");

var $2J6IF = parcelRequire("2J6IF");

var $hwDyF = parcelRequire("hwDyF");
const $422557008e0dbc71$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gKZoD.di)((0, $gL80q.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $2J6IF.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $2J6IF.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $7NDId.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $ca611ff348f89182$export$d1996cb46a690190),
                        method: (0, $bCvSM.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $hwDyF.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $hwDyF.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("7NDId", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $64626586c22c486e$export$73c2f0689b6c4a5a);
class $64626586c22c486e$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("2J6IF", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $5fbccb776f84792e$export$ee79e3ab53b8db79);
const $5fbccb776f84792e$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("hwDyF", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $e8aa8431ce8b786b$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $e8aa8431ce8b786b$export$ddd005554aecd409);
const $e8aa8431ce8b786b$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $e8aa8431ce8b786b$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("7JtDe", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $c6c7124cbfc0022b$export$131c67fd312b8a11);

var $gKZoD = parcelRequire("gKZoD");

var $iUvwD = parcelRequire("iUvwD");

var $50ech = parcelRequire("50ech");

var $boEP0 = parcelRequire("boEP0");

var $iiEdL = parcelRequire("iiEdL");
const $c6c7124cbfc0022b$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gKZoD.di)((0, $boEP0.collectScreenTabsAppliedChangesHistory), (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $iiEdL.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $iiEdL.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $boEP0.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $iUvwD.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $50ech.toScreenTabsValidationError))
        });
    };

});
parcelRegister("iUvwD", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $2febbf39fb2cebbc$export$faf1f1824ee0a136);

var $2jqAp = parcelRequire("2jqAp");
class $2febbf39fb2cebbc$export$faf1f1824ee0a136 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("50ech", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $32af3bb8fe161d39$export$b2675440ade984fb);

const $32af3bb8fe161d39$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $ca611ff348f89182$export$fd26696d109785a0)
    });

});

parcelRegister("iiEdL", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $5d43d6affeb19d8a$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $5d43d6affeb19d8a$export$62d63af83dac7315);
const $5d43d6affeb19d8a$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $5d43d6affeb19d8a$var$isValidScreenTabId = (internalScreenTabs, id)=>$5d43d6affeb19d8a$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $5d43d6affeb19d8a$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$5d43d6affeb19d8a$var$isValidScreenTabId(internalScreenTabs, id) && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && $5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive);
const $5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $5d43d6affeb19d8a$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$5d43d6affeb19d8a$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $5d43d6affeb19d8a$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("eNNkf", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $5092328ed6a09c60$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $5092328ed6a09c60$export$eefe4b2985e8203e);

var $5uXOq = parcelRequire("5uXOq");

var $hLEug = parcelRequire("hLEug");

var $12pgs = parcelRequire("12pgs");
const $5092328ed6a09c60$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const baseUrl = '';
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $hLEug.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $5uXOq.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, newValue);
    }, [
        baseUrl,
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $5uXOq.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
    }, [
        baseUrl,
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $5uXOq.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $5092328ed6a09c60$export$eefe4b2985e8203e = ()=>{
    const baseUrl = '';
    const [, actions] = (0, $hLEug.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $5uXOq.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions,
        baseUrl
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("hLEug", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $f08ba98a3f2bdde2$export$4d156074562bac9a);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $djdK3 = parcelRequire("djdK3");
const $f08ba98a3f2bdde2$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $djdK3.actions
});
const $f08ba98a3f2bdde2$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8 = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: $f08ba98a3f2bdde2$var$getUserPreference
});
const $f08ba98a3f2bdde2$export$4d156074562bac9a = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("djdK3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5c68f1b920b8984c$export$e324594224ef24da);
const $5c68f1b920b8984c$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $5c68f1b920b8984c$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $5c68f1b920b8984c$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $5c68f1b920b8984c$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $5c68f1b920b8984c$export$e324594224ef24da = {
    setUserPreferenceValue: $5c68f1b920b8984c$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $5c68f1b920b8984c$var$deleteUserPreferenceValue,
    setUserPreferences: $5c68f1b920b8984c$var$setUserPreferences,
    getUserPreferenceValue: $5c68f1b920b8984c$export$df0a4f67b9888111
};

});


parcelRegister("12pgs", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $0dfd1081a7a72732$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $0dfd1081a7a72732$export$a60a810760d07867);

var $eusud = parcelRequire("eusud");
const $0dfd1081a7a72732$export$bebe1b9e9f4cbf16 = async (baseUrl, userPreferenceKey, value)=>(0, $eusud.performPutRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    });
const $0dfd1081a7a72732$export$a60a810760d07867 = async (baseUrl, userPreferenceKey)=>(0, $eusud.performDeleteRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`);

});


const $31848aa9a0db89de$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $31848aa9a0db89de$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $31848aa9a0db89de$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $31848aa9a0db89de$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $31848aa9a0db89de$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $31848aa9a0db89de$export$2cf981c493d79a21 = 'jira.user.issue.details.activity-layout-setting';

parcelRegister("kI4MM", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $189406269e224200$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $189406269e224200$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $189406269e224200$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $189406269e224200$export$5513f3c310d101f5);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $kjjoM = parcelRequire("kjjoM");
const $189406269e224200$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || [];
const $189406269e224200$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $189406269e224200$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
const $189406269e224200$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $kjjoM
});
const $189406269e224200$export$5c4a1f63cea7b5b3 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContainers
});
const $189406269e224200$export$769bbe2bda9a43ce = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutGlance
});
const $189406269e224200$export$3aa9017e11451546 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContextPanel
});
const $189406269e224200$export$5513f3c310d101f5 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("kjjoM", function(module, exports) {

$parcel$export(module.exports, "setIssueViewContainersLayout", () => $09c52f32f4231bd8$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $09c52f32f4231bd8$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $09c52f32f4231bd8$export$9a04e4b958ebc410);
const $09c52f32f4231bd8$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $09c52f32f4231bd8$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $09c52f32f4231bd8$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("cNJ33", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $0c6b6ff40aad7732$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $0c6b6ff40aad7732$export$355607dae809ec65);

var $41gqO = parcelRequire("41gqO");
const $0c6b6ff40aad7732$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $41gqO.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $41gqO.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $41gqO.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $0c6b6ff40aad7732$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($0c6b6ff40aad7732$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $41gqO.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $0c6b6ff40aad7732$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("41gqO", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $b08b2795aecf222d$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $b08b2795aecf222d$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $b08b2795aecf222d$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $b08b2795aecf222d$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $b08b2795aecf222d$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $b08b2795aecf222d$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $b08b2795aecf222d$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $b08b2795aecf222d$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $b08b2795aecf222d$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $b08b2795aecf222d$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $b08b2795aecf222d$export$ad3536b13febb432);
const $b08b2795aecf222d$export$99ad62164189f781 = 'ecosystemGlance';
const $b08b2795aecf222d$export$7719ef6e9283671 = 'forgeGlance';
const $b08b2795aecf222d$export$bfebea5ce2e1887a = 'ecosystemContext';
const $b08b2795aecf222d$export$be8e68fb1aed253e = 'forgeContext';
const $b08b2795aecf222d$export$7bf561e6ab380ea1 = 'context';
const $b08b2795aecf222d$export$f42c11634d75863e = 'content';
const $b08b2795aecf222d$export$b38842736b6dbc1d = 'content-request';
const $b08b2795aecf222d$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_TYPE = 'FORGE';
const $b08b2795aecf222d$export$605c43f1b33ab69 = 'SUMMARY';
const $b08b2795aecf222d$export$e655b77b9efe622f = 'CustomItem';
const $b08b2795aecf222d$export$5cf403de05e9bea = 'FieldSectionItem';
const $b08b2795aecf222d$export$30f7f9a86f182492 = 'TabLayout';
const $b08b2795aecf222d$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $b08b2795aecf222d$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $b08b2795aecf222d$export$ad3536b13febb432 = (node)=>node.type === $b08b2795aecf222d$export$5507f31126c8b283.tab;

});



parcelRegister("hhMVP", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $cd61c7d28b4f2500$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $cd61c7d28b4f2500$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $cd61c7d28b4f2500$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
let $cd61c7d28b4f2500$var$previousRouteKey;
function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
    return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
}
function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
    $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
}
function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
        $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
        delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
    }
}

});


parcelRegister("gERis", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});



parcelRegister("5gJcp", function(module, exports) {

$parcel$export(module.exports, "defaultRatioRightColumn", () => $0350c967e71738f5$export$7fec582ac43ca9da);
$parcel$export(module.exports, "largeScreenRatioRightColumn", () => $0350c967e71738f5$export$28d7967aa38f2f87);
$parcel$export(module.exports, "activitySidePanelRatio", () => $0350c967e71738f5$export$6695481d80b63521);
$parcel$export(module.exports, "getIssueContainerDefaultMaxWidth", () => $0350c967e71738f5$export$7fe9ac2b6449f553);
$parcel$export(module.exports, "getIssueContainerIncreasedMaxWidth", () => $0350c967e71738f5$export$9d883719bd435511);
$parcel$export(module.exports, "ACTIVITY_SIDE_PANEL_MIN_WIDTH", () => $0350c967e71738f5$export$dd2feff7666e1f68);
const $0350c967e71738f5$export$7fec582ac43ca9da = 0.35;
const $0350c967e71738f5$export$28d7967aa38f2f87 = 0.4;
const $0350c967e71738f5$export$6695481d80b63521 = 0.4;
const $0350c967e71738f5$export$7fe9ac2b6449f553 = ()=>1680;
const $0350c967e71738f5$export$9d883719bd435511 = ()=>1920;
const $0350c967e71738f5$export$dd2feff7666e1f68 = 400;

});

parcelRegister("2su1H", function(module, exports) {

$parcel$export(module.exports, "useStartNinIssueAppAnalytics", () => $58a286de31151ea6$export$39482b240f0b451f);

var $5uXOq = parcelRequire("5uXOq");

var $dGrdR = parcelRequire("dGrdR");

var $1XJ20 = parcelRequire("1XJ20");

var $ih9zY = parcelRequire("ih9zY");
const $58a286de31151ea6$export$b9b395b52bdc3f4a = (0, $dGrdR.metrics).pageSegmentLoad({
    key: 'new-issue-navigator.issue-app'
});
const $58a286de31151ea6$export$39482b240f0b451f = (issueKey)=>{
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const previousIssueKey = (0, $1XJ20.usePrevious)(issueKey);
    // We explicitly start during render instead of an effect hook as onInteractive can be fired before the effect hook
    // has run for cached issues.
    if (issueKey !== previousIssueKey) $58a286de31151ea6$export$b9b395b52bdc3f4a.start();
    const onInteractive = (0, $5uXOq.useCallback)(()=>{
        $58a286de31151ea6$export$b9b395b52bdc3f4a.stop({
            customData: {
                view: view
            }
        });
    }, [
        view
    ]);
    return {
        onInteractive: onInteractive
    };
};

});

parcelRegister("cqgcE", function(module, exports) {

$parcel$export(module.exports, "useOnDeleteIssue", () => $4b147560fdf5ea67$export$45e2b3c3de4980ed);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");
const $4b147560fdf5ea67$var$getKeyForEdge = (edge)=>{
    const { NODE: NODE } = (0, $eiowN.ConnectionInterface).get();
    return edge?.getLinkedRecord(NODE)?.getValue('key');
};
const $4b147560fdf5ea67$var$getFirstEdgeCursor = (connectionRecord)=>{
    const { CURSOR: CURSOR, EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
    const cursor = edges[0]?.getValue(CURSOR);
    return cursor ? String(cursor) : null;
};
const $4b147560fdf5ea67$var$getLastEdgeCursor = (connectionRecord)=>{
    const { CURSOR: CURSOR, EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
    const cursor = edges[edges.length - 1]?.getValue(CURSOR);
    return cursor ? String(cursor) : null;
};
const $4b147560fdf5ea67$var$updatePageInfoCursor = (pageInfo, pageInfoField, replacementCursor, edgeToDelete)=>{
    if (!pageInfo || !replacementCursor) return;
    const { CURSOR: CURSOR } = (0, $eiowN.ConnectionInterface).get();
    const pageInfoCursor = pageInfo.getValue(pageInfoField);
    if (pageInfoCursor && pageInfoCursor === edgeToDelete.getValue(CURSOR)) pageInfo.setValue(replacementCursor, pageInfoField);
};
const $4b147560fdf5ea67$var$updatePageInfo = (connectionRecord, edgeToDelete)=>{
    const { START_CURSOR: START_CURSOR, END_CURSOR: END_CURSOR, PAGE_INFO: PAGE_INFO } = (0, $eiowN.ConnectionInterface).get();
    const pageInfo = connectionRecord.getLinkedRecord(PAGE_INFO);
    $4b147560fdf5ea67$var$updatePageInfoCursor(pageInfo, START_CURSOR, $4b147560fdf5ea67$var$getFirstEdgeCursor(connectionRecord), edgeToDelete);
    $4b147560fdf5ea67$var$updatePageInfoCursor(pageInfo, END_CURSOR, $4b147560fdf5ea67$var$getLastEdgeCursor(connectionRecord), edgeToDelete);
};
const $4b147560fdf5ea67$export$45e2b3c3de4980ed = (connectionId)=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)((issueKeyToDelete)=>{
        let previousIssueKey;
        let nextIssueKey;
        (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const connectionRecord = connectionId ? store.get(connectionId) : undefined;
            if (!connectionRecord) return;
            const { EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
            const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
            const index = edges.findIndex((edge)=>$4b147560fdf5ea67$var$getKeyForEdge(edge) === issueKeyToDelete);
            if (index > -1) {
                nextIssueKey = $4b147560fdf5ea67$var$getKeyForEdge(edges[index + 1]);
                previousIssueKey = $4b147560fdf5ea67$var$getKeyForEdge(edges[index - 1]);
                // Filter out deleted record from our connection
                connectionRecord.setLinkedRecords(edges.slice(0, index).concat(edges.slice(index + 1)), EDGES);
                // Update page start/end cursors if necessary following record delete
                $4b147560fdf5ea67$var$updatePageInfo(connectionRecord, edges[index]);
                // Decrement the total count
                const totalCount = connectionRecord.getValue('totalIssueSearchResultCount');
                if (typeof totalCount === 'number') connectionRecord.setValue(totalCount - 1, 'totalIssueSearchResultCount');
            }
        });
        // Return the next issue key to select. If there is no next issue key then return the previous key.
        return nextIssueKey ?? previousIssueKey ?? '';
    }, [
        environment,
        connectionId
    ]);
};

});

parcelRegister("9aomo", function(module, exports) {

$parcel$export(module.exports, "default", () => $341a198b9adf9a7a$export$2e2bcd8739ae039);

var $bG6g7 = parcelRequire("bG6g7");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Uumt = parcelRequire("8Uumt");

var $81Uw2 = parcelRequire("81Uw2");

var $6s1PB = parcelRequire("6s1PB");

var $1TiUe = parcelRequire("1TiUe");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $gtUFk = parcelRequire("gtUFk");

var $7OTah = parcelRequire("7OTah");

var $b9kNb = parcelRequire("b9kNb");
/**
 * Render extraHeaderActions if provided or otherwise return an empty render.
 */ const $341a198b9adf9a7a$var$HeaderActionsFallback = ({ extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, maxWidth: maxWidth })=>extraHeaderActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($341a198b9adf9a7a$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView,
        isVREnabled: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6')
    }, extraHeaderActions) : null;
/**
 * Render issue pagination controls and extraHeaderActions if provided.
 */ const $341a198b9adf9a7a$var$HeaderActions = (props)=>{
    const { extraHeaderActions: extraHeaderActions, issueResults: issueResults, maxWidth: maxWidth, isEmbedView: isEmbedView } = props;
    const issueResultsData = (0, $8Uumt.useFragment)((0, $bG6g7.default), issueResults);
    let issuesCount = 0;
    if ((0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) // eslint-disable-next-line react-hooks/rules-of-hooks
    issuesCount = (0, $7OTah.useIssuesCount)();
    let selectedIssuePosition;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const selectedIssueIndex = (0, $7OTah.useSelectedIssueIndex)(); // If selectedIssueIndex is negative then our selected issue key does not exist in the result set, so there
        // are no pagination controls to show.
        // If issueResultsData is null and issuesCount is not zero it means the grouping is enabled
        if (selectedIssueIndex === -1 || issueResultsData == null && issuesCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($341a198b9adf9a7a$var$HeaderActionsFallback, props);
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { getSelectedIssuePosition: getSelectedIssuePosition } = (0, $gtUFk.useSelectedIssueStateOldActions)();
        selectedIssuePosition = getSelectedIssuePosition(); // If selectedIssuePosition is not defined then our selected issue key does not exist in the result set, so there
        // are no pagination controls to show.
        if (selectedIssuePosition == null || issueResultsData == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($341a198b9adf9a7a$var$HeaderActionsFallback, props);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($341a198b9adf9a7a$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView,
        isVREnabled: (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6')
    }, extraHeaderActions ?? null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9kNb.default), {
        issueResults: issueResultsData,
        selectedIssuePosition: selectedIssuePosition
    }));
};
var $341a198b9adf9a7a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $81Uw2.withRecoverableErrorBoundary)($341a198b9adf9a7a$var$HeaderActions, {
    recoveryProp: 'issueResults',
    Fallback: $341a198b9adf9a7a$var$HeaderActionsFallback
});
const $341a198b9adf9a7a$var$HeaderActionsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmbedView: isEmbedView, maxWidth: maxWidth, isVREnabled: isVREnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _4cvr1h6o _1bahesu3 _1e0c1txw _1bsb1osq _vchhusvi _10nju2gc",
            __cmplp.isEmbedView && "_n3tdu2gc",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.isVREnabled ? "_7zw61ejb" : "_7zw6v47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bG6g7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfb9eb4249d2403$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0bc51f9494de5d6fa2940f677e3da0a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0dfb9eb4249d2403$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "headerActions_issueNavigator",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issuePagination_issueNavigator"
        }
    ],
    "type": "JiraIssueConnection"
};
$0dfb9eb4249d2403$var$node.hash = "701bdde8a1a96783e68d573053dd8362";
var $0dfb9eb4249d2403$export$2e2bcd8739ae039 = $0dfb9eb4249d2403$var$node;

});

parcelRegister("81Uw2", function(module, exports) {

$parcel$export(module.exports, "withRecoverableErrorBoundary", () => $8612eca041c6f5de$export$c25a1c850f00ce39);

var $5uXOq = parcelRequire("5uXOq");
function $8612eca041c6f5de$export$c25a1c850f00ce39(WrappedComponent, { recoveryProp: recoveryProp, Fallback: Fallback }) {
    class RecoverableErrorBoundary extends (0, $5uXOq.Component) {
        componentDidUpdate(prevProps) {
            if (this.state.errorProps && prevProps[recoveryProp] !== this.props[recoveryProp]) this.setState({
                errorProps: null
            });
        }
        componentDidCatch(error, errorInfo) {
            this.setState({
                errorProps: {
                    error: error,
                    errorInfo: errorInfo
                }
            });
        }
        render() {
            if (this.state.errorProps) return Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fallback, {
                ...this.props,
                ...this.state.errorProps
            }) : null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, this.props);
        }
        constructor(...args){
            super(...args), this.state = {
                errorProps: null
            };
        }
    }
    return RecoverableErrorBoundary;
}

});

parcelRegister("b9kNb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc85153e8f22912$export$2e2bcd8739ae039);

var $cwNnY = parcelRequire("cwNnY");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $ldJSL = parcelRequire("ldJSL");

var $6s1PB = parcelRequire("6s1PB");

var $1TiUe = parcelRequire("1TiUe");

var $79uRg = parcelRequire("79uRg");

var $7OTah = parcelRequire("7OTah");

var $hFOAl = parcelRequire("hFOAl");

var $68wbI = parcelRequire("68wbI");

var $9psUt = parcelRequire("9psUt");
const $3dc85153e8f22912$var$IssuePagination = ({ issueResults: issueResults, selectedIssuePosition: selectedIssuePosition })=>{
    let issuesCount = 0;
    if ((0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) // eslint-disable-next-line react-hooks/rules-of-hooks
    issuesCount = (0, $7OTah.useIssuesCount)();
    const issueResultsData = (0, $8Uumt.useFragment)((0, $cwNnY.default), issueResults);
    const isCappingIssueSearchResult = issueResultsData?.isCappingIssueSearchResult ?? false;
    const totalIssueSearchResultCount = issueResultsData?.totalIssueSearchResultCount || issuesCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) && /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3dc85153e8f22912$var$PaginationTextContainer, {
        "data-testid": "issue-pagination.pagination-text"
    }, totalIssueSearchResultCount <= 0 ? selectedIssuePosition : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79uRg.default), {
        prependMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hFOAl.default).issueIndexTotalKnownIssueTermRefresh : (0, $hFOAl.default).issueIndexTotalKnown,
        prependMessageValues: {
            issueIndex: selectedIssuePosition
        },
        isCapped: isCappingIssueSearchResult,
        stableCount: totalIssueSearchResultCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9psUt.default), {
        selectedIssuePosition: selectedIssuePosition
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $68wbI.default), {
        totalResultCount: totalIssueSearchResultCount,
        selectedIssuePosition: selectedIssuePosition,
        isCappingIssueSearchResult: isCappingIssueSearchResult
    })));
};
var $3dc85153e8f22912$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3dc85153e8f22912$var$IssuePagination;
const $3dc85153e8f22912$var$PaginationTextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cwNnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7240c8715a77c997$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cdeacb15335634351a83b6eeb614c997>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7240c8715a77c997$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issuePagination_issueNavigator",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            "action": "THROW",
            "path": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$7240c8715a77c997$var$node.hash = "252cad0134e2ce14b78595c597895b8f";
var $7240c8715a77c997$export$2e2bcd8739ae039 = $7240c8715a77c997$var$node;

});

parcelRegister("79uRg", function(module, exports) {

$parcel$export(module.exports, "default", () => $da78c4decc98820b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $cR57N = parcelRequire("cR57N");
/**
 * Display the total number of issues from a search with the ability to toggle from stable to unstable values.
 *
 * Stable vs Unstable
 *  - the **stable count** is returned from the issueSearchStable query. It will be capped at 1000 if
 *    there are more than 1000 results. This is the default count that is displayed
 *
 *  - the **unstable count** is returned from the totalIssueCountQuery query. It is the true number of results
 *    for a search and does not have a cap. This value must be requested by the user via button click.
 */ const $da78c4decc98820b$var$TotalIssueCountWrapper = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "TotalIssueCount",
        packageName: "jiraIssueNavigator",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage(props.prependMessage, {
                ...props.prependMessageValues,
                totalNumberIssues: props.isCapped ? `${props.stableCount}+` : props.stableCount
            })),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cR57N.default), props));
};
var $da78c4decc98820b$export$2e2bcd8739ae039 = $da78c4decc98820b$var$TotalIssueCountWrapper;

});
parcelRegister("cR57N", function(module, exports) {

$parcel$export(module.exports, "default", () => $12abfe1ef23c73a0$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dD7Zc = parcelRequire("dD7Zc");

var $dC5iT = parcelRequire("dC5iT");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $isIOR = parcelRequire("isIOR");

var $38r5c = parcelRequire("38r5c");

var $c3DxU = parcelRequire("c3DxU");

var $dZ9aY = parcelRequire("dZ9aY");
const $12abfe1ef23c73a0$var$TotalIssueCount = ({ prependMessage: prependMessage, prependMessageValues: prependMessageValues, isCapped: isCapped, stableCount: stableCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let totalIssueCount;
    let totalIssueCountIsFetching;
    let totalIssueCountIsError;
    let onFetchTotalIssueCount;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        totalIssueCount = (0, $38r5c.useTotalIssueCount)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        totalIssueCountIsFetching = (0, $38r5c.useTotalIssueCountIsFetching)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        totalIssueCountIsError = (0, $38r5c.useTotalIssueCountIsError)(); // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ onFetchTotalIssueCount: onFetchTotalIssueCount } = (0, $38r5c.useIssueSearchActions)());
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { uncappedTotalIssueCount: uncappedTotalIssueCount, onFetchUncappedTotalIssueCount: onFetchUncappedTotalIssueCount } = (0, $isIOR.useIssueSearchQuery)();
        totalIssueCount = uncappedTotalIssueCount.count;
        totalIssueCountIsFetching = uncappedTotalIssueCount.isFetching;
        totalIssueCountIsError = uncappedTotalIssueCount.isError;
        onFetchTotalIssueCount = onFetchUncappedTotalIssueCount;
    }
    if (isCapped) {
        if (totalIssueCountIsError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: `${stableCount}+`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            position: "top",
            content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dZ9aY.default).errorTooltipTextIssueTermRefresh : (0, $dZ9aY.default).errorTooltipText)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12abfe1ef23c73a0$var$ErrorIconContainer, {
                ...tooltipProps,
                "data-testid": "issue-navigator.common.ui.total-issue-count.error-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                spacing: "spacious",
                label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dZ9aY.default).errorIconLabelIssueTermRefresh : (0, $dZ9aY.default).errorIconLabel)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
            action: "viewed",
            actionSubject: "errorIcon",
            actionSubjectId: "totalIssueCount"
        }));
        if (totalIssueCountIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: ''
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12abfe1ef23c73a0$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small",
            testId: "issue-navigator.common.ui.total-issue-count.spinner"
        })));
        if (!totalIssueCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c3DxU.default), {
                displayText: `${stableCount}+`,
                onFetchCount: onFetchTotalIssueCount
            })
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: totalIssueCount
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span"
    }, formatMessage(prependMessage, {
        ...prependMessageValues,
        totalNumberIssues: stableCount
    }));
};
var $12abfe1ef23c73a0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($12abfe1ef23c73a0$var$TotalIssueCount);
const $12abfe1ef23c73a0$var$ErrorIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _4t3i1tcg _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $12abfe1ef23c73a0$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _otyr1l7b _18u01y44",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c3DxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $760aa3895a440d03$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $dZ9aY = parcelRequire("dZ9aY");
const $760aa3895a440d03$var$LoadUncappedCountButton = ({ onFetchCount: onFetchCount, displayText: displayText })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fetchCount = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onFetchCount();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'totalIssueCountButton');
    }, [
        onFetchCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dZ9aY.default).cappedCountTooltipIssueTermRefresh : (0, $dZ9aY.default).cappedCountTooltip),
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        tabIndex: 0,
        appearance: "link",
        spacing: "none",
        onClick: fetchCount,
        "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dZ9aY.default).cappedCountTooltipIssueTermRefresh : (0, $dZ9aY.default).cappedCountTooltip),
        testId: "issue-navigator.common.ui.total-issue-count.load-uncapped-count-button.button"
    }, displayText));
};
var $760aa3895a440d03$export$2e2bcd8739ae039 = $760aa3895a440d03$var$LoadUncappedCountButton;

});
parcelRegister("dZ9aY", function(module, exports) {

$parcel$export(module.exports, "default", () => $765e50af4a6c461b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $765e50af4a6c461b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTooltipText: {
        "id": "issue-navigator.common.total-issue-count.error-tooltip-text",
        "defaultMessage": "We couldn\u2019t load the total number of issues. Refresh to try again."
    },
    errorIconLabel: {
        "id": "issue-navigator.common.total-issue-count.error-icon-label",
        "defaultMessage": "Error loading total issue count"
    },
    cappedCountTooltip: {
        "id": "issue-navigator.common.total-issue-count.capped-count-tooltip",
        "defaultMessage": "See the total number of issues."
    },
    errorTooltipTextIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.error-tooltip-text-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t load the total number of work items. Refresh to try again."
    },
    errorIconLabelIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.error-icon-label-issue-term-refresh",
        "defaultMessage": "Error loading total work item count"
    },
    cappedCountTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.capped-count-tooltip-issue-term-refresh",
        "defaultMessage": "See the total number of work items."
    }
});

});




parcelRegister("hFOAl", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dfb5e4bfcb2ceca$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $2dfb5e4bfcb2ceca$var$messages = (0, $7VHMR.defineMessages)({
    issueIndexTotalKnown: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.issue-index-total-known",
        "defaultMessage": "{issueIndex} of {totalNumberIssues}"
    },
    issueIndexTotalKnownIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.issue-index-total-known-issue-term-refresh",
        "defaultMessage": "{issueIndex} of {totalNumberIssues}"
    }
});
var $2dfb5e4bfcb2ceca$export$2e2bcd8739ae039 = $2dfb5e4bfcb2ceca$var$messages;

});

parcelRegister("68wbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b717c6c97877d28$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $c8Oei = parcelRequire("c8Oei");

var $3bDjY = parcelRequire("3bDjY");

var $jQtKF = parcelRequire("jQtKF");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $gtUFk = parcelRequire("gtUFk");

var $7OTah = parcelRequire("7OTah");

var $2siHS = parcelRequire("2siHS");
const $5b717c6c97877d28$var$TooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b717c6c97877d28$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $5b717c6c97877d28$var$IssuePaginationNextButton = ({ selectedIssuePosition: selectedIssuePosition, totalResultCount: totalResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let selectNextIssue;
    let issueKey;
    let isDisabled;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const actions = (0, $7OTah.useSelectedIssueActions)();
        selectNextIssue = actions.selectNextIssue; // eslint-disable-next-line react-hooks/rules-of-hooks
        issueKey = (0, $7OTah.useNextIssueKey)();
        isDisabled = !issueKey;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const actions = (0, $gtUFk.useSelectedIssueStateOldActions)();
        selectNextIssue = actions.selectNextIssue;
        issueKey = actions.getNextIssue().issueKey;
        isDisabled = selectedIssuePosition === totalResultCount;
    }
    const nextIssueMessage = issueKey ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2siHS.default).nextIssueTooltipIssueTermRefresh : (0, $2siHS.default).nextIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2siHS.default).nextIssueWithoutKeyTooltipIssueTermRefresh : (0, $2siHS.default).nextIssueWithoutKeyTooltip);
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        if (selectNextIssue()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'nextIssue');
    }, [
        selectNextIssue
    ]);
    if (isDisabled && isCappingIssueSearchResult) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2siHS.default).disabledButtonTooltipIssueTermRefresh : (0, $2siHS.default).disabledButtonTooltip),
        tag: $5b717c6c97877d28$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jQtKF.default), {
        tabIndex: 0,
        isDisabled: true,
        "data-testid": "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button.next-disabled-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))),
        label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2siHS.default).disabledButtonTooltipIssueTermRefresh : (0, $2siHS.default).disabledButtonTooltip),
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))),
        label: isDisabled ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2siHS.default).disabledButtonLabelIssueTermRefresh : (0, $2siHS.default).disabledButtonLabel, {
            issueCount: totalResultCount
        }) : nextIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
};
var $5b717c6c97877d28$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5b717c6c97877d28$var$IssuePaginationNextButton;
const $5b717c6c97877d28$var$StyledTooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jQtKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dbfcf6b8255255f$export$2e2bcd8739ae039);

var $47bDC = parcelRequire("47bDC");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dbfcf6b8255255f$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $47bDC.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$4dbfcf6b8255255f$export$2e2bcd8739ae039 = $4dbfcf6b8255255f$var$DisabledButtonWithTooltip;

});

parcelRegister("2siHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5ef87bb8421fa8e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b5ef87bb8421fa8e$var$messages = (0, $7VHMR.defineMessages)({
    nextIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-tooltip",
        "defaultMessage": "Next issue ''{issueKey}'' (Type 'j')"
    },
    nextIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-without-key-tooltip",
        "defaultMessage": "Next issue (Type 'j')"
    },
    disabledButtonTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-label",
        "defaultMessage": "{issueCount} of {issueCount} issues, select previous issues to go back"
    },
    disabledButtonLabelIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-label-issue-term-refresh",
        "defaultMessage": "{issueCount} of {issueCount} work items, select previous work items to go back"
    },
    nextIssueTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-tooltip-issue-term-refresh",
        "defaultMessage": "Next work item ''{issueKey}'' (Type 'j')"
    },
    nextIssueWithoutKeyTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-without-key-tooltip-issue-term-refresh",
        "defaultMessage": "Next work item (Type 'j')"
    },
    disabledButtonTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-tooltip-issue-term-refresh",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more work items."
    }
});
var $b5ef87bb8421fa8e$export$2e2bcd8739ae039 = $b5ef87bb8421fa8e$var$messages;

});


parcelRegister("9psUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca6a8c917bf734bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $cEqbp = parcelRequire("cEqbp");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $gtUFk = parcelRequire("gtUFk");

var $7OTah = parcelRequire("7OTah");

var $iLFTD = parcelRequire("iLFTD");
const $ca6a8c917bf734bd$var$IssuePaginationPreviousButton = ({ selectedIssuePosition: selectedIssuePosition })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let selectPreviousIssue;
    let issueKey;
    let isDisabled;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const actions = (0, $7OTah.useSelectedIssueActions)();
        selectPreviousIssue = actions.selectPreviousIssue;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        issueKey = (0, $7OTah.usePreviousIssueKey)();
        isDisabled = !issueKey;
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const actions = (0, $gtUFk.useSelectedIssueStateOldActions)();
        selectPreviousIssue = actions.selectPreviousIssue;
        issueKey = actions.getPreviousIssue().issueKey;
        isDisabled = selectedIssuePosition === 1;
    }
    const previousIssueMessage = issueKey ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iLFTD.default).previousIssueTooltipIssueTermRefresh : (0, $iLFTD.default).previousIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iLFTD.default).previousIssueWithoutKeyTooltipIssueTermRefresh : (0, $iLFTD.default).previousIssueWithoutKeyTooltip);
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        if (selectPreviousIssue()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'previousIssue');
    }, [
        selectPreviousIssue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cEqbp))),
        label: isDisabled ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iLFTD.default).disabledButtonLabelIssueTermRefresh : (0, $iLFTD.default).disabledButtonLabel) : previousIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.previous-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
};
var $ca6a8c917bf734bd$export$2e2bcd8739ae039 = $ca6a8c917bf734bd$var$IssuePaginationPreviousButton;

});
parcelRegister("cEqbp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e58b02424147679c6e4b17a279d99cac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $935d87e1572638ec$var$_react = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $935d87e1572638ec$var$_chevronUp = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("jj3Gi")));

var $935d87e1572638ec$var$_chevronUp2 = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("6Pmud")));
function $935d87e1572638ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "ChevronUpIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $935d87e1572638ec$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $935d87e1572638ec$var$_react.default.createElement($935d87e1572638ec$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $935d87e1572638ec$var$_chevronUp2.default
    }, props));
$935d87e1572638ec$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $935d87e1572638ec$var$_default = module.exports.default = $935d87e1572638ec$var$ChevronUpIcon;

});
parcelRegister("6Pmud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f88f2d3e506ed12$var$_react = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4f88f2d3e506ed12$var$_chevronUp = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("jj3Gi")));
function $4f88f2d3e506ed12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f88f2d3e506ed12$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $4f88f2d3e506ed12$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $4f88f2d3e506ed12$var$_chevronUp.default,
        iconType: "utility"
    }));
$4f88f2d3e506ed12$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $4f88f2d3e506ed12$var$_default = module.exports.default = $4f88f2d3e506ed12$var$ChevronUpIcon;

});


parcelRegister("iLFTD", function(module, exports) {

$parcel$export(module.exports, "default", () => $41497c8b4d0b6d68$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $41497c8b4d0b6d68$var$messages = (0, $7VHMR.defineMessages)({
    previousIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip",
        "defaultMessage": "Previous issue ''{issueKey}'' (Type 'k')"
    },
    previousIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip",
        "defaultMessage": "Previous issue (Type 'k')"
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label",
        "defaultMessage": "No previous issue, select next issue"
    },
    disabledButtonLabelIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label-issue-term-refresh",
        "defaultMessage": "No previous work item, select next work item"
    },
    previousIssueTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip-issue-term-refresh",
        "defaultMessage": "Previous work item ''{issueKey}'' (Type 'k')"
    },
    previousIssueWithoutKeyTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip-issue-term-refresh",
        "defaultMessage": "Previous work item (Type 'k')"
    }
});
var $41497c8b4d0b6d68$export$2e2bcd8739ae039 = $41497c8b4d0b6d68$var$messages;

});




parcelRegister("ltUBN", function(module, exports) {

$parcel$export(module.exports, "useScrollToActivityFeed", () => $7bc9ecf5cf789e11$export$5322fd37f123913);

var $5uXOq = parcelRequire("5uXOq");

var $92wsG = parcelRequire("92wsG");

var $ieDtd = parcelRequire("ieDtd");
const $7bc9ecf5cf789e11$var$INTERVAL = 100;
const $7bc9ecf5cf789e11$var$TIMEOUT = 10000;
const $7bc9ecf5cf789e11$export$f0c653cfd7dea798 = ()=>{
    return globalThis.document.getElementById((0, $92wsG.ELID_ISSUE_ACTIVITY_FEED));
};
const $7bc9ecf5cf789e11$export$5322fd37f123913 = (issueKey)=>{
    const viewActivity = (0, $ieDtd.useQueryParam)('viewActivity')[0] === 'true';
    const intervalId = (0, $5uXOq.useRef)();
    const timeoutId = (0, $5uXOq.useRef)();
    const isTimeout = (0, $5uXOq.useRef)(false);
    const waitForElement = (0, $5uXOq.useCallback)(()=>{
        if (isTimeout.current) return;
        const ref = $7bc9ecf5cf789e11$export$f0c653cfd7dea798();
        if (ref) // sometimes the browser can't immediately scroll,
        // so we add a small timeout here to let it render Bento first
        setTimeout(()=>{
            ref.scrollIntoView({
                block: 'start',
                inline: 'nearest'
            });
        }, 300);
        else intervalId.current = setTimeout(waitForElement, $7bc9ecf5cf789e11$var$INTERVAL);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!viewActivity) return;
        clearTimeout(intervalId.current);
        clearTimeout(timeoutId.current);
        isTimeout.current = false;
        // clear the interval in case comments section never shows up
        timeoutId.current = setTimeout(()=>{
            isTimeout.current = true;
        }, $7bc9ecf5cf789e11$var$TIMEOUT);
        // kick off the interval if issueKey changes + on mount
        intervalId.current = setTimeout(waitForElement, $7bc9ecf5cf789e11$var$INTERVAL);
        // clear interval on unmount
        return ()=>{
            clearTimeout(intervalId.current);
            clearTimeout(timeoutId.current);
        };
    }, [
        waitForElement,
        issueKey,
        viewActivity
    ]);
};

});
parcelRegister("92wsG", function(module, exports) {

$parcel$export(module.exports, "issueAppModalWrapperClassName", () => $fcc2b749aa610036$export$6bf7918be801e6c5);
$parcel$export(module.exports, "MODAL_DROPDOWN_PORTAL_CLASS_NAME", () => $fcc2b749aa610036$export$bab98b619b4558be);
$parcel$export(module.exports, "EDITOR_DROPDOWN_PORTAL_CLASS_NAME", () => $fcc2b749aa610036$export$2ec9dc4e52ec0b5d);
$parcel$export(module.exports, "EDITOR_END_CLASS_NAME", () => $fcc2b749aa610036$export$18cffbebfac64f6d);
$parcel$export(module.exports, "EDITOR_START_CLASS_NAME", () => $fcc2b749aa610036$export$ebb284f63692b8b2);
$parcel$export(module.exports, "ISSUE_DESCRIPTION_EDITOR_ID", () => $fcc2b749aa610036$export$b8a46c806f8a6ef3);
$parcel$export(module.exports, "GIC_ISSUE_DESCRIPTION_EDITOR_ID", () => $fcc2b749aa610036$export$96cae1d6f7d37701);
$parcel$export(module.exports, "ELID_ISSUE_HEADER", () => $fcc2b749aa610036$export$4ca9dd62cc85a6c6);
$parcel$export(module.exports, "ELID_ISSUE_HEADER_ACTIONS", () => $fcc2b749aa610036$export$23d48b936935fa57);
$parcel$export(module.exports, "ELID_ISSUE_ACTIVITY_FEED", () => $fcc2b749aa610036$export$f1f90756574f5f9b);
$parcel$export(module.exports, "AGG_ISSUE_ERROR_ANALYTICS", () => $fcc2b749aa610036$export$66553a9be1be2f7e);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_ADD_BUTTON_REF_KEY", () => $fcc2b749aa610036$export$899103370186f1a1);
$parcel$export(module.exports, "DESIGN_PANEL_HEADING_ADD_DESIGN_REF_KEY", () => $fcc2b749aa610036$export$736b3d7f44d56d71);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $fmm8O = parcelRequire("fmm8O");












var $79RqQ = parcelRequire("79RqQ");

const $fcc2b749aa610036$export$6bf7918be801e6c5 = '_issue-app-modal-dialog-wrapper';
const $fcc2b749aa610036$export$bab98b619b4558be = 'issue-app-modal-ak-dropdown-portal';
const $fcc2b749aa610036$export$2ec9dc4e52ec0b5d = 'issue-app-modal-editor-dropdown-portal';
const $fcc2b749aa610036$export$18cffbebfac64f6d = 'issue-editor-end';
const $fcc2b749aa610036$export$ebb284f63692b8b2 = 'issue-editor-start';
const $fcc2b749aa610036$export$b8a46c806f8a6ef3 = 'issue-description-editor';
const $fcc2b749aa610036$export$96cae1d6f7d37701 = 'issue-create.common.ui.fields.description-field.wrapper';
const $fcc2b749aa610036$export$3ef7e400a3598524 = 'issue.error';
const $fcc2b749aa610036$export$4ca9dd62cc85a6c6 = 'jira-issue-header';
const $fcc2b749aa610036$export$23d48b936935fa57 = 'jira-issue-header-actions';
const $fcc2b749aa610036$export$f1f90756574f5f9b = 'jira-issue-activity-feed';
const $fcc2b749aa610036$export$66553a9be1be2f7e = 'issue.error.agg';
const $fcc2b749aa610036$export$899103370186f1a1 = 'quick-add-items.add-button';
const $fcc2b749aa610036$export$736b3d7f44d56d71 = 'design-panel.heading.add-design';

});
parcelRegister("fmm8O", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_WATCHING_ERROR", () => $99d43d51c2dfe210$export$ec8031e221d27341);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_GENERIC", () => $99d43d51c2dfe210$export$78f84210a13989cb);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_INVALID", () => $99d43d51c2dfe210$export$10b0b01977598ffc);
$parcel$export(module.exports, "COMMENT_ACTION_ERROR_INVALID_PERMISSION", () => $99d43d51c2dfe210$export$8443c3b41d7f09d8);
$parcel$export(module.exports, "COMMENT_CONTENT_EXCEEDED_ERROR", () => $99d43d51c2dfe210$export$9b38ca770beaf3d0);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS_FLAG_MESSAGE", () => $99d43d51c2dfe210$export$eef81693e817e3a6);
$parcel$export(module.exports, "COMMENT_FUTURE_TIME_ERROR", () => $99d43d51c2dfe210$export$a0d4d86bde270ad6);
$parcel$export(module.exports, "COMMENT_DELETE_ERROR", () => $99d43d51c2dfe210$export$6b6cd1b99772a4a1);
$parcel$export(module.exports, "EDITOR_ERROR", () => $99d43d51c2dfe210$export$2e48be8618f1b4f8);
$parcel$export(module.exports, "ATTACHMENT_ADD_ERROR", () => $99d43d51c2dfe210$export$c060b7873ebc2eb3);
$parcel$export(module.exports, "ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR", () => $99d43d51c2dfe210$export$1f8e6f6f8d64a715);
$parcel$export(module.exports, "ATTACHMENT_ADD_SUCCESS", () => $99d43d51c2dfe210$export$1f92a25b34c4df93);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_ERROR", () => $99d43d51c2dfe210$export$d8750340852b965e);
$parcel$export(module.exports, "REMOTE_LINK_VALIDATION_ERROR", () => $99d43d51c2dfe210$export$f0962d071c2a358a);
$parcel$export(module.exports, "ATTACHMENT_DELETE_ERROR", () => $99d43d51c2dfe210$export$ef7767ceecf9097c);
$parcel$export(module.exports, "WATCH_TOGGLE_UPDATE_ERROR", () => $99d43d51c2dfe210$export$516af79f4e3b8794);
$parcel$export(module.exports, "FETCH_WATCHERS_ERROR", () => $99d43d51c2dfe210$export$cde4105f7711a10a);
$parcel$export(module.exports, "STOP_WATCHING_SUCCESS", () => $99d43d51c2dfe210$export$f674d1f44f57f99d);
$parcel$export(module.exports, "START_WATCHING_SUCCESS", () => $99d43d51c2dfe210$export$bff6b5ab70bcec53);
$parcel$export(module.exports, "REMOVE_WATCHER_ERROR", () => $99d43d51c2dfe210$export$37934e343a22c4e6);
$parcel$export(module.exports, "ADD_WATCHER_ERROR", () => $99d43d51c2dfe210$export$6a1827094c1ef6d8);
$parcel$export(module.exports, "SUBTASKS_REORDER_ERROR_GENERIC", () => $99d43d51c2dfe210$export$bb96d519395e5dcc);
$parcel$export(module.exports, "LOG_WORK_CONFIRM_ERROR", () => $99d43d51c2dfe210$export$18bd55ba676f8b6d);
$parcel$export(module.exports, "ASSIGN_TO_ME_SUCCESS", () => $99d43d51c2dfe210$export$1249a100986a9489);
$parcel$export(module.exports, "REMOVE_FROM_ME_SUCCESS", () => $99d43d51c2dfe210$export$6b737093486e5a4e);
$parcel$export(module.exports, "CREATE_CHILD_ISSUE_ERROR", () => $99d43d51c2dfe210$export$a2723f15441225d0);
$parcel$export(module.exports, "LINK_CHILD_ISSUE_ERROR", () => $99d43d51c2dfe210$export$569f7258d337be55);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_SUCCESS", () => $99d43d51c2dfe210$export$f92af4e9761d23b9);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_ERROR", () => $99d43d51c2dfe210$export$16dc9ff6a8822a90);
$parcel$export(module.exports, "DELETE_ISSUE_ERROR", () => $99d43d51c2dfe210$export$d4030883b7b7a04);
$parcel$export(module.exports, "ADD_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$2519b72aefd62ee3);
$parcel$export(module.exports, "ADD_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$190e4e4a6ee2a0a2);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$f1709ebef49207cc);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_FAILURE", () => $99d43d51c2dfe210$export$bde55584c7518e8d);
$parcel$export(module.exports, "EDIT_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$cf8d549e537c67d3);
$parcel$export(module.exports, "EDIT_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$2d33e591258e36a8);
$parcel$export(module.exports, "DELETE_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$b595535e9bb1a2a2);
$parcel$export(module.exports, "DELETE_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$c3739a68f63b7e09);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_CONFIRM_ERROR", () => $99d43d51c2dfe210$export$6ba6cb22d5a3c521);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR", () => $99d43d51c2dfe210$export$b1a41c9183097dc);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_REQUIRED_ERROR", () => $99d43d51c2dfe210$export$67544887e2b37fbc);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_FAILED", () => $99d43d51c2dfe210$export$67566c205c72838a);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_ERROR", () => $99d43d51c2dfe210$export$733fe45ab8c75209);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_SUCCESS", () => $99d43d51c2dfe210$export$9d1386a2d0651ca9);
$parcel$export(module.exports, "EDIT_EPIC_COLOUR_ERROR", () => $99d43d51c2dfe210$export$56094d7f6af14eac);
$parcel$export(module.exports, "EDIT_ISSUE_COLOUR_ERROR", () => $99d43d51c2dfe210$export$92d58445895900f9);
$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_ERROR", () => $99d43d51c2dfe210$export$75d850be4d27b98e);
$parcel$export(module.exports, "CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$9030bf81702823b8);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$a2a71fb6b193e549);
$parcel$export(module.exports, "ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$8c5e4d3dfe9a1c32);
$parcel$export(module.exports, "ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$49d11338d75de478);
$parcel$export(module.exports, "ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$3573d8ff428b4c8f);
$parcel$export(module.exports, "COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST", () => $99d43d51c2dfe210$export$c0657c5ed1bbfed4);
const $99d43d51c2dfe210$export$ec8031e221d27341 = 'TOGGLE_WATCHING_ERROR';
const $99d43d51c2dfe210$export$78f84210a13989cb = 'COMMENT_ADD_ERROR_GENERIC';
const $99d43d51c2dfe210$export$10b0b01977598ffc = 'COMMENT_ADD_ERROR_INVALID';
const $99d43d51c2dfe210$export$8443c3b41d7f09d8 = 'COMMENT_ACTION_ERROR_INVALID_PERMISSION';
const $99d43d51c2dfe210$export$9b38ca770beaf3d0 = 'COMMENT_CONTENT_EXCEEDED_ERROR';
const $99d43d51c2dfe210$export$eef81693e817e3a6 = 'SAVE_COMMENT_SUCCESS_FLAG_MESSAGE';
const $99d43d51c2dfe210$export$a0d4d86bde270ad6 = 'COMMENT_FUTURE_TIME_ERROR';
const $99d43d51c2dfe210$export$6b6cd1b99772a4a1 = 'COMMENT_DELETE_ERROR';
const $99d43d51c2dfe210$export$2e48be8618f1b4f8 = 'EDITOR_ERROR';
const $99d43d51c2dfe210$export$c060b7873ebc2eb3 = 'ATTACHMENT_ADD_ERROR';
const $99d43d51c2dfe210$export$1f8e6f6f8d64a715 = 'ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR';
const $99d43d51c2dfe210$export$1f92a25b34c4df93 = 'ATTACHMENT_ADD_SUCCESS';
const $99d43d51c2dfe210$export$d8750340852b965e = 'DELETE_LINKED_ISSUE_ERROR';
const $99d43d51c2dfe210$export$f0962d071c2a358a = 'REMOTE_LINK_VALIDATION_ERROR';
const $99d43d51c2dfe210$export$ef7767ceecf9097c = 'ATTACHMENT_DELETE_ERROR';
const $99d43d51c2dfe210$export$516af79f4e3b8794 = 'WATCH_TOGGLE_UPDATE_ERROR';
const $99d43d51c2dfe210$export$cde4105f7711a10a = 'FETCH_WATCHERS_ERROR';
const $99d43d51c2dfe210$export$f674d1f44f57f99d = 'STOP_WATCHING_SUCCESS';
const $99d43d51c2dfe210$export$bff6b5ab70bcec53 = 'START_WATCHING_SUCCESS';
const $99d43d51c2dfe210$export$37934e343a22c4e6 = 'REMOVE_WATCHER_ERROR';
const $99d43d51c2dfe210$export$6a1827094c1ef6d8 = 'ADD_WATCHER_ERROR';
const $99d43d51c2dfe210$export$bb96d519395e5dcc = 'SUBTASKS_REORDER_ERROR_GENERIC';
const $99d43d51c2dfe210$export$18bd55ba676f8b6d = 'LOG_WORK_CONFIRM_ERROR';
const $99d43d51c2dfe210$export$1249a100986a9489 = 'ASSIGN_TO_ME_SUCCESS';
const $99d43d51c2dfe210$export$6b737093486e5a4e = 'REMOVE_FROM_ME_SUCCESS';
const $99d43d51c2dfe210$export$a2723f15441225d0 = 'CREATE_CHILD_ISSUE_ERROR';
const $99d43d51c2dfe210$export$569f7258d337be55 = 'LINK_CHILD_ISSUE_ERROR';
const $99d43d51c2dfe210$export$f92af4e9761d23b9 = 'CHANGE_ISSUE_TYPE_SUCCESS';
const $99d43d51c2dfe210$export$16dc9ff6a8822a90 = 'CHANGE_ISSUE_TYPE_ERROR';
const $99d43d51c2dfe210$export$d4030883b7b7a04 = 'DELETE_ISSUE_ERROR';
const $99d43d51c2dfe210$export$2519b72aefd62ee3 = 'ADD_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$190e4e4a6ee2a0a2 = 'ADD_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$f1709ebef49207cc = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$2357f9add92f1c9b = 'UPDATE_TIME_REMAINING_SUCCESS';
const $99d43d51c2dfe210$export$bde55584c7518e8d = 'UPDATE_TIME_REMAINING_FAILURE';
const $99d43d51c2dfe210$export$cf8d549e537c67d3 = 'EDIT_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$2d33e591258e36a8 = 'EDIT_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$b595535e9bb1a2a2 = 'DELETE_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$c3739a68f63b7e09 = 'DELETE_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$6ba6cb22d5a3c521 = 'RICH_CONTENT_FIELD_CONFIRM_ERROR';
const $99d43d51c2dfe210$export$b1a41c9183097dc = 'RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR';
const $99d43d51c2dfe210$export$67544887e2b37fbc = 'RICH_CONTENT_FIELD_REQUIRED_ERROR';
const $99d43d51c2dfe210$export$67566c205c72838a = 'DELETE_CONFLUENCE_PAGE_LINK_FAILED';
const $99d43d51c2dfe210$export$e3245a362f751a4a = 'DELETE_WEB_LINK_FAILED';
const $99d43d51c2dfe210$export$3408969e4d418350 = 'CLICKTHROUGH_BANNER_DISMISS_SUCCESS';
const $99d43d51c2dfe210$export$733fe45ab8c75209 = 'SAVE_APPROVAL_ANSWER_ERROR';
const $99d43d51c2dfe210$export$9d1386a2d0651ca9 = 'SAVE_APPROVAL_ANSWER_SUCCESS';
const $99d43d51c2dfe210$export$56094d7f6af14eac = 'EDIT_EPIC_COLOUR_ERROR';
const $99d43d51c2dfe210$export$92d58445895900f9 = 'EDIT_ISSUE_COLOUR_ERROR';
const $99d43d51c2dfe210$export$75d850be4d27b98e = 'FETCH_JIRA_APP_LINKS_ERROR';
const $99d43d51c2dfe210$export$9030bf81702823b8 = 'CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$a2a71fb6b193e549 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$2dd786d54c8f9397 = 'COMMENTS_INTERNAL_SERVER_ERROR';
const $99d43d51c2dfe210$export$8c5e4d3dfe9a1c32 = 'ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$49d11338d75de478 = 'ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$3573d8ff428b4c8f = 'ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$c0657c5ed1bbfed4 = [
    $99d43d51c2dfe210$export$a2a71fb6b193e549,
    $99d43d51c2dfe210$export$3573d8ff428b4c8f
];

});

parcelRegister("79RqQ", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$dd2d62bc7ec6ce51);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$db1ab2b83dc17aa9);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$940ce115dba33e55);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$4ec1f3604b85d553);
$parcel$export(module.exports, "GROUP_VISIBILITY_SETTING_NOT_ENABLED", () => $5fa2842a51e11b84$export$69483322ede4b803);
$parcel$export(module.exports, "ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST", () => $5fa2842a51e11b84$export$e65b95e776ce6f27);
const $5fa2842a51e11b84$export$dd2d62bc7ec6ce51 = 'ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $5fa2842a51e11b84$export$db1ab2b83dc17aa9 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $5fa2842a51e11b84$export$940ce115dba33e55 = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED: 10000';
const $5fa2842a51e11b84$export$4ec1f3604b85d553 = 'REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $5fa2842a51e11b84$export$69483322ede4b803 = 'GROUP_VISIBILITY_SETTING_NOT_ENABLED';
const $5fa2842a51e11b84$export$e65b95e776ce6f27 = [
    $5fa2842a51e11b84$export$dd2d62bc7ec6ce51,
    $5fa2842a51e11b84$export$db1ab2b83dc17aa9,
    $5fa2842a51e11b84$export$940ce115dba33e55,
    $5fa2842a51e11b84$export$4ec1f3604b85d553
];

});

const $7e58198413094512$export$bd6f44214f84c29a = 4102;
const $7e58198413094512$export$aa53f670803b96e = 3165;



parcelRegister("kFLe7", function(module, exports) {

let $f0cc45338f1d2335$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f0cc45338f1d2335$var$load("kWrFZ"),
    $f0cc45338f1d2335$var$load("dsiAd"),
    $f0cc45338f1d2335$var$load("kfXhT"),
    $f0cc45338f1d2335$var$load("2Lfdl"),
    $f0cc45338f1d2335$var$load("92sUi"),
    $f0cc45338f1d2335$var$load("i5RRW"),
    $f0cc45338f1d2335$var$load("eNmuD"),
    $f0cc45338f1d2335$var$load("hPzOn"),
    $f0cc45338f1d2335$var$load("h2MrD"),
    $f0cc45338f1d2335$var$load("bYT2S"),
    $f0cc45338f1d2335$var$load("cM9em"),
    $f0cc45338f1d2335$var$load("fr9NE"),
    $f0cc45338f1d2335$var$load("cggv6")
]).then(()=>parcelRequire('6qbjz'));

});


parcelRegister("kj1di", function(module, exports) {

$parcel$export(module.exports, "InfiniteScrollProvider", () => $0de0172be9dbd684$export$f4ede5143c1d55e9);
$parcel$export(module.exports, "useInfiniteScroll", () => $0de0172be9dbd684$export$a973cef5093a8d22);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $eTXmK = parcelRequire("eTXmK");

var $4R6GH = parcelRequire("4R6GH");

var $czfFt = parcelRequire("czfFt");

var $6UAdF = parcelRequire("6UAdF");
const $0de0172be9dbd684$var$INFINITE_SCROLL_DEFAULT_OPTIONS = {
    pageSize: (0, $6UAdF.MAX_ISSUES_PER_PAGE),
    threshold: 5 * (0, $czfFt.ROW_HEIGHT)
};
const $0de0172be9dbd684$var$INFINITE_SCROLL_INTERACTION_NAME = 'issue-navigator.infinite-scroll';
const $0de0172be9dbd684$var$InfiniteScrollContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    onLoadNext: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onLoadPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isLoadingNext: false,
    isLoadingPrevious: false,
    hasNext: false,
    hasPrevious: false
});
const $0de0172be9dbd684$export$f4ede5143c1d55e9 = ({ onLoadNext: onLoadNext, onLoadPrevious: onLoadPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, children: children })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            onLoadNext: onLoadNext,
            onLoadPrevious: onLoadPrevious,
            isLoadingNext: isLoadingNext,
            isLoadingPrevious: isLoadingPrevious,
            hasNext: hasNext,
            hasPrevious: hasPrevious
        }), [
        onLoadNext,
        onLoadPrevious,
        isLoadingNext,
        isLoadingPrevious,
        hasNext,
        hasPrevious
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0de0172be9dbd684$var$InfiniteScrollContext.Provider, {
        value: value
    }, children);
};
function $0de0172be9dbd684$export$a973cef5093a8d22({ fieldSetIds: fieldSetIds, view: view, groupBy: groupBy, options: options, isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled }) {
    const { pageSize: pageSize, threshold: threshold } = {
        ...$0de0172be9dbd684$var$INFINITE_SCROLL_DEFAULT_OPTIONS,
        ...options
    };
    const { onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...rest } = (0, $5uXOq.useContext)($0de0172be9dbd684$var$InfiniteScrollContext);
    // Extra static variables to ensure consistent field set results are returned during pagination.
    const staticPaginationVariables = (0, $5uXOq.useMemo)(()=>({
            ...isIssueHierarchySupportEnabled && {
                viewConfigInput: {
                    staticViewInput: {
                        isHierarchyEnabled: isHierarchyEnabled || false,
                        ...(0, $4R6GH.fg)('jsc_list_hide_done_items') ? {
                            isHideDoneEnabled: isHideDoneEnabled
                        } : {}
                    }
                }
            },
            fieldSetsInput: {
                fieldSetIds: fieldSetIds
            },
            groupBy: groupBy,
            isPaginating: true
        }), [
        fieldSetIds,
        groupBy,
        isHideDoneEnabled,
        isHierarchyEnabled,
        isIssueHierarchySupportEnabled
    ]);
    const onLoadNext = (0, $5uXOq.useCallback)(()=>{
        if (view && (0, $4R6GH.fg)('add_nin_press_interactions')) (0, $eTXmK.default)(`${$0de0172be9dbd684$var$INFINITE_SCROLL_INTERACTION_NAME}.${view}`);
        return onLoadNextProp(pageSize, {
            UNSTABLE_extraVariables: staticPaginationVariables
        });
    }, [
        onLoadNextProp,
        pageSize,
        staticPaginationVariables,
        view
    ]);
    const onLoadPrevious = (0, $5uXOq.useCallback)(()=>{
        if (view && (0, $4R6GH.fg)('add_nin_press_interactions')) (0, $eTXmK.default)(`${$0de0172be9dbd684$var$INFINITE_SCROLL_INTERACTION_NAME}.${view}`);
        onLoadPreviousProp(pageSize, {
            UNSTABLE_extraVariables: staticPaginationVariables
        });
    }, [
        onLoadPreviousProp,
        pageSize,
        staticPaginationVariables,
        view
    ]);
    const infiniteScrollProps = (0, $5uXOq.useMemo)(()=>({
            onLoadNext: onLoadNext,
            onLoadPrevious: onLoadPrevious,
            activationThreshold: threshold,
            ...rest
        }), [
        onLoadNext,
        onLoadPrevious,
        threshold,
        rest
    ]);
    return infiniteScrollProps;
}

});

parcelRegister("5lE9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $752b8206000afac8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $752b8206000afac8$var$messages = (0, $7VHMR.defineMessages)({
    returnText: {
        "id": "issue-navigator.full-page-issue-app.return-text",
        "defaultMessage": "Return to search"
    }
});
var $752b8206000afac8$export$2e2bcd8739ae039 = $752b8206000afac8$var$messages;

});


parcelRegister("hWyif", function(module, exports) {

$parcel$export(module.exports, "default", () => $eef80bc13fe78613$export$2e2bcd8739ae039);

var $8Oh73 = parcelRequire("8Oh73");

var $aPygs = parcelRequire("aPygs");

var $9bW4Y = parcelRequire("9bW4Y");

var $exNQa = parcelRequire("exNQa");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $gcl1l = parcelRequire("gcl1l");

var $hP2me = parcelRequire("hP2me");

var $imS60 = parcelRequire("imS60");

var $6s1PB = parcelRequire("6s1PB");

var $1TiUe = parcelRequire("1TiUe");

var $4R6GH = parcelRequire("4R6GH");

var $iofGi = parcelRequire("iofGi");

var $48rMm = parcelRequire("48rMm");

var $6UAdF = parcelRequire("6UAdF");

var $jjbNu = parcelRequire("jjbNu");

var $1igGa = parcelRequire("1igGa");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");

var $cKK2E = parcelRequire("cKK2E");

var $38r5c = parcelRequire("38r5c");
const $eef80bc13fe78613$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $eef80bc13fe78613$var$Header = ({ CustomHeader: CustomHeader, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage, viewResult: viewResult, jiraViewResult: jiraViewResult, isGroupingSupported: isGroupingSupported })=>{
    const issueResultsData = (0, $8Uumt.useFragment)((0, $exNQa.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $eef80bc13fe78613$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $5uXOq.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const jql = (0, $gwtSG.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cKK2E.useFilterQuery)();
    const filterData = (0, $8Uumt.useFragment)((0, $9bW4Y.default), filter);
    const viewResultData = (0, $8Uumt.useFragment)((0, $aPygs.default), viewResult);
    const jiraViewData = (0, $8Uumt.useFragment)((0, $8Oh73.default), jiraViewResult);
    const filterDetails = (0, $5uXOq.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    let jiraViewResultData = null;
    if ((0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) jiraViewResultData = jiraViewData && (0, $6UAdF.isJiraSpreadsheetView)(jiraViewData) ? jiraViewData : null;
    else jiraViewResultData = viewResultData;
    let onChangeHierarchy = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    let onChangeGroupedByField = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    let onChangeHideDone = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ onChangeHierarchy: onChangeHierarchy, onChangeGroupedByField: onChangeGroupedByField, onChangeHideDone: onChangeHideDone } = (0, $38r5c.useIssueSearchActions)());
    const HierarchyToggle = jiraViewResultData && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjbNu.HierarchyToggleItem), {
        isGroupingSupported: isGroupingSupported,
        viewResult: jiraViewResultData,
        onChangeHierarchy: onChangeHierarchy
    }) : null;
    let onResetSelectedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if ((0, $4R6GH.fg)('jsc_list_hide_done_items')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reset: onResetSelectedIssues } = (0, $48rMm.useIssueTableSelectedIssuesActions)());
    const HideDoneToggle = jiraViewResultData && (0, $4R6GH.fg)('jsc_list_hide_done_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iofGi.HideDoneItemsToggle), {
        viewResult: jiraViewResultData,
        onChangeHideDone: onChangeHideDone,
        onResetSelectedIssues: onResetSelectedIssues
    }) : null;
    const GroupByDropdown = isGroupingSupported && jiraViewData && (0, $6UAdF.isJiraSpreadsheetView)(jiraViewData) && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hP2me.GroupByDropdown), {
        onChangeGroupedByField: onChangeGroupedByField,
        spreadsheetView: jiraViewData
    }) : null;
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderSkeletonImage, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomHeader, {
        jql: jql,
        filterId: filterId,
        filterDetails: filterDetails,
        searchResultPageData: searchResultPageData,
        HierarchyToggle: HierarchyToggle,
        GroupByDropdown: GroupByDropdown,
        HideDoneToggle: HideDoneToggle
    }));
};
var $eef80bc13fe78613$export$2e2bcd8739ae039 = (0, $1igGa.withReportErrors)($eef80bc13fe78613$var$Header, {
    id: 'ui.header.unhandled',
    packageName: (0, $6UAdF.PACKAGE_NAME),
    teamName: (0, $6UAdF.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $gcl1l.isLoaderErrorAttributes)
});

});
parcelRegister("8Oh73", function(module, exports) {

$parcel$export(module.exports, "default", () => $143f1a157427940a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<328ae49a59df365d68bdbb1be733ef77>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $143f1a157427940a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_jiraViewResult",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueTableGroupByDropdown_GroupByDropdown"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$143f1a157427940a$var$node.hash = "6801cba100b3ce72ddc57445b1e0465b";
var $143f1a157427940a$export$2e2bcd8739ae039 = $143f1a157427940a$var$node;

});

parcelRegister("aPygs", function(module, exports) {

$parcel$export(module.exports, "default", () => $926f4cfc73576864$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40b4fb3555b8eac0ba94fcbf455780ff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $926f4cfc73576864$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_viewResult",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
        },
        {
            "kind": "FragmentSpread",
            "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
        }
    ],
    "type": "JiraIssueSearchView"
};
$926f4cfc73576864$var$node.hash = "98304a7101c46d56450487d906bea361";
var $926f4cfc73576864$export$2e2bcd8739ae039 = $926f4cfc73576864$var$node;

});

parcelRegister("9bW4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $28f411246a53b131$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a59decce3d17ede33536b0b36f9eb2f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $28f411246a53b131$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$28f411246a53b131$var$node.hash = "49ae72938f954e62114776575c662bd8";
var $28f411246a53b131$export$2e2bcd8739ae039 = $28f411246a53b131$var$node;

});

parcelRegister("exNQa", function(module, exports) {

$parcel$export(module.exports, "default", () => $049e4d6502bf1381$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<904e0d39da2e4e2100f94fcd59ddca44>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $049e4d6502bf1381$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_issueNavigator_Header_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$049e4d6502bf1381$var$node.hash = "a6845643ea9e8dc218ebb8df7988c3f7";
var $049e4d6502bf1381$export$2e2bcd8739ae039 = $049e4d6502bf1381$var$node;

});

parcelRegister("hP2me", function(module, exports) {

$parcel$export(module.exports, "GroupByDropdown", () => $d0d4705b9d2a197a$export$84685e583ac84574);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");


var $8Xv4x = parcelRequire("8Xv4x");
const $d0d4705b9d2a197a$export$84685e583ac84574 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-group-by-dropdown",
        packageName: (0, $c2be5dcb54fbd60e$export$b8b9d90f9e5bd72b),
        teamName: (0, $c2be5dcb54fbd60e$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Xv4x.GroupByDropdown), props)));

});
const $c2be5dcb54fbd60e$export$b8b9d90f9e5bd72b = 'jiraIssueTableGroupByDropdown';
const $c2be5dcb54fbd60e$export$d57b6b390e78d90f = 'jira-yurree';
const $c2be5dcb54fbd60e$export$5979c086684d2404 = 'loadGroupByOptions';
const $c2be5dcb54fbd60e$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $c2be5dcb54fbd60e$export$4808ef77f47c3615 = 'issue-navigator-group-by-dropdown';
const $c2be5dcb54fbd60e$export$64d8bb86ca32b86 = 'changeGroupByField';

parcelRegister("8Xv4x", function(module, exports) {

$parcel$export(module.exports, "GroupByDropdown", () => $d136c8320b72cc56$export$84685e583ac84574);

var $jL3wY = parcelRequire("jL3wY");

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $jZ4fr = parcelRequire("jZ4fr");

var $8Uumt = parcelRequire("8Uumt");

var $bWn3s = parcelRequire("bWn3s");

var $c8Oei = parcelRequire("c8Oei");

var $eCeGD = parcelRequire("eCeGD");

var $BLPHT = parcelRequire("BLPHT");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $99gkn = parcelRequire("99gkn");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $8CVvd = parcelRequire("8CVvd");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");


var $aXE7i = parcelRequire("aXE7i");

var $i0YL5 = parcelRequire("i0YL5");

var $jvyZ4 = parcelRequire("jvyZ4");
const $d136c8320b72cc56$var$GroupByTriggerIconAfter = ()=>{
    if ((0, $8CVvd.getWillShowNav3)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $d136c8320b72cc56$var$iconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        label: ""
    }));
    return null;
};
const $d136c8320b72cc56$export$84685e583ac84574 = ({ spreadsheetView: spreadsheetView, onChangeGroupedByField: onChangeGroupedByField })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $c2be5dcb54fbd60e$export$5979c086684d2404),
        analyticsSource: (0, $c2be5dcb54fbd60e$export$f7109619a5e9e0d6)
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $c2be5dcb54fbd60e$export$5979c086684d2404)
    });
    (0, $5uXOq.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const data = (0, $8Uumt.useFragment)((0, $jL3wY.default), spreadsheetView);
    const groupByFieldFromQuery = (0, $5uXOq.useMemo)(()=>data?.viewSettings?.groupByConfig?.groupByField ? {
            fieldId: data.viewSettings.groupByConfig.groupByField.fieldId,
            name: data.viewSettings.groupByConfig.groupByField.name
        } : null, [
        data?.viewSettings?.groupByConfig?.groupByField
    ]);
    const prevGroupByFieldFromQuery = (0, $5uXOq.useRef)(groupByFieldFromQuery);
    const [groupByField, setGroupByField] = (0, $5uXOq.useState)(groupByFieldFromQuery);
    // If group by field changes in the query response, update local state to keep it in sync
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(groupByFieldFromQuery, prevGroupByFieldFromQuery.current)) {
        prevGroupByFieldFromQuery.current = groupByFieldFromQuery;
        setGroupByField(groupByFieldFromQuery);
    }
    const onUpdateGroupByField = (0, $5uXOq.useCallback)((newGroupByField)=>{
        if (groupByField?.fieldId !== newGroupByField?.fieldId) {
            setGroupByField(newGroupByField ?? null);
            onChangeGroupedByField(newGroupByField?.fieldId);
        }
    }, [
        groupByField,
        onChangeGroupedByField
    ]);
    const issueSearchInput = data?.filterId && {
        filterId: data.filterId
    } || data?.jql && {
        jql: data.jql
    } || undefined;
    const groupByFieldId = groupByField?.fieldId;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $i0YL5.groupByDropdownEntryPoint), {
        nodeId: data.id,
        selectedFieldId: groupByFieldId,
        issueSearchInput: issueSearchInput
    });
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    (0, $99gkn.addUFOCustomData)({
        groupByFieldId: data?.viewSettings?.groupByConfig?.groupByField?.typeKey,
        isGrouping: data?.viewSettings?.isGroupingEnabled
    });
    const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'issue-table-group-by-dropdown',
                packageName: (0, $c2be5dcb54fbd60e$export$b8b9d90f9e5bd72b),
                teamName: (0, $c2be5dcb54fbd60e$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $c2be5dcb54fbd60e$export$b8b9d90f9e5bd72b), error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $d136c8320b72cc56$var$errorFallbackStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $jvyZ4.default).entrypointErrorContent)));
    }, [
        formatMessage,
        onExperienceFail
    ]);
    if (!data?.viewSettings?.canEnableGrouping) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                ...triggerProps,
                ref: triggerRef,
                iconAfter: $d136c8320b72cc56$var$GroupByTriggerIconAfter,
                onClick: (event, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueTableGroupByDropdownDisabledTrigger');
                    onClick && onClick(event);
                }
            }, formatMessage((0, $jvyZ4.default).groupByLabelWithoutSelection)),
        placement: "bottom-end",
        shouldRenderToParent: true,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d136c8320b72cc56$var$cantGroupIssuesStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $jvyZ4.default).cantGroupIssuesContentIssueTermRefresh : (0, $jvyZ4.default).cantGroupIssuesContent))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $c2be5dcb54fbd60e$export$4808ef77f47c3615)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, onClick: onClick, isSelected: isSelected, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                ...triggerProps,
                isSelected: Boolean(groupByField) || isSelected,
                testId: "issue-table-group-by-dropdown.ui.group-by-dropdown",
                ref: (0, $bWn3s.mergeRefs)([
                    triggerRef,
                    buttonTrigger
                ]),
                iconAfter: $d136c8320b72cc56$var$GroupByTriggerIconAfter,
                onClick: (event, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueTableGroupByDropdownTrigger');
                    onClick && onClick(event);
                }
            }, groupByField?.name ? formatMessage((0, $jvyZ4.default).groupByLabelWithASelection, {
                groupByField: groupByField.name
            }) : formatMessage((0, $jvyZ4.default).groupByLabelWithoutSelection)),
        placement: "bottom-end",
        shouldRenderToParent: true,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "async-jira-spreadsheet-group-by-dropdown",
        packageName: (0, $c2be5dcb54fbd60e$export$b8b9d90f9e5bd72b),
        teamName: (0, $c2be5dcb54fbd60e$export$d57b6b390e78d90f),
        errorFallback: errorFallback,
        runtimeProps: {
            onUpdateGroupByField: onUpdateGroupByField
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aXE7i.LoadingContent), null)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: (0, $c2be5dcb54fbd60e$export$4808ef77f47c3615)
    }));
};
const $d136c8320b72cc56$var$cantGroupIssuesStyles = (0, $8CUq3.xcss)({
    marginInline: 'space.300',
    marginBlock: 'space.200',
    width: '250px',
    whiteSpace: 'initial'
});
const $d136c8320b72cc56$var$errorFallbackStyles = (0, $8CUq3.xcss)({
    padding: 'space.200',
    width: '250px'
});
const $d136c8320b72cc56$var$iconStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.negative.075'
});

});
parcelRegister("jL3wY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2194e6ac7335f4ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5eec9cb87961d4f938c8648d180bee8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2194e6ac7335f4ec$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "ui_issueTableGroupByDropdown_GroupByDropdown",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "groupBy",
                    "variableName": "groupBy"
                },
                {
                    "kind": "Variable",
                    "name": "issueSearchInput",
                    "variableName": "issueSearchInput"
                },
                {
                    "kind": "Variable",
                    "name": "staticViewInput",
                    "variableName": "staticViewInput"
                }
            ],
            "concreteType": "JiraIssueSearchViewConfigSettings",
            "kind": "LinkedField",
            "name": "viewSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canEnableGrouping"
                },
                {
                    "kind": "ScalarField",
                    "name": "isGroupingEnabled"
                },
                {
                    "concreteType": "JiraSpreadsheetGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "groupByField",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "typeKey"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
};
$2194e6ac7335f4ec$var$node.hash = "fb74039ef112118517cb2d8c0aacd6b0";
var $2194e6ac7335f4ec$export$2e2bcd8739ae039 = $2194e6ac7335f4ec$var$node;

});

parcelRegister("aXE7i", function(module, exports) {

$parcel$export(module.exports, "LoadingContent", () => $fe908327699611a2$export$4ab3512e4872e6ff);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $fe908327699611a2$export$4ab3512e4872e6ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $fe908327699611a2$var$loadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));
const $fe908327699611a2$var$loadingStyles = (0, $8CUq3.xcss)({
    width: '250px',
    paddingBlock: 'space.500'
});

});

parcelRegister("i0YL5", function(module, exports) {

$parcel$export(module.exports, "groupByDropdownEntryPoint", () => $3d764d6f218c7490$export$427ad501ef456b18);

var $fnLZy = parcelRequire("fnLZy");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $3d764d6f218c7490$export$427ad501ef456b18 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6bd9u")), {
        moduleId: "9655b1ba"
    }),
    getPreloadProps: ({ nodeId: nodeId, selectedFieldId: selectedFieldId, issueSearchInput: issueSearchInput })=>({
            queries: {
                groupByDropdownQuery: {
                    parameters: (0, $fnLZy.default),
                    variables: {
                        nodeId: nodeId,
                        issueSearchInput: issueSearchInput
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            },
            extraProps: {
                selectedFieldId: selectedFieldId
            }
        })
});

});
parcelRegister("fnLZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $321c892c08f9b689$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4920aba0fdff5f250bb259e2a4bd33f1>>
 * @relayHash b606c8503ba13103558346bec184b2f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 96ec47cc2b1ac76ade56418d9c4750d062d5fb519c0b910427f4eebfda415c10
const $321c892c08f9b689$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "nodeId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "nodeId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v10 = [
        {
            "kind": "RequiredField",
            "field": v4 /*: any*/ ,
            "action": "THROW",
            "path": "node.id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueSearchViewConfigSettings",
                "kind": "LinkedField",
                "name": "viewSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v5 /*: any*/ ,
                                        "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                                        "kind": "LinkedField",
                                        "name": "availableGroupByFieldOptions",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v6 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.fieldId"
                                                                },
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "node.viewSettings.groupByConfig"
                    }
                ]
            },
            "action": "THROW",
            "path": "node.viewSettings"
        }
    ], v11 = [
        {
            "concreteType": "JiraIssueSearchViewConfigSettings",
            "kind": "LinkedField",
            "name": "viewSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSpreadsheetGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                            "kind": "LinkedField",
                            "name": "availableGroupByFieldOptions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraField",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainGroupByDropdownContentQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v10 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v10 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainGroupByDropdownContentQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "96ec47cc2b1ac76ade56418d9c4750d062d5fb519c0b910427f4eebfda415c10",
            "metadata": {},
            "name": "mainGroupByDropdownContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$321c892c08f9b689$var$node.hash = "e11ca8bdcf47f14e64eabfb3a93eadb5";
var $321c892c08f9b689$export$2e2bcd8739ae039 = $321c892c08f9b689$var$node;

});

parcelRegister("6bd9u", function(module, exports) {

let $47fdf8e037cf95cd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $47fdf8e037cf95cd$var$load("aVX5e").then(()=>parcelRequire('aDBI2'));

});


parcelRegister("jvyZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b05ad221a39d9d95$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b05ad221a39d9d95$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    groupByLabelWithoutSelection: {
        "id": "issue-table-group-by-dropdown.group-by-label-without-selection",
        "defaultMessage": "Group"
    },
    groupByLabelWithASelection: {
        "id": "issue-table-group-by-dropdown.group-by-label-with-a-selection",
        "defaultMessage": "Group: {groupByField}"
    },
    cantGroupIssuesContent: {
        "id": "issue-table-group-by-dropdown.cant-group-issues-content",
        "defaultMessage": "We can only group issues when you filter issues from one project. Update your JQL filter and try again."
    },
    cantGroupIssuesContentIssueTermRefresh: {
        "id": "issue-table-group-by-dropdown.cant-group-issues-content-issue-term-refresh",
        "defaultMessage": "We can only group work items when you filter work items from one project. Update your JQL filter and try again."
    },
    entrypointErrorContent: {
        "id": "issue-table-group-by-dropdown.entrypoint-error-content",
        "defaultMessage": "Something went wrong. Try loading the content again."
    }
});

});



parcelRegister("iofGi", function(module, exports) {

$parcel$export(module.exports, "HideDoneItemsToggle", () => $5e76b62c74772851$export$b7b414a8403ed1a2);

var $cUu2Z = parcelRequire("cUu2Z");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $gqrUg = parcelRequire("gqrUg");

const $5e76b62c74772851$export$b7b414a8403ed1a2 = (props)=>{
    const viewResultData = (0, $8Uumt.useFragment)((0, $cUu2Z.default), props.viewResult);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-hide-done-toggle",
        packageName: (0, $60ea362de9a3f71f$export$b8b9d90f9e5bd72b),
        teamName: (0, $60ea362de9a3f71f$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqrUg.HideDoneItemsToggle), {
        viewResult: viewResultData,
        onChangeHideDone: props.onChangeHideDone,
        onResetSelectedIssues: props.onResetSelectedIssues
    }));
};

});
parcelRegister("cUu2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $244f92fad62d9fad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e83dba05022fc1d8a66669b691ad0ce1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $244f92fad62d9fad$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "staticViewInput",
                    "variableName": "staticViewInput"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ui_issueTableHideDoneToggle_HideDoneItemsToggle"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$244f92fad62d9fad$var$node.hash = "e95333f36c81e4bc86fe59f9dcf1304b";
var $244f92fad62d9fad$export$2e2bcd8739ae039 = $244f92fad62d9fad$var$node;

});

parcelRegister("gqrUg", function(module, exports) {

$parcel$export(module.exports, "HideDoneItemsToggle", () => $5c84dcdbc913b15a$export$b7b414a8403ed1a2);

var $ekHHq = parcelRequire("ekHHq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");

var $dTlW6 = parcelRequire("dTlW6");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $1TiUe = parcelRequire("1TiUe");

var $44cHl = parcelRequire("44cHl");

var $gBRsl = parcelRequire("gBRsl");

var $dG0IQ = parcelRequire("dG0IQ");
const $5c84dcdbc913b15a$export$b7b414a8403ed1a2 = ({ viewResult: viewResult, onChangeHideDone: onChangeHideDone, onResetSelectedIssues: onResetSelectedIssues })=>{
    const viewResultData = (0, $8Uumt.useFragment)((0, $ekHHq.default), viewResult);
    const { viewConfigSettings: viewConfigSettings, viewSettings: viewSettings, id: id, viewId: viewId, __id: issueSearchViewId } = viewResultData;
    const hideDoneToggleViewSettings = (0, $1TiUe.isRefactorNinToViewSchemaEnabled)() ? viewSettings : viewConfigSettings;
    const { hideDone: hideDone } = hideDoneToggleViewSettings ?? {};
    const [hideDoneIsChecked, setHideDoneIsChecked] = (0, $5uXOq.useState)(hideDone);
    const toggleIssueHideDone = (0, $44cHl.useUpdateHideDoneMutation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onChange = (0, $5uXOq.useCallback)(()=>{
        if (id) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'toggle clicked', 'hideDoneItems', {
                hideDone: !hideDone
            });
            setHideDoneIsChecked(!hideDone);
            // toggle mutation here
            toggleIssueHideDone({
                issueSearchViewResultAri: id,
                isHideDoneEnabled: !hideDone,
                issueSearchViewId: issueSearchViewId,
                onChangeHideDone: onChangeHideDone
            });
            // reset the selected issue for the bulk operations when chaging the toggle
            onResetSelectedIssues && onResetSelectedIssues();
        }
    }, [
        createAnalyticsEvent,
        hideDone,
        id,
        issueSearchViewId,
        onChangeHideDone,
        onResetSelectedIssues,
        toggleIssueHideDone
    ]);
    const toggleId = `${viewId}_hide_done_toggle`;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: toggleId
    }, formatMessage((0, $gBRsl.default).showHideDoneItems)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        size: "large",
        id: toggleId,
        onChange: onChange,
        isChecked: Boolean(hideDoneIsChecked)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dG0IQ.HideDoneOnboarding), null));
};

});
parcelRegister("ekHHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c1007dd4df1d6e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<390686b420c6469396589e80be71e93f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4c1007dd4df1d6e0$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "staticViewInput",
        "variableName": "staticViewInput"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "hideDone"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "staticViewInput"
            }
        ],
        "kind": "Fragment",
        "name": "ui_issueTableHideDoneToggle_HideDoneItemsToggle",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "viewId"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "args": [
                            v0 /*: any*/ 
                        ],
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewConfigSettings",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    }
                ],
                "type": "JiraIssueSearchView"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "groupBy",
                                "variableName": "groupBy"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            v0 /*: any*/ 
                        ],
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraIssueSearchViewMetadata",
        "abstractKey": "__isJiraIssueSearchViewMetadata"
    };
}();
$4c1007dd4df1d6e0$var$node.hash = "d2b79349e4c345a095cbd27b5f44cc54";
var $4c1007dd4df1d6e0$export$2e2bcd8739ae039 = $4c1007dd4df1d6e0$var$node;

});

parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $7fA4P = parcelRequire("7fA4P");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fA4P))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("7fA4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));

var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
    }, props));
$5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});



parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});


parcelRegister("44cHl", function(module, exports) {

$parcel$export(module.exports, "useUpdateHideDoneMutation", () => $bf44987b76c2f50f$export$1d65880c4ddc0209);

var $kPt40 = parcelRequire("kPt40");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eCBf9 = parcelRequire("eCBf9");

var $koVbs = parcelRequire("koVbs");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $kaHBi = parcelRequire("kaHBi");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $cZpsT = parcelRequire("cZpsT");


var $edM9a = parcelRequire("edM9a");
const $bf44987b76c2f50f$export$1d65880c4ddc0209 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $60ea362de9a3f71f$export$6a7d6ab86cfdfcdc),
        analyticsSource: (0, $60ea362de9a3f71f$export$f7109619a5e9e0d6)
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $60ea362de9a3f71f$export$6a7d6ab86cfdfcdc)
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $60ea362de9a3f71f$export$6a7d6ab86cfdfcdc)
    });
    const [commit] = (0, $8Uumt.useMutation)((0, $kPt40.default));
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'issue-table-hide-done-toggle',
                packageName: (0, $60ea362de9a3f71f$export$b8b9d90f9e5bd72b),
                teamName: (0, $60ea362de9a3f71f$export$d57b6b390e78d90f)
            },
            error: error
        });
        onExperienceFail((0, $60ea362de9a3f71f$export$b8b9d90f9e5bd72b), error);
        showFlag({
            messageId: 'issue-table-hide-done-toggle.services.update-hide-done-toggle.show-flag.error',
            messageType: 'transactional',
            id: 'hideDoneToggleError',
            title: formatMessage((0, $edM9a.default).hideDoneErrorFlagTitle),
            description: formatMessage((0, $edM9a.default).hideDoneErrorFlagDescription),
            isAutoDismiss: true,
            type: 'error'
        });
    }, [
        formatMessage,
        onExperienceFail,
        showFlag
    ]);
    const storeUpdater = (0, $5uXOq.useCallback)(({ isHideDoneEnabled: isHideDoneEnabled, store: store, issueSearchViewId: issueSearchViewId })=>{
        const issueSearchRecord = store.get(issueSearchViewId);
        if (issueSearchRecord) {
            const viewSettingsRecord = issueSearchRecord.getLinkedRecord('viewSettings');
            if (viewSettingsRecord) viewSettingsRecord.setValue(isHideDoneEnabled, 'hideDone');
        }
    }, []);
    const updateHideDone = (0, $5uXOq.useCallback)(({ issueSearchViewResultAri: issueSearchViewResultAri, issueSearchViewId: issueSearchViewId, isHideDoneEnabled: isHideDoneEnabled, onChangeHideDone: onChangeHideDone })=>{
        if (isAnonymous) {
            onChangeHideDone(isHideDoneEnabled);
            return;
        }
        onExperienceStart();
        commit({
            variables: {
                viewId: issueSearchViewResultAri,
                isHideDoneEnabled: isHideDoneEnabled
            },
            optimisticUpdater (store) {
                storeUpdater({
                    store: store,
                    isHideDoneEnabled: isHideDoneEnabled,
                    issueSearchViewId: issueSearchViewId
                });
                onChangeHideDone(isHideDoneEnabled);
            },
            updater: (store)=>{
                storeUpdater({
                    store: store,
                    issueSearchViewId: issueSearchViewId,
                    isHideDoneEnabled: isHideDoneEnabled
                });
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.updateIssueSearchHideDonePreference ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    handleError(error);
                    return;
                }
                onExperienceSuccess();
            },
            onError: handleError
        });
    }, [
        commit,
        handleError,
        isAnonymous,
        onExperienceStart,
        onExperienceSuccess,
        storeUpdater
    ]);
    return updateHideDone;
};

});
parcelRegister("kPt40", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0afe69c431a00be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4d4af45c8adaaac209629cfdbd007f03>>
 * @relayHash dd9efeee3df9ed0f25a9e443f4fe9ff1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1dd989944ef51d82c8b883520c951c40b4af149ab99937461172b421f27efcf
const $d0afe69c431a00be$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHideDoneEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "isHideDoneEnabled",
            "variableName": "isHideDoneEnabled"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "updateHideDoneToggleMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueSearchHideDonePreference",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "updateHideDoneToggleMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueSearchHideDonePreference",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f1dd989944ef51d82c8b883520c951c40b4af149ab99937461172b421f27efcf",
            "metadata": {},
            "name": "updateHideDoneToggleMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d0afe69c431a00be$var$node.hash = "3419756ffa1072020b7cc0619420840e";
var $d0afe69c431a00be$export$2e2bcd8739ae039 = $d0afe69c431a00be$var$node;

});

parcelRegister("edM9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e43266aa24af7c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2e43266aa24af7c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hideDoneErrorFlagTitle: {
        "id": "issue-table-hide-done-error-flag-title",
        "defaultMessage": "Hide done preference could not be updated."
    },
    hideDoneErrorFlagDescription: {
        "id": "issue-table-hide-done-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});


parcelRegister("gBRsl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7806784a101795$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ea7806784a101795$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showHideDoneItems: {
        "id": "issue-table-hide-done-items",
        "defaultMessage": "Hide done work items"
    }
});

});



parcelRegister("jjbNu", function(module, exports) {

$parcel$export(module.exports, "HierarchyToggleItem", () => $e1e12482daecc3c5$export$357080ffd90225cc);

var $clHlv = parcelRequire("clHlv");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $lx26o = parcelRequire("lx26o");

var $bSg1p = parcelRequire("bSg1p");

var $f7PHy = parcelRequire("f7PHy");

var $4R6GH = parcelRequire("4R6GH");
const $e1e12482daecc3c5$export$357080ffd90225cc = ({ viewResult: viewResult, isGroupingSupported: isGroupingSupported, onChangeHierarchy: onChangeHierarchy })=>{
    const viewResultData = (0, $8Uumt.useFragment)((0, $clHlv.default), viewResult);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "hierarchy-feature-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lx26o.HierarchyToggle), {
        isGroupingSupported: isGroupingSupported,
        viewResult: viewResultData,
        onChangeHierarchy: onChangeHierarchy
    })), (0, $4R6GH.fg)('jira_list_hierarchy_extraction') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7PHy.HierarchyToggleOnboarding), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bSg1p.HierarchyToggleOnboarding), null));
};

});
parcelRegister("clHlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $12a7ed8434d3053c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0f81e67c50a7e9d44fd5052fba5f4fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $12a7ed8434d3053c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ui_issueTableHierarchyToggle_HierarchyToggle"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$12a7ed8434d3053c$var$node.hash = "e0155f59c7e10da0ab42123f84422439";
var $12a7ed8434d3053c$export$2e2bcd8739ae039 = $12a7ed8434d3053c$var$node;

});

parcelRegister("lx26o", function(module, exports) {

$parcel$export(module.exports, "HierarchyToggle", () => $018b012745a5c896$export$3954d500c5aed66);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");


var $4hYz1 = parcelRequire("4hYz1");
const $018b012745a5c896$export$3954d500c5aed66 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-hierarchy-toggle",
        packageName: (0, $bb4c54ee542a60ec$export$b8b9d90f9e5bd72b),
        teamName: (0, $bb4c54ee542a60ec$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hYz1.HierarchyToggle), props)));

});
const $bb4c54ee542a60ec$export$b8b9d90f9e5bd72b = 'jiraIssueTableHierarchyToggle';
const $bb4c54ee542a60ec$export$d57b6b390e78d90f = 'empanada';

parcelRegister("4hYz1", function(module, exports) {

$parcel$export(module.exports, "HierarchyToggle", () => $2ecf2b723bc56fca$export$3954d500c5aed66);

var $BSGGQ = parcelRequire("BSGGQ");

var $il1iJ = parcelRequire("il1iJ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");

var $dTlW6 = parcelRequire("dTlW6");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cZpsT = parcelRequire("cZpsT");

var $1TiUe = parcelRequire("1TiUe");


var $5Lp4g = parcelRequire("5Lp4g");
const $2ecf2b723bc56fca$export$3954d500c5aed66 = ({ viewResult: viewResult, forwardRef: forwardRef, isGroupingSupported: isGroupingSupported, onChangeHierarchy: onChangeHierarchy })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const viewResultData = (0, $8Uumt.useFragment)((0, $il1iJ.default), viewResult);
    const { viewConfigSettings: viewConfigSettings, viewSettings: viewSettings, id: id, viewId: viewId } = viewResultData;
    const hierarchyToggleViewSettings = (0, $1TiUe.isRefactorNinToViewSchemaEnabled)() ? viewSettings : viewConfigSettings;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const toggleIssueHierarchy = $2ecf2b723bc56fca$export$fb4258c5b554d925();
    const { isGroupingEnabled: isGroupingEnabled, canEnableGrouping: canEnableGrouping, isHierarchyEnabled: isHierarchyEnabled, canEnableHierarchy: canEnableHierarchy } = hierarchyToggleViewSettings ?? {};
    const [checked, setChecked] = (0, $5uXOq.useState)(isHierarchyEnabled);
    const updateHierarchy = (0, $5uXOq.useCallback)((hierarchyPreference)=>{
        setChecked(hierarchyPreference);
        onChangeHierarchy && onChangeHierarchy(hierarchyPreference);
    }, [
        onChangeHierarchy
    ]);
    const onChange = (0, $5uXOq.useCallback)(()=>{
        if (id) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'hierarchyToggle clicked', {
                isHierarchyEnabled: !isHierarchyEnabled
            });
            toggleIssueHierarchy(id, !isHierarchyEnabled, updateHierarchy);
        }
    }, [
        id,
        createAnalyticsEvent,
        isHierarchyEnabled,
        toggleIssueHierarchy,
        updateHierarchy
    ]);
    const isGrouping = isGroupingSupported && isGroupingEnabled && canEnableGrouping;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: `${viewId}_hierarchy_toggle`
    }, formatMessage((0, $5Lp4g.default).showHierarchy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        isDisabled: !canEnableHierarchy,
        isChecked: Boolean(checked && canEnableHierarchy),
        id: `${viewId}_hierarchy_toggle`,
        ref: forwardRef,
        onChange: onChange,
        size: "large"
    })), !canEnableHierarchy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtlest",
        size: "small"
    }, isGrouping ? formatMessage((0, $5Lp4g.default).hierarchyDisabledReasonGroupingAndFilters) : formatMessage((0, $5Lp4g.default).hierarchyDisabledReasonFilters)));
};
const $2ecf2b723bc56fca$export$fb4258c5b554d925 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [commit] = (0, $8Uumt.useMutation)((0, $BSGGQ.default));
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const commitMutation = (0, $5uXOq.useCallback)((issueSearchViewResultAri, isHierarchyEnabled, updateHierarchy)=>{
        if (isAnonymous) {
            updateHierarchy(isHierarchyEnabled);
            return;
        }
        commit({
            variables: {
                viewId: issueSearchViewResultAri,
                isHierarchyEnabled: isHierarchyEnabled
            },
            optimisticUpdater () {
                updateHierarchy(isHierarchyEnabled);
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    meta: {
                        id: 'issue-table-hierarchy-toggle',
                        packageName: (0, $bb4c54ee542a60ec$export$b8b9d90f9e5bd72b),
                        teamName: (0, $bb4c54ee542a60ec$export$d57b6b390e78d90f)
                    },
                    error: error
                });
                showFlag({
                    id: 'hierarchyToggleError',
                    title: formatMessage((0, $5Lp4g.default).hierarchyErrorFlagTitle),
                    description: formatMessage((0, $5Lp4g.default).hierarchyErrorFlagDescription),
                    isAutoDismiss: true,
                    type: 'error',
                    messageId: 'issue-table-hierarchy-toggle.ui.show-flag.error.hierarchy-toggle-error',
                    messageType: 'transactional'
                });
            }
        });
    }, [
        commit,
        formatMessage,
        isAnonymous,
        showFlag
    ]);
    return commitMutation;
};

});
parcelRegister("BSGGQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $348ab9fdc65ea106$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ff7227cddb108452ddf6b3f35d6d597>>
 * @relayHash ed932e3a9d9639379c52dcf337027f34
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d0399e1dcc5bef453e30083f43581d3c86d60aab8f1a485736e24c3b95e46665
const $348ab9fdc65ea106$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHierarchyEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v2 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isHierarchyEnabled",
                            "variableName": "isHierarchyEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "concreteType": "JiraIssueSearchHierarchyPreferenceMutationPayload",
                    "kind": "LinkedField",
                    "name": "updateIssueSearchHierarchyPreference",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_issueTableHierarchyToggle_HierarchyToggleMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ui_issueTableHierarchyToggle_HierarchyToggleMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "d0399e1dcc5bef453e30083f43581d3c86d60aab8f1a485736e24c3b95e46665",
            "metadata": {},
            "name": "ui_issueTableHierarchyToggle_HierarchyToggleMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$348ab9fdc65ea106$var$node.hash = "caf43b06bb046e13cf83843bc009eeea";
var $348ab9fdc65ea106$export$2e2bcd8739ae039 = $348ab9fdc65ea106$var$node;

});

parcelRegister("il1iJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3875b3b3287d94c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f1c64d79cbc973aaffaa05f03c1d79ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e3875b3b3287d94c$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "staticViewInput",
        "variableName": "staticViewInput"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "isHierarchyEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "canEnableHierarchy"
        },
        {
            "kind": "ScalarField",
            "name": "isGroupingEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "canEnableGrouping"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "staticViewInput"
            }
        ],
        "kind": "Fragment",
        "name": "ui_issueTableHierarchyToggle_HierarchyToggle",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "viewId"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "args": [
                            v0 /*: any*/ 
                        ],
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewConfigSettings",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    }
                ],
                "type": "JiraIssueSearchView"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "groupBy",
                                "variableName": "groupBy"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            v0 /*: any*/ 
                        ],
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": v1 /*: any*/ 
                    }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
            }
        ],
        "type": "JiraIssueSearchViewMetadata",
        "abstractKey": "__isJiraIssueSearchViewMetadata"
    };
}();
$e3875b3b3287d94c$var$node.hash = "0ef1c91b39f748dac1abca24d26eeef2";
var $e3875b3b3287d94c$export$2e2bcd8739ae039 = $e3875b3b3287d94c$var$node;

});

parcelRegister("5Lp4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $620fcc9c943a9068$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $620fcc9c943a9068$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showHierarchy: {
        "id": "issue-table-show-hierarchy",
        "defaultMessage": "Show hierarchy"
    },
    hierarchyDisabledReasonGroupingAndFilters: {
        "id": "issue-table-hierarchy-disabled-reason-grouping-and-filters",
        "defaultMessage": "Clear grouping and filters to show hierarchy"
    },
    hierarchyDisabledReasonFilters: {
        "id": "issue-table-hierarchy-disabled-reason-filters",
        "defaultMessage": "Clear filters to show hierarchy"
    },
    hierarchyErrorFlagTitle: {
        "id": "issue-table-hierarchy-error-flag-title",
        "defaultMessage": "Hierarchy preference could not be updated."
    },
    hierarchyErrorFlagDescription: {
        "id": "issue-table-hierarchy-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});




parcelRegister("1igGa", function(module, exports) {

$parcel$export(module.exports, "withReportErrors", () => $8e450634a454d1b1$export$89614e972c8b110);

var $5uXOq = parcelRequire("5uXOq");

var $7iJwP = parcelRequire("7iJwP");
const $8e450634a454d1b1$export$89614e972c8b110 = (WrappedComponent, config)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), config, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));

});


parcelRegister("aTDVl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2a9e5a070a2144b$export$2e2bcd8739ae039);

var $4oTzW = parcelRequire("4oTzW");

var $erDxI = parcelRequire("erDxI");

var $wsH9y = parcelRequire("wsH9y");

var $d6cUj = parcelRequire("d6cUj");

var $1NCNs = parcelRequire("1NCNs");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $01Rn4 = parcelRequire("01Rn4");

var $gcl1l = parcelRequire("gcl1l");

var $6s1PB = parcelRequire("6s1PB");

var $jJZqs = parcelRequire("jJZqs");

var $iXVV6 = parcelRequire("iXVV6");

var $imS60 = parcelRequire("imS60");

var $lVJAU = parcelRequire("lVJAU");

var $1TiUe = parcelRequire("1TiUe");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $6UAdF = parcelRequire("6UAdF");

var $6QnB8 = parcelRequire("6QnB8");

var $1igGa = parcelRequire("1igGa");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $a8lIB = parcelRequire("a8lIB");

var $gtUFk = parcelRequire("gtUFk");

var $7OTah = parcelRequire("7OTah");

var $ih9zY = parcelRequire("ih9zY");

var $krnTs = parcelRequire("krnTs");

var $gwtSG = parcelRequire("gwtSG");

var $isIOR = parcelRequire("isIOR");

var $38r5c = parcelRequire("38r5c");

var $4LmBp = parcelRequire("4LmBp");

var $3vkQx = parcelRequire("3vkQx");

var $dTymG = parcelRequire("dTymG");
const $b2a9e5a070a2144b$var$useAnalyticsAttributes = (type)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!type) return;
        const projectType = (0, $2vSU6.toProjectType)(type.toLowerCase());
        if (!projectType) return;
        const edition = (0, $ldyPw.getEditionForProject)(projectType, appEditions);
        if (!edition) return;
        return {
            edition: edition
        };
    }, [
        appEditions,
        type
    ]);
};
const $b2a9e5a070a2144b$var$IssueResults = ({ hasServerError: hasServerError = false, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onCaughtIssueSearchError: onCaughtIssueSearchError, onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld, onIssueFlatListUpdated: onIssueFlatListUpdated, issueResults: issueResults, groupResults: groupResults, viewResult: viewResult, jiraView: jiraView, project: project, issueTableProps: issueTableProps, filter: filter, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_START);
    const [{ view: selectedView }] = (0, $ih9zY.useSelectedViewState)();
    const jql = (0, $gwtSG.useResolvedJql)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    let onSelectedRowChange;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { setSelectedIssueByIndex: setSelectedIssueByIndex } = (0, $7OTah.useSelectedIssueActions)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        onSelectedRowChange = (0, $5uXOq.useCallback)((rowIndex)=>{
            setSelectedIssueByIndex(rowIndex, {
                shouldDebounce: false,
                shouldNotifyOnChange: false,
                isSelectedByUserInteraction: true
            });
        }, [
            setSelectedIssueByIndex
        ]);
    } else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { setSelectedIssueByIndex: setSelectedIssueByIndex } = (0, $gtUFk.useSelectedIssueStateOldActions)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        onSelectedRowChange = (0, $5uXOq.useCallback)((rowIndex)=>{
            setSelectedIssueByIndex(rowIndex, false, false, true);
        }, [
            setSelectedIssueByIndex
        ]);
    }
    let isFetching;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    isFetching = (0, $38r5c.useIsFetching)();
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ isFetching: isFetching } = (0, $isIOR.useIssueSearchQuery)());
    const issueResultsData = (0, $8Uumt.useFragment)((0, $1NCNs.default), issueResults);
    const groupResultsData = (0, $8Uumt.useFragment)((0, $d6cUj.default), groupResults);
    const viewResultData = (0, $8Uumt.useFragment)((0, $wsH9y.default), viewResult);
    const jiraViewData = (0, $8Uumt.useFragment)((0, $erDxI.default), jiraView);
    const projectData = (0, $8Uumt.useFragment)((0, $4oTzW.default), project);
    let attributes;
    if ((0, $4R6GH.fg)('add-attribute-required-for-colorful-labels-expe')) // eslint-disable-next-line react-hooks/rules-of-hooks
    attributes = $b2a9e5a070a2144b$var$useAnalyticsAttributes(projectData?.projectType);
    const viewResultError = (0, $5uXOq.useMemo)(()=>{
        if (jiraViewData && (0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) {
            const message = jiraViewData.error?.message ?? '';
            const statusCode = jiraViewData.error?.extensions?.[0].statusCode;
            if (typeof statusCode !== 'number') return;
            return new (0, $jJZqs.default)(statusCode, message);
        }
        return viewResultData?.__typename === 'QueryError' && viewResultData?.extensions?.[0]?.statusCode !== undefined && viewResultData?.extensions?.[0]?.statusCode !== null ? new (0, $jJZqs.default)(viewResultData?.extensions?.[0]?.statusCode, viewResultData?.message ?? '') : undefined;
    }, [
        jiraViewData,
        viewResultData?.__typename,
        viewResultData?.extensions,
        viewResultData?.message
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_END);
    }, []);
    const onNavigateToIssue = (0, $5uXOq.useCallback)((issueKey)=>push(`/browse/${issueKey}`), [
        push
    ]);
    const sourceName = selectedView === 'detail' ? (0, $6UAdF.ANALYTICS_DETAIL_VIEW_SOURCE_NAME) : (0, $6UAdF.ANALYTICS_LIST_VIEW_SOURCE_NAME);
    let viewContent = null;
    const resultsFragment = (0, $eJ0Zs.exclusiveGroupResultsOrIssueResultsFragment)({
        groupResults: groupResultsData,
        issueResults: issueResultsData
    });
    if ((0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) {
        if (!hasServerError && jiraViewData && !jiraViewData.error) {
            if (selectedView === 'detail' && jiraViewData.__typename === 'JiraDetailedView' && resultsFragment?.issueResults) viewContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4LmBp.default), {
                loading: isFetching,
                onNavigateToIssue: onNavigateToIssue,
                issueResults: resultsFragment.issueResults,
                view: jiraViewData
            });
            else if (selectedView !== 'detail' && (0, $6UAdF.isJiraSpreadsheetView)(jiraViewData) && resultsFragment) viewContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTymG.default), {
                loading: isFetching,
                onSelectedRowChange: onSelectedRowChange,
                onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld,
                onIssueFlatListUpdated: onIssueFlatListUpdated,
                view: jiraViewData,
                project: projectData,
                onChangeColumnConfiguration: onChangeColumnConfiguration,
                issueTableProps: issueTableProps,
                isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
                filter: filter,
                ...resultsFragment
            });
        }
        if (!viewContent) return isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6QnB8.ListViewSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vkQx.default), {
            error: viewResultError
        });
    } else {
        if (!resultsFragment?.issueResults || resultsFragment.issueResults.issueSearchError?.__typename === 'JiraServerError' || !viewResultData || viewResultData?.__typename === 'QueryError') return isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6QnB8.ListViewSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vkQx.default), {
            error: viewResultError
        });
        viewContent = selectedView !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTymG.default), {
            loading: isFetching,
            onSelectedRowChange: onSelectedRowChange,
            view: viewResultData,
            project: projectData,
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            issueTableProps: issueTableProps,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            filter: filter,
            onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld,
            onIssueFlatListUpdated: onIssueFlatListUpdated,
            ...resultsFragment
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4LmBp.default), {
            loading: isFetching,
            onNavigateToIssue: onNavigateToIssue,
            issueResults: resultsFragment.issueResults,
            view: viewResultData
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "issue-results"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: sourceName,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        ...attributes ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vkQx.RecoverableErrorViewBoundary), {
        recoveryProp: isFetching,
        onCaughtIssueSearchError: onCaughtIssueSearchError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krnTs.SortContainer), {
        jql: jql,
        onChangeJql: onChangeJql
    }, viewContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: ()=>{
            onCaughtIssueSearchError && onCaughtIssueSearchError(undefined);
        }
    }))));
};
var $b2a9e5a070a2144b$export$2e2bcd8739ae039 = (0, $1igGa.withReportErrors)($b2a9e5a070a2144b$var$IssueResults, {
    id: 'ui.issue-results.unhandled',
    packageName: (0, $6UAdF.PACKAGE_NAME),
    teamName: (0, $6UAdF.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $gcl1l.isLoaderErrorAttributes)
});

});
parcelRegister("4oTzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2140bab55204986$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<edb4dc30383db0f553ab844a357e2afa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f2140bab55204986$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_project"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$f2140bab55204986$var$node.hash = "d2d4ef4e95db7c6e705ce7f23b5f0a5b";
var $f2140bab55204986$export$2e2bcd8739ae039 = $f2140bab55204986$var$node;

});

parcelRegister("erDxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db08798555245e3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4aa67d431503e89ed559c9796911ad7f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9db08798555245e3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_jiraView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "error",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_DetailView_view"
                }
            ],
            "type": "JiraDetailedView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_ListView_view"
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$9db08798555245e3$var$node.hash = "d1bfcbf5b50637766f970894f71c262d";
var $9db08798555245e3$export$2e2bcd8739ae039 = $9db08798555245e3$var$node;

});

parcelRegister("wsH9y", function(module, exports) {

$parcel$export(module.exports, "default", () => $8502fb9eb5f67b01$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4fec987cb83538f5f89e3acf9e28c55d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8502fb9eb5f67b01$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_viewResult",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_ListView_view"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_DetailView_view"
                }
            ],
            "type": "JiraIssueSearchView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                },
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ],
            "type": "QueryError"
        }
    ],
    "type": "JiraIssueSearchViewResult",
    "abstractKey": "__isJiraIssueSearchViewResult"
};
$8502fb9eb5f67b01$var$node.hash = "c62e6e48eccad98fb8d9de957a0d79e9";
var $8502fb9eb5f67b01$export$2e2bcd8739ae039 = $8502fb9eb5f67b01$var$node;

});

parcelRegister("d6cUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b7bc380ba724e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8181ceb1b33ce238044f09e55f544564>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e3b7bc380ba724e0$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_groupResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_groupResults"
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$e3b7bc380ba724e0$var$node.hash = "36093a29e9613109da41814cc200e024";
var $e3b7bc380ba724e0$export$2e2bcd8739ae039 = $e3b7bc380ba724e0$var$node;

});

parcelRegister("1NCNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c580d7f20c072557$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aa8389f903ce63d77257908b2470e26d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c580d7f20c072557$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_issueResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_DetailView_issueResults"
        },
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$c580d7f20c072557$var$node.hash = "b9e1f72cb2da8567d995836882371482";
var $c580d7f20c072557$export$2e2bcd8739ae039 = $c580d7f20c072557$var$node;

});

parcelRegister("6QnB8", function(module, exports) {

$parcel$export(module.exports, "ListViewSkeleton", () => $8f321f8af9d08cfe$export$8465c21c33452ecb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k42jv = parcelRequire("k42jv");
const $8f321f8af9d08cfe$export$8465c21c33452ecb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f321f8af9d08cfe$var$StyledListViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k42jv.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f321f8af9d08cfe$var$StyledListViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k42jv", function(module, exports) {

$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $405e65301287bbc2$export$309a6db85e3f2aaa);
/* NativeIssueTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $8g71g = parcelRequire("8g71g");
const $405e65301287bbc2$var$customCssStyles = null;
const $405e65301287bbc2$var$containerStyles = {
    height: '448px'
};
const $405e65301287bbc2$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8g71g))),
        containerStyles: $405e65301287bbc2$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("8g71g", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});



parcelRegister("krnTs", function(module, exports) {

$parcel$export(module.exports, "SortContainer", () => $5a9a6c0829096e54$export$f2d9f14f583efb1a);
$parcel$export(module.exports, "useSortFieldAndDirection", () => $5a9a6c0829096e54$export$951ead8cec7da319);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $amUxN = parcelRequire("amUxN");
const $5a9a6c0829096e54$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        field: 'created',
        direction: 'DESC'
    },
    actions: {
        setField: (field, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtils: JqlUtils })=>{
                const { field: prevField } = getState();
                if (field !== prevField) {
                    setState({
                        field: field
                    });
                    const newJql = JqlUtils?.jql(jql).setPrimarySortField(field, undefined, aliases).toJql();
                    typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                }
            },
        setFieldAndDirection: (field, direction, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtils: JqlUtils })=>{
                const { field: prevField, direction: prevDirection } = getState();
                if (field !== prevField || direction !== prevDirection) {
                    setState({
                        field: field,
                        direction: direction
                    });
                    if (direction !== 'NONE' || (0, $4R6GH.fg)('jsc_list_reranking_gate')) {
                        const newJql = JqlUtils?.jql(jql).setPrimarySortField(field, direction, aliases).toJql();
                        typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                    }
                }
            }
    },
    name: 'IssueNavigatorSelectedViewState'
});
const $5a9a6c0829096e54$export$f4b3414b22b0750b = ()=>({ getState: getState, setState: setState }, { jql: jql, JqlUtils: JqlUtils })=>{
        const field = JqlUtils?.jql(jql).getPrimarySortField();
        const direction = JqlUtils?.jql(jql).getPrimarySortDirection();
        const { field: prevField, direction: prevDirection } = getState();
        if (field !== prevField || direction !== prevDirection) setState({
            field: field,
            direction: direction
        });
    };
const $5a9a6c0829096e54$export$42a852a2b6b56249 = (0, $gg7kZ.createContainer)($5a9a6c0829096e54$var$Store, {
    onInit: $5a9a6c0829096e54$export$f4b3414b22b0750b,
    onUpdate: $5a9a6c0829096e54$export$f4b3414b22b0750b
});
const $5a9a6c0829096e54$export$f2d9f14f583efb1a = (props)=>{
    const Utils = (0, $amUxN.useJqlUtils)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a9a6c0829096e54$export$42a852a2b6b56249, {
        JqlUtils: Utils,
        ...props
    });
};
const $5a9a6c0829096e54$export$951ead8cec7da319 = (0, $3sQ5x.createHook)($5a9a6c0829096e54$var$Store, {
    selector: ({ field: field, direction: direction })=>({
            field: field,
            direction: direction
        })
});

});
parcelRegister("amUxN", function(module, exports) {

$parcel$export(module.exports, "useJqlUtils", () => $7e8f6b46153d968f$export$c7c2706ff288264f);

var $5uXOq = parcelRequire("5uXOq");

const $7e8f6b46153d968f$export$4a178a021cc96ab5 = async ()=>{
    const module = await (parcelRequire("4UHoK"));
    const { JqlUtils: JqlUtils } = module;
    return new JqlUtils();
};
const $7e8f6b46153d968f$export$c7c2706ff288264f = ()=>{
    const [Utils, setUtils] = (0, $5uXOq.useState)();
    const asyncEffect = async ()=>{
        const ResolvedUtils = await $7e8f6b46153d968f$export$4a178a021cc96ab5();
        setUtils(ResolvedUtils);
    };
    (0, $5uXOq.useEffect)(()=>{
        asyncEffect();
    }, []);
    return Utils;
};

});
parcelRegister("4UHoK", function(module, exports) {

let $393e0e5736ab7a3f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $393e0e5736ab7a3f$var$load("dsheJ").then(()=>parcelRequire('aWG9Z'));

});



parcelRegister("4LmBp", function(module, exports) {

$parcel$export(module.exports, "default", () => $53522b5e6e51bfef$export$2e2bcd8739ae039);

var $dhc4s = parcelRequire("dhc4s");

var $2Vq1u = parcelRequire("2Vq1u");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gcl1l = parcelRequire("gcl1l");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $kYFm9 = parcelRequire("kYFm9");

var $3HwlS = parcelRequire("3HwlS");

var $5oFIy = parcelRequire("5oFIy");

var $imS60 = parcelRequire("imS60");

var $6UAdF = parcelRequire("6UAdF");

var $eojy4 = parcelRequire("eojy4");

var $1igGa = parcelRequire("1igGa");

var $a8lIB = parcelRequire("a8lIB");

var $hWtSW = parcelRequire("hWtSW");

var $428r9 = parcelRequire("428r9");
const $53522b5e6e51bfef$var$ConditionalContentContainer = ({ children: children })=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $53522b5e6e51bfef$var$ContentContainerStyles
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53522b5e6e51bfef$var$ContentStyledContainer, null, children);
const $53522b5e6e51bfef$var$MaybeListElementProvider = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false), (0, $kYFm9.ElementSizeProvider), ({ children: children })=>children);
const $53522b5e6e51bfef$var$DetailView = ({ IssueApp: IssueApp = (0, $eojy4.default), issueResults: issueResults, view: view, ...props })=>{
    const listRef = (0, $5uXOq.useRef)(null);
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_DETAIL_VIEW_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_DETAIL_VIEW_END);
    }, []);
    const detailViewData = (0, $8Uumt.useFragment)((0, $2Vq1u.default), issueResults);
    const viewData = (0, $8Uumt.useFragment)((0, $dhc4s.default), view);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "detail-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53522b5e6e51bfef$var$ConditionalContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53522b5e6e51bfef$var$MaybeListElementProvider, {
        elementRef: listRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWtSW.default), {
        issueResults: detailViewData,
        view: viewData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $428r9.default), {
        fragment: detailViewData,
        ...props,
        listRef: listRef
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueApp, {
        isEmbedView: true,
        issueResults: detailViewData,
        view: viewData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};
// re-render regression detection
$53522b5e6e51bfef$var$DetailView.whyDidYouRender = true;
var $53522b5e6e51bfef$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $1igGa.withReportErrors)($53522b5e6e51bfef$var$DetailView, {
    id: 'ui.issue-results.detail-view.unhandled',
    packageName: (0, $6UAdF.PACKAGE_NAME),
    teamName: (0, $6UAdF.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $gcl1l.isLoaderErrorAttributes)
});
const $53522b5e6e51bfef$var$ContentStyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $53522b5e6e51bfef$var$ContentContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    flexGrow: 1,
    overflow: 'hidden',
    flexBasis: 0
});

});
parcelRegister("dhc4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $105aa14c9d2fd9d2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<413e774d04809c5372ccc3674da92a96>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $105aa14c9d2fd9d2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_DetailView_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cardContainer_issueNavigator_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_view"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$105aa14c9d2fd9d2$var$node.hash = "68ca158b865b96f58c529de1ab919b9b";
var $105aa14c9d2fd9d2$export$2e2bcd8739ae039 = $105aa14c9d2fd9d2$var$node;

});

parcelRegister("2Vq1u", function(module, exports) {

$parcel$export(module.exports, "default", () => $30bc58ed3773e514$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6d20b50d30d33e809ff675bbd13cffa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $30bc58ed3773e514$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_DetailView_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_CardList_fragment"
        },
        {
            "kind": "FragmentSpread",
            "name": "cardContainer_issueNavigator_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$30bc58ed3773e514$var$node.hash = "6b64dddb99a963cc9fea8872d644dae0";
var $30bc58ed3773e514$export$2e2bcd8739ae039 = $30bc58ed3773e514$var$node;

});

parcelRegister("kYFm9", function(module, exports) {

$parcel$export(module.exports, "useElementSizeSelector", () => $9fb6972593b23474$export$6af5bd31f067d7e5);
$parcel$export(module.exports, "ElementSizeProvider", () => $9fb6972593b23474$export$73bf76c50625186);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $9fb6972593b23474$export$e4c0458e30711294 = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0
};
const $9fb6972593b23474$export$638cf470f916deb7 = (0, $gg7kZ.createContainer)({
    getIsConcurrentSafe: ()=>(0, $4R6GH.fg)('jira-concurrent-issue-table-rss-fix')
});
const $9fb6972593b23474$export$3378d8ea7d02abd0 = {
    height: 0,
    width: 0
};
const $9fb6972593b23474$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $9fb6972593b23474$var$Store = (0, $iXqE5.createStore)({
    containedBy: $9fb6972593b23474$export$638cf470f916deb7,
    initialState: $9fb6972593b23474$export$3378d8ea7d02abd0,
    name: 'ElementSize',
    actions: $9fb6972593b23474$var$actions,
    handlers: {
        onInit: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            },
        onContainerUpdate: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            }
    }
});
const $9fb6972593b23474$export$6af5bd31f067d7e5 = (0, $3sQ5x.createStateHook)($9fb6972593b23474$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $9fb6972593b23474$export$2b86bedf890eab8 = (elementRef)=>{
    const [size, setSize] = (0, $5uXOq.useState)($9fb6972593b23474$export$e4c0458e30711294);
    (0, $5uXOq.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                setSize({
                    height: element.clientHeight,
                    width: element.clientWidth,
                    scrollHeight: element.scrollHeight,
                    scrollWidth: element.scrollWidth
                });
            });
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        elementRef
    ]);
    return size;
};
const $9fb6972593b23474$export$73bf76c50625186 = ({ elementRef: elementRef, children: children })=>{
    const { width: width, height: height } = $9fb6972593b23474$export$2b86bedf890eab8(elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9fb6972593b23474$export$638cf470f916deb7, {
        width: width,
        height: height
    }, children);
};

});

parcelRegister("hWtSW", function(module, exports) {

$parcel$export(module.exports, "default", () => $75bb3ad05744ab39$export$2e2bcd8739ae039);

var $86rKB = parcelRequire("86rKB");

var $IXZB0 = parcelRequire("IXZB0");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $i9xcC = parcelRequire("i9xcC");

var $9CFBJ = parcelRequire("9CFBJ");

var $dCm1o = parcelRequire("dCm1o");

var $6UAdF = parcelRequire("6UAdF");

var $cyCoT = parcelRequire("cyCoT");

var $eLt1F = parcelRequire("eLt1F");

var $kj1di = parcelRequire("kj1di");

var $coNDq = parcelRequire("coNDq");

var $gWk5r = parcelRequire("gWk5r");

var $3uIgp = parcelRequire("3uIgp");

var $kwVxA = parcelRequire("kwVxA");
const $75bb3ad05744ab39$var$infiniteScrollOptions = {
    threshold: 350 // Approximately 5 min-height cards tall
};
const $75bb3ad05744ab39$var$CardContainer = ({ children: children, issueResults: issueResults, view: view })=>{
    const data = (0, $8Uumt.useFragment)((0, $IXZB0.default), issueResults);
    if (!(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($75bb3ad05744ab39$var$StyledContainer, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.styled-container",
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($75bb3ad05744ab39$var$HeaderStyledContainer, {
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gWk5r.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kwVxA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eLt1F.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($75bb3ad05744ab39$var$CardListStyledContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($75bb3ad05744ab39$var$FooterStyledContainer, {
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uIgp.default), {
        issueResults: data
    })));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const viewData = (0, $8Uumt.useFragment)((0, $86rKB.default), view);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const fieldSetIds = (0, $5uXOq.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData?.fieldSets?.edges
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    const infiniteScrollProps = (0, $kj1di.useInfiniteScroll)({
        fieldSetIds: fieldSetIds,
        options: $75bb3ad05744ab39$var$infiniteScrollOptions,
        view: (0, $6UAdF.views).detail
    });
    const { isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext } = infiniteScrollProps; // eslint-disable-next-line react-hooks/rules-of-hooks
    const { onScroll: onScroll, onLoadingThresholdCheck: onLoadingThresholdCheck } = (0, $i9xcC.useInfiniteScrollHandler)(infiniteScrollProps); // eslint-disable-next-line react-hooks/rules-of-hooks
    const scrollContainerRef = (0, $5uXOq.useRef)(null);
    const totalIssues = data.totalIssueSearchResultCount ?? 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : 'space.025',
        grow: "fill",
        xcss: (0, $dCm1o.isVisualRefreshEnabled)() ? $75bb3ad05744ab39$var$containerStyles : $75bb3ad05744ab39$var$containerStylesOld,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.styled-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        xcss: (0, $dCm1o.isVisualRefreshEnabled)() ? $75bb3ad05744ab39$var$headerStyles : $75bb3ad05744ab39$var$headerStylesOld,
        alignBlock: (0, $dCm1o.isVisualRefreshEnabled)() ? 'center' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gWk5r.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kwVxA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eLt1F.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CFBJ.ScrollStateProvider), {
        scrollRef: scrollContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        grow: "fill",
        xcss: $75bb3ad05744ab39$var$loadingIndicatorContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: scrollContainerRef,
        xcss: $75bb3ad05744ab39$var$cardListStyles,
        onScroll: onScroll,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.scroll-container"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coNDq.LoadingManager), {
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        onLoadingThresholdCheck: onLoadingThresholdCheck
    }))), totalIssues != null && totalIssues > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $75bb3ad05744ab39$var$footerStyles,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.total-count"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyCoT.default), {
        startIssueRange: -1,
        endIssueRange: -1,
        total: totalIssues,
        countExceedsMaxResults: !!data.isCappingIssueSearchResult,
        loadedIssuesCount: data.edges?.length ?? 0,
        isInfiniteScrollEnabled: true
    })));
};
var $75bb3ad05744ab39$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $75bb3ad05744ab39$var$CardContainer;
const $75bb3ad05744ab39$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _1e0c1txw _2lx21bp4 _otyru2gc _2hwxpxbi _1ul91k99 _p12f1k99",
            __cmplp.visualRefresh ? "_18zrv77o _bfhkqbzx" : "_1yt4v77o _bfhkm7j4",
            __cmplp.className
        ])
    });
});
const $75bb3ad05744ab39$var$containerStylesOld = (0, $8CUq3.xcss)({
    borderRadius: '4px',
    backgroundColor: 'color.background.neutral',
    boxSizing: 'content-box',
    padding: 'space.025',
    marginBottom: 'space.100',
    marginRight: 'space.200',
    minWidth: '256px',
    maxWidth: '256px'
});
const $75bb3ad05744ab39$var$containerStyles = (0, $8CUq3.xcss)({
    borderRadius: '4px',
    backgroundColor: 'elevation.surface.sunken',
    boxSizing: 'content-box',
    paddingInline: 'space.025',
    marginBottom: 'space.100',
    marginRight: 'space.200',
    minWidth: '256px',
    maxWidth: '256px'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75bb3ad05744ab39$var$CardListStyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dl1kxc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75bb3ad05744ab39$var$HeaderStyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _16jlkb7n _1o9zidpf",
            __cmplp.visualRefresh ? "_18zrv77o _4t3i1ylp _4cvr1h6o _otyr1i6y" : "_n3tdv77o _4t3izwfg",
            __cmplp.className
        ])
    });
});
const $75bb3ad05744ab39$var$headerStylesOld = (0, $8CUq3.xcss)({
    flexGrow: 1,
    flexShrink: 0,
    height: '32px' // gridSize * 4
});
const $75bb3ad05744ab39$var$headerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    flexShrink: 0,
    height: '40px',
    marginBottom: 'space.negative.025',
    // Cards require small margin to show box shadow. This negative margin recenters the header.
    paddingInline: 'space.025'
});
const $75bb3ad05744ab39$var$loadingIndicatorContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: '1',
    flexShrink: '1',
    flexBasis: '100vh',
    overflow: 'hidden',
    position: 'relative' // Required in order to contain loading indicator
});
const $75bb3ad05744ab39$var$cardListStyles = (0, $8CUq3.xcss)({
    flexGrow: '1',
    overflow: 'auto'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75bb3ad05744ab39$var$FooterStyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.visualRefresh ? "_18zrv77o _ca0qv77o" : "_1yt4sb0y",
            __cmplp.className
        ])
    });
});
const $75bb3ad05744ab39$var$footerStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    paddingBlock: 'space.050',
    textAlign: 'center'
});

});
parcelRegister("86rKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $76f82c5b1530b1f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2370cbb0fa87f162f80e407b99684c0a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $76f82c5b1530b1f8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        }
    ],
    "kind": "Fragment",
    "name": "cardContainer_issueNavigator_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$76f82c5b1530b1f8$var$node.hash = "362c3df8b74e5c6a720697f0b7357b9f";
var $76f82c5b1530b1f8$export$2e2bcd8739ae039 = $76f82c5b1530b1f8$var$node;

});

parcelRegister("IXZB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83319da6aeba2fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<25d5caf50e68879c6d4de98b651c3a5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e83319da6aeba2fb$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "cardContainer_issueNavigator_issueResults",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_Paginator"
                }
            ]
        },
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$e83319da6aeba2fb$var$node.hash = "f8c6651dc7a2f7ffc8476a5456e66a48";
var $e83319da6aeba2fb$export$2e2bcd8739ae039 = $e83319da6aeba2fb$var$node;

});

parcelRegister("i9xcC", function(module, exports) {

$parcel$export(module.exports, "useInfiniteScrollHandler", () => $b2b86989bea72b31$export$ee8d81e7d8c9f22d);

var $5uXOq = parcelRequire("5uXOq");

var $czfFt = parcelRequire("czfFt");

var $dbaUr = parcelRequire("dbaUr");
const $b2b86989bea72b31$var$DEFAULT_ACTIVATION_THRESHOLD = 10 * (0, $czfFt.ROW_HEIGHT);
const $b2b86989bea72b31$export$ee8d81e7d8c9f22d = ({ onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...dataProps })=>{
    // Keep props as ref so the callback is stable across rerenders.
    const dataPropsRef = (0, $5uXOq.useRef)(dataProps);
    dataPropsRef.current = dataProps;
    const onLoadNext = (0, $dbaUr.useThrottle)(onLoadNextProp);
    const onLoadPrevious = (0, $dbaUr.useThrottle)(onLoadPreviousProp);
    const onLoadingThresholdCheck = (0, $5uXOq.useCallback)(({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop })=>{
        const { isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold = $b2b86989bea72b31$var$DEFAULT_ACTIVATION_THRESHOLD } = dataPropsRef.current;
        const scrollBottom = scrollHeight - clientHeight - scrollTop;
        const isLoading = isLoadingNext || isLoadingPrevious;
        // Prioritising loading next over loading previous to fill results downwards first,
        // to hopefully feel more natural.
        if (hasNext && !isLoading && scrollBottom <= activationThreshold) onLoadNext?.();
        else if (hasPrevious && !isLoading && scrollTop <= activationThreshold) onLoadPrevious?.();
    }, // Ensure that the callback is not recreated when props change.
    // onLoadNext & onLoadPrevious should be throttled & stable.
    [
        onLoadNext,
        onLoadPrevious
    ]);
    const onScroll = (0, $5uXOq.useCallback)((event)=>{
        onLoadingThresholdCheck(event.currentTarget);
    }, // Ensure that the callback is not recreated when props change.
    // onLoadingThresholdCheck should be stable.
    [
        onLoadingThresholdCheck
    ]);
    return {
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        onScroll: onScroll
    };
};

});
parcelRegister("dbaUr", function(module, exports) {

$parcel$export(module.exports, "useThrottle", () => $9793367875371ab2$export$8b7b9481d6186f21);

var $5uXOq = parcelRequire("5uXOq");
const $9793367875371ab2$export$8b7b9481d6186f21 = (fn, wait = 100)=>{
    const fnRef = (0, $5uXOq.useRef)(fn);
    fnRef.current = fn;
    const waitRef = (0, $5uXOq.useRef)(wait);
    waitRef.current = wait;
    const timeout = (0, $5uXOq.useRef)(undefined);
    const throttled = (0, $5uXOq.useCallback)(()=>{
        if (timeout.current !== undefined) return;
        fnRef.current?.();
        timeout.current = setTimeout(()=>{
            timeout.current = undefined;
        }, waitRef.current);
    // Ensure the callback is not recreated when props change,
    // dependency array should be empty.
    }, []);
    // Cleanup the timeout on unmount.
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (timeout.current !== undefined) clearTimeout(timeout.current);
        };
    }, []);
    return throttled;
};

});


parcelRegister("9CFBJ", function(module, exports) {

$parcel$export(module.exports, "useScrollStateSelector", () => $502b0ac1011ec6e7$export$a2d79f83724ed591);
$parcel$export(module.exports, "useScrollElement", () => $502b0ac1011ec6e7$export$fae04c81b2201f65);
$parcel$export(module.exports, "ScrollStateProvider", () => $502b0ac1011ec6e7$export$9f9741e7dc6bdb9b);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");
const $502b0ac1011ec6e7$export$50b6b7783d156e1b = 200;
const $502b0ac1011ec6e7$export$f9abcb6f103965a2 = (0, $gg7kZ.createContainer)();
const $502b0ac1011ec6e7$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $502b0ac1011ec6e7$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $502b0ac1011ec6e7$var$Store = (0, $iXqE5.createStore)({
    containedBy: $502b0ac1011ec6e7$export$f9abcb6f103965a2,
    initialState: $502b0ac1011ec6e7$var$INITIAL_SCROLL_STATE,
    name: 'ScrollStateManager',
    actions: $502b0ac1011ec6e7$var$actions
});
const $502b0ac1011ec6e7$var$useScrollStateActions = (0, $3sQ5x.createActionsHook)($502b0ac1011ec6e7$var$Store);
const $502b0ac1011ec6e7$export$a2d79f83724ed591 = (0, $3sQ5x.createStateHook)($502b0ac1011ec6e7$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $502b0ac1011ec6e7$export$fae04c81b2201f65 = (0, $3sQ5x.createStateHook)($502b0ac1011ec6e7$var$Store, {
    selector: (state)=>state.scrollElement
});
const $502b0ac1011ec6e7$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $502b0ac1011ec6e7$var$useElementScrollState = (scrollRef)=>{
    const { update: update } = $502b0ac1011ec6e7$var$useScrollStateActions();
    (0, $5uXOq.useEffect)(()=>{
        const targetEl = scrollRef.current;
        // The element should always exists as the useEffect triggers after the reference is assigned.
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            update({
                ...(0, $4R6GH.fg)('jsc-1388-fix-drop-indicator-not-moving-with-scroll') && {
                    scrollWidth: targetEl.scrollWidth
                },
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    ...(0, $4R6GH.fg)('jsc-1388-fix-drop-indicator-not-moving-with-scroll') && {
                        scrollWidth: targetEl.scrollWidth
                    },
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $502b0ac1011ec6e7$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            update({
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                height: targetEl.clientHeight,
                width: targetEl.clientWidth,
                scrollHeight: targetEl.scrollHeight,
                scrollWidth: targetEl.scrollWidth,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $502b0ac1011ec6e7$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $502b0ac1011ec6e7$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        update({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef,
        update
    ]);
};
const $502b0ac1011ec6e7$var$ScrollStateProviderInner = ({ scrollRef: scrollRef, children: children })=>{
    $502b0ac1011ec6e7$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $502b0ac1011ec6e7$export$9f9741e7dc6bdb9b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($502b0ac1011ec6e7$export$f9abcb6f103965a2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($502b0ac1011ec6e7$var$ScrollStateProviderInner, props));
};

});

parcelRegister("cyCoT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb075bc3ee6def7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $79uRg = parcelRequire("79uRg");

var $b71Xi = parcelRequire("b71Xi");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8cb075bc3ee6def7$export$2e2bcd8739ae039 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, loadedIssuesCount: loadedIssuesCount, total: total, countExceedsMaxResults: countExceedsMaxResults, isInfiniteScrollEnabled: isInfiniteScrollEnabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isTotalUnknown = total <= 0;
    if (isInfiniteScrollEnabled) {
        if (isTotalUnknown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, loadedIssuesCount);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79uRg.default), {
            prependMessage: (0, $b71Xi.default).loadedIssuesTotalKnown,
            prependMessageValues: {
                loadedIssuesCount: loadedIssuesCount
            },
            stableCount: total,
            isCapped: countExceedsMaxResults
        });
    }
    if (isTotalUnknown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $b71Xi.default).issueRangeUnknown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79uRg.default), {
        prependMessage: (0, $b71Xi.default).issueRangeKnown,
        prependMessageValues: {
            startIssueRange: startIssueRange,
            endIssueRange: endIssueRange
        },
        stableCount: total,
        isCapped: countExceedsMaxResults
    });
};

});
parcelRegister("b71Xi", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9773df3a4a055b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $db9773df3a4a055b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadedIssuesTotalKnown: {
        "id": "issue-navigator.common.page-text.loaded-issues-total-known",
        "defaultMessage": "{loadedIssuesCount} of {totalNumberIssues}"
    },
    issueRangeKnown: {
        "id": "issue-navigator.card-container.paginator.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "issue-navigator.card-container.paginator.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});

});


parcelRegister("eLt1F", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5cafba943267706$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $jOrGg = parcelRequire("jOrGg");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $isIOR = parcelRequire("isIOR");

var $38r5c = parcelRequire("38r5c");

var $lrrHu = parcelRequire("lrrHu");
const $b5cafba943267706$var$RefreshButton = ()=>{
    let isRefreshing;
    let onRefresh;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        isRefreshing = (0, $38r5c.useIsRefreshing)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ onRefresh: onRefresh } = (0, $38r5c.useIssueSearchActions)());
    } else // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ isRefreshing: isRefreshing, onIssueSearchRefresh: onRefresh } = (0, $isIOR.useIssueSearchQuery)());
    const handleClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'reloadIssueListButton');
        onRefresh();
    }, [
        onRefresh
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        onClick: handleClick,
        testId: "issue-navigator.common.ui.refresh-button.refresh-button",
        label: formatMessage((0, $lrrHu.default).tooltip),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOrGg))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #626F86)",
                LEGACY_size: "small",
                LEGACY_primaryColor: "color.icon.subtle"
            }),
        isLoading: isRefreshing
    });
};
var $b5cafba943267706$export$2e2bcd8739ae039 = $b5cafba943267706$var$RefreshButton;

});
parcelRegister("jOrGg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97b7deedaffb04632472c93b0c8f5452>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6c828a42ee64c30$var$_react = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6c828a42ee64c30$var$_refresh = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("gPelT")));

var $e6c828a42ee64c30$var$_refresh2 = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("75Jbm")));
function $e6c828a42ee64c30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6c828a42ee64c30$var$RefreshIcon = (props)=>/*#__PURE__*/ $e6c828a42ee64c30$var$_react.default.createElement($e6c828a42ee64c30$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $e6c828a42ee64c30$var$_refresh2.default
    }, props));
$e6c828a42ee64c30$var$RefreshIcon.Name = 'RefreshIconMigration';
var $e6c828a42ee64c30$var$_default = module.exports.default = $e6c828a42ee64c30$var$RefreshIcon;

});
parcelRegister("gPelT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::688997f0a16a41562042ca280fe15628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3fc8ad083e2745c$var$_react = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3fc8ad083e2745c$var$_baseNew = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c3fc8ad083e2745c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3fc8ad083e2745c$var$RefreshIcon = (props)=>/*#__PURE__*/ $c3fc8ad083e2745c$var$_react.default.createElement($c3fc8ad083e2745c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$c3fc8ad083e2745c$var$RefreshIcon.displayName = 'RefreshIcon';
var $c3fc8ad083e2745c$var$_default = module.exports.default = $c3fc8ad083e2745c$var$RefreshIcon;

});

parcelRegister("75Jbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $529c0c456318696f$var$_react = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $529c0c456318696f$var$_refresh = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("gPelT")));
function $529c0c456318696f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $529c0c456318696f$var$RefreshIcon = (props)=>/*#__PURE__*/ $529c0c456318696f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $529c0c456318696f$var$_refresh.default
    }));
$529c0c456318696f$var$RefreshIcon.displayName = 'RefreshIcon';
var $529c0c456318696f$var$_default = module.exports.default = $529c0c456318696f$var$RefreshIcon;

});


parcelRegister("lrrHu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d0ea2577d797cdc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var // TODO - Port i18n string translations to new module ID keys
$3d0ea2577d797cdc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "issue-navigator.refresh-button.tooltip",
        "defaultMessage": "Refresh"
    },
    loading: {
        "id": "issue-navigator.refresh-button.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("coNDq", function(module, exports) {

$parcel$export(module.exports, "LoadingManager", () => $af47037513790f77$export$99cc795e99919eed);

var $5uXOq = parcelRequire("5uXOq");

var $dqoiX = parcelRequire("dqoiX");

var $koVbs = parcelRequire("koVbs");

var $kYFm9 = parcelRequire("kYFm9");

var $9CFBJ = parcelRequire("9CFBJ");

var $1XJ20 = parcelRequire("1XJ20");

var $4R6GH = parcelRequire("4R6GH");

var $50QiF = parcelRequire("50QiF");

var $arPIt = parcelRequire("arPIt");
const $af47037513790f77$export$99cc795e99919eed = ({ isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext, onLoadingThresholdCheck: onLoadingThresholdCheck })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // List has height 0 during first render due to virtualization. Some checks need to wait for the list to have a height.
    const hasListHeight = (0, $kYFm9.useElementSizeSelector)((listElm)=>Boolean(listElm.height));
    const scrollContainerHeight = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>scrollState.height);
    const scrollElement = (0, $9CFBJ.useScrollElement)();
    // #region After-load Handler
    /**
   * After initial render and any subsequent loading events, make sure that we continue loading in more issues if
   * necessary because a single load may not have enough issues to fill the scroll container.
   */ (0, $5uXOq.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasListHeight && !isLoadingPrevious && !isLoadingNext) onLoadingThresholdCheck(scrollElement);
    }, [
        hasListHeight,
        isLoadingPrevious,
        isLoadingNext,
        onLoadingThresholdCheck,
        scrollElement
    ]);
    // #endregion
    // #region Resize Handler
    /**
   * Check the loading boundaries when resizing the scroll container, as the new size may require loading more issues.
   */ const prevHeight = (0, $1XJ20.usePreviousWithInitial)(scrollContainerHeight);
    (0, $5uXOq.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasListHeight && scrollContainerHeight > prevHeight) onLoadingThresholdCheck(scrollElement);
    }, [
        hasListHeight,
        scrollContainerHeight,
        prevHeight,
        onLoadingThresholdCheck,
        scrollElement
    ]);
    // #endregion
    // #region Top Scroll Handler
    /**
   * A component that ensures that the scroll position is kept stable when loading previous issues.
   * This is necessary because sometimes the browser does scroll to keep existing rows in view when new rows are prepended.
   *
   * Without this, we may see issues like continuously loading all previous issues until there are none left.
   */ const prevIsLoadingPrevious = (0, $1XJ20.usePreviousWithInitial)(isLoadingPrevious);
    const hasStartedLoadingPrevious = !prevIsLoadingPrevious && isLoadingPrevious;
    const hasFinishedLoadingPrevious = prevIsLoadingPrevious && !isLoadingPrevious;
    // Hook's scrollHeight doesn't update the height information when the scroll height changes due to DOM mutations
    // Need to track this separately when loading starts
    const scrollHeightRef = (0, $5uXOq.useRef)(0);
    (0, $5uXOq.useEffect)(()=>{
        if (scrollElement && hasStartedLoadingPrevious) scrollHeightRef.current = scrollElement.scrollHeight;
    }, [
        hasStartedLoadingPrevious,
        scrollElement
    ]);
    // Ensure that the scroll is kept in place after loading previous issues - browser doesn't always handle this properly
    // Using a layout effect to make sure this happens as quickly as possible to reduce visible movement
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (scrollElement && hasFinishedLoadingPrevious) {
            const newScrollHeight = scrollElement.scrollHeight;
            if (newScrollHeight > scrollHeightRef.current) {
                const heightIncrease = newScrollHeight - scrollHeightRef.current;
                scrollElement.scrollBy(0, heightIncrease);
            }
            scrollHeightRef.current = newScrollHeight;
        }
    }, [
        hasFinishedLoadingPrevious,
        scrollElement
    ]);
    // #endregion
    // #region Loading A11y
    const prevIsLoadingNext = (0, $1XJ20.usePreviousWithInitial)(isLoadingNext);
    const hasFinishedLoadingNext = prevIsLoadingNext && !isLoadingNext;
    const loadingCompleteLiveMessage = (0, $5uXOq.useRef)(undefined);
    if (isLoadingPrevious) loadingCompleteLiveMessage.current = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $arPIt.default).loadStartA11YMessageTopIssueTermRefresh : (0, $arPIt.default).loadStartA11YMessageTop;
    else if (hasFinishedLoadingPrevious) loadingCompleteLiveMessage.current = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $arPIt.default).loadEndA11YMessageTopIssueTermRefresh : (0, $arPIt.default).loadEndA11YMessageTop;
    else if (isLoadingNext) loadingCompleteLiveMessage.current = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $arPIt.default).loadStartA11YMessageBottomIssueTermRefresh : (0, $arPIt.default).loadStartA11YMessageBottom;
    else if (hasFinishedLoadingNext) loadingCompleteLiveMessage.current = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $arPIt.default).loadEndA11YMessageBottomIssueTermRefresh : (0, $arPIt.default).loadEndA11YMessageBottom;
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isLoadingPrevious && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50QiF.LoadingIndicator), {
        position: "top"
    }), isLoadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50QiF.LoadingIndicator), {
        position: "bottom"
    }), loadingCompleteLiveMessage.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, formatMessage(loadingCompleteLiveMessage.current)));
};

});
parcelRegister("50QiF", function(module, exports) {

$parcel$export(module.exports, "LoadingIndicator", () => $143e097710c21fde$export$7c20be4c1d342248);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $kAT4r = parcelRequire("kAT4r");
const $143e097710c21fde$export$7c20be4c1d342248 = ({ position: position })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "center",
        xcss: [
            $143e097710c21fde$var$containerStyles,
            position === 'top' ? $143e097710c21fde$var$positionTopStyles : $143e097710c21fde$var$positionBottomStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "hug",
        xcss: $143e097710c21fde$var$loadingIndicatorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        appearance: "invert",
        size: "small",
        interactionName: (0, $4R6GH.fg)('add_nin_press_interactions') ? 'nin-detail-view-infinite-scroll-loading' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.inverse"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $kAT4r.default).loadingMessageIssueTermRefresh : (0, $kAT4r.default).loadingMessage))));
};
const $143e097710c21fde$var$positionTopStyles = (0, $8CUq3.xcss)({
    top: 'space.0'
});
const $143e097710c21fde$var$positionBottomStyles = (0, $8CUq3.xcss)({
    bottom: 'space.0'
});
const $143e097710c21fde$var$loadingIndicatorStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text.inverse',
    marginBlock: 'space.200',
    padding: 'space.100'
});
const $143e097710c21fde$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    width: '100%'
});

});
parcelRegister("kAT4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $da5373b4b1dc1638$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $da5373b4b1dc1638$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadingMessage: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.loading-indicator.loading-message",
        "defaultMessage": "Loading more issues"
    },
    loadingMessageIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.loading-indicator.loading-message-issue-term-refresh",
        "defaultMessage": "Loading more work items"
    }
});

});


parcelRegister("arPIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d111789e86749f72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d111789e86749f72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadStartA11YMessageTop: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-top",
        "defaultMessage": "Loading more issues at the top of the list."
    },
    loadEndA11YMessageTop: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-top",
        "defaultMessage": "Finished loading more issues at the top of the list."
    },
    loadStartA11YMessageBottom: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-bottom",
        "defaultMessage": "Loading more issues at the bottom of the list."
    },
    loadEndA11YMessageBottom: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-bottom",
        "defaultMessage": "Finished loading more issues at the bottom of the list."
    },
    loadStartA11YMessageTopIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Loading more work items at the top of the list."
    },
    loadEndA11YMessageTopIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the top of the list."
    },
    loadStartA11YMessageBottomIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Loading more work items at the bottom of the list."
    },
    loadEndA11YMessageBottomIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the bottom of the list."
    }
});

});


parcelRegister("gWk5r", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ad171d10df24f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $a5n5E = parcelRequire("a5n5E");
var $b2TJP = parcelRequire("b2TJP");

var $c8Oei = parcelRequire("c8Oei");

var $8oe80 = parcelRequire("8oe80");

var $6s1PB = parcelRequire("6s1PB");

var $aWse0 = parcelRequire("aWse0");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $63r1u = parcelRequire("63r1u");

var $krnTs = parcelRequire("krnTs");

var $5NdVO = parcelRequire("5NdVO");
const $8e8ad171d10df24f$export$e813e910f52c9aab = {
    appearance: 'subtle',
    'data-testid': 'issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown.button'
};
const $8e8ad171d10df24f$var$customFieldIdPattern = /^cf\[\d+\]$/;
const $8e8ad171d10df24f$var$DropdownItemRadioWithAnalytics = (0, $8oe80.default)('dropdownItemRadio', {
    onClick: 'clicked'
})((0, $a5n5E.default));
class $8e8ad171d10df24f$export$50f2c227513bcdb7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    onItemClick(order, aliases) {
        const { onChange: onChange, onBlur: onBlur } = this.props;
        onChange(order, aliases);
        onBlur();
    }
    renderItems() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField } = this.props;
        return Object.values((0, $6UAdF.supportedOrderFields)).filter((0, $eJ0Zs.isNonNullish)).map(({ jqlTerm: jqlTerm, aliases: aliases })=>{
            let jqlTermForMessage = jqlTerm;
            if ([
                'issuetype'
            ].includes(jqlTermForMessage)) jqlTermForMessage = `${jqlTerm}${(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? 'IssueTermRefresh' : ''}`;
            const messageDescriptor = (0, $5NdVO.messageLookup)[jqlTermForMessage];
            const fieldName = messageDescriptor ? formatMessage(messageDescriptor) : jqlTerm;
            const props = {
                id: jqlTerm,
                onClick: ()=>{
                    this.onItemClick(jqlTerm, aliases);
                },
                isSelected: jqlTerm === orderField || orderField && aliases.includes(orderField)
            };
            return /* @ts-expect-error - Type '{ children: string; id: string; onClick: () => void; isSelected: boolean | "" | undefined; key: string; }' is not assignable to type 'Omit<{ children: ReactNode; description?: string | Element | undefined; isDisabled?: boolean | undefined; shouldTitleWrap?: boolean | undefined; shouldDescriptionWrap?: boolean | undefined; ... 5 more ...; testId?: string | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e8ad171d10df24f$var$DropdownItemRadioWithAnalytics, {
                key: jqlTerm,
                ...props
            }, fieldName);
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField, isOpen: isOpen, className: className } = this.props;
        let fallbackMessage = '';
        let fieldName = '';
        if (typeof orderField === 'string') {
            const isCustomFieldId = $8e8ad171d10df24f$var$customFieldIdPattern.test(orderField);
            const expectedOrderField = (0, $6UAdF.supportedOrderFields)[(0, $6UAdF.getSupportedFieldForAlias)(orderField) ?? orderField];
            const fallbackMessageDescriptor = expectedOrderField ? (0, $5NdVO.messageLookup)[expectedOrderField.jqlTerm] : null;
            if (isCustomFieldId) fallbackMessage = formatMessage((0, $5NdVO.default).customField);
            else if (expectedOrderField && fallbackMessageDescriptor) fallbackMessage = formatMessage(fallbackMessageDescriptor);
            else fieldName = orderField;
        } else fallbackMessage = formatMessage((0, $5NdVO.default).defaultLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e8ad171d10df24f$var$StyledContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown",
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e8ad171d10df24f$var$StyledButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    ...props,
                    appearance: "subtle",
                    ref: triggerRef,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                        label: formatMessage((0, $5NdVO.default).defaultLabel)
                    })
                }, fieldName || fallbackMessage)),
            shouldFlip: true,
            placement: "bottom-start",
            shouldRenderToParent: (0, $4R6GH.fg)('empanada_order_dropdown_render_to_parent')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e8ad171d10df24f$var$StyledDropdownMenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b2TJP.default), {
            id: "sort-field-group",
            title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5NdVO.default).fieldGroupIssueTermRefresh : (0, $5NdVO.default).fieldGroup)
        }, this.renderItems()))));
    }
    constructor(...args){
        super(...args), this.onOpenChange = ({ isOpen: isOpen } = {
            isOpen: false
        })=>{
            if (isOpen) this.props.onFocus();
            else this.props.onBlur();
        };
    }
}
const $8e8ad171d10df24f$export$f6d8103ec9453c7f = ()=>{
    const [{ isOpen: isOpen }, { open: open, close: close }] = (0, $63r1u.useOrderByOpenState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const intl = (0, $aWse0.useIntlV2)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $krnTs.useSortFieldAndDirection)();
    const handleOnChange = (0, $5uXOq.useCallback)((orderField, aliases)=>{
        setFieldAndDirection(orderField, direction, aliases);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItemRadio'
        });
        const { fieldType: fieldType = null } = (0, $6UAdF.supportedOrderFields)[(0, $6UAdF.getSupportedFieldForAlias)(orderField) ?? orderField] ?? {};
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sortFieldDropdownItemRadio', {
            fieldType: fieldType,
            order: direction
        });
    }, [
        createAnalyticsEvent,
        direction,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e8ad171d10df24f$export$50f2c227513bcdb7, {
        orderField: field,
        onChange: handleOnChange,
        isOpen: isOpen,
        onFocus: open,
        onBlur: close,
        intl: intl
    });
};
var $8e8ad171d10df24f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
 = $8e8ad171d10df24f$export$f6d8103ec9453c7f;
const $8e8ad171d10df24f$var$StyledButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1s3g12gs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8ad171d10df24f$var$StyledDropdownMenuContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3inklw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8ad171d10df24f$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("63r1u", function(module, exports) {

$parcel$export(module.exports, "useOrderByOpenState", () => $eaf17a9c035669f9$export$32869ae0582ab3ff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $eaf17a9c035669f9$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'IssueNavigatorOrderByOpenState'
});
const $eaf17a9c035669f9$export$2ba8216bf1290828 = (0, $51nlc.createSubscriber)($eaf17a9c035669f9$var$Store);
const $eaf17a9c035669f9$export$32869ae0582ab3ff = (0, $3sQ5x.createHook)($eaf17a9c035669f9$var$Store);

});

parcelRegister("5NdVO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d30701c7e9a99b3c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $d30701c7e9a99b3c$export$3a16bd55b6aaaf91);

var $7VHMR = parcelRequire("7VHMR");
const $d30701c7e9a99b3c$var$messages = (0, $7VHMR.defineMessages)({
    loading: {
        "id": "issue-navigator.card-container.order-dropdown.loading",
        "defaultMessage": "Loading"
    },
    fieldGroup: {
        "id": "issue-navigator.card-container.order-dropdown.field-group",
        "defaultMessage": "Order issues by"
    },
    created: {
        "id": "issue-navigator.card-container.order-dropdown.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "issue-navigator.card-container.order-dropdown.updated",
        "defaultMessage": "Updated"
    },
    lastviewed: {
        "id": "issue-navigator.card-container.order-dropdown.lastviewed",
        "defaultMessage": "Last viewed"
    },
    status: {
        "id": "issue-navigator.card-container.order-dropdown.status",
        "defaultMessage": "Status"
    },
    priority: {
        "id": "issue-navigator.card-container.order-dropdown.priority",
        "defaultMessage": "Priority"
    },
    assignee: {
        "id": "issue-navigator.card-container.order-dropdown.assignee",
        "defaultMessage": "Assignee"
    },
    resolved: {
        "id": "issue-navigator.card-container.order-dropdown.resolved",
        "defaultMessage": "Resolved"
    },
    issuekey: {
        "id": "issue-navigator.card-container.order-dropdown.issuekey",
        "defaultMessage": "Key"
    },
    key: {
        "id": "issue-navigator.card-container.order-dropdown.key",
        "defaultMessage": "Key"
    },
    issuetype: {
        "id": "issue-navigator.card-container.order-dropdown.issuetype",
        "defaultMessage": "Issue Type"
    },
    duedate: {
        "id": "issue-navigator.card-container.order-dropdown.duedate",
        "defaultMessage": "Due date"
    },
    summary: {
        "id": "issue-navigator.card-container.order-dropdown.summary",
        "defaultMessage": "Summary"
    },
    reporter: {
        "id": "issue-navigator.card-container.order-dropdown.reporter",
        "defaultMessage": "Reporter"
    },
    customField: {
        "id": "issue-navigator.card-container.order-dropdown.custom-field",
        "defaultMessage": "Custom field"
    },
    defaultLabel: {
        "id": "issue-navigator.card-container.order-dropdown.default-label",
        "defaultMessage": "Order by"
    },
    fieldGroupIssueTermRefresh: {
        "id": "issue-navigator.card-container.order-dropdown.field-group-issue-term-refresh",
        "defaultMessage": "Order work items by"
    },
    issuetypeIssueTermRefresh: {
        "id": "issue-navigator.card-container.order-dropdown.issuetype-issue-term-refresh",
        "defaultMessage": "Work type"
    }
});
var $d30701c7e9a99b3c$export$2e2bcd8739ae039 = $d30701c7e9a99b3c$var$messages;
const $d30701c7e9a99b3c$export$3a16bd55b6aaaf91 = $d30701c7e9a99b3c$var$messages;

});


parcelRegister("3uIgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $45da2bcc5731351b$export$2e2bcd8739ae039);

var $cVNGL = parcelRequire("cVNGL");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $fmJTX = parcelRequire("fmJTX");

var $6s76W = parcelRequire("6s76W");

var $3bDjY = parcelRequire("3bDjY");

var $3Tty1 = parcelRequire("3Tty1");

var $jQtKF = parcelRequire("jQtKF");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cyCoT = parcelRequire("cyCoT");

var $isIOR = parcelRequire("isIOR");

var $acq6k = parcelRequire("acq6k");
const $45da2bcc5731351b$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $45da2bcc5731351b$var$getPageCursor = (pageCursors, page)=>{
    const { first: first, last: last, around: around } = pageCursors ?? {};
    if (page === first?.pageNumber) return first?.cursor ?? undefined;
    if (page === last?.pageNumber) return last?.cursor ?? undefined;
    return around?.find((pageCursor)=>page === pageCursor?.pageNumber)?.cursor ?? undefined;
};
const $45da2bcc5731351b$var$TooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45da2bcc5731351b$var$StyledTooltipTag, {
        ref: ref,
        ...props
    })); // TODO Remove when cleaning up jira_spreadsheet_component_m1
const $45da2bcc5731351b$var$Paginator = ({ issueResults: issueResults })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.useFragment)((0, $cVNGL.default), issueResults);
    const currentPage = data.pageCursors?.around?.find((pageCursor)=>pageCursor?.isCurrent)?.pageNumber ?? 1;
    const lastPage = $45da2bcc5731351b$var$getLastPage(data.pageCursors) ?? 1;
    const { isFetching: isFetching, isStalePage: isStalePage, onIssueSearchForPage: onIssueSearchForPage } = (0, $isIOR.useIssueSearchQuery)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onChange = (0, $5uXOq.useCallback)((pageNumber)=>{
        // @ts-expect-error - Argument of type '{ readonly around: readonly ({ readonly cursor: string | null | undefined; readonly isCurrent: boolean | null | undefined; readonly pageNumber: number | null | undefined; } | null | undefined)[] | null | undefined; readonly first: { ...; } | ... 1 more ... | undefined; readonly last: { ...; } | ... 1 more ... | unde...' is not assignable to parameter of type '{ readonly around: readonly ({ readonly cursor: string | null | undefined; readonly isCurrent: boolean | null | undefined; readonly pageNumber: number | null | undefined; } | null | undefined)[] | null | undefined; readonly first: { ...; } | ... 1 more ... | undefined; readonly last: { ...; } | ... 1 more ... | unde...'.
        const pageCursor = $45da2bcc5731351b$var$getPageCursor(data.pageCursors, pageNumber);
        if (pageCursor == null) return;
        onIssueSearchForPage(pageCursor);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'pageNumber'
        }), 'issueListPagination', {
            currentPage: currentPage,
            nextPage: pageNumber
        });
    }, [
        data.pageCursors,
        onIssueSearchForPage,
        createAnalyticsEvent,
        currentPage
    ]);
    const onChangePrevious = (0, $5uXOq.useCallback)(()=>onChange(currentPage - 1), [
        currentPage,
        onChange
    ]);
    const onChangeNext = (0, $5uXOq.useCallback)(()=>onChange(currentPage + 1), [
        currentPage,
        onChange
    ]);
    const keyMap = (0, $5uXOq.useMemo)(()=>({
            arrowleft: {
                callback: onChangePrevious,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $acq6k.default).nextPageShortcutLabel))
            },
            arrowright: {
                callback: onChangeNext,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $acq6k.default).prevPageShortcutLabel))
            }
        }), [
        formatMessage,
        onChangeNext,
        onChangePrevious
    ]);
    const totalIssues = data.totalIssueSearchResultCount ?? 0;
    if (totalIssues === 0 || isFetching || isStalePage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45da2bcc5731351b$var$StyledContainer, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.paginator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fmJTX))), {
            spacing: "spacious",
            label: formatMessage((0, $acq6k.default).prevPageButton)
        }),
        appearance: "subtle",
        onClick: onChangePrevious,
        isDisabled: currentPage === 1,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.paginator.prev-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($45da2bcc5731351b$var$PageAndCountContainer, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.paginator.div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyCoT.default), {
        startIssueRange: data.issueNavigatorPageInfo?.firstIssuePosition ?? 0,
        endIssueRange: data.issueNavigatorPageInfo?.lastIssuePosition ?? 0,
        total: totalIssues,
        countExceedsMaxResults: !!data.isCappingIssueSearchResult,
        loadedIssuesCount: -1,
        isInfiniteScrollEnabled: false
    })), currentPage === lastPage && data?.isCappingIssueSearchResult ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $acq6k.default).disabledButtonTooltipIssueTermRefresh : (0, $acq6k.default).disabledButtonTooltip),
        tag: $45da2bcc5731351b$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jQtKF.default), {
        tabIndex: 0,
        isDisabled: true,
        "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $acq6k.default).disabledButtonTooltipIssueTermRefresh : (0, $acq6k.default).disabledButtonTooltip),
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-container.paginator.next-disabled-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6s76W))), {
            spacing: "spacious",
            label: formatMessage((0, $acq6k.default).nextPageButton)
        }),
        appearance: "subtle",
        isDisabled: true,
        onClick: onChangeNext,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.paginator.next-button"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6s76W))), {
            spacing: "spacious",
            label: formatMessage((0, $acq6k.default).nextPageButton)
        }),
        appearance: "subtle",
        isDisabled: currentPage === lastPage,
        onClick: onChangeNext,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.paginator.next-button"
    }));
};
var $45da2bcc5731351b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $45da2bcc5731351b$var$Paginator;
const $45da2bcc5731351b$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1yb4 _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45da2bcc5731351b$var$PageAndCountContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45da2bcc5731351b$var$StyledTooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cVNGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f871d130665c9b22$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<eac20d88dcaa529e2cd27fff9885a4df>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f871d130665c9b22$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "cursor"
        },
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrent"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_issueNavigator_Paginator",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            {
                "kind": "ScalarField",
                "name": "isCappingIssueSearchResult"
            },
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "lastIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "first",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$f871d130665c9b22$var$node.hash = "a148b81aa698fb69850df944c78ece55";
var $f871d130665c9b22$export$2e2bcd8739ae039 = $f871d130665c9b22$var$node;

});

parcelRegister("fmJTX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8f114aeec843a8c754b38083d324c3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));

var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
function $b2fc843461eabf96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
    }, props));
$b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;

});
parcelRegister("a88oa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
function $7601289634e055f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $7601289634e055f6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $7601289634e055f6$var$_chevronLeft.default,
        iconType: "utility"
    }));
$7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;

});


parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default,
        iconType: "utility"
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


parcelRegister("acq6k", function(module, exports) {

$parcel$export(module.exports, "default", () => $049a94890312f7fb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $049a94890312f7fb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nextPageShortcutLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.next-page-shortcut-label",
        "defaultMessage": "Next page"
    },
    prevPageShortcutLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.prev-page-shortcut-label",
        "defaultMessage": "Previous page"
    },
    prevPageButton: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.prev-page-button",
        "defaultMessage": "Previous page"
    },
    nextPageButton: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.next-page-button",
        "defaultMessage": "Next page"
    },
    disabledButtonTooltip: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonTooltipIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.paginator.disabled-button-tooltip-issue-term-refresh",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more work items."
    }
});

});


parcelRegister("kwVxA", function(module, exports) {

$parcel$export(module.exports, "default", () => $824c7ec1b60577e2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $42CjB = parcelRequire("42CjB");

var $5LWLA = parcelRequire("5LWLA");

var $jpYlM = parcelRequire("jpYlM");

var $enBAU = parcelRequire("enBAU");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $6UAdF = parcelRequire("6UAdF");

var $krnTs = parcelRequire("krnTs");

var $cKBXV = parcelRequire("cKBXV");

var $5ngER = parcelRequire("5ngER");

var $lJCod = parcelRequire("lJCod");
class $824c7ec1b60577e2$export$e464399b18ba2124 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    shouldComponentUpdate(nextProps) {
        return this.props.sortDirection !== nextProps.sortDirection || this.props.isDisabled !== nextProps.isDisabled;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, sortDirection: sortDirection, isDisabled: isDisabled } = this.props;
        const tooltipText = sortDirection === (0, $6UAdF.sortDirections).ASC ? formatMessage((0, $lJCod.default).tooltipAsc) : formatMessage((0, $lJCod.default).tooltipDesc);
        const glyph = sortDirection === (0, $6UAdF.sortDirections).ASC ? (0, $5ngER.ArrowUpIcon) : (0, $cKBXV.ArrowDownIcon);
        const SortIcon = sortDirection === (0, $6UAdF.sortDirections).ASC ? (0, (/*@__PURE__*/$parcel$interopDefault($jpYlM))) : (0, (/*@__PURE__*/$parcel$interopDefault($enBAU)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: tooltipText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            appearance: "subtle",
            onClick: this.onClick,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.sort-button.sort-button",
            isDisabled: isDisabled,
            icon: (props)=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SortIcon, {
                    ...props,
                    color: "currentColor"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                    ...props,
                    size: "small",
                    glyph: glyph
                }),
            label: tooltipText
        }));
    }
    constructor(...args){
        super(...args), this.onClick = ()=>{
            const { onSort: onSort, sortDirection: sortDirection } = this.props;
            const newSortDirection = sortDirection === (0, $6UAdF.sortDirections).ASC ? (0, $6UAdF.sortDirections).DESC : (0, $6UAdF.sortDirections).ASC;
            onSort(newSortDirection);
        };
    }
}
const $824c7ec1b60577e2$export$86b24d49f595c6f2 = (props)=>{
    const intl = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $krnTs.useSortFieldAndDirection)();
    const handleOnSort = (0, $5uXOq.useCallback)((newSortDirection)=>{
        typeof field === 'string' && setFieldAndDirection(field, newSortDirection, []);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const orderField = field ? (0, $6UAdF.supportedOrderFields)[(0, $6UAdF.getSupportedFieldForAlias)(field) ?? field] : undefined;
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sortOrderChangeButton', {
            fieldType: orderField?.fieldType ?? null,
            sortOrder: newSortDirection
        });
        return true;
    }, [
        createAnalyticsEvent,
        field,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($824c7ec1b60577e2$export$e464399b18ba2124, {
        isDisabled: typeof field !== 'string',
        sortDirection: direction,
        onSort: handleOnSort,
        ...props,
        intl: intl
    });
};
var $824c7ec1b60577e2$export$2e2bcd8739ae039 = $824c7ec1b60577e2$export$86b24d49f595c6f2;

});
parcelRegister("jpYlM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1533407203f003b100b6bc9fc1cca1a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e22f2a6ad3c1f502$var$_react = $e22f2a6ad3c1f502$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e22f2a6ad3c1f502$var$_baseNew = $e22f2a6ad3c1f502$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e22f2a6ad3c1f502$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e22f2a6ad3c1f502$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $e22f2a6ad3c1f502$var$_react.default.createElement($e22f2a6ad3c1f502$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$e22f2a6ad3c1f502$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $e22f2a6ad3c1f502$var$_default = module.exports.default = $e22f2a6ad3c1f502$var$SortAscendingIcon;

});

parcelRegister("enBAU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2611905fa87d707c1d555c941da4c1d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a780601c67e57879$var$_react = $a780601c67e57879$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a780601c67e57879$var$_baseNew = $a780601c67e57879$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a780601c67e57879$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a780601c67e57879$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $a780601c67e57879$var$_react.default.createElement($a780601c67e57879$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-1.75 3.75v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V7.25zM8 8.75H1v-1.5h7zM6 14H1v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$a780601c67e57879$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $a780601c67e57879$var$_default = module.exports.default = $a780601c67e57879$var$SortDescendingIcon;

});

parcelRegister("cKBXV", function(module, exports) {

$parcel$export(module.exports, "ArrowDownIcon", () => $a0c24d18d28d22b1$export$1c939d3c9b6931b);

var $5uXOq = parcelRequire("5uXOq");
const $a0c24d18d28d22b1$export$1c939d3c9b6931b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.8,4.3 C6.6,4.1 6.3,4 6,4 C5.7,4 5.4,4.1 5.2,4.3 L2.3,7.2 C1.9,7.6 1.9,8.3 2.3,8.7 C2.7,9.1 3.3,9.1 3.7,8.7 L5,7.4 L5,19.1 C5,19.6 5.4,20 6,20 C6.6,20 7,19.6 7,19.1 L7,7.4 L8.3,8.7 C8.7,9.1 9.3,9.1 9.7,8.7 C10.1,8.3 10.1,7.6 9.7,7.2 C9.04754611,6.54754611 8.5582057,6.0582057 8.23197876,5.73197876 C7.91376126,5.41376126 7.436435,4.936435 6.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero",
        transform: "translate(6.000000, 12.000000) rotate(180.000000) translate(-6.000000, -12.000000) "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M21,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 L21,7 C21.6,7 22,6.6 22,6 C22,5.4 21.6,5 21,5 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13,19 L16,19 C16.6,19 17,18.6 17,18 C17,17.4 16.6,17 16,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));

});

parcelRegister("5ngER", function(module, exports) {

$parcel$export(module.exports, "ArrowUpIcon", () => $8b9dee4ad337223b$export$f1a507b991affc46);

var $5uXOq = parcelRequire("5uXOq");
const $8b9dee4ad337223b$export$f1a507b991affc46 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.8,4.3 C7.6,4.1 7.3,4 7,4 C6.7,4 6.4,4.1 6.2,4.3 L3.3,7.2 C2.9,7.6 2.9,8.3 3.3,8.7 C3.7,9.1 4.3,9.1 4.7,8.7 L6,7.4 L6,19.1 C6,19.6 6.4,20 7,20 C7.6,20 8,19.6 8,19.1 L8,7.4 L9.3,8.7 C9.7,9.1 10.3,9.1 10.7,8.7 C11.1,8.3 11.1,7.6 10.7,7.2 C10.0475461,6.54754611 9.5582057,6.0582057 9.23197876,5.73197876 C8.91376126,5.41376126 8.436435,4.936435 7.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M21,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 L21,19 C21.6,19 22,18.6 22,18 C22,17.4 21.6,17 21,17 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13,7 L16,7 C16.6,7 17,6.6 17,6 C17,5.4 16.6,5 16,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));

});

parcelRegister("lJCod", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed0328825ac5e155$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ed0328825ac5e155$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltipAsc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-asc",
        "defaultMessage": "Sort ascending"
    },
    tooltipDesc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-desc",
        "defaultMessage": "Sort descending"
    }
});

});



parcelRegister("428r9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f84771d642bef682$export$2e2bcd8739ae039);

var $xFU5V = parcelRequire("xFU5V");

var $fAUMk = parcelRequire("fAUMk");

var $iu474 = parcelRequire("iu474");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $a8lIB = parcelRequire("a8lIB");

var $gtUFk = parcelRequire("gtUFk");

var $5NwJk = parcelRequire("5NwJk");

var $7OTah = parcelRequire("7OTah");

var $bUpV8 = parcelRequire("bUpV8");

var $74FKa = parcelRequire("74FKa");

var $ly5B7 = parcelRequire("ly5B7");

var $1ocSs = parcelRequire("1ocSs");

var $4f2Gl = parcelRequire("4f2Gl");

var $2UJgO = parcelRequire("2UJgO");
const $f84771d642bef682$var$BLANK_CARD_ANALYTICS_ID = 'blankIssueCard';
const $f84771d642bef682$var$ISSUE_CARD_ANALYTICS_ID = 'issueCard';
const $f84771d642bef682$var$CardWithSelectedIssue = ({ issue: issue, fieldSets: fieldSets, isFocused: isFocused, onFocus: onFocus, onBlur: onBlur })=>{
    const issueData = (0, $8Uumt.useFragment)((0, $iu474.default), issue);
    const fieldSetsData = (0, $8Uumt.useFragment)((0, $fAUMk.default), fieldSets);
    const { key: key } = issueData;
    const isSelected = (0, $7OTah.useIsSelectedIssue)(key);
    const { setSelectedIssueByKey: setSelectedIssueByKey } = (0, $7OTah.useSelectedIssueActions)();
    const onCardFocus = (0, $5uXOq.useCallback)(()=>{
        onFocus(key);
        setSelectedIssueByKey(key, {
            shouldDebounce: true
        });
    }, [
        key,
        onFocus,
        setSelectedIssueByKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f84771d642bef682$var$CardWithAnalytics, {
        issue: issueData,
        fieldSets: fieldSetsData,
        isFocused: isFocused,
        isSelected: isSelected,
        onFocus: onCardFocus,
        onBlur: onBlur
    });
};
const $f84771d642bef682$var$CardWithSelectedIssueStateOld = ({ index: index, issue: issue, fieldSets: fieldSets })=>{
    const selectedIssueIndex = (0, $5NwJk.useSelectedIssueIndex)();
    const { setSelectedIssueByIndex: setSelectedIssueByIndex } = (0, $gtUFk.useSelectedIssueStateOldActions)();
    const [focusedIssueIndex, { setFocusedIssueByIndex: setFocusedIssueByIndex, resetFocusedIssue: resetFocusedIssue }] = (0, $gtUFk.useFocusedIssueIndex)();
    const isSelected = selectedIssueIndex === index;
    const isFocused = focusedIssueIndex === index;
    const onCardFocus = (0, $5uXOq.useCallback)(()=>{
        setFocusedIssueByIndex(index);
        setSelectedIssueByIndex(index, true);
    }, [
        index,
        setFocusedIssueByIndex,
        setSelectedIssueByIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f84771d642bef682$var$CardWithAnalytics, {
        issue: issue,
        fieldSets: fieldSets,
        index: index,
        isFocused: isFocused,
        isSelected: isSelected,
        onFocus: onCardFocus,
        onBlur: resetFocusedIssue
    });
};
const $f84771d642bef682$var$CardWithAnalytics = ({ index: index, isFocused: isFocused, isSelected: isSelected, issue: issue, fieldSets: fieldSets, onFocus: onFocus, onBlur: onBlur })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cardRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (isSelected) {
            // Scroll to the card whenever it is selected and focus on it
            cardRef.current?.scrollIntoView && cardRef.current?.scrollIntoView({
                block: 'nearest'
            });
            isFocused && cardRef.current?.focus();
        }
    }, [
        isSelected,
        isFocused
    ]);
    const onClickWithAnalytics = (0, $5uXOq.useCallback)((event)=>{
        const id = issue ? $f84771d642bef682$var$ISSUE_CARD_ANALYTICS_ID : $f84771d642bef682$var$BLANK_CARD_ANALYTICS_ID;
        const attributes = {
            keyboardShortcut: false,
            // TODO Remove attribute when cleaning up jira_spreadsheet_component_m1
            issueIndex: index !== undefined ? index + 1 : undefined
        };
        if ((0, $eJ0Zs.isNormalClick)(event)) {
            event.preventDefault();
            const analyticsEvent = createAnalyticsEvent({
                action: 'selected',
                actionSubject: 'card'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, id, attributes);
        } else {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'card'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, id, attributes);
        }
    }, [
        createAnalyticsEvent,
        issue,
        index
    ]);
    const onContextMenuHandler = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'contextMenu clicked',
            actionSubject: 'card'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, $f84771d642bef682$var$ISSUE_CARD_ANALYTICS_ID, {
            keyboardShortcut: false,
            // TODO Remove attribute when cleaning up jira_spreadsheet_component_m1
            issueIndex: index !== undefined ? index + 1 : undefined
        });
    }, [
        createAnalyticsEvent,
        index
    ]);
    return issue == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ly5B7.default), {
        ref: cardRef,
        isSelected: isSelected,
        onClick: onClickWithAnalytics,
        onFocus: onFocus
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ocSs.default), {
        ref: cardRef,
        issue: issue,
        fieldSets: fieldSets,
        onClick: onClickWithAnalytics,
        onFocus: onFocus,
        onBlur: onBlur,
        isSelected: isSelected,
        onContextMenu: onContextMenuHandler
    });
};
const $f84771d642bef682$export$4683131014ccb7f3 = ()=>(0, $5uXOq.useState)(null);
const $f84771d642bef682$var$CardList = ({ fragment: fragment, loading: loading, onNavigateToIssue: onNavigateToIssue, listRef: listRef })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START); // Analytics
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)(); // Main
    let focusedIssueIndex = null;
    let setFocusedIssueByIndex = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if (!(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const result = (0, $gtUFk.useFocusedIssueIndex)();
        focusedIssueIndex = result[0];
        setFocusedIssueByIndex = result[1].setFocusedIssueByIndex;
    }
    const [focusedIssueKey, setFocusedIssueKey] = $f84771d642bef682$export$4683131014ccb7f3();
    const maxIssuesPerPage = (0, $6UAdF.getMaxIssuesPerPage)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END);
    }, []);
    const fragmentData = (0, $8Uumt.useFragment)((0, $xFU5V.default), fragment);
    const onIssueChangeEvent = (0, $5uXOq.useCallback)(// TODO Remove issueIndex argument when cleaning up jira_spreadsheet_component_m1
    (issueKey, issueIndex)=>{
        if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
            if (issueKey) setFocusedIssueKey(issueKey);
        } else if (issueIndex !== null) setFocusedIssueByIndex(issueIndex);
        const id = issueKey ? $f84771d642bef682$var$ISSUE_CARD_ANALYTICS_ID : $f84771d642bef682$var$BLANK_CARD_ANALYTICS_ID;
        const analyticsEvent = createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'card'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, id, {
            keyboardShortcut: true,
            issueIndex: issueIndex == null ? null : issueIndex + 1
        });
    }, [
        createAnalyticsEvent,
        setFocusedIssueByIndex,
        setFocusedIssueKey
    ]);
    let cards;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    cards = (0, $5uXOq.useMemo)(()=>fragmentData?.edges?.map((edge)=>edge?.node && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f84771d642bef682$var$CardWithSelectedIssue, {
                key: edge.node.key,
                isFocused: edge.node.key === focusedIssueKey,
                issue: edge.node,
                fieldSets: edge.fieldSets ?? null,
                onFocus: setFocusedIssueKey,
                onBlur: ()=>setFocusedIssueKey(null)
            })) ?? [], [
        fragmentData?.edges,
        focusedIssueKey,
        setFocusedIssueKey
    ]);
    else cards = fragmentData?.edges?.filter((0, $eJ0Zs.isNonNullish)).map((edge, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f84771d642bef682$var$CardWithSelectedIssueStateOld, {
            key: index,
            index: index,
            issue: edge.node ?? undefined,
            fieldSets: edge.fieldSets ?? null
        })) ?? [];
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f84771d642bef682$export$22a81bdd3a723b46, {
        "aria-label": formatMessage((0, $2UJgO.default).issues)
    }, [
        ...Array(maxIssuesPerPage)
    ].map((__, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74FKa.default), {
            key: index,
            issueIndex: index
        })));
    if (cards.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUpV8.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4f2Gl.default), {
        focusedIssueIndex: focusedIssueIndex,
        focusedIssueKey: focusedIssueKey,
        onIssueChangeEvent: onIssueChangeEvent,
        onNavigateToIssue: onNavigateToIssue,
        disableListControls: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f84771d642bef682$export$22a81bdd3a723b46, {
        ref: (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? listRef : undefined,
        "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2UJgO.default).issuesIssueTermRefresh : (0, $2UJgO.default).issues)
    }, cards));
};
var $f84771d642bef682$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $f84771d642bef682$var$CardList;
const $f84771d642bef682$export$22a81bdd3a723b46 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("xFU5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef209f17a9c7453f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9b73427f9f6b234bdde1cdd9521f0bbd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ef209f17a9c7453f$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardList_fragment",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_Card_issue"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_CardWithSelectedIssue_issue"
                        }
                    ]
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 500
                                }
                            ],
                            "concreteType": "JiraIssueFieldSetConnection",
                            "kind": "LinkedField",
                            "name": "fieldSets",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_Card_fieldSets"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_CardWithSelectedIssue_fieldSets"
                                }
                            ],
                            "storageKey": "fieldSets(first:500)"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$ef209f17a9c7453f$var$node.hash = "1bb6eb92de80a9f68083519d7a9f3194";
var $ef209f17a9c7453f$export$2e2bcd8739ae039 = $ef209f17a9c7453f$var$node;

});

parcelRegister("fAUMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $14475bc489a27f22$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<624714bc7d64cade4aaede35e606ffae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $14475bc489a27f22$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardWithSelectedIssue_fieldSets",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Card_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$14475bc489a27f22$var$node.hash = "5d80b931b560f2c418fca0d9f032c9a0";
var $14475bc489a27f22$export$2e2bcd8739ae039 = $14475bc489a27f22$var$node;

});

parcelRegister("iu474", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fbd4a51bc8d266$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef67c1b29917e04b29ae418c9bcc3e9d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b3fbd4a51bc8d266$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardWithSelectedIssue_issue",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Card_issue"
        }
    ],
    "type": "JiraIssue"
};
$b3fbd4a51bc8d266$var$node.hash = "8eb4cdf2fd848d8fc193cb41d7f7d67f";
var $b3fbd4a51bc8d266$export$2e2bcd8739ae039 = $b3fbd4a51bc8d266$var$node;

});

parcelRegister("bUpV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b23b0330efbf510$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4wcJR = parcelRequire("4wcJR");
const $7b23b0330efbf510$export$36d139f95680ab4e = ()=>// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7b23b0330efbf510$var$StyledContainer, {
        "data-testid": "issue-navigator.issue-results.detail-view.card-list.card-empty-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4wcJR.default), null));
var $7b23b0330efbf510$export$2e2bcd8739ae039 = $7b23b0330efbf510$export$36d139f95680ab4e;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b23b0330efbf510$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _4t3i1osq _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4wcJR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b8e75c7cc60728f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $kjIEI = parcelRequire("kjIEI");

var $c7i3D = parcelRequire("c7i3D");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $beQyQ = parcelRequire("beQyQ");
const $5b8e75c7cc60728f$export$f3f2e7ed2b6256b1 = ({ intl: { formatMessage: formatMessage } })=>{
    const noIssues = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $beQyQ.default).noIssuesIssueTermRefresh : (0, $beQyQ.default).noIssues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5b8e75c7cc60728f$var$ImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7i3D.default), {
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5b8e75c7cc60728f$var$ImageWrapperStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjIEI.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, noIssues));
};
var /* eslint-disable-next-line jira/js/no-inject-intl-if-functional-component */ $5b8e75c7cc60728f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($5b8e75c7cc60728f$export$f3f2e7ed2b6256b1);
const $5b8e75c7cc60728f$var$ImageWrapperStylesOld = (0, $8CUq3.xcss)({
    height: '146px',
    width: '160px'
});
const $5b8e75c7cc60728f$var$ImageWrapperStyles = (0, $8CUq3.xcss)({
    height: '165px',
    width: '150px'
});

});
parcelRegister("beQyQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba07fcf1bf5ac48f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ba07fcf1bf5ac48f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    },
    noIssuesIssueTermRefresh: {
        "id": "issue-navigator.common.empty-list-icon.no-issues-issue-term-refresh",
        "defaultMessage": "There's nothing matching your search"
    }
});

});



parcelRegister("74FKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $349ff8ff8da44cac$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dD7Zc = parcelRequire("dD7Zc");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $5xVPG = parcelRequire("5xVPG");

var $jXcGy = parcelRequire("jXcGy");

var $4IWp9 = parcelRequire("4IWp9");

var $2fvFU = parcelRequire("2fvFU");
const $349ff8ff8da44cac$var$shimmer = null;
// eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$SkeletonBackground = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_5sag126j _1o51q7pw _j7hq1en8 _1pglp3kn _bfhkh3tw _1itkst3p _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.hasError ? "_tip8idpf" : "_tip812c5",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$defaultIssueCardHeight = 97; // eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$SkeletonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1rbs _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$IssueCardSkeleton = ({ hasError: hasError = false, issueIndex: issueIndex })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: (0, $dCm1o.isVisualRefreshEnabled)() ? $349ff8ff8da44cac$var$ListItemStyle : $349ff8ff8da44cac$var$ListItemStyleOld,
        "aria-label": formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4IWp9.default).issueLoadingLabelIssueTermRefresh : (0, $4IWp9.default).issueLoadingLabel, {
            number: issueIndex
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$CardContainer, {
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$SkeletonBackground, {
        hasError: hasError,
        "data-component-selector": (0, $2fvFU.skeletonBackgroundSelector)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$ColumnMask, {
        "data-component-selector": (0, $2fvFU.columnMaskSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$SummaryMask, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$TextLineMask, {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$TextLineMask, {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 60
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$FooterMask, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$TypeMask, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$SeparatorMask, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$IssueKeyMask, null), hasError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$ErrorIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$BlankMask, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$ErrorWrapper, {
        "data-component-selector": (0, $2fvFU.errorWrapperSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jXcGy.default), null)))));
};
var $349ff8ff8da44cac$export$2e2bcd8739ae039 = $349ff8ff8da44cac$var$IssueCardSkeleton;
const $349ff8ff8da44cac$var$ListItemStyleOld = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.0'
});
const $349ff8ff8da44cac$var$ListItemStyle = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.0',
    marginBlockEnd: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$CardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $5xVPG.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$ErrorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cglyw _1bsb1osq _4cvr1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$ErrorIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkvuon _16jlkb7n _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$BlankMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _bfhkvuon _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$SeparatorMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbftgi _bfhkvuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$IssueKeyMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3i1tcg _1bsb16xz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$TypeMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3i1tcg _1bsb1tcg _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$TextLineMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rjhebn": (0, $lD23V.default)(__cmplp.fontSize, "px"),
            "--_1oqupad": (0, $lD23V.default)(__cmplp.intrusion, "px"),
            "--_c633pi": (0, $lD23V.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1s7z87mc _x3do1cy7 _n7zl1cy7 _kqswh2mm _4t3i3gti",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$FooterMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zlv4vr _x3do16sd _1e0c1txw _2lx2vrvc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$SummaryMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zl15mc",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$ColumnMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kl715mc _1s7z15mc _kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5xVPG", function(module, exports) {

$parcel$export(module.exports, "CardBaseStyle", () => $489d3a2e61cd5aa2$export$d10d52f6c0613cc3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $jQtKF = parcelRequire("jQtKF");
const $489d3a2e61cd5aa2$var$backgroundColorSelected = "var(--ds-background-selected, #E9F2FF)";
const $489d3a2e61cd5aa2$var$backgroundColor = "var(--ds-surface-raised, #FFFFFF)";
const $489d3a2e61cd5aa2$var$borderColor = "var(--ds-border, #091E4224)";
const $489d3a2e61cd5aa2$var$boxShadowColor = `1px 0px ${"var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"}`;
const $489d3a2e61cd5aa2$export$d10d52f6c0613cc3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vy64tb": (0, $lD23V.default)(__cmplp.isSelected ? "var(--ds-background-accent-blue-subtlest, #E9F2FF)" : "var(--ds-surface-raised, #FFFFFF)"),
            "--_11cvo1a": (0, $lD23V.default)(__cmplp.isSelected ? $489d3a2e61cd5aa2$var$backgroundColorSelected : $489d3a2e61cd5aa2$var$backgroundColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4u2gc _1e0c1ule _vchhusvi _1a3b18uv _4fprglyw _5goinqa1 _nt751r31 _49pcglyw _1hvw1o36 _7ehiytyo _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.visualRefresh ? "_2rkoiti9 _18s8v77o _1yt4utpp _16qszucj _bfhk1sss" : "_x3doidpf _n7zlzgxb _1kl7zgxb _bfhk2rqg _1jc11j8p _14t0zgxb _e6md1se7 _13jwelmp _1tzh1y44",
            __cmplp.className
        ])
    });
});
const $489d3a2e61cd5aa2$export$b15a6cf2987e4b39 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $jQtKF.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jXcGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1838c9b738176ad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $7Csvc = parcelRequire("7Csvc");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression
const $b1838c9b738176ad$var$InfoMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.className
        ])
    });
});
const $b1838c9b738176ad$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1kw7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
class $b1838c9b738176ad$export$e8132eb38e030ec6 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onResetErrors: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1838c9b738176ad$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1838c9b738176ad$var$InfoMessage, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7Csvc.default).infoTextIssueTermRefresh : (0, $7Csvc.default).infoText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            onClick: this.onReloadIssueClick,
            spacing: "none"
        }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7Csvc.default).reloadIssueIssueTermRefresh : (0, $7Csvc.default).reloadIssue)));
    }
    constructor(...args){
        super(...args), // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onReloadIssueClick = (...attrs)=>{
            const analyticsEvent = attrs.pop();
            this.props.onResetErrors(analyticsEvent);
        };
    }
}
var $b1838c9b738176ad$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($b1838c9b738176ad$export$e8132eb38e030ec6);

});
parcelRegister("7Csvc", function(module, exports) {

$parcel$export(module.exports, "default", () => $18a133c57e2faa08$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $18a133c57e2faa08$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    infoText: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text",
        "defaultMessage": "We couldn't load this issue."
    },
    reloadIssue: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue",
        "defaultMessage": "Reload issue"
    },
    infoTextIssueTermRefresh: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text-issue-term-refresh",
        "defaultMessage": "We couldn't load this work item."
    },
    reloadIssueIssueTermRefresh: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue-issue-term-refresh",
        "defaultMessage": "Reload work item"
    }
});

});


parcelRegister("4IWp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $078c5bf6273acc7a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $078c5bf6273acc7a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueLoadingLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card-skeleton.issue-loading-label",
        "defaultMessage": "Issue card {number} loading"
    },
    issueLoadingLabelIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card-skeleton.issue-loading-label-issue-term-refresh",
        "defaultMessage": "Work item card {number} loading"
    }
});

});

parcelRegister("2fvFU", function(module, exports) {

$parcel$export(module.exports, "errorWrapperSelector", () => $3769c2df00d1a140$export$a03455d77d6a4ea);
$parcel$export(module.exports, "skeletonBackgroundSelector", () => $3769c2df00d1a140$export$85fe8f1edff78b98);
$parcel$export(module.exports, "columnMaskSelector", () => $3769c2df00d1a140$export$67b279fb398d016e);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $3769c2df00d1a140$var$defaultIssueCardHeight = 97;
const $3769c2df00d1a140$export$66b8cea0c448285 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1rbs _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$var$shimmer = null;
const $3769c2df00d1a140$export$c3b0ebed856b8b1a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_5sag126j _1o51q7pw _j7hq1en8 _1pglp3kn _bfhkh3tw _1itkst3p _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.hasError ? "_tip8idpf" : "_tip812c5",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$439b7c87164a9b43 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kl715mc _1s7z15mc _kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$792e72b41c80f830 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zl15mc",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$ab3fe3ddc5c7354f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zlv4vr _x3do16sd _1e0c1txw _2lx2vrvc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$f3e0fd2d5209f88b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rjhebn": (0, $lD23V.default)(__cmplp.fontSize, "px"),
            "--_1oqupad": (0, $lD23V.default)(__cmplp.intrusion, "px"),
            "--_c633pi": (0, $lD23V.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1s7z87mc _x3do1cy7 _n7zl1cy7 _kqswh2mm _4t3i3gti",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$59d16c2cd3bc3a2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3i1tcg _1bsb1tcg _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$ca1c048394ed3dbb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3i1tcg _1bsb16xz",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$bdc7d72765b181c3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbftgi _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$a1b9063b4cbc0844 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _bfhkvuon _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$90993d2d9550d725 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkvuon _16jlkb7n _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$bb27b7e39840238f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cglyw _1bsb1osq _4cvr1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$a03455d77d6a4ea = 'jira-issue-navigator-card-skeleton-error-wrapper';
const $3769c2df00d1a140$export$85fe8f1edff78b98 = 'jira-issue-navigator-card-skeleton-skeleton-background';
const $3769c2df00d1a140$export$67b279fb398d016e = 'jira-issue-navigator-card-skeleton-column-mask';

});


parcelRegister("ly5B7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8caaf0a251343b7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $5xVPG = parcelRequire("5xVPG");

var $iwwo9 = parcelRequire("iwwo9");
const $f8caaf0a251343b7$var$EmptyCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isSelected: isSelected = false, onClick: onClick, onFocus: onFocus }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: $f8caaf0a251343b7$var$ListItemStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f8caaf0a251343b7$var$EmptyCardContainer, {
        tabIndex: isSelected ? 0 : -1,
        ref: ref ?? undefined,
        isSelected: isSelected,
        onClick: onClick,
        href: "#",
        onFocus: onFocus,
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iwwo9.default).emptyCardTextIssueTermRefresh : (0, $iwwo9.default).emptyCardText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "blankIssue"
    })));
});
var $f8caaf0a251343b7$export$2e2bcd8739ae039 = $f8caaf0a251343b7$var$EmptyCard;
const $f8caaf0a251343b7$var$textColorActiveState = "var(--ds-text-selected, #0C66E4)";
const $f8caaf0a251343b7$var$textColor = "var(--ds-text, #172B4D)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f8caaf0a251343b7$var$EmptyCardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $5xVPG.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _80omtlke",
            __cmplp.isSelected ? "_syazaqb7" : "_syaz1fxt",
            __cmplp.isSelected ? "_f8pjaqb7 _30l3aqb7" : "_f8pj1fxt _30l31fxt",
            __cmplp.className
        ])
    });
});
const $f8caaf0a251343b7$var$ListItemStyle = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.0'
});

});
parcelRegister("iwwo9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb369d8ea4f3908$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ffb369d8ea4f3908$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    blankText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text",
        "defaultMessage": "We can't display this issue"
    },
    emptyCardText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltip: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    },
    blankTextIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text-issue-term-refresh",
        "defaultMessage": "We can't display this work item"
    },
    emptyCardTextIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text-issue-term-refresh",
        "defaultMessage": "This work item cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltipIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip-issue-term-refresh",
        "defaultMessage": "Either this work item has been deleted, or you don\u2019t have access to it."
    }
});

});


parcelRegister("1ocSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $04760746f23b3b20$export$2e2bcd8739ae039);

var $eLObg = parcelRequire("eLObg");

var $5g6U1 = parcelRequire("5g6U1");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6s1PB = parcelRequire("6s1PB");

var $g5X3G = parcelRequire("g5X3G");

var $dCm1o = parcelRequire("dCm1o");

var $5xVPG = parcelRequire("5xVPG");

var $1BB6R = parcelRequire("1BB6R");
const $04760746f23b3b20$var$backgroundColorSelected = "var(--ds-background-selected, #E9F2FF)";
const $04760746f23b3b20$var$backgroundColorHovered = "var(--ds-background-neutral-subtle-hovered, #091E420F)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04760746f23b3b20$var$StyledListElement = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf",
            __cmplp.visualRefresh && "_otyr1b66",
            __cmplp.className
        ])
    });
});
const $04760746f23b3b20$export$1d41361302b577a1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $5xVPG.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _f8pj1kw7 _30l31kw7",
            __cmplp.isSelected ? "_syazaqb7" : "_syaz1kw7",
            __cmplp.isSelected ? "_irr3fg4m" : "_irr3166n",
            __cmplp.className
        ])
    });
});
const $04760746f23b3b20$export$c3fc4c88db352deb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_slp31hna _1i4q1hna _1nmz1hna",
            __cmplp.visualRefresh ? "_otyru2gc" : "_otyr1b66",
            __cmplp.className
        ])
    });
});
const $04760746f23b3b20$var$Card = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ style: style, onMounted: onMounted, onClick: onClick, onFocus: onFocus, onBlur: onBlur, issue: issue, fieldSets: fieldSetsFragment, isSelected: isSelected, onContextMenu: onContextMenu }, ref)=>{
    const fragmentData = (0, $8Uumt.useFragment)((0, $5g6U1.default), issue);
    const fieldSets = (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? fieldSetsFragment : fragmentData.fieldSetsForIssueSearchView ?? null;
    const fieldSetsData = (0, $8Uumt.useFragment)((0, $eLObg.default), fieldSets);
    const issueKey = fragmentData.key;
    (0, $5uXOq.useEffect)(()=>{
        onMounted && onMounted();
    }, [
        onMounted
    ]);
    const fieldEdges = fieldSetsData?.edges ?? null;
    const summary = (0, $1BB6R.byFieldId)(fieldEdges, 'summary', (summaryEdge)=>summaryEdge?.node?.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04760746f23b3b20$var$StyledListElement, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.list-item",
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04760746f23b3b20$export$1d41361302b577a1 // @ts-expect-error incorrect ref type
    , {
        ref: ref ?? undefined,
        onContextMenu: onContextMenu,
        isSelected: isSelected,
        onBlur: onBlur,
        tabIndex: isSelected ? 0 : -1,
        onClick: onClick,
        onFocus: onFocus,
        style: style,
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card",
        href: `/browse/${issueKey}`,
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04760746f23b3b20$export$c3fc4c88db352deb, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.summary",
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, summary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BB6R.Footer), {
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        isResolved: fragmentData.isResolved,
        fieldSets: fieldSetsData,
        isSelected: isSelected
    })));
});
var $04760746f23b3b20$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($04760746f23b3b20$var$Card);

});
parcelRegister("eLObg", function(module, exports) {

$parcel$export(module.exports, "default", () => $52436c85d14b8231$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<665198baf0f9c2c411158353f00d7520>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $52436c85d14b8231$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Card_fieldSets",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "footer_issueNavigator_FooterInternal"
        },
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "text"
                                                        }
                                                    ],
                                                    "type": "JiraSingleLineTextField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$52436c85d14b8231$var$node.hash = "606cafbbef903d4ec28da2ea50226fe2";
var $52436c85d14b8231$export$2e2bcd8739ae039 = $52436c85d14b8231$var$node;

});

parcelRegister("5g6U1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4e46f8431bdece$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ebdd1820e138dcf11f68ac2778906c4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4b4e46f8431bdece$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsContext"
        },
        {
            "kind": "RootArgument",
            "name": "filterId"
        },
        {
            "kind": "RootArgument",
            "name": "namespace"
        },
        {
            "kind": "RootArgument",
            "name": "viewId"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_Card_issue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "ScalarField",
            "name": "isResolved"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "context",
                                "variableName": "fieldSetsContext"
                            },
                            {
                                "kind": "Variable",
                                "name": "filterId",
                                "variableName": "filterId"
                            },
                            {
                                "kind": "Variable",
                                "name": "first",
                                "variableName": "amountOfColumns"
                            },
                            {
                                "kind": "Variable",
                                "name": "namespace",
                                "variableName": "namespace"
                            },
                            {
                                "kind": "Variable",
                                "name": "viewId",
                                "variableName": "viewId"
                            }
                        ],
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSetsForIssueSearchView",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_Card_fieldSets"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "fieldSetsForIssueSearchView"
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$4b4e46f8431bdece$var$node.hash = "c7905d3b95940a78e8b4bd1557d28ea2";
var $4b4e46f8431bdece$export$2e2bcd8739ae039 = $4b4e46f8431bdece$var$node;

});

parcelRegister("1BB6R", function(module, exports) {

$parcel$export(module.exports, "byFieldId", () => $508c659e42eab501$export$7a6e1e67b4eca178);
$parcel$export(module.exports, "Footer", () => $508c659e42eab501$export$a06f1c675e846f6f);

var $cA9Wh = parcelRequire("cA9Wh");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $ujWmd = parcelRequire("ujWmd");

var $3bDjY = parcelRequire("3bDjY");

var $dqoiX = parcelRequire("dqoiX");

var $gULOk = parcelRequire("gULOk");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $ku7XM = parcelRequire("ku7XM");

var $dCm1o = parcelRequire("dCm1o");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $aEaMJ = parcelRequire("aEaMJ");
const $508c659e42eab501$export$7a6e1e67b4eca178 = (edges, fieldId, mapperFn)=>edges?.map((edge)=>edge?.node?.fields?.edges?.[0]).filter((edge)=>edge?.node?.fieldId === fieldId).filter((0, $eJ0Zs.isNonNullish)).map(mapperFn)[0];
const $508c659e42eab501$var$FooterInternal = ({ issueKey: issueKey, isResolved: isResolvedProp, isSelected: isSelected, fieldSets: fieldSets })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fieldSetsData = (0, $8Uumt.useFragment)((0, $cA9Wh.default), fieldSets);
    const fieldSetEdges = fieldSetsData?.edges;
    const assignee = $508c659e42eab501$export$7a6e1e67b4eca178(fieldSetEdges, 'assignee', (assigneeEdge)=>assigneeEdge?.node?.user);
    const issueType = $508c659e42eab501$export$7a6e1e67b4eca178(fieldSetEdges, 'issuetype', (issueTypeEdge)=>issueTypeEdge?.node?.issueType);
    const statusCategoryId = $508c659e42eab501$export$7a6e1e67b4eca178(fieldSetEdges, 'statusCategory', (statusCategoryEdge)=>statusCategoryEdge?.node?.statusCategory?.statusCategoryId);
    const isResolved = (0, $ku7XM.shouldDisplayStrikethrough)(isResolvedProp ?? undefined, (0, $gULOk.statusCategoryForId)(statusCategoryId));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($508c659e42eab501$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($508c659e42eab501$var$TypeIcon, {
        src: issueType?.avatar?.small ?? undefined,
        alt: issueType?.name ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($508c659e42eab501$export$263c092b561e7355, {
        isSelected: isSelected,
        isResolved: isResolved,
        isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, issueKey, isResolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        role: "status"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aEaMJ.default).screenReaderFooterKeyResolvedIssueTermRefresh : (0, $aEaMJ.default).screenReaderFooterKeyResolved, {
        issueKey: issueKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($508c659e42eab501$var$AvatarStyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: assignee?.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: assignee?.picture,
        name: assignee?.name,
        size: "small"
    }))));
};
const $508c659e42eab501$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $5uXOq.memo)($508c659e42eab501$var$FooterInternal); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $508c659e42eab501$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $508c659e42eab501$var$TypeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _1bsb7vkz _4t3i7vkz _2hwx1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $508c659e42eab501$var$AvatarStyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1f4h _19bvu2gc _18u01wug _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $508c659e42eab501$export$263c092b561e7355 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, isSelected: isSelected, isResolved: isResolved, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _kqswh2mm",
            __cmplp.isVisualRefresh ? "_k48p1wq8" : "_k48pmoej",
            __cmplp.isSelected ? "_syazaqb7" : __cmplp.isVisualRefresh ? "_syaz1gjq" : "_syaz1fxt",
            __cmplp.isResolved ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cA9Wh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9702b926129cb95c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<54d5e2050f16aa77b0b95c4ea04b0425>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9702b926129cb95c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "footer_issueNavigator_FooterInternal",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "picture"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "small"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$9702b926129cb95c$var$node.hash = "80bd71836423cbf18b560dfc0418dc69";
var $9702b926129cb95c$export$2e2bcd8739ae039 = $9702b926129cb95c$var$node;

});

parcelRegister("gULOk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e77315bf13f8b83b$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e77315bf13f8b83b$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e77315bf13f8b83b$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e77315bf13f8b83b$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e77315bf13f8b83b$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e77315bf13f8b83b$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e77315bf13f8b83b$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e77315bf13f8b83b$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e77315bf13f8b83b$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e77315bf13f8b83b$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e77315bf13f8b83b$export$d928f247c903643a);
const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
    $e77315bf13f8b83b$export$6db089fe7b26f5b6,
    $e77315bf13f8b83b$export$aa456a5030160740,
    $e77315bf13f8b83b$export$5a9ac66c2785cc13,
    $e77315bf13f8b83b$export$71efb3495f6084f2
];
const $e77315bf13f8b83b$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
    }
];
const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
};
const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});

parcelRegister("ku7XM", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayStrikethrough", () => $5e2ee485e17261c7$export$1e1e848245d3a6f7);

var $gULOk = parcelRequire("gULOk");
const { DONE: $5e2ee485e17261c7$var$DONE } = (0, $gULOk);
const $5e2ee485e17261c7$export$1e1e848245d3a6f7 = (isResolved, statusCategory)=>{
    if (isResolved !== undefined) return isResolved;
    // In JSW, the strikethrough must now only depend on resolution. However we have to keep
    // this logic because there is a consumer of issue-line-card in JSM that displays
    // the strikethrough based on status src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx
    return statusCategory === $5e2ee485e17261c7$var$DONE;
};

});

parcelRegister("aEaMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8db5e8f8694ecf3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f8db5e8f8694ecf3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    screenReaderFooterKeyResolved: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-resolved",
        "defaultMessage": "Resolved issue: {issueKey}"
    },
    screenReaderFooterKeyDone: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-done",
        "defaultMessage": "Done issue: {issueKey}"
    },
    screenReaderFooterKeyResolvedIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-resolved-issue-term-refresh",
        "defaultMessage": "Resolved issue: {issueKey}"
    },
    screenReaderFooterKeyDoneIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-done-issue-term-refresh",
        "defaultMessage": "Done work item: {issueKey}"
    }
});

});



parcelRegister("4f2Gl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3513a249a124c25$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3Tty1 = parcelRequire("3Tty1");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $63r1u = parcelRequire("63r1u");

var $gtUFk = parcelRequire("gtUFk");

var $5NwJk = parcelRequire("5NwJk");

var $7OTah = parcelRequire("7OTah");

var $eaucu = parcelRequire("eaucu");
const $b3513a249a124c25$var$useUpdatingRef = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
};
const $b3513a249a124c25$var$KeyboardShortcuts = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const propsRef = $b3513a249a124c25$var$useUpdatingRef(props);
    const openStateRef = $b3513a249a124c25$var$useUpdatingRef((0, $63r1u.useOrderByOpenState)());
    const selectedIssueKey = (0, $5NwJk.useSelectedIssueKey)();
    const selectedIssueKeyRef = $b3513a249a124c25$var$useUpdatingRef(selectedIssueKey);
    let handleNext;
    let handlePrevious;
    let selectedIssueIndex = null;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        const { selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $7OTah.useSelectedIssueActions)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const nextIssueKey = (0, $7OTah.useNextIssueKey)() ?? (0, $g5X3G.toIssueKey)('');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const nextIssueKeyRef = (0, $5uXOq.useRef)(nextIssueKey);
        nextIssueKeyRef.current = nextIssueKey;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        handleNext = (0, $5uXOq.useCallback)(()=>{
            const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
            if (selectNextIssue(true)) onIssueChangeEvent && onIssueChangeEvent(nextIssueKeyRef.current);
        // Dependencies must be stable as downstream useMemo has an empty dependencies array
        }, [
            propsRef,
            selectNextIssue
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const previousIssueKey = (0, $7OTah.usePreviousIssueKey)() ?? (0, $g5X3G.toIssueKey)('');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const previousIssueKeyRef = (0, $5uXOq.useRef)(previousIssueKey);
        previousIssueKeyRef.current = previousIssueKey;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        handlePrevious = (0, $5uXOq.useCallback)(()=>{
            const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
            if (selectPreviousIssue(true)) onIssueChangeEvent && onIssueChangeEvent(previousIssueKeyRef.current);
        // Dependencies must be stable as downstream useMemo has an empty dependencies array
        }, [
            propsRef,
            selectPreviousIssue
        ]);
    } else {
        const { getNextIssue: getNextIssue, selectNextIssue: selectNextIssue, getPreviousIssue: getPreviousIssue, selectPreviousIssue: selectPreviousIssue } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $gtUFk.useSelectedIssueStateOldActions)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        handleNext = (0, $5uXOq.useCallback)(()=>{
            const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
            // getNextIssue and selectNextIssue need to be stable function references as
            // useMemo has an empty dependencies array
            const { issueKey: issueKey, issueIndex: issueIndex } = getNextIssue();
            if (selectNextIssue(true)) onIssueChangeEvent && onIssueChangeEvent(issueKey, issueIndex);
        }, [
            propsRef,
            getNextIssue,
            selectNextIssue
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        handlePrevious = (0, $5uXOq.useCallback)(()=>{
            const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
            // getPreviousIssue and selectPreviousIssue need to be stable function references as
            // useMemo has an empty dependencies array
            const { issueKey: issueKey, issueIndex: issueIndex } = getPreviousIssue();
            if (selectPreviousIssue(true)) onIssueChangeEvent && onIssueChangeEvent(issueKey, issueIndex);
        }, [
            propsRef,
            getPreviousIssue,
            selectPreviousIssue
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        selectedIssueIndex = (0, $5NwJk.useSelectedIssueIndex)();
    }
    // TODO Remove when cleaning up jira_spreadsheet_component_m1
    const selectedIssueIndexRef = $b3513a249a124c25$var$useUpdatingRef(selectedIssueIndex);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: (0, $5uXOq.useMemo)(()=>({
                j: {
                    callback: ()=>{
                        const { disableListControls: disableListControls } = propsRef.current;
                        if (disableListControls === true) return;
                        // handleNext needs to be a stable function references as useMemo has an empty dependencies array
                        handleNext();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eaucu.default).nextIssueIssueTermRefresh : (0, $eaucu.default).nextIssue))
                },
                k: {
                    callback: ()=>{
                        const { disableListControls: disableListControls } = propsRef.current;
                        if (disableListControls === true) return;
                        // handlePrevious needs to be a stable function references as useMemo has an empty dependencies array
                        handlePrevious();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eaucu.default).previousIssueIssueTermRefresh : (0, $eaucu.default).previousIssue))
                },
                y: {
                    callback: ()=>{
                        const [{ isOpen: isOpen }, { open: open, close: close }] = openStateRef.current;
                        isOpen ? close() : open();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $eaucu.default).displaySortFields))
                },
                z: {
                    callback: ()=>{
                        if (selectedIssueKeyRef.current) propsRef.current.onNavigateToIssue(selectedIssueKeyRef.current);
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eaucu.default).openIssueFullScreenIssueTermRefresh : (0, $eaucu.default).openIssueFullScreen))
                },
                arrowup: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, focusedIssueIndex: focusedIssueIndex, focusedIssueKey: focusedIssueKey } = propsRef.current;
                        if (disableListControls === true) return;
                        let isSelectedIssueFocused;
                        if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) isSelectedIssueFocused = focusedIssueKey !== null && focusedIssueKey === selectedIssueKeyRef.current;
                        else isSelectedIssueFocused = focusedIssueIndex !== null && focusedIssueIndex === selectedIssueIndexRef.current;
                        if (isSelectedIssueFocused) handlePrevious();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eaucu.default).previousIssueIssueTermRefresh : (0, $eaucu.default).previousIssue))
                },
                arrowdown: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, focusedIssueIndex: focusedIssueIndex, focusedIssueKey: focusedIssueKey } = propsRef.current;
                        if (disableListControls === true) return;
                        let isSelectedIssueFocused;
                        if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) isSelectedIssueFocused = focusedIssueKey !== null && focusedIssueKey === selectedIssueKeyRef.current;
                        else isSelectedIssueFocused = focusedIssueIndex !== null && focusedIssueIndex === selectedIssueIndexRef.current;
                        if (isSelectedIssueFocused) handleNext();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eaucu.default).nextIssueIssueTermRefresh : (0, $eaucu.default).nextIssue))
                }
            }), [] // eslint-disable-line react-hooks/exhaustive-deps
        )
    });
};
$b3513a249a124c25$var$KeyboardShortcuts.defaultProps = {
    disableListControls: false
};
var $b3513a249a124c25$export$2e2bcd8739ae039 = $b3513a249a124c25$var$KeyboardShortcuts;

});
parcelRegister("eaucu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f07eece787fe1a7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1f07eece787fe1a7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nextIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.next-issue",
        "defaultMessage": "Next issue"
    },
    previousIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.previous-issue",
        "defaultMessage": "Previous issue"
    },
    displaySortFields: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.display-sort-fields",
        "defaultMessage": "Detail view order by"
    },
    openIssueFullScreen: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen",
        "defaultMessage": "Open issue fullscreen"
    },
    nextIssueIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.next-issue-issue-term-refresh",
        "defaultMessage": "Next work item"
    },
    previousIssueIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.previous-issue-issue-term-refresh",
        "defaultMessage": "Previous work item"
    },
    openIssueFullScreenIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen-issue-term-refresh",
        "defaultMessage": "Open the work item in fullscreen"
    }
});

});


parcelRegister("2UJgO", function(module, exports) {

$parcel$export(module.exports, "default", () => $28be3dd688e218d3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $28be3dd688e218d3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issues: {
        "id": "issue-navigator.issue-results.detail-view.card-list.issues",
        "defaultMessage": "Issues"
    },
    issuesIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.issues-issue-term-refresh",
        "defaultMessage": "Work items"
    }
});

});



parcelRegister("3vkQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8745c6e002add02e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "RecoverableErrorViewBoundary", () => $8745c6e002add02e$export$d42c1f6e3e564ee9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $81Uw2 = parcelRequire("81Uw2");

var $6s1PB = parcelRequire("6s1PB");

var $kjIEI = parcelRequire("kjIEI");

var $c7i3D = parcelRequire("c7i3D");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $isIOR = parcelRequire("isIOR");

var $38r5c = parcelRequire("38r5c");

var $hlGjX = parcelRequire("hlGjX");
const $8745c6e002add02e$var$ErrorView = ({ onCaughtIssueSearchError: onCaughtIssueSearchError, error: errorProp })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let onRefresh;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ onRefresh: onRefresh } = (0, $38r5c.useIssueSearchActions)());
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ onIssueSearchRefresh: onRefresh } = (0, $isIOR.useIssueSearchQuery)());
    const onClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent.clone(), 'refreshFromError');
        onRefresh();
    }, [
        onRefresh
    ]);
    const error = (0, $5uXOq.useMemo)(()=>errorProp || new Error('There was an error searching for issues'), [
        errorProp
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        onCaughtIssueSearchError && onCaughtIssueSearchError(error);
    }, [
        onCaughtIssueSearchError,
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8745c6e002add02e$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $hlGjX.default).emptyStateErrorHeader),
        description: formatMessage((0, $hlGjX.default).emptyStateErrorDescription),
        testId: "issue-navigator.ui.issue-results.error-view.error-message",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $hlGjX.default).emptyStateErrorAction)),
        renderImage: ()=>(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh_drop_6') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $8745c6e002add02e$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7i3D.default), {
                alt: ""
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $8745c6e002add02e$var$ImageWrapperStylesOld
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjIEI.default), {
                alt: ""
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "screen",
        actionSubjectId: "issueSearchError"
    }));
};
var $8745c6e002add02e$export$2e2bcd8739ae039 = $8745c6e002add02e$var$ErrorView;
const $8745c6e002add02e$export$d42c1f6e3e564ee9 = (0, $81Uw2.withRecoverableErrorBoundary)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children), {
    recoveryProp: 'recoveryProp',
    Fallback: $8745c6e002add02e$var$ErrorView
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8745c6e002add02e$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $8745c6e002add02e$var$ImageWrapperStylesOld = (0, $8CUq3.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});
const $8745c6e002add02e$var$ImageWrapperStyles = (0, $8CUq3.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("hlGjX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7ed0162ee24bd2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c7ed0162ee24bd2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyStateErrorHeader: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-header",
        "defaultMessage": "We couldn\u2019t load your search results"
    },
    emptyStateErrorDescription: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-description",
        "defaultMessage": "Refresh to try again."
    },
    emptyStateErrorAction: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-action",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("dTymG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c7151db16a02806$export$2e2bcd8739ae039);

var $59Iqo = parcelRequire("59Iqo");

var $3Q636 = parcelRequire("3Q636");

var $gDdVw = parcelRequire("gDdVw");

var $bW3jF = parcelRequire("bW3jF");

var $1Fibi = parcelRequire("1Fibi");

var $2fw1T = parcelRequire("2fw1T");

var $krXnE = parcelRequire("krXnE");

var $ebHAX = parcelRequire("ebHAX");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jcw0u = parcelRequire("jcw0u");

var $gcl1l = parcelRequire("gcl1l");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $pa9q9 = parcelRequire("pa9q9");

var $6bs0c = parcelRequire("6bs0c");

var $gkVdw = parcelRequire("gkVdw");

var $czfFt = parcelRequire("czfFt");

var $aB7bN = parcelRequire("aB7bN");

var $5iGOJ = parcelRequire("5iGOJ");

var $32GaU = parcelRequire("32GaU");

var $3HwlS = parcelRequire("3HwlS");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");

var $imS60 = parcelRequire("imS60");

var $1TiUe = parcelRequire("1TiUe");

var $4R6GH = parcelRequire("4R6GH");

var $6UAdF = parcelRequire("6UAdF");

var $1igGa = parcelRequire("1igGa");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $a8lIB = parcelRequire("a8lIB");

var $jlRhf = parcelRequire("jlRhf");

var $hZQx0 = parcelRequire("hZQx0");

var $gtUFk = parcelRequire("gtUFk");

var $5NwJk = parcelRequire("5NwJk");

var $ih9zY = parcelRequire("ih9zY");

var $krnTs = parcelRequire("krnTs");

var $gwtSG = parcelRequire("gwtSG");

var $kiKYF = parcelRequire("kiKYF");

var $kj1di = parcelRequire("kj1di");

var $isIOR = parcelRequire("isIOR");

var $38r5c = parcelRequire("38r5c");

var $gUt9J = parcelRequire("gUt9J");

var $7UBlg = parcelRequire("7UBlg");

var $bC77a = parcelRequire("bC77a");

var $2lRxk = parcelRequire("2lRxk");

var $8ev74 = parcelRequire("8ev74");

var $2hlL8 = parcelRequire("2hlL8");

var $df5k9 = parcelRequire("df5k9");

var $cKSn6 = parcelRequire("cKSn6");

var $1g3qz = parcelRequire("1g3qz");

var $ePwTF = parcelRequire("ePwTF");

var $dHKP1 = parcelRequire("dHKP1");

var $dYvVi = parcelRequire("dYvVi");
const $9c7151db16a02806$var$reorderColumnsErrorFlag = {
    type: 'error',
    title: (0, $df5k9.default).reorderColumnsErrorTitle,
    description: (0, $df5k9.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-navigator.ui.issue-results.list-view.reorder-columns-error-flag.error',
    messageType: 'transactional'
};
const $9c7151db16a02806$var$resetColumnsErrorFlag = {
    type: 'error',
    title: (0, $df5k9.default).resetColumnsErrorTitle,
    description: (0, $df5k9.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-navigator.ui.issue-results.list-view.reset-columns-error-flag.error',
    messageType: 'transactional'
};
const $9c7151db16a02806$var$TableContainer = ({ children: children })=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9c7151db16a02806$var$TableContainerStyles
    }, children) : children;
const $9c7151db16a02806$export$bec6bbce63eee986 = ()=>{
    const [isRestoringDefaultColumns, setIsRestoringDefaultColumns] = (0, $5uXOq.useState)(false);
    return {
        isRestoringDefaultColumns: isRestoringDefaultColumns,
        setIsRestoringDefaultColumns: setIsRestoringDefaultColumns
    };
};
const $9c7151db16a02806$export$b4f6a715a9e57e85 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { isFilterEditable: isFilterEditable } = (0, $gwtSG.useActiveJql)();
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isLoading: isLoading } = (0, $jlRhf.useColumnPickerLoadingContext)();
        return !isAnonymous && (!(0, $eJ0Zs.isFilterViewId)(view) || isFilterEditable === true) && !isLoading;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { isFetching: isFetching, hasViewIdChanged: hasViewIdChanged, isRefreshing: isRefreshing } = (0, $isIOR.useIssueSearchQuery)();
    const isFetchingView = isFetching && hasViewIdChanged;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { isRestoringDefaultColumns: isRestoringDefaultColumns } = $9c7151db16a02806$export$bec6bbce63eee986();
    return !isAnonymous && (!(0, $eJ0Zs.isFilterViewId)(view) || isFilterEditable === true) && !isFetchingView && !isRefreshing && !isRestoringDefaultColumns;
};
const $9c7151db16a02806$export$539ae4acd804b244 = (onRestoreDefaultColumns, hasDefaultFieldSets)=>{
    const { isFilterEditable: isFilterEditable } = (0, $gwtSG.useActiveJql)();
    const [{ view: selectedView }] = (0, $ih9zY.useSelectedViewState)();
    return !((0, $eJ0Zs.isFilterViewId)(selectedView) && isFilterEditable === false) && hasDefaultFieldSets === false ? onRestoreDefaultColumns : undefined;
};
const $9c7151db16a02806$export$3e7a75a1659bbaae = (onColumnsChange)=>{
    const canEditColumns = $9c7151db16a02806$export$b4f6a715a9e57e85();
    return canEditColumns ? onColumnsChange : undefined;
};
const $9c7151db16a02806$export$d7623a323994e4cc = (selectedColumns)=>{
    const [{ view: selectedView }] = (0, $ih9zY.useSelectedViewState)();
    const canEditColumns = $9c7151db16a02806$export$b4f6a715a9e57e85();
    return (0, $kiKYF.useColumnLoader)(selectedView, canEditColumns, selectedColumns, (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false));
};
const $9c7151db16a02806$export$90b784197d8a906f = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return !isAnonymous ? $9c7151db16a02806$export$d7623a323994e4cc : undefined;
};
const $9c7151db16a02806$export$6a2cc3745a117f8 = ()=>{
    const { hasViewIdChanged: hasViewIdChanged, isFetching: isFetching } = (0, $isIOR.useIssueSearchQuery)();
    const isFetchingView = isFetching && hasViewIdChanged;
    const { isRestoringDefaultColumns: isRestoringDefaultColumns } = $9c7151db16a02806$export$bec6bbce63eee986();
    return {
        /**
     * @deprecated - use ColumnPickerLoadingContext instead
     */ isColumnPickerLoading: isRestoringDefaultColumns || isFetchingView
    };
};
const $9c7151db16a02806$var$ListView = ({ loading: loading, onChangeColumnConfiguration: onChangeColumnConfiguration, onSelectedRowChange: onSelectedRowChange, issueResults: issueResults, groupResults: groupResults, view: view, project: project, issueTableProps: issueTableProps, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, filter: filter, onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld, onIssueFlatListUpdated: onIssueFlatListUpdated })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_LIST_VIEW_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_LIST_VIEW_END);
    }, []);
    const resolvedJql = (0, $gwtSG.useResolvedJql)();
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const issueResultsData = (0, $8Uumt.useFragment)((0, $ebHAX.default), issueResults);
    const groupResultsData = (0, $8Uumt.useFragment)((0, $krXnE.default), groupResults);
    const viewData = (0, $8Uumt.useFragment)((0, $2fw1T.default), view);
    const projectData = (0, $8Uumt.useFragment)((0, $1Fibi.default), project);
    const filterData = (0, $8Uumt.useFragment)((0, $bW3jF.default), filter);
    const selectedIssueKey = (0, $5NwJk.useSelectedIssueKey)();
    const selectedIssueIndex = (0, $5NwJk.useSelectedIssueIndex)();
    const currentPage = issueResultsData?.pageCursors?.around?.find((cursor)=>cursor?.isCurrent)?.pageNumber ?? 1;
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $krnTs.useSortFieldAndDirection)();
    let onIssueSearchForColumnConfig;
    let onRefresh;
    let isColumnPickerLoading;
    let isRestoringDefaultColumns;
    let setIsRestoringDefaultColumns;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // TODO JSC-242 Need to figure out appropriate refetch behaviour, e.g. do we want to try keep visible issues in view?
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ onRefetch: onIssueSearchForColumnConfig, onRefresh: onRefresh } = (0, $38r5c.useIssueSearchActions)());
        ({ isLoading: isColumnPickerLoading, setIsRestoringDefaultColumns: setIsRestoringDefaultColumns } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $jlRhf.useColumnPickerLoadingContext)());
        isRestoringDefaultColumns = false; // Cleanup with jira_spreadsheet_component_m1
    } else {
        ({ onIssueSearchForCurrentPage: onIssueSearchForColumnConfig, onIssueSearchRefresh: onRefresh } = (0, $isIOR.useIssueSearchQuery)());
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ isColumnPickerLoading: isColumnPickerLoading } = $9c7151db16a02806$export$6a2cc3745a117f8());
        ({ isRestoringDefaultColumns: isRestoringDefaultColumns, setIsRestoringDefaultColumns: setIsRestoringDefaultColumns } = // eslint-disable-next-line react-hooks/rules-of-hooks
        $9c7151db16a02806$export$bec6bbce63eee986());
    }
    const onModifyColumns = (0, $5uXOq.useCallback)(()=>{
        onChangeColumnConfiguration && onChangeColumnConfiguration();
        onIssueSearchForColumnConfig();
    }, [
        onChangeColumnConfiguration,
        onIssueSearchForColumnConfig
    ]);
    let onPageChange;
    let fieldSetIds = [];
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    fieldSetIds = (0, $5uXOq.useMemo)(()=>viewData.fieldSets.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData.fieldSets.edges
    ]);
    else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { selectIssueOnPage: selectIssueOnPage } = (0, $gtUFk.useSelectedIssueStateOldActions)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        onPageChange = (0, $5uXOq.useCallback)((cursor, shouldSelectLastIssue)=>{
            selectIssueOnPage(cursor, shouldSelectLastIssue);
        }, [
            selectIssueOnPage
        ]);
    }
    const eventHandlers = (0, $dYvVi.useEventHandlers)(issueResultsData?.__id, fieldSetIds);
    const overriddenTableComponents = issueTableProps?.components;
    const projectContext = issueTableProps?.projectContext;
    const isGroupingSupported = issueTableProps?.isGroupingSupported;
    let infiniteScrollProps = {};
    const viewSettings = (0, $1TiUe.isRefactorNinToViewSchemaEnabled)() ? viewData?.viewSettings : viewData.viewConfigSettings;
    /**
   * isHierarchyEnabled reflects user preference in the current page,
   * canEnableHierarchy reflects whether the hierarchy can be enabled based on the JQL / other settings,
   * isIssueHierarchySupportEnabled reflects whether the hierarchy is supported in the experience.
   * The combination of these three values determines whether issue hierarchy is enabled in issue table.
   */ const isHierarchyEnabled = viewSettings?.isHierarchyEnabled && viewSettings.canEnableHierarchy && isIssueHierarchySupportEnabled;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    infiniteScrollProps = (0, $kj1di.useInfiniteScroll)({
        isHierarchyEnabled: isHierarchyEnabled,
        fieldSetIds: fieldSetIds,
        groupBy: isGroupingSupported ? viewData?.viewSettings?.groupByConfig?.groupByField?.fieldId : undefined,
        view: (0, $6UAdF.views).list,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isHideDoneEnabled: viewSettings?.hideDone || false
    });
    const onSortOrderChange = (0, $5uXOq.useCallback)((sortField, sortDirection)=>setFieldAndDirection(sortField, sortDirection, []), [
        setFieldAndDirection
    ]);
    const hasMaxSelectedColumns = viewData?.fieldSets?.totalCount ? viewData?.fieldSets?.totalCount >= (0, $czfFt.MAX_COLUMNS) : false;
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    let Footer;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) Footer = undefined;
    else Footer = (0, $2lRxk.Footer);
    const [replaceListViewFieldSets] = (0, $8Uumt.useMutation)((0, $gDdVw.default));
    const [replaceSpreadsheetViewFieldSets] = (0, $8Uumt.useMutation)((0, $3Q636.default));
    const onColumnsChange = (0, $5uXOq.useCallback)((columnIds, changeType, optimisticFieldSets, onSuccessCallback, onErrorCallback, retries = 0)=>{
        let attempts = 0;
        // This handler can be called from a native event listener hence React does not batch state updates.
        // We manually batch this update for better rendering performance and more accurate measurement of
        // drag-and-drop interaction performance. We can remove this with React 18's automatic batching.
        (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unstable_batchedUpdates(()=>{
            if (changeType === (0, $czfFt.REORDER_COLUMNS)) (0, $dHKP1.dragAndDropExperience).start();
            const variables = {
                id: viewData.id,
                amountOfColumns: (0, $czfFt.MAX_COLUMNS),
                fieldSetsInput: {
                    replaceFieldSetsInput: {
                        nodes: columnIds
                    }
                },
                includeView: changeType === (0, $czfFt.REORDER_COLUMNS)
            };
            const handleCompleted = (success)=>{
                if (success) {
                    if (changeType === (0, $czfFt.MODIFY_COLUMNS)) onModifyColumns();
                    else if (changeType === (0, $czfFt.REORDER_COLUMNS)) (0, $dHKP1.dragAndDropExperience).success();
                    if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) onSuccessCallback?.();
                } else {
                    const showError = !(0, $4R6GH.fg)('jira_inline_field_config_gate') || attempts === retries;
                    if (showError) {
                        showFlag($9c7151db16a02806$var$reorderColumnsErrorFlag);
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'commitReplaceListViewFieldSetsMutationUnsuccessful',
                                packageName: (0, $6UAdF.PACKAGE_NAME),
                                teamName: (0, $6UAdF.TEAM_NAME)
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            attributes: {
                                changeType: changeType,
                                retries: retries
                            }
                        });
                        if (changeType === (0, $czfFt.REORDER_COLUMNS)) (0, $dHKP1.dragAndDropExperience).failure();
                        if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) onErrorCallback?.();
                    } else {
                        attempts++;
                        commitFieldSets();
                    }
                }
            };
            const handleError = (error)=>{
                const showError = !(0, $4R6GH.fg)('jira_inline_field_config_gate') || attempts === retries;
                if (showError) {
                    showFlag($9c7151db16a02806$var$reorderColumnsErrorFlag);
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'commitReplaceListViewFieldSetsMutationError',
                            packageName: (0, $6UAdF.PACKAGE_NAME),
                            teamName: (0, $6UAdF.TEAM_NAME)
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: {
                            changeType: changeType
                        }
                    });
                    if (changeType === (0, $czfFt.REORDER_COLUMNS)) (0, $dHKP1.dragAndDropExperience).failure();
                    if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) onErrorCallback?.();
                } else {
                    attempts++;
                    commitFieldSets();
                }
            };
            const commitFieldSets = ()=>{
                if ((0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) replaceSpreadsheetViewFieldSets({
                    variables: variables,
                    optimisticResponse: changeType === (0, $czfFt.REORDER_COLUMNS) && optimisticFieldSets ? {
                        jira: {
                            replaceSpreadsheetViewFieldSets: {
                                success: true,
                                view: {
                                    __typename: viewData.__typename,
                                    id: viewData.id,
                                    hasDefaultFieldSets: viewData.hasDefaultFieldSets,
                                    fieldSets: {
                                        ...optimisticFieldSets
                                    }
                                }
                            }
                        }
                    } : undefined,
                    onCompleted (data) {
                        handleCompleted(data.jira?.replaceSpreadsheetViewFieldSets?.success);
                    },
                    onError (error) {
                        handleError(error);
                    }
                });
                else replaceListViewFieldSets({
                    variables: variables,
                    optimisticResponse: changeType === (0, $czfFt.REORDER_COLUMNS) && optimisticFieldSets ? {
                        jira: {
                            replaceIssueSearchViewFieldSets: {
                                success: true,
                                view: {
                                    id: viewData.id,
                                    viewId: viewData.viewId,
                                    hasDefaultFieldSets: viewData.hasDefaultFieldSets,
                                    fieldSets: {
                                        ...optimisticFieldSets
                                    }
                                }
                            }
                        }
                    } : undefined,
                    onCompleted (data) {
                        handleCompleted(data.jira?.replaceIssueSearchViewFieldSets?.success);
                    },
                    onError (error) {
                        handleError(error);
                    }
                });
            };
            commitFieldSets();
        });
    }, [
        viewData.id,
        viewData.__typename,
        viewData.hasDefaultFieldSets,
        viewData.viewId,
        onModifyColumns,
        showFlag,
        replaceSpreadsheetViewFieldSets,
        replaceListViewFieldSets
    ]);
    const [updateFieldSetPreferences] = (0, $8Uumt.useMutation)((0, $59Iqo.default));
    const cloudId = (0, $koeKL.useCloudId)();
    const updateColumnWidth = (0, $5iGOJ.useColumnWidthUpdater)(viewData.fieldSets.__id);
    const onColumnResize = (0, $5uXOq.useCallback)((columnId, width)=>{
        // skip mutation for anonymous users as they don't have access to user preferences
        if (!isAnonymous) // we intentionally don't optimistically update the store to avoid rolling back column widths
        // in case of a mutation error, which would be very jarring for the user
        updateFieldSetPreferences({
            variables: {
                cloudId: cloudId,
                input: {
                    nodes: [
                        {
                            fieldSetId: columnId,
                            width: width ?? null
                        }
                    ]
                }
            },
            onCompleted (data) {
                if (!data.jira?.updateUserFieldSetPreferences?.success) // silently fail as column will remain at the desired width until the next page load
                (0, $jcw0u.default)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationUnsuccessful',
                        packageName: (0, $6UAdF.PACKAGE_NAME),
                        teamName: (0, $6UAdF.TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onError (error) {
                // silently fail as column will remain at the desired width until the next page load
                (0, $jcw0u.default)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationError',
                        packageName: (0, $6UAdF.PACKAGE_NAME),
                        teamName: (0, $6UAdF.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        // commit local update to the store independently of the mutation result to preserve user's desired width
        updateColumnWidth(columnId, width);
    }, [
        cloudId,
        isAnonymous,
        updateColumnWidth,
        updateFieldSetPreferences
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $dHKP1.dragAndDropExperience).markInlineResponse();
    });
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            hasMaxSelectedColumns: hasMaxSelectedColumns,
            filterName: filterData?.name
        }), [
        filterData?.name,
        hasMaxSelectedColumns
    ]);
    const onRestoreDefaultColumns = (0, $5uXOq.useCallback)(()=>{
        setIsRestoringDefaultColumns(true);
        const variables = {
            id: viewData.id,
            amountOfColumns: (0, $czfFt.MAX_COLUMNS),
            includeView: true,
            fieldSetsInput: {
                resetToDefaultFieldSets: true
            }
        };
        const handleCompleted = (success)=>{
            setIsRestoringDefaultColumns(false);
            if (success) onRefresh();
            else {
                showFlag($9c7151db16a02806$var$resetColumnsErrorFlag);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'commitReplaceListViewUsingResetFieldSetsMutationUnsuccessful',
                        packageName: (0, $6UAdF.PACKAGE_NAME),
                        teamName: (0, $6UAdF.TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        const handleError = (error)=>{
            setIsRestoringDefaultColumns(false);
            showFlag($9c7151db16a02806$var$resetColumnsErrorFlag);
            (0, $jcw0u.default)({
                meta: {
                    id: 'commitReplaceListViewUsingResetFieldSetsMutationError',
                    packageName: (0, $6UAdF.PACKAGE_NAME),
                    teamName: (0, $6UAdF.TEAM_NAME)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        };
        if ((0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) replaceSpreadsheetViewFieldSets({
            variables: variables,
            onCompleted (data) {
                handleCompleted(data.jira?.replaceSpreadsheetViewFieldSets?.success);
            },
            onError (error) {
                handleError(error);
            }
        });
        else replaceListViewFieldSets({
            variables: variables,
            onCompleted (data) {
                handleCompleted(data.jira?.replaceIssueSearchViewFieldSets?.success);
            },
            onError (error) {
                handleError(error);
            }
        });
    }, [
        setIsRestoringDefaultColumns,
        viewData.id,
        onRefresh,
        showFlag,
        replaceSpreadsheetViewFieldSets,
        replaceListViewFieldSets
    ]);
    /**
   * returns undefined if there are default field sets
   * returns undefined if the user is on filter tab but cannot edit filter
   */ const conditionalOnRestoreDefaults = $9c7151db16a02806$export$539ae4acd804b244(onRestoreDefaultColumns, viewData?.hasDefaultFieldSets);
    const tableComponents = (0, $5uXOq.useMemo)(// We shallow merge these objects to make it easier for issue-navigator consumers to revert custom column
    // picker components, which are very NIN specific. This decision can be reconsidered if we need to introduce
    // additional nested custom components in the issue table and make those available to all consumers.
    ()=>({
            columnPicker: {
                Container: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bC77a.ColumnPickerRemountManager), {
                        viewIdFromResponse: (0, $eJ0Zs.parseIssueNavigatorViewIdOrDefault)(viewData.viewId),
                        isRestoringDefaults: isRestoringDefaultColumns
                    }, children),
                PopupComponent: (0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, $7UBlg.createPopupComponent)(conditionalOnRestoreDefaults) : (0, $7UBlg.default)
            },
            Footer: Footer,
            IssueCount: $2hlL8.IssueCount,
            NoColumns: $cKSn6.NoColumns,
            NoIssues: $1g3qz.NoIssues,
            ...overriddenTableComponents,
            ConnectionsSubscriber: (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? ({ connections: connections, updateConnectionDetails: updateConnectionDetails })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ev74.BulkOpsConnectionsSubscriber), {
                    connections: connections,
                    updateConnectionDetails: updateConnectionDetails,
                    fragmentRef: issueResultsData || groupResultsData?.firstGroup?.issues || null
                }) : undefined
        }), [
        Footer,
        overriddenTableComponents,
        viewData.viewId,
        isRestoringDefaultColumns,
        issueResultsData,
        groupResultsData?.firstGroup?.issues,
        conditionalOnRestoreDefaults
    ]);
    const conditionalOnChange = $9c7151db16a02806$export$3e7a75a1659bbaae(onColumnsChange);
    const conditionalColumnLoader = $9c7151db16a02806$export$90b784197d8a906f();
    const [isIFCEnabled, ifcConfig] = (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gUt9J.useIFCSidebar)({
        projectKey: projectData?.key,
        projectId: projectData?.projectId
    }) : [
        false,
        undefined
    ];
    const resultsFragment = (0, $aB7bN.exclusiveGroupsOrIssuesFragment)({
        groups: groupResultsData,
        issues: issueResultsData
    });
    if (!resultsFragment) throw new Error('Missing groups or issues data');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "list-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkVdw.DialogContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            currentPage: currentPage,
            isAnonymous: isAnonymous
        }
    }, resultsFragment.issues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePwTF.AsyncRegisterShortcutDialogActions), {
        issues: resultsFragment.issues,
        // TODO Remove when cleaning up jira_spreadsheet_component_m1
        selectedIssueIndex: selectedIssueIndex,
        selectedIssueKey: selectedIssueKey,
        eventHandlers: eventHandlers
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZQx0.ColumnPickerMessageContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9c7151db16a02806$var$TableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32GaU.default), {
        columns: viewData.fieldSets,
        onColumnsChange: conditionalOnChange,
        onRestoreDefaultColumns: conditionalOnRestoreDefaults,
        useColumnLoader: conditionalColumnLoader,
        loading: loading,
        eventHandlers: eventHandlers,
        onSelectedRowChange: onSelectedRowChange,
        onPageChange: onPageChange,
        selectedRow: selectedIssueIndex,
        sortField: field,
        sortDirection: direction,
        onSortChange: onSortOrderChange,
        onRefetch: onIssueSearchForColumnConfig,
        components: tableComponents,
        issueSearchBaseUrl: "" // Relative to current route rendering the issue navigator
        ,
        isColumnPickerLoading: isColumnPickerLoading,
        projectContext: projectContext,
        isGroupingSupported: isGroupingSupported,
        isIssueCreateEnabled: true // It's already tied to the project context
        ,
        onColumnResize: onColumnResize,
        project: projectData,
        isIssueHierarchyEnabled: Boolean(isHierarchyEnabled),
        isInlineEditingExtendedFieldSupportEnabled: (0, $6s1PB.expVal)('jira_list_inline_editing', 'isInlineEditingEnabled', false),
        isInBetweenColumnPickerEnabled: (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false),
        isInlineFieldConfigEnabled: (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false),
        ifcConfig: isIFCEnabled ? ifcConfig : undefined,
        onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld,
        onIssueFlatListUpdated: onIssueFlatListUpdated,
        ...(0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') && {
            jql: resolvedJql
        },
        ...(0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) && {
            enableMultiSelect: true
        },
        ...(0, $6s1PB.expVal)('jira_list_reparenting', 'isReparentingEnabled', false) && {
            isReparentingEnabled: true
        },
        ...(0, $6s1PB.expVal)('jira_list_single_line_row_height', 'isEnabled', false) && {
            isSingleLineRowHeightEnabled: true
        },
        ...(0, $6s1PB.expVal)('jira_list_hide_done_items', 'isEnabled', false) && {
            isHideDoneItemsEnabled: viewSettings?.hideDone ?? false
        },
        ...infiniteScrollProps,
        ...resultsFragment,
        preloadedEntryPoints: issueTableProps?.preloadedEntryPoints
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6bs0c.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};
// re-render regression detection
$9c7151db16a02806$var$ListView.whyDidYouRender = true;
const $9c7151db16a02806$var$ListViewWithColumnPickerContext = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jlRhf.ColumnPickerLoadingContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9c7151db16a02806$var$ListView, props));
const $9c7151db16a02806$var$ConditionalListView = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false), $9c7151db16a02806$var$ListViewWithColumnPickerContext, $9c7151db16a02806$var$ListView);
var $9c7151db16a02806$export$2e2bcd8739ae039 = (0, $1igGa.withReportErrors)($9c7151db16a02806$var$ConditionalListView, {
    id: 'ui.issue-results.list-view.unhandled',
    packageName: (0, $6UAdF.PACKAGE_NAME),
    teamName: (0, $6UAdF.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $gcl1l.isLoaderErrorAttributes)
});
const $9c7151db16a02806$var$TableContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    flexBasis: 0,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    flexDirection: 'column'
});

});
parcelRegister("59Iqo", function(module, exports) {

$parcel$export(module.exports, "default", () => $02853882c92b5022$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f869b29cb2bead806de4a76c098662d6>>
 * @relayHash 49c7fff6a0e7619f946ea6858ac070f4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aa78c7137d4bf2c426f358e5e8e25a3d05afb5062d08ddd15fa808b550e9004e
const $02853882c92b5022$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "fieldSetPreferencesInput",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraFieldSetPreferencesUpdatePayload",
                    "kind": "LinkedField",
                    "name": "updateUserFieldSetPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "aa78c7137d4bf2c426f358e5e8e25a3d05afb5062d08ddd15fa808b550e9004e",
            "metadata": {},
            "name": "main_updateFieldSetPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$02853882c92b5022$var$node.hash = "5e33dd509f20cf3d934020e4f1ce2386";
var $02853882c92b5022$export$2e2bcd8739ae039 = $02853882c92b5022$var$node;

});

parcelRegister("3Q636", function(module, exports) {

$parcel$export(module.exports, "default", () => $189300f3c547d1b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8cc27382846fe18ad0b3306d2a0863d8>>
 * @relayHash 3759b0a00447a28fce7511f0049c259c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 02b6ff2f4ecea3efa1709a6d72c249bf8addd5ec4fc100f74e9622756189a48c
const $189300f3c547d1b2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeView"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "success"
    }, v6 = {
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v7 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v9 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v10 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceSpreadsheetViewFieldSets",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v7 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceSpreadsheetViewFieldSets",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v6 /*: any*/ ,
                                                {
                                                    "args": v7 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jqlTerm"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v11 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v10 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "02b6ff2f4ecea3efa1709a6d72c249bf8addd5ec4fc100f74e9622756189a48c",
            "metadata": {},
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$189300f3c547d1b2$var$node.hash = "a7c1d97e88a3beacc3da435a1deabb4f";
var $189300f3c547d1b2$export$2e2bcd8739ae039 = $189300f3c547d1b2$var$node;

});

parcelRegister("gDdVw", function(module, exports) {

$parcel$export(module.exports, "default", () => $d20acc54f93c21cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0f421aa32b019ac864a29be3bb22a691>>
 * @relayHash 6004b7f3013cab7c9711821c41f742b7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ed65b6a9227ed4aeab495e7c0afb22d73e7cda56158c467c30064489593c4c12
const $d20acc54f93c21cf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeView"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "viewId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v10 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v12 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v13 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_replaceListViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueSearchViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceIssueSearchViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchView",
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "args": v10 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_replaceListViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueSearchViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceIssueSearchViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueSearchView",
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                {
                                                    "args": v10 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jqlTerm"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v14 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ed65b6a9227ed4aeab495e7c0afb22d73e7cda56158c467c30064489593c4c12",
            "metadata": {},
            "name": "main_replaceListViewFieldSetsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d20acc54f93c21cf$var$node.hash = "466463d5818b0ea99c65ad6cd3e34d53";
var $d20acc54f93c21cf$export$2e2bcd8739ae039 = $d20acc54f93c21cf$var$node;

});

parcelRegister("bW3jF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b474cf232be6876b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1ac4ee09aa06d0c162ef3bdadd8c445>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b474cf232be6876b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$b474cf232be6876b$var$node.hash = "42fd583d4b19e59270b0aa45271f2d67";
var $b474cf232be6876b$export$2e2bcd8739ae039 = $b474cf232be6876b$var$node;

});

parcelRegister("1Fibi", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a08b67ac7f6a8a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ecb59397caeeba8b1f96e7ccfec494a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $98a08b67ac7f6a8a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_nativeIssueTable_NativeIssueTable_project"
        }
    ],
    "type": "JiraProject"
};
$98a08b67ac7f6a8a$var$node.hash = "704e90d839184a3c8963617bf36efd8c";
var $98a08b67ac7f6a8a$export$2e2bcd8739ae039 = $98a08b67ac7f6a8a$var$node;

});

parcelRegister("2fw1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a78a0369755798f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0339d79f2fb3448a4d2c28b026866c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9a78a0369755798f$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "staticViewInput",
        "variableName": "staticViewInput"
    }, v1 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v2 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v3 = {
        "kind": "ScalarField",
        "name": "hideDone"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "staticViewInput"
            }
        ],
        "kind": "Fragment",
        "name": "main_issueNavigator_ListView_view",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "viewId"
                },
                "action": "THROW",
                "path": "viewId"
            },
            {
                "kind": "ScalarField",
                "name": "hasDefaultFieldSets"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "filter",
                            "value": {
                                "fieldSetSelectedState": "SELECTED"
                            }
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "amountOfColumns"
                        }
                    ],
                    "concreteType": "JiraIssueSearchFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        },
                        {
                            "concreteType": "JiraIssueSearchFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueSearchFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldSetId"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "fieldSets"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    v0 /*: any*/ 
                                ],
                                "concreteType": "JiraIssueSearchViewConfigSettings",
                                "kind": "LinkedField",
                                "name": "viewConfigSettings",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraIssueSearchView"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "groupBy",
                                "variableName": "groupBy"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            v0 /*: any*/ 
                        ],
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "concreteType": "JiraSpreadsheetGroupByConfig",
                                "kind": "LinkedField",
                                "name": "groupByConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraField",
                                        "kind": "LinkedField",
                                        "name": "groupByField",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v1 /*: any*/ ,
                            v3 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
            }
        ],
        "type": "JiraIssueSearchViewMetadata",
        "abstractKey": "__isJiraIssueSearchViewMetadata"
    };
}();
$9a78a0369755798f$var$node.hash = "8176dda3a5404b6fc7ea9b10dc04e07e";
var $9a78a0369755798f$export$2e2bcd8739ae039 = $9a78a0369755798f$var$node;

});

parcelRegister("krXnE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd44a72c3036ca18$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d652a1b2284d199da24c97c8d94c171c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cd44a72c3036ca18$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_groupResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ui_nativeIssueTable_NativeIssueTable_groups"
        },
        {
            "condition": "isPaginating",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraSpreadsheetGroup",
                    "kind": "LinkedField",
                    "name": "firstGroup",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 50
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$cd44a72c3036ca18$var$node.hash = "704a4bd6ed89da1a55b318db843e480c";
var $cd44a72c3036ca18$export$2e2bcd8739ae039 = $cd44a72c3036ca18$var$node;

});

parcelRegister("ebHAX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be221d7b1d11260$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92eb7e574617eb356b13722ca2af5d5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5be221d7b1d11260$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "registerShortcutDialogActions_issueNavigator_RegisterShortcutsDialogActions"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ui_nativeIssueTable_NativeIssueTable_issues"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "maxCursors",
                    "value": 7
                }
            ],
            "concreteType": "JiraPageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "around",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageNumber"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCurrent"
                        }
                    ]
                }
            ],
            "storageKey": "pageCursors(maxCursors:7)"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$5be221d7b1d11260$var$node.hash = "8788f53f8a15dc0aef8fef526135d46a";
var $5be221d7b1d11260$export$2e2bcd8739ae039 = $5be221d7b1d11260$var$node;

});

parcelRegister("6bs0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $c801f3f91f59a7ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gjEtj = parcelRequire("gjEtj");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c801f3f91f59a7ab$var$AsyncAttachFileModal = (0, $kxZPA.lazy)(()=>(parcelRequire("3BuhX")), {
    moduleId: "./src/packages/issue-navigator/issue-operations/dialogs/attach-file-dialog/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c801f3f91f59a7ab$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "attach-file-dialog",
        packageName: "native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c801f3f91f59a7ab$var$AsyncAttachFileModal, null));

});
parcelRegister("3BuhX", function(module, exports) {

let $29fc52789a4e50d9$var$load = (parcelRequire("28QjX"))(4);
module.exports = $29fc52789a4e50d9$var$load("6Rhyy").then(()=>parcelRequire('jStLa'));

});


parcelRegister("gkVdw", function(module, exports) {

$parcel$export(module.exports, "DialogContextContainer", () => $2bf33a8fdc4b74e3$export$8e9ef3fae6d51d86);
$parcel$export(module.exports, "useIssueOperationsDialogContext", () => $2bf33a8fdc4b74e3$export$a2a00ec2da7337e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $2bf33a8fdc4b74e3$var$initialState = {
    openDialog: null,
    issueKey: null,
    issueId: null,
    mediaUploadContext: null
};
const $2bf33a8fdc4b74e3$var$actions = {
    setDialogContext: (openDialog, issueId, issueKey, mediaUploadContext)=>({ setState: setState })=>{
            setState({
                openDialog: openDialog,
                issueId: issueId,
                issueKey: issueKey,
                mediaUploadContext: mediaUploadContext
            });
        }
};
const $2bf33a8fdc4b74e3$var$Store = (0, $iXqE5.createStore)({
    initialState: $2bf33a8fdc4b74e3$var$initialState,
    actions: $2bf33a8fdc4b74e3$var$actions,
    name: 'IssueNavigatorIssueOperationsDialogContext'
});
const $2bf33a8fdc4b74e3$export$8e9ef3fae6d51d86 = (0, $gg7kZ.createContainer)($2bf33a8fdc4b74e3$var$Store);
const $2bf33a8fdc4b74e3$export$a2a00ec2da7337e = (0, $3sQ5x.createHook)($2bf33a8fdc4b74e3$var$Store);

});

parcelRegister("aB7bN", function(module, exports) {

$parcel$export(module.exports, "isNonNullish", () => $9f1ae0edfbf313d7$export$70573498ee17fe1d);
$parcel$export(module.exports, "isKnownColumnType", () => $9f1ae0edfbf313d7$export$e8280bcdc1c3f84);
$parcel$export(module.exports, "exclusiveGroupsOrIssuesFragment", () => $9f1ae0edfbf313d7$export$7ac78cf15a1a4ba3);
$parcel$export(module.exports, "getProjectKeyFromIssueKey", () => $9f1ae0edfbf313d7$export$defe38779a6b81d2);
$parcel$export(module.exports, "escapeBackslashes", () => $9f1ae0edfbf313d7$export$fbd15c27bb7e257c);

var $65VLO = parcelRequire("65VLO");

function $9f1ae0edfbf313d7$export$70573498ee17fe1d(value) {
    return value != null;
}
function $9f1ae0edfbf313d7$export$e8280bcdc1c3f84(value) {
    return value !== undefined && Object.values((0, $65VLO.KNOWN_COLUMN_TYPES)).includes(value);
}
function $9f1ae0edfbf313d7$export$7ac78cf15a1a4ba3({ groups: groups, issues: issues }) {
    if (issues) return {
        groups: null,
        issues: issues
    };
    if (groups) return {
        groups: groups,
        issues: null
    };
    return null;
}
function $9f1ae0edfbf313d7$export$defe38779a6b81d2(issueKey) {
    return issueKey.split('-')[0];
}
const $9f1ae0edfbf313d7$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');

});
parcelRegister("65VLO", function(module, exports) {

$parcel$export(module.exports, "KNOWN_COLUMN_TYPES", () => $1fec13ea3747c865$export$bbc2e8c301f97f97);
const $1fec13ea3747c865$export$bbc2e8c301f97f97 = {
    ASSIGNEE: 'assignee',
    CHECKBOX: '__issuetable_internal_checkbox',
    CHECKBOX_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    DESCRIPTION: 'description',
    ENVIRONMENT: 'environment',
    EXPAND_BUTTON: '__issuetable_internal_expand_button',
    ISSUE_KEY: 'issuekey',
    ISSUE_OPERATIONS: '__issuetable_internal_meatball',
    STATUS: 'status',
    SUMMARY: 'summary',
    ISSUE_TYPE: 'issuetype',
    RESOLUTION: 'resolution',
    PARENT: 'parent',
    LABELS: 'labels',
    COMPONENTS: 'components',
    FIX_VERSIONS: 'fixVersions',
    STATUS_CATEGORY: 'statusCategory',
    PROJECT: 'project',
    READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
    SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
    TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
    CREATED: 'created',
    RESOLUTION_DATE: 'resolutiondate',
    TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
    UPDATED: 'updated',
    DUE_DATE: 'duedate',
    REPORTER: 'reporter',
    CREATOR: 'creator',
    PRIORITY: 'priority',
    AFFECTS_VERSIONS: 'versions',
    REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
    NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points',
    USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    CUSTOM_LABELS: 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
    DATE_TIME: 'com.atlassian.jira.plugin.system.customfieldtypes:datetime',
    URL: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
    SINGLE_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
    MULTI_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    MULTI_USER_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker',
    TEAM: 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team',
    ORIGINAL_ESTIMATE: 'timeoriginalestimate',
    GOALS: 'com.atlassian.jira.plugin.system.customfieldtypes:goals',
    CASCADING_SELECT: 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect',
    CONFLUENCE_PAGES: 'confluenceRemoteIssueLinks',
    PEOPLE: 'com.atlassian.jira.plugin.system.customfieldtypes:people',
    DATE_PICKER: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker'
};
const $1fec13ea3747c865$export$de4c02b525d877fa = '__issuetable_internal_meatball';
const $1fec13ea3747c865$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
const $1fec13ea3747c865$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';

});


parcelRegister("5iGOJ", function(module, exports) {

$parcel$export(module.exports, "useColumnWidthUpdater", () => $64afe22c2487a08a$export$e54397ae25183faf);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");
const $64afe22c2487a08a$export$e54397ae25183faf = (connectionId)=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)((columnId, width)=>{
        (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const connection = store.get(connectionId);
            const fieldSetEdges = connection?.getLinkedRecords('edges') ?? [];
            const fieldSetEdge = fieldSetEdges.find((edge)=>{
                const fieldSetId = edge?.getLinkedRecord('node')?.getValue('fieldSetId');
                return columnId === fieldSetId;
            });
            if (!fieldSetEdge) return;
            const fieldSetNode = fieldSetEdge.getLinkedRecord('node');
            if (!fieldSetNode) return;
            if (width == null) {
                fieldSetNode.setValue(null, 'fieldSetPreferences');
                return;
            }
            const fieldSetPreferences = fieldSetNode.getOrCreateLinkedRecord('fieldSetPreferences', 'JiraFieldSetPreferences');
            fieldSetPreferences.setValue(width, 'width');
        });
    }, [
        connectionId,
        environment
    ]);
};

});

parcelRegister("32GaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6283edc5fe5ca969$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $l8ruj = parcelRequire("l8ruj");

var $7CMCs = parcelRequire("7CMCs");

var $frBVt = parcelRequire("frBVt");

var $4R6GH = parcelRequire("4R6GH");

var $hxGva = parcelRequire("hxGva");

const $6283edc5fe5ca969$var$AsyncNativeIssueTable = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("4afSm")), {
    moduleId: "./src/packages/platform/ui/issue-table/issue-table/src/ui/index.tsx"
});
const $6283edc5fe5ca969$var$AsyncNativeIssueTableOld = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hxGva.IssueTableSkeleton), null),
        name: "async-native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6283edc5fe5ca969$var$AsyncNativeIssueTable, props)));
const $6283edc5fe5ca969$var$AsyncNativeIssueTableNew = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const entryPointReference = props.preloadedEntryPoints?.nativeIssueTableEntryPoint;
    if (entryPointReference && (0, $4R6GH.fg)('jira_list_issue_table_entrypoint')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "native-issue-table-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "native-issue-table-entrypoint",
        packageName: "jiraNativeIssueTable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: "native-issue-table",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hxGva.IssueTableSkeleton), null),
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // EntryPointContainer can't infer the type of props from entryPointReference correctly
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: props
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6283edc5fe5ca969$var$AsyncNativeIssueTableOld, props);
});
var $6283edc5fe5ca969$export$2e2bcd8739ae039 = $6283edc5fe5ca969$var$AsyncNativeIssueTableNew;

});
parcelRegister("hxGva", function(module, exports) {

$parcel$export(module.exports, "IssueTableSkeleton", () => $d6b3a71d2cc1f810$export$32020b6a5557f03e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k42jv = parcelRequire("k42jv");
const $d6b3a71d2cc1f810$export$32020b6a5557f03e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d6b3a71d2cc1f810$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k42jv.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6b3a71d2cc1f810$var$SkeletonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4afSm", function(module, exports) {

let $3084692e8e067778$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3084692e8e067778$var$load("h2MrD"),
    $3084692e8e067778$var$load("bYT2S"),
    $3084692e8e067778$var$load("dsiAd"),
    $3084692e8e067778$var$load("hPzOn"),
    $3084692e8e067778$var$load("nEBxE")
]).then(()=>parcelRequire('bPcgy'));

});


parcelRegister("jlRhf", function(module, exports) {

$parcel$export(module.exports, "useColumnPickerLoadingContext", () => $7e5a5499bbded874$export$bd7ab5278af9a7dd);
$parcel$export(module.exports, "ColumnPickerLoadingContextProvider", () => $7e5a5499bbded874$export$9e9936dbd6aef092);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $38r5c = parcelRequire("38r5c");
const $7e5a5499bbded874$var$defaultState = {
    isLoading: false,
    setIsRestoringDefaultColumns: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $7e5a5499bbded874$var$ColumnPickerLoadingContext = /*#__PURE__*/ (0, $5uXOq.createContext)($7e5a5499bbded874$var$defaultState);
const $7e5a5499bbded874$export$bd7ab5278af9a7dd = ()=>(0, $5uXOq.useContext)($7e5a5499bbded874$var$ColumnPickerLoadingContext);
const $7e5a5499bbded874$export$9e9936dbd6aef092 = ({ children: children })=>{
    const [isRestoringDefaultColumns, setIsRestoringDefaultColumns] = (0, $5uXOq.useState)(false);
    const isFetchingView = (0, $38r5c.useIsFetchingView)();
    const isRefreshing = (0, $38r5c.useIsRefreshing)();
    const isLoading = isRestoringDefaultColumns || isFetchingView || isRefreshing;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isLoading: isLoading,
            setIsRestoringDefaultColumns: setIsRestoringDefaultColumns
        }), [
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e5a5499bbded874$var$ColumnPickerLoadingContext.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("hZQx0", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerMessageContext", () => $709509bebc56c733$export$2f14e8286acf4660);

var $5uXOq = parcelRequire("5uXOq");
const $709509bebc56c733$var$defaultMessageContext = {
    hasMaxSelectedColumns: false
};
const $709509bebc56c733$export$2f14e8286acf4660 = /*#__PURE__*/ (0, $5uXOq.createContext)($709509bebc56c733$var$defaultMessageContext);

});

parcelRegister("kiKYF", function(module, exports) {

$parcel$export(module.exports, "useColumnLoader", () => $c727c8c1b7da3679$export$6dc2ac601f90aafc);

var $5MNOm = parcelRequire("5MNOm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $cgL5K = parcelRequire("cgL5K");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $hH4aB = parcelRequire("hH4aB");

var $Nu4Sg = parcelRequire("Nu4Sg");

var $kHDIc = parcelRequire("kHDIc");

var $koeKL = parcelRequire("koeKL");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $bWSqf = parcelRequire("bWSqf");

var $2F3SN = parcelRequire("2F3SN");
const $c727c8c1b7da3679$var$mapColumnPickerOptions = (data, search, intl, selectedColumns, canEditColumns, isIFCEnabled)=>{
    let totalCount = 0;
    let edges;
    let endCursor;
    if (!isIFCEnabled && data?.jira.issueSearchViewByNamespaceAndViewId?.fieldSets) {
        totalCount = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount;
        edges = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges;
        endCursor = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo?.endCursor ? data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo.endCursor : undefined;
    }
    if (isIFCEnabled && data?.jira.issueSearchViewResult?.fieldSets) {
        totalCount = data?.jira.issueSearchViewResult.fieldSets.totalCount;
        edges = data?.jira.issueSearchViewResult.fieldSets.edges;
        endCursor = data?.jira.issueSearchViewResult.fieldSets.pageInfo?.endCursor ? data?.jira.issueSearchViewResult.fieldSets.pageInfo.endCursor : undefined;
    }
    // @ts-expect-error - Argument of type '(edge: Node) => { secondaryLabel?: JSX.Element | undefined; isDisabled?: true | undefined; disabledMessage?: React.ReactNode; optionType: "option"; cursor: string; value: string; label: string; }' is not assignable to parameter of type '(value: { readonly cursor: string; readonly node: { readonly displayName: string; readonly fieldSetId: string; readonly fieldType?: { readonly displayName: string | null | undefined; } | null | undefined; readonly type: string; }; }, index: number, array: { ...; }[]) => { ...; }'.
    const options = edges?.filter((0, $eJ0Zs.isNonNullish)).map((edge)=>{
        const fieldTypeDisplayName = edge.node.fieldType?.displayName;
        const icon = edge.node.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHDIc.FieldTypeIcon), {
            type: edge.node.type,
            size: "small"
        }) : undefined;
        const isOnlyUnselectable = (0, $2F3SN.isOnlyUnselectableField)(edge.node.type, canEditColumns);
        return {
            optionType: 'option',
            cursor: edge.cursor,
            value: edge.node.fieldSetId,
            label: edge.node.displayName,
            secondaryLabel: fieldTypeDisplayName && icon ? (0, $Nu4Sg.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
            ...isOnlyUnselectable && {
                isOnlyUnselectable: isOnlyUnselectable,
                disabledMessage: intl.formatMessage((0, $bWSqf.default).deprecatedParentyLinkMessage, {
                    field: edge.node.displayName,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                            as: "strong",
                            color: "inherit",
                            size: "UNSAFE_small"
                        }, chunks)
                })
            },
            ...isIFCEnabled && {
                customWidth: edge.node.fieldSetPreferences?.width,
                type: edge.node.type
            }
        };
    });
    if (!options?.length) return {
        options: [],
        totalCount: 0
    };
    if (search.length) return {
        options: options,
        totalCount: totalCount,
        endCursor: endCursor
    };
    // total count is the count of unselected options for non-search queries
    totalCount += selectedColumns.length;
    return {
        options: [
            {
                id: (0, $6UAdF.ALL_COLUMNS_ID),
                label: intl.formatMessage((0, $bWSqf.default).columnGroupHeader),
                optionType: 'group',
                options: options
            }
        ],
        totalCount: totalCount,
        endCursor: endCursor
    };
};
const $c727c8c1b7da3679$export$6dc2ac601f90aafc = (viewId, canEditColumns, selectedColumns, isIFCEnabled)=>{
    const intl = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    // refs for selectedColumns, endCursor and search prevent outdated data in the relay store from being used
    // in cases when selected options changes & picker is paginated
    const columnsRef = (0, $5uXOq.useRef)(selectedColumns);
    const endCursorRef = (0, $5uXOq.useRef)();
    const searchRef = (0, $5uXOq.useRef)();
    const loadedOptionsRef = (0, $5uXOq.useRef)();
    return (0, $5uXOq.useMemo)(()=>(0, $hH4aB.createDebouncedColumnLoader)(async (search, renderInitialValues, endCursor)=>{
            let cursor = endCursor;
            if (!canEditColumns) {
                const options = selectedColumns ? selectedColumns.filter((col)=>col.optionType === 'option' && (search ? col.label.toLocaleLowerCase().includes(search.toLocaleLowerCase()) : true)) : [];
                return Promise.resolve({
                    options: options,
                    totalCount: options.length
                });
            }
            // calculate cursor from edges, since endCursor might not be valid anymore when last option was selected
            if (endCursor !== undefined && loadedOptionsRef.current && selectedColumns) cursor = (0, $2F3SN.getCursorOfLastUnselectedOption)(loadedOptionsRef.current, selectedColumns, search, endCursor);
            try {
                const result = await (0, $8Uumt.fetchQuery)(environment, (0, $5MNOm.default), {
                    cloudId: cloudId,
                    namespace: (0, $6UAdF.ISSUE_SEARCH_NAMESPACE),
                    viewId: viewId,
                    first: 25,
                    after: cursor,
                    filter: {
                        searchString: search,
                        fieldSetSelectedState: !search ? 'NON_SELECTED' : 'ALL'
                    },
                    isIFCEnabled: !!isIFCEnabled
                }, {
                    fetchPolicy: columnsRef.current !== selectedColumns || endCursorRef.current !== cursor || searchRef.current !== search ? 'network-only' : 'store-or-network'
                }).toPromise();
                columnsRef.current = selectedColumns;
                endCursorRef.current = cursor;
                searchRef.current = search;
                const pickerOptions = $c727c8c1b7da3679$var$mapColumnPickerOptions(result, search, intl, selectedColumns, canEditColumns, isIFCEnabled);
                loadedOptionsRef.current = pickerOptions.options || undefined;
                return pickerOptions;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'fetchColumnPickerOptions',
                        packageName: (0, $6UAdF.PACKAGE_NAME),
                        teamName: (0, $6UAdF.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                loadedOptionsRef.current = undefined;
                return {
                    options: [
                        {
                            optionType: 'error',
                            error: error,
                            onRetry: ()=>undefined
                        }
                    ],
                    totalCount: 0
                };
            }
        }), [
        canEditColumns,
        cloudId,
        environment,
        intl,
        isIFCEnabled,
        selectedColumns,
        viewId
    ]);
};

});
parcelRegister("5MNOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $611919e8b187ec0e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ede3a039e0a48fb848162fb9dde351a>>
 * @relayHash cab0eefa33d0d1c36a97ce8b73b3afb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 446095d828f64da903b60abae20e5d251003a76cbf9d089a7ca34036c1918133
const $611919e8b187ec0e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIFCEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v12 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "type"
    }, v15 = {
        "concreteType": "JiraFieldType",
        "kind": "LinkedField",
        "name": "fieldType",
        "plural": false,
        "selections": [
            v13 /*: any*/ 
        ]
    }, v16 = {
        "concreteType": "JiraFieldSetPreferences",
        "kind": "LinkedField",
        "name": "fieldSetPreferences",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "isIFCEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchView",
                                            "kind": "LinkedField",
                                            "name": "issueSearchViewByNamespaceAndViewId",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "args": v8 /*: any*/ ,
                                                        "concreteType": "JiraIssueSearchFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSets",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v9 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount"
                                                            },
                                                            v10 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueSearchFieldSet",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v12 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.fieldSetId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v13 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.displayName"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v14 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.type"
                                                                                    },
                                                                                    v15 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.issueSearchViewByNamespaceAndViewId"
                                    }
                                ]
                            },
                            {
                                "condition": "isIFCEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v7 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "issueSearchViewResult",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "args": v8 /*: any*/ ,
                                                                "concreteType": "JiraIssueSearchFieldSetConnection",
                                                                "kind": "LinkedField",
                                                                "name": "fieldSets",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v9 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "jira.issueSearchViewResult.fieldSets.totalCount"
                                                                    },
                                                                    v10 /*: any*/ ,
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": {
                                                                                        "concreteType": "JiraIssueSearchFieldSet",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v12 /*: any*/ ,
                                                                                                "action": "THROW",
                                                                                                "path": "jira.issueSearchViewResult.fieldSets.edges.node.fieldSetId"
                                                                                            },
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v13 /*: any*/ ,
                                                                                                "action": "THROW",
                                                                                                "path": "jira.issueSearchViewResult.fieldSets.edges.node.displayName"
                                                                                            },
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v14 /*: any*/ ,
                                                                                                "action": "THROW",
                                                                                                "path": "jira.issueSearchViewResult.fieldSets.edges.node.type"
                                                                                            },
                                                                                            v15 /*: any*/ ,
                                                                                            v16 /*: any*/ 
                                                                                        ]
                                                                                    },
                                                                                    "action": "THROW",
                                                                                    "path": "jira.issueSearchViewResult.fieldSets.edges.node"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "jira.issueSearchViewResult.fieldSets.edges"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.issueSearchViewResult.fieldSets"
                                                        }
                                                    ],
                                                    "type": "JiraIssueSearchView"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.issueSearchViewResult"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isIFCEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraIssueSearchView",
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewByNamespaceAndViewId",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                v13 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                v15 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isIFCEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewResult",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v8 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraIssueSearchView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v17 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "446095d828f64da903b60abae20e5d251003a76cbf9d089a7ca34036c1918133",
            "metadata": {},
            "name": "fetchColumnPickerOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$611919e8b187ec0e$var$node.hash = "921f1fdd989c0f6dbf67c6e1e7e52de9";
var $611919e8b187ec0e$export$2e2bcd8739ae039 = $611919e8b187ec0e$var$node;

});

parcelRegister("hH4aB", function(module, exports) {

$parcel$export(module.exports, "MAX_COLUMNS", () => $3fccc46c5f9227b4$export$7ec4af037f372df4);
$parcel$export(module.exports, "createDebouncedColumnLoader", () => $3fccc46c5f9227b4$export$a6cff24b97727de1);

var $7pFAn = parcelRequire("7pFAn");

const $3fccc46c5f9227b4$export$7ec4af037f372df4 = 500;
const $3fccc46c5f9227b4$export$a6cff24b97727de1 = (0, $7pFAn.createGenericDebouncableDataLoader);

});
parcelRegister("7pFAn", function(module, exports) {

$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $b301ace3fb837e49$export$ea63a11564958c9e);

var $lFKmC = parcelRequire("lFKmC");
const $b301ace3fb837e49$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $b301ace3fb837e49$export$2e2bcd8739ae039 = $b301ace3fb837e49$export$ea63a11564958c9e;

});


parcelRegister("Nu4Sg", function(module, exports) {

$parcel$export(module.exports, "getSecondaryLabelWithIcon", () => $f4ca1075411980d4$export$de24d837eb50c435);

var $5uXOq = parcelRequire("5uXOq");
const $f4ca1075411980d4$export$de24d837eb50c435 = (icon, fieldTypeDisplayName)=>({
        label: fieldTypeDisplayName,
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, icon, fieldTypeDisplayName)
    });

});

parcelRegister("kHDIc", function(module, exports) {

$parcel$export(module.exports, "fieldTypesIcons", () => $84df96f6dc813d24$export$67f993f3bbfb364d);
$parcel$export(module.exports, "panelIcons", () => $84df96f6dc813d24$export$4641b622f6c36f58);
$parcel$export(module.exports, "allFieldTypeGlyphs", () => $84df96f6dc813d24$export$14355977bfae6aaa);
$parcel$export(module.exports, "StrictFieldTypeIcon", () => $84df96f6dc813d24$export$aaac7dbe01e6025d);
$parcel$export(module.exports, "FieldTypeIcon", () => $84df96f6dc813d24$export$87c5289d8835f589);
$parcel$export(module.exports, "default", () => $84df96f6dc813d24$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $4iV1e = parcelRequire("4iV1e");

var $b0XU0 = parcelRequire("b0XU0");

var $4hqZ5 = parcelRequire("4hqZ5");

var $h8cgU = parcelRequire("h8cgU");

var $fyC9a = parcelRequire("fyC9a");

var $5fc53 = parcelRequire("5fc53");

var $5fc53 = parcelRequire("5fc53");
var $3XO6n = parcelRequire("3XO6n");

var $VoGvu = parcelRequire("VoGvu");
// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
const $84df96f6dc813d24$var$ResizedIcon = ({ glyph: glyph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: "",
        glyph: glyph,
        size: "medium"
    });
const $84df96f6dc813d24$var$checkedFieldTypesIcons = {
    [(0, $5fc53.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.numberGlyph)
    }),
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.numberGlyph)
    }),
    [(0, $5fc53.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    [(0, $5fc53.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.radioGlyph)
    }),
    [(0, $5fc53.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.doubleDropdownGlyph)
    }),
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $3XO6n.USERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $3XO6n.MULTIUSERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.FLAGGED_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    [(0, $5fc53.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $5fc53.TEAM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    // <ResizedIcon /> was introduced when SWIFT had a limited number of supported field types,
    // but it's no longer a scalable option. We should be using icons directly provided by @atlaskit,
    // and if it does not match our design constraints, then we'll need to investigate contributing to a new @atlaskit icon set.
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
        spacing: "spacious",
        label: ""
    }),
    [(0, $5fc53.PARENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $5fc53.BASELINE_START_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.BASELINE_END_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.shipGlyph)
    }),
    [(0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGroupGlyph)
    }),
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.officeBuildingGlyph)
    }),
    [(0, $5fc53.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.ATTACHMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.attachmentGlyph)
    }),
    [(0, $5fc53.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    [(0, $5fc53.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.priorityGlyph)
    }),
    [(0, $5fc53.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.TIME_ESTIMATE_CONFIG_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    [(0, $5fc53.TIME_TRACKING_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeTrackingGlyph)
    }),
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.originalTimeEstimateGlyph)
    }),
    [(0, $5fc53.ASSETS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.screenGlyph)
    }),
    [(0, $5fc53.SERVICE_ENTITY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    [(0, $5fc53.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.arrowRightGlyph)
    }),
    [(0, $5fc53.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.shortTextGlyph)
    }),
    [(0, $3XO6n.DESCRIPTION_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.shortTextGlyph)
    }),
    [(0, $3XO6n.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.checkboxGlyph)
    }),
    [(0, $5fc53.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $3XO6n.ENVIRONMENT_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.commentGlyph)
    }),
    [(0, $5fc53.APPROVERS_LIST_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.appAccessGlyph)
    }),
    [(0, $5fc53.APPROVALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.appAccessGlyph)
    }),
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.folderGlyph)
    }),
    [(0, $5fc53.MESSAGE_EDIT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.MESSAGE_VIEW_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.jwmCategoryGlyph)
    }),
    [(0, $5fc53.ENTITLEMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.SENTIMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $5fc53.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }),
    [(0, $5fc53.ORGANIZATION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    })
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$84df96f6dc813d24$var$checkedFieldTypesIcons
});
const $84df96f6dc813d24$export$67f993f3bbfb364d = $84df96f6dc813d24$var$checkedFieldTypesIcons;
const $84df96f6dc813d24$export$4641b622f6c36f58 = {
    development: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0XU0))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    devSummary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0XU0))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    timetracking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fyC9a))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    })
};
/**
 * @deprecated - consider using allFieldTypeGlyphs or FieldTypeIcon instead
 */ const $84df96f6dc813d24$var$allIcons = {
    ...$84df96f6dc813d24$export$67f993f3bbfb364d,
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    number: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.numberGlyph)
    }),
    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    datetime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    dropdown: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    addon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.addonGlyph)
    }),
    checkbox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.checkboxGlyph)
    }),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.radioGlyph)
    }),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.commentGlyph)
    }),
    bulletList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.bulletListGlyph)
    }),
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    labelpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.closeGlyph)
    }),
    assetspicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.screenGlyph)
    }),
    select: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    multiselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    cascadingselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.doubleDropdownGlyph)
    }),
    multigrouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    grouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    multiversion: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    version: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    projectpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    customField: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    })
};
const $84df96f6dc813d24$var$checkedFieldTypesGlyphs = {
    [(0, $5fc53.NUMBER_CF_TYPE)]: (0, $VoGvu.numberGlyph),
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $VoGvu.numberGlyph),
    [(0, $5fc53.LABELS_CF_TYPE)]: (0, $VoGvu.labelGlyph),
    [(0, $5fc53.DATE_CF_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.DATETIME_CF_TYPE)]: (0, $VoGvu.timeStampGlyph),
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: (0, $VoGvu.radioGlyph),
    [(0, $5fc53.SELECT_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: (0, $VoGvu.doubleDropdownGlyph),
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.VERSION_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.GROUP_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.USER_CF_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $3XO6n.USERPICKER_FIELD_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $3XO6n.MULTIUSERPICKER_FIELD_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.PEOPLE_CF_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.FLAGGED_CF_TYPE)]: (0, $VoGvu.timeStampGlyph),
    [(0, $5fc53.URL_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.TEAM_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.PARENT_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.SPRINT_TYPE)]: (0, $VoGvu.shipGlyph),
    [(0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE)]: (0, $VoGvu.peopleGroupGlyph),
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: (0, $VoGvu.officeBuildingGlyph),
    [(0, $5fc53.REPORTER_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.ATTACHMENT_TYPE)]: (0, $VoGvu.attachmentGlyph),
    [(0, $5fc53.ASSIGNEE_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.LABELS_TYPE)]: (0, $VoGvu.labelGlyph),
    [(0, $5fc53.PRIORITY_TYPE)]: (0, $VoGvu.priorityGlyph),
    [(0, $5fc53.DUE_DATE_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.TIME_ESTIMATE_CONFIG_TYPE)]: (0, $VoGvu.timeStampGlyph),
    [(0, $5fc53.TIME_TRACKING_TYPE)]: (0, $VoGvu.timeTrackingGlyph),
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: (0, $VoGvu.originalTimeEstimateGlyph),
    [(0, $5fc53.ASSETS_CF_TYPE)]: (0, $VoGvu.screenGlyph),
    [(0, $5fc53.SERVICE_ENTITY_CF_TYPE)]: (0, $VoGvu.labelGlyph),
    [(0, $5fc53.STATUS_TYPE)]: (0, $VoGvu.arrowRightGlyph),
    [(0, $5fc53.SUMMARY_TYPE)]: (0, $VoGvu.shortTextGlyph),
    [(0, $3XO6n.DESCRIPTION_FIELD_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.TEXT_CF_TYPE)]: (0, $VoGvu.shortTextGlyph),
    [(0, $3XO6n.TEXT_AREA_CF_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: (0, $VoGvu.checkboxGlyph),
    [(0, $5fc53.ISSUE_LINKS_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $3XO6n.ENVIRONMENT_FIELD_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.COMMENT_TYPE)]: (0, $VoGvu.commentGlyph),
    [(0, $5fc53.APPROVERS_LIST_CF_TYPE)]: (0, $VoGvu.appAccessGlyph),
    [(0, $5fc53.APPROVALS_CF_TYPE)]: (0, $VoGvu.appAccessGlyph),
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: (0, $VoGvu.folderGlyph),
    [(0, $5fc53.MESSAGE_EDIT_CF_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.MESSAGE_VIEW_CF_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.CATEGORY_TYPE)]: (0, $VoGvu.jwmCategoryGlyph),
    [(0, $5fc53.ENTITLEMENT_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.SENTIMENT_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.ORGANIZATION_CF_TYPE)]: (0, $VoGvu.customFieldGlyph)
};
const $84df96f6dc813d24$export$14355977bfae6aaa = {
    ...$84df96f6dc813d24$var$checkedFieldTypesGlyphs,
    text: (0, $VoGvu.paragraphGlyph),
    number: (0, $VoGvu.numberGlyph),
    date: (0, $VoGvu.dateGlyph),
    datetime: (0, $VoGvu.timeStampGlyph),
    dropdown: (0, $VoGvu.dropdownGlyph),
    addon: (0, $VoGvu.addonGlyph),
    checkbox: (0, $VoGvu.checkboxGlyph),
    user: (0, $VoGvu.peopleGlyph),
    radio: (0, $VoGvu.radioGlyph),
    time: (0, $VoGvu.timeStampGlyph),
    message: (0, $VoGvu.commentGlyph),
    bulletList: (0, $VoGvu.bulletListGlyph),
    label: (0, $VoGvu.labelGlyph),
    labelpicker: (0, $VoGvu.labelGlyph),
    close: (0, $VoGvu.closeGlyph),
    assetspicker: (0, $VoGvu.screenGlyph),
    select: (0, $VoGvu.dropdownGlyph),
    multiselect: (0, $VoGvu.dropdownGlyph),
    cascadingselect: (0, $VoGvu.doubleDropdownGlyph),
    multigrouppicker: (0, $VoGvu.dropdownGlyph),
    grouppicker: (0, $VoGvu.dropdownGlyph),
    multiversion: (0, $VoGvu.dropdownGlyph),
    version: (0, $VoGvu.dropdownGlyph),
    projectpicker: (0, $VoGvu.dropdownGlyph),
    customField: (0, $VoGvu.customFieldGlyph)
};
const $84df96f6dc813d24$export$aaac7dbe01e6025d = /*#__PURE__*/ (0, $5uXOq.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $5fc53.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: "",
        glyph: $84df96f6dc813d24$var$checkedFieldTypesGlyphs[type] || $84df96f6dc813d24$var$checkedFieldTypesGlyphs.customField,
        size: size,
        testId: testId
    });
});
const $84df96f6dc813d24$export$87c5289d8835f589 = /*#__PURE__*/ (0, $5uXOq.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $5fc53.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: "",
        glyph: $84df96f6dc813d24$export$14355977bfae6aaa[type] || $84df96f6dc813d24$export$14355977bfae6aaa.customField,
        size: size,
        testId: testId
    });
});
var /**
 * @deprecated - Use allFieldTypeGlyphs or FieldTypeIcon instead.
 */ $84df96f6dc813d24$export$2e2bcd8739ae039 = $84df96f6dc813d24$var$allIcons;

});
parcelRegister("b0XU0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5f697d891cc6bba8e40c46639eb125>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $804e2928682a9df6$var$_react = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $804e2928682a9df6$var$_branch = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("4iPF3")));

var $804e2928682a9df6$var$_branches = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("9XvX5")));
function $804e2928682a9df6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BranchIcon.
 * This component is BranchIcon, with `UNSAFE_fallbackIcon` set to "BitbucketBranchesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $804e2928682a9df6$var$BranchIcon = (props)=>/*#__PURE__*/ $804e2928682a9df6$var$_react.default.createElement($804e2928682a9df6$var$_branch.default, Object.assign({
        LEGACY_fallbackIcon: $804e2928682a9df6$var$_branches.default
    }, props));
$804e2928682a9df6$var$BranchIcon.Name = 'BranchIconMigration';
var $804e2928682a9df6$var$_default = module.exports.default = $804e2928682a9df6$var$BranchIcon;

});
parcelRegister("4iPF3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3220eab15e59539d$var$_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3220eab15e59539d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3220eab15e59539d$var$BranchIcon = (props)=>/*#__PURE__*/ $3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;

});

parcelRegister("9XvX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $740268c474e86b43$var$_react = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $740268c474e86b43$var$_branch = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("4iPF3")));
function $740268c474e86b43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $740268c474e86b43$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $740268c474e86b43$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $740268c474e86b43$var$_branch.default
    }));
$740268c474e86b43$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $740268c474e86b43$var$_default = module.exports.default = $740268c474e86b43$var$BitbucketBranchesIcon;

});


parcelRegister("fyC9a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8fa98d5af7aa71848cf5218e04fd5c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5379f2924fc9e12$var$_react = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b5379f2924fc9e12$var$_stopwatch = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("cXVn2")));

var $b5379f2924fc9e12$var$_stopwatch2 = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("63gsv")));
function $b5379f2924fc9e12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StopwatchIcon.
 * This component is StopwatchIcon, with `UNSAFE_fallbackIcon` set to "StopwatchIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5379f2924fc9e12$var$StopwatchIcon = (props)=>/*#__PURE__*/ $b5379f2924fc9e12$var$_react.default.createElement($b5379f2924fc9e12$var$_stopwatch.default, Object.assign({
        LEGACY_fallbackIcon: $b5379f2924fc9e12$var$_stopwatch2.default
    }, props));
$b5379f2924fc9e12$var$StopwatchIcon.Name = 'StopwatchIconMigration';
var $b5379f2924fc9e12$var$_default = module.exports.default = $b5379f2924fc9e12$var$StopwatchIcon;

});
parcelRegister("cXVn2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da0501648aefebd7252ab6523b352986>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97077f52e189c3c9$var$_react = $97077f52e189c3c9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97077f52e189c3c9$var$_baseNew = $97077f52e189c3c9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $97077f52e189c3c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97077f52e189c3c9$var$StopwatchIcon = (props)=>/*#__PURE__*/ $97077f52e189c3c9$var$_react.default.createElement($97077f52e189c3c9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 0h6v1.5H8.75v1.543a6.47 6.47 0 0 1 3.06 1.19l1.137-1.24 1.106 1.014-1.137 1.24a6.5 6.5 0 1 1-9.832 0l-1.137-1.24 1.106-1.014 1.137 1.24a6.47 6.47 0 0 1 3.06-1.19V1.5H5zm3 4.5a4.98 4.98 0 0 0-3.378 1.314A5 5 0 1 0 8 4.5m2.842 3.01-2.541 2.75-1.102-1.02 2.542-2.75z" clip-rule="evenodd"/>`
    }, props));
$97077f52e189c3c9$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $97077f52e189c3c9$var$_default = module.exports.default = $97077f52e189c3c9$var$StopwatchIcon;

});

parcelRegister("63gsv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $467fca4622452061$var$_react = $467fca4622452061$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $467fca4622452061$var$_stopwatch = $467fca4622452061$var$_interopRequireDefault((parcelRequire("cXVn2")));
function $467fca4622452061$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $467fca4622452061$var$StopwatchIcon = (props)=>/*#__PURE__*/ $467fca4622452061$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.587 6.988.626-.664c.203-.215.481-.324.76-.324.247 0 .496.086.694.262a.98.98 0 0 1 .063 1.414l-.565.6a7 7 0 1 1-10.33 0l-.564-.6a.98.98 0 0 1 .062-1.414A1.04 1.04 0 0 1 7.03 6c.278 0 .556.109.76.324l.624.664a7 7 0 0 1 2.582-.916L10.998 5H10.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.498l.001 1.071a7 7 0 0 1 2.584.917M12 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10m.368-4.232a.796.796 0 0 1-1.14-.018.834.834 0 0 1 .018-1.163l2.386-2.355a.796.796 0 0 1 1.14.018.834.834 0 0 1-.018 1.163z"/></svg>`
    }, props, {
        newIcon: $467fca4622452061$var$_stopwatch.default
    }));
$467fca4622452061$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $467fca4622452061$var$_default = module.exports.default = $467fca4622452061$var$StopwatchIcon;

});


parcelRegister("VoGvu", function(module, exports) {

$parcel$export(module.exports, "numberGlyph", () => $2e91e7edf801074a$export$b368272069fe93ea);
$parcel$export(module.exports, "checkboxGlyph", () => $2e91e7edf801074a$export$747056db840f2e62);
$parcel$export(module.exports, "folderGlyph", () => $2e91e7edf801074a$export$fc939f15c0ac57d8);
$parcel$export(module.exports, "dateGlyph", () => $2e91e7edf801074a$export$54ae6633cc16eed1);
$parcel$export(module.exports, "dropdownGlyph", () => $2e91e7edf801074a$export$d298f123ec74117c);
$parcel$export(module.exports, "doubleDropdownGlyph", () => $2e91e7edf801074a$export$b3ea0fc10228ca3e);
$parcel$export(module.exports, "labelGlyph", () => $2e91e7edf801074a$export$fc64eea29ed0831d);
$parcel$export(module.exports, "paragraphGlyph", () => $2e91e7edf801074a$export$cbee9ded46569696);
$parcel$export(module.exports, "peopleGlyph", () => $2e91e7edf801074a$export$2ade78849d2113ea);
$parcel$export(module.exports, "shortTextGlyph", () => $2e91e7edf801074a$export$1c6cf19eb34bcc14);
$parcel$export(module.exports, "timeStampGlyph", () => $2e91e7edf801074a$export$98a4a461fe316fce);
$parcel$export(module.exports, "timeTrackingGlyph", () => $2e91e7edf801074a$export$637d50811e2b7176);
$parcel$export(module.exports, "originalTimeEstimateGlyph", () => $2e91e7edf801074a$export$bc2bb299bed9df91);
$parcel$export(module.exports, "arrowRightGlyph", () => $2e91e7edf801074a$export$3a9d3f1c52f4dab9);
$parcel$export(module.exports, "addonGlyph", () => $2e91e7edf801074a$export$a4cdad58220c405a);
$parcel$export(module.exports, "attachmentGlyph", () => $2e91e7edf801074a$export$e6e85f1bc2e23bd4);
$parcel$export(module.exports, "bulletListGlyph", () => $2e91e7edf801074a$export$a6a7f7b7c0399a2a);
$parcel$export(module.exports, "commentGlyph", () => $2e91e7edf801074a$export$835d228e2a9d6a93);
$parcel$export(module.exports, "officeBuildingGlyph", () => $2e91e7edf801074a$export$fdad804cb16a6544);
$parcel$export(module.exports, "peopleGroupGlyph", () => $2e91e7edf801074a$export$a20644de4b67f161);
$parcel$export(module.exports, "radioGlyph", () => $2e91e7edf801074a$export$ce87e45dceec205d);
$parcel$export(module.exports, "shipGlyph", () => $2e91e7edf801074a$export$d95e2215202c8556);
$parcel$export(module.exports, "priorityGlyph", () => $2e91e7edf801074a$export$3062e49c5521698d);
$parcel$export(module.exports, "screenGlyph", () => $2e91e7edf801074a$export$17d48fc8b753df77);
$parcel$export(module.exports, "closeGlyph", () => $2e91e7edf801074a$export$cbbe21ca62a58ed6);
$parcel$export(module.exports, "appAccessGlyph", () => $2e91e7edf801074a$export$8fd991b9da3a43e5);
$parcel$export(module.exports, "jwmCategoryGlyph", () => $2e91e7edf801074a$export$f21213fb7b480582);
$parcel$export(module.exports, "customFieldGlyph", () => $2e91e7edf801074a$export$88453606d7da6ff7);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $2e91e7edf801074a$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$747056db840f2e62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$fc939f15c0ac57d8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.708 11.723L12.779 14.678C12.566 14.893 12.288 15 12.009 15C11.73 15 11.449 14.893 11.231 14.678L8.291 11.713C7.903 11.321 7.903 10.686 8.291 10.294C8.679 9.902 9.309 9.902 9.698 10.294L12.005 12.621L14.303 10.304C14.69 9.912 15.32 9.912 15.708 10.304C16.097 10.696 16.097 11.331 15.708 11.723Z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$b3ea0fc10228ca3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$cbee9ded46569696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$637d50811e2b7176 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M17.476 9.067A6.552 6.552 0 0 1 19 13.263C19 16.983 15.866 20 12 20s-7-3.016-7-6.737c0-1.587.57-3.045 1.524-4.196l-.383-.402a.82.82 0 0 1 .054-1.19.9.9 0 0 1 1.237.052l.345.363a7.116 7.116 0 0 1 3.348-1.312v-.894h-.438a.43.43 0 0 1-.437-.42V4.42a.43.43 0 0 1 .438-.42h2.624a.43.43 0 0 1 .438.421v.842a.43.43 0 0 1-.438.421h-.437v.894a7.116 7.116 0 0 1 3.348 1.312l.345-.363a.9.9 0 0 1 1.237-.052.82.82 0 0 1 .054 1.19l-.383.402zM12 18.316c2.9 0 5.25-2.262 5.25-5.053 0-2.79-2.35-5.052-5.25-5.052s-5.25 2.262-5.25 5.052c0 2.79 2.35 5.053 5.25 5.053zm.645-4.562a.9.9 0 0 1-1.237-.02.82.82 0 0 1 .02-1.19l2.588-2.412a.9.9 0 0 1 1.238.02.82.82 0 0 1-.02 1.19l-2.589 2.412z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$bc2bb299bed9df91 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$3a9d3f1c52f4dab9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$a4cdad58220c405a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.928 6.917l4.81-2.846c.727-.429 1.8-.427 2.523 0l4.811 2.846c.726.43 1.261 1.382 1.261 2.238v5.69c0 .859-.537 1.81-1.26 2.238L13.26 19.93c-.726.429-1.799.427-2.522 0l-4.811-2.846c-.726-.43-1.261-1.382-1.261-2.238v-5.69c0-.859.537-1.81 1.26-2.238zm6.408-1.204c-.152-.09-.52-.09-.672 0L6.853 8.558c-.152.09-.336.416-.336.597v5.69c0 .18.183.507.336.597l4.81 2.845c.153.09.52.09.673 0l4.811-2.845c.152-.09.336-.416.336-.597v-5.69c0-.18-.183-.507-.336-.597l-4.81-2.845zM12 15.667a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334zm0-1.834a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$e6e85f1bc2e23bd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.672 17.468c-1.402 1.37-3.68 1.37-5.08.004a3.458 3.458 0 0 1 .002-4.962l6.552-6.402a2.123 2.123 0 0 1 2.964-.003c.818.8.82 2.092.003 2.89L10.968 15a.599.599 0 0 1-.838-.008.568.568 0 0 1 0-.827l5.71-5.58a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.268 0l-5.71 5.58a2.294 2.294 0 0 0 0 3.307 2.423 2.423 0 0 0 3.375.008l6.145-6.005a3.735 3.735 0 0 0-.003-5.37 3.947 3.947 0 0 0-5.502.003L6.325 11.27a5.184 5.184 0 0 0-.001 7.442c2.1 2.052 5.514 2.051 7.617-.004l6.13-5.99a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.27 0l-6.129 5.99z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.5 7.59a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.008v.152A1 1 0 0 1 6.659 8.75h-.152A1 1 0 0 1 5.5 7.743V7.59zm4.333 8.667a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.008h-6.678a.993.993 0 0 1-.995-1.008v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.008h-.152A1 1 0 0 1 5.5 16.409v-.152zm4.333-4.333a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.007h-.152A1 1 0 0 1 5.5 12.076v-.152zM9.833 7.59a.999.999 0 0 1 .995-1.008h6.678c.549 0 .994.439.994 1.008v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007V7.59z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 0 0 .164.033.515.515 0 0 0 .474-.716zM7 10c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1h-8.01A.995.995 0 0 1 7 10zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1H8c-.552 0-1-.444-1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$fdad804cb16a6544 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.444 14.667V20H5.785C4.8 20 4 19.146 4 18.09V8.577c0-1.055.802-1.91 1.785-1.91h2.66v3.556H6.666V12h1.777v.889H6.667v1.778h1.777zm.89-8.894A1.78 1.78 0 0 1 11.119 4h7.096A1.78 1.78 0 0 1 20 5.773v12.454c0 .979-.802 1.773-1.785 1.773H9.333V5.773zM12 7.556v1.777h1.778V7.556H12zm0 2.666V12h1.778v-1.778H12zm0 2.667v1.778h1.778v-1.778H12zm1.778 2.667v2.666h1.778v-2.666h-1.778zm1.778-8v1.777h1.777V7.556h-1.777zm0 2.666V12h1.777v-1.778h-1.777zm0 2.667v1.778h1.777v-1.778h-1.777z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$a20644de4b67f161 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 12a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-3.228-1.667A3.333 3.333 0 0 0 9.795 12H9.5A2.501 2.501 0 0 0 7 14.497v2.469c-1.771-.147-3.333-.766-3.333-1.858V12c0-.92.74-1.667 1.666-1.667h3.439zm6.456 0h3.439c.92 0 1.666.738 1.666 1.667v3.108c0 1.092-1.562 1.711-3.333 1.858v-2.47A2.5 2.5 0 0 0 14.5 12h-.295a3.333 3.333 0 0 0 1.023-1.667zM10.306 6.63A3.332 3.332 0 0 0 8.67 9.357a2.5 2.5 0 1 1 1.636-2.728zm5.024 2.728a3.328 3.328 0 0 0-1.636-2.73 2.5 2.5 0 1 1 1.636 2.73zm-7.497 5.456c0-1.093.892-1.98 1.996-1.98h4.342a2 2 0 0 1 1.996 1.994v2.781c0 2.523-8.334 2.523-8.334 0v-2.795z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$ce87e45dceec205d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$d95e2215202c8556 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.5 12h7.333v-1.833H6.5V12zM4.667 9.242c0-.502.417-.909.919-.909h9.162c.507 0 .919.414.919.909v4.591h-11V9.242zm.458 7.341h12.828l.919-2.75H4.795l.33 2.75zm-2.287-3.677A.79.79 0 0 1 3.643 12h16.86c.504 0 .786.382.625.865l-1.565 4.686c-.16.478-.695.866-1.205.866H4.415c-.506 0-.964-.402-1.025-.906l-.552-4.605zM6.5 7.42c0-1.015.823-1.838 1.831-1.838h1.838c1.011 0 1.831.82 1.831 1.838v2.746H6.5V7.42zm3.667 0v-.004H8.331c.005 0 .002.002.002.004v.912h1.834V7.42z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$3062e49c5521698d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.959 15.833V8.474l-2.868 2.868a.541.541 0 1 1-.766-.766l3.79-3.789.001-.004a.544.544 0 0 1 .77.003l3.791 3.792a.543.543 0 0 1 0 .766.543.543 0 0 1-.765 0l-2.87-2.87v7.36a.543.543 0 0 1-.541.541.543.543 0 0 1-.542-.542zm7-6.666v7.359l-2.868-2.868a.541.541 0 1 0-.766.766l3.79 3.789.001.004a.544.544 0 0 0 .77-.003l3.791-3.792a.543.543 0 0 0 0-.766.543.543 0 0 0-.765 0l-2.87 2.87v-7.36a.543.543 0 0 0-.541-.541.543.543 0 0 0-.542.542z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".5",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$17d48fc8b753df77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4 6.772C4 5.793 4.793 5 5.773 5h12.454C19.206 5 20 5.796 20 6.772v7.044c0 .979-.793 1.772-1.773 1.772H5.773A1.774 1.774 0 0 1 4 13.816V6.772zm1.778 7.052h12.444v-7.06H5.778v7.06zm8 5.294h.452c.241 0 .437.204.437.44V20H9.333v-.441c0-.244.203-.441.437-.441h.452V16.47h3.556v2.647z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$cbbe21ca62a58ed6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16.244 6.244a.833.833 0 1 1 1.179 1.179l-4.412 4.41 4.412 4.411a.834.834 0 0 1 .074 1.093l-.074.086a.833.833 0 0 1-1.179 0l-4.411-4.412-4.41 4.412a.834.834 0 0 1-1.094.074l-.085-.074a.833.833 0 0 1 0-1.179l4.411-4.411-4.41-4.41a.834.834 0 0 1-.076-1.094l.075-.085a.833.833 0 0 1 1.179 0l4.41 4.411z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$8fd991b9da3a43e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.975 5.975 0 0 1 10 17a5.994 5.994 0 0 1 2.682-5z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        fill: "currentColor",
        cx: "9",
        cy: "7",
        r: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "17",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3l1.406 1.405z",
        fill: "inherit"
    })));
const $2e91e7edf801074a$export$f21213fb7b480582 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$88453606d7da6ff7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        role: "presentation",
        focusable: "false",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6H3ZM4 16V12H20V16H4ZM2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V12Z",
        fill: "currentColor"
    })));

});


parcelRegister("bWSqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c969c7acf49869cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c969c7acf49869cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    columnGroupHeader: {
        "id": "issue-table-column-picker.common.column-group-header",
        "defaultMessage": "All columns"
    },
    deprecatedParentyLinkMessage: {
        "id": "issue-navigator.services.fetch-column-picker-options.deprecated-parenty-link-message",
        "defaultMessage": "<strong>{field}</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    }
});

});

parcelRegister("2F3SN", function(module, exports) {

$parcel$export(module.exports, "getCursorOfLastUnselectedOption", () => $0932bf87004e47f4$export$5918fea5c056698b);
$parcel$export(module.exports, "isOnlyUnselectableField", () => $0932bf87004e47f4$export$bf5bbd6344a5f1aa);

var $hIkqU = parcelRequire("hIkqU");

var $jG2IE = parcelRequire("jG2IE");

var $6UAdF = parcelRequire("6UAdF");
const $0932bf87004e47f4$var$isNotinSelectedList = (selectedOptions, option)=>{
    const optionFound = selectedOptions.find((select)=>(0, $jG2IE.isSingleValueOption)(select) && (0, $jG2IE.isSingleValueOption)(option) && select.cursor === option.cursor);
    return optionFound === undefined;
};
const $0932bf87004e47f4$export$5918fea5c056698b = (options, selectedOptions, search, endCursor)=>{
    const flatten = options.flatMap((option)=>option.optionType === 'group' ? option.options : option);
    const lastUnselectedOption = (0, (/*@__PURE__*/$parcel$interopDefault($hIkqU)))(flatten, (option)=>(0, $jG2IE.isSingleValueOption)(option) && !!option.cursor && $0932bf87004e47f4$var$isNotinSelectedList(selectedOptions, option));
    let cursor = lastUnselectedOption && (0, $jG2IE.isSingleValueOption)(lastUnselectedOption) ? lastUnselectedOption?.cursor : undefined;
    // with a given search input, don't set cursor to undefined when there are only selected options in the list, because we query with 'ALL' options
    if (search && cursor === undefined && endCursor) cursor = endCursor;
    return cursor;
};
const $0932bf87004e47f4$export$bf5bbd6344a5f1aa = (fieldType, canEditColumns)=>{
    if (fieldType === (0, $6UAdF.COLUMN_TYPE_EPIC_LINK)) return canEditColumns;
    if (fieldType === (0, $6UAdF.COLUMN_TYPE_PARENT_LINK)) return canEditColumns;
    return false;
};

});
parcelRegister("hIkqU", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $apUNl = parcelRequire("apUNl");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $0353f9604956038c$var$findLast = $bptzf($apUNl);
module.exports = $0353f9604956038c$var$findLast;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});

parcelRegister("apUNl", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $79584b713e0c6354$var$nativeMax = Math.max, $79584b713e0c6354$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $79584b713e0c6354$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $kPZpS(fromIndex);
        index = fromIndex < 0 ? $79584b713e0c6354$var$nativeMax(length + index, 0) : $79584b713e0c6354$var$nativeMin(index, length - 1);
    }
    return $b5dwA(array, $bxDef(predicate, 3), index, true);
}
module.exports = $79584b713e0c6354$var$findLastIndex;

});


parcelRegister("jG2IE", function(module, exports) {

$parcel$export(module.exports, "isSingleValueOption", () => $4dbead67dfc4bb06$export$35faed52a6bc243e);
const $4dbead67dfc4bb06$export$35faed52a6bc243e = (option)=>option.optionType === 'option' || option.optionType === 'avatar' || option.optionType === 'lozenge' || option.optionType === 'field';

});



parcelRegister("gUt9J", function(module, exports) {

$parcel$export(module.exports, "useIFCSidebar", () => $c81b19b8c94d3931$export$50b7b16d5dcf708b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");

var $eZJjh = parcelRequire("eZJjh");

var $f98ZZ = parcelRequire("f98ZZ");

var $7XluA = parcelRequire("7XluA");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $4anLj = parcelRequire("4anLj");

var $47gW9 = parcelRequire("47gW9");

var $jfQeI = parcelRequire("jfQeI");
const $c81b19b8c94d3931$var$IFCTriggerRef = ({ children: children })=>{
    const { entryPointActions: entryPointActions } = (0, $jfQeI.useIFCEntryPointContext)();
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return children({
        triggerRef: triggerRef
    });
};
const $c81b19b8c94d3931$export$50b7b16d5dcf708b = ({ projectId: projectId, projectKey: projectKey })=>{
    const ifcContext = (0, $jfQeI.useIFCEntryPointContext)();
    const [, { setStaticSidebarContent: setStaticSidebarContent, closeSidebar: closeSidebar }] = (0, $f98ZZ.useSidebar)();
    const isSiteAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = (0, $4anLj.useIsProjectAdmin)();
    const isAdmin = isSiteAdmin || isProjectAdmin;
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const isIFCEnabled = Boolean(isAdmin && project?.simplified);
    const onUpdate = (0, $5uXOq.useCallback)(({ fieldId: fieldId, onFieldDeleted: onFieldDeleted, onFieldUpdated: onFieldUpdated, onStartFieldUpdate: onStartFieldUpdate })=>{
        if (projectId && projectKey) setStaticSidebarContent?.('ifc-sidebar-edit', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c81b19b8c94d3931$var$styles.sidebarContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: ifcContext.entryPointReferenceSubject,
            id: "jira-nin-inline-field-config-sidebar",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "medium"
            })),
            runtimeProps: {
                projectId: projectId,
                projectKey: projectKey,
                onClose: closeSidebar,
                fieldId: fieldId,
                mode: 'edit',
                onFieldDeleted: onFieldDeleted,
                onFieldUpdated: onFieldUpdated,
                onStartFieldUpdate: onStartFieldUpdate
            }
        })));
    }, [
        closeSidebar,
        ifcContext.entryPointReferenceSubject,
        projectId,
        projectKey,
        setStaticSidebarContent
    ]);
    const onCreate = (0, $5uXOq.useCallback)((createArgs)=>{
        if (projectId && projectKey) setStaticSidebarContent?.('ifc-sidebar-create', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $c81b19b8c94d3931$var$styles.sidebarContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: ifcContext.entryPointReferenceSubject,
            id: "jira-nin-inline-field-config-sidebar",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "medium"
            })),
            runtimeProps: {
                projectId: projectId,
                projectKey: projectKey,
                onClose: closeSidebar,
                onStartFieldCreate: createArgs?.onStartFieldCreate,
                onFieldCreated: createArgs?.onFieldCreated,
                onFieldCreateError: createArgs?.onFieldCreateError,
                mode: 'create'
            }
        })));
    }, [
        closeSidebar,
        ifcContext.entryPointReferenceSubject,
        projectId,
        projectKey,
        setStaticSidebarContent
    ]);
    return (0, $5uXOq.useMemo)(()=>[
            isIFCEnabled,
            {
                IFCTriggerRef: $c81b19b8c94d3931$var$IFCTriggerRef,
                onCreate: onCreate,
                onUpdate: onUpdate
            }
        ], [
        isIFCEnabled,
        onCreate,
        onUpdate
    ]);
};
const $c81b19b8c94d3931$var$styles = {
    sidebarContent: "_4t3i1osq _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};

});
parcelRegister("4anLj", function(module, exports) {

$parcel$export(module.exports, "useIsProjectAdmin", () => $28cdc31165a564f1$export$9facd8d31b938a25);

var $dAfqg = parcelRequire("dAfqg");
const $28cdc31165a564f1$export$9facd8d31b938a25 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    return !!data?.isProjectAdmin;
};

});


parcelRegister("7UBlg", function(module, exports) {

$parcel$export(module.exports, "createPopupComponent", () => $3f97be657325a468$export$7b08561157a7df33);
$parcel$export(module.exports, "default", () => $3f97be657325a468$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $ousew = parcelRequire("ousew");

var $4R6GH = parcelRequire("4R6GH");

var $hZQx0 = parcelRequire("hZQx0");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");

var $hW8cB = parcelRequire("hW8cB");

var $8HSL7 = parcelRequire("8HSL7");

var $f4YBC = parcelRequire("f4YBC");

var $kgFPU = parcelRequire("kgFPU");
const $3f97be657325a468$var$ColumnPickerPopupComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onRestoreDefaults: onRestoreDefaults, ...props }, ref)=>{
    const { filterId: filterId, isFilterEditable: isFilterEditable } = (0, $gwtSG.useActiveJql)();
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const { hasMaxSelectedColumns: hasMaxSelectedColumns, filterName: filterName } = (0, $5uXOq.useContext)((0, $hZQx0.ColumnPickerMessageContext));
    let bannerMessage = null;
    if (hasMaxSelectedColumns) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HSL7.ColumnPickerMaxSelectedColumns), null);
    else if (view === 'list_system') bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hW8cB.ColumnPickerBannerMessage), {
        bannerMessage: (0, $4R6GH.fg)('jira_inline_field_config_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kgFPU.default).listSystemWarningMessageNew) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kgFPU.default).listSystemWarningMessage),
        type: "warning"
    });
    else if (view === `list_filter_${filterId}`) {
        if (isFilterEditable === false) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hW8cB.ColumnPickerBannerMessage), {
            type: "info",
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $kgFPU.default).listNonEditableFilterInfoMessage,
                values: {
                    // To remove @ts-expect-error below we need to upgrade intl to v6
                    // https://stackoverflow.com/questions/67884173/formattedmessage-values-chunks-using-typescript
                    // @ts-expect-error TS2322: Type '(chunks: ReactNode[]) => JSX.Element' is not assignable to type 'ReactNode'.
                    link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                            href: `/jira/filters${filterName ? `?name="${encodeURIComponent(filterName)}"` : ''}`,
                            target: "_blank"
                        }, chunks)
                }
            })
        });
        else bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hW8cB.ColumnPickerBannerMessage), {
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kgFPU.default).listFilterWarningMessage),
            type: "warning"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f97be657325a468$var$PopupComponentContainer, {
        ...props,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f4YBC.default), {
        onRestoreDefaults: (0, $4R6GH.fg)('jira_inline_field_config_gate') ? onRestoreDefaults : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f97be657325a468$var$TabsContentContainer, null, bannerMessage, children)));
});
const $3f97be657325a468$export$7b08561157a7df33 = (onRestoreDefaultColumns)=>/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f97be657325a468$var$ColumnPickerPopupComponent, {
            ...props,
            ref: ref,
            onRestoreDefaults: onRestoreDefaultColumns
        }));
var $3f97be657325a468$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3f97be657325a468$var$ColumnPickerPopupComponent;
const $3f97be657325a468$var$PopupComponentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1bsb1mjv _bfhk1bhr _16qs1cd0 _1pby1nn1 _ca0q1b66 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f97be657325a468$var$TabsContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hW8cB", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerBannerMessage", () => $cc30b6aaadae0517$export$3ccab74b576df308);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1jWct = parcelRequire("1jWct");

var $bU3PY = parcelRequire("bU3PY");
const $cc30b6aaadae0517$export$3ccab74b576df308 = ({ bannerMessage: bannerMessage, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc30b6aaadae0517$var$BannerContent, {
        type: type
    }, type === 'warning' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc30b6aaadae0517$var$BannerMessage, null, bannerMessage));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc30b6aaadae0517$var$BannerContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _syaz1gjq",
            __cmplp.type === 'warning' ? "_bfhk1tzq" : "_bfhk33gi",
            __cmplp.className
        ])
    });
});
const $cc30b6aaadae0517$var$BannerMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _19pkidpf _2hwxidpf _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8HSL7", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerMaxSelectedColumns", () => $661e3e27622b6b54$export$3ec21851fe32329c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6tRzQ = parcelRequire("6tRzQ");

var $koVbs = parcelRequire("koVbs");

var $czfFt = parcelRequire("czfFt");

var $5oFIy = parcelRequire("5oFIy");

var $dyiFy = parcelRequire("dyiFy");
const $661e3e27622b6b54$export$3ec21851fe32329c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($661e3e27622b6b54$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($661e3e27622b6b54$var$Message, null, formatMessage((0, $dyiFy.default).maxSelectedColumns, {
        maxColumns: (0, $czfFt.MAX_COLUMNS)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "maxSelectedFieldsMessage",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $661e3e27622b6b54$var$MessageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _bfhkm7j4 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _syaz1gjq _19pku2gc",
            __cmplp.className
        ])
    });
});
const $661e3e27622b6b54$var$Message = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _19pkidpf _2hwxidpf _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dyiFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf25dbe16eb48e62$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cf25dbe16eb48e62$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    maxSelectedColumns: {
        "id": "issue-navigator.issue-results.list-view.column-picker-max-selected-columns.max-selected-columns",
        "defaultMessage": "The column limit is {maxColumns, number}. Remove and add the most important ones to your view."
    }
});

});


parcelRegister("f4YBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d61f43128e0eaf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $fphHl = parcelRequire("fphHl");
var $cte3m = parcelRequire("cte3m");
var $eQ4wW = parcelRequire("eQ4wW");

var $koVbs = parcelRequire("koVbs");

var $9Nvh7 = parcelRequire("9Nvh7");

var $8zOmE = parcelRequire("8zOmE");

var $g5X3G = parcelRequire("g5X3G");

var $itmJb = parcelRequire("itmJb");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");

var $2CHGs = parcelRequire("2CHGs");

var $k4UJN = parcelRequire("k4UJN");
const $a4d61f43128e0eaf$var$CustomTabPanel = ({ children: children })=>{
    /**
   * We can omit the tab index as our panel always contains a focusable input as the first element https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic#accessibilityfeatures.
   * > It is recommended that all tabpanel elements in a tab set are focusable if there are any panels in the set that
   * > contain content where the first element in the panel is not focusable.
   */ const { tabIndex: tabIndex, ...tabPanelAttributes } = (0, $eQ4wW.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", tabPanelAttributes, children);
};
const $a4d61f43128e0eaf$var$ColumnPickerTabs = ({ children: children, onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const [{ view: view }, { setView: setView }] = (0, $ih9zY.useSelectedViewState)();
    const isFilterTabEnabled = filterId != null && (0, $9Nvh7.isCustomFilter)(filterId);
    const tabsMetaData = (0, $5uXOq.useMemo)(()=>{
        const resultTabs = [
            {
                key: 'Default',
                label: formatMessage((0, $2CHGs.default).pickerTabTextDefault),
                view: 'list_default',
                onRestoreDefaults: onRestoreDefaults
            }
        ];
        if (isFilterTabEnabled) {
            const filterViewId = (0, $eJ0Zs.convertFilterIdToIssueNavigatorId)(filterId);
            if (filterViewId != null) resultTabs.push({
                key: 'Filter',
                label: formatMessage((0, $2CHGs.default).pickerTabTextFilter),
                view: filterViewId
            });
        }
        if (isAdmin) resultTabs.push({
            key: 'System',
            label: formatMessage((0, $2CHGs.default).pickerTabTextSystem),
            view: 'list_system'
        });
        return resultTabs;
    }, [
        formatMessage,
        isFilterTabEnabled,
        filterId,
        isAdmin,
        onRestoreDefaults
    ]);
    const handleUpdate = (0, $5uXOq.useCallback)((index, event)=>{
        if (view !== tabsMetaData[index].view) {
            (0, $8zOmE.fireUIAnalytics)(event, 'columnPickerTabs', {
                tab: tabsMetaData[index].view
            });
            setView(tabsMetaData[index].view, (0, $g5X3G.toIssueKey)(''));
        }
    }, [
        setView,
        tabsMetaData,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fphHl.default), {
        id: "issue-table-column-picker.ui.column-picker.picker-tabs",
        onChange: handleUpdate,
        selected: tabsMetaData.findIndex((tab)=>tab.view === view),
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cte3m.default), null, tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4UJN.default), {
            key: tab.key,
            label: tab.label,
            maxWidth: `${Math.floor(100 / (tabsMetaData.length || 1))}%`,
            onRestoreDefaults: tab.onRestoreDefaults
        })))), tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4d61f43128e0eaf$var$CustomTabPanel, {
            key: tab.key
        }, children)));
};
var $a4d61f43128e0eaf$export$2e2bcd8739ae039 = $a4d61f43128e0eaf$var$ColumnPickerTabs;

});
parcelRegister("fphHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4810d6c8b7d5c95d$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $dWD6q = parcelRequire("dWD6q");
const $4810d6c8b7d5c95d$var$baseStyles = null;
const $4810d6c8b7d5c95d$var$tabsStyles = null;
const $4810d6c8b7d5c95d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $5uXOq.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $5uXOq.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4810d6c8b7d5c95d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;

});
parcelRegister("dWD6q", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $b47499898157cfdc$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $b47499898157cfdc$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $b47499898157cfdc$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5uXOq = parcelRequire("5uXOq");
const $b47499898157cfdc$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$2054129d247c3102 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("cte3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15f9538b451f314$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $eQ4wW = parcelRequire("eQ4wW");

var $dWD6q = parcelRequire("dWD6q");
const $e15f9538b451f314$var$baseStyles = null;
const $e15f9538b451f314$var$tabListStyles = null;
const $e15f9538b451f314$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $e15f9538b451f314$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $eQ4wW.useTabList)();
    const ref = /*#__PURE__*/ (0, $5uXOq.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "tablist",
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;

});
parcelRegister("eQ4wW", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $4d8616502e4de6b0$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $4d8616502e4de6b0$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $4d8616502e4de6b0$export$fae0121b5afe572d);

var $5uXOq = parcelRequire("5uXOq");

var $dWD6q = parcelRequire("dWD6q");
const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $5uXOq.useContext)((0, $dWD6q.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $5uXOq.useContext)((0, $dWD6q.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $5uXOq.useContext)((0, $dWD6q.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("2CHGs", function(module, exports) {

$parcel$export(module.exports, "default", () => $824f5fbceb95a5ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $824f5fbceb95a5ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pickerTabTextDefault: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-default",
        "defaultMessage": "My defaults"
    },
    pickerTabTextFilter: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-filter",
        "defaultMessage": "Filter"
    },
    pickerTabTextSystem: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-system",
        "defaultMessage": "System"
    }
});

});

parcelRegister("k4UJN", function(module, exports) {

$parcel$export(module.exports, "default", () => $51a2efbb5ab69baf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eQ4wW = parcelRequire("eQ4wW");

var $42CjB = parcelRequire("42CjB");

var $lzNDe = parcelRequire("lzNDe");

var $fKpEJ = parcelRequire("fKpEJ");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $fijky = parcelRequire("fijky");

var $diHTh = parcelRequire("diHTh");
const $51a2efbb5ab69baf$var$Tab = ({ label: label, maxWidth: maxWidth = '100%', onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { labelOverflows: labelOverflows, onLabelRef: onLabelRef } = (0, $diHTh.useLabelOverflow)();
    const tabAttributes = (0, $eQ4wW.useTab)();
    const handleRestoreDefaults = (0, $5uXOq.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'filterSearchRestoreDefaults', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onRestoreDefaults && typeof onRestoreDefaults === 'function' && onRestoreDefaults();
    }, [
        onRestoreDefaults
    ]);
    if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51a2efbb5ab69baf$var$TabStyled, {
        maxWidthValue: maxWidth,
        ...tabAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fKpEJ.ConditionalTooltip), {
        condition: labelOverflows,
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51a2efbb5ab69baf$var$tabStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: onLabelRef,
        xcss: $51a2efbb5ab69baf$var$textStyles
    }, label), onRestoreDefaults !== undefined && typeof onRestoreDefaults === 'function' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lzNDe))),
        onClick: handleRestoreDefaults,
        label: formatMessage((0, $fijky.default).restoreDefaults),
        appearance: "subtle",
        spacing: "compact",
        isTooltipDisabled: false
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51a2efbb5ab69baf$var$TabStyled, {
        maxWidthValue: maxWidth,
        ...tabAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fKpEJ.ConditionalTooltip), {
        condition: labelOverflows,
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: onLabelRef,
        xcss: $51a2efbb5ab69baf$var$textStyles
    }, label)));
};
const $51a2efbb5ab69baf$var$textStyles = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
const $51a2efbb5ab69baf$var$tabStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51a2efbb5ab69baf$var$TabStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidthValue: maxWidthValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ocvhpw": (0, $lD23V.default)(__cmplp.maxWidthValue)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fd0nw _vchhusvi _ae4v1h6o",
            __cmplp.className
        ])
    });
});
var $51a2efbb5ab69baf$export$2e2bcd8739ae039 = $51a2efbb5ab69baf$var$Tab;

});
parcelRegister("lzNDe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b87cc7d74b53f2f9074ecfc04ea4b65>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb535dae8e778b64$var$_react = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fb535dae8e778b64$var$_baseNew = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fb535dae8e778b64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb535dae8e778b64$var$RetryIcon = (props)=>/*#__PURE__*/ $fb535dae8e778b64$var$_react.default.createElement($fb535dae8e778b64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$fb535dae8e778b64$var$RetryIcon.displayName = 'RetryIcon';
var $fb535dae8e778b64$var$_default = module.exports.default = $fb535dae8e778b64$var$RetryIcon;

});

parcelRegister("fKpEJ", function(module, exports) {

$parcel$export(module.exports, "ConditionalTooltip", () => $68dbfbed07ea6c84$export$d8abb7a1cfbd4b6b);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");
const $68dbfbed07ea6c84$export$d8abb7a1cfbd4b6b = ({ condition: condition, children: children, ...rest })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), rest, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});

parcelRegister("fijky", function(module, exports) {

$parcel$export(module.exports, "default", () => $531ffbde38170d0a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $531ffbde38170d0a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    restoreDefaults: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.tab.restore-defaults",
        "defaultMessage": "Restore defaults"
    }
});

});

parcelRegister("diHTh", function(module, exports) {

$parcel$export(module.exports, "useLabelOverflow", () => $553ab2a51c9cea37$export$96d540e3e625885f);

var $5uXOq = parcelRequire("5uXOq");
const $553ab2a51c9cea37$export$96d540e3e625885f = ()=>{
    const [labelOverflows, setLabelOverflows] = (0, $5uXOq.useState)(false);
    const onLabelRef = (0, $5uXOq.useCallback)((node)=>{
        if (node != null) {
            const isOverflow = Boolean(node.offsetWidth < node.scrollWidth);
            isOverflow !== labelOverflows && setLabelOverflows(isOverflow);
        }
    }, [
        labelOverflows
    ]);
    return {
        labelOverflows: labelOverflows,
        onLabelRef: onLabelRef,
        setLabelOverflows: setLabelOverflows
    };
};

});



parcelRegister("kgFPU", function(module, exports) {

$parcel$export(module.exports, "default", () => $77988429b36d0c09$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $77988429b36d0c09$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    listSystemWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-system-warning-message",
        "defaultMessage": "Any changes here will modify columns for all users."
    },
    listSystemWarningMessageNew: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-system-warning-message-new",
        "defaultMessage": "Changes will apply to everyone."
    },
    listFilterWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-filter-warning-message",
        "defaultMessage": "Any changes here will affect all users of this filter."
    },
    listNonEditableFilterInfoMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-non-editable-filter-info-message",
        "defaultMessage": "You can\u2019t modify this filter. Contact the owner using the <link>Filters directory</link> for edit permission."
    }
});

});


parcelRegister("bC77a", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerRemountManager", () => $43bbd345ff33d027$export$a4237a5d372a0de2);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $jlRhf = parcelRequire("jlRhf");

var $ih9zY = parcelRequire("ih9zY");
const $43bbd345ff33d027$export$a4237a5d372a0de2 = ({ children: children, viewIdFromResponse: viewIdFromResponse, isRestoringDefaults: isRestoringDefaults })=>{
    const [{ view: optimisticViewId }] = (0, $ih9zY.useSelectedViewState)();
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isLoading: isLoading } = (0, $jlRhf.useColumnPickerLoadingContext)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: isLoading ? 'loading' : `${optimisticViewId}${viewIdFromResponse}`
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        key: isRestoringDefaults ? 'loading' : optimisticViewId + viewIdFromResponse,
        "data-vc": `column-picker-container${false ? '-ssr' : ''}`
    }, children);
};

});

parcelRegister("2lRxk", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $67350735789792d8$export$a06f1c675e846f6f);

var $5uXOq = parcelRequire("5uXOq");

var $9DYf6 = parcelRequire("9DYf6");

var $isIOR = parcelRequire("isIOR");
const $67350735789792d8$export$a06f1c675e846f6f = ({ end: end, center: center, ...props })=>{
    const { isStalePage: isStalePage } = (0, $isIOR.useIssueSearchQuery)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9DYf6.components).Footer, {
        ...props,
        // Do not show pagination controls while issue data is stale as page cursor information will be inaccurate
        center: isStalePage && props.isNewFooterOrderEnabled ? undefined : center,
        end: isStalePage && !props.isNewFooterOrderEnabled ? undefined : end
    });
};

});
parcelRegister("9DYf6", function(module, exports) {

$parcel$export(module.exports, "components", () => $b2da35897bea1cb9$export$9b5ac10f59f76296);

var $eUiAo = parcelRequire("eUiAo");

var $35sx5 = parcelRequire("35sx5");

var $56vto = parcelRequire("56vto");
const $b2da35897bea1cb9$export$9b5ac10f59f76296 = {
    columnPicker: $eUiAo.components,
    Footer: $35sx5.Footer,
    NoColumns: $56vto.NoColumns
};

});
parcelRegister("eUiAo", function(module, exports) {

$parcel$export(module.exports, "components", () => $63a1b7bd09a72394$export$9b5ac10f59f76296);

var $50z6e = parcelRequire("50z6e");
const $63a1b7bd09a72394$export$9b5ac10f59f76296 = {
    NoOptionsMessage: $50z6e.default
};

});
parcelRegister("50z6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a81df9ef986c35d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dD7Zc = parcelRequire("dD7Zc");

var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $7krAo = parcelRequire("7krAo");
const $1a81df9ef986c35d$var$IconContainerConditional = ({ children: children })=>{
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a81df9ef986c35d$var$IconContainer, null, children);
};
const $1a81df9ef986c35d$var$MessageContainer = ({ icon: icon, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150",
        xcss: $1a81df9ef986c35d$var$stackStyles,
        alignInline: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text"
    }, formatMessage((0, $7krAo.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage((0, $7krAo.default).noOptionsSecondaryMessage)), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a81df9ef986c35d$var$Container, null, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a81df9ef986c35d$var$StyledTitle, null, formatMessage((0, $7krAo.default).title)), children);
};
/**
 * Custom message to show when no options are visible in the column picker. This allows additional help text/content to
 * be rendered using the children prop.
 */ const $1a81df9ef986c35d$var$NoOptionsMessage = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a81df9ef986c35d$var$MessageContainer, {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a81df9ef986c35d$var$IconContainerConditional, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            label: "",
            color: "var(--ds-icon, #44546F)",
            LEGACY_primaryColor: "currentColor"
        }))
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
var $1a81df9ef986c35d$export$2e2bcd8739ae039 = $1a81df9ef986c35d$var$NoOptionsMessage;
const $1a81df9ef986c35d$var$stackStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100',
    // this is for the children additional help text/content
    color: 'color.text.subtlest'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a81df9ef986c35d$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s81gzt _syaz131l _1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $1a81df9ef986c35d$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});
const $1a81df9ef986c35d$var$StyledTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7krAo", function(module, exports) {

$parcel$export(module.exports, "default", () => $51300b676abd2848$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $51300b676abd2848$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-table-column-picker.column-picker.no-options-message.title",
        "defaultMessage": "We couldn\u2019t find the field you\u2019re looking for."
    },
    noOptionsPrimaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});

});



parcelRegister("35sx5", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $9ac639c2cf475c33$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kYFm9 = parcelRequire("kYFm9");

var $9CFBJ = parcelRequire("9CFBJ");
const $9ac639c2cf475c33$export$a06f1c675e846f6f = ({ start: start = $9ac639c2cf475c33$var$SpacerElement, center: center = $9ac639c2cf475c33$var$SpacerElement, end: end = $9ac639c2cf475c33$var$SpacerElement })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$var$FooterBase, null, start, center, end);
};
function $9ac639c2cf475c33$var$FooterBase({ children: children }) {
    const tableHeight = (0, $kYFm9.useElementSizeSelector)((size)=>size.height);
    const hasShadow = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>{
        const { height: containerHeight, scrollTop: scrollTop } = scrollState;
        // Scroll measurements are fractional, while height measurements are integer, so we need to round before comparing
        return containerHeight < tableHeight && Math.round(scrollTop) < tableHeight - containerHeight;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$var$FooterContainer, {
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: hasShadow
    }, children);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ac639c2cf475c33$var$FooterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.hasShadow && "_16qsahas",
            __cmplp.className
        ])
    });
});
const $9ac639c2cf475c33$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $9ac639c2cf475c33$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$export$d7a54cba636a8cd6, null);

});

parcelRegister("56vto", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $1e9e65187073fe12$export$a0e9f6d02eee4aa4);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");

var $koVbs = parcelRequire("koVbs");

var $bHZac = parcelRequire("bHZac");

var $8zOmE = parcelRequire("8zOmE");

var $9yV2W = parcelRequire("9yV2W");
const $1e9e65187073fe12$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isOpen: isOpen }, actions] = (0, $bHZac.useColumnPickerOpenState)();
    const onOpenColumnPicker = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton');
        if (!isOpen) actions.open();
    }, [
        isOpen,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $9yV2W.default).noColumnsHeaderText),
        description: formatMessage((0, $9yV2W.default).noColumnsDescriptionText),
        testId: "native-issue-table.common.ui.components.no-columns.no-columns",
        primaryAction: hasColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: onOpenColumnPicker
        }, formatMessage((0, $9yV2W.default).configureColumns)) : undefined,
        renderImage: ()=>defaultNoColumnsGlyph
    }));
};

});
parcelRegister("bHZac", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerContainer", () => $cceed226e735615f$export$e1286e1cb3fa0dec);
$parcel$export(module.exports, "useColumnPickerOpenState", () => $cceed226e735615f$export$81588ffe8d9d4add);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $cceed226e735615f$export$e1286e1cb3fa0dec = (0, $gg7kZ.createContainer)();
const $cceed226e735615f$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'ColumnPickerOpenState',
    containedBy: $cceed226e735615f$export$e1286e1cb3fa0dec
});
const $cceed226e735615f$export$81588ffe8d9d4add = (0, $3sQ5x.createHook)($cceed226e735615f$var$Store);

});

parcelRegister("9yV2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb37f0f12ee9177e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cb37f0f12ee9177e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noColumnsHeaderText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-header-text",
        "defaultMessage": "Configure your columns"
    },
    noColumnsDescriptionText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-description-text",
        "defaultMessage": "You haven't configured any columns yet. Add fields as columns to see search results and their information."
    },
    configureColumns: {
        "id": "native-issue-table.issue-table.no-columns.configure-columns",
        "defaultMessage": "Configure columns"
    }
});

});




parcelRegister("8ev74", function(module, exports) {

$parcel$export(module.exports, "BulkOpsConnectionsSubscriber", () => $fdbbad112159e743$export$e722c6c8da1d5a1a);

var $5uXOq = parcelRequire("5uXOq");

var $48rMm = parcelRequire("48rMm");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $9fB6c = parcelRequire("9fB6c");
const $fdbbad112159e743$var$entryPointParams = {};
const $fdbbad112159e743$export$e722c6c8da1d5a1a = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const selectedIssues = (0, $48rMm.useIssueTableSelectedIssues)();
    const [hasSelectedAtLeastOnce, setHasSelectedAtLeastOnce] = (0, $5uXOq.useState)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $9fB6c.bulkOperationsConnectionsSubscriberEntryPoint), $fdbbad112159e743$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (!hasSelectedAtLeastOnce && selectedIssues.length > 0) {
            setHasSelectedAtLeastOnce(true);
            entryPointActions.load();
        }
    }, [
        entryPointActions,
        hasSelectedAtLeastOnce,
        selectedIssues.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.nin-bulk.operations.connections.subscriber",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
});

});
parcelRegister("9fB6c", function(module, exports) {

$parcel$export(module.exports, "bulkOperationsConnectionsSubscriberEntryPoint", () => $1445af39083fc172$export$f0e5693d80379467);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1445af39083fc172$export$f0e5693d80379467 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("icAqF")), {
        moduleId: "a230f98b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("icAqF", function(module, exports) {

let $d4059b0d88651597$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d4059b0d88651597$var$load("80fTN").then(()=>parcelRequire('HQMPw'));

});



parcelRegister("2hlL8", function(module, exports) {

$parcel$export(module.exports, "IssueCount", () => $987d8685128f2230$export$542fba90cc9c1bd1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $dCm1o = parcelRequire("dCm1o");

var $cyCoT = parcelRequire("cyCoT");

var $eLt1F = parcelRequire("eLt1F");

var $isIOR = parcelRequire("isIOR");
const $987d8685128f2230$export$542fba90cc9c1bd1 = (issueCountProps)=>{
    // TODO Remove when cleaning up jira_spreadsheet_component_m1
    let isStalePage = false;
    if (!(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ isStalePage: isStalePage } = (0, $isIOR.useIssueSearchQuery)());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987d8685128f2230$var$IssueCountContainer, {
        "data-testid": "issue-navigator.ui.issue-results.list-view.issue-count",
        isFlexEnd: issueCountProps.isNewFooterOrderEnabled
    }, !isStalePage && ((0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        testId: "issue-navigator.ui.issue-results.list-view.issue-count.text",
        xcss: $987d8685128f2230$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyCoT.default), issueCountProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": "issue-navigator.ui.issue-results.list-view.issue-count.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyCoT.default), issueCountProps))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eLt1F.default), null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $987d8685128f2230$var$IssueCountContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexEnd: isFlexEnd, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulp1b66 _1e0c1txw _4cvr1h6o _k48p1pd9",
            __cmplp.isFlexEnd ? "_1bahesu3" : "_1bah1h6o",
            __cmplp.className
        ])
    });
});
const $987d8685128f2230$var$textStyles = (0, $8CUq3.xcss)({
    fontWeight: 'font.weight.medium',
    color: 'color.text.subtle'
});

});

parcelRegister("df5k9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9512add73ee5293a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9512add73ee5293a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reorderColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reorder-columns-error-title",
        "defaultMessage": "We couldn't reorder your columns"
    },
    resetColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reset-columns-error-title",
        "defaultMessage": "We couldn't restore your default columns"
    },
    columnConfigMutationErrorDescription: {
        "id": "issue-navigator.issue-results.list-view.column-config-mutation-error-description",
        "defaultMessage": "Refresh and try again."
    }
});

});

parcelRegister("cKSn6", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $21675d57ff4dba29$export$a0e9f6d02eee4aa4);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");

var $6s1PB = parcelRequire("6s1PB");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $9DYf6 = parcelRequire("9DYf6");

var $8zOmE = parcelRequire("8zOmE");

var $g5X3G = parcelRequire("g5X3G");

var $cZpsT = parcelRequire("cZpsT");

var $ih9zY = parcelRequire("ih9zY");

var $1oKq6 = parcelRequire("1oKq6");
const $21675d57ff4dba29$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, children);
const $21675d57ff4dba29$var$NoColumnsAnonymous = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { setView: setView }] = (0, $ih9zY.useSelectedViewState)();
    const onClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton', {
            isAnon: true
        });
        setView('detail', (0, $g5X3G.toIssueKey)(''));
    }, [
        setView
    ]);
    const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $1oKq6.default).noColumnsHeaderAnonymous),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
            componentsMapping: {
                bold: $21675d57ff4dba29$var$Bold
            },
            message: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1oKq6.default).noColumnsDescriptionAnonymousIssueTermRefresh : (0, $1oKq6.default).noColumnsDescriptionAnonymous, {
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }),
        testId: "issue-navigator.ui.issue-results.list-view.no-columns.no-columns-anonymous",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $1oKq6.default).switchView)),
        renderImage: ()=>defaultNoColumnsGlyph
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.800"
    }, component);
};
const $21675d57ff4dba29$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21675d57ff4dba29$var$NoColumnsAnonymous, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9DYf6.components).NoColumns, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph,
        hasColumnConfiguration: hasColumnConfiguration
    });
};

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $2YZCu.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("1oKq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $180f8d8b8bfd2e47$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $180f8d8b8bfd2e47$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noColumnsHeaderAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-header-anonymous",
        "defaultMessage": "The admin hasn't configured any columns"
    },
    noColumnsDescriptionAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-description-anonymous",
        "defaultMessage": "Switch to {boldStart}Detail view{boldEnd} to see issues and their information."
    },
    switchView: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.switch-view",
        "defaultMessage": "Switch to detail view"
    },
    noColumnsDescriptionAnonymousIssueTermRefresh: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-description-anonymous-issue-term-refresh",
        "defaultMessage": "Switch to {boldStart}Detail view{boldEnd} to see work items and their information."
    }
});

});


parcelRegister("1g3qz", function(module, exports) {

$parcel$export(module.exports, "NoIssues", () => $b830958a6a36b095$export$a7a61a727a1d891b);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $hgx9A = parcelRequire("hgx9A");
const $b830958a6a36b095$export$a7a61a727a1d891b = ({ defaultNoIssuesGlyph: defaultNoIssuesGlyph })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hgx9A.default).noIssuesIssueTermRefresh : (0, $hgx9A.default).noIssues),
        renderImage: ()=>defaultNoIssuesGlyph,
        testId: "issue-navigator.ui.issue-results.list-view.no-issues.empty-state"
    }));
};

});
parcelRegister("hgx9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $4793c96b4dc9cacf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4793c96b4dc9cacf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    },
    noIssuesIssueTermRefresh: {
        "id": "issue-navigator.issue-results.list-view.no-issues.no-issues-issue-term-refresh",
        "defaultMessage": "There's nothing matching your search"
    }
});

});


parcelRegister("ePwTF", function(module, exports) {

$parcel$export(module.exports, "AsyncRegisterShortcutDialogActions", () => $336808f7ab792907$export$53d5920188b673b6);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $a0UwL = parcelRequire("a0UwL");

var $kxZPA = parcelRequire("kxZPA");
var $6Lg6A = parcelRequire("6Lg6A");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $336808f7ab792907$var$LazyRegisterShortcutDialogActions = (0, $kxZPA.lazy)(()=>(parcelRequire("8znGq")), {
    moduleId: "./src/packages/issue-navigator/issue-navigator/src/ui/issue-results/list-view/register-shortcut-dialog-actions/index.tsx"
});
const $336808f7ab792907$export$53d5920188b673b6 = (props)=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, $a0UwL.useShortcuts)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigator",
        id: "register-issue-actions-worklflow-shortcuts-dialog",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
        until: isShortcutsDialogVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "register-shortcut-dialog-actions",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($336808f7ab792907$var$LazyRegisterShortcutDialogActions, props))));
};

});
parcelRegister("a0UwL", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $991d4b7077d5c717$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $991d4b7077d5c717$export$b331ee6e87b9104c);

var $axjlw = parcelRequire("axjlw");
const $991d4b7077d5c717$export$a1ca853c6e4bb6fb = ()=>(0, $axjlw.useShortcutsStore)();
const $991d4b7077d5c717$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $axjlw.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("axjlw", function(module, exports) {

$parcel$export(module.exports, "useShortcutsStore", () => $fefbe59bb1ce22b9$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $fefbe59bb1ce22b9$export$1a29bfef7fa09838);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $f0R9h = parcelRequire("f0R9h");
const $fefbe59bb1ce22b9$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $fefbe59bb1ce22b9$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $fefbe59bb1ce22b9$export$d4c72bab9d6cc13a,
    actions: $f0R9h
});
const $fefbe59bb1ce22b9$export$a14646bfc7ba8d81 = (0, $3sQ5x.createHook)($fefbe59bb1ce22b9$export$6f57813fe9f31bf9);
const $fefbe59bb1ce22b9$export$1a29bfef7fa09838 = (0, $3sQ5x.createHook)($fefbe59bb1ce22b9$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("f0R9h", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", () => $d845eb212fa1ca53$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $d845eb212fa1ca53$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $d845eb212fa1ca53$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $d845eb212fa1ca53$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $d845eb212fa1ca53$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $d845eb212fa1ca53$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $d845eb212fa1ca53$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $d845eb212fa1ca53$export$9cf39adf0dec984);

var $k8IPx = parcelRequire("k8IPx");

var $1qfyE = parcelRequire("1qfyE");

var $8mrJC = parcelRequire("8mrJC");
const $d845eb212fa1ca53$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $d845eb212fa1ca53$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $d845eb212fa1ca53$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $d845eb212fa1ca53$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $d845eb212fa1ca53$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $d845eb212fa1ca53$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $1qfyE.default)();
        const shortcuts = result ? (0, $8mrJC.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $d845eb212fa1ca53$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $d845eb212fa1ca53$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("1qfyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0636f27c00094fd3$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0636f27c00094fd3$export$2e2bcd8739ae039 = async ()=>{
    try {
        return await (0, $7f4tk.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};

});

parcelRegister("8mrJC", function(module, exports) {

$parcel$export(module.exports, "buildAdminSections", () => $9289773ab8ca36d5$export$5f8c94ecd4c9eb76);
const $9289773ab8ca36d5$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$9289773ab8ca36d5$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("8znGq", function(module, exports) {

let $63d3f6a0e87efa4e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $63d3f6a0e87efa4e$var$load("lA0j4").then(()=>parcelRequire('Jq3ih'));

});


parcelRegister("dHKP1", function(module, exports) {

$parcel$export(module.exports, "dragAndDropExperience", () => $ede56ac081600cc8$export$c1eb53e51d4d0ab3);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $ede56ac081600cc8$export$c1eb53e51d4d0ab3 = new (0, $duUGa.UFOExperience)('jira-issue-navigator.list-view.drag-and-drop', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("dYvVi", function(module, exports) {

$parcel$export(module.exports, "useEventHandlers", () => $a2e970e494c5fd70$export$8ce912bc34d0dbea);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $g5X3G = parcelRequire("g5X3G");

var $gtUFk = parcelRequire("gtUFk");

var $7OTah = parcelRequire("7OTah");

var $isIOR = parcelRequire("isIOR");

var $cqgcE = parcelRequire("cqgcE");

var $6Hhfn = parcelRequire("6Hhfn");
const $a2e970e494c5fd70$var$useEventHandlersOld = ()=>{
    const { setSelectedIssueByKey: setSelectedIssueByKey, deselectIssue: deselectIssue } = (0, $gtUFk.useSelectedIssueStateOldActions)();
    const { onDeleteIssue: onDeleteIssue, onIssueByFieldsRefetch: onIssueByFieldsRefetch } = (0, $isIOR.useIssueSearchQuery)();
    const onIssueRefetch = onIssueByFieldsRefetch;
    // While we don't have a mutation setup for inline editing, use issue refetch as a substitute
    const onUpdateCache = onIssueByFieldsRefetch;
    const onIssueDelete = (0, $5uXOq.useCallback)((deletedIssueKey)=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue(false, false, false);
            return;
        }
        setSelectedIssueByKey((0, $g5X3G.toIssueKey)(issueKeyToSelect), false, false, false);
    }, [
        onDeleteIssue,
        setSelectedIssueByKey,
        deselectIssue
    ]);
    const onIssueLinkSelected = (0, $5uXOq.useCallback)((issueKey)=>{
        setSelectedIssueByKey((0, $g5X3G.toIssueKey)(issueKey));
        return true;
    }, [
        setSelectedIssueByKey
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            onIssueRefetch: onIssueRefetch,
            onUpdateCache: onUpdateCache,
            onIssueDelete: onIssueDelete,
            onIssueLinkSelected: onIssueLinkSelected
        }), [
        onIssueRefetch,
        onUpdateCache,
        onIssueDelete,
        onIssueLinkSelected
    ]);
};
const $a2e970e494c5fd70$var$useEventHandlersNew = (connectionId, fieldSetIds)=>{
    const { setSelectedIssueByKey: setSelectedIssueByKey, deselectIssue: deselectIssue } = (0, $7OTah.useSelectedIssueActions)();
    const onDeleteIssue = (0, $cqgcE.useOnDeleteIssue)(connectionId);
    const onIssueByFieldsRefetch = (0, $6Hhfn.useIssueByFieldsRefetch)(fieldSetIds);
    const onIssueRefetch = onIssueByFieldsRefetch;
    // While we don't have a mutation setup for inline editing, use issue refetch as a substitute
    const onUpdateCache = onIssueByFieldsRefetch;
    const onIssueDelete = (0, $5uXOq.useCallback)((deletedIssueKey)=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue({
                shouldDebounce: false,
                shouldNotifyOnChange: false,
                isSelectedByUserInteraction: false
            });
            return;
        }
        setSelectedIssueByKey((0, $g5X3G.toIssueKey)(issueKeyToSelect), {
            shouldDebounce: false,
            shouldNotifyOnChange: false,
            isSelectedByUserInteraction: false
        });
    }, [
        onDeleteIssue,
        setSelectedIssueByKey,
        deselectIssue
    ]);
    const onIssueLinkSelected = (0, $5uXOq.useCallback)((issueKey, viewActivity)=>{
        setSelectedIssueByKey((0, $g5X3G.toIssueKey)(issueKey), {
            viewActivity: viewActivity
        });
        return true;
    }, [
        setSelectedIssueByKey
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            onIssueRefetch: onIssueRefetch,
            onUpdateCache: onUpdateCache,
            onIssueDelete: onIssueDelete,
            onIssueLinkSelected: onIssueLinkSelected
        }), [
        onIssueRefetch,
        onUpdateCache,
        onIssueDelete,
        onIssueLinkSelected
    ]);
};
const $a2e970e494c5fd70$export$8ce912bc34d0dbea = (connectionId, fieldSetIds)=>(0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false) ? $a2e970e494c5fd70$var$useEventHandlersNew(connectionId, fieldSetIds) : $a2e970e494c5fd70$var$useEventHandlersOld();

});



parcelRegister("gOpmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $df04299218cd8fb7$export$2e2bcd8739ae039);

var $2KpEY = parcelRequire("2KpEY");

var $CuCBv = parcelRequire("CuCBv");

var $9XMR6 = parcelRequire("9XMR6");

var $gq57B = parcelRequire("gq57B");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lhXIu = parcelRequire("lhXIu");

var $kQ256 = parcelRequire("kQ256");

var $3RNwj = parcelRequire("3RNwj");

var $8WcPx = parcelRequire("8WcPx");

var $032ey = parcelRequire("032ey");

var $3HwlS = parcelRequire("3HwlS");

var $elFwM = parcelRequire("elFwM");

var $9z65D = parcelRequire("9z65D");

var $cZpsT = parcelRequire("cZpsT");

var $l8ruj = parcelRequire("l8ruj");

var $7XYc4 = parcelRequire("7XYc4");

var $1TiUe = parcelRequire("1TiUe");

var $dCm1o = parcelRequire("dCm1o");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $a8lIB = parcelRequire("a8lIB");

var $1z7Yr = parcelRequire("1z7Yr");

var $acgaZ = parcelRequire("acgaZ");

var $anxcG = parcelRequire("anxcG");

var $gwtSG = parcelRequire("gwtSG");

var $isIOR = parcelRequire("isIOR");

var $38r5c = parcelRequire("38r5c");

var $bNJuB = parcelRequire("bNJuB");

var $5aoL8 = parcelRequire("5aoL8");

var $66jXs = parcelRequire("66jXs");

var $weR3I = parcelRequire("weR3I");

var $3iu8n = parcelRequire("3iu8n");

const $df04299218cd8fb7$var$JQLBuilderWrapper = ({ defaultJql: defaultJql, onFilterSave: onFilterSave, onReset: onReset, onChangeJql: onChangeJql, onToggleAi: onToggleAi, groupResults: groupResults, issueResults: issueResults, filter: filter, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey, initialQueryAsJql: initialQueryAsJql })=>{
    const { startJqlBuilderMetric: startJqlBuilderMetric, stopJqlBuilderMetric: stopJqlBuilderMetric, markJqlBuilderMetric: markJqlBuilderMetric } = (0, $weR3I.useJqlBuilderInstrumentation)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        startJqlBuilderMetric();
        markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_START);
    }, [
        startJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const { query: query, onSearch: onSearch } = (0, $anxcG.useJqlSearch)(onChangeJql);
    const { maybeHydrationQueryReference: maybeHydrationQueryReference, ...restJqlBuilderProps } = jqlBuilderProps ?? {
        maybeHydrationQueryReference: undefined
    }; /**
      * We will only utilise a router resource HydrationQueryReference if it is the
      * first time the component is mounted on page load.
      * So we check whether the query hasn't changed between page load and component mount
      */ 
    const [hydrationQueryReferenceRef] = (0, $5uXOq.useState)(()=>{
        if (!(0, $4R6GH.fg)('jracloud_85520_hydration_ref_only_on_page_load')) return undefined;
        return initialQueryAsJql === query ? maybeHydrationQueryReference : undefined;
    });
    const { jql: jql, filterJql: filterJql, filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let isFetching;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    isFetching = (0, $38r5c.useIsFetching)();
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ isFetching: isFetching } = (0, $isIOR.useIssueSearchQuery)());
    const groupResultsData = (0, $8Uumt.useFragment)((0, $gq57B.default), groupResults);
    const issueResultsData = (0, $8Uumt.useFragment)((0, $9XMR6.default), issueResults);
    const issueSearchError = issueResultsData?.issueSearchError ?? null;
    const jqlErrors = (0, $5uXOq.useMemo)(()=>{
        const groupConnectionClientErrors = (groupResultsData?.errors ?? []).filter(({ extensions: extensions })=>extensions?.some(({ statusCode: statusCode })=>typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500));
        if (!isFetching) {
            if (issueSearchError) {
                if (issueSearchError.__typename === 'JiraInvalidJqlError') return issueSearchError.messages?.filter((0, $eJ0Zs.isNonNullish)).map((message)=>({
                        type: 'error',
                        message: message
                    })) ?? [];
                if (issueSearchError.__typename === 'JiraInvalidSyntaxError' && issueSearchError.message != null) return [
                    {
                        type: 'error',
                        message: issueSearchError.message,
                        errorType: issueSearchError.errorType ?? undefined
                    }
                ];
            } else if (groupConnectionClientErrors.length && (0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) return groupConnectionClientErrors.map(({ message: message })=>({
                    message: message,
                    type: 'error'
                }));
        }
        return undefined;
    }, [
        groupResultsData?.errors,
        isFetching,
        issueSearchError
    ]);
    const filterData = (0, $8Uumt.useFragment)((0, $CuCBv.default), filter);
    const ResetButtonControl = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $66jXs.default), {
            onReset: onReset
        }), [
        onReset
    ]);
    const GoBackToFilterButtonControl = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $66jXs.default), {
            onReset: onReset,
            isResetToFilter: true
        }), [
        onReset
    ]);
    const SaveFilterDialog = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point'), (0, $elFwM.SaveFilterDialog), (0, $9z65D.AsyncSaveFilterDialog));
    const SaveFilterControl = (0, $5uXOq.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df04299218cd8fb7$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-control",
            "data-vc": "jql-builder-ui-save-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SaveFilterDialog, {
            jql: query,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $032ey.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $bNJuB.default).saveFilterButton),
            title: formatMessage((0, $bNJuB.default).saveFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        formatMessage,
        SaveFilterDialog
    ]);
    const SaveFilterDropdownControl = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df04299218cd8fb7$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-dropdown-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lhXIu.SaveFilterDropdown), {
            query: query,
            filterId: filterId,
            onFilterSave: onFilterSave
        })), [
        filterId,
        query,
        onFilterSave
    ]);
    const CopyFilterControl = (0, $5uXOq.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df04299218cd8fb7$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.copy-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SaveFilterDialog, {
            jql: query,
            filterId: filterId,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $032ey.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $bNJuB.default).copyFilterButton),
            title: formatMessage((0, $bNJuB.default).copyFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        filterId,
        formatMessage,
        SaveFilterDialog
    ]);
    const renderFilterControls = (0, $5uXOq.useCallback)(()=>{
        const extraControls = []; // Button nor dropdown should be shown when user is anonymous
        if (!isAnonymous) {
            if (filterData) {
                const { isEditable: isEditable } = filterData; // Should not show neither the button nor the dropdown if jql errors
                if (!jqlErrors || jqlErrors.length === 0) {
                    if ((0, $3iu8n.isFilterJqlModified)({
                        filterJql: filterJql,
                        query: query
                    })) {
                        if (isEditable === true) extraControls.push(SaveFilterDropdownControl);
                        else extraControls.push(SaveFilterControl);
                    } else extraControls.push(CopyFilterControl);
                }
            } else extraControls.push(SaveFilterControl);
        }
        return extraControls;
    }, [
        CopyFilterControl,
        SaveFilterControl,
        SaveFilterDropdownControl,
        filterData,
        filterJql,
        isAnonymous,
        jqlErrors,
        query
    ]);
    const renderExtraControls = (0, $5uXOq.useCallback)(()=>{
        const extraControls = [];
        const showResetButton = (0, $3iu8n.isOnlyJqlAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $3iu8n.isOnlyFilterAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $3iu8n.filterAndJqlIsTheSameAndDifferentToDefault)(jql, defaultJql, filterJql);
        const showGoBackToFilterButton = (0, $3iu8n.jqlIsDifferentToFilter)(jql, filterJql);
        const addResetButton = ()=>showGoBackToFilterButton || showResetButton;
        if (addResetButton()) extraControls.push(showResetButton ? ResetButtonControl : GoBackToFilterButtonControl);
        extraControls.push(...renderFilterControls());
        return extraControls;
    }, [
        renderFilterControls,
        jql,
        defaultJql,
        filterJql,
        ResetButtonControl,
        GoBackToFilterButtonControl
    ]);
    const { messages: jqlInfos } = (0, $acgaZ.useJqlSearchStatus)({
        query: query,
        isSearching: isFetching
    });
    const jqlMessages = (0, $5uXOq.useMemo)(()=>[
            ...jqlErrors || [],
            ...jqlInfos || []
        ], [
        jqlErrors,
        jqlInfos
    ]);
    const onLoad = (0, $5uXOq.useCallback)((mode)=>{
        if (mode === (0, $032ey.SEARCH_MODE_BASIC)) markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_BASIC_START);
        else markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_ADVANCED_START);
    }, [
        markJqlBuilderMetric
    ]);
    const onReady = (0, $5uXOq.useCallback)((mode)=>{
        if (mode === (0, $032ey.SEARCH_MODE_BASIC)) {
            markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_BASIC_END);
            markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_END);
        } else {
            markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_ADVANCED_END);
            markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_END);
        }
        stopJqlBuilderMetric();
    }, [
        stopJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const aiBuilderOverrides = (0, $5uXOq.useMemo)(()=>({
            // Only render filter controls (no reset action) for the AI embedded JQL builder
            renderExtraControls: renderFilterControls
        }), [
        renderFilterControls
    ]); /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ 
    const jqlBuilderWithAiData = (0, $8Uumt.useFragment)((0, $2KpEY.default), jqlBuilderWithAiKey); /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ 
    const { onJourneyStart: onJourneyStart } = (0, $1z7Yr.useAppContextualAnalyticsActions)();
    const handlePerformanceMark = (0, $5uXOq.useCallback)(({ mark: mark })=>{
        markJqlBuilderMetric(mark);
    }, [
        markJqlBuilderMetric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $df04299218cd8fb7$var$wrapperStyles,
            (0, $3HwlS.getWillShowNav4)() && $df04299218cd8fb7$var$newWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kQ256.ShortcutsDialogIntegrationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WcPx.default), {
        analyticsSource: (0, $6UAdF.ANALYTICS_SOURCE),
        query: query,
        onSearch: onSearch,
        renderExtraControls: renderExtraControls,
        jqlMessages: jqlMessages,
        isSearching: isFetching,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        NoOptionComponent: (0, $5aoL8.NoOptionsMessage),
        aiBuilderOverrides: aiBuilderOverrides,
        onToggleAi: onToggleAi,
        fragmentKey: jqlBuilderWithAiData,
        onPerformanceMark: handlePerformanceMark,
        ...(0, $4R6GH.fg)('jracloud_85520_hydration_ref_only_on_page_load') ? {
            maybeHydrationQueryReference: hydrationQueryReferenceRef,
            ...restJqlBuilderProps
        } : jqlBuilderProps,
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-fix-ai-inline-prompt') ? {} : (0, $4R6GH.fg)('visual-refresh_drop_6') ? {
            aiInlineContainerStyles: $df04299218cd8fb7$var$aiInlineContainerStyles
        } : {}
    })));
};
const $df04299218cd8fb7$var$JQLBuilderWrapperWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "issue-navigator-jql-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "ui.jql-builder.error-boundary",
        packageName: (0, $6UAdF.PACKAGE_NAME),
        teamName: (0, $6UAdF.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $gcl1l.isLoaderErrorAttributes),
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3RNwj.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df04299218cd8fb7$var$JQLBuilderWrapper, props)));
var $df04299218cd8fb7$export$2e2bcd8739ae039 = $df04299218cd8fb7$var$JQLBuilderWrapperWithErrorBoundary;
const $df04299218cd8fb7$var$wrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.negative.025',
    marginBottom: 'space.0'
});
const $df04299218cd8fb7$var$newWrapperStyles = (0, $8CUq3.xcss)({
    flexGrow: 'var(--jql-wrapper-grow, 0)',
    maxHeight: 'min-content'
});
const $df04299218cd8fb7$var$aiInlineContainerStyles = (0, $8CUq3.xcss)({
    transform: 'translateY(-9%)'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df04299218cd8fb7$var$SaveFilterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2KpEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f74bc17cdb37af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96f197ee49bffef91f88aabc89058cb4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f3f74bc17cdb37af$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_jqlBuilderWithAi_JQLBuilderWithAI"
        }
    ],
    "type": "JiraQuery"
};
$f3f74bc17cdb37af$var$node.hash = "dd0aae667d7d92a8112c28d2dcff0ac8";
var $f3f74bc17cdb37af$export$2e2bcd8739ae039 = $f3f74bc17cdb37af$var$node;

});

parcelRegister("CuCBv", function(module, exports) {

$parcel$export(module.exports, "default", () => $85c380d9942dc9d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a76e30faae7fd3f790cc395215820217>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $85c380d9942dc9d5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ],
    "type": "JiraCustomFilter"
};
$85c380d9942dc9d5$var$node.hash = "46b543f50c73d7423957a8ecbe71b627";
var $85c380d9942dc9d5$export$2e2bcd8739ae039 = $85c380d9942dc9d5$var$node;

});

parcelRegister("9XMR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2c66ac90ee34e3d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a3182e66785e68d12090ebb9bf08695e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2c66ac90ee34e3d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "messages"
                        }
                    ],
                    "type": "JiraInvalidJqlError"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "errorType"
                        }
                    ],
                    "type": "JiraInvalidSyntaxError"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$a2c66ac90ee34e3d$var$node.hash = "eeb59c3a307dc75263f7e39b4f314c7c";
var $a2c66ac90ee34e3d$export$2e2bcd8739ae039 = $a2c66ac90ee34e3d$var$node;

});

parcelRegister("gq57B", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e1d70940a61f798$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2da135e56e9e45c2e5f481821656e304>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0e1d70940a61f798$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults",
    "selections": [
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$0e1d70940a61f798$var$node.hash = "30cd518272beee6c712a219e1b78cd63";
var $0e1d70940a61f798$export$2e2bcd8739ae039 = $0e1d70940a61f798$var$node;

});

parcelRegister("lhXIu", function(module, exports) {

$parcel$export(module.exports, "SaveFilterDropdown", () => $27f5e7d6c447efe5$export$4aae2fedc7924eed);

var $64TeP = parcelRequire("64TeP");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $c8Oei = parcelRequire("c8Oei");

var $jcw0u = parcelRequire("jcw0u");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $7oAQw = parcelRequire("7oAQw");

var $eVAtv = parcelRequire("eVAtv");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $c88gN = parcelRequire("c88gN");

var $cKjus = parcelRequire("cKjus");

var $9OXo1 = parcelRequire("9OXo1");

var $a0UsQ = parcelRequire("a0UsQ");

var $4R6GH = parcelRequire("4R6GH");

var $lXAdy = parcelRequire("lXAdy");

var $inHPh = parcelRequire("inHPh");
const $27f5e7d6c447efe5$export$a3ca021e3e6c7315 = (0, $7HGHK.toFlagId)('issue-navigator-save-filter-success-flag');
const $27f5e7d6c447efe5$export$f5e4c120ac01b615 = (0, $7HGHK.toFlagId)('issue-navigator-save-filter-error-flag');
const $27f5e7d6c447efe5$export$4aae2fedc7924eed = ({ defaultOpen: defaultOpen = false, filterId: filterId, query: query, onFilterSave: onFilterSave })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const [updateJiraCustomFilterJqlMutation] = (0, $8Uumt.useMutation)((0, $64TeP.default));
    const { activationId: activationId, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    const onSaveChanges = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterChanges');
        filterId !== undefined && updateJiraCustomFilterJqlMutation({
            variables: {
                id: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                jql: query
            },
            onCompleted: ({ jira: jira })=>{
                if (jira?.jiraFilterMutation?.updateJiraCustomFilterJql) {
                    const { success: success, filter: filter, errors: jiraErrors } = jira?.jiraFilterMutation?.updateJiraCustomFilterJql;
                    if (success && filter) {
                        const { name: name } = filter;
                        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
                            actionSubject: 'issueFilterJql',
                            action: 'updated'
                        }), 'issueFilterJql updated');
                        showFlag({
                            id: $27f5e7d6c447efe5$export$a3ca021e3e6c7315,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eVAtv.SuccessFlag), {
                                    id: $27f5e7d6c447efe5$export$a3ca021e3e6c7315,
                                    messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.success-flag",
                                    messageType: "transactional",
                                    filterName: name,
                                    viewUrl: `${window.location.origin}/issues/?filter=${filterId}`,
                                    analyticsEvent: createAnalyticsEvent({
                                        actionSubject: 'button',
                                        action: 'clicked'
                                    }),
                                    ...renderProps
                                })
                        });
                    } else {
                        const errors = jiraErrors ? jiraErrors.map((error)=>error.message || '') : [];
                        showFlag({
                            id: $27f5e7d6c447efe5$export$f5e4c120ac01b615,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7oAQw.ErrorFlag), {
                                    id: $27f5e7d6c447efe5$export$f5e4c120ac01b615,
                                    messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.error-flag",
                                    messageType: "transactional",
                                    errors: errors,
                                    ...renderProps
                                })
                        });
                        (0, $jcw0u.default)({
                            event: analyticsEvent,
                            error: new Error(errors[0]),
                            meta: {
                                id: 'updateFilterJqlMutation',
                                packageName: 'jiraIssueNavigatorCustomFilters',
                                teamName: 'empanada'
                            }
                        });
                    }
                }
            },
            onError: (error)=>{
                showFlag({
                    id: $27f5e7d6c447efe5$export$f5e4c120ac01b615,
                    render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7oAQw.ErrorFlag), {
                            id: $27f5e7d6c447efe5$export$f5e4c120ac01b615,
                            messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.error-flag.1",
                            messageType: "transactional",
                            ...renderProps,
                            errors: [
                                ''
                            ]
                        })
                });
                (0, $jcw0u.default)({
                    event: analyticsEvent,
                    error: error,
                    meta: {
                        id: 'updateFilterJqlMutation',
                        packageName: 'jiraIssueNavigatorCustomFilters',
                        teamName: 'empanada'
                    }
                });
                return undefined;
            }
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        filterId,
        query,
        showFlag,
        updateJiraCustomFilterJqlMutation,
        analyticsEvent
    ]);
    const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(defaultOpen);
    const [shouldShowThirdPartyNudge, setShouldShowThirdPartyNudge] = (0, $5uXOq.useState)(false);
    const onOpenSaveFilterModal = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterCopy');
        setIsModalOpen(true);
    }, [
        createAnalyticsEvent,
        setIsModalOpen
    ]);
    const onCloseSaveFilterModal = (0, $5uXOq.useCallback)(()=>{
        setIsModalOpen(false);
    }, [
        setIsModalOpen
    ]);
    let modalProps;
    let entryPointProps;
    let entryPointParams;
    if ((0, $4R6GH.fg)('nin-save-filter-dialog-entry-point')) {
        modalProps = {
            width: 'medium',
            shouldScrollInViewport: true,
            shouldReturnFocus: false
        }; // eslint-disable-next-line react-hooks/rules-of-hooks
        entryPointProps = (0, $5uXOq.useMemo)(()=>({
                jql: query,
                filterId: filterId,
                onFilterSave: onFilterSave,
                title: formatMessage((0, $inHPh.default).copyFilterDialogTitle)
            }), [
            query,
            filterId,
            onFilterSave,
            formatMessage
        ]); // eslint-disable-next-line react-hooks/rules-of-hooks
        entryPointParams = (0, $5uXOq.useMemo)(()=>({
                filterAri: filterId !== null && filterId !== undefined ? (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }) : undefined
            }), [
            filterId,
            cloudId,
            activationId
        ]);
    }
    const onTriggerClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        }), 'filterOptions');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowThirdPartyNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a0UsQ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($27f5e7d6c447efe5$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isOpen: isDropdownOpen,
        onOpenChange: (attrs)=>{
            setIsDropdownOpen(attrs.isOpen);
            if (attrs.isOpen) {
                setShouldShowThirdPartyNudge(true);
                onTriggerClick();
            }
        },
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                appearance: "link",
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                    label: formatMessage((0, $inHPh.default).saveFilter)
                })
            }, formatMessage((0, $inHPh.default).saveFilter))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onSaveChanges
    }, formatMessage((0, $inHPh.default).saveChanges)), (0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXAdy.ModalEntryPointDropdownItemTrigger), {
        onClick: onOpenSaveFilterModal,
        modalProps: modalProps,
        entryPoint: (0, $c88gN.saveFilterDialogEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "save-filter-copy",
        useInternalModal: true
    }, formatMessage((0, $inHPh.default).saveAsACopy)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onOpenSaveFilterModal
    }, formatMessage((0, $inHPh.default).saveAsACopy))))), !(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjus.AsyncSaveFilterDialogContent), {
        isOpen: isModalOpen,
        jql: query,
        filterId: filterId,
        onClose: onCloseSaveFilterModal,
        onFilterSave: onFilterSave,
        title: formatMessage((0, $inHPh.default).copyFilterDialogTitle)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $27f5e7d6c447efe5$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k4hekqvv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("64TeP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e51d2a292043c16$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bfa68958cffd28f839eb1cc1261ee729>>
 * @relayHash a8b99d4e5148c557424db90f1be8215c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5
const $7e51d2a292043c16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFilterMutation",
                    "kind": "LinkedField",
                    "name": "jiraFilterMutation",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "id"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "jql",
                                            "variableName": "jql"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "input"
                                }
                            ],
                            "concreteType": "JiraUpdateCustomFilterJqlPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraCustomFilterJql",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraCustomFilter",
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5",
            "metadata": {},
            "name": "mainUpdateFilterJqlMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7e51d2a292043c16$var$node.hash = "6807efed6a00f60f9cf95df455e467fd";
var $7e51d2a292043c16$export$2e2bcd8739ae039 = $7e51d2a292043c16$var$node;

});

parcelRegister("7oAQw", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $8373e62b74d8a04b$export$518ba8e0e60f145f);

var $5uXOq = parcelRequire("5uXOq");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $koVbs = parcelRequire("koVbs");

var $f2rml = parcelRequire("f2rml");
const $8373e62b74d8a04b$export$518ba8e0e60f145f = ({ id: id, errors: errors, messageId: messageId = 'issue-navigator-actions-common.ui.error-flag.jira-error-flag', messageType: messageType = 'transactional' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const onDismissed = (0, $5uXOq.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    const description = (0, $5uXOq.useMemo)(()=>errors.reduce((desc, error)=>`${desc}\n${error}`), [
        errors
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpPp.default), {
        id: (0, $7HGHK.fromFlagId)(id),
        onDismissed: onDismissed,
        title: formatMessage((0, $f2rml.default).flagTitle),
        description: description,
        messageId: messageId,
        messageType: messageType
    });
};

});
parcelRegister("f2rml", function(module, exports) {

$parcel$export(module.exports, "default", () => $9196e79ea8ea2ad1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9196e79ea8ea2ad1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.error-flag.flag-title",
        "defaultMessage": "Filter couldn't be saved"
    }
});

});


parcelRegister("eVAtv", function(module, exports) {

$parcel$export(module.exports, "SuccessFlag", () => $92d66436aee8a83b$export$93bd4963a1d00fd5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $4ywcn = parcelRequire("4ywcn");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $d0WfM = parcelRequire("d0WfM");
const $92d66436aee8a83b$export$93bd4963a1d00fd5 = ({ id: id, filterName: filterName, viewUrl: viewUrl, analyticsEvent: analyticsEvent, messageId: messageId = 'issue-navigator-actions-common.ui.success-flag.jira-success-flag', messageType: messageType = 'transactional' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [isCopied, setCopied] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const copyToClipboard = (0, $5uXOq.useCallback)(()=>{
        try {
            if ((0, $4R6GH.fg)('jfp-magma-undefined-navigator')) globalThis.navigator.clipboard.writeText(viewUrl);
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            navigator.clipboard.writeText(viewUrl);
            setCopied(true);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'copyLink'); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'copyToClipboard',
                    packageName: 'jiraIssueNavigatorActionsCommon'
                }
            });
        }
    }, [
        analyticsEvent,
        viewUrl
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>{
        const flagActions = [];
        flagActions.push({
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92d66436aee8a83b$var$CopySuccess, null, formatMessage((0, $d0WfM.default).copyActionCopied)) : formatMessage((0, $d0WfM.default).copyAction),
            onClick: copyToClipboard
        });
        return flagActions;
    }, [
        copyToClipboard,
        formatMessage,
        isCopied
    ]);
    const onDismissed = (0, $5uXOq.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ywcn.default), {
        id: (0, $7HGHK.fromFlagId)(id),
        onDismissed: onDismissed,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92d66436aee8a83b$var$WordBreakSpan, null, formatMessage((0, $d0WfM.default).flagTitle, {
            name: filterName
        })),
        description: formatMessage((0, $d0WfM.default).flagDescription),
        messageId: messageId,
        messageType: messageType,
        actions: actions
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92d66436aee8a83b$var$CopySuccess = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazy73q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92d66436aee8a83b$var$WordBreakSpan = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1nmz1hna",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $92d66436aee8a83b$export$7ed12d2a5241e393 = {
    WordBreakSpan: $92d66436aee8a83b$var$WordBreakSpan
};

});
parcelRegister("d0WfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $be725ec701d9f454$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $be725ec701d9f454$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.success-flag.flag-title",
        "defaultMessage": "\"{name}\" filter saved"
    },
    flagDescription: {
        "id": "issue-navigator-actions-common.success-flag.flag-description",
        "defaultMessage": "We\u2019ve saved this filter successfully."
    },
    viewAction: {
        "id": "issue-navigator-actions-common.success-flag.view-action",
        "defaultMessage": "View filter"
    },
    copyAction: {
        "id": "issue-navigator-actions-common.success-flag.copy-action",
        "defaultMessage": "Copy link"
    },
    copyActionCopied: {
        "id": "issue-navigator-actions-common.success-flag.copy-action-copied",
        "defaultMessage": "Copied"
    }
});

});


parcelRegister("a0UsQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $18bfcc44ee4250a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $apcoj = parcelRequire("apcoj");
const $18bfcc44ee4250a9$var$runtimeProps = {};
const $18bfcc44ee4250a9$var$entryPointParams = {};
const $18bfcc44ee4250a9$var$AsyncThirdPartyNudge = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $apcoj.thirdPartyNudgeEntryPoint), $18bfcc44ee4250a9$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "third-party-nudge-spotlight",
        packageName: "third-party-nudge",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $18bfcc44ee4250a9$var$runtimeProps,
        errorFallback: "unmount"
    });
};
var $18bfcc44ee4250a9$export$2e2bcd8739ae039 = $18bfcc44ee4250a9$var$AsyncThirdPartyNudge;

});
parcelRegister("apcoj", function(module, exports) {

$parcel$export(module.exports, "thirdPartyNudgeEntryPoint", () => $b44a97c5eec5eb15$export$b751b31b276f613a);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $b44a97c5eec5eb15$export$b751b31b276f613a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2Y2up")), {
        moduleId: "3cb7fd8f"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2Y2up", function(module, exports) {

let $22931dbc2178d2d4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $22931dbc2178d2d4$var$load("jsSdY").then(()=>parcelRequire('7R5AD'));

});



parcelRegister("inHPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $610585c330983aff$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $610585c330983aff$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    saveFilter: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-filter",
        "defaultMessage": "Save filter"
    },
    saveChanges: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-changes",
        "defaultMessage": "Save changes"
    },
    saveAsACopy: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-as-a-copy",
        "defaultMessage": "Save as a copy"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});

});


parcelRegister("kQ256", function(module, exports) {

$parcel$export(module.exports, "useIntegrateDotDialogContext", () => $4f25f7900866c0e5$export$705d46354f301b1c);
$parcel$export(module.exports, "ShortcutsDialogIntegrationProvider", () => $4f25f7900866c0e5$export$97e3ca22c7078b46);

var $5uXOq = parcelRequire("5uXOq");
const $4f25f7900866c0e5$var$PRESET_VALUE = {
    DEFAULT: {
        isShortcutsDialogIntegrationAvailable: false
    },
    INTEGRATED: {
        isShortcutsDialogIntegrationAvailable: true
    }
};
const $4f25f7900866c0e5$var$IntegrateDotDialogContext = /*#__PURE__*/ (0, $5uXOq.createContext)($4f25f7900866c0e5$var$PRESET_VALUE.DEFAULT);
const $4f25f7900866c0e5$export$705d46354f301b1c = ()=>(0, $5uXOq.useContext)($4f25f7900866c0e5$var$IntegrateDotDialogContext);
const $4f25f7900866c0e5$export$97e3ca22c7078b46 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f25f7900866c0e5$var$IntegrateDotDialogContext.Provider, {
        value: $4f25f7900866c0e5$var$PRESET_VALUE.INTEGRATED
    }, children);

});

parcelRegister("3RNwj", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderErrorBoundryFallback", () => $8e5460bcff63ee1a$export$4c766016a5659721);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $92Z2l = parcelRequire("92Z2l");

var $koVbs = parcelRequire("koVbs");

var $iWDqa = parcelRequire("iWDqa");
const $8e5460bcff63ee1a$var$onRefresh = ()=>{
    if (typeof window !== 'undefined') window.location.reload();
};
const $8e5460bcff63ee1a$export$4c766016a5659721 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        testId: "jql-builder-common.ui.error-boundry-fallback.section-message"
    }, formatMessage((0, $iWDqa.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                spacing: "none",
                onClick: $8e5460bcff63ee1a$var$onRefresh
            }, linkText)
    }));
};

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && $a97355a0cc6aeb06$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $dg0Fl = parcelRequire("dg0Fl");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $d1d7dced94bb00f5$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$var$appearanceIconSchema[appearance] || $d1d7dced94bb00f5$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';



parcelRegister("iWDqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c45ebd3e2c96181c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c45ebd3e2c96181c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "jql-builder-common.error-boundry-fallback.error-message",
        "defaultMessage": "We couldn't load your search criteria. <link>Refresh the page</link> to try again."
    }
});

});


parcelRegister("8WcPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e61a910f85b3f4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $4p4kl = parcelRequire("4p4kl");

var $kxZPA = parcelRequire("kxZPA");

const $95e61a910f85b3f4$var$JQLBuilderWithAIAsync = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("6ApIi")), {
    moduleId: "./src/packages/jql-builder/with-ai/src/index.tsx"
});
const $95e61a910f85b3f4$var$JQLBuilderWithAI = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-jql-builder-with-ai",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4p4kl.IssueNavigatorJQLBuilderSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95e61a910f85b3f4$var$JQLBuilderWithAIAsync, props));
var $95e61a910f85b3f4$export$2e2bcd8739ae039 = $95e61a910f85b3f4$var$JQLBuilderWithAI;

});
parcelRegister("4p4kl", function(module, exports) {

$parcel$export(module.exports, "IssueNavigatorJQLBuilderSkeleton", () => $fb9c2cbb8213ab8c$export$5be82223ddc28851);
/* jql-builder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $ei1nS = parcelRequire("ei1nS");
const $fb9c2cbb8213ab8c$var$customCssStyles = null;
const $fb9c2cbb8213ab8c$var$containerStyles = {
    height: '52px'
};
const $fb9c2cbb8213ab8c$export$5be82223ddc28851 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ei1nS))),
        containerStyles: $fb9c2cbb8213ab8c$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("ei1nS", function(module, exports) {
module.exports = new URL("issue-navigator-jql-builder-skeleton.tpl.20beba3c.svg", import.meta.url).toString();

});


parcelRegister("6ApIi", function(module, exports) {

let $4cba0d07e6cb629b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4cba0d07e6cb629b$var$load("2fUpT").then(()=>parcelRequire('7F6VS'));

});


parcelRegister("elFwM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "SaveFilterDialog", () => $32d4bc710130ff58$export$935f6430ba933614);
$parcel$export(module.exports, "default", () => $32d4bc710130ff58$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $4R6GH = parcelRequire("4R6GH");

var $2KAtx = parcelRequire("2KAtx");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $c88gN = parcelRequire("c88gN");

var $cKjus = parcelRequire("cKjus");
const $32d4bc710130ff58$export$935f6430ba933614 = ({ buttonText: buttonText, filterId: filterId, ...props })=>{
    if (!(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const openModal = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'saveFilterDialog');
            setIsOpen(true);
        }, [
            setIsOpen
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const closeModal = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
            setIsOpen
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: openModal,
            appearance: "link",
            testId: "save-filter-dialog.ui.save-filter-dialog.button"
        }, buttonText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjus.AsyncSaveFilterDialogContent), {
            onClose: closeModal,
            filterId: filterId,
            ...props,
            isOpen: isOpen
        }));
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 'medium',
            shouldScrollInViewport: true
        }), []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            filterId: filterId,
            ...props
        }), [
        filterId,
        props
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cloudId = (0, $koeKL.useCloudId)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const activationId = (0, $fY39E.useActivationId)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            filterAri: filterId !== null && filterId !== undefined ? (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'filter',
                resourceId: filterId,
                activationId: activationId
            }) : undefined
        }), [
        filterId,
        cloudId,
        activationId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        modalProps: modalProps,
        entryPoint: (0, $c88gN.saveFilterDialogEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: (_, analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'saveFilterDialog'),
            appearance: "link",
            testId: "save-filter-dialog.ui.save-filter-dialog.button",
            interactionName: "save-filter-dialog",
            ref: ref
        }, buttonText));
};
var $32d4bc710130ff58$export$2e2bcd8739ae039 = $32d4bc710130ff58$export$935f6430ba933614;

});

parcelRegister("9z65D", function(module, exports) {

$parcel$export(module.exports, "AsyncSaveFilterDialog", () => $88c358d8076a9a73$export$2213da0eee0aa8f);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $88c358d8076a9a73$var$SaveFilterDialog = (0, $kxZPA.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("elFwM"))), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/main.tsx"
});
const $88c358d8076a9a73$export$2213da0eee0aa8f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "save-filters-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            isDisabled: true
        }, props.buttonText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88c358d8076a9a73$var$SaveFilterDialog, props));

});

parcelRegister("acgaZ", function(module, exports) {

$parcel$export(module.exports, "useJqlSearchStatus", () => $68036d2e3f2d9e10$export$6d36bd77a6aeafd9);

var $0qvdT = parcelRequire("0qvdT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $6MtPV = parcelRequire("6MtPV");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $4fmBV = parcelRequire("4fmBV");
const $68036d2e3f2d9e10$export$529d2e9d8e9d3cad = 2000; // wait 2s before making the request
const $68036d2e3f2d9e10$export$bbec15ef0a4926b6 = 7000; // wait 7s before retrying after the previous request
const $68036d2e3f2d9e10$export$cf31b3fd6a57249f = 5; // Check the status no more than 5 times for the same JQL search
const $68036d2e3f2d9e10$var$statusToMessages = (status, formatMessage)=>{
    if (status == null || !('functions' in status) || !Array.isArray(status?.functions)) return [];
    const processing = status.functions.filter((fn)=>fn.app && fn.function && fn.status === 'PROCESSING');
    const functions = Array.from(new Set(processing.map((fn)=>fn.function)));
    const apps = Array.from(new Set(processing.map((fn)=>fn.app)));
    switch(functions.length){
        case 0:
            return [];
        case 1:
            {
                const message = formatMessage((0, $4fmBV.default).singleSlowForgeFunction, {
                    functionName: functions[0],
                    appName: apps[0]
                });
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
        default:
            {
                let message;
                switch(apps.length){
                    case 1:
                        message = formatMessage((0, $4fmBV.default).multipleSlowForgeFunctionsFromTheSameApp, {
                            appName: apps[0]
                        });
                        break;
                    case 2:
                        message = formatMessage((0, $4fmBV.default).multipleSlowForgeFunctionsTwoApps, {
                            appName1: apps[0],
                            appName2: apps[1]
                        });
                        break;
                    default:
                        message = formatMessage((0, $4fmBV.default).multipleSlowForgeFunctionsThreeApps, {
                            appName1: apps[0],
                            appName2: apps[1],
                            appName3: apps[2]
                        });
                }
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
    }
};
const $68036d2e3f2d9e10$var$analyticsMeta = {
    id: 'jqlSearchStatus',
    packageName: 'jiraIssueNavigator',
    teamName: 'empanada'
};
const $68036d2e3f2d9e10$var$EMPTY_EXTERNAL_INFO = [];
const $68036d2e3f2d9e10$export$6d36bd77a6aeafd9 = ({ query: query, isSearching: isSearching })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [statusMessages, setStatusMessages] = (0, $5uXOq.useState)($68036d2e3f2d9e10$var$EMPTY_EXTERNAL_INFO);
    const isSearchingRef = (0, $5uXOq.useRef)(isSearching);
    const timeoutRef = (0, $5uXOq.useRef)(null);
    const fetchCountRef = (0, $5uXOq.useRef)(0);
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireOperationalEvent = (0, $5uXOq.useCallback)((action, attributes)=>(0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$68036d2e3f2d9e10$var$analyticsMeta.packageName}.${$68036d2e3f2d9e10$var$analyticsMeta.id} ${action}`, attributes), [
        createAnalyticsEvent
    ]);
    const cancelPendingOperations = (0, $5uXOq.useCallback)(()=>{
        timeoutRef.current && clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
        fetchCountRef.current = 0;
    }, []);
    const scheduleSearchStatusFetch = (0, $5uXOq.useCallback)((delay)=>{
        const isRetry = delay === $68036d2e3f2d9e10$export$bbec15ef0a4926b6;
        const defaultAnalyticsAttributes = (0, $6MtPV.createAttributes)({
            isRetry: isRetry
        });
        const timeout = setTimeout(()=>{
            if (fetchCountRef.current >= $68036d2e3f2d9e10$export$cf31b3fd6a57249f) {
                fireOperationalEvent('interrupted', {
                    ...defaultAnalyticsAttributes,
                    reason: 'MAX_ATTEMPTS_REACHED'
                });
                return;
            }
            fireOperationalEvent('attempt', defaultAnalyticsAttributes);
            fetchCountRef.current += 1;
            (0, $8Uumt.fetchQuery)(environment, (0, $0qvdT.default), {
                cloudId: cloudId,
                jql: query
            }, {
                fetchPolicy: 'network-only'
            }).toPromise().then((data)=>{
                let hasPendingFn = false;
                const status = data?.jira?.issueSearchStatus ?? null;
                if (isSearchingRef.current && timeoutRef.current === timeout) {
                    const infos = $68036d2e3f2d9e10$var$statusToMessages(status, formatMessage);
                    setStatusMessages(infos);
                    if (infos.length) {
                        hasPendingFn = true;
                        scheduleSearchStatusFetch($68036d2e3f2d9e10$export$bbec15ef0a4926b6);
                    }
                }
                fireOperationalEvent('finished', {
                    ...defaultAnalyticsAttributes,
                    hasPendingFn: hasPendingFn
                });
            }).catch((error)=>{
                (0, $jcw0u.default)({
                    meta: $68036d2e3f2d9e10$var$analyticsMeta,
                    attributes: (0, $6MtPV.createAttributes)({
                        error: error,
                        isRetry: isRetry
                    })
                });
                if (isSearchingRef.current && timeoutRef.current === timeout) scheduleSearchStatusFetch($68036d2e3f2d9e10$export$bbec15ef0a4926b6);
            });
        }, delay);
        timeoutRef.current = timeout;
    }, [
        cloudId,
        environment,
        fireOperationalEvent,
        formatMessage,
        query
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isSearchingRef.current = isSearching;
    }, [
        isSearching
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setStatusMessages($68036d2e3f2d9e10$var$EMPTY_EXTERNAL_INFO);
        cancelPendingOperations();
        if (isSearching) scheduleSearchStatusFetch($68036d2e3f2d9e10$export$529d2e9d8e9d3cad);
    }, [
        isSearching,
        query,
        cancelPendingOperations,
        scheduleSearchStatusFetch
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            messages: statusMessages
        }), [
        statusMessages
    ]);
};

});
parcelRegister("0qvdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $12b7df9e3f6f6313$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06f329a4787d481a42a4c55f0b801953>>
 * @relayHash 7d47bdaa4d5aeb847704c6e13c25fd58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8
const $12b7df9e3f6f6313$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "jql",
                            "variableName": "jql"
                        }
                    ],
                    "concreteType": "JiraIssueSearchStatus",
                    "kind": "LinkedField",
                    "name": "issueSearchStatus",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraJqlFunctionProcessingStatus",
                            "kind": "LinkedField",
                            "name": "functions",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "function"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "app"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8",
            "metadata": {},
            "name": "jqlSearchStatus_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$12b7df9e3f6f6313$var$node.hash = "9dd1bed08ceb0d25df132f36097ae6d1";
var $12b7df9e3f6f6313$export$2e2bcd8739ae039 = $12b7df9e3f6f6313$var$node;

});

parcelRegister("4fmBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $15682dd15c8b1e33$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $15682dd15c8b1e33$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    singleSlowForgeFunction: {
        "id": "issue-navigator.controllers.jql-search-status.single-slow-forge-function",
        "defaultMessage": "{appName} is still executing the {functionName} JQL function."
    },
    multipleSlowForgeFunctionsFromTheSameApp: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-from-the-same-app",
        "defaultMessage": "{appName} is still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsTwoApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-two-apps",
        "defaultMessage": "{appName1} and {appName2} are still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsThreeApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-three-apps",
        "defaultMessage": "{appName1}, {appName2}, and {appName3} are still executing multiple JQL functions."
    }
});

});


parcelRegister("anxcG", function(module, exports) {

$parcel$export(module.exports, "useJqlSearch", () => $34ef274676d00077$export$e69d0de2e354a2cb);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $gwtSG = parcelRequire("gwtSG");

var $isIOR = parcelRequire("isIOR");

var $38r5c = parcelRequire("38r5c");
const $34ef274676d00077$export$e69d0de2e354a2cb = (changeJql)=>{
    const query = (0, $gwtSG.useResolvedJql)();
    let onRefetch;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ onRefetch: onRefetch } = (0, $38r5c.useIssueSearchActions)());
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ onIssueSearch: onRefetch } = (0, $isIOR.useIssueSearchQuery)());
    const onSearch = (0, $5uXOq.useCallback)((jql)=>{
        if (jql === query) // This will execute a new search against the network with current JQL input arguments
        onRefetch();
        else changeJql && changeJql(jql);
    }, [
        query,
        onRefetch,
        changeJql
    ]);
    return {
        onSearch: onSearch,
        query: query
    };
};

});

parcelRegister("bNJuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f106025efda7e896$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f106025efda7e896$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    saveFilterButton: {
        "id": "issue-navigator.jql-builder.save-filter-button",
        "defaultMessage": "Save filter"
    },
    saveFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.save-filter-dialog-title",
        "defaultMessage": "Save filter"
    },
    copyFilterButton: {
        "id": "issue-navigator.jql-builder.copy-filter-button",
        "defaultMessage": "Copy filter"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});

});

parcelRegister("5aoL8", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $c1e8091431e2a9ec$export$d58b72b7d3c4072c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $3EOg8 = parcelRequire("3EOg8");
const $c1e8091431e2a9ec$var$IconContainer = ({ children: children })=>{
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd"
        ])
    }, children);
};
const $c1e8091431e2a9ec$var$MessageContainer = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150",
        xcss: $c1e8091431e2a9ec$var$stackStyles,
        alignInline: "center"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text"
    }, formatMessage((0, $3EOg8.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $3EOg8.default).noOptionsSecondaryMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c1e8091431e2a9ec$var$boxStyles
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyru2gc _18u0idpf _1i4qfg65"
        ])
    }, formatMessage((0, $3EOg8.default).fieldNotFoundMessage)));
};
const $c1e8091431e2a9ec$export$d58b72b7d3c4072c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1e8091431e2a9ec$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1e8091431e2a9ec$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon-subtle, #626F86)"
    })));
};
const $c1e8091431e2a9ec$var$boxStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    paddingBottom: 'space.100',
    color: 'color.text.subtle',
    textAlign: 'center'
});
const $c1e8091431e2a9ec$var$stackStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100'
});
const $c1e8091431e2a9ec$var$titleStyles = null;
const $c1e8091431e2a9ec$var$iconContainerStyles = null;

});
parcelRegister("3EOg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d1234d483fa7193$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d1234d483fa7193$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fieldNotFoundMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.field-not-found-message",
        "defaultMessage": "We couldn't find the field you are looking for."
    },
    noOptionsPrimaryMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});

});


parcelRegister("66jXs", function(module, exports) {

$parcel$export(module.exports, "ResetButton", () => $8f283f726de8b644$export$2491f201e3dd9acf);
$parcel$export(module.exports, "default", () => $8f283f726de8b644$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $7HGp6 = parcelRequire("7HGp6");
const $8f283f726de8b644$export$2491f201e3dd9acf = ({ onReset: onReset, isResetToFilter: isResetToFilter = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleOnReset = (0, $5uXOq.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, isResetToFilter ? 'goBackToFilterButton' : 'resetButton', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onReset && onReset(isResetToFilter);
    }, [
        onReset,
        isResetToFilter
    ]);
    const resetButtonText = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $7HGp6.default).clearFiltersButtonText : (0, $7HGp6.default).resetButtonText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f283f726de8b644$var$ResetButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "issue-navigator.ui.jql-builder.reset-button",
        appearance: "subtle-link",
        onClick: handleOnReset
    }, formatMessage(isResetToFilter ? (0, $7HGp6.default).goBackToFilterButtonText : resetButtonText)));
};
var $8f283f726de8b644$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $8f283f726de8b644$export$2491f201e3dd9acf;
const $8f283f726de8b644$var$ResetButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug _1e0c1txw _p12fuuw1 _4cvr1h6o _4t3izwfg _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7HGp6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b65ac11d69a3064$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0b65ac11d69a3064$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    clearFiltersButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.clear-filters-button-text",
        "defaultMessage": "Clear filters"
    },
    resetButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.reset-button-text",
        "defaultMessage": "Reset"
    },
    goBackToFilterButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.go-back-to-filter-button-text",
        "defaultMessage": "Go back to filter"
    }
});

});


parcelRegister("weR3I", function(module, exports) {

$parcel$export(module.exports, "useJqlBuilderInstrumentation", () => $83b99282af44666a$export$42691712ca1334f9);

var $5uXOq = parcelRequire("5uXOq");

var $a8lIB = parcelRequire("a8lIB");
const $83b99282af44666a$export$42691712ca1334f9 = ()=>{
    const [finished, setFinished] = (0, $5uXOq.useState)(false);
    return (0, $5uXOq.useMemo)(()=>({
            startJqlBuilderMetric: ()=>{
                if (finished) return;
                (0, $a8lIB.NINJqlBuilderAsyncLoad).start();
            },
            stopJqlBuilderMetric: ()=>{
                setFinished(true);
                (0, $a8lIB.NINJqlBuilderAsyncLoad).stop();
            },
            markJqlBuilderMetric: (mark)=>{
                if (finished) return;
                (0, $a8lIB.markOnce)(mark);
            }
        }), [
        finished
    ]);
};

});

parcelRegister("3iu8n", function(module, exports) {

$parcel$export(module.exports, "isOnlyJqlAndDifferentToDefault", () => $6170d953a5f8d41c$export$3cfc4f52186efe7d);
$parcel$export(module.exports, "isOnlyFilterAndDifferentToDefault", () => $6170d953a5f8d41c$export$933470cfeba275aa);
$parcel$export(module.exports, "filterAndJqlIsTheSameAndDifferentToDefault", () => $6170d953a5f8d41c$export$a25fc74cc3fc7015);
$parcel$export(module.exports, "jqlIsDifferentToFilter", () => $6170d953a5f8d41c$export$7dfcf59726e2b396);
$parcel$export(module.exports, "isFilterJqlModified", () => $6170d953a5f8d41c$export$d3d543997ba807);
const $6170d953a5f8d41c$export$3cfc4f52186efe7d = (jqlParam, defaultJqlTerm, filterParam)=>filterParam === undefined && jqlParam !== undefined && jqlParam.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $6170d953a5f8d41c$export$933470cfeba275aa = (jqlParam, defaultJqlTerm, filterJqlTerm)=>filterJqlTerm !== undefined && jqlParam === undefined && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $6170d953a5f8d41c$export$a25fc74cc3fc7015 = (jqlParam, defaultJqlTerm, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && jqlParam.toLowerCase() === filterJqlTerm.toLowerCase() && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $6170d953a5f8d41c$export$7dfcf59726e2b396 = (jqlParam, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && filterJqlTerm.toLowerCase() !== jqlParam.toLowerCase();
const $6170d953a5f8d41c$export$d3d543997ba807 = ({ query: query, filterJql: filterJql })=>filterJql !== undefined && query.toLowerCase().trim() !== filterJql.toLowerCase().trim();

});


parcelRegister("7Cqtr", function(module, exports) {

$parcel$export(module.exports, "default", () => $912451f7718e6cf5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $912451f7718e6cf5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    screenReaderGroupResultInfo: {
        "id": "issue-navigator.screen-reader-group-result-info",
        "defaultMessage": "Grouping has been applied to the list."
    },
    screenReaderSearchResultInfo: {
        "id": "issue-navigator.screen-reader-search-result-info",
        "defaultMessage": "{total, plural, one {One issue matches your search.} other {{total} issues match your search.}}"
    },
    screenReaderSearchResultMoreInfo: {
        "id": "issue-navigator.screen-reader-search-result-more-info",
        "defaultMessage": "{total, plural, one {{total} or more issues found} other {{total} or more issues found}}."
    },
    screenReaderSearchResultInfoIssueTermRefresh: {
        "id": "issue-navigator.screen-reader-search-result-info-issue-term-refresh",
        "defaultMessage": "{total, plural, one {One work item matches your search.} other {{total} work items match your search.}}"
    },
    screenReaderSearchResultMoreInfoIssueTermRefresh: {
        "id": "issue-navigator.screen-reader-search-result-more-info-issue-term-refresh",
        "defaultMessage": "{total, plural, one {{total} or more work items found} other {{total} or more work items found}}."
    }
});

});

parcelRegister("5RTlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f478b4b7c16dded$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $3Tty1 = parcelRequire("3Tty1");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $9f478b4b7c16dded$var$RegisterDotShortcut = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { open: open } = (0, $d8lE2.useActionsCommandPalette)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: {
            '.': {
                callback: ()=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'pressed',
                        actionSubject: 'keyboardShortcut'
                    }), 'dotDialogKeyboardShortcut', {
                        keyPressed: '.',
                        keyboardShortcut: true
                    });
                    open();
                }
            }
        }
    });
};
var $9f478b4b7c16dded$export$2e2bcd8739ae039 = $9f478b4b7c16dded$var$RegisterDotShortcut;

});

parcelRegister("6tXCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7541b9a37d8ce6a5$export$2e2bcd8739ae039);

var $gPAgh = parcelRequire("gPAgh");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5Czte = parcelRequire("5Czte");

var $atxn1 = parcelRequire("atxn1");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $ih9zY = parcelRequire("ih9zY");
const $7541b9a37d8ce6a5$var$IssueNavigatorSpotlight = ({ hasIssueResults: hasIssueResults, userPreferences: userPreferences, isAiEnabled: isAiEnabled })=>{
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const searchModeResponse = (0, $8Uumt.useFragment)((0, $gPAgh.default), userPreferences);
    const selectedSearchMode = (0, $atxn1.toSearchModeWithBasicModeFallback)(searchModeResponse?.jqlBuilderSearchMode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Czte.NinChangeboardingTourCard), {
        mode: selectedSearchMode,
        view: (0, $eJ0Zs.convertToView)(view),
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
var $7541b9a37d8ce6a5$export$2e2bcd8739ae039 = $7541b9a37d8ce6a5$var$IssueNavigatorSpotlight;

});
parcelRegister("gPAgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $74e7fcdf8e98c48e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30a8994404dfcae5d894d268d148ffe9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $74e7fcdf8e98c48e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "spotlight_issueNavigator_IssueNavigatorSpotlight",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$74e7fcdf8e98c48e$var$node.hash = "3c8e72948beb901cccd7a6650610b18e";
var $74e7fcdf8e98c48e$export$2e2bcd8739ae039 = $74e7fcdf8e98c48e$var$node;

});


parcelRegister("dqObP", function(module, exports) {

$parcel$export(module.exports, "default", () => $072aa667050b5f51$export$2e2bcd8739ae039);

var $12cBT = parcelRequire("12cBT");

var $7ITL8 = parcelRequire("7ITL8");

var $d0LIH = parcelRequire("d0LIH");

var $iCUpo = parcelRequire("iCUpo");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $gcl1l = parcelRequire("gcl1l");

var $1asmd = parcelRequire("1asmd");

var $hP2me = parcelRequire("hP2me");

var $3HwlS = parcelRequire("3HwlS");

var $48rMm = parcelRequire("48rMm");

var $6s1PB = parcelRequire("6s1PB");

var $imS60 = parcelRequire("imS60");

var $1TiUe = parcelRequire("1TiUe");

var $4R6GH = parcelRequire("4R6GH");

var $iofGi = parcelRequire("iofGi");

var $6UAdF = parcelRequire("6UAdF");

var $jjbNu = parcelRequire("jjbNu");

var $1igGa = parcelRequire("1igGa");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");

var $cKK2E = parcelRequire("cKK2E");

var $38r5c = parcelRequire("38r5c");
const $072aa667050b5f51$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $072aa667050b5f51$var$styles = {
    jqlWrapper: "_5ynfkb7n"
};
const $072aa667050b5f51$var$TopBar = ({ ActionMenu: ActionMenu, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage, jqlBuilder: jqlBuilder, viewResult: viewResult, jiraViewResult: jiraViewResult, isGroupingSupported: isGroupingSupported })=>{
    const issueResultsData = (0, $8Uumt.useFragment)((0, $iCUpo.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $072aa667050b5f51$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $5uXOq.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const jql = (0, $gwtSG.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cKK2E.useFilterQuery)();
    const filterData = (0, $8Uumt.useFragment)((0, $d0LIH.default), filter);
    const viewResultData = (0, $8Uumt.useFragment)((0, $7ITL8.default), viewResult);
    const jiraViewData = (0, $8Uumt.useFragment)((0, $12cBT.default), jiraViewResult);
    const filterDetails = (0, $5uXOq.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    let jiraViewResultData = null;
    if ((0, $1TiUe.isRefactorNinToViewSchemaEnabled)()) jiraViewResultData = jiraViewData && (0, $6UAdF.isJiraSpreadsheetView)(jiraViewData) ? jiraViewData : null;
    else jiraViewResultData = viewResultData;
    let onChangeHierarchy = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    let onChangeGroupedByField = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    let onChangeHideDone = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ onChangeHierarchy: onChangeHierarchy, onChangeGroupedByField: onChangeGroupedByField, onChangeHideDone: onChangeHideDone } = (0, $38r5c.useIssueSearchActions)());
    const HierarchyToggle = jiraViewResultData && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjbNu.HierarchyToggleItem), {
        isGroupingSupported: isGroupingSupported,
        viewResult: jiraViewResultData,
        onChangeHierarchy: onChangeHierarchy
    }) : null;
    const GroupByDropdown = isGroupingSupported && jiraViewData && (0, $6UAdF.isJiraSpreadsheetView)(jiraViewData) && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hP2me.GroupByDropdown), {
        onChangeGroupedByField: onChangeGroupedByField,
        spreadsheetView: jiraViewData
    }) : null;
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderSkeletonImage, null);
    let onResetSelectedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if ((0, $4R6GH.fg)('jsc_list_hide_done_items')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reset: onResetSelectedIssues } = (0, $48rMm.useIssueTableSelectedIssuesActions)());
    const HideDoneToggle = jiraViewResultData && (0, $4R6GH.fg)('jsc_list_hide_done_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iofGi.HideDoneItemsToggle), {
        viewResult: jiraViewResultData,
        onChangeHideDone: onChangeHideDone,
        onResetSelectedIssues: onResetSelectedIssues
    }) : null;
    const pageTopBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1asmd.PageTopBar), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ActionMenu, {
            jql: jql,
            filterId: filterId,
            filterDetails: filterDetails,
            searchResultPageData: searchResultPageData,
            HierarchyToggle: HierarchyToggle,
            GroupByDropdown: GroupByDropdown,
            HideDoneToggle: HideDoneToggle
        }),
        bottomBar: jqlBuilder
    });
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "top-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $072aa667050b5f51$var$styles.jqlWrapper
        ])
    }, pageTopBar));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "top-bar"
    }, pageTopBar);
};
var $072aa667050b5f51$export$2e2bcd8739ae039 = (0, $1igGa.withReportErrors)($072aa667050b5f51$var$TopBar, {
    id: 'ui.topbar.unhandled',
    packageName: (0, $6UAdF.PACKAGE_NAME),
    teamName: (0, $6UAdF.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $gcl1l.isLoaderErrorAttributes)
});

});
parcelRegister("12cBT", function(module, exports) {

$parcel$export(module.exports, "default", () => $24510a11b4a5f3a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00786fd07d799d59d54a6fe98c42ac89>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $24510a11b4a5f3a6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_jiraViewResult",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueTableGroupByDropdown_GroupByDropdown"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$24510a11b4a5f3a6$var$node.hash = "a15fc2f8358d2528f544588b8d27263d";
var $24510a11b4a5f3a6$export$2e2bcd8739ae039 = $24510a11b4a5f3a6$var$node;

});

parcelRegister("7ITL8", function(module, exports) {

$parcel$export(module.exports, "default", () => $be8c2e42f32f9d34$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<096bf82bd355a50c4e3c69b25160edf4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $be8c2e42f32f9d34$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_viewResult",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
        },
        {
            "kind": "FragmentSpread",
            "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$be8c2e42f32f9d34$var$node.hash = "cb1ec8eae133c845db482d8342db857f";
var $be8c2e42f32f9d34$export$2e2bcd8739ae039 = $be8c2e42f32f9d34$var$node;

});

parcelRegister("d0LIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d39de334e93931$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ab7c2a8b5f9d7e53e2eda0626fb3cbe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45d39de334e93931$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$45d39de334e93931$var$node.hash = "d1fd34a229f9cb2668ab6793af284885";
var $45d39de334e93931$export$2e2bcd8739ae039 = $45d39de334e93931$var$node;

});

parcelRegister("iCUpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a632fb92c01e9f2e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<222e07e55baf5ff3dcc37bb6cbd7a80e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a632fb92c01e9f2e$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "topBar_issueNavigator_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$a632fb92c01e9f2e$var$node.hash = "52b4c743e436bc90ea0831559f2c3e48";
var $a632fb92c01e9f2e$export$2e2bcd8739ae039 = $a632fb92c01e9f2e$var$node;

});

parcelRegister("1asmd", function(module, exports) {

$parcel$export(module.exports, "PageTopBar", () => $a509d50a7a06aca2$export$7e5801dc91bf1819);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");

var $cS37j = parcelRequire("cS37j");

var $3HwlS = parcelRequire("3HwlS");

var $dCm1o = parcelRequire("dCm1o");

const $a509d50a7a06aca2$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: (0, $2fd65ab7d0fa0d2a$export$90c4434a1e138106),
        xcss: [
            !(0, $dCm1o.isVisualRefreshEnabled)() && $a509d50a7a06aca2$var$wrapperStylesOld2,
            (0, $dCm1o.isVisualRefreshEnabled)() && $a509d50a7a06aca2$var$wrapperStyles,
            wrapAtMd ? $a509d50a7a06aca2$var$wrapAtMdStyle : $a509d50a7a06aca2$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: (0, $2fd65ab7d0fa0d2a$export$1742330ac6a668f0),
        xcss: [
            $a509d50a7a06aca2$var$actionsBoxStyles,
            wrapAtMd && $a509d50a7a06aca2$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $a509d50a7a06aca2$export$7e5801dc91bf1819 = (props)=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a509d50a7a06aca2$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), props);
const $a509d50a7a06aca2$var$noWrapStyle = (0, $8CUq3.xcss)({
    flexWrap: 'nowrap'
});
const $a509d50a7a06aca2$var$wrapAtMdStyle = (0, $8CUq3.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $h9kUS.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $a509d50a7a06aca2$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    paddingTop: 'space.250',
    paddingBottom: 'space.200',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $h9kUS.media).above.md]: {
        gap: 'space.300'
    }
});
const $a509d50a7a06aca2$var$wrapperStylesOld2 = (0, $8CUq3.xcss)({
    display: 'flex',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $h9kUS.media).above.md]: {
        gap: 'space.300'
    }
});
const $a509d50a7a06aca2$var$actionsBoxAtMdStyles = (0, $8CUq3.xcss)({
    flex: '1 1 auto',
    [(0, $h9kUS.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $a509d50a7a06aca2$var$actionsBoxStyles = (0, $8CUq3.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $57MwZ = parcelRequire("57MwZ");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57MwZ.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("57MwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9694e728fd1ea060$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eeGIy = parcelRequire("eeGIy");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;

});
parcelRegister("eeGIy", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $0c196d37a4e8266c$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $0c196d37a4e8266c$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $0c196d37a4e8266c$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $0c196d37a4e8266c$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $0c196d37a4e8266c$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $0c196d37a4e8266c$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $0c196d37a4e8266c$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $0c196d37a4e8266c$var$truncateStyles = null;
const $0c196d37a4e8266c$var$outerStyles = null;
const $0c196d37a4e8266c$var$titleStyles = null;
const $0c196d37a4e8266c$var$titleWrapperStyles = null;
const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = null;
const $0c196d37a4e8266c$var$titleContainerStyles = null;
const $0c196d37a4e8266c$var$actionStyles = null;
const $0c196d37a4e8266c$var$titleContainerTruncateStyles = null;
const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m _1n261g80",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $0c196d37a4e8266c$var$styles.bottomBar,
        children: children
    });
};

});



const $2fd65ab7d0fa0d2a$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $2fd65ab7d0fa0d2a$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';



parcelRegister("cWY4u", function(module, exports) {

$parcel$export(module.exports, "SidebarCloserController", () => $7429dc5179f79a1f$export$700866716e53c09d);

var $ih9zY = parcelRequire("ih9zY");

var $f98ZZ = parcelRequire("f98ZZ");

var $1XJ20 = parcelRequire("1XJ20");
const $7429dc5179f79a1f$export$700866716e53c09d = ()=>{
    const [{ id: id }, { closeSidebar: closeSidebar }] = (0, $f98ZZ.useSidebar)();
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const prevView = (0, $1XJ20.usePrevious)(view);
    if (id !== null && view === 'detail' && prevView !== 'detail') closeSidebar();
    return null;
};

});

parcelRegister("887Eo", function(module, exports) {

$parcel$export(module.exports, "SidebarExperienceRegistryWithErrorBoundary", () => $d16820970d8c3915$export$2ca0ed61c620e2d7);

var $5uXOq = parcelRequire("5uXOq");

var $f98ZZ = parcelRequire("f98ZZ");

var $6gWfU = parcelRequire("6gWfU");

var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $gwtSG = parcelRequire("gwtSG");

var $gcgVs = parcelRequire("gcgVs");

var $4WYaK = parcelRequire("4WYaK");
const $d16820970d8c3915$export$50cee155b5f4b008 = ()=>{
    const [{ id: id, content: content }, { closeSidebar: closeSidebar }] = (0, $f98ZZ.useSidebar)();
    const jql = (0, $gwtSG.useResolvedJql)();
    if (content) return content;
    if (id === (0, $6gWfU.SIDEBAR_EXPERIENCE_NAME) && (0, $6s1PB.expVal)('helios_list_view_statistics_nin_migration', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcgVs.IssueFieldStatisticsSidebarExperience), {
        jql: jql,
        onClose: closeSidebar
    });
    return null;
};
const $d16820970d8c3915$export$2ca0ed61c620e2d7 = ()=>{
    const { closeSidebar: closeSidebar } = (0, $f98ZZ.useSidebarActions)();
    const fallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4WYaK.ErrorState), {
            onClose: closeSidebar
        }), [
        closeSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "sidebarExperienceRegistry",
        packageName: "jiraIssueNavigator",
        teamName: "empanada",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d16820970d8c3915$export$50cee155b5f4b008, null));
};

});
parcelRegister("gcgVs", function(module, exports) {

$parcel$export(module.exports, "IssueFieldStatisticsSidebarExperience", () => $2bb3e7cbb51113a5$export$63b30538475bf529);

var $5uXOq = parcelRequire("5uXOq");

var $SpDot = parcelRequire("SpDot");

var $7XluA = parcelRequire("7XluA");

var $4WYaK = parcelRequire("4WYaK");
const $2bb3e7cbb51113a5$var$HELIOS_TEAM_NAME = 'helios-reports';
const $2bb3e7cbb51113a5$export$63b30538475bf529 = ({ jql: jql, onClose: onClose })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $SpDot.useIssueFieldStatisticsEntryPoint)();
    const issueFieldStatisticsRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            jql: jql,
            onClose: onClose
        }), [
        jql,
        onClose
    ]);
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4WYaK.ErrorState), {
            onClose: onClose
        }), [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "issueFieldStatisticsSidebar",
        packageName: "jiraIssueNavigatorActionIssueFieldStatistics",
        errorFallback: errorFallback,
        teamName: $2bb3e7cbb51113a5$var$HELIOS_TEAM_NAME,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: issueFieldStatisticsRuntimeProps
    });
};

});
parcelRegister("4WYaK", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $fbefa06fe4c91318$export$c1ed4f415b9e7023);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $42CjB = parcelRequire("42CjB");

var $84THj = parcelRequire("84THj");

var $koVbs = parcelRequire("koVbs");

var $a2fxE = parcelRequire("a2fxE");

var $hi7kV = parcelRequire("hi7kV");
const $fbefa06fe4c91318$export$c1ed4f415b9e7023 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        alignItems: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        alignItems: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($84THj))),
        label: formatMessage((0, $hi7kV.default).close),
        isTooltipDisabled: false,
        onClick: ()=>{
            onClose();
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        alignItems: "center",
        xcss: $fbefa06fe4c91318$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a2fxE.default), {
        alt: formatMessage((0, $hi7kV.default).warning)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, formatMessage((0, $hi7kV.default).errorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        align: "center"
    }, formatMessage((0, $hi7kV.default).errorBody))));
};
const $fbefa06fe4c91318$var$contentStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.800',
    gap: 'space.100'
});

});
parcelRegister("a2fxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b458312a82455ed$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $N9uAB = parcelRequire("N9uAB");

var $jrNAP = parcelRequire("jrNAP");
const $5b458312a82455ed$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($N9uAB)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jrNAP))
});
var $5b458312a82455ed$export$2e2bcd8739ae039 = $5b458312a82455ed$var$Illustration;
const $5b458312a82455ed$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("N9uAB", function(module, exports) {
module.exports = new URL("error-triangle-basic.6c1bbfdc.svg", import.meta.url).toString();

});

parcelRegister("jrNAP", function(module, exports) {
module.exports = new URL("error-triangle-basic-darkmode.aa5ef22c.svg", import.meta.url).toString();

});


parcelRegister("hi7kV", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d4cac6e48b6b74$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $63d4cac6e48b6b74$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    warning: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.warning-icon-label",
        "defaultMessage": "Warning"
    },
    close: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.close",
        "defaultMessage": "Close"
    },
    errorTitle: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.error-body",
        "defaultMessage": "Try refreshing the page, or check your connection."
    }
});

});





parcelRegister("9BgIv", function(module, exports) {

$parcel$export(module.exports, "SelectedIssue", () => $29e7a5baa3c338c1$export$39b2b4a30505b395);

var $1qDhJ = parcelRequire("1qDhJ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6s1PB = parcelRequire("6s1PB");

var $g5X3G = parcelRequire("g5X3G");

var $4R6GH = parcelRequire("4R6GH");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $hnJJ3 = parcelRequire("hnJJ3");

var $ih9zY = parcelRequire("ih9zY");

var $38r5c = parcelRequire("38r5c");

var $gM6H8 = parcelRequire("gM6H8");
const $29e7a5baa3c338c1$export$39b2b4a30505b395 = ({ children: children, issues: issues, selectedIssueKey: selectedIssueKey, onChange: onChange })=>{
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const searchKey = (0, $38r5c.useSearchKey)();
    const issueData = (0, $8Uumt.useFragment)((0, $1qDhJ.default), issues);
    let issuesFlatList;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    issuesFlatList = (0, $gM6H8.useFlatListIssues)();
    const issueKeys = (0, $5uXOq.useMemo)(()=>// eslint-disable-next-line jira/ff/no-preconditioning
        (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') && view !== 'detail' && issuesFlatList ? issuesFlatList : issueData?.edges?.map((edge)=>(0, $g5X3G.toIssueKey)(edge?.node?.key ?? '')) ?? [], [
        issuesFlatList,
        issueData?.edges,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnJJ3.SelectedIssueContainer), {
        view: (0, $eJ0Zs.convertToView)(view),
        issueKeys: issueKeys,
        searchKey: searchKey,
        selectedIssueKey: selectedIssueKey,
        onChange: onChange
    }, children);
};

});
parcelRegister("1qDhJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $41bc6b895343393b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<861c6a2b5276ec2a8b6ba119835e232f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $41bc6b895343393b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedIssue_issueNavigator",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$41bc6b895343393b$var$node.hash = "966aa39a272d43746556adcb1b54c0d8";
var $41bc6b895343393b$export$2e2bcd8739ae039 = $41bc6b895343393b$var$node;

});


parcelRegister("k4pU6", function(module, exports) {

$parcel$export(module.exports, "SelectedViewContainer", () => $f88dfd427b272bd1$export$6e497a97feb37da2);

var $lBgt7 = parcelRequire("lBgt7");

var $8MDuC = parcelRequire("8MDuC");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6s1PB = parcelRequire("6s1PB");

var $1TiUe = parcelRequire("1TiUe");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $ih9zY = parcelRequire("ih9zY");

var $isIOR = parcelRequire("isIOR");

var $38r5c = parcelRequire("38r5c");
const $f88dfd427b272bd1$export$6e497a97feb37da2 = ({ children: children, issueSearchView: issueSearchView, jiraView: jiraView, onSetView: onSetView })=>{
    let onIssueSearchForView;
    if ((0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ onChangeView: onIssueSearchForView } = (0, $38r5c.useIssueSearchActions)());
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ onIssueSearchForView: onIssueSearchForView } = (0, $isIOR.useIssueSearchQuery)());
    const issueSearchViewData = (0, $8Uumt.useFragment)((0, $8MDuC.default), issueSearchView);
    const jiraViewData = (0, $8Uumt.useFragment)((0, $lBgt7.default), jiraView);
    const viewId = (0, $eJ0Zs.parseIssueNavigatorViewIdOrDefault)((0, $1TiUe.isRefactorNinToViewSchemaEnabled)() ? jiraViewData?.viewId : issueSearchViewData?.viewId, (0, $6UAdF.DEFAULT_VIEW_ID));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ih9zY.Container), {
        view: viewId,
        onSetView: onSetView,
        onIssueSearchForView: onIssueSearchForView
    }, children);
};

});
parcelRegister("lBgt7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d58dd3056534460e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9e6e0435e948129fcdb5920c201bd9c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d58dd3056534460e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedView_issueNavigator_SelectedViewContainer_jiraView",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "viewId"
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$d58dd3056534460e$var$node.hash = "cf266a14f94b711c625c539ed89becfa";
var $d58dd3056534460e$export$2e2bcd8739ae039 = $d58dd3056534460e$var$node;

});

parcelRegister("8MDuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71ae36b0230a63e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a4404a464a5c9c95e0bf1d382233789e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a71ae36b0230a63e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedView_issueNavigator_SelectedViewContainer_issueSearchView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "viewId"
        }
    ],
    "type": "JiraIssueSearchView"
};
$a71ae36b0230a63e$var$node.hash = "6373906f98b0da7dd8bd2aaf1f2c68ca";
var $a71ae36b0230a63e$export$2e2bcd8739ae039 = $a71ae36b0230a63e$var$node;

});



parcelRegister("lNtuJ", function(module, exports) {

$parcel$export(module.exports, "GlobalIssueNavigatorHeaderSkeleton", () => $a7cd888c50f3d6dc$export$51e99114949d3e8f);
/* global-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $hh0MT = parcelRequire("hh0MT");
const $a7cd888c50f3d6dc$var$customCssStyles = null;
const $a7cd888c50f3d6dc$var$containerStyles = {
    height: '80px'
};
const $a7cd888c50f3d6dc$export$51e99114949d3e8f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hh0MT))),
        containerStyles: $a7cd888c50f3d6dc$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("hh0MT", function(module, exports) {
module.exports = new URL("global-issue-navigator-header-skeleton.tpl.f1ae7ec6.svg", import.meta.url).toString();

});


parcelRegister("kfUal", function(module, exports) {

$parcel$export(module.exports, "default", () => $0774879bc5ee0439$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $cS37j = parcelRequire("cS37j");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $9Nvh7 = parcelRequire("9Nvh7");

var $jCD74 = parcelRequire("jCD74");

var $cgTfp = parcelRequire("cgTfp");

var $2jaAN = parcelRequire("2jaAN");

var $cZpsT = parcelRequire("cZpsT");

var $gs7uP = parcelRequire("gs7uP");

var $9Bfjr = parcelRequire("9Bfjr");
const $0774879bc5ee0439$export$49640514ca453805 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0774879bc5ee0439$export$acedcd153f648084, {
        ref: ref,
        ...props
    }));
const $0774879bc5ee0439$export$8b251419efc915eb = ({ jql: jql, filterId: filterId, filterDetails: filterDetails, searchResultPageData: searchResultPageData })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const titleMessage = filterId !== undefined && filterDetails ? formatMessage((0, $gs7uP.default).filterWindowTitle, {
        filterName: filterDetails.name
    }) : formatMessage((0, $gs7uP.default).windowTitle);
    const heading = formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gs7uP.default).headingIssueTermRefresh : (0, $gs7uP.default).heading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Bfjr.default), {
            jql: jql,
            filterId: filterId,
            isModifiedFilter: filterDetails?.jql !== jql,
            searchResultPageData: searchResultPageData,
            filterName: filterDetails?.name
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: titleMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0774879bc5ee0439$export$6d0d24718f298af7, null, filterId !== undefined && filterDetails ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: filterDetails.name,
        tag: $0774879bc5ee0439$export$49640514ca453805,
        position: "mouse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0774879bc5ee0439$export$d337e02ad938bc27, null, filterDetails.name)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jaAN.FavoriteButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jaAN.FavoriteButton), {
        filterId: filterDetails.filterId,
        isFavoriteInitial: filterDetails.isFavourite,
        favoriteItemName: filterDetails.name
    })), (0, $9Nvh7.isCustomFilter)(filterDetails.filterId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgTfp.DetailsButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jCD74.DetailsPopup), {
        filterId: filterId
    }))) : heading));
};
var $0774879bc5ee0439$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $0774879bc5ee0439$export$8b251419efc915eb;
const $0774879bc5ee0439$export$acedcd153f648084 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0774879bc5ee0439$export$d337e02ad938bc27 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0774879bc5ee0439$export$6d0d24718f298af7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _1e0c116y _4cvr1y6m _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("jCD74", function(module, exports) {

$parcel$export(module.exports, "DetailsPopup", () => $ad1b1ac535cd8166$export$b61797ace80c3d8);

var $5uXOq = parcelRequire("5uXOq");

var $bWn3s = parcelRequire("bWn3s");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");

var $6KXPO = parcelRequire("6KXPO");

var $4R6GH = parcelRequire("4R6GH");

var $lu5k0 = parcelRequire("lu5k0");

var $i4HKU = parcelRequire("i4HKU");

var $9DNHu = parcelRequire("9DNHu");

const $ad1b1ac535cd8166$export$b61797ace80c3d8 = ({ filterId: filterId, defaultOpen: defaultOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const triggerRef = (0, $5uXOq.useRef)(null);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultOpen);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const titleId = 'issue-navigator-custom-filters.ui.details-popup.popup.title';
    const onTriggerClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        setIsOpen(!isOpen);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'filterDetailsButton');
    }, [
        isOpen,
        setIsOpen
    ]);
    const [isEditFilterModalOpen, setIsEditFilterModalOpen] = (0, $5uXOq.useState)(false);
    const onOpenEditFilterModal = (0, $5uXOq.useCallback)(()=>{
        setIsEditFilterModalOpen(true);
        onClose();
    }, [
        onClose
    ]);
    const onCloseEditFilterModal = (0, $5uXOq.useCallback)(()=>{
        setIsEditFilterModalOpen(false);
        (0, $4R6GH.fg)('jfp_a11y_issue_navigator_detail_keyboard_focus') && setReturnFocusTo(triggerRef);
    }, [
        setReturnFocusTo
    ]);
    const Content = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9DNHu.PopupContent), {
            ...props,
            ...(0, $4R6GH.fg)('jfp-a11y-team_return-focus-to-filter-details') && {
                triggerRef: triggerRef
            },
            onOpenEditFilterModal: onOpenEditFilterModal,
            onOpenNewSubscriptionModal: onClose,
            filterId: filterId,
            titleId: titleId
        }), [
        filterId,
        onClose,
        onOpenEditFilterModal
    ]);
    const Trigger = (0, $5uXOq.useCallback)((props)=>{
        const ref = (0, $bWn3s.mergeRefs)([
            props.ref,
            triggerRef
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...props,
            appearance: "link",
            onClick: onTriggerClick,
            isSelected: isOpen,
            onMouseOver: (0, $9DNHu.preloadPopupContentComponent),
            testId: "issue-navigator-custom-filters.ui.details-popup.button",
            ...(0, $4R6GH.fg)('jfp_a11y_issue_navigator_detail_keyboard_focus') ? {
                ref: ref
            } : {}
        }, formatMessage((0, $i4HKU.default).filterDetails));
    }, [
        isOpen,
        onTriggerClick,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6KXPO.AsyncUpdateFilterDialog), {
        filterId: filterId,
        onClose: onCloseEditFilterModal,
        isOpen: isEditFilterModalOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        shouldRenderToParent: (0, $4R6GH.fg)('jfp_a11y_team_fix_filter_details_reading_order'),
        placement: "bottom-start",
        messageId: "issue-navigator-custom-filters.ui.details-popup.popup",
        messageType: "transactional",
        content: Content,
        trigger: Trigger,
        testId: "issue-navigator-custom-filters.ui.details-popup.popup",
        role: "dialog",
        titleId: titleId
    }));
};

});
parcelRegister("i4HKU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a4107a8a3141584$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4a4107a8a3141584$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterDetails: {
        "id": "issue-navigator-custom-filters.details-popup.filter-details",
        "defaultMessage": "Filter details"
    }
});

});

parcelRegister("9DNHu", function(module, exports) {

$parcel$export(module.exports, "preloadPopupContentComponent", () => $166058a1fd3e08e7$export$c115357d632001d1);
$parcel$export(module.exports, "PopupContent", () => $166058a1fd3e08e7$export$2a2c7ba12d3231e3);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $dnjeJ = parcelRequire("dnjeJ");

var $eyQMS = parcelRequire("eyQMS");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $166058a1fd3e08e7$export$1c4b66177193d06d = (0, $kxZPA.lazy)(()=>(parcelRequire("8F29B")), {
    moduleId: "./src/packages/issue-navigator/custom-filters/src/ui/details-popup/popup-content/index.tsx"
});
const $166058a1fd3e08e7$export$c115357d632001d1 = ()=>$166058a1fd3e08e7$export$1c4b66177193d06d.preload();
const $166058a1fd3e08e7$var$LoadingFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($166058a1fd3e08e7$var$LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null));
const $166058a1fd3e08e7$export$2a2c7ba12d3231e3 = (props)=>{
    (0, $dnjeJ.useUFOComponentExperience)((0, $eyQMS.viewDetailsPopupExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "popup-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($166058a1fd3e08e7$var$LoadingFallback, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($166058a1fd3e08e7$export$1c4b66177193d06d, props));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $166058a1fd3e08e7$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _1bsb1vif _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _c71lqdd9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $166058a1fd3e08e7$var$LoadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $166058a1fd3e08e7$var$ContentWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dnjeJ", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $44448c24118cb590$export$30ab340faaed55d4);

var $5uXOq = parcelRequire("5uXOq");
const $44448c24118cb590$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $44448c24118cb590$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("eyQMS", function(module, exports) {

$parcel$export(module.exports, "viewDetailsPopupExperience", () => $0dbbce9899ca1284$export$54c37dd263cb6171);
$parcel$export(module.exports, "viewNewSubscriptionModal", () => $0dbbce9899ca1284$export$1584a1158c503c0a);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $0dbbce9899ca1284$export$54c37dd263cb6171 = new (0, $duUGa.UFOExperience)('jira-issue-navigator.custom-filters.view-details-popup', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $0dbbce9899ca1284$export$1584a1158c503c0a = new (0, $duUGa.UFOExperience)('jira-issue-navigator.custom-filters.details-popup.view-new-subscription-modal', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("8F29B", function(module, exports) {

let $64e3d2cc14975350$var$load = (parcelRequire("28QjX"))(4);
module.exports = $64e3d2cc14975350$var$load("ic5fz").then(()=>parcelRequire('6ibCj'));

});



parcelRegister("cgTfp", function(module, exports) {

$parcel$export(module.exports, "DetailsButtonHeaderWrapper", () => $f2f63e79032646e3$export$1eb74eb504903ed6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $f2f63e79032646e3$export$1eb74eb504903ed6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _19pkv77o _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2jaAN", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $dc82f725480f4be1$export$8d5dab2ad1e19ea0);
$parcel$export(module.exports, "FavoriteButtonHeaderWrapper", () => $dc82f725480f4be1$export$5ca4047aa6ecffac);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hLZZY = parcelRequire("hLZZY");

var $eXQym = parcelRequire("eXQym");
const $dc82f725480f4be1$export$8d5dab2ad1e19ea0 = ({ filterId: filterId, isFavoriteInitial: isFavoriteInitial, favoriteItemName: favoriteItemName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hLZZY.default), {
        key: filterId,
        baseUrl: "",
        itemType: (0, $eXQym.FILTERS_ITEM_TYPE),
        itemId: filterId,
        isFavoriteInitial: isFavoriteInitial,
        favoriteItemName: favoriteItemName,
        isShownInList: true
    });
const $dc82f725480f4be1$export$5ca4047aa6ecffac = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _4t3izwfg _19pkze3t _2hwx1b66 _otyrze3t _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hLZZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a968ac170a325ff4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4041n = parcelRequire("4041n");


var $fH2dG = parcelRequire("fH2dG");
class $a968ac170a325ff4$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4041n.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fH2dG.FavoriteButton), {
                ...this.props,
                favoriteChangeContext: favoriteChangeContext
            }));
    }
}

});
parcelRegister("fH2dG", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $e0f2aac973023e83$export$8d5dab2ad1e19ea0);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $hcObS = parcelRequire("hcObS");

var $eXQym = parcelRequire("eXQym");

var $1WPu2 = parcelRequire("1WPu2");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $e0f2aac973023e83$var$isProduction = window.BUILD_KEY !== 'JF-TEST';
class $e0f2aac973023e83$export$8d5dab2ad1e19ea0 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isFavoriteInitial: undefined,
            favoriteItemName: undefined,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props), this.onClick = (analyticsEvent)=>{
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType, onClick: onClick } = this.props;
            const { changeFavorite: changeFavorite } = favoriteChangeContext;
            if (changeFavorite) changeFavorite({
                id: itemId,
                type: itemType,
                value: !this.getIsFavorite()
            }, analyticsEvent);
            if (typeof onClick === 'function') onClick();
        };
        this.state = {
            isFavorite: props.isFavoriteInitial
        };
    }
    componentDidMount() {
        const { baseUrl: baseUrl, itemId: itemId, itemType: itemType } = this.props;
        if (typeof baseUrl === 'undefined' || typeof itemId === 'undefined' || typeof itemType === 'undefined') return;
        // Adding an Error here for the next dev to implement this button.
        // This error won't show in prod, but will show when running a fragment.
        if (!$e0f2aac973023e83$var$isProduction && !(0, $eXQym.VALID_ITEM_TYPES).includes(itemType)) throw new Error(`FavoriteButton: Invalid value for prop 'type'.\n You passed: "${itemType}"\n It must be one of [${JSON.stringify((0, $eXQym.VALID_ITEM_TYPES))}]\n\n`);
        if (typeof this.props.isFavoriteInitial !== 'undefined') // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.props.favoriteChangeContext.items[itemType][itemId] = {
            id: itemId,
            type: itemType,
            value: this.props.isFavoriteInitial,
            pending: false
        };
        if (this.getIsFavorite() === undefined) (0, $1WPu2.getFavorite)(baseUrl, {
            id: itemId,
            type: itemType
        }).then((isFavorite)=>{
            this.setState({
                isFavorite: isFavorite
            });
        });
    }
    getIsFavorite() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.value : this.state.isFavorite;
    }
    getIsPending() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.pending : false;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "favourite-button.favorite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
            isFavorite: this.getIsFavorite(),
            favoriteItemName: this.props.favoriteItemName,
            pending: this.getIsPending(),
            hideTooltip: this.props.hideTooltip,
            tooltipPosition: this.props.tooltipPosition,
            onClick: this.onClick,
            isShownInList: this.props.isShownInList,
            isSmall: this.props.isSmall
        }));
    }
}

});
parcelRegister("1WPu2", function(module, exports) {

$parcel$export(module.exports, "getFavorite", () => $1961b1823763022d$export$fce5eda070ce88d0);

var $eusud = parcelRequire("eusud");
const $1961b1823763022d$export$959ca2ee969adb8d = (baseUrl, request)=>`${baseUrl}/rest/internal/2/favourites/${request.type}/${request.id}`;
const $1961b1823763022d$export$fce5eda070ce88d0 = async (baseUrl, request)=>(0, $eusud.performGetRequest)($1961b1823763022d$export$959ca2ee969adb8d(baseUrl, request));

});




parcelRegister("gs7uP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a87a2ffd163e1826$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a87a2ffd163e1826$var$messages = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "global-issue-navigator.heading",
        "defaultMessage": "Issues"
    },
    windowTitle: {
        "id": "global-issue-navigator.window-title-migration",
        "defaultMessage": "Issue navigator"
    },
    filterWindowTitle: {
        "id": "global-issue-navigator.filter-window-title-migration",
        "defaultMessage": "[{filterName}] Issue navigator"
    },
    headingIssueTermRefresh: {
        "id": "global-issue-navigator.heading-issue-term-refresh",
        "defaultMessage": "All work"
    }
});
var $a87a2ffd163e1826$export$2e2bcd8739ae039 = $a87a2ffd163e1826$var$messages;

});

parcelRegister("9Bfjr", function(module, exports) {

$parcel$export(module.exports, "default", () => $47364065a0de794c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $cY1ec = parcelRequire("cY1ec");

var $1VU5d = parcelRequire("1VU5d");

var $o4HRh = parcelRequire("o4HRh");

var $7bJv8 = parcelRequire("7bJv8");

var $a8lIB = parcelRequire("a8lIB");

var $lml1M = parcelRequire("lml1M");

var $cZpsT = parcelRequire("cZpsT");

var $dCm1o = parcelRequire("dCm1o");
const $47364065a0de794c$var$PageActions = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter, searchResultPageData: searchResultPageData, filterName: filterName })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).PAGE_ACTIONS_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).PAGE_ACTIONS_END);
    }, []);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47364065a0de794c$export$48377ae1c677702b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47364065a0de794c$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $o4HRh.default), null)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47364065a0de794c$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7bJv8.ShareButton), {
        jql: jql,
        filterId: filterId,
        isModifiedFilter: isModifiedFilter
    })), !((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47364065a0de794c$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cY1ec.default), {
        jql: jql,
        filterId: filterId,
        isModifiedFilter: isModifiedFilter,
        showEcosystemApps: true,
        filterName: filterName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47364065a0de794c$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lml1M.default), {
        filterId: filterId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47364065a0de794c$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1VU5d.default), {
        jql: jql,
        filterId: filterId,
        searchResultPageData: searchResultPageData
    })));
};
var $47364065a0de794c$export$2e2bcd8739ae039 = $47364065a0de794c$var$PageActions;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47364065a0de794c$var$StyledPageAction = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66 _1ul9idpf _1xoqidpf",
            __cmplp.className
        ])
    });
});
const $47364065a0de794c$export$48377ae1c677702b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cY1ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $10ae3433867a34b6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $Y0ZJB = parcelRequire("Y0ZJB");

var $WbiIJ = parcelRequire("WbiIJ");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $6h1uG = parcelRequire("6h1uG");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $10ae3433867a34b6$var$ExportIssues = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("7sZLz")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/actions/export-issues/src/ui/index.tsx"
});
const $10ae3433867a34b6$var$Fallback = ({ onRetry: onRetry, customTriggerButton: customTriggerButton })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const triggerButton = ({ triggerRef: triggerRef, ...props })=>customTriggerButton ? customTriggerButton(false, {
            triggerRef: triggerRef,
            ...props
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WbiIJ.FilterButton), {
            ...props,
            text: formatMessage((0, $6h1uG.default).exportButtonText),
            label: formatMessage((0, $6h1uG.default).exportIssuesButtonIconLabel),
            ref: triggerRef
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>triggerButton({
                triggerRef: triggerRef,
                ...props
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y0ZJB.ErrorState), {
        onRetry: onRetry,
        pageAction: "exportIssues"
    }));
};
const $10ae3433867a34b6$var$AsyncExportIssues = (props)=>{
    const { customTriggerButton: customTriggerButton, customDisabledButton: customDisabledButton } = props;
    const [resetCaughtError, setResetCaughtError] = (0, $5uXOq.useState)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorActionExportIssues",
        id: "async-export-issues",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10ae3433867a34b6$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error),
                customTriggerButton: customTriggerButton
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-export-issues",
        fallback: customDisabledButton ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WbiIJ.FilterButton), {
            isDisabled: true,
            text: formatMessage((0, $6h1uG.default).exportButtonText),
            label: formatMessage((0, $6h1uG.default).exportIssuesButtonIconLabel)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10ae3433867a34b6$var$ExportIssues, props)));
};
var $10ae3433867a34b6$export$2e2bcd8739ae039 = $10ae3433867a34b6$var$AsyncExportIssues;

});
parcelRegister("Y0ZJB", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $a04e313879f6b069$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fVnbM = parcelRequire("fVnbM");

var $dD7Zc = parcelRequire("dD7Zc");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6TIqn = parcelRequire("6TIqn");

var $4MFPU = parcelRequire("4MFPU");
const $a04e313879f6b069$var$BOX_HEIGHT = (0, $gwIPs.gridSize) * 18;
const $a04e313879f6b069$var$ERROR_ICON_BOX_WRAPPER_HEIGHT = (0, $gwIPs.gridSize) * 9;
const $a04e313879f6b069$var$ICON_SIZE = (0, $gwIPs.gridSize) * 9;
const $a04e313879f6b069$export$c1ed4f415b9e7023 = (props)=>{
    const { pageAction: pageAction, onRetry: onRetry, description: description, role: role } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = ()=>{
        onRetry();
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${pageAction}Retry clicked`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a04e313879f6b069$var$StyledBox, {
        height: $a04e313879f6b069$var$BOX_HEIGHT,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a04e313879f6b069$var$StyledBox, {
        height: $a04e313879f6b069$var$ERROR_ICON_BOX_WRAPPER_HEIGHT,
        iconSize: $a04e313879f6b069$var$ICON_SIZE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4MFPU.StyledText), null, description !== undefined ? description : formatMessage((0, $6TIqn.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClick,
        appearance: "link",
        testId: "issue-navigator-actions-common.ui.error.button"
    }, formatMessage((0, $6TIqn.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a04e313879f6b069$var$StyledBox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $lD23V.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6TIqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c213a9b9cc23628d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c213a9b9cc23628d$var$messages = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-actions-common.error.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-actions-common.error.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $c213a9b9cc23628d$export$2e2bcd8739ae039 = $c213a9b9cc23628d$var$messages;

});

parcelRegister("4MFPU", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $acc4659069112fb0$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $l1N8i = parcelRequire("l1N8i");
const $acc4659069112fb0$export$d675f139b342d51a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $lD23V.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $acc4659069112fb0$var$StyledTextComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $acc4659069112fb0$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acc4659069112fb0$var$StyledTextComponent, props));

});


parcelRegister("WbiIJ", function(module, exports) {

$parcel$export(module.exports, "FilterButton", () => $d3768321d4c015de$export$fb46dd9777cc6db0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $c8Oei = parcelRequire("c8Oei");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $d3768321d4c015de$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isSelected: isSelected, onClick: onClick, testId: testId, vcId: vcId, isDisabled: isDisabled, text: text, label: label, customTriggerProps: customTriggerProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d3768321d4c015de$var$buttonWrapperStyles,
        "data-vc": `${vcId}-button${false ? '-ssr' : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        isDisabled: isDisabled,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3768321d4c015de$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            label: label,
            color: "currentColor"
        })),
        ...customTriggerProps
    }, text)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3768321d4c015de$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _2hwx196n",
            __cmplp.className
        ])
    });
});
const $d3768321d4c015de$var$buttonWrapperStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});

});

parcelRegister("6h1uG", function(module, exports) {

$parcel$export(module.exports, "default", () => $85218cd505ca3251$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $85218cd505ca3251$var$messages = (0, $7VHMR.defineMessages)({
    exportButtonText: {
        "id": "issue-navigator-action-export-issues.export-button-text",
        "defaultMessage": "Export"
    },
    exportIssuesButtonIconLabel: {
        "id": "issue-navigator-action-export-issues.export-issues-button-icon-label",
        "defaultMessage": "Open export issues dropdown"
    }
});
var $85218cd505ca3251$export$2e2bcd8739ae039 = $85218cd505ca3251$var$messages;

});

parcelRegister("7sZLz", function(module, exports) {

let $56fb0f6633c5eb0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $56fb0f6633c5eb0f$var$load("89rrl").then(()=>parcelRequire('3wO03'));

});


parcelRegister("1VU5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $501391b3afc4b8d9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bJeNF = parcelRequire("bJeNF");

var $eZJjh = parcelRequire("eZJjh");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");

var $8U6zd = parcelRequire("8U6zd");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dG0IQ = parcelRequire("dG0IQ");

var $koVbs = parcelRequire("koVbs");

var $7XYc4 = parcelRequire("7XYc4");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $47gW9 = parcelRequire("47gW9");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $Y0ZJB = parcelRequire("Y0ZJB");

var $5Czte = parcelRequire("5Czte");

var $7mPT9 = parcelRequire("7mPT9");

var $f7PHy = parcelRequire("f7PHy");

var $bSg1p = parcelRequire("bSg1p");

var $cZpsT = parcelRequire("cZpsT");

var $dCm1o = parcelRequire("dCm1o");

var $8zOmE = parcelRequire("8zOmE");

var $ceKQx = parcelRequire("ceKQx");

var $2fsrR = parcelRequire("2fsrR");

var $jeztk = parcelRequire("jeztk");

var $cuGU0 = parcelRequire("cuGU0");

var $k7Zdy = parcelRequire("k7Zdy");

const $501391b3afc4b8d9$var$StatisticsOnboardingSpotlight = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('helios_list_view_statistics_nin_migration', 'isEnabled', false), ({ children: children, shouldShowSpotlight: shouldShowSpotlight, coordinationClient: coordinationClient, onStatisticsTryNow: onStatisticsTryNow, onStatisticsOnboardingStop: onStatisticsOnboardingStop })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cuGU0.StatisticsOnboarding), {
        shouldShowSpotlight: shouldShowSpotlight,
        coordinationClient: coordinationClient,
        onStatisticsTryNow: onStatisticsTryNow,
        onStatisticsOnboardingStop: ()=>onStatisticsOnboardingStop((0, $ff8c546d428de2bd$export$36bc26bb4371a2a))
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
const $501391b3afc4b8d9$var$useHierarchyOnboardingContext = ()=>{
    if ((0, $4R6GH.fg)('jira_list_hierarchy_extraction')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $f7PHy.useHierarchyOnboardingContext)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $bSg1p.useHierarchyOnboardingContext)();
};
const $501391b3afc4b8d9$export$ef4a0fdddd7eccb7 = ({ jql: jql, filterId: filterId = '', searchResultPageData: searchResultPageData, additionalMenuItems: additionalMenuItems, viewOptions: viewOptions, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled })=>{
    const { data: data, loading: loading, error: error, fetch: fetch, requestPayload: requestPayload } = (0, $ceKQx.useMeatballMenuItems)(searchResultPageData);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isNinChangeboardingEnabled = (0, $5uXOq.useContext)((0, $5Czte.NinChangeboardingContext));
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const shouldShowOptOut = isNinChangeboardingEnabled && !isAnonymous;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const lastUsedRequestPayload = (0, $5uXOq.useRef)();
    const hasPreviousError = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const isMeatballMenuOpenedWithNewPayload = isOpen && JSON.stringify(requestPayload) !== JSON.stringify(lastUsedRequestPayload.current);
        if (!loading && !hasPreviousError.current && isMeatballMenuOpenedWithNewPayload) {
            fetch(requestPayload);
            lastUsedRequestPayload.current = requestPayload;
        }
        // If there was a fetch error, we clear the lastUsedRequestPayload
        if (error) {
            hasPreviousError.current = true;
            lastUsedRequestPayload.current = undefined;
        }
    }, [
        fetch,
        isOpen,
        loading,
        requestPayload,
        error
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2fsrR.meatballMenuPopUpEntryPoint), {});
    const { shouldShowSpotlight: shouldShowSpotlight, onStatisticsOnboardingStop: onStatisticsOnboardingStop, coordinationClient: coordinationClient } = (0, $k7Zdy.useStatisticsSpotlight)();
    const onStatisticsTryNow = ()=>{
        onStatisticsOnboardingStop((0, $ff8c546d428de2bd$export$e328a74db0175ecc));
        entryPointActions.load();
        setIsOpen(true);
    };
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            jql: jql,
            filterId: filterId,
            additionalMenuItems: additionalMenuItems,
            viewOptions: viewOptions,
            shouldShowOptOut: shouldShowOptOut,
            data: data
        }), [
        jql,
        filterId,
        additionalMenuItems,
        viewOptions,
        shouldShowOptOut,
        data
    ]);
    const entryPointTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const [retryKey, setRetryKey] = (0, $5uXOq.useState)(0);
    const errorFallback = (onRetry)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y0ZJB.ErrorState), {
            onRetry: onRetry,
            pageAction: "meatballMenu"
        });
    const { showToggleOnboarding: showToggleOnboarding } = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $501391b3afc4b8d9$var$useHierarchyOnboardingContext() : {
        showToggleOnboarding: false
    };
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (// eslint-disable-next-line jira/ff/no-preconditioning
        showToggleOnboarding && (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && isIssueHierarchySupportEnabled) {
            // We cannot access the ref of the "next" button in the onboarding spotlight.
            // Easiest workaround is to load the entrypoint here before we open the menu.
            // Once onboarding is removed, we can likely remove the entire isOpen prop from
            // the DropdownMenu component to avoid this issue in the future.
            entryPointActions.load();
            setIsOpen(true);
        }
    }, [
        showToggleOnboarding,
        entryPointActions,
        isIssueHierarchySupportEnabled
    ]);
    const { showHideDoneOnboarding: showHideDoneOnboarding } = (0, $4R6GH.fg)('jsc_list_hide_done_items') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $dG0IQ.useHideDoneOnboarding)({
        isHideDoneSupportEnabled: isHideDoneSupportEnabled
    }) : {
        showHideDoneOnboarding: false
    };
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (showHideDoneOnboarding && isHideDoneSupportEnabled && (0, $4R6GH.fg)('jsc_list_hide_done_items')) {
            // We cannot open the menu without loading the entrypoint.
            // Easiest workaround is to load the entrypoint here before we open the menu.
            // Once onboarding is removed, we can likely remove the entire isOpen prop from
            // the DropdownMenu component to avoid this issue in the future.
            entryPointActions.load();
            setIsOpen(true);
        }
    }, [
        entryPointActions,
        isHideDoneSupportEnabled,
        showHideDoneOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isLoading: loading && JSON.stringify(requestPayload) === JSON.stringify(lastUsedRequestPayload.current),
        onOpenChange: (nextState)=>{
            if (nextState.isOpen) hasPreviousError.current = false;
            setIsOpen(nextState.isOpen);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: nextState.isOpen ? 'opened' : 'closed',
                actionSubject: 'button'
            }), 'meatballMenuPopup');
        },
        isOpen: isOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($501391b3afc4b8d9$var$StatisticsOnboardingSpotlight, {
                shouldShowSpotlight: shouldShowSpotlight,
                onStatisticsTryNow: onStatisticsTryNow,
                onStatisticsOnboardingStop: onStatisticsOnboardingStop,
                coordinationClient: coordinationClient
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ref: (0, $7mPT9.mergeRefs)(triggerRef, entryPointTriggerRef),
                ...props,
                testId: "issue-navigator-action-meatball-menu.ui.menu-trigger",
                isSelected: isOpen,
                label: formatMessage((0, $jeztk.default).moreActionsLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))),
                isTooltipDisabled: false
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($501391b3afc4b8d9$var$StatisticsOnboardingSpotlight, {
                shouldShowSpotlight: shouldShowSpotlight,
                onStatisticsTryNow: onStatisticsTryNow,
                onStatisticsOnboardingStop: onStatisticsOnboardingStop,
                coordinationClient: coordinationClient
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                testId: "issue-navigator-action-meatball-menu.ui.menu-trigger",
                spacing: "default",
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    label: formatMessage((0, $jeztk.default).moreActionsLabel),
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }),
                ref: (0, $7mPT9.mergeRefs)(triggerRef, entryPointTriggerRef)
            })),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact",
        testId: "issue-navigator-action-meatball-menu.ui.dropdown-menu"
    }, !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        key: retryKey,
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "popup-content",
        packageName: "jiraIssueNavigatorActionMeatballMenu",
        errorFallback: ()=>errorFallback(()=>{
                ()=>setRetryKey((prev)=>prev + 1);
            }),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $501391b3afc4b8d9$var$spinnerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        })),
        runtimeProps: runtimeProps
    }) : errorFallback(()=>{
        fetch(requestPayload);
        lastUsedRequestPayload.current = requestPayload;
    }));
};
const $501391b3afc4b8d9$var$spinnerContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
var $501391b3afc4b8d9$export$2e2bcd8739ae039 = $501391b3afc4b8d9$export$ef4a0fdddd7eccb7;

});
parcelRegister("ceKQx", function(module, exports) {

$parcel$export(module.exports, "useMeatballMenuItems", () => $b2c469395e2212b2$export$dcc369963df3381d);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $ld2hZ = parcelRequire("ld2hZ");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");
const $b2c469395e2212b2$export$162e19c052deab0b = '/rest/issueNav/1/issueNav/operations/tools';
const $b2c469395e2212b2$export$34482912a4c2747c = (options)=>(0, $eusud.performPostRequest)($b2c469395e2212b2$export$162e19c052deab0b, {
        credentials: 'same-origin',
        body: (0, $ebyGx.stringify)(options),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Atlassian-Token': 'no-check',
            __amdModuleName: 'jira/issue/utils/xsrf-token-header'
        }
    });
const $b2c469395e2212b2$export$dcc369963df3381d = (searchResultPageData)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)($b2c469395e2212b2$export$34482912a4c2747c);
    const { offset: offset, pages: pages, total: total } = searchResultPageData;
    // Issue count here is used to show warning message in
    // bulk edit page. We show a warning message if the issue count is > 999.
    const allIssues = total > 999 ? 1000 : 999;
    const requestPayload = {
        offset: offset,
        searchResultsTotal: // eslint-disable-next-line jira/ff/no-preconditioning
        (0, $6s1PB.expVal)('jira_spreadsheet_component_m1', 'isHierarchyEnabled', false) && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? allIssues : total,
        searchResultsPages: pages,
        // useColumns and skipColumns aren't used in the endpoint but is required for the constructor
        useColumns: false,
        skipColumns: false,
        new: true
    };
    (0, $5uXOq.useEffect)(()=>{
        if (loading) return;
        if (error) (0, $jcw0u.default)({
            error: error,
            event: createAnalyticsEvent({}),
            meta: {
                id: 'useMeatballMenuItems'
            }
        });
        else if (data) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useMeatballMenuItems succeeded', 'meatballMenu');
    }, [
        createAnalyticsEvent,
        data,
        error,
        loading
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        fetch: fetch,
        requestPayload: requestPayload
    };
};

});

parcelRegister("2fsrR", function(module, exports) {

$parcel$export(module.exports, "meatballMenuPopUpEntryPoint", () => $ffbb05921429c280$export$a544c6272b25c45e);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $ffbb05921429c280$export$a544c6272b25c45e = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("1XVOy")), {
        moduleId: "87e9200c"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1XVOy", function(module, exports) {

let $16e825d9d2235e35$var$load = (parcelRequire("28QjX"))(4);
module.exports = $16e825d9d2235e35$var$load("5MdBH").then(()=>parcelRequire('14NkX'));

});


parcelRegister("jeztk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e045e5a40071d40$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $6e045e5a40071d40$var$messages = (0, $7VHMR.defineMessages)({
    moreActionsLabel: {
        "id": "issue-navigator-action-meatball-menu.more-actions-label",
        "defaultMessage": "More actions"
    },
    actionsOptOutDisplayText: {
        "id": "issue-navigator-action-meatball-menu.actions-opt-out-display-text",
        "defaultMessage": "Go back to the old issue search"
    },
    actionsGiveFeedbackDisplayText: {
        "id": "issue-navigator-action-meatball-menu.actions-give-feedback-display-text",
        "defaultMessage": "Give feedback"
    },
    feedbackTitle: {
        "id": "issue-navigator-action-meatball-menu.feedback-title",
        "defaultMessage": "Give feedback for issue search"
    },
    feedbackTitleDetails: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-details",
        "defaultMessage": "Let us know how we can improve this experience."
    },
    feedbackTitleDetailsContactSupport: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-details-contact-support",
        "defaultMessage": "If you\u2019re having technical issues, contact our support team."
    },
    feedbackTypePlaceholder: {
        "id": "issue-navigator-action-meatball-menu.feedback-type-placeholder",
        "defaultMessage": "Select an option"
    },
    bulkChangeIssues: {
        "id": "issue-navigator-action-meatball-menu.bulk-change-issues",
        "defaultMessage": "Bulk change work items"
    },
    bulkChangeIssuesOldTerminology: {
        "id": "issue-navigator-action-meatball-menu.bulk-change-issues-old-terminology",
        "defaultMessage": "Bulk change issues"
    },
    viewIssuesAsAChart: {
        "id": "issue-navigator-action-meatball-menu.view-issues-as-a-chart",
        "defaultMessage": "View issues as a chart"
    },
    viewWorkItemsAsAChart: {
        "id": "issue-navigator-action-meatball-menu.view-issues-as-a-chart-issue-term-refresh",
        "defaultMessage": "View work items as a chart"
    },
    export: {
        "id": "issue-navigator-action-meatball-menu.export",
        "defaultMessage": "Export"
    },
    newLozengeLabel: {
        "id": "issue-navigator-action-meatball-menu.new-lozenge-label",
        "defaultMessage": "New"
    }
});
var $6e045e5a40071d40$export$2e2bcd8739ae039 = $6e045e5a40071d40$var$messages;

});

parcelRegister("cuGU0", function(module, exports) {

$parcel$export(module.exports, "StatisticsOnboarding", () => $a14340ed73a0f079$export$d628ca45cec6f862);

var $5uXOq = parcelRequire("5uXOq");

var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $hxoiH = parcelRequire("hxoiH");

var $ioD1B = parcelRequire("ioD1B");

var $6DLDx = parcelRequire("6DLDx");

var $bu56N = parcelRequire("bu56N");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $ggZrk = parcelRequire("ggZrk");

const $a14340ed73a0f079$export$d628ca45cec6f862 = ({ shouldShowSpotlight: shouldShowSpotlight, coordinationClient: coordinationClient, onStatisticsTryNow: onStatisticsTryNow, onStatisticsOnboardingStop: onStatisticsOnboardingStop, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    if (!shouldShowSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "nin-meatball-button-statistics-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        pulse: shouldShowSpotlight
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        heading: formatMessage((0, $ggZrk.default).getWorkInsights),
        messageId: (0, $4R6GH.fg)('helios_nin_statistics_onboarding_spotlight') ? (0, $ff8c546d428de2bd$export$e57f07f68ad825f4) : (0, $ff8c546d428de2bd$export$60f0ae43d6be43f1),
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($bu56N))) : (0, (/*@__PURE__*/$parcel$interopDefault($6DLDx))),
        key: "nin-meatball-button-statistics-spotlight",
        actions: [
            {
                onClick: onStatisticsTryNow,
                text: formatMessage((0, $ggZrk.default).tryItOut)
            },
            {
                onClick: onStatisticsOnboardingStop,
                text: formatMessage((0, $ggZrk.default).dismiss)
            }
        ],
        targetRadius: 3,
        targetBgColor: "var(--ds-background-discovery, #F3F0FF)",
        target: "nin-meatball-button-statistics-spotlight",
        messageType: "engagement",
        dialogPlacement: "bottom right"
    }, (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? formatMessage((0, $ggZrk.default).onboardingStatisticsDescriptionIssueTermRefresh) : formatMessage((0, $ggZrk.default).onboardingStatisticsDescription))));
};

});
parcelRegister("6DLDx", function(module, exports) {
module.exports = new URL("issue-view-statistics-onboarding.3f045443.gif", import.meta.url).toString();

});

parcelRegister("bu56N", function(module, exports) {
module.exports = new URL("issue-view-statistics-onboarding-dark-mode.18820f06.gif", import.meta.url).toString();

});

parcelRegister("ggZrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc0701c9aa6fc3d6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $dc0701c9aa6fc3d6$var$messages = (0, $7VHMR.defineMessages)({
    onboardingStatisticsDescription: {
        "id": "issue-navigator-action-meatball-menu.onboarding-statistics-description",
        "defaultMessage": "You can now create charts from filtered issues for quick and useful insights."
    },
    onboardingStatisticsDescriptionIssueTermRefresh: {
        "id": "issue-navigator-action-meatball-menu.onboarding-statistics-description-issue-term-refresh",
        "defaultMessage": "You can now create charts from filtered work items for quick and useful insights."
    },
    tryItOut: {
        "id": "issue-navigator-action-meatball-menu.try-it-out",
        "defaultMessage": "Try it out"
    },
    dismiss: {
        "id": "issue-navigator-action-meatball-menu.dismiss",
        "defaultMessage": "Dismiss"
    },
    getWorkInsights: {
        "id": "issue-navigator-action-meatball-menu.get-work-insights",
        "defaultMessage": "Get work insights"
    }
});
var $dc0701c9aa6fc3d6$export$2e2bcd8739ae039 = $dc0701c9aa6fc3d6$var$messages;

});

const $ff8c546d428de2bd$export$c7e6a6b283196232 = '/gateway/api';
const $ff8c546d428de2bd$export$60f0ae43d6be43f1 = 'jira-nin-statistics-onboarding-spotlight';
const $ff8c546d428de2bd$export$e57f07f68ad825f4 = 'jira_helios_nin_statistics_onboarding';
const $ff8c546d428de2bd$export$e328a74db0175ecc = 'jiraNinStatisticsOnboardingTryItOut';
const $ff8c546d428de2bd$export$36bc26bb4371a2a = 'jiraNinStatisticsOnboardingDismiss';
const $ff8c546d428de2bd$export$db1926f449c86467 = 'jiraNinStatisticsOnboardingSpotlight';


parcelRegister("k7Zdy", function(module, exports) {

$parcel$export(module.exports, "useStatisticsSpotlight", () => $5fd3cc9895f4daa9$export$e4f5ca4f8dca0290);

var $5uXOq = parcelRequire("5uXOq");

var $kbqIt = parcelRequire("kbqIt");

var $eGLgs = parcelRequire("eGLgs");

var $6s1PB = parcelRequire("6s1PB");

var $koeKL = parcelRequire("koeKL");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

const $5fd3cc9895f4daa9$export$e4f5ca4f8dca0290 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [showPulse, setShowPulse] = (0, $5uXOq.useState)(false);
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, (0, $ff8c546d428de2bd$export$c7e6a6b283196232), false, '', 'engagement'), [
        cloudId
    ]);
    const [isMessageActive, stopMessage] = (0, $kbqIt.useCoordination)(coordinationClient, (0, $4R6GH.fg)('helios_nin_statistics_onboarding_spotlight') ? (0, $ff8c546d428de2bd$export$e57f07f68ad825f4) : (0, $ff8c546d428de2bd$export$60f0ae43d6be43f1));
    (0, $5uXOq.useEffect)(()=>{
        if (isMessageActive) {
            setShowPulse(true);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'spotlight'
            }), (0, $ff8c546d428de2bd$export$db1926f449c86467));
        }
    }, [
        coordinationClient,
        createAnalyticsEvent,
        isMessageActive
    ]);
    const shouldShowSpotlight = (0, $5uXOq.useMemo)(()=>showPulse && (0, $6s1PB.expVal)('helios_list_view_statistics_nin_migration', 'isEnabled', false), [
        showPulse
    ]);
    const onStatisticsOnboardingStop = (0, $5uXOq.useCallback)((actionSubject)=>{
        stopMessage();
        setShowPulse(false);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: `${actionSubject} button`
        }));
    }, [
        stopMessage,
        createAnalyticsEvent
    ]);
    return {
        shouldShowSpotlight: shouldShowSpotlight,
        onStatisticsOnboardingStop: onStatisticsOnboardingStop,
        coordinationClient: coordinationClient
    };
};

});


parcelRegister("o4HRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $99334036623bc424$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");

var $7CMCs = parcelRequire("7CMCs");

var $Y0ZJB = parcelRequire("Y0ZJB");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $7trNp = parcelRequire("7trNp");

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
const $99334036623bc424$var$PluggableItems = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("jpPFz")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/actions/pluggable-items/src/ui/main.tsx"
});
const $99334036623bc424$var$Fallback = ({ onRetry: onRetry })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7trNp.PluggableItemsFilterButton), {
                ...props,
                ref: triggerRef
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y0ZJB.ErrorState), {
        onRetry: onRetry,
        pageAction: "apps"
    }));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $99334036623bc424$var$AsyncPluggableItems = ()=>{
    const [resetCaughtError, setResetCaughtError] = (0, $5uXOq.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorActionPluggableItems",
        id: "async-pluggable-items",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($99334036623bc424$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error)
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-pluggable-items",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7trNp.PluggableItemsFilterButton), {
            isDisabled: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($99334036623bc424$var$PluggableItems, null)));
};
var $99334036623bc424$export$2e2bcd8739ae039 = $99334036623bc424$var$AsyncPluggableItems;

});
parcelRegister("7trNp", function(module, exports) {

$parcel$export(module.exports, "PluggableItemsFilterButton", () => $91976ee30eecca78$export$7f94e3b48172a1bd);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $WbiIJ = parcelRequire("WbiIJ");

var $64Mgm = parcelRequire("64Mgm");
const $91976ee30eecca78$export$7f94e3b48172a1bd = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WbiIJ.FilterButton), {
        testId: "issue-navigator-action-pluggable-items.ui.filter-button.menu-trigger",
        vcId: "pluggable-items",
        text: formatMessage((0, $64Mgm.default).pluggableItemsButtonText),
        label: formatMessage((0, $64Mgm.default).pluggableItemsButtonIconLabel),
        ...props,
        ref: ref
    });
});

});
parcelRegister("64Mgm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec76edf4a5abe930$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ec76edf4a5abe930$var$messages = (0, $7VHMR.defineMessages)({
    pluggableItemsButtonText: {
        "id": "issue-navigator-action-pluggable-items.filter-button.pluggable-items-button-text",
        "defaultMessage": "Apps"
    },
    pluggableItemsButtonIconLabel: {
        "id": "issue-navigator-action-pluggable-items.filter-button.pluggable-items-button-icon-label",
        "defaultMessage": "Open pluggable items dropdown"
    }
});
var $ec76edf4a5abe930$export$2e2bcd8739ae039 = $ec76edf4a5abe930$var$messages;

});


parcelRegister("jpPFz", function(module, exports) {

let $e2286e9ab6c31968$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e2286e9ab6c31968$var$load("ijXkn").then(()=>parcelRequire('9avSx'));

});


parcelRegister("7bJv8", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $2f0198851cf45c49$export$e980dfbc2840e8bc);

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $3Tty1 = parcelRequire("3Tty1");

var $koVbs = parcelRequire("koVbs");

var $WbiIJ = parcelRequire("WbiIJ");

var $9Nvh7 = parcelRequire("9Nvh7");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iL8EU = parcelRequire("iL8EU");

var $16v4H = parcelRequire("16v4H");

var $a0UsQ = parcelRequire("a0UsQ");

var $bcD3e = parcelRequire("bcD3e");

var $i5w7k = parcelRequire("i5w7k");

var $68QXU = parcelRequire("68QXU");

var $lYorD = parcelRequire("lYorD");
const $2f0198851cf45c49$var$getShareLink = (param, value)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { hostname: hostname, protocol: protocol } = window.location;
    return `${protocol}//${hostname}/issues/?${param}=${encodeURIComponent(value)}`;
};
const $2f0198851cf45c49$var$CustomTriggerButton = ({ isDisabled: isDisabled, isSelected: isSelected, onClick: onClick }, triggerProps)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onKeyboardShortcutClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), 'shareSearchCriteriaModalKeyboardShortcut', {
            keyPressed: 's',
            keyboardShortcut: true
        });
        onClick();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const shortcutsKeyMap = (0, $5uXOq.useMemo)(()=>({
            s: {
                callback: onKeyboardShortcutClick,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $lYorD.messages).shareKeyboardShortcut))
            }
        }), [
        formatMessage,
        onKeyboardShortcutClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: shortcutsKeyMap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WbiIJ.FilterButton), {
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        label: "",
        text: formatMessage((0, $lYorD.messages).share),
        customTriggerProps: {
            ...triggerProps,
            'aria-haspopup': false
        },
        vcId: "share-button"
    }));
};
const $2f0198851cf45c49$var$addContextToEvent = (event)=>{
    const attributes = event.context.map((context)=>context.attributes);
    event.update((payload)=>({
            ...payload,
            attributes: Object.assign(event.payload.attributes || {}, ...attributes)
        }));
};
const $2f0198851cf45c49$export$e980dfbc2840e8bc = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const subProduct = (0, $16v4H.useSubProduct)();
    const [shouldShowThirdPartyNudge, setShouldShowThirdPartyNudge] = (0, $5uXOq.useState)(false);
    const showFilterShareLinkNew = filterId !== undefined && (0, $9Nvh7.isCustomFilter)(filterId) && !isModifiedFilter;
    // share custom filters by ID if the JQL is not overridden, otherwise just share the JQL
    const additionalProps = showFilterShareLinkNew ? {
        integrationType: (0, $bcD3e.INTEGRATION_TYPES).FILTER,
        shareContentType: (0, $bcD3e.INTEGRATION_TYPES).FILTER,
        shareLink: $2f0198851cf45c49$var$getShareLink('filter', filterId),
        shareTitle: formatMessage((0, $lYorD.messages).filter),
        shareFormTitle: formatMessage((0, $lYorD.messages).dialogTitleFilter)
    } : {
        integrationType: (0, $bcD3e.INTEGRATION_TYPES).SEARCH,
        shareContentType: (0, $bcD3e.INTEGRATION_TYPES).SEARCH,
        shareLink: $2f0198851cf45c49$var$getShareLink('jql', jql),
        shareTitle: formatMessage((0, $lYorD.messages).search),
        shareFormTitle: formatMessage((0, $lYorD.messages).dialogTitleSearch)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        channel: "*",
        onEvent: $2f0198851cf45c49$var$addContextToEvent
    }, shouldShowThirdPartyNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a0UsQ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.ShareButton), {
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: (0, $68QXU.getShareSubProductId)(subProduct),
        objectAri: "" // The legacy sharing API does not use ARIs
        ,
        legacyShareClientConfig: (0, $i5w7k.shareSearchClientConfig),
        renderCustomTriggerButton: $2f0198851cf45c49$var$CustomTriggerButton,
        onTriggerButtonClick: ()=>{
            setShouldShowThirdPartyNudge(true);
        },
        ...additionalProps
    }));
};

});
parcelRegister("iL8EU", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $4e5335f44d688bbf$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButtonAnalyticsWrapperWithGating", () => $4e5335f44d688bbf$export$593c5080db936480);
$parcel$export(module.exports, "ShareButton", () => $4e5335f44d688bbf$export$e980dfbc2840e8bc);
$parcel$export(module.exports, "ShareButtonAsync", () => $4e5335f44d688bbf$export$3585ee2128ae4c25);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $kOEld = parcelRequire("kOEld");

var $42CjB = parcelRequire("42CjB");

var $1PVpv = parcelRequire("1PVpv");

var $empdx = parcelRequire("empdx");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $itmJb = parcelRequire("itmJb");

var $4R6GH = parcelRequire("4R6GH");

var $93Yeu = parcelRequire("93Yeu");

var $dAfqg = parcelRequire("dAfqg");

var $lODMY = parcelRequire("lODMY");

var $7XYc4 = parcelRequire("7XYc4");

var $67hPg = parcelRequire("67hPg");
var $kNJSJ = parcelRequire("kNJSJ");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $Kpokz = parcelRequire("Kpokz");

var $8BVfN = parcelRequire("8BVfN");
const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $Kpokz.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e5335f44d688bbf$var$ShareButtonBase = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("gOkRe")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $4e5335f44d688bbf$export$f87be37f8e8be65 = (0, $lODMY.createRouterSelector)((state)=>state.match.params.projectKey || '');
const $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper = ({ children: children, ...props })=>{
    const maybeProjectKey = $4e5335f44d688bbf$export$f87be37f8e8be65();
    const projectKey = props.projectKey || maybeProjectKey;
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const projectStyle = (0, $93Yeu.useProjectStyle)(projectKey);
    const projectContext = (0, $dAfqg.useProjectContext)();
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = isAdmin || projectContext?.data?.isProjectAdmin || false;
    const analyticsData = (0, $5uXOq.useMemo)(()=>{
        const projectContextData = projectKey ? {
            projectType: projectType,
            projectStyle: projectStyle,
            isProjectAdmin: isProjectAdmin
        } : undefined;
        return {
            isAdmin: isAdmin,
            userLocation: userLocation,
            ...projectContextData
        };
    }, [
        projectKey,
        projectType,
        projectStyle,
        isProjectAdmin,
        userLocation,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.FabricElementsAnalyticsContext), {
        data: analyticsData
    }, children));
};
const $4e5335f44d688bbf$export$593c5080db936480 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsw-smart-access-extended-analytics-enabled'), $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper, ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
const $4e5335f44d688bbf$export$e980dfbc2840e8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props))));
const $4e5335f44d688bbf$export$3585ee2128ae4c25 = (props)=>{
    const { Panel: Panel, trigger: trigger } = (0, $kNJSJ.usePanel)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            ...props
        }), [
        props
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jsm-share-button-async",
        packageName: "jiraShareButton",
        teamName: "people-and-teams-collective",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $8BVfN.shareButtonEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps
    }, ({ ref: ref })=>!isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            testId: "share-button.button",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            appearance: "default",
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
            onClick: ()=>setIsOpen(true)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Panel, null));
};

});
parcelRegister("kOEld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f277c50ed79b6741$var$_react = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f277c50ed79b6741$var$_share = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("empdx")));

var $f277c50ed79b6741$var$_share2 = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("jZX0t")));
function $f277c50ed79b6741$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f277c50ed79b6741$var$ShareIcon = (props)=>/*#__PURE__*/ $f277c50ed79b6741$var$_react.default.createElement($f277c50ed79b6741$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $f277c50ed79b6741$var$_share2.default
    }, props));
$f277c50ed79b6741$var$ShareIcon.Name = 'ShareIconMigration';
var $f277c50ed79b6741$var$_default = module.exports.default = $f277c50ed79b6741$var$ShareIcon;

});
parcelRegister("empdx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccb1509d7e2270e6a953aebace8cfd49>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a746ae65a0e1944c$var$_react = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a746ae65a0e1944c$var$_baseNew = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a746ae65a0e1944c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a746ae65a0e1944c$var$ShareIcon = (props)=>/*#__PURE__*/ $a746ae65a0e1944c$var$_react.default.createElement($a746ae65a0e1944c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$a746ae65a0e1944c$var$ShareIcon.displayName = 'ShareIcon';
var $a746ae65a0e1944c$var$_default = module.exports.default = $a746ae65a0e1944c$var$ShareIcon;

});

parcelRegister("jZX0t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8f17c524b03e26b$var$ShareIcon = (props)=>/*#__PURE__*/ $e8f17c524b03e26b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $e8f17c524b03e26b$var$_share.default
    }));
$e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;

});


parcelRegister("67hPg", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $f5abbb29b5666c06$export$41fb9f06171c75f4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Du7S = parcelRequire("3Du7S");

var $iwwXK = parcelRequire("iwwXK");

var $7F2yO = parcelRequire("7F2yO");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");
const $f5abbb29b5666c06$var$emptyEntryPointParams = {};
const $f5abbb29b5666c06$var$emptyEntryPointProps = {};
function $f5abbb29b5666c06$export$41fb9f06171c75f4({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, forwardedRef: forwardedRef, trigger: trigger }) {
    const { setPanel: setPanel } = trigger;
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $f5abbb29b5666c06$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        const defaultFallback = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {})
            ]
        });
        setPanel(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || defaultFallback,
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $f5abbb29b5666c06$var$emptyEntryPointProps
        }));
    }, [
        setPanel,
        id,
        entryPointProps,
        fallback,
        errorFallback
    ]);
    const triggerRef = (0, $7F2yO.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});

parcelRegister("kNJSJ", function(module, exports) {

$parcel$export(module.exports, "usePanel", () => $0ef0a2f3e739e762$export$9168a42f32e3d071);

var $5uXOq = parcelRequire("5uXOq");
function $0ef0a2f3e739e762$export$9168a42f32e3d071(initialState) {
    const [panel, setPanel] = (0, $5uXOq.useState)(initialState);
    const Panel = (0, $5uXOq.useMemo)(()=>{
        const PanelComponent = ()=>panel ?? null;
        return PanelComponent;
    }, [
        panel
    ]);
    const trigger = (0, $5uXOq.useMemo)(()=>({
            setPanel: (panel)=>setPanel(panel)
        }), [
        setPanel
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            Panel: Panel,
            trigger: trigger
        }), [
        Panel,
        trigger
    ]);
}

});

parcelRegister("Kpokz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $026d1258a1c95d57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $026d1258a1c95d57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("8BVfN", function(module, exports) {

$parcel$export(module.exports, "shareButtonEntryPoint", () => $735d063ad5974451$export$ad8b1559c594245d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $735d063ad5974451$export$ad8b1559c594245d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("96z0m")), {
        moduleId: "50ae946e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("96z0m", function(module, exports) {

let $6a0fd3d6e38f0700$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $6a0fd3d6e38f0700$var$load("cM9em"),
    $6a0fd3d6e38f0700$var$load("fr9NE"),
    $6a0fd3d6e38f0700$var$load("hPzOn"),
    $6a0fd3d6e38f0700$var$load("h2MrD"),
    $6a0fd3d6e38f0700$var$load("bYT2S"),
    $6a0fd3d6e38f0700$var$load("iVQTr")
]).then(()=>parcelRequire('8kufr'));

});


parcelRegister("gOkRe", function(module, exports) {

let $c3d17ec1e67bb60d$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $c3d17ec1e67bb60d$var$load("cM9em"),
    $c3d17ec1e67bb60d$var$load("fr9NE"),
    $c3d17ec1e67bb60d$var$load("hPzOn"),
    $c3d17ec1e67bb60d$var$load("h2MrD"),
    $c3d17ec1e67bb60d$var$load("bYT2S"),
    $c3d17ec1e67bb60d$var$load("bfk3F")
]).then(()=>parcelRequire('7aU9g'));

});


parcelRegister("bcD3e", function(module, exports) {

$parcel$export(module.exports, "INTEGRATION_TYPES", () => $b057f09e7b03d4c8$export$195813ac8b6ae6f9);
const $b057f09e7b03d4c8$export$195813ac8b6ae6f9 = {
    FILTER: 'filter',
    SEARCH: 'search'
};

});

parcelRegister("i5w7k", function(module, exports) {

$parcel$export(module.exports, "shareSearchClientConfig", () => $b84dbc261bc35c80$export$14295897acb58714);

var $bcD3e = parcelRequire("bcD3e");
const $b84dbc261bc35c80$export$14295897acb58714 = {
    getShareEndpoint: ({ link: link, type: type })=>type === (0, $bcD3e.INTEGRATION_TYPES).FILTER ? `/rest/share/1.0/filter/${new URL(link).searchParams.get('filter') || ''}` : '/rest/share/1.0/search',
    getSharePayload: ({ link: link, type: type })=>{
        const jql = new URL(link).searchParams.get('jql');
        return type === (0, $bcD3e.INTEGRATION_TYPES).SEARCH && jql !== null ? {
            jql: jql
        } : {};
    }
};

});

parcelRegister("68QXU", function(module, exports) {

$parcel$export(module.exports, "getShareSubProductId", () => $a1c93c3f1c8e701d$export$4a20278dd1d015dd);
const $a1c93c3f1c8e701d$var$subProductMap = {
    addon: 'jira-addon',
    core: 'jira-core',
    polaris: 'jira-polaris',
    portfolio: 'jira-portfolio',
    serviceDesk: 'jira-servicedesk',
    software: 'jira-software',
    platform: 'jira-platform',
    unknown: 'jira-unknown'
};
const $a1c93c3f1c8e701d$export$4a20278dd1d015dd = (subProduct)=>subProduct && $a1c93c3f1c8e701d$var$subProductMap[subProduct] || 'jira-platform';

});

parcelRegister("lYorD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7d14c0e250c5cb9b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7d14c0e250c5cb9b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    dialogTitleFilter: {
        "id": "issue-navigator-action-share-button.dialog-title-filter",
        "defaultMessage": "Share current filter"
    },
    dialogTitleSearch: {
        "id": "issue-navigator-action-share-button.dialog-title-search",
        "defaultMessage": "Share search criteria"
    },
    filter: {
        "id": "issue-navigator-action-share-button.filter",
        "defaultMessage": "Filter"
    },
    search: {
        "id": "issue-navigator-action-share-button.search",
        "defaultMessage": "Search"
    },
    share: {
        "id": "issue-navigator-action-share-button.share",
        "defaultMessage": "Share"
    },
    shareKeyboardShortcut: {
        "id": "issue-navigator-action-share-button.share-keyboard-shortcut",
        "defaultMessage": "Open share modal"
    }
});

});


parcelRegister("lml1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $600f1e70c70bcfbe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aZ5rg = parcelRequire("aZ5rg");

var $4n4k5 = parcelRequire("4n4k5");

var $1A6di = parcelRequire("1A6di");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");

var $7Uevx = parcelRequire("7Uevx");

var $3bDjY = parcelRequire("3bDjY");

var $3Tty1 = parcelRequire("3Tty1");

var $6s1PB = parcelRequire("6s1PB");

var $aWse0 = parcelRequire("aWse0");

var $9Nvh7 = parcelRequire("9Nvh7");

var $5Czte = parcelRequire("5Czte");

var $761Hb = parcelRequire("761Hb");

var $qLuSt = parcelRequire("qLuSt");

var $2jDmD = parcelRequire("2jDmD");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $1aUn4 = parcelRequire("1aUn4");

var $dCm1o = parcelRequire("dCm1o");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $a8lIB = parcelRequire("a8lIB");

var $5NwJk = parcelRequire("5NwJk");

var $ih9zY = parcelRequire("ih9zY");

var $71kvA = parcelRequire("71kvA");
const $600f1e70c70bcfbe$var$KeyboardShortcuts = ({ view: view, onToggle: onToggle, intl: { formatMessage: formatMessage } })=>{
    const isDetailView = view === (0, $6UAdF.views).detail;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: {
            t: {
                callback: ()=>{
                    const newView = isDetailView ? (0, $6UAdF.views).list : (0, $6UAdF.views).detail;
                    onToggle(newView, true);
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage(isDetailView ? (0, $71kvA.default).listText : (0, $71kvA.default).detailText))
            }
        }
    });
};
const $600f1e70c70bcfbe$export$c774a1845e27fedc = ({ view: view, onToggle: onToggle, intl: intl })=>{
    const { formatMessage: formatMessage } = intl;
    const testIdPrefix = 'issue-navigator.ui.refinement-bar.view-switcher.toggle-button.';
    let listLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($600f1e70c70bcfbe$var$IconLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            size: "UNSAFE_small",
            weight: "semibold"
        }, formatMessage((0, $71kvA.default).listOptionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ5rg))), {
            label: "",
            LEGACY_size: "small"
        })), [
        formatMessage
    ]);
    let detailLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($600f1e70c70bcfbe$var$IconLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            size: "UNSAFE_small",
            weight: "semibold"
        }, formatMessage((0, $71kvA.default).detailOptionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4n4k5))), {
            label: "",
            LEGACY_size: "small"
        })), [
        formatMessage
    ]);
    if ((0, $3HwlS.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        listLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $71kvA.default).listOptionLabel)), [
            formatMessage
        ]); // eslint-disable-next-line react-hooks/rules-of-hooks
        detailLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $71kvA.default).detailOptionLabel)), [
            formatMessage
        ]);
    }
    if ((0, $dCm1o.isVisualRefreshEnabled)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        listLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $71kvA.default).listOptionLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Uevx))), {
                label: formatMessage((0, $71kvA.default).listOptionLabel)
            }))), [
            formatMessage
        ]); // eslint-disable-next-line react-hooks/rules-of-hooks
        detailLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $71kvA.default).detailOptionLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1A6di))), {
                label: formatMessage((0, $71kvA.default).detailOptionLabel)
            }))), [
            formatMessage
        ]);
    }
    const options = (0, $5uXOq.useMemo)(()=>[
            {
                id: (0, $6UAdF.views).list,
                label: listLabel,
                testId: `${testIdPrefix}${(0, $6UAdF.views).list}`
            },
            {
                id: (0, $6UAdF.views).detail,
                label: detailLabel,
                testId: `${testIdPrefix}${(0, $6UAdF.views).detail}`
            }
        ], [
        listLabel,
        detailLabel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($600f1e70c70bcfbe$var$KeyboardShortcuts, {
        view: view,
        onToggle: onToggle,
        intl: intl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aUn4.default), {
        label: formatMessage((0, $71kvA.default).toggleButtonsLabel),
        isCompact: (0, $dCm1o.isVisualRefreshEnabled)(),
        options: options,
        selectedOption: view,
        onChange: (newView)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onToggle(newView, false);
        }
    }));
};
$600f1e70c70bcfbe$export$c774a1845e27fedc.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $600f1e70c70bcfbe$export$3f624639bbe23442 = ({ filterId: filterId })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).PAGE_ACTIONS_VIEW_SWITCHER_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).PAGE_ACTIONS_VIEW_SWITCHER_END);
    }, []);
    const selectedIssueKey = (0, $5NwJk.useSelectedIssueKey)();
    const [{ view: view }, { setView: setView }] = (0, $ih9zY.useSelectedViewState)();
    const intl = (0, $aWse0.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnToggle = (0, $5uXOq.useCallback)((newView, isKeyboardShortcut)=>{
        // When toggling to detail view we want to update the issue key in the URL to match the currently selected
        // issue. When toggling to list view we want to discard the issue key from the URL.
        const newIssueKey = newView === (0, $6UAdF.views).detail ? selectedIssueKey : (0, $g5X3G.toIssueKey)('');
        let resolvedNewView = (0, $eJ0Zs.convertToIssueNavigatorId)(newView);
        if (newView === (0, $6UAdF.views).list && filterId && (0, $9Nvh7.isCustomFilter)(filterId)) resolvedNewView = (0, $eJ0Zs.convertFilterIdToIssueNavigatorId)(filterId);
        setView(resolvedNewView, newIssueKey);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'switchIssueNavigatorView', {
            keyboardShortcut: isKeyboardShortcut,
            switchToView: newView
        });
        return true;
    }, [
        selectedIssueKey,
        filterId,
        setView,
        createAnalyticsEvent
    ]);
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Czte.NinChangeboardingTourTarget), {
        engagementId: "nin.view-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($600f1e70c70bcfbe$export$c774a1845e27fedc, {
        view: (0, $eJ0Zs.convertToView)(view),
        onToggle: handleOnToggle,
        intl: intl
    }));
    const renderSpotlightCard = ({ onEndTour: onEndTour, onSetActiveCard: onSetActiveCard })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qLuSt.default), {
            cardKey: (0, $761Hb.cardKeys).GLOBAL_SCOPE_VIEW_SWITCHER,
            dialogWidth: 272,
            dialogPlacement: "bottom right",
            actions: view === 'detail' ? [
                {
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $71kvA.default).done)
                }
            ] : [
                {
                    onClick: ()=>{
                        onSetActiveCard((0, $761Hb.cardKeys).GLOBAL_SCOPE_COLUMN_PICKER);
                    },
                    text: intl.formatMessage((0, $71kvA.default).next)
                },
                {
                    appearance: 'subtle',
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $71kvA.default).skip)
                }
            ],
            heading: intl.formatMessage((0, $71kvA.default).tourHeading),
            target: "nin.spotlight.view-switcher",
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            targetRadius: 3,
            messageId: "issue-navigator.ui.view-switcher.spotlight-tour-card.nin.spotlight.view-switcher.spotlight",
            messageType: "transactional"
        }, intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $71kvA.default).tourBodyIssueTermRefresh : (0, $71kvA.default).tourBody));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jDmD.default), {
        name: "nin.spotlight.view-switcher",
        renderSpotlightCard: renderSpotlightCard
    }, children);
};
var $600f1e70c70bcfbe$export$2e2bcd8739ae039 // clean up this styled element with getWillShowNav4
 = $600f1e70c70bcfbe$export$3f624639bbe23442;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $600f1e70c70bcfbe$var$IconLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_zulp1b66" : "_10cu1b66 _2t30idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4n4k5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07e9a2b593bf5e9366acb4ee47ef2d98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32eca9e1c2feaa3e$var$_react = $32eca9e1c2feaa3e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32eca9e1c2feaa3e$var$_sidebarRight = $32eca9e1c2feaa3e$var$_interopRequireDefault((parcelRequire("aRO6g")));

var $32eca9e1c2feaa3e$var$_detailView = $32eca9e1c2feaa3e$var$_interopRequireDefault((parcelRequire("jmEdU")));
function $32eca9e1c2feaa3e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SidebarRightIcon.
 * This component is SidebarRightIcon, with `UNSAFE_fallbackIcon` set to "DetailViewIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a drawer or sidebar to the right of the viewport edge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32eca9e1c2feaa3e$var$SidebarRightIcon = (props)=>/*#__PURE__*/ $32eca9e1c2feaa3e$var$_react.default.createElement($32eca9e1c2feaa3e$var$_sidebarRight.default, Object.assign({
        LEGACY_fallbackIcon: $32eca9e1c2feaa3e$var$_detailView.default
    }, props));
$32eca9e1c2feaa3e$var$SidebarRightIcon.Name = 'SidebarRightIconMigration';
var $32eca9e1c2feaa3e$var$_default = module.exports.default = $32eca9e1c2feaa3e$var$SidebarRightIcon;

});
parcelRegister("aRO6g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0baa35972d89eacaa977962f4f53337e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e95b773b99220a6$var$_react = $7e95b773b99220a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7e95b773b99220a6$var$_baseNew = $7e95b773b99220a6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7e95b773b99220a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a drawer or sidebar to the right of the viewport edge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e95b773b99220a6$var$SidebarRightIcon = (props)=>/*#__PURE__*/ $7e95b773b99220a6$var$_react.default.createElement($7e95b773b99220a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h5v-9zm6.5 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm4.5 3h-3V5h3zm0 3h-3V8h3z" clip-rule="evenodd"/>`
    }, props));
$7e95b773b99220a6$var$SidebarRightIcon.displayName = 'SidebarRightIcon';
var $7e95b773b99220a6$var$_default = module.exports.default = $7e95b773b99220a6$var$SidebarRightIcon;

});

parcelRegister("jmEdU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e18f45ea4410736a$var$_react = $e18f45ea4410736a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e18f45ea4410736a$var$_sidebarRight = $e18f45ea4410736a$var$_interopRequireDefault((parcelRequire("aRO6g")));
function $e18f45ea4410736a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e18f45ea4410736a$var$DetailViewIcon = (props)=>/*#__PURE__*/ $e18f45ea4410736a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14 17h6V7.01C20 7 14 7 14 7zM12 5h8c1.11 0 2 .9 2 2.01V17a2 2 0 0 1-2 2h-8zM2 7h8V5H3a1 1 0 0 0-1 1zm0 4h8V9H2zm0 7c0 .55.45 1 1 1h7v-2H2zm0-3h8v-2H2z"/></svg>`
    }, props, {
        newIcon: $e18f45ea4410736a$var$_sidebarRight.default
    }));
$e18f45ea4410736a$var$DetailViewIcon.displayName = 'DetailViewIcon';
var $e18f45ea4410736a$var$_default = module.exports.default = $e18f45ea4410736a$var$DetailViewIcon;

});


parcelRegister("1A6di", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe9a089e1f04f18f538500f4f4d79587>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $126df91b70991685$var$_react = $126df91b70991685$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $126df91b70991685$var$_baseNew = $126df91b70991685$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $126df91b70991685$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $126df91b70991685$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $126df91b70991685$var$_react.default.createElement($126df91b70991685$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-7.75C6.115 1 5.5 1.616 5.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h7.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11H7v-11zM4 2.375C4 1.615 3.384 1 2.625 1h-1.25C.615 1 0 1.616 0 2.375v11.25C0 14.385.616 15 1.375 15h1.25C3.385 15 4 14.384 4 13.625zM2.5 2.5v11h-1v-11z" clip-rule="evenodd"/>`
    }, props));
$126df91b70991685$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var $126df91b70991685$var$_default = module.exports.default = $126df91b70991685$var$LayoutTwoColumnsSidebarLeftIcon;

});

parcelRegister("7Uevx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1fd96c5b3b13ee02dc5743b09d638d98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c1904502a6c690c$var$_react = $5c1904502a6c690c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5c1904502a6c690c$var$_baseNew = $5c1904502a6c690c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5c1904502a6c690c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spreadsheet".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c1904502a6c690c$var$SpreadsheetIcon = (props)=>/*#__PURE__*/ $5c1904502a6c690c$var$_react.default.createElement($5c1904502a6c690c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3.25H5V3.5zm4.5 0v3.75h8V4a.5.5 0 0 0-.5-.5zm8 5.25h-8v3.75H14a.5.5 0 0 0 .5-.5zM5 12.5V8.75H1.5V12a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$5c1904502a6c690c$var$SpreadsheetIcon.displayName = 'SpreadsheetIcon';
var $5c1904502a6c690c$var$_default = module.exports.default = $5c1904502a6c690c$var$SpreadsheetIcon;

});

parcelRegister("761Hb", function(module, exports) {

$parcel$export(module.exports, "cardKeys", () => $d137429970660ed4$export$79399c5778983d77);
/**
 * Collection of keys representing individual spotlight cards displayed within the issue navigator.
 */ const $d137429970660ed4$export$79399c5778983d77 = {
    GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL: 'global-scope.jql-builder-with-ai.natural-language-to-jql',
    GLOBAL_SCOPE_VIEW_SWITCHER: 'global-scope.view-switcher',
    GLOBAL_SCOPE_COLUMN_PICKER: 'global-scope.column-picker',
    JQL_BUILDER_NL_TOGGLE: 'jql-builder-with-ai.natural-language-toggle',
    JQL_BUILDER_NL_TO_JQL: 'jql-builder-with-ai.natural-language-to-jql'
};

});

parcelRegister("qLuSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea5d5d108c2f1c20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ea5d5d108c2f1c20$var$SpotlightTourCardAsync = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jwxJk")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/ui/spotlight-tour-card/main.tsx"
});
const $ea5d5d108c2f1c20$var$SpotlightTourCard = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-issue-navigator-changeboarding-spotlight-tour-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-issue-navigator-changeboarding-spotlight-tour-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea5d5d108c2f1c20$var$SpotlightTourCardAsync, props)));
var $ea5d5d108c2f1c20$export$2e2bcd8739ae039 = $ea5d5d108c2f1c20$var$SpotlightTourCard;

});
parcelRegister("jwxJk", function(module, exports) {

let $e36b2b92bcfd0949$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e36b2b92bcfd0949$var$load("khibr").then(()=>parcelRequire('4CMeD'));

});


parcelRegister("2jDmD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e9c17dad5a296c3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $8QPci = parcelRequire("8QPci");
/**
 *
 * Renders a spotlight target and associated spotlight card.
 */ const $2e9c17dad5a296c3$var$SpotlightTourTarget = ({ children: children, name: name, renderSpotlightCard: renderSpotlightCard })=>{
    const { onEndTour: onEndTour, onSetActiveCard: onSetActiveCard } = (0, $8QPci.useSpotlightCoordinationActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: name
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, typeof renderSpotlightCard === 'function' ? renderSpotlightCard({
        onEndTour: onEndTour,
        onSetActiveCard: onSetActiveCard
    }) : renderSpotlightCard));
};
var $2e9c17dad5a296c3$export$2e2bcd8739ae039 = $2e9c17dad5a296c3$var$SpotlightTourTarget;

});
parcelRegister("8QPci", function(module, exports) {

$parcel$export(module.exports, "useIsActiveSpotlightCard", () => $1bf3a4be42170bcd$export$ac706a6842f43035);
$parcel$export(module.exports, "useSpotlightCoordinationActions", () => $1bf3a4be42170bcd$export$d0297e733168e478);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

const $1bf3a4be42170bcd$var$initialState = {
    cardKey: null,
    onStopCoordination: null
};
const $1bf3a4be42170bcd$var$actions = {
    onSetActiveCard: (cardKey, stop)=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            setState({
                cardKey: cardKey,
                onStopCoordination: stop ?? onStopCoordination
            });
        },
    onEndTour: ()=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            onStopCoordination && onStopCoordination();
            setState({
                cardKey: null,
                onStopCoordination: null
            });
        }
};
const $1bf3a4be42170bcd$var$Store = (0, $iXqE5.createStore)({
    initialState: $1bf3a4be42170bcd$var$initialState,
    actions: $1bf3a4be42170bcd$var$actions
});
const $1bf3a4be42170bcd$export$ac706a6842f43035 = (0, $3sQ5x.createHook)($1bf3a4be42170bcd$var$Store, {
    selector: (state, cardKeys)=>Array.isArray(cardKeys) ? state.cardKey !== null && cardKeys.includes(state.cardKey) : state.cardKey === cardKeys
});
const $1bf3a4be42170bcd$export$d0297e733168e478 = (0, $3sQ5x.createActionsHook)($1bf3a4be42170bcd$var$Store);

});


parcelRegister("71kvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $270ebddc9dcee8b9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $270ebddc9dcee8b9$var$messages = (0, $7VHMR.defineMessages)({
    done: {
        "id": "issue-navigator.view-switcher.done",
        "defaultMessage": "Done"
    },
    next: {
        "id": "issue-navigator.view-switcher.next",
        "defaultMessage": "Next"
    },
    skip: {
        "id": "issue-navigator.view-switcher.skip",
        "defaultMessage": "Skip"
    },
    tourHeading: {
        "id": "issue-navigator.view-switcher.tour-heading",
        "defaultMessage": "View switcher"
    },
    tourBody: {
        "id": "issue-navigator.view-switcher.tour-body",
        "defaultMessage": "Switch between these two views to easily scan through a list or view the details of the issues."
    },
    detailText: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-text",
        "defaultMessage": "Switch to detail view"
    },
    listText: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-text",
        "defaultMessage": "Switch to list view"
    },
    toggleButtonsLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.toggle-buttons-label",
        "defaultMessage": "Select view"
    },
    detailOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-option-label",
        "defaultMessage": "Detail view"
    },
    listOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-option-label",
        "defaultMessage": "List view"
    },
    tourBodyIssueTermRefresh: {
        "id": "issue-navigator.view-switcher.tour-body-issue-term-refresh",
        "defaultMessage": "Switch between these two views to easily scan through a list or view the details of the work item."
    }
});
var $270ebddc9dcee8b9$export$2e2bcd8739ae039 = $270ebddc9dcee8b9$var$messages;

});





parcelRegister("ay8sY", function(module, exports) {

$parcel$export(module.exports, "getJqlFromParamValues", () => $fac2feff71c61553$export$52de656da34011c3);
$parcel$export(module.exports, "getSearchInput", () => $fac2feff71c61553$export$2fa22ca814667ff4);
$parcel$export(module.exports, "useUpdateUrlQueryParamCallback", () => $fac2feff71c61553$export$f6b4f46bd8314b51);

var $5uXOq = parcelRequire("5uXOq");

var $9Nvh7 = parcelRequire("9Nvh7");

var $ieDtd = parcelRequire("ieDtd");

var $6UAdF = parcelRequire("6UAdF");
const $fac2feff71c61553$export$52de656da34011c3 = (defaultJql, jqlParam, filter, /**
	 * when `filter` has a value that is not a standard numeric filter ID, consumers can provide a
	 * customMapper function to transform the filter value to a jql string. For example this is used
	 * by Project Issue Navigator to map filter query params such as '?filter=myopenissues into jql
	 * strings without calling the backend API
	 */ customMapper, /**
	 * callback in the event of jql being returned is different to the jqlParam value, such as when
	 * it is undefined and the default jql is being returned. This allows the caller to sync the new
	 * jql value with the `?jql=...` url query param
	 */ onMutateJqlParam)=>{
    let jql = jqlParam;
    if (typeof jql === 'string') return jql;
    if ((0, $9Nvh7.isFilterId)(filter)) return undefined;
    if (typeof filter === 'string' && customMapper) jql = customMapper(filter);
    if (jql === undefined) jql = defaultJql;
    if (jql !== jqlParam) onMutateJqlParam?.(jql);
    return jql;
};
const $fac2feff71c61553$var$getFilter = (filterInput)=>(0, $9Nvh7.isFilterId)(filterInput) ? {
        value: filterInput,
        type: (0, $6UAdF.FilterTypes).ID
    } : {
        value: filterInput,
        type: (0, $6UAdF.FilterTypes).JQL
    };
const $fac2feff71c61553$export$2fa22ca814667ff4 = (jqlInput, filterInput)=>{
    const filter = filterInput !== undefined ? $fac2feff71c61553$var$getFilter(filterInput) : undefined;
    if (jqlInput === undefined) {
        if (filter === undefined) throw new Error('filter is missing for search input');
        return filter;
    }
    if (filter === undefined) return {
        jql: jqlInput,
        type: (0, $6UAdF.SearchInputTypes).JQL
    };
    return {
        jql: jqlInput,
        filter: filter,
        type: (0, $6UAdF.SearchInputTypes).FILTER_AND_JQL
    };
};
const $fac2feff71c61553$export$f6b4f46bd8314b51 = (queryParamKey)=>{
    const [_, setQueryParam] = (0, $ieDtd.useQueryParam)(queryParamKey);
    const setJqlQueryParamCallback = (0, $5uXOq.useCallback)((value)=>setQueryParam(value, 'replace'), [
        setQueryParam
    ]);
    return setJqlQueryParamCallback;
};

});

parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});




const $135ded4f9a1460dc$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $135ded4f9a1460dc$export$2aca0ebce9a48d61 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.visible-fields';
const $135ded4f9a1460dc$export$fc60a8d420264e7d = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.hidden-fields';
const $135ded4f9a1460dc$export$e1184c3be46bd7cb = false;
const $135ded4f9a1460dc$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $135ded4f9a1460dc$export$988f0f6f6457039a = 'status-and-approval-spotlight';

const $c5ab1cac32219280$export$87b07f66f76af007 = 1000;
const $c5ab1cac32219280$export$7cf28317477c9e48 = 'w';

const $13918fc81534c491$export$cb17e3c17bc50301 = 'Epic';
const $13918fc81534c491$export$d29cf9c8492f955d = 'Base';
const $13918fc81534c491$export$7fbc739f2667a35e = 'Subtask';

const $05ea8866f66e1e3c$export$37b67b9fa9f77199 = 'APPLINK_MISSING';
const $05ea8866f66e1e3c$export$d1fe0e8f550fe68d = 'APPLINK_REQ_AUTH';
const $05ea8866f66e1e3c$export$a6054426471fb4c4 = 'REMOTE_SERVER';
const $05ea8866f66e1e3c$export$cdf8a4853fe35e61 = 'REMOTE_LINK_MISSING';


//# sourceMappingURL=async-global-issue-navigator.96783e76.js.map
